import './index-B_eBR6Bb.css';var wc = Object.defineProperty;
var Rc = (B, V, ie) => V in B ? wc(B, V, { enumerable: !0, configurable: !0, writable: !0, value: ie }) : B[V] = ie;
var _n = (B, V, ie) => Rc(B, typeof V != "symbol" ? V + "" : V, ie);
import { jsx as he, jsxs as rn, Fragment as Gr } from "react/jsx-runtime";
import { useRef as gr, useCallback as Un, useSyncExternalStore as ol, createContext as Ea, useContext as va, useState as ar, useEffect as Zr, useMemo as dr, memo as Cc, useLayoutEffect as Nc, useId as Dc, forwardRef as Oc, createRef as Mc } from "react";
import { initReactI18next as Lc, useTranslation as On } from "react-i18next";
import Pc from "i18next";
import xc from "i18next-resources-to-backend";
import { S as Dr, U as Fc, W as kc, X as Zc, Z as Kn, _ as Ta, $ as Bc, a0 as Uc, a1 as Gc, a2 as Hc, a3 as qc, a4 as Vc, y as jc, a5 as ma, a6 as Yc, a7 as Kc, a8 as pa, a9 as zc, aa as sl, ab as Wc, ac as ll, ad as ul, ae as Qc, af as Xc, ag as $c, ah as Ks, ai as zs, aj as Jc, ak as fo, al as ef, am as tf } from "./vidstack-CW95SyGp.js";
import { an as pp } from "./vidstack-CW95SyGp.js";
import { useFloating as Oi, autoUpdate as Mi, shift as ba, offset as Sa, arrow as Aa, useMergeRefs as Eo, useListNavigation as vo, useClick as cl, useDismiss as Ia, useInteractions as wa, FloatingFocusManager as Ra, FloatingArrow as Ca, detectOverflow as nf } from "@floating-ui/react";
const bi = [0.5, 0.75, 1, 1.25, 1.5, 2], rf = [0.5, 1, 2, 3, 4], af = 5, To = "-ytb";
let of = Symbol("clean"), xr = [], zr = 0;
const ua = 4;
let yr = (B) => {
  let V = [], ie = {
    get() {
      return ie.lc || ie.listen(() => {
      })(), ie.value;
    },
    lc: 0,
    listen(ye) {
      return ie.lc = V.push(ye), () => {
        for (let st = zr + ua; st < xr.length; )
          xr[st] === ye ? xr.splice(st, ua) : st += ua;
        let Ce = V.indexOf(ye);
        ~Ce && (V.splice(Ce, 1), --ie.lc || ie.off());
      };
    },
    notify(ye, Ce) {
      let st = !xr.length;
      for (let Se of V)
        xr.push(Se, ie.value, ye, Ce);
      if (st) {
        for (zr = 0; zr < xr.length; zr += ua)
          xr[zr](
            xr[zr + 1],
            xr[zr + 2],
            xr[zr + 3]
          );
        xr.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(ye) {
      let Ce = ie.value;
      Ce !== ye && (ie.value = ye, ie.notify(Ce));
    },
    subscribe(ye) {
      let Ce = ie.listen(ye);
      return ye(ie.value), Ce;
    },
    value: B
  };
  return process.env.NODE_ENV !== "production" && (ie[of] = () => {
    V = [], ie.lc = 0, ie.off();
  }), ie;
};
function sf(B, V, ie) {
  let ye = new Set(V).add(void 0);
  return B.listen((Ce, st, Se) => {
    ye.has(Se) && ie(Ce, st, Se);
  });
}
let go = (B, V) => (ie) => {
  B.current !== ie && (B.current = ie, V());
};
function ya(B, { keys: V, deps: ie = [B, V] } = {}) {
  let ye = gr();
  ye.current = B.get();
  let Ce = Un((Se) => (go(ye, Se)(B.value), (V == null ? void 0 : V.length) > 0 ? sf(B, V, go(ye, Se)) : B.listen(go(ye, Se))), ie), st = () => ye.current;
  return ol(Ce, st, st);
}
var ho = { exports: {} };
/*! For license information please see dash.all.min.js.LICENSE.txt */
var Ws;
function lf() {
  return Ws || (Ws = 1, function(B, V) {
    (function(ie, ye) {
      B.exports = ye();
    })(self, function() {
      return function() {
        var ie = { 4593: function(Se, ge) {
          var R, te, E, t, e, m = function(v) {
            for (var h = [], n = 0; n < v.length; ++n) {
              var f = v.charCodeAt(n);
              f < 128 ? h.push(f) : f < 2048 ? (h.push(192 | f >> 6), h.push(128 | 63 & f)) : f < 65536 ? (h.push(224 | f >> 12), h.push(128 | 63 & f >> 6), h.push(128 | 63 & f)) : (h.push(240 | f >> 18), h.push(128 | 63 & f >> 12), h.push(128 | 63 & f >> 6), h.push(128 | 63 & f));
            }
            return h;
          }, p = function(v) {
            for (var h = [], n = 0; n < v.length; ) {
              var f = v[n++];
              f < 128 || (f < 224 ? (f = (31 & f) << 6, f |= 63 & v[n++]) : f < 240 ? (f = (15 & f) << 12, f |= (63 & v[n++]) << 6, f |= 63 & v[n++]) : (f = (7 & f) << 18, f |= (63 & v[n++]) << 12, f |= (63 & v[n++]) << 6, f |= 63 & v[n++])), h.push(String.fromCharCode(f));
            }
            return h.join("");
          }, l = {};
          R = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", te = function(v) {
            for (var h = 0, n = [], f = 0 | v.length / 3; 0 < f--; ) {
              var d = (v[h] << 16) + (v[h + 1] << 8) + v[h + 2];
              h += 3, n.push(R.charAt(63 & d >> 18)), n.push(R.charAt(63 & d >> 12)), n.push(R.charAt(63 & d >> 6)), n.push(R.charAt(63 & d));
            }
            return v.length - h == 2 ? (d = (v[h] << 16) + (v[h + 1] << 8), n.push(R.charAt(63 & d >> 18)), n.push(R.charAt(63 & d >> 12)), n.push(R.charAt(63 & d >> 6)), n.push("=")) : v.length - h == 1 && (d = v[h] << 16, n.push(R.charAt(63 & d >> 18)), n.push(R.charAt(63 & d >> 12)), n.push("==")), n.join("");
          }, E = function() {
            for (var v = [], h = 0; h < R.length; ++h) v[R.charCodeAt(h)] = h;
            return v[61] = 0, v;
          }(), t = function(v) {
            for (var h = 0, n = [], f = 0 | v.length / 4; 0 < f--; ) {
              var d = (E[v.charCodeAt(h)] << 18) + (E[v.charCodeAt(h + 1)] << 12) + (E[v.charCodeAt(h + 2)] << 6) + E[v.charCodeAt(h + 3)];
              n.push(255 & d >> 16), n.push(255 & d >> 8), n.push(255 & d), h += 4;
            }
            return n && (v.charAt(h - 2) == "=" ? (n.pop(), n.pop()) : v.charAt(h - 1) == "=" && n.pop()), n;
          }, e = { encode: function(v) {
            for (var h = [], n = 0; n < v.length; ++n) h.push(v.charCodeAt(n));
            return h;
          }, decode: function(v) {
            for (var h = 0; h < s.length; ++h) a[h] = String.fromCharCode(a[h]);
            return a.join("");
          } }, l.decodeArray = function(v) {
            var h = t(v);
            return new Uint8Array(h);
          }, l.encodeASCII = function(v) {
            var h = e.encode(v);
            return te(h);
          }, l.decodeASCII = function(v) {
            var h = t(v);
            return e.decode(h);
          }, l.encode = function(v) {
            var h = m(v);
            return te(h);
          }, l.decode = function(v) {
            var h = t(v);
            return p(h);
          }, ge.decode = l.decode, ge.decodeArray = l.decodeArray, ge.encode = l.encode, ge.encodeASCII = l.encodeASCII;
        }, 452: function(Se, ge) {
          (function(R) {
            var te = { 42: 225, 92: 233, 94: 237, 95: 243, 96: 250, 123: 231, 124: 247, 125: 209, 126: 241, 127: 9608, 128: 174, 129: 176, 130: 189, 131: 191, 132: 8482, 133: 162, 134: 163, 135: 9834, 136: 224, 137: 32, 138: 232, 139: 226, 140: 234, 141: 238, 142: 244, 143: 251, 144: 193, 145: 201, 146: 211, 147: 218, 148: 220, 149: 252, 150: 8216, 151: 161, 152: 42, 153: 8217, 154: 9473, 155: 169, 156: 8480, 157: 8226, 158: 8220, 159: 8221, 160: 192, 161: 194, 162: 199, 163: 200, 164: 202, 165: 203, 166: 235, 167: 206, 168: 207, 169: 239, 170: 212, 171: 217, 172: 249, 173: 219, 174: 171, 175: 187, 176: 195, 177: 227, 178: 205, 179: 204, 180: 236, 181: 210, 182: 242, 183: 213, 184: 245, 185: 123, 186: 125, 187: 92, 188: 94, 189: 95, 190: 124, 191: 8764, 192: 196, 193: 228, 194: 214, 195: 246, 196: 223, 197: 165, 198: 164, 199: 9475, 200: 197, 201: 229, 202: 216, 203: 248, 204: 9487, 205: 9491, 206: 9495, 207: 9499 }, E = function(M) {
              var W = M;
              return te.hasOwnProperty(M) && (W = te[M]), String.fromCharCode(W);
            }, t = 15, e = 32, m = { 17: 1, 18: 3, 21: 5, 22: 7, 23: 9, 16: 11, 19: 12, 20: 14 }, p = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 }, l = { 25: 1, 26: 3, 29: 5, 30: 7, 31: 9, 24: 11, 27: 12, 28: 14 }, v = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 }, h = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], n = { verboseFilter: { DATA: 3, DEBUG: 3, INFO: 2, WARNING: 2, TEXT: 1, ERROR: 0 }, time: null, verboseLevel: 0, setTime: function(M) {
              this.time = M;
            }, log: function(M, W) {
              var se = this.verboseFilter[M];
              this.verboseLevel >= se && console.log(this.time + " [" + M + "] " + W);
            } }, f = function(M) {
              for (var W = [], se = 0; se < M.length; se++) W.push(M[se].toString(16));
              return W;
            }, d = function(M, W, se, j, re) {
              this.foreground = M || "white", this.underline = W || !1, this.italics = se || !1, this.background = j || "black", this.flash = re || !1;
            };
            d.prototype = { reset: function() {
              this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
            }, setStyles: function(M) {
              for (var W = ["foreground", "underline", "italics", "background", "flash"], se = 0; se < W.length; se++) {
                var j = W[se];
                M.hasOwnProperty(j) && (this[j] = M[j]);
              }
            }, isDefault: function() {
              return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
            }, equals: function(M) {
              return this.foreground === M.foreground && this.underline === M.underline && this.italics === M.italics && this.background === M.background && this.flash === M.flash;
            }, copy: function(M) {
              this.foreground = M.foreground, this.underline = M.underline, this.italics = M.italics, this.background = M.background, this.flash = M.flash;
            }, toString: function() {
              return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
            } };
            var S = function(M, W, se, j, re, ce) {
              this.uchar = M || " ", this.penState = new d(W, se, j, re, ce);
            };
            S.prototype = { reset: function() {
              this.uchar = " ", this.penState.reset();
            }, setChar: function(M, W) {
              this.uchar = M, this.penState.copy(W);
            }, setPenState: function(M) {
              this.penState.copy(M);
            }, equals: function(M) {
              return this.uchar === M.uchar && this.penState.equals(M.penState);
            }, copy: function(M) {
              this.uchar = M.uchar, this.penState.copy(M.penState);
            }, isEmpty: function() {
              return this.uchar === " " && this.penState.isDefault();
            } };
            var x = function() {
              this.chars = [];
              for (var M = 0; M < e; M++) this.chars.push(new S());
              this.pos = 0, this.currPenState = new d();
            };
            x.prototype = { equals: function(M) {
              for (var W = !0, se = 0; se < e; se++) if (!this.chars[se].equals(M.chars[se])) {
                W = !1;
                break;
              }
              return W;
            }, copy: function(M) {
              for (var W = 0; W < e; W++) this.chars[W].copy(M.chars[W]);
            }, isEmpty: function() {
              for (var M = !0, W = 0; W < e; W++) if (!this.chars[W].isEmpty()) {
                M = !1;
                break;
              }
              return M;
            }, setCursor: function(M) {
              this.pos !== M && (this.pos = M), this.pos < 0 ? (n.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > e && (n.log("ERROR", "Too large cursor position " + this.pos), this.pos = e);
            }, moveCursor: function(M) {
              var W = this.pos + M;
              if (M > 1) for (var se = this.pos + 1; se < W + 1; se++) this.chars[se].setPenState(this.currPenState);
              this.setCursor(W);
            }, backSpace: function() {
              this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
            }, insertChar: function(M) {
              M >= 144 && this.backSpace();
              var W = E(M);
              this.pos >= e ? n.log("ERROR", "Cannot insert " + M.toString(16) + " (" + W + ") at position " + this.pos + ". Skipping it!") : (this.chars[this.pos].setChar(W, this.currPenState), this.moveCursor(1));
            }, clearFromPos: function(M) {
              var W;
              for (W = M; W < e; W++) this.chars[W].reset();
            }, clear: function() {
              this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
            }, clearToEndOfRow: function() {
              this.clearFromPos(this.pos);
            }, getTextString: function() {
              for (var M = [], W = !0, se = 0; se < e; se++) {
                var j = this.chars[se].uchar;
                j !== " " && (W = !1), M.push(j);
              }
              return W ? "" : M.join("");
            }, setPenStyles: function(M) {
              this.currPenState.setStyles(M), this.chars[this.pos].setPenState(this.currPenState);
            } };
            var G = function() {
              this.rows = [];
              for (var M = 0; M < t; M++) this.rows.push(new x());
              this.currRow = 14, this.nrRollUpRows = null, this.reset();
            };
            G.prototype = { reset: function() {
              for (var M = 0; M < t; M++) this.rows[M].clear();
              this.currRow = 14;
            }, equals: function(M) {
              for (var W = !0, se = 0; se < t; se++) if (!this.rows[se].equals(M.rows[se])) {
                W = !1;
                break;
              }
              return W;
            }, copy: function(M) {
              for (var W = 0; W < t; W++) this.rows[W].copy(M.rows[W]);
            }, isEmpty: function() {
              for (var M = !0, W = 0; W < t; W++) if (!this.rows[W].isEmpty()) {
                M = !1;
                break;
              }
              return M;
            }, backSpace: function() {
              this.rows[this.currRow].backSpace();
            }, clearToEndOfRow: function() {
              this.rows[this.currRow].clearToEndOfRow();
            }, insertChar: function(M) {
              this.rows[this.currRow].insertChar(M);
            }, setPen: function(M) {
              this.rows[this.currRow].setPenStyles(M);
            }, moveCursor: function(M) {
              this.rows[this.currRow].moveCursor(M);
            }, setCursor: function(M) {
              n.log("INFO", "setCursor: " + M), this.rows[this.currRow].setCursor(M);
            }, setPAC: function(M) {
              n.log("INFO", "pacData = " + JSON.stringify(M));
              var W = M.row - 1;
              this.nrRollUpRows && W < this.nrRollUpRows - 1 && (W = this.nrRollUpRows - 1), this.currRow = W;
              var se = this.rows[this.currRow];
              if (M.indent !== null) {
                var j = M.indent, re = Math.max(j - 1, 0);
                se.setCursor(M.indent), M.color = se.chars[re].penState.foreground;
              }
              var ce = { foreground: M.color, underline: M.underline, italics: M.italics, background: "black", flash: !1 };
              this.setPen(ce);
            }, setBkgData: function(M) {
              n.log("INFO", "bkgData = " + JSON.stringify(M)), this.backSpace(), this.setPen(M), this.insertChar(32);
            }, setRollUpRows: function(M) {
              this.nrRollUpRows = M;
            }, rollUp: function() {
              if (this.nrRollUpRows !== null) {
                n.log("TEXT", this.getDisplayText());
                var M = this.currRow + 1 - this.nrRollUpRows, W = this.rows.splice(M, 1)[0];
                W.clear(), this.rows.splice(this.currRow, 0, W), n.log("INFO", "Rolling up");
              } else n.log("DEBUG", "roll_up but nrRollUpRows not set yet");
            }, getDisplayText: function(M) {
              M = M || !1;
              for (var W = [], se = "", j = -1, re = 0; re < t; re++) {
                var ce = this.rows[re].getTextString();
                ce && (j = re + 1, M ? W.push("Row " + j + ': "' + ce + '"') : W.push(ce.trim()));
              }
              return W.length > 0 && (se = M ? "[" + W.join(" | ") + "]" : W.join(`
`)), se;
            }, getTextAndFormat: function() {
              return this.rows;
            } };
            var P = function(M, W) {
              this.chNr = M, this.outputFilter = W, this.mode = null, this.verbose = 0, this.displayedMemory = new G(), this.nonDisplayedMemory = new G(), this.lastOutputScreen = new G(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
            };
            P.prototype = { modes: ["MODE_ROLL-UP", "MODE_POP-ON", "MODE_PAINT-ON", "MODE_TEXT"], reset: function() {
              this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
            }, getHandler: function() {
              return this.outputFilter;
            }, setHandler: function(M) {
              this.outputFilter = M;
            }, setPAC: function(M) {
              this.writeScreen.setPAC(M);
            }, setBkgData: function(M) {
              this.writeScreen.setBkgData(M);
            }, setMode: function(M) {
              M !== this.mode && (this.mode = M, n.log("INFO", "MODE=" + M), this.mode == "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = M);
            }, insertChars: function(M) {
              for (var W = 0; W < M.length; W++) this.writeScreen.insertChar(M[W]);
              var se = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
              n.log("INFO", se + ": " + this.writeScreen.getDisplayText(!0)), this.mode !== "MODE_PAINT-ON" && this.mode !== "MODE_ROLL-UP" || (n.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
            }, cc_RCL: function() {
              n.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
            }, cc_BS: function() {
              n.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
            }, cc_AOF: function() {
            }, cc_AON: function() {
            }, cc_DER: function() {
              n.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
            }, cc_RU: function(M) {
              n.log("INFO", "RU(" + M + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(M);
            }, cc_FON: function() {
              n.log("INFO", "FON - Flash On"), this.writeScreen.setPen({ flash: !0 });
            }, cc_RDC: function() {
              n.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
            }, cc_TR: function() {
              n.log("INFO", "TR"), this.setMode("MODE_TEXT");
            }, cc_RTD: function() {
              n.log("INFO", "RTD"), this.setMode("MODE_TEXT");
            }, cc_EDM: function() {
              n.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate();
            }, cc_CR: function() {
              n.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate();
            }, cc_ENM: function() {
              n.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
            }, cc_EOC: function() {
              if (n.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                var M = this.displayedMemory;
                this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = M, this.writeScreen = this.nonDisplayedMemory, n.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
              }
              this.outputDataUpdate();
            }, cc_TO: function(M) {
              n.log("INFO", "TO(" + M + ") - Tab Offset"), this.writeScreen.moveCursor(M);
            }, cc_MIDROW: function(M) {
              var W = { flash: !1 };
              if (W.underline = M % 2 == 1, W.italics = M >= 46, W.italics) W.foreground = "white";
              else {
                var se = Math.floor(M / 2) - 16;
                W.foreground = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"][se];
              }
              n.log("INFO", "MIDROW: " + JSON.stringify(W)), this.writeScreen.setPen(W);
            }, outputDataUpdate: function() {
              var M = n.time;
              M !== null && this.outputFilter && (this.outputFilter.updateData && this.outputFilter.updateData(M, this.displayedMemory), this.cueStartTime !== null || this.displayedMemory.isEmpty() ? this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, M, this.lastOutputScreen), this.cueStartTime = this.displayedMemory.isEmpty() ? null : M) : this.cueStartTime = M, this.lastOutputScreen.copy(this.displayedMemory));
            }, cueSplitAtTime: function(M) {
              this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, M, this.displayedMemory), this.cueStartTime = M));
            } };
            var J = function(M, W, se) {
              this.field = M || 1, this.outputs = [W, se], this.channels = [new P(1, W), new P(2, se)], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = { padding: 0, char: 0, cmd: 0, other: 0 };
            };
            J.prototype = { getHandler: function(M) {
              return this.channels[M].getHandler();
            }, setHandler: function(M, W) {
              this.channels[M].setHandler(W);
            }, addData: function(M, W) {
              var se, j, re, ce = !1;
              this.lastTime = M, n.setTime(M);
              for (var Re = 0; Re < W.length; Re += 2) j = 127 & W[Re], re = 127 & W[Re + 1], j >= 16 && j <= 31 && j === this.lastCmdA && re === this.lastCmdB ? (this.lastCmdA = null, this.lastCmdB = null, n.log("DEBUG", "Repeated command (" + f([j, re]) + ") is dropped")) : j !== 0 || re !== 0 ? (n.log("DATA", "[" + f([W[Re], W[Re + 1]]) + "] -> (" + f([j, re]) + ")"), (se = this.parseCmd(j, re)) || (se = this.parseMidrow(j, re)), se || (se = this.parsePAC(j, re)), se || (se = this.parseBackgroundAttributes(j, re)), se || (ce = this.parseChars(j, re)) && (this.currChNr && this.currChNr >= 0 ? this.channels[this.currChNr - 1].insertChars(ce) : n.log("WARNING", "No channel found yet. TEXT-MODE?")), se ? this.dataCounters.cmd += 2 : ce ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, n.log("WARNING", "Couldn't parse cleaned data " + f([j, re]) + " orig: " + f([W[Re], W[Re + 1]])))) : this.dataCounters.padding += 2;
            }, parseCmd: function(M, W) {
              var se;
              if (!((M === 20 || M === 21 || M === 28 || M === 29) && 32 <= W && W <= 47 || (M === 23 || M === 31) && 33 <= W && W <= 35)) return !1;
              se = M === 20 || M === 21 || M === 23 ? 1 : 2;
              var j = this.channels[se - 1];
              return M === 20 || M === 21 || M === 28 || M === 29 ? W === 32 ? j.cc_RCL() : W === 33 ? j.cc_BS() : W === 34 ? j.cc_AOF() : W === 35 ? j.cc_AON() : W === 36 ? j.cc_DER() : W === 37 ? j.cc_RU(2) : W === 38 ? j.cc_RU(3) : W === 39 ? j.cc_RU(4) : W === 40 ? j.cc_FON() : W === 41 ? j.cc_RDC() : W === 42 ? j.cc_TR() : W === 43 ? j.cc_RTD() : W === 44 ? j.cc_EDM() : W === 45 ? j.cc_CR() : W === 46 ? j.cc_ENM() : W === 47 && j.cc_EOC() : j.cc_TO(W - 32), this.lastCmdA = M, this.lastCmdB = W, this.currChNr = se, !0;
            }, parseMidrow: function(M, W) {
              var se = null;
              if ((M === 17 || M === 25) && 32 <= W && W <= 47) {
                if ((se = M === 17 ? 1 : 2) !== this.currChNr) return n.log("ERROR", "Mismatch channel in midrow parsing"), !1;
                var j = this.channels[se - 1];
                return j.insertChars([32]), j.cc_MIDROW(W), n.log("DEBUG", "MIDROW (" + f([M, W]) + ")"), this.lastCmdA = M, this.lastCmdB = W, !0;
              }
              return !1;
            }, parsePAC: function(M, W) {
              var se, j;
              if (!((17 <= M && M <= 23 || 25 <= M && M <= 31) && 64 <= W && W <= 127 || (M === 16 || M === 24) && 64 <= W && W <= 95)) return !1;
              se = M <= 23 ? 1 : 2, j = 64 <= W && W <= 95 ? se === 1 ? m[M] : l[M] : se === 1 ? p[M] : v[M];
              var re = this.interpretPAC(j, W);
              return this.channels[se - 1].setPAC(re), this.lastCmdA = M, this.lastCmdB = W, this.currChNr = se, !0;
            }, interpretPAC: function(M, W) {
              var se, j = { color: null, italics: !1, indent: null, underline: !1, row: M };
              return se = W > 95 ? W - 96 : W - 64, j.underline = (1 & se) == 1, se <= 13 ? j.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(se / 2)] : se <= 15 ? (j.italics = !0, j.color = "white") : j.indent = 4 * Math.floor((se - 16) / 2), j;
            }, parseChars: function(M, W) {
              var se = null, j = null, re = null;
              if (M >= 25 ? (se = 2, re = M - 8) : (se = 1, re = M), 17 <= re && re <= 19) {
                var ce;
                ce = re === 17 ? W + 80 : re === 18 ? W + 112 : W + 144, n.log("INFO", "Special char '" + E(ce) + "' in channel " + se), j = [ce], this.lastCmdA = M, this.lastCmdB = W;
              } else 32 <= M && M <= 127 && (j = W === 0 ? [M] : [M, W], this.lastCmdA = null, this.lastCmdB = null);
              if (j) {
                var Re = f(j);
                n.log("DEBUG", "Char codes =  " + Re.join(","));
              }
              return j;
            }, parseBackgroundAttributes: function(M, W) {
              var se, j, re;
              return ((M === 16 || M === 24) && 32 <= W && W <= 47 || (M === 23 || M === 31) && 45 <= W && W <= 47) && (se = {}, M === 16 || M === 24 ? (j = Math.floor((W - 32) / 2), se.background = h[j], W % 2 == 1 && (se.background = se.background + "_semi")) : W === 45 ? se.background = "transparent" : (se.foreground = "black", W === 47 && (se.underline = !0)), re = M < 24 ? 1 : 2, this.channels[re - 1].setBkgData(se), this.lastCmdA = M, this.lastCmdB = W, !0);
            }, reset: function() {
              for (var M = 0; M < this.channels.length; M++) this.channels[M] && this.channels[M].reset();
              this.lastCmdA = null, this.lastCmdB = null;
            }, cueSplitAtTime: function(M) {
              for (var W = 0; W < this.channels.length; W++) this.channels[W] && this.channels[W].cueSplitAtTime(M);
            } }, R.logger = n, R.PenState = d, R.CaptionScreen = G, R.Cea608Parser = J, R.findCea608Nalus = function(M, W, se) {
              for (var j = 0, re = W, ce = [], Re = function(Ae, Ze, Xe, at) {
                if (Ae !== 4 || Ze < 8) return null;
                var Ie = Xe.getUint8(at), Be = Xe.getUint16(at + 1), It = Xe.getUint32(at + 3), _t = Xe.getUint8(at + 7);
                return Ie == 181 && Be == 49 && It == 1195456820 && _t == 3;
              }; re < W + se; ) {
                if (j = M.getUint32(re), (31 & M.getUint8(re + 4)) == 6) for (var $ = re + 5, Me = -1; $ < re + 4 + j - 1; ) {
                  Me = 0;
                  for (var Ge = 255; Ge === 255; ) Me += Ge = M.getUint8($), $++;
                  var Qe = 0;
                  for (Ge = 255; Ge === 255; ) Qe += Ge = M.getUint8($), $++;
                  Re(Me, Qe, M, $) && ce.push([$, Qe]), $ += Qe;
                }
                re += j + 4;
              }
              return ce;
            }, R.extractCea608DataFromRange = function(M, W) {
              var se = W[0], j = [[], []];
              se += 8;
              var re = 31 & M.getUint8(se);
              se += 2;
              for (var ce = 0; ce < re; ce++) {
                var Re = M.getUint8(se), $ = 4 & Re, Me = 3 & Re;
                se++;
                var Ge = M.getUint8(se);
                se++;
                var Qe = M.getUint8(se);
                se++, $ && (127 & Ge) + (127 & Qe) != 0 && (Me === 0 ? (j[0].push(Ge), j[0].push(Qe)) : Me === 1 && (j[1].push(Ge), j[1].push(Qe)));
              }
              return j;
            };
          })(ge);
        }, 8416: function(Se, ge, R) {
          var te = R(1139), E = R(5448), t = R(6398), e = R(2032), m = (R(5530), typeof window < "u" && window || R.g), p = m.dashjs;
          p || (p = m.dashjs = {}), p.MediaPlayer = te.Z, p.FactoryMaker = E.Z, p.Debug = t.Z, p.Version = (0, e.e)();
        }, 6398: function(Se, ge, R) {
          var te = R(5595), E = R(8512), t = R(5448), e = 1, m = 2, p = 3, l = 4, v = 5;
          function h(f) {
            f = f || {};
            var d, S, x, G, P = this.context, J = (0, te.Z)(P).getInstance(), M = f.settings, W = [];
            function se(Ge) {
              return Ge && Ge.bind ? Ge.bind(window.console) : window.console.log.bind(window.console);
            }
            function j() {
              for (var Ge = arguments.length, Qe = new Array(Ge), Ae = 0; Ae < Ge; Ae++) Qe[Ae] = arguments[Ae];
              Me.apply(void 0, [e, this].concat(Qe));
            }
            function re() {
              for (var Ge = arguments.length, Qe = new Array(Ge), Ae = 0; Ae < Ge; Ae++) Qe[Ae] = arguments[Ae];
              Me.apply(void 0, [m, this].concat(Qe));
            }
            function ce() {
              for (var Ge = arguments.length, Qe = new Array(Ge), Ae = 0; Ae < Ge; Ae++) Qe[Ae] = arguments[Ae];
              Me.apply(void 0, [p, this].concat(Qe));
            }
            function Re() {
              for (var Ge = arguments.length, Qe = new Array(Ge), Ae = 0; Ae < Ge; Ae++) Qe[Ae] = arguments[Ae];
              Me.apply(void 0, [l, this].concat(Qe));
            }
            function $() {
              for (var Ge = arguments.length, Qe = new Array(Ge), Ae = 0; Ae < Ge; Ae++) Qe[Ae] = arguments[Ae];
              Me.apply(void 0, [v, this].concat(Qe));
            }
            function Me(Ge, Qe) {
              var Ae = "", Ze = null;
              S && (Ze = (/* @__PURE__ */ new Date()).getTime(), Ae += "[" + (Ze - G) + "]"), x && Qe && Qe.getClassName && (Ae += "[" + Qe.getClassName() + "]", Qe.getType && (Ae += "[" + Qe.getType() + "]")), Ae.length > 0 && (Ae += " ");
              for (var Xe = arguments.length, at = new Array(Xe > 2 ? Xe - 2 : 0), Ie = 2; Ie < Xe; Ie++) at[Ie - 2] = arguments[Ie];
              Array.apply(null, at).forEach(function(Be) {
                Ae += Be + " ";
              }), W[Ge] && M && M.get().debug.logLevel >= Ge && W[Ge](Ae), M && M.get().debug.dispatchEvent && J.trigger(E.Z.LOG, { message: Ae, level: Ge });
            }
            return d = { getLogger: function(Ge) {
              return { fatal: j.bind(Ge), error: re.bind(Ge), warn: ce.bind(Ge), info: Re.bind(Ge), debug: $.bind(Ge) };
            }, setLogTimestampVisible: function(Ge) {
              S = Ge;
            }, setCalleeNameVisible: function(Ge) {
              x = Ge;
            } }, S = !0, x = !0, G = (/* @__PURE__ */ new Date()).getTime(), typeof window < "u" && window.console && (W[e] = se(window.console.error), W[m] = se(window.console.error), W[p] = se(window.console.warn), W[l] = se(window.console.info), W[v] = se(window.console.debug)), d;
          }
          h.__dashjs_factory_name = "Debug";
          var n = t.Z.getSingletonFactory(h);
          n.LOG_LEVEL_NONE = 0, n.LOG_LEVEL_FATAL = e, n.LOG_LEVEL_ERROR = m, n.LOG_LEVEL_WARNING = p, n.LOG_LEVEL_INFO = l, n.LOG_LEVEL_DEBUG = v, t.Z.updateSingletonFactory(h.__dashjs_factory_name, n), ge.Z = n;
        }, 5595: function(Se, ge, R) {
          var te = R(5448), E = R(8825);
          function t() {
            var m = {};
            function p(v, h, n) {
              var f = -1;
              return m[v] && m[v].some(function(d, S) {
                if (d && d.callback === h && (!n || n === d.scope)) return f = S, !0;
              }), f;
            }
            var l = { on: function(v, h, n) {
              var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              if (!v) throw new Error("event type cannot be null or undefined");
              if (!h || typeof h != "function") throw new Error("listener must be a function: " + h);
              var d = f.priority || 0;
              if (!(p(v, h, n) >= 0)) {
                m[v] = m[v] || [];
                var S = { callback: h, scope: n, priority: d };
                n && n.getStreamId && (S.streamId = n.getStreamId()), n && n.getType && (S.mediaType = n.getType()), f && f.mode && (S.mode = f.mode);
                var x = m[v].some(function(G, P) {
                  if (G && d > G.priority) return m[v].splice(P, 0, S), !0;
                });
                x || m[v].push(S);
              }
            }, off: function(v, h, n) {
              if (v && h && m[v]) {
                var f = p(v, h, n);
                f < 0 || (m[v][f] = null);
              }
            }, trigger: function(v) {
              var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              if (v && m[v]) {
                if ((h = h || {}).hasOwnProperty("type")) throw new Error("'type' is a reserved word for event dispatching");
                h.type = v, n.streamId && (h.streamId = n.streamId), n.mediaType && (h.mediaType = n.mediaType), m[v].filter(function(f) {
                  return !(!f || n.streamId && f.streamId && f.streamId !== n.streamId || n.mediaType && f.mediaType && f.mediaType !== n.mediaType || n.mode && f.mode && f.mode !== n.mode || !f.mode && n.mode && n.mode === E.Z.EVENT_MODE_ON_RECEIVE);
                }).forEach(function(f) {
                  return f && f.callback.call(f.scope, h);
                });
              }
            }, reset: function() {
              m = {};
            } };
            return l;
          }
          t.__dashjs_factory_name = "EventBus";
          var e = te.Z.getSingletonFactory(t);
          e.EVENT_PRIORITY_LOW = 0, e.EVENT_PRIORITY_HIGH = 5e3, te.Z.updateSingletonFactory(t.__dashjs_factory_name, e), ge.Z = e;
        }, 5448: function(Se, ge) {
          var R = function() {
            var te, E = [], t = {}, e = {};
            function m(h, n) {
              for (var f in E) {
                var d = E[f];
                if (d.context === h && d.name === n) return d.instance;
              }
              return null;
            }
            function p(h, n) {
              return n[h];
            }
            function l(h, n, f) {
              h in f && (f[h] = n);
            }
            function v(h, n, f) {
              var d, S = h.__dashjs_factory_name, x = n[S];
              if (x) {
                var G = x.instance;
                if (!x.override) return G.apply({ context: n, factory: te }, f);
                for (var P in d = h.apply({ context: n }, f), G = G.apply({ context: n, factory: te, parent: d }, f)) d.hasOwnProperty(P) && (d[P] = G[P]);
              } else d = h.apply({ context: n }, f);
              return d.getClassName = function() {
                return S;
              }, d;
            }
            return te = { extend: function(h, n, f, d) {
              !d[h] && n && (d[h] = { instance: n, override: f });
            }, getSingletonInstance: m, setSingletonInstance: function(h, n, f) {
              for (var d in E) {
                var S = E[d];
                if (S.context === h && S.name === n) return void (E[d].instance = f);
              }
              E.push({ name: n, context: h, instance: f });
            }, deleteSingletonInstances: function(h) {
              E = E.filter(function(n) {
                return n.context !== h;
              });
            }, getSingletonFactory: function(h) {
              var n = p(h.__dashjs_factory_name, t);
              return n || (n = function(f) {
                var d;
                return f === void 0 && (f = {}), { getInstance: function() {
                  return d || (d = m(f, h.__dashjs_factory_name)), d || (d = v(h, f, arguments), E.push({ name: h.__dashjs_factory_name, context: f, instance: d })), d;
                } };
              }, t[h.__dashjs_factory_name] = n), n;
            }, getSingletonFactoryByName: function(h) {
              return p(h, t);
            }, updateSingletonFactory: function(h, n) {
              l(h, n, t);
            }, getClassFactory: function(h) {
              var n = p(h.__dashjs_factory_name, e);
              return n || (n = function(f) {
                return f === void 0 && (f = {}), { create: function() {
                  return v(h, f, arguments);
                } };
              }, e[h.__dashjs_factory_name] = n), n;
            }, getClassFactoryByName: function(h) {
              return p(h, e);
            }, updateClassFactory: function(h, n) {
              l(h, n, e);
            } }, te;
          }();
          ge.Z = R;
        }, 1264: function(Se, ge, R) {
          var te = R(5448), E = R(703), t = R(6398), e = R(3393), m = R(7855), p = R(5595), l = R(8512);
          function v(d) {
            return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
              return typeof S;
            } : function(S) {
              return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
            }, v(d);
          }
          function h(d, S, x) {
            return S in d ? Object.defineProperty(d, S, { value: x, enumerable: !0, configurable: !0, writable: !0 }) : d[S] = x, d;
          }
          function n() {
            var d, S, x = this.context, G = (0, p.Z)(x).getInstance(), P = { "streaming.delay.liveDelay": l.Z.SETTING_UPDATED_LIVE_DELAY, "streaming.delay.liveDelayFragmentCount": l.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, "streaming.liveCatchup.enabled": l.Z.SETTING_UPDATED_CATCHUP_ENABLED, "streaming.liveCatchup.playbackRate.min": l.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, "streaming.liveCatchup.playbackRate.max": l.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX }, J = { debug: { logLevel: t.Z.LOG_LEVEL_WARNING, dispatchEvent: !1 }, streaming: { abandonLoadTimeout: 1e4, wallclockTimeUpdateInterval: 100, manifestUpdateRetryInterval: 100, liveUpdateTimeThresholdInMilliseconds: 0, cacheInitSegments: !1, applyServiceDescription: !0, applyProducerReferenceTime: !0, applyContentSteering: !0, eventControllerRefreshDelay: 100, enableManifestDurationMismatchFix: !0, parseInbandPrft: !1, enableManifestTimescaleMismatchFix: !1, capabilities: { filterUnsupportedEssentialProperties: !0, useMediaCapabilitiesApi: !1 }, timeShiftBuffer: { calcFromSegmentTimeline: !1, fallbackToSegmentTimeline: !0 }, metrics: { maxListDepth: 100 }, delay: { liveDelayFragmentCount: NaN, liveDelay: NaN, useSuggestedPresentationDelay: !0 }, protection: { keepProtectionMediaKeys: !1, ignoreEmeEncryptedEvent: !1, detectPlayreadyMessageFormat: !0 }, buffer: { enableSeekDecorrelationFix: !1, fastSwitchEnabled: !0, flushBufferAtTrackSwitch: !1, reuseExistingSourceBuffers: !0, bufferPruningInterval: 10, bufferToKeep: 20, bufferTimeAtTopQuality: 30, bufferTimeAtTopQualityLongForm: 60, initialBufferLevel: NaN, stableBufferTime: 12, longFormContentDurationThreshold: 600, stallThreshold: 0.3, useAppendWindow: !0, setStallState: !0, avoidCurrentTimeRangePruning: !1, useChangeTypeForTrackSwitch: !0, mediaSourceDurationInfinity: !0, resetSourceBuffersForTrackSwitch: !1 }, gaps: { jumpGaps: !0, jumpLargeGaps: !0, smallGapLimit: 1.5, threshold: 0.3, enableSeekFix: !0, enableStallFix: !1, stallSeek: 0.1 }, utcSynchronization: { enabled: !0, useManifestDateHeaderTimeSource: !0, backgroundAttempts: 2, timeBetweenSyncAttempts: 30, maximumTimeBetweenSyncAttempts: 600, minimumTimeBetweenSyncAttempts: 2, timeBetweenSyncAttemptsAdjustmentFactor: 2, maximumAllowedDrift: 100, enableBackgroundSyncAfterSegmentDownloadError: !0, defaultTimingSource: { scheme: "urn:mpeg:dash:utc:http-xsdate:2014", value: "https://time.akamai.com/?iso&ms" } }, scheduling: { defaultTimeout: 500, lowLatencyTimeout: 0, scheduleWhilePaused: !0 }, text: { defaultEnabled: !0, dispatchForManualRendering: !1, extendSegmentedCues: !0, imsc: { displayForcedOnlyMode: !1, enableRollUp: !0 }, webvtt: { customRenderingEnabled: !1 } }, liveCatchup: { maxDrift: NaN, playbackRate: { min: NaN, max: NaN }, playbackBufferMin: 0.5, enabled: null, mode: e.Z.LIVE_CATCHUP_MODE_DEFAULT }, lastBitrateCachingInfo: { enabled: !0, ttl: 36e4 }, lastMediaSettingsCachingInfo: { enabled: !0, ttl: 36e4 }, saveLastMediaSettingsForCurrentStreamingSession: !0, cacheLoadThresholds: { video: 50, audio: 5 }, trackSwitchMode: { audio: e.Z.TRACK_SWITCH_MODE_ALWAYS_REPLACE, video: e.Z.TRACK_SWITCH_MODE_NEVER_REPLACE }, selectionModeForInitialTrack: e.Z.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY, fragmentRequestTimeout: 2e4, fragmentRequestProgressTimeout: -1, manifestRequestTimeout: 1e4, retryIntervals: (d = {}, h(d, m.w.MPD_TYPE, 500), h(d, m.w.XLINK_EXPANSION_TYPE, 500), h(d, m.w.MEDIA_SEGMENT_TYPE, 1e3), h(d, m.w.INIT_SEGMENT_TYPE, 1e3), h(d, m.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, 1e3), h(d, m.w.INDEX_SEGMENT_TYPE, 1e3), h(d, m.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 1e3), h(d, m.w.LICENSE, 1e3), h(d, m.w.OTHER_TYPE, 1e3), h(d, "lowLatencyReductionFactor", 10), d), retryAttempts: (S = {}, h(S, m.w.MPD_TYPE, 3), h(S, m.w.XLINK_EXPANSION_TYPE, 1), h(S, m.w.MEDIA_SEGMENT_TYPE, 3), h(S, m.w.INIT_SEGMENT_TYPE, 3), h(S, m.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, 3), h(S, m.w.INDEX_SEGMENT_TYPE, 3), h(S, m.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 3), h(S, m.w.LICENSE, 3), h(S, m.w.OTHER_TYPE, 3), h(S, "lowLatencyMultiplyFactor", 5), S), abr: { movingAverageMethod: e.Z.MOVING_AVERAGE_SLIDING_WINDOW, ABRStrategy: e.Z.ABR_STRATEGY_DYNAMIC, additionalAbrRules: { insufficientBufferRule: !0, switchHistoryRule: !0, droppedFramesRule: !0, abandonRequestsRule: !0 }, abrRulesParameters: { abandonRequestsRule: { graceTimeThreshold: 500, abandonMultiplier: 1.8, minLengthToAverage: 5 } }, bandwidthSafetyFactor: 0.9, useDefaultABRRules: !0, useDeadTimeLatency: !0, limitBitrateByPortal: !1, usePixelRatioInLimitBitrateByPortal: !1, maxBitrate: { audio: -1, video: -1 }, minBitrate: { audio: -1, video: -1 }, maxRepresentationRatio: { audio: 1, video: 1 }, initialBitrate: { audio: -1, video: -1 }, initialRepresentationRatio: { audio: -1, video: -1 }, autoSwitchBitrate: { audio: !0, video: !0 }, fetchThroughputCalculationMode: e.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING }, cmcd: { enabled: !1, sid: null, cid: null, rtp: null, rtpSafetyFactor: 5, mode: e.Z.CMCD_MODE_QUERY, enabledKeys: ["br", "d", "ot", "tb", "bl", "dl", "mtp", "nor", "nrr", "su", "bs", "rtp", "cid", "pr", "sf", "sid", "st", "v"] }, cmsd: { enabled: !1, abr: { applyMb: !1, etpWeightRatio: 0 } } }, errors: { recoverAttempts: { mediaErrorDecode: 5 } } }, M = E.Z.clone(J);
            function W(se, j, re) {
              for (var ce in se) se.hasOwnProperty(ce) && (j.hasOwnProperty(ce) ? v(se[ce]) !== "object" || se[ce] instanceof Array || se[ce] === null ? (j[ce] = E.Z.clone(se[ce]), P[re + ce] && G.trigger(P[re + ce])) : W(se[ce], j[ce], re.slice() + ce + ".") : console.error("Settings parameter " + re + ce + " is not supported"));
            }
            return { get: function() {
              return M;
            }, update: function(se) {
              v(se) === "object" && W(se, M, "");
            }, reset: function() {
              M = E.Z.clone(J);
            } };
          }
          n.__dashjs_factory_name = "Settings";
          var f = te.Z.getSingletonFactory(n);
          ge.Z = f;
        }, 703: function(Se, ge, R) {
          var te = R(3875), E = R.n(te), t = R(1067);
          function e(l) {
            return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
              return typeof v;
            } : function(v) {
              return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
            }, e(l);
          }
          function m(l, v) {
            for (var h = 0; h < v.length; h++) {
              var n = v[h];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(l, n.key, n);
            }
          }
          var p = function() {
            function l() {
              (function(n, f) {
                if (!(n instanceof f)) throw new TypeError("Cannot call a class as a function");
              })(this, l);
            }
            var v, h;
            return v = l, h = [{ key: "mixin", value: function(n, f, d) {
              var S, x = {};
              if (n) for (var G in f) f.hasOwnProperty(G) && (S = f[G], G in n && (n[G] === S || G in x && x[G] === S) || (e(n[G]) === "object" && n[G] !== null ? n[G] = l.mixin(n[G], S, d) : n[G] = d(S)));
              return n;
            } }, { key: "clone", value: function(n) {
              if (!n || e(n) !== "object") return n;
              var f;
              if (n instanceof Array) {
                f = [];
                for (var d = 0, S = n.length; d < S; ++d) d in n && f.push(l.clone(n[d]));
              } else f = {};
              return l.mixin(f, n, l.clone);
            } }, { key: "addAditionalQueryParameterToUrl", value: function(n, f) {
              try {
                if (!f || f.length === 0) return n;
                var d = new URL(n);
                return f.forEach(function(S) {
                  S.key && S.value && d.searchParams.set(S.key, S.value);
                }), d.href;
              } catch {
                return n;
              }
            } }, { key: "parseHttpHeaders", value: function(n) {
              var f = {};
              if (!n) return f;
              for (var d = n.trim().split(`\r
`), S = 0, x = d.length; S < x; S++) {
                var G = d[S], P = G.indexOf(": ");
                P > 0 && (f[G.substring(0, P)] = G.substring(P + 2));
              }
              return f;
            } }, { key: "generateUuid", value: function() {
              var n = (/* @__PURE__ */ new Date()).getTime();
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(f) {
                var d = (n + 16 * Math.random()) % 16 | 0;
                return n = Math.floor(n / 16), (f == "x" ? d : 3 & d | 8).toString(16);
              });
            } }, { key: "generateHashCode", value: function(n) {
              var f = 0;
              if (n.length === 0) return f;
              for (var d = 0; d < n.length; d++) f = (f << 5) - f + n.charCodeAt(d), f |= 0;
              return f;
            } }, { key: "getRelativeUrl", value: function(n, f) {
              try {
                var d = new URL(n), S = new URL(f);
                if (d.protocol = S.protocol, d.origin !== S.origin) return f;
                var x = E().relative(d.pathname.substr(0, d.pathname.lastIndexOf("/")), S.pathname.substr(0, S.pathname.lastIndexOf("/"))), G = x.length === 0 ? 1 : 0;
                return x += S.pathname.substr(S.pathname.lastIndexOf("/") + G, S.pathname.length - 1), S.pathname.length < x.length ? S.pathname : x;
              } catch {
                return f;
              }
            } }, { key: "parseUserAgent", value: function() {
              var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              try {
                var f = n === null && typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "";
                return (0, t.UAParser)(f);
              } catch {
                return {};
              }
            } }, { key: "stringHasProtocol", value: function(n) {
              return /(http(s?)):\/\//i.test(n);
            } }], h && m(v, h), l;
          }();
          ge.Z = p;
        }, 2032: function(Se, ge, R) {
          function te() {
            return "4.7.4";
          }
          R.d(ge, { e: function() {
            return te;
          } });
        }, 2230: function(Se, ge) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var m = t[e];
              m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(E, m.key, m);
            }
          }
          var te = function() {
            function E() {
              (function(m, p) {
                if (!(m instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E);
            }
            var t, e;
            return t = E, (e = [{ key: "extend", value: function(m, p) {
              if (m) {
                var l = !!p && p.override, v = !!p && p.publicOnly;
                for (var h in m) !m.hasOwnProperty(h) || this[h] && !l || v && m[h].indexOf("public_") === -1 || (this[h] = m[h]);
              }
            } }]) && R(t.prototype, e), E;
          }();
          ge.Z = te;
        }, 4351: function(Se, ge, R) {
          function te(p) {
            return te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
              return typeof l;
            } : function(l) {
              return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
            }, te(p);
          }
          function E(p, l) {
            return E = Object.setPrototypeOf || function(v, h) {
              return v.__proto__ = h, v;
            }, E(p, l);
          }
          function t(p, l) {
            return !l || te(l) !== "object" && typeof l != "function" ? function(v) {
              if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }(p) : l;
          }
          function e(p) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(l) {
              return l.__proto__ || Object.getPrototypeOf(l);
            }, e(p);
          }
          var m = function(p) {
            (function(f, d) {
              if (typeof d != "function" && d !== null) throw new TypeError("Super expression must either be null or a function");
              f.prototype = Object.create(d && d.prototype, { constructor: { value: f, writable: !0, configurable: !0 } }), d && E(f, d);
            })(n, p);
            var l, v, h = (l = n, v = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var f, d = e(l);
              if (v) {
                var S = e(this).constructor;
                f = Reflect.construct(d, arguments, S);
              } else f = d.apply(this, arguments);
              return t(this, f);
            });
            function n() {
              var f;
              return function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (f = h.call(this)).ATTEMPT_BACKGROUND_SYNC = "attemptBackgroundSync", f.BUFFERING_COMPLETED = "bufferingCompleted", f.BUFFER_CLEARED = "bufferCleared", f.BYTES_APPENDED_END_FRAGMENT = "bytesAppendedEndFragment", f.BUFFER_REPLACEMENT_STARTED = "bufferReplacementStarted", f.CHECK_FOR_EXISTENCE_COMPLETED = "checkForExistenceCompleted", f.CMSD_STATIC_HEADER = "cmsdStaticHeader", f.CURRENT_TRACK_CHANGED = "currentTrackChanged", f.DATA_UPDATE_COMPLETED = "dataUpdateCompleted", f.INBAND_EVENTS = "inbandEvents", f.INITIAL_STREAM_SWITCH = "initialStreamSwitch", f.INIT_FRAGMENT_LOADED = "initFragmentLoaded", f.INIT_FRAGMENT_NEEDED = "initFragmentNeeded", f.INTERNAL_MANIFEST_LOADED = "internalManifestLoaded", f.ORIGINAL_MANIFEST_LOADED = "originalManifestLoaded", f.LOADING_COMPLETED = "loadingCompleted", f.LOADING_PROGRESS = "loadingProgress", f.LOADING_DATA_PROGRESS = "loadingDataProgress", f.LOADING_ABANDONED = "loadingAborted", f.MANIFEST_UPDATED = "manifestUpdated", f.MEDIA_FRAGMENT_LOADED = "mediaFragmentLoaded", f.MEDIA_FRAGMENT_NEEDED = "mediaFragmentNeeded", f.QUOTA_EXCEEDED = "quotaExceeded", f.SEGMENT_LOCATION_BLACKLIST_ADD = "segmentLocationBlacklistAdd", f.SEGMENT_LOCATION_BLACKLIST_CHANGED = "segmentLocationBlacklistChanged", f.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD = "serviceLocationBlacklistAdd", f.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED = "serviceLocationBlacklistChanged", f.SERVICE_LOCATION_LOCATION_BLACKLIST_ADD = "serviceLocationLocationBlacklistAdd", f.SERVICE_LOCATION_LOCATION_BLACKLIST_CHANGED = "serviceLocationLocationBlacklistChanged", f.SET_FRAGMENTED_TEXT_AFTER_DISABLED = "setFragmentedTextAfterDisabled", f.SET_NON_FRAGMENTED_TEXT = "setNonFragmentedText", f.SOURCE_BUFFER_ERROR = "sourceBufferError", f.STREAMS_COMPOSED = "streamsComposed", f.STREAM_BUFFERING_COMPLETED = "streamBufferingCompleted", f.STREAM_REQUESTING_COMPLETED = "streamRequestingCompleted", f.TEXT_TRACKS_QUEUE_INITIALIZED = "textTracksQueueInitialized", f.TIME_SYNCHRONIZATION_COMPLETED = "timeSynchronizationComplete", f.UPDATE_TIME_SYNC_OFFSET = "updateTimeSyncOffset", f.URL_RESOLUTION_FAILED = "urlResolutionFailed", f.VIDEO_CHUNK_RECEIVED = "videoChunkReceived", f.WALLCLOCK_TIME_UPDATED = "wallclockTimeUpdated", f.XLINK_ELEMENT_LOADED = "xlinkElementLoaded", f.XLINK_READY = "xlinkReady", f.SEEK_TARGET = "seekTarget", f.SETTING_UPDATED_LIVE_DELAY = "settingUpdatedLiveDelay", f.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT = "settingUpdatedLiveDelayFragmentCount", f.SETTING_UPDATED_CATCHUP_ENABLED = "settingUpdatedCatchupEnabled", f.SETTING_UPDATED_PLAYBACK_RATE_MIN = "settingUpdatedPlaybackRateMin", f.SETTING_UPDATED_PLAYBACK_RATE_MAX = "settingUpdatedPlaybackRateMax", f;
            }
            return n;
          }(R(8342).Z);
          ge.Z = m;
        }, 8512: function(Se, ge, R) {
          function te(v) {
            return te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
              return typeof h;
            } : function(h) {
              return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
            }, te(v);
          }
          function E(v, h) {
            if (!(v instanceof h)) throw new TypeError("Cannot call a class as a function");
          }
          function t(v, h) {
            return t = Object.setPrototypeOf || function(n, f) {
              return n.__proto__ = f, n;
            }, t(v, h);
          }
          function e(v, h) {
            return !h || te(h) !== "object" && typeof h != "function" ? function(n) {
              if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return n;
            }(v) : h;
          }
          function m(v) {
            return m = Object.setPrototypeOf ? Object.getPrototypeOf : function(h) {
              return h.__proto__ || Object.getPrototypeOf(h);
            }, m(v);
          }
          var p = function(v) {
            (function(S, x) {
              if (typeof x != "function" && x !== null) throw new TypeError("Super expression must either be null or a function");
              S.prototype = Object.create(x && x.prototype, { constructor: { value: S, writable: !0, configurable: !0 } }), x && t(S, x);
            })(d, v);
            var h, n, f = (h = d, n = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var S, x = m(h);
              if (n) {
                var G = m(this).constructor;
                S = Reflect.construct(x, arguments, G);
              } else S = x.apply(this, arguments);
              return e(this, S);
            });
            function d() {
              return E(this, d), f.apply(this, arguments);
            }
            return d;
          }(R(4351).Z), l = new p();
          ge.Z = l;
        }, 8342: function(Se, ge) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var m = t[e];
              m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(E, m.key, m);
            }
          }
          var te = function() {
            function E() {
              (function(m, p) {
                if (!(m instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E);
            }
            var t, e;
            return t = E, (e = [{ key: "extend", value: function(m, p) {
              if (m) {
                var l = !!p && p.override, v = !!p && p.publicOnly;
                for (var h in m) !m.hasOwnProperty(h) || this[h] && !l || v && m[h].indexOf("public_") === -1 || (this[h] = m[h]);
              }
            } }]) && R(t.prototype, e), E;
          }();
          ge.Z = te;
        }, 9326: function(Se, ge, R) {
          var te = R(3186), E = R(7855), t = R(5448), e = R(8825), m = R(7387), p = R(1553);
          function l(v) {
            var h, n, f, d, S, x = (v = v || {}).eventBus, G = v.debug, P = v.urlUtils, J = v.type, M = v.streamInfo, W = v.segmentsController, se = v.timelineConverter, j = v.baseURLController;
            function re() {
              return J;
            }
            function ce() {
              f = null;
            }
            function Re(Ae, Ze, Xe) {
              var at, Ie, Be = j.resolve(Xe.path), It = {};
              return Be && Ze !== Be.url && P.isRelative(Ze) ? (at = Be.url, Ie = Be.serviceLocation, It = Be.queryParams, Ze && (at = P.resolve(Ze, at))) : at = Ze, !P.isRelative(at) && (Ae.url = at, Ae.serviceLocation = Ie, Ae.queryParams = It, !0);
            }
            function $(Ae, Ze) {
              if (Ze == null) return null;
              var Xe = new te.Z(), at = Ze.representation, Ie = at.adaptation.period.mpd.manifest.Period_asArray[at.adaptation.period.index].AdaptationSet_asArray[at.adaptation.index].Representation_asArray[at.index].bandwidth, Be = Ze.media;
              return Be = (0, m.vi)(Be, "Number", Ze.replacementNumber), Be = (0, m.vi)(Be, "Time", Ze.replacementTime), Be = (0, m.vi)(Be, "Bandwidth", Ie), Be = (0, m.Aj)(Be, at.id), Be = (0, m.eR)(Be), Xe.mediaType = re(), Xe.type = E.w.MEDIA_SEGMENT_TYPE, Xe.range = Ze.mediaRange, Xe.startTime = Ze.presentationStartTime, Xe.mediaStartTime = Ze.mediaStartTime, Xe.duration = Ze.duration, Xe.timescale = at.timescale, Xe.availabilityStartTime = Ze.availabilityStartTime, Xe.availabilityEndTime = Ze.availabilityEndTime, Xe.availabilityTimeComplete = at.availabilityTimeComplete, Xe.wallStartTime = Ze.wallStartTime, Xe.quality = at.index, Xe.index = Ze.index, Xe.mediaInfo = Ae, Xe.adaptationIndex = at.adaptation.index, Xe.representationId = at.id, Re(Xe, Be, at) ? Xe : void 0;
            }
            function Me(Ae, Ze, Xe) {
              var at = null;
              if (!Ze || !Ze.segmentInfoType) return at;
              var Ie = W.getSegmentByTime(Ze, Xe);
              return Ie && (f = Ie, n.debug("Index for time " + Xe + " is " + Ie.index), at = $(Ae, Ie)), at;
            }
            function Ge(Ae, Ze, Xe) {
              var at = null, Ie = W.getSegmentByIndex(Ze, Xe, f ? f.mediaStartTime : -1);
              if (Ie) at = $(Ae, Ie), f = Ie;
              else {
                if (d && !S) return n.debug(re() + " No segment found at index: " + Xe + ". Wait for next loop"), null;
                S = !0;
              }
              return at;
            }
            function Qe() {
              n.debug("Dynamic stream complete"), S = !0;
            }
            return h = { getCurrentIndex: function() {
              return f ? f.index : -1;
            }, getInitRequest: function(Ae, Ze) {
              return Ze ? function(Xe, at, Ie) {
                var Be = new te.Z(), It = at.adaptation.period, _t = It.start;
                if (Be.mediaType = Ie, Be.type = E.w.INIT_SEGMENT_TYPE, Be.range = at.range, Be.availabilityStartTime = se.calcAvailabilityStartTimeFromPresentationTime(_t, at, d), Be.availabilityEndTime = se.calcAvailabilityEndTimeFromPresentationTime(_t + It.duration, at, d), Be.quality = at.index, Be.mediaInfo = Xe, Be.representationId = at.id, Re(Be, at.initialization, at)) return Be.url = (0, m.vi)(Be.url, "Bandwidth", at.bandwidth), Be;
              }(Ae, Ze, re()) : null;
            }, getNextSegmentRequest: function(Ae, Ze) {
              return Ze && Ze.segmentInfoType ? Ge(Ae, Ze, f ? f.index + 1 : 0) : null;
            }, getNextSegmentRequestIdempotent: function(Ae, Ze) {
              var Xe = f ? f.index + 1 : 0, at = W.getSegmentByIndex(Ze, Xe, f ? f.mediaStartTime : -1);
              return at ? $(Ae, at) : null;
            }, getSegmentRequestForTime: Me, getStreamId: function() {
              return M.id;
            }, getStreamInfo: function() {
              return M;
            }, getType: re, getValidTimeAheadOfTargetTime: function(Ae, Ze, Xe, at) {
              try {
                if (isNaN(Ae) || !Ze || !Xe) return NaN;
                if (Ae < 0 && (Ae = 0), isNaN(at) && (at = 0.5), Me(Ze, Xe, Ae)) return Ae;
                if (Xe.adaptation.period.start + Xe.adaptation.period.duration < Ae) return NaN;
                for (var Ie = isFinite(Xe.adaptation.period.duration) ? Xe.adaptation.period.start + Xe.adaptation.period.duration : Ae + 30, Be = Math.min(Ae + at, Ie), It = NaN, _t = null; Be <= Ie; ) {
                  var Ve = null;
                  if (Be <= Ie && (Ve = Me(Ze, Xe, Be)), Ve) {
                    It = Be, _t = Ve;
                    break;
                  }
                  Be += at;
                }
                if (_t) {
                  var ot = _t.startTime + _t.duration;
                  return Ae > _t.startTime && ot - Ae > at ? Ae : !isNaN(_t.startTime) && Ae < _t.startTime && It > _t.startTime ? _t.startTime + 1e-3 : Math.min(ot - at, It);
                }
                return It;
              } catch {
                return NaN;
              }
            }, initialize: function(Ae) {
              d = Ae, S = !1, W.initialize(Ae);
            }, isLastSegmentRequested: function(Ae, Ze) {
              return !Ae || !f ? !1 : S ? !0 : !isFinite(Ae.adaptation.period.duration) || f.presentationStartTime + f.duration > Ze ? !1 : Ae.mediaFinishedInformation && !isNaN(Ae.mediaFinishedInformation.numberOfSegments) && !isNaN(f.index) && f.index >= Ae.mediaFinishedInformation.numberOfSegments - 1 && (!d || Ae.segmentInfoType === p.Z.SEGMENT_TEMPLATE || d && Ae.segmentInfoType === p.Z.SEGMENT_LIST && Ae.adaptation.period.nextPeriodId) ? !0 : !!(d && Ae.adaptation.period.nextPeriodId && Ae.segmentInfoType === p.Z.SEGMENT_TIMELINE && Ae.mediaFinishedInformation && !isNaN(Ae.mediaFinishedInformation.mediaTimeOfLastSignaledSegment) && f && !isNaN(f.mediaStartTime) && !isNaN(f.duration) && f.mediaStartTime + f.duration >= Ae.mediaFinishedInformation.mediaTimeOfLastSignaledSegment - 0.05);
            }, repeatSegmentRequest: function(Ae, Ze) {
              return Ze && Ze.segmentInfoType ? Ge(Ae, Ze, f ? f.index : 0) : null;
            }, reset: function() {
              ce(), x.off(e.Z.DYNAMIC_TO_STATIC, Qe, h);
            } }, n = G.getLogger(h), ce(), x.on(e.Z.DYNAMIC_TO_STATIC, Qe, h), h;
          }
          l.__dashjs_factory_name = "DashHandler", ge.Z = t.Z.getClassFactory(l);
        }, 1553: function(Se, ge) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var m = t[e];
              m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(E, m.key, m);
            }
          }
          var te = new (function() {
            function E() {
              (function(m, p) {
                if (!(m instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E), this.init();
            }
            var t, e;
            return t = E, (e = [{ key: "init", value: function() {
              this.BASE_URL = "BaseURL", this.SEGMENT_BASE = "SegmentBase", this.SEGMENT_TEMPLATE = "SegmentTemplate", this.SEGMENT_LIST = "SegmentList", this.SEGMENT_URL = "SegmentURL", this.SEGMENT_TIMELINE = "SegmentTimeline", this.SEGMENT_PROFILES = "segmentProfiles", this.ADAPTATION_SET = "AdaptationSet", this.REPRESENTATION = "Representation", this.REPRESENTATION_INDEX = "RepresentationIndex", this.SUB_REPRESENTATION = "SubRepresentation", this.INITIALIZATION = "Initialization", this.INITIALIZATION_MINUS = "initialization", this.MPD = "MPD", this.PERIOD = "Period", this.ASSET_IDENTIFIER = "AssetIdentifier", this.EVENT_STREAM = "EventStream", this.ID = "id", this.PROFILES = "profiles", this.SERVICE_LOCATION = "serviceLocation", this.RANGE = "range", this.INDEX = "index", this.MEDIA = "media", this.BYTE_RANGE = "byteRange", this.INDEX_RANGE = "indexRange", this.MEDIA_RANGE = "mediaRange", this.VALUE = "value", this.CONTENT_TYPE = "contentType", this.MIME_TYPE = "mimeType", this.BITSTREAM_SWITCHING = "BitstreamSwitching", this.BITSTREAM_SWITCHING_MINUS = "bitstreamSwitching", this.CODECS = "codecs", this.DEPENDENCY_ID = "dependencyId", this.MEDIA_STREAM_STRUCTURE_ID = "mediaStreamStructureId", this.METRICS = "Metrics", this.METRICS_MINUS = "metrics", this.REPORTING = "Reporting", this.WIDTH = "width", this.HEIGHT = "height", this.SAR = "sar", this.FRAMERATE = "frameRate", this.AUDIO_SAMPLING_RATE = "audioSamplingRate", this.MAXIMUM_SAP_PERIOD = "maximumSAPPeriod", this.START_WITH_SAP = "startWithSAP", this.MAX_PLAYOUT_RATE = "maxPlayoutRate", this.CODING_DEPENDENCY = "codingDependency", this.SCAN_TYPE = "scanType", this.FRAME_PACKING = "FramePacking", this.AUDIO_CHANNEL_CONFIGURATION = "AudioChannelConfiguration", this.CONTENT_PROTECTION = "ContentProtection", this.ESSENTIAL_PROPERTY = "EssentialProperty", this.ESSENTIAL_PROPERTY_ASARRAY = "EssentialProperty_asArray", this.SUPPLEMENTAL_PROPERTY = "SupplementalProperty", this.SUPPLEMENTAL_PROPERTY_ASARRAY = "SupplementalProperty_asArray", this.INBAND_EVENT_STREAM = "InbandEventStream", this.PRODUCER_REFERENCE_TIME = "ProducerReferenceTime", this.INBAND = "inband", this.TYPE = "type", this.ACCESSIBILITY = "Accessibility", this.ROLE = "Role", this.RATING = "Rating", this.CONTENT_COMPONENT = "ContentComponent", this.SUBSET = "Subset", this.LANG = "lang", this.VIEWPOINT = "Viewpoint", this.VIEWPOINT_ASARRAY = "Viewpoint_asArray", this.ROLE_ASARRAY = "Role_asArray", this.REPRESENTATION_ASARRAY = "Representation_asArray", this.PRODUCERREFERENCETIME_ASARRAY = "ProducerReferenceTime_asArray", this.ACCESSIBILITY_ASARRAY = "Accessibility_asArray", this.AUDIOCHANNELCONFIGURATION_ASARRAY = "AudioChannelConfiguration_asArray", this.CONTENTPROTECTION_ASARRAY = "ContentProtection_asArray", this.MAIN = "main", this.DYNAMIC = "dynamic", this.STATIC = "static", this.MEDIA_PRESENTATION_DURATION = "mediaPresentationDuration", this.MINIMUM_UPDATE_PERIOD = "minimumUpdatePeriod", this.CODEC_PRIVATE_DATA = "codecPrivateData", this.BANDWITH = "bandwidth", this.SOURCE_URL = "sourceURL", this.TIMESCALE = "timescale", this.DURATION = "duration", this.START_NUMBER = "startNumber", this.PRESENTATION_TIME_OFFSET = "presentationTimeOffset", this.AVAILABILITY_START_TIME = "availabilityStartTime", this.AVAILABILITY_END_TIME = "availabilityEndTime", this.TIMESHIFT_BUFFER_DEPTH = "timeShiftBufferDepth", this.MAX_SEGMENT_DURATION = "maxSegmentDuration", this.PRESENTATION_TIME = "presentationTime", this.MIN_BUFFER_TIME = "minBufferTime", this.MAX_SUBSEGMENT_DURATION = "maxSubsegmentDuration", this.START = "start", this.AVAILABILITY_TIME_OFFSET = "availabilityTimeOffset", this.AVAILABILITY_TIME_COMPLETE = "availabilityTimeComplete", this.CENC_DEFAULT_KID = "cenc:default_KID", this.DVB_PRIORITY = "dvb:priority", this.DVB_WEIGHT = "dvb:weight", this.DVB_URL = "dvb:url", this.DVB_MIMETYPE = "dvb:mimeType", this.DVB_FONTFAMILY = "dvb:fontFamily", this.SUGGESTED_PRESENTATION_DELAY = "suggestedPresentationDelay", this.SERVICE_DESCRIPTION = "ServiceDescription", this.SERVICE_DESCRIPTION_SCOPE = "Scope", this.SERVICE_DESCRIPTION_LATENCY = "Latency", this.SERVICE_DESCRIPTION_PLAYBACK_RATE = "PlaybackRate", this.SERVICE_DESCRIPTION_OPERATING_QUALITY = "OperatingQuality", this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH = "OperatingBandwidth", this.PATCH_LOCATION = "PatchLocation", this.PATCH_LOCATION_AS_ARRAY = "PatchLocation_asArray", this.LOCATION = "Location", this.LOCATION_AS_ARRAY = "Location_asArray", this.PUBLISH_TIME = "publishTime", this.ORIGINAL_PUBLISH_TIME = "originalPublishTime", this.ORIGINAL_MPD_ID = "mpdId", this.WALL_CLOCK_TIME = "wallClockTime", this.PRESENTATION_TIME = "presentationTime", this.LABEL = "Label", this.GROUP_LABEL = "GroupLabel", this.CONTENT_STEERING = "ContentSteering", this.CONTENT_STEERING_AS_ARRAY = "ContentSteering_asArray", this.DEFAULT_SERVICE_LOCATION = "defaultServiceLocation", this.QUERY_BEFORE_START = "queryBeforeStart", this.CLIENT_REQUIREMENT = "clientRequirement", this.TTL = "ttl", this.CONTENT_STEERING_RESPONSE = { VERSION: "VERSION", TTL: "TTL", RELOAD_URI: "RELOAD-URI", PATHWAY_PRIORITY: "PATHWAY-PRIORITY", PATHWAY_CLONES: "PATHWAY-CLONES", BASE_ID: "BASE-ID", ID: "ID", URI_REPLACEMENT: "URI-REPLACEMENT", HOST: "HOST", PARAMS: "PARAMS" }, this.PRODUCER_REFERENCE_TIME_TYPE = { ENCODER: "encoder", CAPTURED: "captured", APPLICATION: "application" }, this.SEGMENT_ALIGNMENT = "segmentAlignment", this.SUB_SEGMENT_ALIGNMENT = "subsegmentAlignment";
            } }]) && R(t.prototype, e), E;
          }())();
          ge.Z = te;
        }, 7802: function(Se, ge, R) {
          var te = R(5448), E = R(1724), t = R(3636), e = R(1736), m = R(5246);
          function p(v) {
            v = v || {};
            var h, n, f = this.context, d = v.dashConstants, S = v.type, x = v.segmentBaseController;
            function G(P) {
              return P ? P.segments ? n[d.SEGMENT_BASE] : n[P.segmentInfoType] : null;
            }
            return h = { initialize: function(P) {
              n[d.SEGMENT_TIMELINE] = (0, E.Z)(f).create(v, P), n[d.SEGMENT_TEMPLATE] = (0, t.Z)(f).create(v, P), n[d.SEGMENT_LIST] = (0, e.Z)(f).create(v, P), n[d.SEGMENT_BASE] = (0, m.Z)(f).create(v, P);
            }, updateInitData: function(P, J) {
              return J ? Promise.resolve() : x.getSegmentBaseInitSegment({ representation: P, mediaType: S });
            }, updateSegmentData: function(P, J) {
              return J ? Promise.resolve() : x.getSegmentList({ mimeType: P.mimeType, representation: P, mediaType: S });
            }, getSegmentByIndex: function(P, J, M) {
              var W = G(P);
              return W ? W.getSegmentByIndex(P, J, M) : null;
            }, getSegmentByTime: function(P, J) {
              var M = G(P);
              return M ? M.getSegmentByTime(P, J) : null;
            }, getMediaFinishedInformation: function(P) {
              var J = G(P);
              return J ? J.getMediaFinishedInformation(P) : { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
            } }, n = {}, h;
          }
          p.__dashjs_factory_name = "SegmentsController";
          var l = te.Z.getClassFactory(p);
          ge.Z = l;
        }, 1736: function(Se, ge, R) {
          var te = R(5448), E = R(3393), t = R(7387);
          function e(p, l) {
            var v = (p = p || {}).timelineConverter;
            function h() {
              if (!v || !v.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function n(f, d) {
              if (h(), !f) return null;
              var S = f.adaptation.period.mpd.manifest.Period_asArray[f.adaptation.period.index].AdaptationSet_asArray[f.adaptation.index].Representation_asArray[f.index].SegmentList, x = S.SegmentURL_asArray.length, G = f && !isNaN(f.startNumber) ? f.startNumber : 1, P = Math.max(G - 1, 0), J = Math.max(d - P, 0), M = null;
              if (J < x) {
                var W = S.SegmentURL_asArray[J];
                (M = (0, t.NF)(v, l, f, d)) && (M.replacementTime = (G + d - 1) * f.segmentDuration, M.media = W.media ? W.media : "", M.mediaRange = W.mediaRange, M.indexRange = W.indexRange);
              }
              return M;
            }
            return { getSegmentByIndex: n, getSegmentByTime: function(f, d) {
              if (h(), !f) return null;
              var S = f.segmentDuration;
              if (isNaN(S)) return null;
              var x = v.calcPeriodRelativeTimeFromMpdRelativeTime(f, d);
              return n(f, Math.floor(x / S));
            }, getMediaFinishedInformation: function(f) {
              var d = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              if (!f) return d;
              var S = f.adaptation.period.mpd.manifest.Period_asArray[f.adaptation.period.index].AdaptationSet_asArray[f.adaptation.index].Representation_asArray[f.index].SegmentList, x = f && !isNaN(f.startNumber) ? f.startNumber : 1, G = Math.max(x - 1, 0);
              return d.numberOfSegments = G + S.SegmentURL_asArray.length, d;
            } };
          }
          e.__dashjs_factory_name = "ListSegmentsGetter";
          var m = te.Z.getClassFactory(e);
          ge.Z = m;
        }, 5246: function(Se, ge, R) {
          var te = R(5448), E = R(3393);
          function t(m) {
            var p = (m = m || {}).timelineConverter;
            function l() {
              if (!p || !p.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function v(h, n) {
              if (l(), !h) return null;
              var f, d = h.segments ? h.segments.length : -1;
              if (n < d && (f = h.segments[n]) && f.index === n) return f;
              for (var S = 0; S < d; S++) if ((f = h.segments[S]) && f.index === n) return f;
              return null;
            }
            return { getSegmentByIndex: v, getSegmentByTime: function(h, n) {
              l();
              var f = function(d, S) {
                if (!d) return -1;
                var x, G, P, J, M, W = d.segments, se = W ? W.length : null, j = -1;
                if (W && se > 0) {
                  for (M = 0; M < se; M++) if (P = (G = W[M]).presentationStartTime, S + (x = (J = G.duration) / 2) >= P && S - x < P + J) {
                    j = G.index;
                    break;
                  }
                }
                return j;
              }(h, n);
              return v(h, f);
            }, getMediaFinishedInformation: function(h) {
              var n = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              return h && h.segments && (n.numberOfSegments = h.segments.length), n;
            } };
          }
          t.__dashjs_factory_name = "SegmentBaseGetter";
          var e = te.Z.getClassFactory(t);
          ge.Z = e;
        }, 7387: function(Se, ge, R) {
          R.d(ge, { Aj: function() {
            return e;
          }, NF: function() {
            return v;
          }, TJ: function() {
            return h;
          }, eR: function() {
            return t;
          }, vi: function() {
            return m;
          } });
          var te = R(2011);
          function E(n, f) {
            for (; n.length < f; ) n = "0" + n;
            return n;
          }
          function t(n) {
            return n && n.split("$$").join("$");
          }
          function e(n, f) {
            if (!f || !n || n.indexOf("$RepresentationID$") === -1) return n;
            var d = f.toString();
            return n.split("$RepresentationID$").join(d);
          }
          function m(n, f, d) {
            var S, x, G, P, J, M, W = f.length, se = 2;
            if (!n) return n;
            for (; ; ) {
              if ((S = n.indexOf("$" + f)) < 0 || (x = n.indexOf("$", S + W)) < 0) return n;
              if ((G = n.indexOf("%0", S + W)) > S && G < x) switch (P = n.charAt(x - 1), J = parseInt(n.substring(G + se, x - 1), 10), P) {
                case "d":
                case "i":
                case "u":
                  M = E(d.toString(), J);
                  break;
                case "x":
                  M = E(d.toString(16), J);
                  break;
                case "X":
                  M = E(d.toString(16), J).toUpperCase();
                  break;
                case "o":
                  M = E(d.toString(8), J);
                  break;
                default:
                  return n;
              }
              else M = d;
              n = n.substring(0, S) + M + n.substring(x + 1);
            }
          }
          function p(n, f, d, S, x, G, P, J) {
            var M, W = new te.Z();
            return W.representation = n, W.duration = f, W.presentationStartTime = d, W.mediaStartTime = S, W.availabilityStartTime = x.calcAvailabilityStartTimeFromPresentationTime(G, n, P), W.availabilityEndTime = x.calcAvailabilityEndTimeFromPresentationTime(G + f, n, P), W.wallStartTime = x.calcWallTimeForSegment(W, P), W.replacementNumber = (M = J, W.representation.startNumber + M), W.index = J, W;
          }
          function l(n, f, d, S) {
            var x = f.adaptation.period;
            if (isFinite(x.duration) && x.start + x.duration <= d.presentationStartTime) return !1;
            if (S) {
              if (f.availabilityTimeOffset === "INF") return !0;
              var G = n.getClientReferenceTime();
              return d.availabilityStartTime.getTime() <= G && (!isFinite(d.availabilityEndTime) || d.availabilityEndTime.getTime() >= G);
            }
            return !0;
          }
          function v(n, f, d, S) {
            var x, G, P;
            x = d.segmentDuration, isNaN(x) && (x = d.adaptation.period.duration), G = parseFloat((d.adaptation.period.start + S * x).toFixed(5)), P = parseFloat((G + x).toFixed(5));
            var J = p(d, x, G, n.calcMediaTimeFromPresentationTime(G, d), n, P, f, S);
            return l(n, d, J, f) ? J : null;
          }
          function h(n, f, d, S, x, G, P, J, M, W) {
            var se, j, re = S / G, ce = x / G;
            return se = n.calcPresentationTimeFromMediaTime(re, d), l(n, d, j = p(d, ce, se, re, n, se + ce, f, M), f) ? (j.replacementTime = W || S, P = m(P, "Number", j.replacementNumber), P = m(P, "Time", j.replacementTime), j.media = P, j.mediaRange = J, j) : null;
          }
        }, 3636: function(Se, ge, R) {
          var te = R(5448), E = R(3393), t = R(7387);
          function e(p, l) {
            var v = (p = p || {}).timelineConverter;
            function h() {
              if (!v || !v.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function n(f, d) {
              if (h(), !f) return null;
              var S = f.adaptation.period.mpd.manifest.Period_asArray[f.adaptation.period.index].AdaptationSet_asArray[f.adaptation.index].Representation_asArray[f.index].SegmentTemplate;
              d = Math.max(d, 0);
              var x = (0, t.NF)(v, l, f, d);
              if (x) {
                x.replacementTime = Math.round((d - 1) * f.segmentDuration * f.timescale, 10);
                var G = S.media;
                G = (0, t.vi)(G, "Number", x.replacementNumber), G = (0, t.vi)(G, "Time", x.replacementTime), x.media = G;
              }
              return x;
            }
            return { getSegmentByIndex: n, getSegmentByTime: function(f, d) {
              if (h(), !f) return null;
              var S = f.segmentDuration;
              if (isNaN(S)) return null;
              var x = v.calcPeriodRelativeTimeFromMpdRelativeTime(f, d);
              return n(f, Math.floor(x / S));
            }, getMediaFinishedInformation: function(f) {
              var d = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              if (!f) return d;
              var S = f.segmentDuration;
              return isNaN(S) ? d.numberOfSegments = 1 : d.numberOfSegments = Math.ceil(f.adaptation.period.duration / S), d;
            } };
          }
          e.__dashjs_factory_name = "TemplateSegmentsGetter";
          var m = te.Z.getClassFactory(e);
          ge.Z = m;
        }, 1724: function(Se, ge, R) {
          var te = R(5448), E = R(3393), t = R(7387);
          function e(p, l) {
            var v = (p = p || {}).timelineConverter, h = p.dashMetrics;
            function n() {
              if (!v) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function f(S, x) {
              var G, P, J, M, W, se, j, re = S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentTemplate || S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentList, ce = re.SegmentTimeline, Re = re.SegmentURL_asArray, $ = 0, Me = -1;
              j = S.timescale;
              var Ge = !1;
              for (J = 0, M = (G = ce.S_asArray).length; J < M && !Ge; J++) for (se = 0, (P = G[J]).hasOwnProperty("r") && (se = P.r), P.hasOwnProperty("t") && ($ = P.t), se < 0 && (se = d(S, G[J + 1], P, j, $ / j)), W = 0; W <= se && !Ge; W++) (Ge = x($, re, Re, P, j, ++Me, J)) && (S.segmentDuration = P.d / j), $ += P.d;
            }
            function d(S, x, G, P, J) {
              var M;
              if (x && x.hasOwnProperty("t")) M = x.t / P;
              else try {
                var W = 0;
                if (isNaN(S.adaptation.period.start) || isNaN(S.adaptation.period.duration) || !isFinite(S.adaptation.period.duration)) {
                  var se = h.getCurrentDVRInfo();
                  W = isNaN(se.end) ? 0 : se.end;
                } else W = S.adaptation.period.start + S.adaptation.period.duration;
                M = v.calcMediaTimeFromPresentationTime(W, S), S.segmentDuration = G.d / P;
              } catch {
                M = 0;
              }
              return Math.max(Math.ceil((M - J) / (G.d / P)) - 1, 0);
            }
            return { getSegmentByIndex: function(S, x, G) {
              if (n(), !S) return null;
              var P = null, J = !1;
              return f(S, function(M, W, se, j, re, ce, Re) {
                if (J || G < 0) {
                  var $ = W.media, Me = j.mediaRange;
                  return se && ($ = se[Re].media || "", Me = se[Re].mediaRange), P = (0, t.TJ)(v, l, S, M, j.d, re, $, Me, ce, j.tManifest), !0;
                }
                return M >= G * re - 0.5 * j.d && (J = !0), !1;
              }), P;
            }, getSegmentByTime: function(S, x) {
              if (n(), !S) return null;
              x === void 0 && (x = null);
              var G = null, P = v.calcMediaTimeFromPresentationTime(x, S);
              return f(S, function(J, M, W, se, j, re, ce) {
                var Re = parseFloat((P * j).toPrecision(15));
                if (Re < J + se.d && Re >= J) {
                  var $ = M.media, Me = se.mediaRange;
                  return W && ($ = W[ce].media || "", Me = W[ce].mediaRange), G = (0, t.TJ)(v, l, S, J, se.d, j, $, Me, re, se.tManifest), !0;
                }
                return !1;
              }), G;
            }, getMediaFinishedInformation: function(S) {
              if (!S) return 0;
              var x, G, P, J, M, W, se, j = (S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentTemplate || S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentList).SegmentTimeline, re = 0, ce = 0, Re = 0;
              for (se = S.timescale, J = (x = j.S_asArray).length, P = 0; P < J; P++) for (W = 0, (G = x[P]).hasOwnProperty("r") && (W = G.r), G.hasOwnProperty("t") && (ce = (re = G.t) / se), W < 0 && (W = d(S, x[P + 1], G, se, ce)), M = 0; M <= W; M++) Re++, ce = (re += G.d) / se;
              return { numberOfSegments: Re, mediaTimeOfLastSignaledSegment: ce };
            } };
          }
          e.__dashjs_factory_name = "TimelineSegmentsGetter";
          var m = te.Z.getClassFactory(e);
          ge.Z = m;
        }, 2011: function(Se, ge) {
          ge.Z = function R() {
            (function(te, E) {
              if (!(te instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.indexRange = null, this.index = null, this.mediaRange = null, this.media = null, this.duration = NaN, this.replacementTime = null, this.replacementNumber = NaN, this.mediaStartTime = NaN, this.presentationStartTime = NaN, this.availabilityStartTime = NaN, this.availabilityEndTime = NaN, this.wallStartTime = NaN, this.representation = null;
          };
        }, 2610: function(Se, ge) {
          ge.Z = function R() {
            (function(te, E) {
              if (!(te instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.schemeIdUri = "", this.value = "";
          };
        }, 1139: function(Se, ge, R) {
          R.d(ge, { Z: function() {
            return Ic;
          } });
          var te = R(452), E = R.n(te), t = R(3393), e = R(1553), m = R(3860), p = R(5595), l = R(8512), v = R(5448), h = R(6398), n = R(8825);
          function f() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q, le, K, de, g, L, D, O = this.context, A = (0, p.Z)(O).getInstance();
            function oe() {
              k(), Z = !1, Y = 0, H = 0, fe = 0, g = !1, _e = !0, q = !1, L = !1, le = NaN, ae = NaN, y && (A.off(l.Z.DATA_UPDATE_COMPLETED, We, i), A.off(l.Z.LOADING_PROGRESS, Vt, i), A.off(l.Z.MANIFEST_UPDATED, ft, i), A.off(l.Z.STREAMS_COMPOSED, pe, i), A.off(n.Z.PLAYBACK_ENDED, mt, i), A.off(n.Z.STREAM_INITIALIZING, ze, i), A.off(n.Z.REPRESENTATION_SWITCH, Pe, i), A.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, ht, i), pt(), y.removeEventListener("canplay", Tt), y.removeEventListener("canplaythrough", vt), y.removeEventListener("play", Wt), y.removeEventListener("waiting", zt), y.removeEventListener("playing", gn), y.removeEventListener("pause", pn), y.removeEventListener("error", kt), y.removeEventListener("seeking", Ke), y.removeEventListener("seeked", Et), y.removeEventListener("timeupdate", lt), y.removeEventListener("progress", Rt), y.removeEventListener("ratechange", Pt), y.removeEventListener("loadedmetadata", $t), y.removeEventListener("loadeddata", Qt), y.removeEventListener("stalled", Xt), y.removeEventListener("ended", en), y.removeEventListener("volumechange", sn)), F = null, y = null, N = null, U = null;
            }
            function Q() {
              var be = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              return parseFloat((ue(be) - Ne()).toFixed(5));
            }
            function ue(be) {
              var Je = be || N;
              return Je.start + Je.duration;
            }
            function ee() {
              var be = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              N && y && y.getElement() ? (be && U && xe(Ne()), y.play()) : Z = !0;
            }
            function k() {
              N && y && y.pause();
            }
            function ne(be) {
              var Je = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Nt = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
              if (N && y && y.getElement()) {
                var yn = isNaN(le) ? y.getTime() : le;
                be !== yn && ((K = Nt === !0) || (le = be), r.info("Requesting seek to time: " + be + (K ? " (internal)" : "")), U && xt && xe(be), y.setCurrentTime(be, Je));
              }
            }
            function ve() {
              if (N && y && U) {
                var be = u && u.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Je = w.getCurrentDVRInfo(be);
                return Je && Je.range ? Je.range.end : 0;
              }
            }
            function xe(be) {
              var Je = new Date(C.getClientReferenceTime()), Nt = I.getRegularPeriods()[0], xt = C.calcPresentationTimeFromWallTime(Je, Nt);
              Y = xt - be;
            }
            function Ne() {
              return N && y ? y.getTime() : null;
            }
            function Fe() {
              return N && y ? y.isPaused() : null;
            }
            function Le() {
              return N && y ? y.isSeeking() : null;
            }
            function ut() {
              return N && y ? y.isStalled() : null;
            }
            function ct() {
              return N && y ? y.getPlaybackRate() : null;
            }
            function nt() {
              return N && y ? y.getEnded() : null;
            }
            function rt() {
              return U;
            }
            function Bt() {
              var be = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              if (!Fe() && U && y.getReadyState() !== 0 && !Le() && !g) {
                be || (be = u.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO);
                var Je = Ne(), Nt = we(Je, be), xt = !isNaN(Nt) && Nt !== Je;
                xt && !Le() && (ut() || de || y.getReadyState() === 1) && (r.debug("UpdateCurrentTime: Seek to actual time: ".concat(Nt, " from currentTime: ").concat(Je)), ne(Nt, !1, !1));
              }
            }
            function we(be, Je) {
              var Nt = w.getCurrentDVRInfo(Je), xt = Nt ? Nt.range : null;
              return xt ? be > xt.end ? Math.max(xt.end - Y, xt.start) : be > 0 && be + 0.25 < xt.start && Math.abs(be - xt.start) < 31536e4 ? q ? Math.max(xt.end - Y, xt.start) : xt.start : be : NaN;
            }
            function He() {
              F === null && (F = setInterval(function() {
                (function() {
                  if (A.trigger(l.Z.WALLCLOCK_TIME_UPDATED, { isDynamic: U, time: /* @__PURE__ */ new Date() }), rt()) {
                    var be = Date.now();
                    (isNaN(ae) || be > ae + D.get().streaming.liveUpdateTimeThresholdInMilliseconds) && (u.addDVRMetric(), Fe() ? function() {
                      var Je = Date.now();
                      (!me || Je > me + 500) && (me = Je, lt());
                    }() : Bt(), ae = be);
                  }
                })();
              }, D.get().streaming.wallclockTimeUpdateInterval));
            }
            function pt() {
              clearInterval(F), F = null;
            }
            function We(be) {
              var Je = I.convertRepresentationToRepresentationInfo(be.currentRepresentation), Nt = Je ? Je.mediaInfo.streamInfo : null;
              Nt !== null && N.id === Nt.id && (N = Nt);
            }
            function Tt() {
              A.trigger(l.Z.CAN_PLAY);
            }
            function vt() {
              A.trigger(l.Z.CAN_PLAY_THROUGH);
            }
            function ht(be) {
              be.streamId === u.getActiveStreamInfo().id && (de = be.state === m.Z.BUFFER_EMPTY, D.get().streaming.buffer.setStallState && y.setStallState(be.mediaType, be.state === m.Z.BUFFER_EMPTY));
            }
            function Wt() {
              r.info("Native video element event: play"), Bt(), He(), A.trigger(l.Z.PLAYBACK_STARTED, { startTime: Ne() });
            }
            function zt() {
              r.info("Native video element event: waiting"), A.trigger(l.Z.PLAYBACK_WAITING, { playingTime: Ne() });
            }
            function gn() {
              r.info("Native video element event: playing"), K = !1, A.trigger(l.Z.PLAYBACK_PLAYING, { playingTime: Ne() });
            }
            function pn() {
              r.info("Native video element event: pause"), A.trigger(l.Z.PLAYBACK_PAUSED, { ended: nt() });
            }
            function Ke() {
              if (!K) {
                var be = Ne();
                isNaN(le) || le === be || (be = le), le = NaN, r.info("Seeking to: " + be), He(), A.trigger(l.Z.PLAYBACK_SEEKING, { seekTime: be, streamId: N.id });
              }
            }
            function Et() {
              r.info("Native video element event: seeked"), K = !1, A.trigger(l.Z.PLAYBACK_SEEKED);
            }
            function lt() {
              N && A.trigger(l.Z.PLAYBACK_TIME_UPDATED, { timeToEnd: Q(), time: Ne(), streamId: N.id });
            }
            function Rt() {
              A.trigger(l.Z.PLAYBACK_PROGRESS, { streamId: N.id });
            }
            function Pt() {
              var be = ct();
              r.info("Native video element event: ratechange: ", be), A.trigger(l.Z.PLAYBACK_RATE_CHANGED, { playbackRate: be });
            }
            function $t() {
              r.info("Native video element event: loadedmetadata"), A.trigger(l.Z.PLAYBACK_METADATA_LOADED), He();
            }
            function Qt() {
              r.info("Native video element event: loadeddata"), A.trigger(l.Z.PLAYBACK_LOADED_DATA);
            }
            function en() {
              r.info("Native video element event: ended"), k(), pt();
              var be = u ? u.getActiveStreamInfo() : null;
              be && A.trigger(l.Z.PLAYBACK_ENDED, { isLast: be.isLast });
            }
            function sn() {
              A.trigger(l.Z.PLAYBACK_VOLUME_CHANGED);
            }
            function mt(be) {
              if (F && be.isLast) {
                r.info("onPlaybackEnded -- PLAYBACK_ENDED but native video element didn't fire ended");
                var Je = be.seekTime ? be.seekTime : ue();
                y.setCurrentTime(Je), k(), pt();
              }
            }
            function kt(be) {
              var Je = be.target || be.srcElement;
              A.trigger(l.Z.PLAYBACK_ERROR, { error: Je.error });
            }
            function qt() {
              U = !1;
            }
            function Vt(be) {
              if (be.stream === !1 && q && !isNaN(be.request.duration)) {
                var Je = 1.2 * be.request.duration;
                Je > Y && (r.warn("Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:", Je.toFixed(2)), Y = Je, H = Je);
              }
            }
            function Xt(be) {
              A.trigger(l.Z.PLAYBACK_STALLED, { e: be });
            }
            function ze(be) {
              var Je;
              (Je = be.mediaInfo) && Je.supplementalProperties && Je.supplementalProperties[t.Z.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME] && Je.supplementalProperties[t.Z.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME].value === "true" && (r.debug("Low Latency critical SupplementalProperty set: Enabling low Latency"), q = !0);
            }
            function Pe(be) {
              var Je = u.getActiveStreamInfo();
              be && Je && be.currentRepresentation && be.streamId && be.streamId === Je.id && be.mediaType && (be.mediaType === t.Z.VIDEO || be.mediaType === t.Z.AUDIO) && (_e = be.currentRepresentation.availabilityTimeComplete, (q = !_e) && !L && (L = !0));
            }
            function ft() {
              g = !0;
            }
            function pe() {
              g = !1;
            }
            return i = { initialize: function(be, Je) {
              N = be, Je !== !0 && (y.addEventListener("canplay", Tt), y.addEventListener("canplaythrough", vt), y.addEventListener("play", Wt), y.addEventListener("waiting", zt), y.addEventListener("playing", gn), y.addEventListener("pause", pn), y.addEventListener("error", kt), y.addEventListener("seeking", Ke), y.addEventListener("seeked", Et), y.addEventListener("timeupdate", lt), y.addEventListener("progress", Rt), y.addEventListener("ratechange", Pt), y.addEventListener("loadedmetadata", $t), y.addEventListener("loadeddata", Qt), y.addEventListener("stalled", Xt), y.addEventListener("ended", en), y.addEventListener("volumechange", sn), U = N.manifestInfo.isDynamic, de = !1, K = !1, A.on(l.Z.DATA_UPDATE_COMPLETED, We, i), A.on(l.Z.LOADING_PROGRESS, Vt, i), A.on(l.Z.MANIFEST_UPDATED, ft, i), A.on(l.Z.STREAMS_COMPOSED, pe, i), A.on(n.Z.PLAYBACK_ENDED, mt, i, { priority: p.Z.EVENT_PRIORITY_HIGH }), A.on(n.Z.STREAM_INITIALIZING, ze, i), A.on(n.Z.REPRESENTATION_SWITCH, Pe, i), A.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, ht, i), A.on(n.Z.DYNAMIC_TO_STATIC, qt, i), Z && (Z = !1, ee()));
            }, setConfig: function(be) {
              be && (be.streamController && (u = be.streamController), be.serviceDescriptionController && (_ = be.serviceDescriptionController), be.dashMetrics && (w = be.dashMetrics), be.adapter && (I = be.adapter), be.videoModel && (y = be.videoModel), be.timelineConverter && (C = be.timelineConverter), be.settings && (D = be.settings));
            }, getTimeToStreamEnd: Q, getBufferLevel: function() {
              var be = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Je = null;
              return u.getActiveStreamProcessors().forEach(function(Nt) {
                if (!be || be.length === 0 || be.indexOf(Nt.getType()) === -1) {
                  var xt = Nt.getBufferLevel();
                  Je = Je === null ? xt : Math.min(Je, xt);
                }
              }), Je;
            }, getPlaybackStalled: function() {
              return de;
            }, getTime: Ne, getLowLatencyModeEnabled: function() {
              return q;
            }, getInitialCatchupModeActivated: function() {
              return L;
            }, getIsManifestUpdateInProgress: function() {
              return g;
            }, getPlaybackRate: ct, getPlayedRanges: function() {
              return N && y ? y.getPlayedRanges() : null;
            }, getEnded: nt, getIsDynamic: rt, getStreamController: function() {
              return u;
            }, computeAndSetLiveDelay: function(be, Je) {
              var Nt, xt, yn, Ln = !isNaN(be) && isFinite(be) ? be : NaN, Qn = I.getSuggestedPresentationDelay(), Dn = _.getServiceDescriptionSettings();
              return Nt = isNaN(D.get().streaming.delay.liveDelay) ? D.get().streaming.delay.liveDelayFragmentCount === null || isNaN(D.get().streaming.delay.liveDelayFragmentCount) || isNaN(Ln) ? Dn && !isNaN(Dn.liveDelay) && Dn.liveDelay > 0 ? Dn.liveDelay : D.get().streaming.delay.useSuggestedPresentationDelay === !0 && Qn !== null && !isNaN(Qn) && Qn > 0 ? Qn : isNaN(Ln) ? Je && !isNaN(Je.minBufferTime) ? 4 * Je.minBufferTime : 4 * N.manifestInfo.minBufferTime : 4 * Ln : Ln * D.get().streaming.delay.liveDelayFragmentCount : D.get().streaming.delay.liveDelay, (yn = I.getAvailabilityStartTime()) !== null && (fe = yn), xt = Je && Je.dvrWindowSize > 0 ? Math.min(Nt, Je.dvrWindowSize) : Nt, Y = xt, H = xt, xt;
            }, getLiveDelay: function() {
              return Y;
            }, getOriginalLiveDelay: function() {
              return H;
            }, getCurrentLiveLatency: function() {
              if (!U || isNaN(fe)) return NaN;
              var be = Ne();
              if (isNaN(be) || be === 0) return 0;
              var Je = (/* @__PURE__ */ new Date()).getTime() + 1e3 * C.getClientTimeOffset();
              return Math.max(((Je - fe - 1e3 * be) / 1e3).toFixed(3), 0);
            }, play: ee, isPaused: Fe, isStalled: ut, pause: k, isSeeking: Le, getStreamEndTime: ue, seek: ne, seekToOriginalLive: function() {
              var be = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], Je = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Nt = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = ve();
              if (xt !== 0) {
                var yn = xt - (Y = H);
                ne(yn, be, Je, Nt);
              }
            }, seekToCurrentLive: function() {
              var be = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], Je = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Nt = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = ve();
              if (xt !== 0) {
                var yn = xt - Y;
                ne(yn, be, Je, Nt);
              }
            }, reset: oe, updateCurrentTime: Bt, getAvailabilityStartTime: function() {
              return fe;
            } }, r = (0, h.Z)(O).getInstance().getLogger(i), oe(), i;
          }
          f.__dashjs_factory_name = "PlaybackController";
          var d = v.Z.getSingletonFactory(f), S = R(3186), x = "loading", G = "executed", P = "failed";
          function J(i) {
            var r, u, _, w, I = (i = i || {}).eventBus, y = i.events, C = i.dashMetrics, F = i.fragmentLoader, Y = i.debug, H = i.streamInfo, N = i.type;
            function U(g) {
              var L;
              return !!g && (L = !1, _.some(function(D) {
                if (O = g, A = D, !isNaN(O.index) && O.startTime === A.startTime && O.adaptationIndex === A.adaptationIndex && O.type === A.type || function(oe, Q) {
                  return isNaN(oe.index) && isNaN(Q.index) && oe.quality === Q.quality;
                }(g, D) || function(oe, Q) {
                  return oe.action === S.Z.ACTION_COMPLETE && oe.action === Q.action;
                }(g, D)) return L = !0;
                var O, A;
              }), L);
            }
            function Z(g) {
              return isNaN(g.duration) ? 0.25 : Math.min(g.duration / 8, 0.5);
            }
            function me(g) {
              _ = _.filter(function(L) {
                var D = Z(L);
                return isNaN(L.startTime) || g !== void 0 && L.startTime >= g - D;
              });
            }
            function ae(g, L) {
              L <= g + 0.5 || (_ = _.filter(function(D) {
                var O = Z(D);
                return isNaN(D.startTime) || D.startTime >= L - O || isNaN(D.duration) || D.startTime + D.duration <= g + O;
              }));
            }
            function fe(g, L, D) {
              for (var O = g.length - 1; O >= 0; O--) {
                var A = g[O], oe = A.startTime, Q = oe + A.duration;
                if (D = isNaN(D) ? Z(A) : D, !isNaN(oe) && !isNaN(Q) && L + D >= oe && L - D < Q || isNaN(oe) && isNaN(L)) return A;
              }
              return null;
            }
            function _e(g, L) {
              C.addSchedulingInfo(g, L), C.addRequestsQueue(g.mediaType, w, _);
            }
            function q(g) {
              g.sender === F && (w.splice(w.indexOf(g.request), 1), g.response && !g.error && _.push(g.request), _e(g.request, g.error ? P : G), I.trigger(y.FRAGMENT_LOADING_COMPLETED, { request: g.request, response: g.response, error: g.error, sender: this }, { streamId: H.id, mediaType: N }));
            }
            function le(g) {
              g.sender === F && I.trigger(y.FRAGMENT_LOADING_PROGRESS, { request: g.request, response: g.response, error: g.error, sender: this }, { streamId: H.id, mediaType: N });
            }
            function K(g) {
              g.sender === F && I.trigger(y.FRAGMENT_LOADING_ABANDONED, { request: g.request }, { streamId: H.id, mediaType: N });
            }
            function de() {
              _ = [], w = [];
            }
            return r = { getStreamId: function() {
              return H.id;
            }, getType: function() {
              return N;
            }, getRequests: function(g) {
              var L = g ? g.state instanceof Array ? g.state : [g.state] : [], D = [];
              return L.forEach(function(O) {
                var A = function(oe) {
                  var Q;
                  switch (oe) {
                    case x:
                      Q = w;
                      break;
                    case G:
                      Q = _;
                      break;
                    default:
                      Q = [];
                  }
                  return Q;
                }(O);
                D = D.concat(function(oe, Q) {
                  return Q.hasOwnProperty("time") ? [fe(oe, Q.time, Q.threshold)] : oe.filter(function(ue) {
                    for (var ee in Q) if (ee !== "state" && Q.hasOwnProperty(ee) && ue[ee] != Q[ee]) return !1;
                    return !0;
                  });
                }(A, g));
              }), D;
            }, isFragmentLoaded: U, isFragmentLoadedOrPending: function(g) {
              var L, D = !1, O = 0;
              if (!(D = U(g))) for (O = 0; O < w.length; O++) L = w[O], g.url === L.url && g.startTime === L.startTime && (D = !0);
              return D;
            }, removeExecutedRequestsBeforeTime: me, removeExecutedRequestsAfterTime: function(g) {
              _ = _.filter(function(L) {
                return isNaN(L.startTime) || g !== void 0 && L.startTime < g;
              });
            }, syncExecutedRequestsWithBufferedRange: function(g, L) {
              if (g && g.length !== 0) {
                for (var D = 0, O = 0, A = g.length; O < A; O++) ae(D, g.start(O)), D = g.end(O);
                L > 0 && ae(D, L);
              } else me();
            }, abortRequests: function() {
              u.debug("abort requests"), F.abort(), w = [];
            }, executeRequest: function(g) {
              g.action === S.Z.ACTION_DOWNLOAD ? (_e(g, x), w.push(g), function(L) {
                I.trigger(y.FRAGMENT_LOADING_STARTED, { request: L }, { streamId: H.id, mediaType: N }), F.load(L);
              }(g)) : u.warn("Unknown request action.");
            }, reset: function() {
              I.off(y.LOADING_COMPLETED, q, this), I.off(y.LOADING_DATA_PROGRESS, le, this), I.off(y.LOADING_ABANDONED, K, this), F && F.reset(), de();
            }, resetInitialSettings: de, addExecutedRequest: function(g) {
              _.push(g);
            } }, u = Y.getLogger(r), de(), I.on(y.LOADING_COMPLETED, q, r), I.on(y.LOADING_DATA_PROGRESS, le, r), I.on(y.LOADING_ABANDONED, K, r), r;
          }
          J.__dashjs_factory_name = "FragmentModel";
          var M = v.Z.getClassFactory(J);
          M.FRAGMENT_MODEL_LOADING = x, M.FRAGMENT_MODEL_EXECUTED = G, M.FRAGMENT_MODEL_CANCELED = "canceled", M.FRAGMENT_MODEL_FAILED = P, v.Z.updateClassFactory(J.__dashjs_factory_name, M);
          var W = M, se = R(5459);
          function j(i) {
            return j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, j(i);
          }
          function re(i, r) {
            return re = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, re(i, r);
          }
          function ce(i, r) {
            return !r || j(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Re(i) {
            return Re = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Re(i);
          }
          var $ = new (function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && re(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Re(r);
              if (u) {
                var C = Re(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return ce(this, I);
            });
            function w() {
              var I;
              return function(y, C) {
                if (!(y instanceof C)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (I = _.call(this)).MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE = 10, I.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE = 11, I.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE = 12, I.SEGMENT_BASE_LOADER_ERROR_CODE = 15, I.TIME_SYNC_FAILED_ERROR_CODE = 16, I.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE = 17, I.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE = 18, I.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 19, I.APPEND_ERROR_CODE = 20, I.REMOVE_ERROR_CODE = 21, I.DATA_UPDATE_FAILED_ERROR_CODE = 22, I.CAPABILITY_MEDIASOURCE_ERROR_CODE = 23, I.CAPABILITY_MEDIAKEYS_ERROR_CODE = 24, I.DOWNLOAD_ERROR_ID_MANIFEST_CODE = 25, I.DOWNLOAD_ERROR_ID_SIDX_CODE = 26, I.DOWNLOAD_ERROR_ID_CONTENT_CODE = 27, I.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE = 28, I.DOWNLOAD_ERROR_ID_XLINK_CODE = 29, I.MANIFEST_ERROR_ID_PARSE_CODE = 31, I.MANIFEST_ERROR_ID_NOSTREAMS_CODE = 32, I.TIMED_TEXT_ERROR_ID_PARSE_CODE = 33, I.MANIFEST_ERROR_ID_MULTIPLEXED_CODE = 34, I.MEDIASOURCE_TYPE_UNSUPPORTED_CODE = 35, I.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE = "parsing failed for ", I.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading manifest: ", I.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading Xlink element: ", I.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE = "Segments update failed", I.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE = "no segments are available yet", I.SEGMENT_BASE_LOADER_ERROR_MESSAGE = "error loading segment ranges from sidx", I.TIME_SYNC_FAILED_ERROR_MESSAGE = "Failed to synchronize client and server time", I.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE = "request is null", I.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = "Failed to resolve a valid URL", I.APPEND_ERROR_MESSAGE = "chunk is not defined", I.REMOVE_ERROR_MESSAGE = "Removing data from the SourceBuffer", I.DATA_UPDATE_FAILED_ERROR_MESSAGE = "Data update failed", I.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE = "mediasource is not supported", I.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE = "mediakeys is not supported", I.TIMED_TEXT_ERROR_MESSAGE_PARSE = "parsing error :", I.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE = "Error creating source buffer of type : ", I;
            }
            return w;
          }(R(2230).Z))(), Me = R(1264), Ge = R(7855);
          function Qe(i) {
            var r, u, _, w, I, y, C = this.context, F = (0, Me.Z)(C).getInstance(), Y = i.textController, H = i.eventBus, N = [], U = [], Z = !1, me = i.mediaSource, ae = null;
            function fe(A) {
              return new Promise(function(oe) {
                O(function() {
                  w.changeType && w.changeType(A), oe();
                });
              });
            }
            function _e(A) {
              return w = Y.getTextSourceBuffer(A), Promise.resolve();
            }
            function q() {
              if (typeof w.addEventListener == "function") try {
                w.addEventListener("updateend", L, !1), w.addEventListener("error", D, !1), w.addEventListener("abort", D, !1);
              } catch {
                y = setInterval(L, 50);
              }
              else y = setInterval(L, 50);
            }
            function le(A) {
              return new Promise(function(oe) {
                w && F.get().streaming.buffer.useAppendWindow ? O(function() {
                  try {
                    if (!w) return void oe();
                    var Q = me.duration, ue = 0;
                    A && !isNaN(A.start) && !isNaN(A.duration) && isFinite(A.duration) && (Q = A.start + A.duration), A && !isNaN(A.start) && (ue = A.start), w.appendWindowEnd === Q && w.appendWindowStart === ue || (w.appendWindowStart = 0, w.appendWindowEnd = Q + 0.01, w.appendWindowStart = Math.max(ue - 0.1, 0), _.debug("Updated append window for ".concat(I.type, ". Set start to ").concat(w.appendWindowStart, " and end to ").concat(w.appendWindowEnd))), oe();
                  } catch {
                    _.warn("Failed to set append window"), oe();
                  }
                }) : oe();
              });
            }
            function K(A) {
              return new Promise(function(oe) {
                w ? O(function() {
                  try {
                    w.timestampOffset === A || isNaN(A) || (w.timestampOffset = A, _.debug("Set MSE timestamp offset to ".concat(A))), oe();
                  } catch {
                    oe();
                  }
                }) : oe();
              });
            }
            function de() {
              if (!Z && U.length > 0) {
                Z = !0;
                var A = U[0];
                U.splice(0, 1);
                var oe = function() {
                  Z = !1, U.length > 0 && de.call(this), A && A.data && A.data.segmentType && A.data.segmentType !== Ge.w.INIT_SEGMENT_TYPE && delete A.data.bytes, A.promise.resolve({ chunk: A.data });
                };
                try {
                  ae = A.request, A.data.bytes.byteLength === 0 ? oe.call(this) : (w.appendBuffer ? w.appendBuffer(A.data.bytes) : w.append(A.data.bytes, A.data), O(oe.bind(this)));
                } catch (Q) {
                  _.fatal('SourceBuffer append failed "' + Q + '"'), U.length > 0 ? de() : Z = !1, delete A.data.bytes, A.promise.reject({ chunk: A.data, error: new se.Z(Q.code, Q.message) });
                }
              }
            }
            function g() {
              N.length > 0 && (w.updating || (N.shift()(), g()));
            }
            function L() {
              w.updating || g();
            }
            function D(A) {
              var oe, Q, ue = A.target || {};
              oe = l.Z.SOURCE_BUFFER_ERROR, Q = { error: ue, lastRequestAppended: ae }, H.trigger(oe, Q, { streamId: I.streamInfo.id, mediaType: u });
            }
            function O(A) {
              N.push(A), w.updating || g();
            }
            return r = { getType: function() {
              return u;
            }, getAllBufferRanges: function() {
              try {
                return w.buffered;
              } catch (A) {
                return _.error("getAllBufferRanges exception: " + A.message), null;
              }
            }, getBuffer: function() {
              return w;
            }, append: function(A) {
              var oe = this, Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return new Promise(function(ue, ee) {
                A ? (U.push({ data: A, promise: { resolve: ue, reject: ee }, request: Q }), O(de.bind(oe))) : ee({ chunk: A, error: new se.Z($.APPEND_ERROR_CODE, $.APPEND_ERROR_MESSAGE) });
              });
            }, remove: function(A) {
              return new Promise(function(oe, Q) {
                var ue = A.start, ee = A.end;
                ue >= 0 && ee > ue ? O(function() {
                  try {
                    w.remove(ue, ee), O(function() {
                      oe({ from: ue, to: ee, unintended: !1 }), A.resolve && A.resolve();
                    });
                  } catch (k) {
                    Q({ from: ue, to: ee, unintended: !1, error: new se.Z($.REMOVE_ERROR_CODE, $.REMOVE_ERROR_MESSAGE) }), A.reject && A.reject(k);
                  }
                }) : oe();
              });
            }, abort: function() {
              return new Promise(function(A) {
                try {
                  U = [], me.readyState === "open" ? O(function() {
                    try {
                      w && w.abort(), A();
                    } catch {
                      A();
                    }
                  }) : (w && w.setTextTrack && me.readyState === "ended" && w.abort(), A());
                } catch {
                  A();
                }
              });
            }, reset: function() {
              if (w) {
                try {
                  N = [], function() {
                    try {
                      typeof w.removeEventListener == "function" && (w.removeEventListener("updateend", L, !1), w.removeEventListener("error", D, !1), w.removeEventListener("abort", D, !1)), clearInterval(y);
                    } catch (A) {
                      _.error(A);
                    }
                  }(), Z = !1, U = [], w.getClassName && w.getClassName() === "TextSourceBuffer" || (_.debug("Removing sourcebuffer from media source"), me.removeSourceBuffer(w));
                } catch {
                }
                w = null;
              }
              ae = null;
            }, updateTimestampOffset: K, initializeForStreamSwitch: function(A, oe, Q) {
              u = (I = A).type;
              var ue = I.codec;
              (function(k) {
                w = k.getBuffer();
              })(Q), q();
              var ee = [];
              return ee.push(new Promise(function(k) {
                O(function() {
                  var ne = w.appendWindowStart, ve = w.appendWindowEnd;
                  w && (w.abort(), w.appendWindowStart = ne, w.appendWindowEnd = ve), k();
                });
              })), ee.push(le(I.streamInfo)), F.get().streaming.buffer.useChangeTypeForTrackSwitch && ee.push(fe(ue)), oe && oe.MSETimeOffset !== void 0 && ee.push(K(oe.MSETimeOffset)), Promise.all(ee);
            }, initializeForFirstUse: function(A, oe, Q) {
              u = (I = oe).type;
              var ue = I.codec;
              try {
                if (ue.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i)) return _e(A);
                w = me.addSourceBuffer(ue), q();
                var ee = [];
                return ee.push(le(I.streamInfo)), Q && Q.MSETimeOffset !== void 0 && ee.push(K(Q.MSETimeOffset)), Promise.all(ee);
              } catch (k) {
                return I.type == t.Z.TEXT && !I.isFragmented || ue.indexOf('codecs="stpp') !== -1 || ue.indexOf('codecs="vtt') !== -1 || ue.indexOf("text/vtt") !== -1 ? _e(A) : Promise.reject(k);
              }
            }, updateAppendWindow: le, changeType: fe }, _ = (0, h.Z)(C).getInstance().getLogger(r), r;
          }
          Qe.__dashjs_factory_name = "SourceBufferSink";
          var Ae = v.Z.getClassFactory(Qe);
          function Ze(i) {
            var r, u, _, w = this.context, I = [], y = i;
            function C(F, Y) {
              return I = I.filter(function(H) {
                return !((isNaN(Y) || H.start < Y) && (isNaN(F) || H.end > F));
              }), Promise.resolve();
            }
            return r = { getAllBufferRanges: function() {
              for (var F = [], Y = 0; Y < I.length; Y++) {
                var H = I[Y];
                F.length === 0 || H.start > F[F.length - 1].end ? F.push({ start: H.start, end: H.end }) : F[F.length - 1].end = H.end;
              }
              var N = { start: function(U) {
                return F[U].start;
              }, end: function(U) {
                return F[U].end;
              } };
              return Object.defineProperty(N, "length", { get: function() {
                return F.length;
              } }), N;
            }, append: function(F) {
              return F.segmentType !== "InitializationSegment" ? (I.push(F), I.sort(function(Y, H) {
                return Y.start - H.start;
              }), _ = null) : _ = F, u.debug("PreBufferSink appended chunk s: " + F.start + "; e: " + F.end), y && y({ chunk: F }), Promise.resolve();
            }, remove: C, abort: function() {
              return Promise.resolve();
            }, discharge: function(F, Y) {
              var H = function(N, U) {
                return I.filter(function(Z) {
                  return (isNaN(U) || Z.start < U) && (isNaN(N) || Z.end > N);
                });
              }(F, Y);
              return _ && (H.push(_), _ = null), C(F, Y), H;
            }, reset: function() {
              I = [], _ = null, y = null;
            }, updateTimestampOffset: function() {
              return Promise.resolve();
            }, waitForUpdateEnd: function(F) {
              F();
            }, getBuffer: function() {
              return this;
            } }, u = (0, h.Z)(w).getInstance().getLogger(r), r;
          }
          Ze.__dashjs_factory_name = "PreBufferSink";
          var Xe = v.Z.getClassFactory(Ze);
          function at() {
            var i = {};
            return { save: function(r) {
              var u = r.streamId, _ = r.representationId;
              i[u] = i[u] || {}, i[u][_] = r;
            }, extract: function(r, u) {
              return i && i[r] && i[r][u] ? i[r][u] : null;
            }, reset: function() {
              i = {};
            } };
          }
          at.__dashjs_factory_name = "InitCache";
          var Ie = v.Z.getSingletonFactory(at), Be = 0.01, It = "BufferController";
          function _t(i) {
            i = i || {};
            var r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q, le, K, de, g = this.context, L = (0, p.Z)(g).getInstance(), D = i.errHandler, O = i.fragmentModel, A = i.representationController, oe = i.adapter, Q = i.textController, ue = i.abrController, ee = i.playbackController, k = i.streamInfo, ne = i.type, ve = i.settings;
            function xe(Pe) {
              var ft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return new Promise(function(pe, be) {
                y = Pe, Y && ft && typeof Y.discharge == "function" ? (H = Y, Fe(ft).then(function() {
                  pe();
                }).catch(function(Je) {
                  be(Je);
                })) : pe();
              });
            }
            function Ne(Pe) {
              return oe.convertRepresentationToRepresentationInfo(A.getRepresentationForQuality(Pe));
            }
            function Fe(Pe) {
              var ft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
              return new Promise(function(pe, be) {
                q && Pe ? y ? (N = !1, ut(Pe, ft).then(function(Je) {
                  pe(Je);
                }).catch(function(Je) {
                  be(Je);
                })) : (N = !0, Le().then(function(Je) {
                  pe(Je);
                }).catch(function(Je) {
                  be(Je);
                })) : pe(null);
              });
            }
            function Le() {
              var Pe = this;
              return new Promise(function(ft, pe) {
                var be = ue.getQualityFor(ne, k.id);
                Y = Xe(g).create(we.bind(Pe)), $t(Ne(be)).then(function() {
                  ft(Y);
                }).catch(function() {
                  pe();
                });
              });
            }
            function ut(Pe, ft) {
              return new Promise(function(pe, be) {
                var Je = ue.getQualityFor(ne, k.id);
                Y = Ae(g).create({ mediaSource: y, textController: Q, eventBus: L }), function(Nt, xt, yn) {
                  var Ln = Ne(yn);
                  return xt && xt[ne] && (ne === t.Z.VIDEO || ne === t.Z.AUDIO) ? Y.initializeForStreamSwitch(Nt, Ln, xt[ne]) : Y.initializeForFirstUse(k, Nt, Ln);
                }(Pe, ft, Je).then(function() {
                  return $t(Ne(Je));
                }).then(function() {
                  pe(Y);
                }).catch(function(Nt) {
                  u.fatal("Caught error on create SourceBuffer: " + Nt), D.error(new se.Z($.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, $.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + ne)), be(Nt);
                });
              });
            }
            function ct(Pe) {
              ve.get().streaming.cacheInitSegments && (u.info("Init fragment finished loading saving to", ne + "'s init cache"), q.save(Pe.chunk)), u.debug("Append Init fragment", ne, " with representationId:", Pe.chunk.representationId, " and quality:", Pe.chunk.quality, ", data size:", Pe.chunk.bytes.byteLength), rt(Pe.chunk);
            }
            function nt(Pe) {
              rt(Pe.chunk, Pe.request);
            }
            function rt(Pe) {
              var ft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              Y && (Y.append(Pe, ft).then(function(pe) {
                we(pe);
              }).catch(function(pe) {
                we(pe);
              }), Pe.mediaInfo.type === t.Z.VIDEO && Xt(l.Z.VIDEO_CHUNK_RECEIVED, { chunk: Pe }));
            }
            function Bt(Pe) {
              if (Pe && Pe.length > 0) for (var ft = 0, pe = Pe.length; ft < pe; ft++) u.debug("Buffered range: " + Pe.start(ft) + " - " + Pe.end(ft) + ", currentTime = ", ee.getTime());
            }
            function we(Pe) {
              if (Pe.error) return Pe.error.code === 22 && function() {
                if (_e = !0, I = 0.8 * kt(), u.warn("Quota exceeded, Critical Buffer: " + I), I > 0) {
                  var be = Math.max(0.2 * I, 1), Je = I - be, Nt = Math.min(ve.get().streaming.buffer.bufferTimeAtTopQuality, 0.9 * Je), xt = Math.min(ve.get().streaming.buffer.bufferTimeAtTopQualityLongForm, 0.9 * Je), yn = { streaming: { buffer: { bufferToKeep: parseFloat(be.toFixed(5)), bufferTimeAtTopQuality: parseFloat(Nt.toFixed(5)), bufferTimeAtTopQualityLongForm: parseFloat(xt.toFixed(5)) } } };
                  ve.update(yn);
                }
              }(), void (Pe.error.code !== 22 && Vt() || (u.warn("Clearing playback buffer to overcome quota exceed situation"), Xt(l.Z.QUOTA_EXCEEDED, { criticalBufferLevel: I, quotaExceededTime: Pe.chunk.start }), lt(Et())));
              if (Y && (Wt(), _e = !1, (me = Pe.chunk) && me.endFragment)) {
                me && !isNaN(me.index) && (C = Math.max(me.index, C), zt());
                var ft = Y.getAllBufferRanges();
                me.segmentType === Ge.w.MEDIA_SEGMENT_TYPE && (Bt(ft), We(), function() {
                  if (!isNaN(de) && !N) if (ne === t.Z.AUDIO || ne === t.Z.VIDEO) {
                    var be = ee.getTime(), Je = ht(be, 0), Nt = ht(de, 0);
                    if (Je && Nt && Je.start === Nt.start) de = NaN;
                    else {
                      var xt = A.getCurrentRepresentation().segmentDuration, yn = ht(de, xt);
                      yn && (ve.get().streaming.buffer.enableSeekDecorrelationFix && Math.abs(be - de) > xt ? de <= yn.end && ee.seek(Math.max(de, yn.start), !1, !0) : be < yn.start && ee.seek(yn.start, !1, !0));
                    }
                  } else de = NaN;
                }());
                var pe = !1;
                U && (U.indexOf(me) > 0 && (pe = !0), U = null), me && !pe && Xt(l.Z.BYTES_APPENDED_END_FRAGMENT, { quality: me.quality, startTime: me.start, index: me.index, bufferedRanges: ft, segmentType: me.segmentType, mediaType: ne });
              }
            }
            function He() {
              return new Promise(function(Pe, ft) {
                var pe = pt();
                if (!pe || pe.length === 0) return We(), void Pe();
                lt(pe).then(function() {
                  Pe();
                }).catch(function(be) {
                  ft(be);
                });
              });
            }
            function pt(Pe) {
              var ft = [], pe = Y.getAllBufferRanges();
              if (!pe || pe.length === 0) return ft;
              if (!Pe && Pe !== 0 || isNaN(Pe)) ft.push({ start: pe.start(0), end: pe.end(pe.length - 1) + 0.5 });
              else {
                var be = function(Nt, xt) {
                  var yn = ve.get().streaming.buffer.bufferToKeep, Ln = xt.start(0);
                  if (Nt - Ln > yn) {
                    var Qn = Math.max(0, Nt - yn), Dn = O.getRequests({ state: W.FRAGMENT_MODEL_EXECUTED, time: Nt, threshold: Be })[0];
                    if (Dn && (Qn = Math.min(Dn.startTime, Qn)), Qn > 0) return { start: Ln, end: Qn };
                  }
                  return null;
                }(Pe, pe), Je = function(Nt, xt) {
                  var yn = xt.end(xt.length - 1) + 0.5, Ln = qt(Nt), Qn = k.manifestInfo.duration >= ve.get().streaming.buffer.longFormContentDurationThreshold ? ve.get().streaming.buffer.bufferTimeAtTopQualityLongForm : ve.get().streaming.buffer.bufferTimeAtTopQuality, Dn = isNaN(Ln) ? Nt : Math.min(Ln, Nt + Qn);
                  if (Dn >= xt.end(xt.length - 1)) return null;
                  var mr = O.getRequests({ state: W.FRAGMENT_MODEL_EXECUTED, time: Nt, threshold: Be })[0];
                  if (mr && (Dn = Math.max(mr.startTime + mr.duration, Dn)), ve.get().streaming.buffer.avoidCurrentTimeRangePruning) {
                    for (var er = 0; er < xt.length; er++) if (xt.start(er) <= Nt && Nt <= xt.end(er) && xt.start(er) <= Dn && Dn <= xt.end(er)) {
                      var jr = Dn;
                      Dn = er + 1 < xt.length ? xt.start(er + 1) : xt.end(er) + 1, u.debug("Buffered range [" + xt.start(er) + ", " + xt.end(er) + "] overlaps with targetTime " + Nt + " and range to be pruned [" + jr + ", " + yn + "], using [" + Dn + ", " + yn + "] instead" + (Dn < yn ? "" : " (no actual pruning)"));
                      break;
                    }
                  }
                  return Dn < xt.end(xt.length - 1) ? { start: Dn, end: yn } : null;
                }(Pe, pe);
                be && ft.push(be), Je && ft.push(Je);
              }
              return ft;
            }
            function We() {
              (!K || ne === t.Z.TEXT && Q.isTextEnabled()) && Wt();
            }
            function Tt() {
              gn();
            }
            function vt() {
              gn(), de = NaN;
            }
            function ht(Pe, ft) {
              if (!Y) return null;
              var pe, be, Je = Y.getAllBufferRanges(), Nt = 0, xt = 0, yn = null, Ln = null, Qn = 0, Dn = isNaN(ft) ? 0.15 : ft;
              if (Je != null) {
                for (be = 0, pe = Je.length; be < pe; be++) if (Nt = Je.start(be), xt = Je.end(be), yn === null) Qn = Math.abs(Nt - Pe), (Pe >= Nt && Pe < xt || Qn <= Dn) && (yn = Nt, Ln = xt);
                else {
                  if (!((Qn = Nt - Ln) <= Dn)) break;
                  Ln = xt;
                }
                if (yn !== null) return { start: yn, end: Ln };
              }
              return null;
            }
            function Wt() {
              if (ee) {
                var Pe = ee.getTime() || 0;
                N && (Pe = isNaN(de) ? 0 : de);
                var ft = ve.get().streaming.gaps.jumpGaps && !isNaN(ve.get().streaming.gaps.smallGapLimit) ? ve.get().streaming.gaps.smallGapLimit : NaN;
                w = Math.max(function(pe, be) {
                  var Je;
                  return ve.get().streaming.gaps.jumpGaps && (be = ve.get().streaming.gaps.smallGapLimit), (Je = ht(pe, be)) === null ? 0 : Je.end - pe;
                }(Pe, ft), 0), Xt(l.Z.BUFFER_LEVEL_UPDATED, { mediaType: ne, bufferLevel: w }), gn();
              }
            }
            function zt() {
              var Pe = C >= F - 1, ft = ee.getTimeToStreamEnd(k) - w < 1e-5;
              !Pe && !ft || _ || (mt(!0), u.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(k.id, " and type ").concat(ne)));
            }
            function gn() {
              ne !== t.Z.AUDIO && ne !== t.Z.VIDEO || ((!ee.getLowLatencyModeEnabled() && w < ve.get().streaming.buffer.stallThreshold || w === 0) && !_ ? pn(m.Z.BUFFER_EMPTY) : (_ || w >= ve.get().streaming.buffer.stallThreshold || ee.getLowLatencyModeEnabled() && w > 0) && pn(m.Z.BUFFER_LOADED));
            }
            function pn(Pe) {
              Z === Pe || Pe === m.Z.BUFFER_EMPTY && ee.getTime() === 0 || ne === t.Z.TEXT && !Q.isTextEnabled() || (Z = Pe, Xt(l.Z.BUFFER_LEVEL_STATE_CHANGED, { state: Pe }), Xt(Pe === m.Z.BUFFER_LOADED ? l.Z.BUFFER_LOADED : l.Z.BUFFER_EMPTY), u.debug(Pe === m.Z.BUFFER_LOADED ? "Got enough buffer to start" : "Waiting for more buffer before starting playback"));
            }
            function Ke() {
              Y && ne !== t.Z.TEXT && (_ || lt(Et()));
            }
            function Et() {
              var Pe = [], ft = Y.getAllBufferRanges();
              if (!ft || ft.length === 0) return Pe;
              var pe = ee.getTime(), be = Math.max(0, pe - ve.get().streaming.buffer.bufferToKeep), Je = O.getRequests({ state: W.FRAGMENT_MODEL_EXECUTED, time: pe, threshold: Be })[0];
              if (Je) be = Math.min(Je.startTime, be);
              else if (pe === 0 && ee.getIsDynamic()) return [];
              if (ft.start(0) <= be) {
                for (var Nt = { start: 0, end: be }, xt = 0; xt < ft.length && ft.end(xt) <= be; xt++) Nt.end = ft.end(xt);
                Nt.start < Nt.end && Pe.push(Nt);
              }
              return Pe;
            }
            function lt(Pe) {
              return new Promise(function(ft, pe) {
                if (Pe && Y && Pe.length !== 0) {
                  var be = [];
                  Pe.forEach(function(Je) {
                    be.push(function(Nt) {
                      return new Promise(function(xt, yn) {
                        Nt.resolve = xt, Nt.reject = yn, le.push(Nt);
                      });
                    }(Je));
                  }), fe || Rt(), Promise.all(be).then(function() {
                    ft();
                  }).catch(function(Je) {
                    pe(Je);
                  });
                } else ft();
              });
            }
            function Rt() {
              try {
                if (le.length === 0 || !Y) return u.debug("Nothing to prune, halt pruning"), le = [], void (fe = !1);
                var Pe = Y.getBuffer();
                if (!Pe || !Pe.buffered || Pe.buffered.length === 0) return u.debug("SourceBuffer is empty (or does not exist), halt pruning"), le = [], void (fe = !1);
                var ft = le.shift();
                u.debug("".concat(ne, ": Removing buffer from: ").concat(ft.start, " to ").concat(ft.end)), fe = !0, ee.getTime() < ft.end && mt(!1), Y.remove(ft).then(function(pe) {
                  Pt(pe);
                }).catch(function(pe) {
                  Pt(pe);
                });
              } catch {
                fe = !1;
              }
            }
            function Pt(Pe) {
              u.debug("onRemoved buffer from:", Pe.from, "to", Pe.to), Y && (Bt(Y.getAllBufferRanges()), le.length === 0 && (fe = !1, Wt()), Pe.unintended && (u.warn("Detected unintended removal from:", Pe.from, "to", Pe.to, "setting streamprocessor time to", Pe.from), Xt(l.Z.SEEK_TARGET, { time: Pe.from })), fe ? Rt() : (K ? K = !1 : Wt(), Xt(l.Z.BUFFER_CLEARED, { from: Pe.from, to: Pe.to, unintended: Pe.unintended, hasEnoughSpaceToAppend: Vt(), quotaExceeded: _e })));
            }
            function $t(Pe) {
              return new Promise(function(ft) {
                Pe && Pe.MSETimeOffset !== void 0 && Y && Y.updateTimestampOffset ? Y.updateTimestampOffset(Pe.MSETimeOffset).then(function() {
                  ft();
                }).catch(function() {
                  ft();
                }) : ft();
              });
            }
            function Qt() {
              return Y && !_ ? Y.updateAppendWindow(k) : Promise.resolve();
            }
            function en() {
              ++ae * (ve.get().streaming.wallclockTimeUpdateInterval / 1e3) >= ve.get().streaming.buffer.bufferPruningInterval && (ae = 0, Ke());
            }
            function sn() {
              gn();
            }
            function mt(Pe) {
              (_ = Pe) ? Xt(l.Z.BUFFERING_COMPLETED) : F = Number.POSITIVE_INFINITY;
            }
            function kt() {
              try {
                var Pe, ft, pe = Y.getAllBufferRanges(), be = 0;
                if (!pe) return be;
                for (ft = 0, Pe = pe.length; ft < Pe; ft++) be += pe.end(ft) - pe.start(ft);
                return be;
              } catch {
                return 0;
              }
            }
            function qt(Pe) {
              try {
                var ft = Pe, pe = Y.getAllBufferRanges();
                if (!pe || pe.length === 0) return NaN;
                for (var be = 0; ft === Pe && be < pe.length; ) {
                  var Je = pe.start(be), Nt = pe.end(be);
                  ft >= Je && ft <= Nt && (ft = Nt), be += 1;
                }
                return ft === Pe ? NaN : ft;
              } catch {
              }
            }
            function Vt() {
              var Pe = kt();
              return isNaN(Pe) || Pe < I;
            }
            function Xt(Pe, ft) {
              var pe = ft || {};
              L.trigger(Pe, pe, { streamId: k.id, mediaType: ne });
            }
            function ze(Pe, ft) {
              if (I = Number.POSITIVE_INFINITY, Z = void 0, F = Number.POSITIVE_INFINITY, C = 0, me = null, _ = !1, fe = !1, _e = !1, w = 0, ae = 0, le = [], de = NaN, N = !1, Y) {
                var pe = Y;
                Y = null, Pe || ft || pe.abort().then(function() {
                  pe.reset(ft), pe = null;
                });
              }
              K = !1;
            }
            return r = { initialize: function(Pe) {
              xe(Pe), L.on(l.Z.INIT_FRAGMENT_LOADED, ct, r), L.on(l.Z.MEDIA_FRAGMENT_LOADED, nt, r), L.on(l.Z.WALLCLOCK_TIME_UPDATED, en, r), L.on(n.Z.PLAYBACK_PLAYING, vt, r), L.on(n.Z.PLAYBACK_PROGRESS, We, r), L.on(n.Z.PLAYBACK_TIME_UPDATED, We, r), L.on(n.Z.PLAYBACK_RATE_CHANGED, sn, r), L.on(n.Z.PLAYBACK_STALLED, Tt, r);
            }, getStreamId: function() {
              return k.id;
            }, getType: function() {
              return ne;
            }, getBufferControllerType: function() {
              return It;
            }, createBufferSink: Fe, dischargePreBuffer: function() {
              if (Y && H && typeof H.discharge == "function") {
                var Pe = H.getAllBufferRanges();
                if (Pe.length > 0) {
                  for (var ft = "Beginning " + ne + "PreBuffer discharge, adding buffer for:", pe = 0; pe < Pe.length; pe++) ft += " start: " + Pe.start(pe) + ", end: " + Pe.end(pe) + ";";
                  u.debug(ft);
                } else u.debug("PreBuffer discharge requested, but there were no media segments in the PreBuffer.");
                U = [];
                for (var be = H.discharge(), Je = null, Nt = 0; Nt < be.length; Nt++) {
                  var xt = be[Nt];
                  if (xt.segmentType !== Ge.w.INIT_SEGMENT_TYPE) {
                    var yn = q.extract(xt.streamId, xt.representationId);
                    yn && Je !== yn && (U.push(yn), Y.append(yn), Je = yn);
                  }
                  U.push(xt), Y.append(xt);
                }
                H.reset(), H = null;
              }
            }, getBuffer: function() {
              return Y;
            }, getBufferLevel: function() {
              return w;
            }, getRangeAt: ht, hasBufferAtTime: function(Pe) {
              try {
                var ft = Y.getAllBufferRanges();
                if (!ft || ft.length === 0) return !1;
                for (var pe = 0; pe < ft.length; ) {
                  var be = ft.start(pe), Je = ft.end(pe);
                  if (Pe >= be && Pe <= Je) return !0;
                  pe += 1;
                }
                return !1;
              } catch (Nt) {
                return u.error(Nt), !1;
              }
            }, pruneBuffer: Ke, setMediaSource: xe, getMediaSource: function() {
              return y;
            }, appendInitSegmentFromCache: function(Pe) {
              var ft = q.extract(k.id, Pe);
              return !!ft && (u.info("Append Init fragment", ne, " with representationId:", ft.representationId, " and quality:", ft.quality, ", data size:", ft.bytes.byteLength), rt(ft), !0);
            }, getIsBufferingCompleted: function() {
              return _;
            }, setIsBufferingCompleted: mt, getIsPruningInProgress: function() {
              return fe;
            }, reset: function(Pe, ft) {
              L.off(l.Z.INIT_FRAGMENT_LOADED, ct, this), L.off(l.Z.MEDIA_FRAGMENT_LOADED, nt, this), L.off(l.Z.WALLCLOCK_TIME_UPDATED, en, this), L.off(n.Z.PLAYBACK_PLAYING, vt, this), L.off(n.Z.PLAYBACK_PROGRESS, We, this), L.off(n.Z.PLAYBACK_TIME_UPDATED, We, this), L.off(n.Z.PLAYBACK_RATE_CHANGED, sn, this), L.off(n.Z.PLAYBACK_STALLED, Tt, this), ze(Pe, ft);
            }, prepareForPlaybackSeek: function() {
              return _ && mt(!1), Y.abort();
            }, prepareForReplacementTrackSwitch: function(Pe) {
              return new Promise(function(ft, pe) {
                Y.abort().then(function() {
                  return Qt();
                }).then(function() {
                  return ve.get().streaming.buffer.useChangeTypeForTrackSwitch ? Y.changeType(Pe) : Promise.resolve();
                }).then(function() {
                  return He();
                }).then(function() {
                  mt(!1), ft();
                }).catch(function(be) {
                  pe(be);
                });
              });
            }, prepareForNonReplacementTrackSwitch: function(Pe) {
              return new Promise(function(ft, pe) {
                Qt().then(function() {
                  return ve.get().streaming.buffer.useChangeTypeForTrackSwitch ? Y.changeType(Pe) : Promise.resolve();
                }).then(function() {
                  ft();
                }).catch(function(be) {
                  pe(be);
                });
              });
            }, prepareForForceReplacementQualitySwitch: function(Pe) {
              return new Promise(function(ft, pe) {
                Y.abort().then(function() {
                  return Qt();
                }).then(function() {
                  return He();
                }).then(function() {
                  return $t(Pe);
                }).then(function() {
                  mt(!1), ft();
                }).catch(function(be) {
                  pe(be);
                });
              });
            }, updateAppendWindow: Qt, getAllRangesWithSafetyFactor: pt, getContinuousBufferTimeForTargetTime: qt, clearBuffers: lt, pruneAllSafely: He, updateBufferTimestampOffset: $t, setSeekTarget: function(Pe) {
              de = Pe;
            }, segmentRequestingCompleted: function(Pe) {
              isNaN(Pe) || (F = Pe, zt());
            } }, u = (0, h.Z)(g).getInstance().getLogger(r), q = Ie(g).getInstance(), ze(), r;
          }
          _t.__dashjs_factory_name = It;
          var Ve = v.Z.getClassFactory(_t), ot = "NotFragmentedTextBufferController";
          function Ee(i) {
            i = i || {};
            var r, u, _, w, I, y, C = this.context, F = (0, p.Z)(C).getInstance(), Y = i.textController, H = i.errHandler, N = i.streamInfo, U = i.type;
            function Z(fe) {
              w = fe;
            }
            function me(fe) {
              var _e, q;
              u !== fe && (u = fe) && (_e = l.Z.BUFFERING_COMPLETED, q = {}, F.trigger(_e, q, { streamId: N.id, mediaType: U }));
            }
            function ae(fe) {
              fe.chunk.bytes && !u && (y.save(fe.chunk), I.append(fe.chunk), me(!0));
            }
            return r = { initialize: function(fe) {
              Z(fe);
            }, getStreamId: function() {
              return N.id;
            }, getType: function() {
              return U;
            }, getBufferControllerType: function() {
              return ot;
            }, createBufferSink: function(fe) {
              return new Promise(function(_e, q) {
                try {
                  (I = Ae(C).create({ mediaSource: w, textController: Y, eventBus: F })).initializeForFirstUse(N, fe), _ || (I.getBuffer() && typeof I.getBuffer().initialize == "function" && I.getBuffer().initialize(), _ = !0), _e(I);
                } catch (le) {
                  H.error(new se.Z($.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, $.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + U)), q(le);
                }
              });
            }, dischargePreBuffer: function() {
            }, getBuffer: function() {
              return I;
            }, getBufferLevel: function() {
              return 0;
            }, getRangeAt: function() {
              return null;
            }, pruneBuffer: function() {
            }, hasBufferAtTime: function() {
              return !0;
            }, getAllRangesWithSafetyFactor: function() {
              return [];
            }, getContinuousBufferTimeForTargetTime: function() {
              return Number.POSITIVE_INFINITY;
            }, setMediaSource: Z, getMediaSource: function() {
              return w;
            }, appendInitSegmentFromCache: function(fe) {
              return y.extract(N.id, fe) !== null;
            }, getIsBufferingCompleted: function() {
              return u;
            }, setIsBufferingCompleted: me, getIsPruningInProgress: function() {
              return !1;
            }, reset: function(fe) {
              F.off(l.Z.INIT_FRAGMENT_LOADED, ae, r), !fe && I && (I.abort(), I.reset(), I = null);
            }, clearBuffers: function() {
              return Promise.resolve();
            }, prepareForPlaybackSeek: function() {
              return Promise.resolve();
            }, prepareForReplacementTrackSwitch: function() {
              return u = !1, Promise.resolve();
            }, setSeekTarget: function() {
            }, updateAppendWindow: function() {
              return Promise.resolve();
            }, pruneAllSafely: function() {
              return Promise.resolve();
            }, updateBufferTimestampOffset: function() {
              return Promise.resolve();
            }, segmentRequestingCompleted: function() {
            } }, _ = !1, w = null, u = !1, y = Ie(C).getInstance(), F.on(l.Z.INIT_FRAGMENT_LOADED, ae, r), r;
          }
          Ee.__dashjs_factory_name = ot;
          var Te = v.Z.getClassFactory(Ee);
          function je(i) {
            i = i || {};
            var r, u, _, w, I, y, C, F, Y, H, N, U, Z, me = this.context, ae = (0, p.Z)(me).getInstance(), fe = i.dashMetrics, _e = i.mediaPlayerModel, q = i.fragmentModel, le = i.abrController, K = i.playbackController, de = i.textController, g = i.type, L = i.bufferController, D = i.representationController, O = i.settings;
            function A() {
              U = !0;
            }
            function oe() {
              U = !1;
            }
            function Q(ut) {
              if (!L.getIsBufferingCompleted()) {
                ue();
                var ct = isNaN(ut) ? 0 : ut;
                I = setTimeout(ee, ct);
              }
            }
            function ue() {
              I && (clearTimeout(I), I = null);
            }
            function ee() {
              try {
                if (function() {
                  try {
                    return g === t.Z.TEXT && !de.isTextEnabled() || K.isPaused() && (!K.getStreamController().getInitialPlayback() || !K.getStreamController().getAutoPlay()) && !O.get().streaming.scheduling.scheduleWhilePaused;
                  } catch {
                    return !1;
                  }
                }()) return void ue();
                if (function() {
                  try {
                    return !!U && D.getCurrentRepresentationInfo() && (isNaN(Y) || H || (nt = u.id, rt = le.getMaxAllowedIndexFor(g, nt), !(!isNaN(F) && F == rt || (_.info("Top quality " + g + " index has changed from " + F + " to " + rt), F = rt, 0))) || function() {
                      var Bt = D.getCurrentRepresentationInfo();
                      return !g || !Bt || fe.getCurrentBufferLevel(g) < k();
                    }());
                  } catch {
                    return !1;
                  }
                  var nt, rt;
                }()) {
                  var ut = !1;
                  Z && (ut = le.checkPlaybackQuality(g, u.id)), ut || (ct = D.getCurrentRepresentationInfo(), N || ct.quality !== Y || H ? (H ? (_.debug("Switch track for " + g + ", representation id = " + ct.id), H = !1) : _.debug("Quality has changed, get init request for representationid = " + ct.id), ae.trigger(l.Z.INIT_FRAGMENT_NEEDED, { representationId: ct.id, sender: r }, { streamId: u.id, mediaType: g }), Z = !1, N = !1) : (_.debug("Media segment needed for ".concat(g, " and stream id ").concat(u.id)), ae.trigger(l.Z.MEDIA_FRAGMENT_NEEDED, {}, { streamId: u.id, mediaType: g }), Z = !0));
                } else Q(K.getLowLatencyModeEnabled() ? O.get().streaming.scheduling.lowLatencyTimeout : O.get().streaming.scheduling.defaultTimeout);
              } catch {
                Q(K.getLowLatencyModeEnabled() ? O.get().streaming.scheduling.lowLatencyTimeout : O.get().streaming.scheduling.defaultTimeout);
              }
              var ct;
            }
            function k() {
              var ut = NaN, ct = D.getCurrentRepresentationInfo();
              return g && ct && (ut = g === t.Z.TEXT ? function() {
                try {
                  if (de.isTextEnabled()) {
                    var nt = D.getCurrentRepresentationInfo();
                    if (isNaN(nt.fragmentDuration)) {
                      var rt = fe.getCurrentSchedulingInfo(m.Z.SCHEDULING_INFO);
                      return rt ? rt.duration : 0;
                    }
                    return nt.fragmentDuration;
                  }
                  return 0;
                } catch {
                  return 0;
                }
              }() : g === t.Z.AUDIO && y ? function() {
                try {
                  var nt = fe.getCurrentBufferLevel(t.Z.VIDEO), rt = D.getCurrentRepresentationInfo();
                  return isNaN(rt.fragmentDuration) ? nt + 1 : Math.max(nt + 1, rt.fragmentDuration);
                } catch {
                  return 0;
                }
              }() : function() {
                try {
                  var nt = D.getCurrentRepresentationInfo().mediaInfo.streamInfo;
                  return le.isPlayingAtTopQuality(nt) ? nt.manifestInfo.duration >= O.get().streaming.buffer.longFormContentDurationThreshold ? O.get().streaming.buffer.bufferTimeAtTopQualityLongForm : O.get().streaming.buffer.bufferTimeAtTopQuality : _e.getStableBufferTime();
                } catch {
                  return _e.getStableBufferTime();
                }
              }()), ut;
            }
            function ne() {
              ve(!0);
            }
            function ve(ut) {
              if (K && q) {
                var ct = q.getRequests({ state: W.FRAGMENT_MODEL_EXECUTED, time: K.getTime(), threshold: 0 })[0];
                ct && K.getTime() >= ct.startTime && ((!C.mediaInfo || ct.mediaInfo.type === C.mediaInfo.type && ct.mediaInfo.index !== C.mediaInfo.index) && ut && ae.trigger(l.Z.TRACK_CHANGE_RENDERED, { mediaType: g, oldMediaInfo: C.mediaInfo, newMediaInfo: ct.mediaInfo, streamId: u.id }), ct.quality === C.quality && ct.adaptationIndex === C.adaptationIndex || !ut || (_.debug("Quality change rendered for streamId ".concat(u.id, " and type ").concat(g)), ae.trigger(l.Z.QUALITY_CHANGE_RENDERED, { mediaType: g, oldQuality: C.quality, newQuality: ct.quality, streamId: u.id })), C = { mediaInfo: ct.mediaInfo, quality: ct.quality, adaptationIndex: ct.adaptationIndex });
              }
            }
            function xe() {
              q.abortRequests(), ue();
            }
            function Ne() {
              O.get().streaming.scheduling.scheduleWhilePaused || Q();
            }
            function Fe(ut) {
              fe.updatePlayListTraceMetrics({ playbackspeed: ut.playbackRate.toString() });
            }
            function Le() {
              Z = !0, w = 0, Y = NaN, C = { mediaInfo: void 0, quality: NaN, adaptationIndex: NaN }, F = NaN, H = !1, N = !1, U = !0;
            }
            return r = { initialize: function(ut) {
              y = ut, ae.on(l.Z.URL_RESOLUTION_FAILED, xe, r), ae.on(n.Z.PLAYBACK_STARTED, Ne, r), ae.on(n.Z.PLAYBACK_RATE_CHANGED, Fe, r), ae.on(n.Z.PLAYBACK_TIME_UPDATED, ne, r), ae.on(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING, A, r), ae.on(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING, oe, r);
            }, getType: function() {
              return g;
            }, getStreamId: function() {
              return u.id;
            }, setTimeToLoadDelay: function(ut) {
              w = ut;
            }, getTimeToLoadDelay: function() {
              return w;
            }, setSwitchTrack: function(ut) {
              H = ut;
            }, getSwitchTrack: function() {
              return H;
            }, startScheduleTimer: Q, clearScheduleTimer: ue, reset: function() {
              ae.off(l.Z.URL_RESOLUTION_FAILED, xe, r), ae.off(n.Z.PLAYBACK_STARTED, Ne, r), ae.off(n.Z.PLAYBACK_RATE_CHANGED, Fe, r), ae.off(n.Z.PLAYBACK_TIME_UPDATED, ne, r), ae.off(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING, A, r), ae.off(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING, oe, r), ue(), ve(!1), Le(), u = null;
            }, getBufferTarget: k, getPlaybackController: function() {
              return K;
            }, setCheckPlaybackQuality: function(ut) {
              Z = ut;
            }, setInitSegmentRequired: function(ut) {
              N = ut;
            }, setLastInitializedQuality: function(ut) {
              Y = ut;
            } }, _ = (0, h.Z)(me).getInstance().getLogger(r), Le(), u = i.streamInfo, r;
          }
          je.__dashjs_factory_name = "ScheduleController";
          var c = v.Z.getClassFactory(je), o = R(7387);
          function T(i) {
            var r, u, _, w, I, y, C = (i = i || {}).eventBus, F = i.events, Y = i.abrController, H = i.dashMetrics, N = i.playbackController, U = i.timelineConverter, Z = i.type, me = i.streamInfo, ae = i.dashConstants, fe = i.segmentsController, _e = i.isDynamic, q = i.adapter;
            function le() {
              return Z;
            }
            function K() {
              return _;
            }
            function de() {
              return y;
            }
            function g() {
              u = null, _ = !0, w = [], I = null;
            }
            function L(ue) {
              return new Promise(function(ee, k) {
                var ne = ue.hasInitialization(), ve = ue.hasSegments(), xe = [];
                xe.push(fe.updateInitData(ue, ne)), xe.push(fe.updateSegmentData(ue, ve)), Promise.all(xe).then(function(Ne) {
                  var Fe;
                  Ne[0] && !Ne[0].error && (ue = function(Le, ut) {
                    return ut && !ut.error && ut.representation ? ut.representation : Le;
                  }(ue, Ne[0])), Ne[1] && !Ne[1].error && (ue = function(Le, ut) {
                    if (ut && !ut.error) {
                      var ct, nt, rt, Bt, we = ut.segments, He = [], pt = 0;
                      for (ct = 0, nt = we ? we.length : 0; ct < nt; ct++) rt = we[ct], (Bt = (0, o.TJ)(U, _e, Le, rt.startTime, rt.duration, rt.timescale, rt.media, rt.mediaRange, pt)) && (He.push(Bt), Bt = null, pt++);
                      return He.length > 0 && (Le.segments = He), Le;
                    }
                  }(ue, Ne[1])), (Fe = ue).mediaFinishedInformation = fe.getMediaFinishedInformation(Fe), function(Le) {
                    if (K()) {
                      var ut, ct, nt = H.getCurrentManifestUpdate(), rt = !1;
                      if (nt) {
                        for (var Bt = 0; Bt < nt.representationInfo.length; Bt++) if ((ut = nt.representationInfo[Bt]).index === Le.index && ut.mediaType === le()) {
                          rt = !0;
                          break;
                        }
                        rt || H.addManifestUpdateRepresentationInfo(Le, le());
                      }
                      if (function() {
                        for (var He = 0, pt = w.length; He < pt; He++) {
                          var We = w[He].segmentInfoType;
                          if (!w[He].hasInitialization() || (We === ae.SEGMENT_BASE || We === ae.BASE_URL) && !w[He].segments) return !1;
                        }
                        return !0;
                      }()) {
                        Y.setPlaybackQuality(Z, me, (ct = y, w.indexOf(ct)));
                        var we = H.getCurrentDVRInfo(Z);
                        we && H.updateManifestUpdateInfo({ latency: we.range.end - N.getTime() }), H.getCurrentRepresentationSwitch(de().adaptation.type) || D(), A();
                      }
                    }
                  }(ue), ee();
                }).catch(function(Ne) {
                  k(Ne);
                });
              });
            }
            function D() {
              (function() {
                if (!(Y && H && N && U)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              })();
              var ue = /* @__PURE__ */ new Date(), ee = de(), k = 1e3 * N.getTime();
              ee && H.addRepresentationSwitch(ee.adaptation.type, ue, k, ee.id), C.trigger(n.Z.REPRESENTATION_SWITCH, { mediaType: Z, streamId: me.id, currentRepresentation: ee, numberOfRepresentations: w.length }, { streamId: me.id, mediaType: Z });
            }
            function O(ue) {
              return ue == null || ue >= w.length ? null : w[ue];
            }
            function A(ue) {
              _ = !1, C.trigger(F.DATA_UPDATE_COMPLETED, { data: u, currentRepresentation: y, error: ue }, { streamId: me.id, mediaType: Z });
            }
            function oe(ue) {
              y = ue, I = q.convertRepresentationToRepresentationInfo(y);
            }
            function Q(ue) {
              if (ue.newDuration) {
                var ee = de();
                ee && ee.adaptation.period && (ee.adaptation.period.duration = ue.newDuration);
              }
            }
            return r = { getStreamId: function() {
              return me.id;
            }, getType: le, getData: function() {
              return u;
            }, isUpdating: K, updateData: function(ue, ee, k, ne, ve) {
              return new Promise(function(xe, Ne) {
                if (_ = !0, w = ee, u = ue, oe(O(ve)), k !== t.Z.VIDEO && k !== t.Z.AUDIO && (k !== t.Z.TEXT || !ne)) return A(), void xe();
                for (var Fe = [], Le = 0, ut = w.length; Le < ut; Le++) {
                  var ct = w[Le];
                  Fe.push(L(ct));
                }
                Promise.all(Fe).then(function() {
                  oe(O(ve)), xe();
                }).catch(function(nt) {
                  Ne(nt);
                });
              });
            }, getCurrentRepresentation: de, getCurrentRepresentationInfo: function() {
              return I;
            }, getRepresentationForQuality: O, prepareQualityChange: function(ue) {
              oe(O(ue)), D();
            }, reset: function() {
              C.off(n.Z.MANIFEST_VALIDITY_CHANGED, Q, r), g();
            } }, g(), C.on(n.Z.MANIFEST_VALIDITY_CHANGED, Q, r), r;
          }
          T.__dashjs_factory_name = "RepresentationController";
          var b = v.Z.getClassFactory(T), X = R(3106), z = R(9326), De = R(7473), tt = R(2594);
          function Ue(i, r) {
            if (!(i instanceof r)) throw new TypeError("Cannot call a class as a function");
          }
          var ke = function i() {
            Ue(this, i), this.start = null, this.mstart = null, this.starttype = null, this.trace = [];
          };
          ke.INITIAL_PLAYOUT_START_REASON = "initial_playout", ke.SEEK_START_REASON = "seek", ke.RESUME_FROM_PAUSE_START_REASON = "resume", ke.METRICS_COLLECTION_START_REASON = "metrics_collection_start";
          var Oe = function i() {
            Ue(this, i), this.representationid = null, this.subreplevel = null, this.start = null, this.mstart = null, this.duration = null, this.playbackspeed = null, this.stopreason = null;
          };
          Oe.REPRESENTATION_SWITCH_STOP_REASON = "representation_switch", Oe.REBUFFERING_REASON = "rebuffering", Oe.USER_REQUEST_STOP_REASON = "user_request", Oe.END_OF_PERIOD_STOP_REASON = "end_of_period", Oe.END_OF_CONTENT_STOP_REASON = "end_of_content", Oe.METRICS_COLLECTION_STOP_REASON = "metrics_collection_end", Oe.FAILURE_STOP_REASON = "failure";
          var qe = R(7802);
          function it() {
            return { ntpToUTC: function(i) {
              var r = new Date(Date.UTC(1900, 0, 1, 0, 0, 0));
              return new Date(r.getTime() + i).getTime();
            } };
          }
          it.__dashjs_factory_name = "TimeUtils";
          var bt = v.Z.getSingletonFactory(it);
          function dt(i) {
            i = i || {};
            var r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe = this.context, _e = (0, p.Z)(fe).getInstance(), q = i.streamInfo, le = i.type, K = i.errHandler, de = i.mimeType, g = i.timelineConverter, L = i.adapter, D = i.manifestModel, O = i.mediaPlayerModel, A = i.fragmentModel, oe = i.abrController, Q = i.playbackController, ue = i.mediaController, ee = i.textController, k = i.dashMetrics, ne = i.settings, ve = i.boxParser, xe = i.segmentBlacklistController;
            function Ne() {
              return q.id;
            }
            function Fe() {
              return le;
            }
            function Le() {
              return L.getIsTextTrack(F.getData());
            }
            function ut() {
              I = [], w = null, me = 0, Y = !1, H = !1, N = !1, ae = null;
            }
            function ct(ze) {
              return !isNaN(ze) && !isNaN(q.duration) && isFinite(q.duration) && ze >= q.start + q.duration;
            }
            function nt(ze) {
              var Pe = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
              if (ze.sender) {
                if (Q.getIsManifestUpdateInProgress()) pt();
                else if ((!Le() || ee.isTextEnabled()) && y && ze.representationId && !y.appendInitSegmentFromCache(ze.representationId)) {
                  var ft = F.getCurrentRepresentation();
                  if (ft.range === 0) return void rt();
                  var pe = U ? U.getInitRequest(w, ft) : null;
                  pe ? A.executeRequest(pe) : Pe && (C.setInitSegmentRequired(!0), pt());
                }
              }
            }
            function rt(ze) {
              var Pe = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
              if (Q.getIsManifestUpdateInProgress() || y.getIsPruningInProgress()) pt();
              else {
                var ft = He();
                ft ? (Y = !1, H = !1, Bt(ft)) : we(Pe);
              }
            }
            function Bt(ze) {
              isNaN(ze.startTime + ze.duration) || (me = ze.startTime + ze.duration), ze.delayLoadingTime = (/* @__PURE__ */ new Date()).getTime() + C.getTimeToLoadDelay(), C.setTimeToLoadDelay(0), function(Pe) {
                var ft = Pe.url;
                return Pe.range && (ft = ft.concat("_", Pe.range)), xe.contains(ft);
              }(ze) ? (u.warn("Fragment request url ".concat(ze.url, " for stream id ").concat(q.id, " and media type ").concat(le, " is on the ignore list and will be skipped")), pt()) : (u.debug("Next fragment request url for stream id ".concat(q.id, " and media type ").concat(le, " is ").concat(ze.url)), A.executeRequest(ze));
            }
            function we(ze) {
              var Pe, ft = F.getCurrentRepresentation();
              if (!ne.get().streaming.gaps.enableSeekFix || !Y && Q.getTime() !== 0 || (_ ? _ && ft.segmentInfoType === e.Z.SEGMENT_TIMELINE && (Pe = U.getValidTimeAheadOfTargetTime(me, w, ft, ne.get().streaming.gaps.threshold)) : Pe = U.getValidTimeAheadOfTargetTime(me, w, ft, ne.get().streaming.gaps.threshold), isNaN(Pe) || Pe === me)) {
                if (U.isLastSegmentRequested(ft, me)) {
                  var pe = U.getCurrentIndex();
                  return u.debug("Segment requesting for stream ".concat(q.id, " has finished")), _e.trigger(l.Z.STREAM_REQUESTING_COMPLETED, { segmentIndex: pe }, { streamId: q.id, mediaType: le }), y.segmentRequestingCompleted(pe), void C.clearScheduleTimer();
                }
                ze && pt();
              } else Q.isSeeking() || Q.getTime() === 0 ? (u.warn("Adjusting playback time ".concat(Pe, " because of gap in the manifest. Seeking by ").concat(Pe - me)), Q.seek(Pe, !1, !1)) : (u.warn("Adjusting buffering time ".concat(Pe, " because of gap in the manifest. Adjusting time by ").concat(Pe - me)), Xt(Pe), ze && pt());
            }
            function He() {
              var ze, Pe = Qt();
              if (isNaN(me) || Fe() === t.Z.TEXT && !ee.isTextEnabled()) return null;
              if (U) {
                var ft = F && Pe ? F.getRepresentationForQuality(Pe.quality) : null;
                ze = Y ? U.getSegmentRequestForTime(w, ft, me) : H ? U.repeatSegmentRequest(w, ft) : U.getNextSegmentRequest(w, ft);
              }
              return ze;
            }
            function pt() {
              C.startScheduleTimer(Q.getLowLatencyModeEnabled() ? ne.get().streaming.scheduling.lowLatencyTimeout : ne.get().streaming.scheduling.defaultTimeout);
            }
            function We(ze) {
              ze.error || y.getIsBufferingCompleted() || y.updateBufferTimestampOffset(ze.currentRepresentation);
            }
            function Tt(ze) {
              k.addBufferState(le, ze.state, C.getBufferTarget()), ze.state !== m.Z.BUFFER_EMPTY || Q.isSeeking() || (u.info("Buffer is empty! Stalling!"), k.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), Oe.REBUFFERING_REASON));
            }
            function vt(ze) {
              A.syncExecutedRequestsWithBufferedRange(y.getBuffer().getAllBufferRanges(), q.duration), ze.quotaExceeded && ze.from > Q.getTime() && Xt(ze.from), ze.hasEnoughSpaceToAppend && ze.quotaExceeded && C.startScheduleTimer();
            }
            function ht(ze) {
              if (ze && ze.lastRequestAppended && ze.lastRequestAppended.url) {
                var Pe = ze.lastRequestAppended.url;
                ze.lastRequestAppended.range && (Pe = Pe.concat("_", ze.lastRequestAppended.range)), u.warn("Blacklisting segment with url ".concat(Pe)), xe.add(Pe);
              }
            }
            function Wt(ze) {
              if (u.debug("Appended bytes for ".concat(ze.mediaType, " and stream id ").concat(ze.streamId)), ze.segmentType === Ge.w.INIT_SEGMENT_TYPE) {
                var Pe = ze.quality;
                C.setLastInitializedQuality(Pe), u.info("[" + le + "] lastInitializedRepresentationInfo changed to " + ze.quality);
              }
              ae ? zt(ae) : C.startScheduleTimer(0);
            }
            function zt(ze) {
              var Pe = A.getRequests({ state: W.FRAGMENT_MODEL_LOADING });
              if (Pe && Pe.length > 0) return u.debug("Preparing for default quality switch: Waiting for ongoing segment request to be finished before applying switch."), void (ae = ze);
              y.updateBufferTimestampOffset(ze).then(function() {
                C.setCheckPlaybackQuality(!1), w.segmentAlignment || w.subSegmentAlignment ? C.startScheduleTimer() : qt(), ae = null, N = !1;
              }).catch(function() {
                ae = null, N = !1;
              });
            }
            function gn(ze) {
              u.info("onFragmentLoadingAbandoned request: " + ze.request.url + " has been aborted"), Q.isSeeking() || C.getSwitchTrack() || N || (u.info("onFragmentLoadingAbandoned request: " + ze.request.url + " has to be downloaded again, origin is not seeking process or switch track call"), ze.request && ze.request.isInitializationRequest() ? C.setInitSegmentRequired(!0) : Xt(ze.request.startTime + ze.request.duration / 2), C.startScheduleTimer(0));
            }
            function pn(ze) {
              u.info("OnFragmentLoadingCompleted for stream id " + q.id + " and media type " + le + " - Url:", ze.request ? ze.request.url : "undefined", ze.request.range ? ", Range:" + ze.request.range : ""), Le() && C.startScheduleTimer(0), ze.error && ze.request.serviceLocation && function(Pe) {
                u.info("Fragment loading completed with an error"), Pe && Pe.request && Pe.request.type && (Pe.request.type === Ge.w.INIT_SEGMENT_TYPE ? nt({ representationId: Pe.request.representationId, sender: {} }, !1) : Pe.request.type === Ge.w.MEDIA_SEGMENT_TYPE && (Xt(Pe.request.startTime + Pe.request.duration / 2), rt({}, !1)));
              }(ze);
            }
            function Ke() {
              Xt(Q.getTime()), $t().startScheduleTimer();
            }
            function Et(ze) {
              var Pe = ze.currentTrackInfo;
              if (Pe) {
                var ft = I.find(function(pe) {
                  return pe.index === Pe.index && pe.lang === Pe.lang;
                });
                ft && Pt(ft).then(function() {
                  y.setIsBufferingCompleted(!1), Xt(Q.getTime()), C.setInitSegmentRequired(!0), C.startScheduleTimer();
                });
              }
            }
            function lt(ze) {
              Xt(ze.quotaExceededTime), C.clearScheduleTimer();
            }
            function Rt() {
              return y ? y.getBuffer() : null;
            }
            function Pt(ze) {
              ze === w || ze && w && ze.type !== w.type || (w = ze);
              var Pe = L.getRealAdaptation(q, w), ft = L.getVoRepresentations(w);
              if (F) {
                var pe, be = F.getData(), Je = oe.getMaxAllowedIndexFor(le, q.id), Nt = oe.getMinAllowedIndexFor(le, q.id), xt = null;
                return be !== null && be.id === Pe.id || le === t.Z.TEXT ? pe = oe.getQualityFor(le, q.id) : (xt = oe.getThroughputHistory().getAverageThroughput(le, _) || oe.getInitialBitrateFor(le, q.id), pe = oe.getQualityForBitrate(w, xt, q.id)), Nt !== void 0 && pe < Nt && (pe = Nt), pe > Je && (pe = Je), F.updateData(Pe, ft, le, w.isFragmented, pe);
              }
              return Promise.resolve();
            }
            function $t() {
              return C;
            }
            function Qt(ze) {
              var Pe;
              return ze !== void 0 ? ((0, X.SE)(ze), Pe = F ? F.getRepresentationForQuality(ze) : null) : Pe = F ? F.getCurrentRepresentation() : null, L.convertRepresentationToRepresentationInfo(Pe);
            }
            function en() {
              return !!y && y.getIsBufferingCompleted();
            }
            function sn(ze) {
              if (ne.get().streaming.enableManifestTimescaleMismatchFix) {
                var Pe = ze.chunk, ft = Pe.bytes, pe = Qt(Pe.quality), be = F && pe ? F.getRepresentationForQuality(pe.quality) : null;
                pe && be && (be.timescale = ve.getMediaTimescaleFromMoov(ft));
              }
            }
            function mt(ze) {
              var Pe = ze.chunk, ft = Pe.bytes, pe = Pe.quality, be = Qt(pe), Je = F && be ? F.getRepresentationForQuality(be.quality) : null;
              if (be && Je) {
                var Nt;
                if (ne.get().streaming.parseInbandPrft && ze.request.type === Ge.w.MEDIA_SEGMENT_TYPE) {
                  var xt = function(mr, er) {
                    var jr = mr.getBoxes("prft"), ei = [];
                    return jr.forEach(function(ti) {
                      ei.push(function(Pr, Br) {
                        var pr = "unknown";
                        switch (Pr.flags) {
                          case 0:
                            pr = e.Z.PRODUCER_REFERENCE_TIME_TYPE.ENCODER;
                            break;
                          case 16:
                            pr = e.Z.PRODUCER_REFERENCE_TIME_TYPE.APPLICATION;
                            break;
                          case 24:
                            pr = e.Z.PRODUCER_REFERENCE_TIME_TYPE.CAPTURED;
                        }
                        var Yr = 1e3 * Pr.ntp_timestamp_sec + Pr.ntp_timestamp_frac / Math.pow(2, 32) * 1e3;
                        return { type: pr, ntpTimestamp: Yr = bt(fe).getInstance().ntpToUTC(Yr), mediaTime: Pr.media_time / Br };
                      }(ti, er));
                    }), ei;
                  }(Nt = Nt || ve.parse(ft), Je.timescale);
                  xt && xt.length && _e.trigger(n.Z.INBAND_PRFT, { data: xt }, { streamId: q.id, mediaType: le });
                }
                var yn = L.getEventsFor(be.mediaInfo, null, q), Ln = L.getEventsFor(be, Je, q);
                if (yn && yn.length > 0 || Ln && Ln.length > 0) {
                  var Qn = A.getRequests({ state: W.FRAGMENT_MODEL_EXECUTED, quality: pe, index: Pe.index })[0], Dn = function(mr, er, jr, ei) {
                    try {
                      for (var ti = {}, Pr = [], Br = jr.concat(ei), pr = 0, Yr = Br.length; pr < Yr; pr++) ti[Br[pr].schemeIdUri + "/" + Br[pr].value] = Br[pr];
                      var ni = mr.getBoxes("emsg");
                      if (!ni || ni.length === 0) return Pr;
                      for (var Nr = mr.getBox("sidx"), Ni = !Nr || isNaN(Nr.earliest_presentation_time) || isNaN(Nr.timescale) ? er && !isNaN(er.mediaStartTime) ? er.mediaStartTime : 0 : Nr.earliest_presentation_time / Nr.timescale, oa = Math.max(Ni, 0), sa = F.getCurrentRepresentation(), Kr = 0, la = ni.length; Kr < la; Kr++) {
                        var ri = L.getEvent(ni[Kr], ti, oa, sa);
                        ri && Pr.push(ri);
                      }
                      return Pr;
                    } catch {
                      return [];
                    }
                  }(Nt = Nt || ve.parse(ft), Qn, yn, Ln);
                  _e.trigger(l.Z.INBAND_EVENTS, { events: Dn }, { streamId: q.id });
                }
              }
            }
            function kt() {
              var ze = Q.getTime();
              ne.get().streaming.buffer.flushBufferAtTrackSwitch && Q.seek(ze + 1e-3, !1, !0), Xt(ze), y.setSeekTarget(ze), C.startScheduleTimer();
            }
            function qt() {
              var ze = Q.getTime(), Pe = y.getContinuousBufferTimeForTargetTime(ze);
              Xt(isNaN(Pe) ? ze : Pe), C.startScheduleTimer();
            }
            function Vt(ze) {
              ze && !isNaN(ze.time) && (Xt(ze.time), y.setSeekTarget(ze.time));
            }
            function Xt(ze) {
              me = ze, Y = !0;
            }
            return r = { initialize: function(ze, Pe, ft) {
              Z = (0, qe.Z)(fe).create({ events: l.Z, eventBus: _e, streamInfo: q, timelineConverter: g, dashConstants: e.Z, segmentBaseController: i.segmentBaseController, type: le }), U = (0, z.Z)(fe).create({ streamInfo: q, type: le, timelineConverter: g, dashMetrics: k, mediaPlayerModel: O, baseURLController: i.baseURLController, errHandler: K, segmentsController: Z, settings: ne, boxParser: ve, events: l.Z, eventBus: _e, errors: $, debug: (0, h.Z)(fe).getInstance(), requestModifier: (0, De.Z)(fe).getInstance(), dashConstants: e.Z, constants: t.Z, urlUtils: (0, tt.Z)(fe).getInstance() }), _ = q.manifestInfo.isDynamic, U.initialize(_), oe.registerStreamType(le, r), F = b(fe).create({ streamInfo: q, type: le, abrController: oe, dashMetrics: k, playbackController: Q, timelineConverter: g, dashConstants: e.Z, events: l.Z, eventBus: _e, errors: $, isDynamic: _, adapter: L, segmentsController: Z }), y = function(pe, be) {
                return pe ? pe !== t.Z.TEXT || be ? Ve(fe).create({ streamInfo: q, type: pe, mediaPlayerModel: O, manifestModel: D, fragmentModel: A, errHandler: K, mediaController: ue, representationController: F, adapter: L, textController: ee, abrController: oe, playbackController: Q, settings: ne }) : Te(fe).create({ streamInfo: q, type: pe, mimeType: de, fragmentModel: A, textController: ee, errHandler: K, settings: ne }) : (K.error(new se.Z($.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, $.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + "not properly defined")), null);
              }(le, ft), y && y.initialize(ze), (C = c(fe).create({ streamInfo: q, type: le, mimeType: de, adapter: L, dashMetrics: k, mediaPlayerModel: O, fragmentModel: A, abrController: oe, playbackController: Q, textController: ee, mediaController: ue, bufferController: y, representationController: F, settings: ne })).initialize(Pe), me = 0, Y = !1, H = !1;
            }, getStreamId: Ne, getType: Fe, isUpdating: function() {
              return !!F && F.isUpdating();
            }, getBufferController: function() {
              return y;
            }, dischargePreBuffer: function() {
              y.dischargePreBuffer();
            }, getFragmentModel: function() {
              return A;
            }, getScheduleController: $t, getRepresentationController: function() {
              return F;
            }, getRepresentationInfo: Qt, getBufferLevel: function() {
              return y ? y.getBufferLevel() : 0;
            }, isBufferingCompleted: en, createBufferSinks: function(ze) {
              var Pe = Rt();
              return Pe ? Promise.resolve(Pe) : y ? y.createBufferSink(w, ze) : Promise.resolve(null);
            }, updateStreamInfo: function(ze) {
              return q = ze, en() ? Promise.resolve() : y.updateAppendWindow();
            }, getStreamInfo: function() {
              return q;
            }, selectMediaInfo: Pt, clearMediaInfoArray: function() {
              I = [];
            }, addMediaInfo: function(ze) {
              I.indexOf(ze) === -1 && I.push(ze);
            }, prepareTrackSwitch: function() {
              return new Promise(function(ze) {
                u.debug("Preparing track switch for type ".concat(le));
                var Pe = le === t.Z.TEXT || ne.get().streaming.trackSwitchMode[le] === t.Z.TRACK_SWITCH_MODE_ALWAYS_REPLACE && Q.getTimeToStreamEnd(q) > ne.get().streaming.buffer.stallThreshold;
                if (y.getIsBufferingCompleted() && !Pe) return y.prepareForNonReplacementTrackSwitch(w.codec).then(function() {
                  _e.trigger(l.Z.BUFFERING_COMPLETED, {}, { streamId: q.id, mediaType: le });
                }).catch(function() {
                  _e.trigger(l.Z.BUFFERING_COMPLETED, {}, { streamId: q.id, mediaType: le });
                }), void ze();
                C.clearScheduleTimer(), C.setSwitchTrack(!0), Pe ? (_e.trigger(l.Z.BUFFER_REPLACEMENT_STARTED, { mediaType: le, streamId: q.id }, { mediaType: le, streamId: q.id }), A.abortRequests(), y.prepareForReplacementTrackSwitch(w.codec).then(function() {
                  var ft = Qt();
                  return y.updateBufferTimestampOffset(ft);
                }).then(function() {
                  kt(), ze();
                }).catch(function() {
                  kt(), ze();
                })) : y.prepareForNonReplacementTrackSwitch(w.codec).then(function() {
                  qt(), ze();
                }).catch(function() {
                  qt(), ze();
                });
              });
            }, prepareQualityChange: function(ze) {
              ae && u.warn("Canceling queued representation switch to ".concat(ae.quality, " for ").concat(le)), u.debug("Preparing quality switch for type ".concat(le));
              var Pe = ze.newQuality;
              N = !0, C.clearScheduleTimer(), F.prepareQualityChange(Pe);
              var ft = Qt(Pe);
              ze.reason && ze.reason.forceReplace ? function(pe) {
                A.abortRequests(), _e.trigger(l.Z.BUFFER_REPLACEMENT_STARTED, { mediaType: le, streamId: q.id }, { mediaType: le, streamId: q.id }), C.setCheckPlaybackQuality(!1), y.prepareForForceReplacementQualitySwitch(pe).then(function() {
                  kt(), ae = null, N = !1;
                }).catch(function() {
                  kt(), ae = null, N = !1;
                });
              }(ft) : ze && ze.reason && ze.reason.forceAbandon ? function(pe) {
                y.updateBufferTimestampOffset(pe).then(function() {
                  A.abortRequests(), H = !0, C.setCheckPlaybackQuality(!1), C.startScheduleTimer(), N = !1, ae = null;
                }).catch(function() {
                  ae = null, N = !1;
                });
              }(ft) : ne.get().streaming.buffer.fastSwitchEnabled ? function(pe) {
                var be = Q.getTime(), Je = 1.5 * (isNaN(pe.fragmentDuration) ? 1 : pe.fragmentDuration), Nt = A.getRequests({ state: W.FRAGMENT_MODEL_EXECUTED, time: be + Je, threshold: 0 })[0];
                if (Nt && !Le()) {
                  var xt = y.getBufferLevel(), yn = oe.getAbandonmentStateFor(q.id, le);
                  Nt.quality < pe.quality && xt >= Je && yn !== m.Z.ABANDON_LOAD ? y.updateBufferTimestampOffset(pe).then(function() {
                    A.abortRequests(), Xt(be + Je), C.setCheckPlaybackQuality(!1), C.startScheduleTimer(), N = !1;
                  }).catch(function() {
                    N = !1;
                  }) : zt(pe);
                } else zt(pe);
              }(ft) : zt(ft), k.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), Oe.REPRESENTATION_SWITCH_STOP_REASON), k.createPlaylistTraceMetrics(ft.id, 1e3 * Q.getTime(), Q.getPlaybackRate());
            }, getMediaInfo: function() {
              return w;
            }, getMediaSource: function() {
              return y.getMediaSource();
            }, setMediaSource: function(ze) {
              return y.setMediaSource(ze, w);
            }, getBuffer: Rt, setExplicitBufferingTime: Xt, finalisePlayList: function(ze, Pe) {
              k.pushPlayListTraceMetrics(ze, Pe);
            }, probeNextRequest: function() {
              var ze = Qt(), Pe = F && ze ? F.getRepresentationForQuality(ze.quality) : null;
              return U.getNextSegmentRequestIdempotent(w, Pe);
            }, prepareInnerPeriodPlaybackSeeking: function(ze) {
              return new Promise(function(Pe) {
                if (y.hasBufferAtTime(ze.seekTime)) return y.pruneBuffer(), ct(y.getContinuousBufferTimeForTargetTime(ze.seekTime)) && y.setIsBufferingCompleted(!0), void Pe();
                C.clearScheduleTimer(), A.abortRequests(), y.prepareForPlaybackSeek().then(function() {
                  var ft = y.getAllRangesWithSafetyFactor(ze.seekTime);
                  return y.clearBuffers(ft);
                }).then(function() {
                  var ft = y.getContinuousBufferTimeForTargetTime(ze.seekTime);
                  if (ct(ft)) y.setIsBufferingCompleted(!0), Pe();
                  else {
                    var pe = isNaN(ft) ? ze.seekTime : ft;
                    Xt(pe), y.setSeekTarget(pe);
                    var be = [];
                    be.push(y.updateAppendWindow());
                    var Je = Qt();
                    be.push(y.updateBufferTimestampOffset(Je)), Promise.all(be).then(function() {
                      C.setInitSegmentRequired(!0), C.setCheckPlaybackQuality(!1), C.startScheduleTimer(), Pe();
                    });
                  }
                }).catch(function(ft) {
                  u.error(ft);
                });
              });
            }, prepareOuterPeriodPlaybackSeeking: function() {
              return new Promise(function(ze, Pe) {
                try {
                  C.clearScheduleTimer(), A.abortRequests(), y.prepareForPlaybackSeek().then(function() {
                    return y.pruneAllSafely();
                  }).then(function() {
                    ze();
                  });
                } catch (ft) {
                  Pe(ft);
                }
              });
            }, reset: function(ze, Pe) {
              U && U.reset(), y && (y.reset(ze, Pe), y = null), C && (C.reset(), C = null), F && (F.reset(), F = null), Z && (Z = null), oe && oe.unRegisterStreamType(Ne(), le), _e.off(l.Z.DATA_UPDATE_COMPLETED, We, r), _e.off(l.Z.INIT_FRAGMENT_NEEDED, nt, r), _e.off(l.Z.MEDIA_FRAGMENT_NEEDED, rt, r), _e.off(l.Z.INIT_FRAGMENT_LOADED, sn, r), _e.off(l.Z.MEDIA_FRAGMENT_LOADED, mt, r), _e.off(l.Z.BUFFER_LEVEL_STATE_CHANGED, Tt, r), _e.off(l.Z.BUFFER_CLEARED, vt, r), _e.off(l.Z.SEEK_TARGET, Vt, r), _e.off(l.Z.FRAGMENT_LOADING_ABANDONED, gn, r), _e.off(l.Z.FRAGMENT_LOADING_COMPLETED, pn, r), _e.off(l.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, Ke, r), _e.off(l.Z.SET_NON_FRAGMENTED_TEXT, Et, r), _e.off(l.Z.QUOTA_EXCEEDED, lt, r), _e.off(l.Z.SOURCE_BUFFER_ERROR, ht, r), _e.off(l.Z.BYTES_APPENDED_END_FRAGMENT, Wt, r), ut(), le = null, q = null;
            } }, u = (0, h.Z)(fe).getInstance().getLogger(r), ut(), _e.on(l.Z.DATA_UPDATE_COMPLETED, We, r, { priority: p.Z.EVENT_PRIORITY_HIGH }), _e.on(l.Z.INIT_FRAGMENT_NEEDED, nt, r), _e.on(l.Z.MEDIA_FRAGMENT_NEEDED, rt, r), _e.on(l.Z.INIT_FRAGMENT_LOADED, sn, r), _e.on(l.Z.MEDIA_FRAGMENT_LOADED, mt, r), _e.on(l.Z.BUFFER_LEVEL_STATE_CHANGED, Tt, r), _e.on(l.Z.BUFFER_CLEARED, vt, r), _e.on(l.Z.SEEK_TARGET, Vt, r), _e.on(l.Z.FRAGMENT_LOADING_ABANDONED, gn, r), _e.on(l.Z.FRAGMENT_LOADING_COMPLETED, pn, r), _e.on(l.Z.QUOTA_EXCEEDED, lt, r), _e.on(l.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, Ke, r), _e.on(l.Z.SET_NON_FRAGMENTED_TEXT, Et, r), _e.on(l.Z.SOURCE_BUFFER_ERROR, ht, r), _e.on(l.Z.BYTES_APPENDED_END_FRAGMENT, Wt, r), r;
          }
          dt.__dashjs_factory_name = "StreamProcessor";
          var Yt = v.Z.getClassFactory(dt), Mt = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.streamId = null, this.mediaInfo = null, this.segmentType = null, this.quality = NaN, this.index = NaN, this.bytes = null, this.start = NaN, this.end = NaN, this.duration = NaN, this.representationId = null, this.endFragment = null;
          }, Ht = R(9032);
          function Ut(i, r) {
            if (i) {
              if (typeof i == "string") return cn(i, r);
              var u = Object.prototype.toString.call(i).slice(8, -1);
              return u === "Object" && i.constructor && (u = i.constructor.name), u === "Map" || u === "Set" ? Array.from(i) : u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u) ? cn(i, r) : void 0;
            }
          }
          function cn(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function Tn(i) {
            i = i || {};
            var r, u, _ = this.context, w = i.requestModifier, I = i.lowLatencyThroughputModel, y = i.boxParser, C = (0, Me.Z)(_).getInstance();
            function F(N) {
              var U, Z = /* @__PURE__ */ new Date(), me = N.request, ae = new Headers();
              if (me.range && ae.append("Range", "bytes=" + me.range), N.headers) for (var fe in N.headers) {
                var _e = N.headers[fe];
                _e && ae.append(fe, _e);
              }
              me.requestStartDate || (me.requestStartDate = Z), w && w.modifyRequestHeader && w.modifyRequestHeader({ setRequestHeader: function(g, L) {
                ae.append(g, L);
              } }, { url: N.url }), typeof window.AbortController == "function" && (U = new AbortController(), N.abortController = U, U.signal.onabort = N.onabort);
              var q = { method: N.method, headers: ae, credentials: N.withCredentials ? "include" : void 0, signal: U ? U.signal : void 0 }, le = C.get().streaming.abr.fetchThroughputCalculationMode, K = Date.now(), de = 0;
              new Promise(function(g) {
                if (le === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && I && (de = I.getThroughputCapacityDelayMS(me, 1e3 * u.getCurrentBufferLevel(me.mediaType)))) return setTimeout(g, de);
                g();
              }).then(function() {
                var g = Date.now();
                fetch(N.url, q).then(function(L) {
                  N.response || (N.response = {}), N.response.status = L.status, N.response.statusText = L.statusText, N.response.responseURL = L.url, L.ok || N.onerror();
                  var D, O = "", A = function(We, Tt) {
                    var vt;
                    if (typeof Symbol > "u" || We[Symbol.iterator] == null) {
                      if (Array.isArray(We) || (vt = Ut(We))) {
                        vt && (We = vt);
                        var ht = 0, Wt = function() {
                        };
                        return { s: Wt, n: function() {
                          return ht >= We.length ? { done: !0 } : { done: !1, value: We[ht++] };
                        }, e: function(Ke) {
                          throw Ke;
                        }, f: Wt };
                      }
                      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                    }
                    var zt, gn = !0, pn = !1;
                    return { s: function() {
                      vt = We[Symbol.iterator]();
                    }, n: function() {
                      var Ke = vt.next();
                      return gn = Ke.done, Ke;
                    }, e: function(Ke) {
                      pn = !0, zt = Ke;
                    }, f: function() {
                      try {
                        gn || vt.return == null || vt.return();
                      } finally {
                        if (pn) throw zt;
                      }
                    } };
                  }(L.headers.keys());
                  try {
                    for (A.s(); !(D = A.n()).done; ) {
                      var oe = D.value;
                      O += oe + ": " + L.headers.get(oe) + `\r
`;
                    }
                  } catch (We) {
                    A.e(We);
                  } finally {
                    A.f();
                  }
                  if (N.response.responseHeaders = O, !L.body) return L.arrayBuffer().then(function(We) {
                    N.response.response = We;
                    var Tt = { loaded: We.byteLength, total: We.byteLength, stream: !1 };
                    N.progress(Tt), N.onload(), N.onend();
                  });
                  var Q, ue, ee, k, ne = parseInt(L.headers.get("Content-Length"), 10), ve = 0, xe = !1, Ne = new Uint8Array(), Fe = 0;
                  if (le === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && I) {
                    var Le = g, ut = 0, ct = (ee = L.body.tee(), k = 2, function(We) {
                      if (Array.isArray(We)) return We;
                    }(ee) || function(We, Tt) {
                      if (typeof Symbol < "u" && Symbol.iterator in Object(We)) {
                        var vt = [], ht = !0, Wt = !1, zt = void 0;
                        try {
                          for (var gn, pn = We[Symbol.iterator](); !(ht = (gn = pn.next()).done) && (vt.push(gn.value), !Tt || vt.length !== Tt); ht = !0) ;
                        } catch (Ke) {
                          Wt = !0, zt = Ke;
                        } finally {
                          try {
                            ht || pn.return == null || pn.return();
                          } finally {
                            if (Wt) throw zt;
                          }
                        }
                        return vt;
                      }
                    }(ee, k) || Ut(ee, k) || function() {
                      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                    }()), nt = ct[0], rt = ct[1];
                    Q = nt.getReader(), ue = [], Q.read().then(function We(Tt) {
                      var vt = Tt.value, ht = Tt.done;
                      if (ut = Date.now(), vt && vt.length) {
                        var Wt = ut - Le, zt = vt.length;
                        ue.push({ chunkDownloadTimeRelativeMS: ut - g, chunkDownloadDurationMS: Wt, chunkBytes: zt, kbps: Math.round(8 * zt / (Wt / 1e3)), bufferLevel: u.getCurrentBufferLevel(me.mediaType) });
                      }
                      if (ht) {
                        var gn = ut - g, pn = ue.reduce(function(Ke, Et) {
                          return Ke + Et.chunkBytes;
                        }, 0);
                        return I.addMeasurement(me, gn, ue, K, de, O), void N.progress({ loaded: pn, total: pn, lengthComputable: !0, time: I.getEstimatedDownloadDurationMS(me), stream: !0 });
                      }
                      return Le = Date.now(), Q.read().then(We);
                    }), N.reader = rt.getReader();
                  } else N.reader = L.body.getReader();
                  var Bt = [], we = [], He = [], pt = !0;
                  Y(N, function We(Tt) {
                    var vt = Tt.value;
                    if (Tt.done) {
                      if (Ne) {
                        if (le !== t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST) {
                          var ht = null, Wt = null;
                          le === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING ? (ht = function(Ke, Et) {
                            try {
                              var lt, Rt;
                              lt = Ke.filter(function(kt, qt) {
                                return qt < Ke.length - 1;
                              }), Rt = Et.filter(function(kt, qt) {
                                return qt < Et.length - 1;
                              });
                              var Pt = [];
                              if (lt.length > 1) {
                                for (var $t = 0, Qt = 0, en = 0; en < lt.length; en++) if (lt[en] && Rt[en]) {
                                  var sn = Rt[en].ts - lt[en].ts;
                                  if (sn > 1) Pt.push(8 * Rt[en].bytes / sn), Qt = 0;
                                  else {
                                    Qt === 0 && (Qt = lt[en].ts, $t = 0);
                                    var mt = Rt[en].ts - Qt;
                                    mt > 1 ? ($t += Rt[en].bytes, Pt.push(8 * $t / mt), Qt = 0) : $t += Rt[en].bytes;
                                  }
                                }
                                if (Pt.length > 0) return Pt.reduce(function(kt, qt) {
                                  return kt + qt;
                                }, 0) / Pt.length;
                              }
                              return null;
                            } catch {
                              return null;
                            }
                          }(we, He), ht && (Wt = 8 * ve / ht)) : le === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA && (Wt = H(Bt, ve)), N.progress({ loaded: ve, total: isNaN(ne) ? ve : ne, lengthComputable: !0, time: Wt, stream: !0 });
                        }
                        N.response.response = Ne.buffer;
                      }
                      return N.onload(), void N.onend();
                    }
                    if (vt && vt.length > 0) {
                      Ne = function(Ke, Et) {
                        if (Ke.length === 0) return Et;
                        var lt = new Uint8Array(Ke.length + Et.length);
                        return lt.set(Ke), lt.set(Et, Ke.length), lt;
                      }(Ne, vt), ve += vt.length, Bt.push({ ts: Date.now(), bytes: vt.length }), le === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && pt && y.findLastTopIsoBoxCompleted(["moof"], Ne, Fe).found && (pt = !1, we.push({ ts: performance.now(), bytes: vt.length }));
                      var zt = y.findLastTopIsoBoxCompleted(["moov", "mdat"], Ne, Fe);
                      if (zt.found) {
                        var gn, pn = zt.lastCompletedOffset + zt.size;
                        le !== t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING || pt || (pt = !0, He.push({ ts: performance.now(), bytes: Ne.length })), pn === Ne.length ? (gn = Ne, Ne = new Uint8Array()) : (gn = new Uint8Array(Ne.subarray(0, pn)), Ne = Ne.subarray(pn)), N.progress({ data: gn.buffer, lengthComputable: !1, noTrace: !0 }), Fe = 0;
                      } else Fe = zt.lastCompletedOffset, xe || (N.progress({ lengthComputable: !1, noTrace: !0 }), xe = !0);
                    }
                    Y(N, We);
                  });
                }).catch(function(L) {
                  N.onerror && N.onerror(L);
                });
              });
            }
            function Y(N, U) {
              N.reader.read().then(U).catch(function(Z) {
                N.onerror && N.response.status === 200 && N.onerror(Z);
              });
            }
            function H(N, U) {
              try {
                if ((N = N.filter(function(ae) {
                  return ae.bytes > U / 4 / N.length;
                })).length > 1) {
                  var Z = 0, me = (N[N.length - 1].ts - N[0].ts) / N.length;
                  return N.forEach(function(ae, fe) {
                    var _e = N[fe + 1];
                    if (_e) {
                      var q = _e.ts - ae.ts;
                      Z += q < me ? q : 0;
                    }
                  }), Z;
                }
                return null;
              } catch {
                return null;
              }
            }
            return r = { load: function(N) {
              w && w.modifyRequest ? (0, De.k)(N, w).then(function() {
                return F(N);
              }) : F(N);
            }, abort: function(N) {
              if (N.abortController) N.abortController.abort();
              else if (N.reader) try {
                N.reader.cancel(), N.onabort();
              } catch {
              }
            }, calculateDownloadedTime: H, setup: function(N) {
              u = N.dashMetrics;
            } }, r;
          }
          Tn.__dashjs_factory_name = "FetchLoader";
          var xn = v.Z.getClassFactory(Tn), Mn = R(1180);
          function kn(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var tr = function() {
            function i() {
              (function(_, w) {
                if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.id = null, this.index = -1, this.adaptation = null, this.segmentInfoType = null, this.initialization = null, this.codecs = null, this.mimeType = null, this.codecPrivateData = null, this.segmentDuration = NaN, this.timescale = 1, this.startNumber = 1, this.indexRange = null, this.range = null, this.presentationTimeOffset = 0, this.MSETimeOffset = NaN, this.mediaFinishedInformation = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN }, this.bandwidth = NaN, this.width = NaN, this.height = NaN, this.scanType = null, this.maxPlayoutRate = NaN, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0, this.frameRate = null;
            }
            var r, u;
            return r = i, (u = [{ key: "hasInitialization", value: function() {
              return this.initialization !== null || this.range !== null;
            } }, { key: "hasSegments", value: function() {
              return this.segmentInfoType !== e.Z.BASE_URL && this.segmentInfoType !== e.Z.SEGMENT_BASE && !this.indexRange;
            } }]) && kn(r.prototype, u), i;
          }(), wn = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.period = null, this.index = -1, this.type = null;
          }, hr = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = -1, this.duration = NaN, this.start = NaN, this.mpd = null, this.nextPeriodId = null;
          };
          hr.DEFAULT_ID = "defaultId";
          var zn = hr, or = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.manifest = null, this.suggestedPresentationDelay = 0, this.availabilityStartTime = null, this.availabilityEndTime = Number.POSITIVE_INFINITY, this.timeShiftBufferDepth = Number.POSITIVE_INFINITY, this.maxSegmentDuration = Number.POSITIVE_INFINITY, this.publishTime = null, this.minimumUpdatePeriod = NaN, this.mediaPresentationDuration = NaN;
          }, vr = R(2610), sr = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.type = "", this.duration = NaN, this.presentationTime = NaN, this.id = NaN, this.messageData = "", this.eventStream = null, this.presentationTimeDelta = NaN;
          }, Ar = function i(r, u, _, w) {
            (function(I, y) {
              if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = u || r || "", this.dvbPriority = _ || 1, this.dvbWeight = w || 1, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0, this.queryParams = {};
          };
          Ar.DEFAULT_DVB_PRIORITY = 1, Ar.DEFAULT_DVB_WEIGHT = 1;
          var Ir = Ar, li = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.adaptionSet = null, this.representation = null, this.period = null, this.timescale = 1, this.value = "", this.schemeIdUri = "", this.presentationTimeOffset = 0;
          }, Dt = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.inband = !1, this.type = "encoder", this.applicationScheme = null, this.wallClockTime = null, this.presentationTime = NaN, this.UTCTiming = null;
          }, wt = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.defaultServiceLocation = null, this.defaultServiceLocationArray = [], this.queryBeforeStart = !1, this.serverUrl = null, this.clientRequirement = !0;
          };
          function Ct(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Ye = function() {
            function i() {
              (function(_, w) {
                if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.schemeIdUri = null, this.value = null, this.id = null;
            }
            var r, u;
            return r = i, (u = [{ key: "init", value: function(_) {
              return _ && (this.schemeIdUri = _.schemeIdUri ? _.schemeIdUri : null, this.value = _.value ? _.value : null, this.id = _.id ? _.id : null, _[e.Z.DVB_URL] && (this.dvbUrl = _[e.Z.DVB_URL]), _[e.Z.DVB_MIMETYPE] && (this.dvbMimeType = _[e.Z.DVB_MIMETYPE]), _[e.Z.DVB_FONTFAMILY] && (this.dvbFontFamily = _[e.Z.DVB_FONTFAMILY])), this;
            } }]) && Ct(r.prototype, u), i;
          }(), yt = R(3101), $e = R.n(yt);
          function gt() {
            return { areEqual: function(i, r) {
              return $e()(i, r);
            } };
          }
          gt.__dashjs_factory_name = "ObjectUtils";
          var Zt = v.Z.getSingletonFactory(gt), Gt = R(7803), nn = function i(r, u) {
            (function(_, w) {
              if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = u || null, this.queryParams = {};
          }, an = function i(r, u, _) {
            (function(w, I) {
              if (!(w instanceof I)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = u || null, this.ttl = _ || NaN, this.queryParams = {};
          };
          function Kt(i, r) {
            var u = Object.keys(i);
            if (Object.getOwnPropertySymbols) {
              var _ = Object.getOwnPropertySymbols(i);
              r && (_ = _.filter(function(w) {
                return Object.getOwnPropertyDescriptor(i, w).enumerable;
              })), u.push.apply(u, _);
            }
            return u;
          }
          function At(i) {
            for (var r = 1; r < arguments.length; r++) {
              var u = arguments[r] != null ? arguments[r] : {};
              r % 2 ? Kt(Object(u), !0).forEach(function(_) {
                tn(i, _, u[_]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(u)) : Kt(Object(u)).forEach(function(_) {
                Object.defineProperty(i, _, Object.getOwnPropertyDescriptor(u, _));
              });
            }
            return i;
          }
          function tn(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Jt(i, r) {
            var u;
            if (typeof Symbol > "u" || i[Symbol.iterator] == null) {
              if (Array.isArray(i) || (u = dn(i)) || r) {
                u && (i = u);
                var _ = 0, w = function() {
                };
                return { s: w, n: function() {
                  return _ >= i.length ? { done: !0 } : { done: !1, value: i[_++] };
                }, e: function(F) {
                  throw F;
                }, f: w };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var I, y = !0, C = !1;
            return { s: function() {
              u = i[Symbol.iterator]();
            }, n: function() {
              var F = u.next();
              return y = F.done, F;
            }, e: function(F) {
              C = !0, I = F;
            }, f: function() {
              try {
                y || u.return == null || u.return();
              } finally {
                if (C) throw I;
              }
            } };
          }
          function dn(i, r) {
            if (i) {
              if (typeof i == "string") return bn(i, r);
              var u = Object.prototype.toString.call(i).slice(8, -1);
              return u === "Object" && i.constructor && (u = i.constructor.name), u === "Map" || u === "Set" ? Array.from(i) : u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u) ? bn(i, r) : void 0;
            }
          }
          function bn(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function Cn() {
            var i, r, u, _, w = this.context, I = (0, tt.Z)(w).getInstance(), y = Number.isInteger || function(g) {
              return typeof g == "number" && isFinite(g) && Math.floor(g) === g;
            };
            function C(g, L) {
              if (!g) throw new Error("adaptation is not defined");
              if (!L) throw new Error("type is not defined");
              if (g.Representation_asArray && g.Representation_asArray.length) {
                var D = fe(g.Representation_asArray[0]);
                if (D && D.length > 0 && Gt.Y.indexOf(D[0].schemeIdUri) >= 0) return L === t.Z.IMAGE;
              }
              if (g.ContentComponent_asArray && g.ContentComponent_asArray.length > 0) {
                if (g.ContentComponent_asArray.length > 1) return L === t.Z.MUXED;
                if (g.ContentComponent_asArray[0].contentType === L) return !0;
              }
              var O = L === t.Z.TEXT ? new RegExp("(ttml|vtt|wvtt|stpp)") : new RegExp(L);
              if (g.Representation_asArray && g.Representation_asArray.length) {
                var A = g.Representation_asArray[0].codecs;
                if (O.test(A)) return !0;
              }
              if (g.hasOwnProperty(e.Z.MIME_TYPE)) return O.test(g.mimeType);
              if (g.Representation_asArray) {
                for (var oe, Q = 0; Q < g.Representation_asArray.length; Q++) if ((oe = g.Representation_asArray[Q]).hasOwnProperty(e.Z.MIME_TYPE)) return O.test(oe.mimeType);
              }
              return !1;
            }
            function F(g) {
              if (!g) throw new Error("adaptation is not defined");
              if (g.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) || g.hasOwnProperty(e.Z.SEGMENT_TIMELINE) || g.hasOwnProperty(e.Z.SEGMENT_LIST) || g.hasOwnProperty(e.Z.SEGMENT_BASE)) return !0;
              if (g.Representation_asArray && g.Representation_asArray.length > 0) {
                var L = g.Representation_asArray[0];
                if (L.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) || L.hasOwnProperty(e.Z.SEGMENT_TIMELINE) || L.hasOwnProperty(e.Z.SEGMENT_LIST) || L.hasOwnProperty(e.Z.SEGMENT_BASE)) return !0;
              }
              return !1;
            }
            function Y(g) {
              return C(g, t.Z.VIDEO);
            }
            function H(g) {
              return C(g, t.Z.TEXT);
            }
            function N(g) {
              return C(g, t.Z.IMAGE);
            }
            function U(g) {
              return g && Array.isArray(g.Representation_asArray) && g.Representation_asArray.sort(function(L, D) {
                return L.bandwidth - D.bandwidth;
              }), g;
            }
            function Z(g, L) {
              return g && g.Period_asArray && y(L) && g.Period_asArray[L] ? g.Period_asArray[L].AdaptationSet_asArray : [];
            }
            function me(g) {
              return g && g.Period_asArray ? g.Period_asArray : [];
            }
            function ae(g) {
              var L = !1;
              return g && g.hasOwnProperty("type") && (L = g.type === e.Z.DYNAMIC), L;
            }
            function fe(g) {
              return g && g.EssentialProperty_asArray && g.EssentialProperty_asArray.length ? g.EssentialProperty_asArray.map(function(L) {
                return { schemeIdUri: L.schemeIdUri, value: L.value };
              }) : null;
            }
            function _e(g) {
              if (!g || !g.S_asArray) return NaN;
              var L = g.S_asArray[0], D = g.S_asArray[1];
              return L.hasOwnProperty("d") ? L.d : D.t - L.t;
            }
            function q(g, L) {
              if (!g) throw new Error("Period cannot be null or undefined");
              var D = zn.DEFAULT_ID + "_" + L;
              return g.hasOwnProperty(e.Z.ID) && g.id.length > 0 && g.id !== "__proto__" && (D = g.id), D;
            }
            function le(g, L, D) {
              var O, A = [];
              if (!g) return A;
              for (O = 0; O < g.length; O++) {
                var oe = new li();
                if (oe.timescale = 1, oe.representation = L, !g[O].hasOwnProperty(t.Z.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                oe.schemeIdUri = g[O].schemeIdUri, g[O].hasOwnProperty(e.Z.TIMESCALE) && (oe.timescale = g[O].timescale), g[O].hasOwnProperty(e.Z.VALUE) && (oe.value = g[O].value), A.push(oe), oe.period = D;
              }
              return A;
            }
            function K(g) {
              var L = [], D = g.BaseURL_asArray || [g.baseUri], O = !1;
              return D.some(function(A) {
                if (A) {
                  var oe = new Ir(), Q = A.__text || A;
                  return I.isRelative(Q) && (O = !0, g.baseUri && (Q = I.resolve(Q, g.baseUri))), oe.url = Q, A.hasOwnProperty(e.Z.SERVICE_LOCATION) && A.serviceLocation.length ? oe.serviceLocation = A.serviceLocation : oe.serviceLocation = Q, A.hasOwnProperty(e.Z.DVB_PRIORITY) && (oe.dvbPriority = A[e.Z.DVB_PRIORITY]), A.hasOwnProperty(e.Z.DVB_WEIGHT) && (oe.dvbWeight = A[e.Z.DVB_WEIGHT]), A.hasOwnProperty(e.Z.AVAILABILITY_TIME_OFFSET) && (oe.availabilityTimeOffset = A[e.Z.AVAILABILITY_TIME_OFFSET]), A.hasOwnProperty(e.Z.AVAILABILITY_TIME_COMPLETE) && (oe.availabilityTimeComplete = A[e.Z.AVAILABILITY_TIME_COMPLETE] !== "false"), L.push(oe), O;
                }
              }), L;
            }
            function de(g) {
              var L = new wt();
              return L.serverUrl = g.__text, g.hasOwnProperty(e.Z.DEFAULT_SERVICE_LOCATION) && (L.defaultServiceLocation = g[e.Z.DEFAULT_SERVICE_LOCATION], L.defaultServiceLocationArray = L.defaultServiceLocation.split(" ")), g.hasOwnProperty(e.Z.QUERY_BEFORE_START) && (L.queryBeforeStart = g[e.Z.QUERY_BEFORE_START].toLowerCase() === "true"), g.hasOwnProperty(e.Z.CLIENT_REQUIREMENT) && (L.clientRequirement = g[e.Z.CLIENT_REQUIREMENT].toLowerCase() !== "false"), L;
            }
            return i = { getIsTypeOf: C, getIsText: H, getIsFragmented: F, getProducerReferenceTimesForAdaptation: function(g) {
              var L = g && g.hasOwnProperty(e.Z.PRODUCERREFERENCETIME_ASARRAY) ? g[e.Z.PRODUCERREFERENCETIME_ASARRAY] : [];
              (g && g.hasOwnProperty(e.Z.REPRESENTATION_ASARRAY) ? g[e.Z.REPRESENTATION_ASARRAY] : []).forEach(function(O) {
                var A;
                O.hasOwnProperty(e.Z.PRODUCERREFERENCETIME_ASARRAY) && L.push.apply(L, function(oe) {
                  if (Array.isArray(oe)) return bn(oe);
                }(A = O[e.Z.PRODUCERREFERENCETIME_ASARRAY]) || function(oe) {
                  if (typeof Symbol < "u" && Symbol.iterator in Object(oe)) return Array.from(oe);
                }(A) || dn(A) || function() {
                  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }());
              });
              var D = [];
              return L.forEach(function(O) {
                var A = new Dt();
                O.hasOwnProperty(e.Z.ID) && (A[e.Z.ID] = O[e.Z.ID], O.hasOwnProperty(e.Z.WALL_CLOCK_TIME) && (A[e.Z.WALL_CLOCK_TIME] = O[e.Z.WALL_CLOCK_TIME], O.hasOwnProperty(e.Z.PRESENTATION_TIME) && (A[e.Z.PRESENTATION_TIME] = O[e.Z.PRESENTATION_TIME], O.hasOwnProperty(e.Z.INBAND) && (A[e.Z.INBAND] = O[e.Z.INBAND] !== "false"), O.hasOwnProperty(e.Z.TYPE) && (A[e.Z.TYPE] = O[e.Z.TYPE]), D.push(A))));
              }), D;
            }, getLanguageForAdaptation: function(g) {
              var L = "";
              return g && g.hasOwnProperty(e.Z.LANG) && (L = g.lang), L;
            }, getViewpointForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.VIEWPOINT_ASARRAY) && g[e.Z.VIEWPOINT_ASARRAY].length ? g[e.Z.VIEWPOINT_ASARRAY].map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, getRolesForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ROLE_ASARRAY) && g[e.Z.ROLE_ASARRAY].length ? g[e.Z.ROLE_ASARRAY].map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, getAccessibilityForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ACCESSIBILITY_ASARRAY) && g[e.Z.ACCESSIBILITY_ASARRAY].length ? g[e.Z.ACCESSIBILITY_ASARRAY].map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, getAudioChannelConfigurationForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY) && g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].length ? g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, getAudioChannelConfigurationForRepresentation: function(g) {
              return g && g.hasOwnProperty(e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY) && g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].length ? g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, getAdaptationForIndex: function(g, L, D) {
              var O = Z(L, D);
              return O.length > 0 && y(g) ? O[g] : null;
            }, getIndexForAdaptation: function(g, L, D) {
              if (!g) return -1;
              for (var O = Z(L, D), A = 0; A < O.length; A++) if (Zt(w).getInstance().areEqual(O[A], g)) return A;
              return -1;
            }, getAdaptationForId: function(g, L, D) {
              var O, A, oe = Z(L, D);
              for (O = 0, A = oe.length; O < A; O++) if (oe[O].hasOwnProperty(e.Z.ID) && oe[O].id === g) return oe[O];
              return null;
            }, getAdaptationsForType: function(g, L, D) {
              var O, A, oe = Z(g, L), Q = [];
              for (O = 0, A = oe.length; O < A; O++) C(oe[O], D) && Q.push(U(oe[O]));
              return Q;
            }, getRealPeriods: me, getRealPeriodForIndex: function(g, L) {
              var D = me(L);
              return D.length > 0 && y(g) ? D[g] : null;
            }, getCodec: function(g, L, D) {
              var O = null;
              if (g && g.Representation_asArray && g.Representation_asArray.length > 0) {
                var A = y(L) && L >= 0 && L < g.Representation_asArray.length ? g.Representation_asArray[L] : g.Representation_asArray[0];
                A && (O = A.mimeType + ';codecs="' + A.codecs + '"', D && A.width !== void 0 && (O += ';width="' + A.width + '";height="' + A.height + '"'));
              }
              return O && (O = O.replace(/\sprofiles=[^;]*/g, "")), O;
            }, getSelectionPriority: function(g) {
              try {
                var L = g && g.selectionPriority !== void 0 ? parseInt(g.selectionPriority) : 1;
                return isNaN(L) ? 1 : L;
              } catch {
                return 1;
              }
            }, getMimeType: function(g) {
              return g && g.Representation_asArray && g.Representation_asArray.length > 0 ? g.Representation_asArray[0].mimeType : null;
            }, getKID: function(g) {
              return g && g.hasOwnProperty(e.Z.CENC_DEFAULT_KID) ? g[e.Z.CENC_DEFAULT_KID] : null;
            }, getLabelsForAdaptation: function(g) {
              if (!g || !Array.isArray(g.Label_asArray)) return [];
              for (var L = [], D = 0; D < g.Label_asArray.length; D++) L.push({ lang: g.Label_asArray[D].lang, text: g.Label_asArray[D].__text || g.Label_asArray[D] });
              return L;
            }, getContentProtectionData: function(g) {
              return g && g.hasOwnProperty(e.Z.CONTENTPROTECTION_ASARRAY) && g.ContentProtection_asArray.length !== 0 ? g.ContentProtection_asArray : null;
            }, getIsDynamic: ae, getId: function(g) {
              return g && g[e.Z.ID] || null;
            }, hasProfile: function(g, L) {
              var D = !1;
              return g && g.profiles && g.profiles.length > 0 && (D = g.profiles.indexOf(L) !== -1), D;
            }, getDuration: function(g) {
              return g && g.hasOwnProperty(e.Z.MEDIA_PRESENTATION_DURATION) ? g.mediaPresentationDuration : g && g.type == "dynamic" ? Number.POSITIVE_INFINITY : Number.MAX_SAFE_INTEGER || Number.MAX_VALUE;
            }, getBandwidth: function(g) {
              return g && g.bandwidth ? g.bandwidth : NaN;
            }, getManifestUpdatePeriod: function(g) {
              var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, D = NaN;
              return g && g.hasOwnProperty(e.Z.MINIMUM_UPDATE_PERIOD) && (D = g.minimumUpdatePeriod), isNaN(D) ? D : Math.max(D - L, 1);
            }, getPublishTime: function(g) {
              return g && g.hasOwnProperty(e.Z.PUBLISH_TIME) ? new Date(g[e.Z.PUBLISH_TIME]) : null;
            }, getRepresentationCount: function(g) {
              return g && Array.isArray(g.Representation_asArray) ? g.Representation_asArray.length : 0;
            }, getBitrateListForAdaptation: function(g) {
              var L = U(g);
              return (L && Array.isArray(L.Representation_asArray) ? L.Representation_asArray : []).map(function(D) {
                return { bandwidth: D.bandwidth, width: D.width || 0, height: D.height || 0, scanType: D.scanType || null, id: D.id || null };
              });
            }, getRepresentationFor: function(g, L) {
              return L && L.Representation_asArray && L.Representation_asArray.length > 0 && y(g) ? L.Representation_asArray[g] : null;
            }, getRepresentationsForAdaptation: function(g) {
              var L, D, O, A, oe = [], Q = function(Ne) {
                if (Ne && Ne.period && y(Ne.period.index)) {
                  var Fe = Ne.period.mpd.manifest.Period_asArray[Ne.period.index];
                  if (Fe && Fe.AdaptationSet_asArray && y(Ne.index)) return U(Fe.AdaptationSet_asArray[Ne.index]);
                }
              }(g);
              if (Q && Q.Representation_asArray) {
                if (g && g.period && y(g.period.index)) {
                  var ue = K(g.period.mpd.manifest);
                  ue && (D = ue[0]);
                }
                for (var ee = 0, k = Q.Representation_asArray.length; ee < k; ++ee) {
                  var ne = Q.Representation_asArray[ee], ve = new tr();
                  if (ve.index = ee, ve.adaptation = g, ne.hasOwnProperty(e.Z.ID) && (ve.id = ne.id), ne.hasOwnProperty(e.Z.CODECS) && (ve.codecs = ne.codecs), ne.hasOwnProperty(e.Z.MIME_TYPE) && (ve.mimeType = ne[e.Z.MIME_TYPE]), ne.hasOwnProperty(e.Z.CODEC_PRIVATE_DATA) && (ve.codecPrivateData = ne.codecPrivateData), ne.hasOwnProperty(e.Z.BANDWITH) && (ve.bandwidth = ne.bandwidth), ne.hasOwnProperty(e.Z.WIDTH) && (ve.width = ne.width), ne.hasOwnProperty(e.Z.HEIGHT) && (ve.height = ne.height), ne.hasOwnProperty(e.Z.SCAN_TYPE) && (ve.scanType = ne.scanType), ne.hasOwnProperty(e.Z.MAX_PLAYOUT_RATE) && (ve.maxPlayoutRate = ne.maxPlayoutRate), ne.hasOwnProperty(e.Z.SEGMENT_BASE) ? (L = ne.SegmentBase, ve.segmentInfoType = e.Z.SEGMENT_BASE) : ne.hasOwnProperty(e.Z.SEGMENT_LIST) ? (L = ne.SegmentList).hasOwnProperty(e.Z.SEGMENT_TIMELINE) ? ve.segmentInfoType = e.Z.SEGMENT_TIMELINE : ve.segmentInfoType = e.Z.SEGMENT_LIST : ne.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) ? ((L = ne.SegmentTemplate).hasOwnProperty(e.Z.SEGMENT_TIMELINE) ? ve.segmentInfoType = e.Z.SEGMENT_TIMELINE : ve.segmentInfoType = e.Z.SEGMENT_TEMPLATE, L.hasOwnProperty(e.Z.INITIALIZATION_MINUS) && (ve.initialization = L.initialization.split("$Bandwidth$").join(ne.bandwidth).split("$RepresentationID$").join(ne.id))) : ve.segmentInfoType = e.Z.BASE_URL, ve.essentialProperties = fe(ne), L) {
                    if (L.hasOwnProperty(e.Z.INITIALIZATION)) {
                      var xe = L.Initialization;
                      xe.hasOwnProperty(e.Z.SOURCE_URL) && (ve.initialization = xe.sourceURL), xe.hasOwnProperty(e.Z.RANGE) && (ve.range = xe.range);
                    } else H(Q) && F(Q) && Q.mimeType && Q.mimeType.indexOf("application/mp4") === -1 && (ve.range = 0);
                    L.hasOwnProperty(e.Z.TIMESCALE) && (ve.timescale = L.timescale), L.hasOwnProperty(e.Z.DURATION) ? ve.segmentDuration = L.duration / ve.timescale : ne.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) && (L = ne.SegmentTemplate).hasOwnProperty(e.Z.SEGMENT_TIMELINE) && (ve.segmentDuration = _e(L.SegmentTimeline) / ve.timescale), L.hasOwnProperty(e.Z.MEDIA) && (ve.media = L.media), L.hasOwnProperty(e.Z.START_NUMBER) && (ve.startNumber = L.startNumber), L.hasOwnProperty(e.Z.INDEX_RANGE) && (ve.indexRange = L.indexRange), L.hasOwnProperty(e.Z.PRESENTATION_TIME_OFFSET) && (ve.presentationTimeOffset = L.presentationTimeOffset / ve.timescale), L.hasOwnProperty(e.Z.AVAILABILITY_TIME_OFFSET) ? ve.availabilityTimeOffset = L.availabilityTimeOffset : D && D.availabilityTimeOffset !== void 0 && (ve.availabilityTimeOffset = D.availabilityTimeOffset), L.hasOwnProperty(e.Z.AVAILABILITY_TIME_COMPLETE) ? ve.availabilityTimeComplete = L.availabilityTimeComplete !== "false" : D && D.availabilityTimeComplete !== void 0 && (ve.availabilityTimeComplete = D.availabilityTimeComplete);
                  }
                  ve.MSETimeOffset = (A = (O = ve).presentationTimeOffset, O.adaptation.period.start - A), ve.path = [g.period.index, g.index, ee], oe.push(ve);
                }
              }
              return oe;
            }, getAdaptationsForPeriod: function(g) {
              var L, D, O, A = g && y(g.index) ? g.mpd.manifest.Period_asArray[g.index] : null, oe = [];
              if (A && A.AdaptationSet_asArray) for (O = 0; O < A.AdaptationSet_asArray.length; O++) D = A.AdaptationSet_asArray[O], L = new wn(), D.hasOwnProperty(e.Z.ID) && (L.id = D.id), L.index = O, L.period = g, C(D, t.Z.MUXED) ? L.type = t.Z.MUXED : C(D, t.Z.AUDIO) ? L.type = t.Z.AUDIO : Y(D) ? L.type = t.Z.VIDEO : H(D) ? L.type = t.Z.TEXT : N(D) ? L.type = t.Z.IMAGE : r.warn("Unknown Adaptation stream type"), oe.push(L);
              return oe;
            }, getRegularPeriods: function(g) {
              var L, D, O = !!g && ae(g.manifest), A = [], oe = null, Q = null, ue = null, ee = null;
              for (D = 0, L = g && g.manifest && g.manifest.Period_asArray ? g.manifest.Period_asArray.length : 0; D < L; D++) (Q = g.manifest.Period_asArray[D]).hasOwnProperty(e.Z.START) ? (ee = new zn()).start = Q.start : oe !== null && oe.hasOwnProperty(e.Z.DURATION) && ue !== null ? (ee = new zn()).start = parseFloat((ue.start + ue.duration).toFixed(5)) : D !== 0 || O || ((ee = new zn()).start = 0), ue !== null && isNaN(ue.duration) && (ee !== null ? ue.duration = parseFloat((ee.start - ue.start).toFixed(5)) : r.warn("First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback")), ee !== null && (ee.id = q(Q, D), ee.index = D, ee.mpd = g, Q.hasOwnProperty(e.Z.DURATION) && (ee.duration = Q.duration), ue && (ue.nextPeriodId = ee.id), A.push(ee), oe = Q, ue = ee), Q = null, ee = null;
              return A.length === 0 || ue !== null && isNaN(ue.duration) && (ue.duration = parseFloat((function(k) {
                (function() {
                  if (!u || !u.hasOwnProperty("error")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
                })();
                var ne, ve = ae(k.mpd.manifest);
                return k.mpd.manifest.mediaPresentationDuration ? ne = k.mpd.manifest.mediaPresentationDuration : k.duration ? ne = k.duration : ve ? ne = Number.POSITIVE_INFINITY : u.error(new se.Z($.MANIFEST_ERROR_ID_PARSE_CODE, "Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.", k)), ne;
              }(ue) - ue.start).toFixed(5))), A;
            }, getMpd: function(g) {
              var L = new or();
              return g && (L.manifest = g, g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME) ? L.availabilityStartTime = new Date(g.availabilityStartTime.getTime()) : g.loadedTime && (L.availabilityStartTime = new Date(g.loadedTime.getTime())), g.hasOwnProperty(e.Z.AVAILABILITY_END_TIME) && (L.availabilityEndTime = new Date(g.availabilityEndTime.getTime())), g.hasOwnProperty(e.Z.MINIMUM_UPDATE_PERIOD) && (L.minimumUpdatePeriod = g.minimumUpdatePeriod), g.hasOwnProperty(e.Z.MEDIA_PRESENTATION_DURATION) && (L.mediaPresentationDuration = g.mediaPresentationDuration), g.hasOwnProperty(e.Z.SUGGESTED_PRESENTATION_DELAY) && (L.suggestedPresentationDelay = g.suggestedPresentationDelay), g.hasOwnProperty(e.Z.TIMESHIFT_BUFFER_DEPTH) && (L.timeShiftBufferDepth = g.timeShiftBufferDepth), g.hasOwnProperty(e.Z.MAX_SEGMENT_DURATION) && (L.maxSegmentDuration = g.maxSegmentDuration), g.hasOwnProperty(e.Z.PUBLISH_TIME) && (L.publishTime = new Date(g.publishTime))), L;
            }, getEventsForPeriod: function(g) {
              var L, D, O = g && g.mpd && g.mpd.manifest ? g.mpd.manifest : null, A = O ? O.Period_asArray : null, oe = A && g && y(g.index) ? A[g.index].EventStream_asArray : null, Q = [];
              if (oe) for (L = 0; L < oe.length; L++) {
                var ue = new li();
                if (ue.period = g, ue.timescale = 1, !oe[L].hasOwnProperty(t.Z.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                for (ue.schemeIdUri = oe[L][t.Z.SCHEME_ID_URI], oe[L].hasOwnProperty(e.Z.TIMESCALE) && (ue.timescale = oe[L][e.Z.TIMESCALE]), oe[L].hasOwnProperty(e.Z.VALUE) && (ue.value = oe[L][e.Z.VALUE]), oe[L].hasOwnProperty(e.Z.PRESENTATION_TIME_OFFSET) && (ue.presentationTimeOffset = oe[L][e.Z.PRESENTATION_TIME_OFFSET]), D = 0; oe[L].Event_asArray && D < oe[L].Event_asArray.length; D++) {
                  var ee = oe[L].Event_asArray[D], k = new sr();
                  k.presentationTime = 0, k.eventStream = ue, ee.hasOwnProperty(e.Z.PRESENTATION_TIME) && (k.presentationTime = ee.presentationTime);
                  var ne = ue.presentationTimeOffset ? ue.presentationTimeOffset / ue.timescale : 0;
                  k.calculatedPresentationTime = k.presentationTime / ue.timescale + g.start - ne, ee.hasOwnProperty(e.Z.DURATION) && (k.duration = ee.duration / ue.timescale), ee.hasOwnProperty(e.Z.ID) ? k.id = ee.id : k.id = null, ee.Signal && ee.Signal.Binary ? k.messageData = _.decodeArray(ee.Signal.Binary.toString()) : k.messageData = ee.messageData || ee.__cdata || ee.__text, Q.push(k);
                }
              }
              return Q;
            }, getEssentialPropertiesForAdaptation: function(g) {
              var L = {};
              if (g && g.hasOwnProperty(e.Z.ESSENTIAL_PROPERTY_ASARRAY)) {
                var D, O = Jt(g.EssentialProperty_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (L[A[t.Z.SCHEME_ID_URI]] = At({}, A));
                  }
                } catch (oe) {
                  O.e(oe);
                } finally {
                  O.f();
                }
              }
              return L;
            }, getEssentialPropertiesAsArrayForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ESSENTIAL_PROPERTY_ASARRAY) && g.EssentialProperty_asArray.length ? g.EssentialProperty_asArray.map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, getEssentialPropertiesForRepresentation: fe, getEventStreamForAdaptationSet: function(g, L, D) {
              var O, A, oe;
              return g && g.Period_asArray && L && L.period && y(L.period.index) && (A = g.Period_asArray[L.period.index]) && A.AdaptationSet_asArray && y(L.index) && (oe = A.AdaptationSet_asArray[L.index]) && (O = oe.InbandEventStream_asArray), le(O, null, D);
            }, getEventStreamForRepresentation: function(g, L, D) {
              var O, A, oe, Q;
              return g && g.Period_asArray && L && L.adaptation && L.adaptation.period && y(L.adaptation.period.index) && (A = g.Period_asArray[L.adaptation.period.index]) && A.AdaptationSet_asArray && y(L.adaptation.index) && (oe = A.AdaptationSet_asArray[L.adaptation.index]) && oe.Representation_asArray && y(L.index) && (Q = oe.Representation_asArray[L.index]) && (O = Q.InbandEventStream_asArray), le(O, L, D);
            }, getUTCTimingSources: function(g) {
              var L = ae(g), D = !!g && g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME), O = g ? g.UTCTiming_asArray : null, A = [];
              return (L || D) && O && O.forEach(function(oe) {
                var Q = new vr.Z();
                oe.hasOwnProperty(t.Z.SCHEME_ID_URI) && (Q.schemeIdUri = oe.schemeIdUri, oe.hasOwnProperty(e.Z.VALUE) && (Q.value = oe.value.toString(), A.push(Q)));
              }), A;
            }, getBaseURLsFromElement: K, getRepresentationSortFunction: function() {
              return function(g, L) {
                return g.bandwidth - L.bandwidth;
              };
            }, getContentSteering: function(g) {
              if (g && g.hasOwnProperty(e.Z.CONTENT_STEERING_AS_ARRAY)) return de(g[e.Z.CONTENT_STEERING_AS_ARRAY][0]);
            }, getLocation: function(g) {
              return g && g.hasOwnProperty(e.Z.LOCATION_AS_ARRAY) ? g[e.Z.LOCATION_AS_ARRAY].map(function(L) {
                var D = L.__text || L, O = L.hasOwnProperty(e.Z.SERVICE_LOCATION) ? L[e.Z.SERVICE_LOCATION] : null;
                return new nn(D, O);
              }) : [];
            }, getPatchLocation: function(g) {
              return g && g.hasOwnProperty(e.Z.PATCH_LOCATION_AS_ARRAY) ? g[e.Z.PATCH_LOCATION_AS_ARRAY].map(function(L) {
                var D = L.__text || L, O = L.hasOwnProperty(e.Z.SERVICE_LOCATION) ? L[e.Z.SERVICE_LOCATION] : null, A = L.hasOwnProperty(e.Z.TTL) ? 1e3 * parseFloat(L[e.Z.TTL]) : NaN;
                return new an(D, O, A);
              }) : [];
            }, getSuggestedPresentationDelay: function(g) {
              return g && g.hasOwnProperty(e.Z.SUGGESTED_PRESENTATION_DELAY) ? g.suggestedPresentationDelay : null;
            }, getAvailabilityStartTime: function(g) {
              return g && g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME) && g.availabilityStartTime !== null ? g.availabilityStartTime.getTime() : null;
            }, getServiceDescriptions: function(g) {
              var L = [];
              if (g && g.hasOwnProperty(e.Z.SERVICE_DESCRIPTION)) {
                var D, O = Jt(g.ServiceDescription_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value, oe = null, Q = null, ue = null, ee = null, k = null, ne = null, ve = null;
                    for (var xe in A) A.hasOwnProperty(xe) && (xe === e.Z.ID ? oe = A[xe] : xe === e.Z.SERVICE_DESCRIPTION_SCOPE ? Q = A[xe].schemeIdUri : xe === e.Z.SERVICE_DESCRIPTION_LATENCY ? ue = { target: parseInt(A[xe].target), max: parseInt(A[xe].max), min: parseInt(A[xe].min), referenceId: parseInt(A[xe].referenceId) } : xe === e.Z.SERVICE_DESCRIPTION_PLAYBACK_RATE ? ee = { max: parseFloat(A[xe].max), min: parseFloat(A[xe].min) } : xe === e.Z.SERVICE_DESCRIPTION_OPERATING_QUALITY ? k = { mediaType: A[xe].mediaType, max: parseInt(A[xe].max), min: parseInt(A[xe].min), target: parseInt(A[xe].target), type: A[xe].type, maxQualityDifference: parseInt(A[xe].maxQualityDifference) } : xe === e.Z.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH ? ne = { mediaType: A[xe].mediaType, max: parseInt(A[xe].max), min: parseInt(A[xe].min), target: parseInt(A[xe].target) } : xe === e.Z.CONTENT_STEERING && (ve = de(A[xe])));
                    L.push({ id: oe, schemeIdUri: Q, latency: ue, playbackRate: ee, operatingQuality: k, operatingBandwidth: ne, contentSteering: ve });
                  }
                } catch (Ne) {
                  O.e(Ne);
                } finally {
                  O.f();
                }
              }
              return L;
            }, getSegmentAlignment: function(g) {
              return !(!g || !g.hasOwnProperty(e.Z.SEGMENT_ALIGNMENT)) && g[e.Z.SEGMENT_ALIGNMENT] === "true";
            }, getSubSegmentAlignment: function(g) {
              return !(!g || !g.hasOwnProperty(e.Z.SUB_SEGMENT_ALIGNMENT)) && g[e.Z.SUB_SEGMENT_ALIGNMENT] === "true";
            }, getSupplementalPropertiesForAdaptation: function(g) {
              var L = {};
              if (g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY)) {
                var D, O = Jt(g.SupplementalProperty_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (L[A[t.Z.SCHEME_ID_URI]] = At({}, A));
                  }
                } catch (oe) {
                  O.e(oe);
                } finally {
                  O.f();
                }
              }
              return L;
            }, getSupplementalPropertiesAsArrayForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY) && g.SupplementalProperty_asArray.length ? g.SupplementalProperty_asArray.map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, getSupplementalPropertiesForRepresentation: function(g) {
              var L = {};
              if (g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY)) {
                var D, O = Jt(g.SupplementalProperty_asArray);
                try {
                  for (O.s(); !(D = O.n()).done; ) {
                    var A = D.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (L[A[t.Z.SCHEME_ID_URI]] = At({}, A));
                  }
                } catch (oe) {
                  O.e(oe);
                } finally {
                  O.f();
                }
              }
              return L;
            }, getSupplementalPropertiesAsArrayForRepresentation: function(g) {
              return g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY) && g.SupplementalProperty_asArray.length ? g.SupplementalProperty_asArray.map(function(L) {
                return new Ye().init(L);
              }) : [];
            }, setConfig: function(g) {
              g && (g.errHandler && (u = g.errHandler), g.BASE64 && (_ = g.BASE64));
            } }, r = (0, h.Z)(w).getInstance().getLogger(i), i;
          }
          Cn.__dashjs_factory_name = "DashManifestModel";
          var ln = v.Z.getSingletonFactory(Cn), St = R(703);
          function Ot(i, r) {
            var u;
            if (typeof Symbol > "u" || i[Symbol.iterator] == null) {
              if (Array.isArray(i) || (u = function(F, Y) {
                if (F) {
                  if (typeof F == "string") return jt(F, Y);
                  var H = Object.prototype.toString.call(F).slice(8, -1);
                  return H === "Object" && F.constructor && (H = F.constructor.name), H === "Map" || H === "Set" ? Array.from(F) : H === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(H) ? jt(F, Y) : void 0;
                }
              }(i)) || r) {
                u && (i = u);
                var _ = 0, w = function() {
                };
                return { s: w, n: function() {
                  return _ >= i.length ? { done: !0 } : { done: !1, value: i[_++] };
                }, e: function(F) {
                  throw F;
                }, f: w };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var I, y = !0, C = !1;
            return { s: function() {
              u = i[Symbol.iterator]();
            }, n: function() {
              var F = u.next();
              return y = F.done, F;
            }, e: function(F) {
              C = !0, I = F;
            }, f: function() {
              try {
                y || u.return == null || u.return();
              } finally {
                if (C) throw I;
              }
            } };
          }
          function jt(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function fn() {
            var i, r, u, _, w, I, y, C, F, Y, H = this.context, N = (0, p.Z)(H).getInstance(), U = (0, Me.Z)(H).getInstance();
            function Z() {
              u = { pr: 1, nor: null, st: null, sf: null, sid: "".concat(St.Z.generateUuid()), cid: null }, F = {}, C = {}, Y = {}, ae();
            }
            function me() {
              ae();
            }
            function ae() {
              if (I) {
                var A = I.getStreamController();
                if (A && typeof A.getActiveStream == "function") {
                  var oe = A.getActiveStream();
                  oe && (y = oe.getProcessors());
                }
              }
            }
            function fe(A, oe) {
              var Q, ue = {}, ee = Ot(oe);
              try {
                for (ee.s(); !(Q = ee.n()).done; ) {
                  var k = Q.value;
                  A[k] && (ue[k] = A[k]);
                }
              } catch (ne) {
                ee.e(ne);
              } finally {
                ee.f();
              }
              return ue;
            }
            function _e(A) {
              var oe = U.get().streaming.cmcd.enabledKeys;
              return A.filter(function(Q) {
                return oe.includes(Q);
              });
            }
            function q(A) {
              try {
                return A.type === Ge.w.MPD_TYPE ? ((Q = le()).ot = "m", Q) : A.type === Ge.w.MEDIA_SEGMENT_TYPE ? (oe = A.mediaType, Y.hasOwnProperty(oe) || (Y[oe] = !1), C.hasOwnProperty(oe) || (C[oe] = !1), F.hasOwnProperty(oe) || (F[oe] = !1), function(ue) {
                  var ee, k = le(), ne = function(rt) {
                    try {
                      var Bt = rt.quality, we = rt.mediaInfo.bitrateList;
                      return parseInt(we[Bt].bandwidth / 1e3);
                    } catch {
                      return null;
                    }
                  }(ue), ve = function(rt) {
                    try {
                      return isNaN(rt.duration) ? NaN : Math.round(1e3 * rt.duration);
                    } catch {
                      return null;
                    }
                  }(ue), xe = function(rt) {
                    try {
                      return 100 * parseInt(_.getThroughputHistory().getSafeAverageThroughput(rt) / 100);
                    } catch {
                      return null;
                    }
                  }(ue.mediaType), Ne = function(rt) {
                    try {
                      var Bt = u.pr, we = w.getCurrentBufferLevel(rt);
                      return isNaN(Bt) || isNaN(we) ? null : 100 * parseInt(we / Bt * 10);
                    } catch {
                      return null;
                    }
                  }(ue.mediaType), Fe = K(ue.mediaType), Le = function(rt) {
                    try {
                      var Bt = _.getTopBitrateInfoFor(rt);
                      return Math.round(Bt.bitrate / 1e3);
                    } catch {
                      return null;
                    }
                  }(ue.mediaType), ut = u.pr, ct = function(rt) {
                    if (y && y.length !== 0) {
                      var Bt, we = Ot(y);
                      try {
                        for (we.s(); !(Bt = we.n()).done; ) {
                          var He = Bt.value;
                          if (He.getType() === rt) return He.probeNextRequest();
                        }
                      } catch (pt) {
                        we.e(pt);
                      } finally {
                        we.f();
                      }
                    }
                  }(ue.mediaType);
                  ue.mediaType === t.Z.VIDEO && (ee = "v"), ue.mediaType === t.Z.AUDIO && (ee = "a"), ue.mediaType === t.Z.TEXT && (ee = ue.mediaInfo.mimeType === "application/mp4" ? "tt" : "c");
                  var nt = U.get().streaming.cmcd.rtp;
                  return nt || (nt = function(rt) {
                    try {
                      var Bt = I.getPlaybackRate();
                      Bt || (Bt = 1);
                      var we = rt.quality, He = rt.mediaType, pt = rt.mediaInfo, We = rt.duration;
                      if (!pt) return NaN;
                      var Tt = K(He);
                      Tt === 0 && (Tt = 500);
                      var vt = pt.bitrateList[we].bandwidth * We / 1e3 / (Tt / Bt / 1e3), ht = U.get().streaming.cmcd.rtpSafetyFactor && !isNaN(U.get().streaming.cmcd.rtpSafetyFactor) ? U.get().streaming.cmcd.rtpSafetyFactor : 5;
                      return 100 * (parseInt(vt * ht / 100) + 1);
                    } catch {
                      return NaN;
                    }
                  }(ue)), isNaN(nt) || (k.rtp = nt), ct && (ue.url !== ct.url ? k.nor = encodeURIComponent(St.Z.getRelativeUrl(ue.url, ct.url)) : ct.range && (k.nrr = ct.range)), ne && (k.br = ne), ee && (k.ot = ee), isNaN(ve) || (k.d = ve), isNaN(xe) || (k.mtp = xe), isNaN(Ne) || (k.dl = Ne), isNaN(Fe) || (k.bl = Fe), isNaN(Le) || (k.tb = Le), isNaN(ut) || ut === 1 || (k.pr = ut), F[ue.mediaType] && (k.bs = !0, F[ue.mediaType] = !1), !C[ue.mediaType] && Y[ue.mediaType] || (k.su = !0, C[ue.mediaType] = !1, Y[ue.mediaType] = !0), k;
                }(A)) : A.type === Ge.w.INIT_SEGMENT_TYPE ? function() {
                  var ue = le();
                  return ue.ot = "i", ue.su = !0, ue;
                }() : A.type === Ge.w.OTHER_TYPE || A.type === Ge.w.XLINK_EXPANSION_TYPE ? function() {
                  var ue = le();
                  return ue.ot = "o", ue;
                }() : A.type === Ge.w.LICENSE ? function(ue) {
                  var ee = le();
                  return ee.ot = "k", ee;
                }() : null;
              } catch {
                return null;
              }
              var oe, Q;
            }
            function le() {
              var A = {}, oe = U.get().streaming.cmcd.cid ? U.get().streaming.cmcd.cid : u.cid;
              return A.v = 1, A.sid = U.get().streaming.cmcd.sid ? U.get().streaming.cmcd.sid : u.sid, A.sid = "".concat(A.sid), oe && (A.cid = "".concat(oe)), isNaN(u.pr) || u.pr === 1 || u.pr === null || (A.pr = u.pr), u.st && (A.st = u.st), u.sf && (A.sf = u.sf), A;
            }
            function K(A) {
              try {
                var oe = w.getCurrentBufferLevel(A);
                return isNaN(oe) ? null : 100 * parseInt(10 * oe);
              } catch {
                return null;
              }
            }
            function de(A) {
              try {
                u.pr = A.playbackRate;
              } catch {
              }
            }
            function g(A) {
              try {
                var oe = i.getIsDynamic(A.data) ? "l" : "v", Q = A.protocol && A.protocol === "MSS" ? "s" : "d";
                u.st = "".concat(oe), u.sf = "".concat(Q);
              } catch {
              }
            }
            function L(A) {
              try {
                A.state && A.mediaType && A.state === n.Z.BUFFER_EMPTY && (F[A.mediaType] || (F[A.mediaType] = !0), C[A.mediaType] || (C[A.mediaType] = !0));
              } catch {
              }
            }
            function D() {
              for (var A in F) F.hasOwnProperty(A) && (F[A] = !0);
              for (var oe in C) C.hasOwnProperty(oe) && (C[oe] = !0);
            }
            function O(A) {
              try {
                if (!A) return null;
                var oe = Object.keys(A).sort(function(ee, k) {
                  return ee.localeCompare(k);
                }), Q = oe.length, ue = oe.reduce(function(ee, k, ne) {
                  return k === "v" && A[k] === 1 || (typeof A[k] == "string" && k !== "ot" && k !== "sf" && k !== "st" ? ee += "".concat(k, "=").concat(JSON.stringify(A[k])) : ee += "".concat(k, "=").concat(A[k]), ne < Q - 1 && (ee += ",")), ee;
                }, "");
                return (ue = ue.replace(/=true/g, "")).replace(/,\s*$/, "");
              } catch {
                return null;
              }
            }
            return r = { getQueryParameter: function(A) {
              try {
                if (U.get().streaming.cmcd && U.get().streaming.cmcd.enabled) {
                  var oe = q(A), Q = function(ee) {
                    try {
                      var k = U.get().streaming.cmcd.enabledKeys;
                      return Object.keys(ee).filter(function(ne) {
                        return k.includes(ne);
                      }).reduce(function(ne, ve) {
                        return ne[ve] = ee[ve], ne;
                      }, {});
                    } catch {
                      return ee;
                    }
                  }(oe), ue = O(Q);
                  return N.trigger(Mn.Z.CMCD_DATA_GENERATED, { url: A.url, mediaType: A.mediaType, cmcdData: oe, cmcdString: ue }), { key: "CMCD", value: ue };
                }
                return null;
              } catch {
                return null;
              }
            }, getHeaderParameters: function(A) {
              try {
                if (U.get().streaming.cmcd && U.get().streaming.cmcd.enabled) {
                  var oe = q(A), Q = fe(oe, _e(["br", "d", "ot", "tb"])), ue = fe(oe, _e(["bl", "dl", "mtp", "nor", "nrr", "su"])), ee = fe(oe, _e(["bs", "rtp"])), k = fe(oe, _e(["cid", "pr", "sf", "sid", "st", "v"])), ne = { "CMCD-Object": O(Q), "CMCD-Request": O(ue), "CMCD-Status": O(ee), "CMCD-Session": O(k) };
                  return N.trigger(Mn.Z.CMCD_DATA_GENERATED, { url: A.url, mediaType: A.mediaType, cmcdData: oe, headers: ne }), ne;
                }
                return null;
              } catch {
                return null;
              }
            }, setConfig: function(A) {
              A && (A.abrController && (_ = A.abrController), A.dashMetrics && (w = A.dashMetrics), A.playbackController && (I = A.playbackController));
            }, reset: function() {
              N.off(n.Z.PLAYBACK_RATE_CHANGED, de, this), N.off(n.Z.MANIFEST_LOADED, g, this), N.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, L, r), N.off(n.Z.PLAYBACK_SEEKED, D, r), Z();
            }, initialize: function() {
              N.on(n.Z.PLAYBACK_RATE_CHANGED, de, r), N.on(n.Z.MANIFEST_LOADED, g, r), N.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, L, r), N.on(n.Z.PLAYBACK_SEEKED, D, r), N.on(n.Z.PERIOD_SWITCH_COMPLETED, me, r);
            } }, i = ln(H).getInstance(), Z(), r;
          }
          fn.__dashjs_factory_name = "CmcdModel";
          var mn = v.Z.getSingletonFactory(fn);
          function In(i) {
            return In = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, In(i);
          }
          function Rn(i, r) {
            Rn = function(C, F) {
              return new I(C, void 0, F);
            };
            var u = rr(RegExp), _ = RegExp.prototype, w = /* @__PURE__ */ new WeakMap();
            function I(C, F, Y) {
              var H = u.call(this, C, F);
              return w.set(H, Y || w.get(C)), H;
            }
            function y(C, F) {
              var Y = w.get(F);
              return Object.keys(Y).reduce(function(H, N) {
                return H[N] = C[Y[N]], H;
              }, /* @__PURE__ */ Object.create(null));
            }
            return nr(I, u), I.prototype.exec = function(C) {
              var F = _.exec.call(this, C);
              return F && (F.groups = y(F, this)), F;
            }, I.prototype[Symbol.replace] = function(C, F) {
              if (typeof F == "string") {
                var Y = w.get(this);
                return _[Symbol.replace].call(this, C, F.replace(/\$<([^>]+)>/g, function(N, U) {
                  return "$" + Y[U];
                }));
              }
              if (typeof F == "function") {
                var H = this;
                return _[Symbol.replace].call(this, C, function() {
                  var N = [];
                  return N.push.apply(N, arguments), In(N[N.length - 1]) !== "object" && N.push(y(N, H)), F.apply(this, N);
                });
              }
              return _[Symbol.replace].call(this, C, F);
            }, Rn.apply(this, arguments);
          }
          function nr(i, r) {
            if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
            i.prototype = Object.create(r && r.prototype, { constructor: { value: i, writable: !0, configurable: !0 } }), r && jn(i, r);
          }
          function rr(i) {
            var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
            return rr = function(u) {
              if (u === null || (_ = u, Function.toString.call(_).indexOf("[native code]") === -1)) return u;
              var _;
              if (typeof u != "function") throw new TypeError("Super expression must either be null or a function");
              if (r !== void 0) {
                if (r.has(u)) return r.get(u);
                r.set(u, w);
              }
              function w() {
                return Gn(u, arguments, ir(this).constructor);
              }
              return w.prototype = Object.create(u.prototype, { constructor: { value: w, enumerable: !1, writable: !0, configurable: !0 } }), jn(w, u);
            }, rr(i);
          }
          function Gn(i, r, u) {
            return Gn = $n() ? Reflect.construct : function(_, w, I) {
              var y = [null];
              y.push.apply(y, w);
              var C = new (Function.bind.apply(_, y))();
              return I && jn(C, I.prototype), C;
            }, Gn.apply(null, arguments);
          }
          function $n() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }
          function jn(i, r) {
            return jn = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, jn(i, r);
          }
          function ir(i) {
            return ir = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ir(i);
          }
          var Hr = "static", wr = "dynamic", Or = "cmsd-", ur = Or + Hr, Pi = Or + wr, ui = "stream", xi = ["mb", "st", "sf", "v"], Fi = { video: "v", audio: "a", text: "tt", stream: ui }, ki = /^[-0-9]/;
          function ci() {
            var i, r, u, _, w = this.context, I = (0, p.Z)(w).getInstance();
            function y() {
              u = {}, _ = {};
            }
            function C(Z) {
              Z && Object.keys(Z).forEach(function(me) {
                xi.includes(me) || delete Z[me];
              });
            }
            function F(Z) {
              return !Z || Z.toLowerCase() !== "false" && (ki.test(Z) ? parseInt(Z, 10) : Z.replace(/["]+/g, ""));
            }
            function Y(Z) {
              try {
                for (var me = {}, ae = Z.split(","), fe = 0; fe < ae.length; fe++) {
                  var _e = ae[fe].split("="), q = _e[0], le = F(_e[1]);
                  me[q] = le;
                }
                return me;
              } catch (K) {
                r.error("Failed to parse CMSD-Static response header value:", K);
              }
            }
            function H(Z) {
              try {
                for (var me = {}, ae = Z.split(","), fe = ae[ae.length - 1].split(";"), _e = 1; _e < fe.length; _e++) {
                  var q = fe[_e].split("="), le = q[0], K = F(q[1]);
                  me[le] = K;
                }
                return me;
              } catch (de) {
                return r.error("Failed to parse CMSD-Dynamic response header value:", de), [];
              }
            }
            function N(Z) {
              return Fi[Z] || "o";
            }
            function U(Z, me, ae) {
              var fe = Z === Hr ? u : _, _e = fe[me] || {}, q = fe[ui] || {};
              return _e[ae] || q[ae];
            }
            return i = { setConfig: function() {
            }, initialize: function() {
            }, reset: function() {
              y();
            }, parseResponseHeaders: function(Z, me) {
              for (var ae = null, fe = null, _e = Z.split(`\r
`), q = _e.length - 1; q >= 0; q--) {
                var le = _e[q].match(Rn(/^((?:(?!:)[\s\S])*):[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(.*)$/, { key: 1, value: 2 }));
                if (le && le.groups) {
                  var K = le.groups.key.toLowerCase(), de = le.groups.value;
                  switch (K) {
                    case ur:
                      ae = Y(de), I.trigger(l.Z.CMSD_STATIC_HEADER, ae);
                      break;
                    case Pi:
                      fe || (fe = H(de));
                  }
                }
              }
              var g = ui;
              return ae && ae.ot ? g = ae.ot : me && (g = N(me)), C(u[g]), C(_[g]), ae && (u[g] = Object.assign(u[g] || {}, ae)), fe && (_[g] = Object.assign(_[g] || {}, fe)), { static: ae, dynamic: fe };
            }, getMaxBitrate: function(Z) {
              var me = N(Z);
              return U(wr, me, "mb") || -1;
            }, getEstimatedThroughput: function(Z) {
              var me = N(Z);
              return U(wr, me, "etp") || null;
            }, getResponseDelay: function(Z) {
              var me = N(Z);
              return U(wr, me, "rd") || null;
            }, getRoundTripTime: function(Z) {
              var me = N(Z);
              return U(wr, me, "rtt") || null;
            } }, r = (0, h.Z)(w).getInstance().getLogger(i), y(), i;
          }
          ci.__dashjs_factory_name = "CmsdModel";
          var Ft = v.Z.getSingletonFactory(ci);
          function un() {
            var i, r, u = this.context, _ = {};
            function w() {
              r = (0, h.Z)(u).getInstance().getLogger(i);
            }
            function I(C) {
              for (var F = {}, Y = 0, H = 0, N = 0, U = 0, Z = C.length, me = 0; me < Z; ++me) Y += C[me].chunkDownloadTimeRelativeMS, H += C[me].bufferLevel, N += C[me].chunkDownloadTimeRelativeMS * C[me].bufferLevel, U += C[me].chunkDownloadTimeRelativeMS * C[me].chunkDownloadTimeRelativeMS;
              return F.m = (N - Y * H / Z) / (U - Y * Y / Z), F.b = H / Z - F.m * Y / Z, function(ae) {
                return F.m * ae + F.b;
              };
            }
            function y(C) {
              var F, Y = !0, H = C.reduce(function(N, U) {
                return N + U.bufferLevelAtSegmentEnd;
              }, 0) / C.length;
              return C.forEach(function(N) {
                Math.abs(N.bufferLevelAtSegmentEnd / N.bufferLevelAtSegmentStart) < 0.95 && (Y = !1), N.bufferLevelAtSegmentEnd / H < 0.8 && (Y = !1), F ? F > N.bitrate && (Y = !1) : F = N.bitrate;
              }), Y;
            }
            return i = { setup: w, addMeasurement: function(C, F, Y, H, N) {
              C && C.mediaType && !_[C.mediaType] && (_[C.mediaType] = []);
              var U = C.mediaInfo.bitrateList.find(function(Z) {
                return Z.id === C.representationId;
              });
              _[C.mediaType].push({ index: C.index, repId: C.representationId, mediaType: C.mediaType, requestTimeMS: H, adjustedAvailabilityStartTimeMS: C.availabilityStartTime.getTime(), segDurationMS: 1e3 * C.duration, chunksDurationMS: Y.reduce(function(Z, me) {
                return Z + me.chunkDownloadDurationMS;
              }, 0), segmentBytes: Y.reduce(function(Z, me) {
                return Z + me.chunkBytes;
              }, 0), bitrate: U && U.bandwidth, bitrateList: C.mediaInfo.bitrateList, chunkMeasurements: Y, fetchDownloadDurationMS: F, throughputCapacityDelayMS: N, getEstimatedBufferLevel: I(Y.slice(1)) }), _[C.mediaType].length > 10 && _[C.mediaType].shift();
            }, getThroughputCapacityDelayMS: function(C, F) {
              var Y = _[C.mediaType] && _[C.mediaType].slice(-3);
              return !Y || Y.length < 3 ? 0 : y(Y) ? F / 4 > 250 ? 250 : F / 4 : 0;
            }, getEstimatedDownloadDurationMS: function(C) {
              var F = _[C.mediaType].slice(-1).pop(), Y = _[C.mediaType].slice(-3), H = F.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;
              F.bufferLevelAtSegmentStart = F.getEstimatedBufferLevel(H / 2), F.bufferLevelAtSegmentEnd = F.getEstimatedBufferLevel(H);
              var N = y(Y), U = N ? 0.6 : 0.8;
              if (F.isBufferStable && 1.05 * F.segDurationMS < F.fetchDownloadDurationMS) return F.fetchDownloadDurationMS;
              if (!N || F.segDurationMS < F.fetchDownloadDurationMS || F.adjustedAvailabilityStartTimeMS <= F.requestTimeMS + F.throughputCapacityDelayMS - F.segDurationMS) return 0.8 * F.fetchDownloadDurationMS;
              for (var Z = F.requestTimeMS + F.throughputCapacityDelayMS - F.adjustedAvailabilityStartTimeMS, me = 0, ae = 0, fe = 0, _e = 0; _e < F.chunkMeasurements.length; _e++) {
                var q = F.chunkMeasurements[_e];
                if (Z < ae + q.chunkDownloadDurationMS) break;
                ae += q.chunkDownloadDurationMS, me += q.chunkBytes, fe++;
              }
              if (Z < 0 && r.warn("request time was before adjusted availibitly start time"), me && ae && fe > 0.2 * F.chunkMeasurements.length) {
                var le = me / ae, K = F.segmentBytes / le;
                return F.fetchDownloadDurationMS < K ? F.fetchDownloadDurationMS * U : K * U;
              }
              var de = F.bitrate;
              return F.bitrateList.some(function(g) {
                if (g.bandwidth > F.bitrate) return de = g.bandwidth, !0;
              }), de === F.bitrate ? F.fetchDownloadDurationMS * U : U * F.segmentBytes * 8 * 1e3 / de;
            } }, w(), i;
          }
          un.__dashjs_factory_name = "LowLatencyThroughputModel";
          var vn = v.Z.getSingletonFactory(un), Yn = R(5717);
          function Nn(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Jn(i) {
            i = i || {};
            var r, u, _, w, I, y, C, F, Y, H, N, U = this.context, Z = i.errHandler, me = i.dashMetrics, ae = i.mediaPlayerModel, fe = i.requestModifier, _e = i.boxParser, q = i.errors, le = i.requestTimeout || 0, K = (0, p.Z)(U).getInstance(), de = (0, Me.Z)(U).getInstance();
            function g(L, D) {
              var O, A = L.request, oe = [], Q = !0, ue = !0, ee = /* @__PURE__ */ new Date(), k = ee, ne = 0, ve = null, xe = null;
              if (!fe || !me || !Z) throw new Error("config object is not correct or missing");
              var Ne, Fe = function(Tt) {
                A.requestStartDate = ee, A.requestEndDate = /* @__PURE__ */ new Date(), A.firstByteDate = A.firstByteDate || ee, A.fileLoaderType = xe;
                var vt = O.response ? O.response.responseURL : null, ht = O.response ? O.response.status : null, Wt = O.response && O.response.getAllResponseHeaders ? O.response.getAllResponseHeaders() : O.response ? O.response.responseHeaders : null, zt = Wt && de.get().streaming.cmsd && de.get().streaming.cmsd.enabled ? C.parseResponseHeaders(Wt, A.mediaType) : null;
                me.addHttpRequest(A, vt, ht, Wt, Tt ? oe : null, zt);
              }, Le = function(Tt) {
                ue = !1, Fe(Tt), A.type === Ge.w.MPD_TYPE && (me.addManifestUpdate(A), K.trigger(l.Z.MANIFEST_LOADING_FINISHED, { request: A }));
              }, ut = function() {
                if (ve && (clearTimeout(ve), ve = null), u.indexOf(O) !== -1 && (u.splice(u.indexOf(O), 1), ue)) if (Le(!1), D > 0) {
                  try {
                    de.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError && A.type === Ge.w.MEDIA_SEGMENT_TYPE && ae.getRetryAttemptsForType(Ge.w.MEDIA_SEGMENT_TYPE) === D && K.trigger(l.Z.ATTEMPT_BACKGROUND_SYNC);
                  } catch {
                  }
                  D--;
                  var Tt = { config: L };
                  w.push(Tt), Tt.timeout = setTimeout(function() {
                    w.indexOf(Tt) !== -1 && (w.splice(w.indexOf(Tt), 1), g(L, D));
                  }, ae.getRetryIntervalsForType(A.type));
                } else {
                  if (A.type === Ge.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE) return;
                  Z.error(new se.Z(I[A.type], A.url + " is not available", { request: A, response: O.response })), L.error && L.error(A, "error", O.response.statusText, O.response), L.complete && L.complete(A, O.response.statusText);
                }
              };
              A.hasOwnProperty("availabilityTimeComplete") && A.availabilityTimeComplete === !1 && window.fetch && A.responseType === "arraybuffer" && A.type === Ge.w.MEDIA_SEGMENT_TYPE ? ((Ne = xn(U).create({ requestModifier: fe, lowLatencyThroughputModel: Y, boxParser: _e })).setup({ dashMetrics: me }), xe = t.Z.FILE_LOADER_TYPES.FETCH) : (Ne = (0, Ht.Z)(U).create({ requestModifier: fe }), xe = t.Z.FILE_LOADER_TYPES.XHR);
              var ct = null, nt = fe.modifyRequestURL ? fe.modifyRequestURL(A.url) : A.url;
              if (de.get().streaming.cmcd && de.get().streaming.cmcd.enabled) {
                var rt = de.get().streaming.cmcd.mode;
                if (rt === t.Z.CMCD_MODE_QUERY) {
                  var Bt = function(Tt) {
                    try {
                      var vt = [], ht = y.getQueryParameter(Tt);
                      return ht && vt.push(ht), vt;
                    } catch {
                      return [];
                    }
                  }(A);
                  nt = St.Z.addAditionalQueryParameterToUrl(nt, Bt);
                } else rt === t.Z.CMCD_MODE_HEADER && (ct = y.getHeaderParameters(A));
              }
              var we = F.getXHRWithCredentialsForType(A.type);
              if (A.queryParams) {
                var He = Object.keys(A.queryParams).map(function(Tt) {
                  return { key: Tt, value: A.queryParams[Tt] };
                });
                nt = St.Z.addAditionalQueryParameterToUrl(nt, He);
              }
              A.url = nt, O = { url: nt, method: Ge.w.GET, withCredentials: we, request: A, onload: function() {
                O.response.status >= 200 && O.response.status <= 299 && (Le(!0), L.success && L.success(O.response.response, O.response.statusText, O.response.responseURL), L.complete && L.complete(A, O.response.statusText));
              }, onend: ut, onerror: ut, progress: function(Tt) {
                var vt = /* @__PURE__ */ new Date();
                Q && (Q = !1, (!Tt.lengthComputable || Tt.lengthComputable && Tt.total !== Tt.loaded) && (A.firstByteDate = vt)), Tt.lengthComputable && (A.bytesLoaded = Tt.loaded, A.bytesTotal = Tt.total), Tt.noTrace || (oe.push({ s: k, d: Tt.time ? Tt.time : vt.getTime() - k.getTime(), b: [Tt.loaded ? Tt.loaded - ne : 0] }), k = vt, ne = Tt.loaded), ve && (clearTimeout(ve), ve = null), de.get().streaming.fragmentRequestProgressTimeout > 0 && (ve = setTimeout(function() {
                  H.warn("Abort request " + O.url + " due to progress timeout"), O.response.onabort = null, O.loader.abort(O), ut();
                }, de.get().streaming.fragmentRequestProgressTimeout)), L.progress && Tt && L.progress(Tt);
              }, onabort: function() {
                Fe(!0), ve && (clearTimeout(ve), ve = null), L.abort && L.abort(A);
              }, ontimeout: function(Tt) {
                var vt;
                if (Tt.lengthComputable) {
                  var ht = Tt.loaded / Tt.total * 100;
                  vt = "Request timeout: loaded: " + Tt.loaded + ", out of: " + Tt.total + " : " + ht.toFixed(3) + "% Completed";
                } else vt = "Request timeout: non-computable download size";
                H.warn(vt);
              }, loader: Ne, timeout: le, headers: ct };
              var pt = (/* @__PURE__ */ new Date()).getTime();
              if (isNaN(A.delayLoadingTime) || pt >= A.delayLoadingTime) u.push(O), Ne.load(O);
              else {
                var We = { httpRequest: O };
                _.push(We), We.delayTimeout = setTimeout(function() {
                  if (_.indexOf(We) !== -1) {
                    _.splice(_.indexOf(We), 1);
                    try {
                      ee = /* @__PURE__ */ new Date(), k = ee, u.push(We.httpRequest), Ne.load(We.httpRequest);
                    } catch {
                      We.httpRequest.onerror();
                    }
                  }
                }, A.delayLoadingTime - pt);
              }
            }
            return r = { load: function(L) {
              L.request ? g(L, ae.getRetryAttemptsForType(L.request.type)) : L.error && L.error(L.request, "error");
            }, abort: function() {
              w.forEach(function(L) {
                clearTimeout(L.timeout), L.config.request && L.config.abort && L.config.abort(L.config.request);
              }), w = [], _.forEach(function(L) {
                return clearTimeout(L.delayTimeout);
              }), _ = [], u.forEach(function(L) {
                L.request.type !== Ge.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE && (L.onloadend = L.onerror = L.onprogress = void 0, L.loader.abort(L));
              }), u = [];
            } }, H = (0, h.Z)(U).getInstance().getLogger(r), u = [], _ = [], w = [], y = mn(U).getInstance(), C = Ft(U).getInstance(), Y = vn(U).getInstance(), F = (0, Yn.Z)(U).getInstance(), Nn(N = {}, Ge.w.MPD_TYPE, q.DOWNLOAD_ERROR_ID_MANIFEST_CODE), Nn(N, Ge.w.XLINK_EXPANSION_TYPE, q.DOWNLOAD_ERROR_ID_XLINK_CODE), Nn(N, Ge.w.INIT_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE), Nn(N, Ge.w.MEDIA_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), Nn(N, Ge.w.INDEX_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), Nn(N, Ge.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), Nn(N, Ge.w.OTHER_TYPE, q.DOWNLOAD_ERROR_ID_CONTENT_CODE), I = N, r;
          }
          Jn.__dashjs_factory_name = "HTTPLoader";
          var Zn = v.Z.getClassFactory(Jn);
          function Tr() {
            var i;
            function r() {
              i = {};
            }
            function u() {
              r();
            }
            return u(), { getLoader: function(_) {
              for (var w in i) if (i.hasOwnProperty(w) && _.startsWith(w)) return i[w];
              return Zn;
            }, registerLoader: function(_, w) {
              i[_] = w;
            }, unregisterLoader: function(_) {
              i[_] && delete i[_];
            }, unregisterAllLoader: r, reset: u };
          }
          Tr.__dashjs_factory_name = "SchemeLoaderFactory";
          var Wn = v.Z.getSingletonFactory(Tr);
          function Hn(i) {
            i = i || {};
            var r, u, _ = this.context;
            return r = Wn(_).getInstance(), { load: function(w) {
              if (!u) {
                var I = r.getLoader(w && w.request ? w.request.url : null);
                u = I(_).create({ errHandler: i.errHandler, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, dashMetrics: i.dashMetrics, boxParser: i.boxParser ? i.boxParser : null, constants: i.constants ? i.constants : null, dashConstants: i.dashConstants ? i.dashConstants : null, urlUtils: i.urlUtils ? i.urlUtils : null, requestTimeout: isNaN(i.requestTimeout) ? 0 : i.requestTimeout, errors: i.errors });
              }
              u.load(w);
            }, abort: function() {
              u && u.abort();
            } };
          }
          Hn.__dashjs_factory_name = "URLLoader";
          var cr = v.Z.getClassFactory(Hn);
          function fr(i) {
            return fr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, fr(i);
          }
          function Mr(i, r) {
            return Mr = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Mr(i, r);
          }
          function Rr(i, r) {
            return !r || fr(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Lr(i) {
            return Lr = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Lr(i);
          }
          var qr = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && Mr(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Lr(r);
              if (u) {
                var C = Lr(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return Rr(this, I);
            });
            function w(I) {
              var y;
              return function(C, F) {
                if (!(C instanceof F)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (y = _.call(this, I)).checkForExistenceOnly = !0, y;
            }
            return w;
          }(S.Z);
          function Ai(i) {
            i = i || {};
            var r, u, _ = this.context, w = i.eventBus, I = i.events, y = i.urlUtils, C = i.errors, F = i.streamId;
            return r = { checkForExistence: function(Y) {
              var H = function(U) {
                w.trigger(I.CHECK_FOR_EXISTENCE_COMPLETED, { request: Y, exists: U });
              };
              if (Y) {
                var N = new qr(Y.url);
                u.load({ request: N, success: function() {
                  H(!0);
                }, error: function() {
                  H(!1);
                } });
              } else H(!1);
            }, load: function(Y) {
              var H = function(N, U) {
                w.trigger(I.LOADING_COMPLETED, { request: Y, response: N || null, error: U || null, sender: r });
              };
              Y ? u.load({ request: Y, progress: function(N) {
                w.trigger(I.LOADING_PROGRESS, { request: Y, stream: N.stream, streamId: F }), N.data && w.trigger(I.LOADING_DATA_PROGRESS, { request: Y, response: N.data || null, error: null, sender: r });
              }, success: function(N) {
                H(N);
              }, error: function(N, U, Z) {
                H(void 0, new se.Z(C.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE, Z, U));
              }, abort: function(N) {
                N && w.trigger(I.LOADING_ABANDONED, { mediaType: N.mediaType, request: N, sender: r });
              } }) : H(void 0, new se.Z(C.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE, C.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE));
            }, abort: function() {
              u && u.abort();
            }, reset: function() {
              u && (u.abort(), u = null);
            } }, u = cr(_).create({ errHandler: i.errHandler, errors: C, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, urlUtils: y, constants: t.Z, boxParser: i.boxParser, dashConstants: i.dashConstants, requestTimeout: i.settings.get().streaming.fragmentRequestTimeout }), r;
          }
          Ai.__dashjs_factory_name = "FragmentLoader";
          var fi = v.Z.getClassFactory(Ai);
          function di() {
            return { modifyResponseAsync: function(i) {
              return Promise.resolve(i);
            } };
          }
          di.__dashjs_factory_name = "SegmentResponseModifier";
          var Zi = v.Z.getSingletonFactory(di);
          function Bi(i) {
            i = i || {};
            var r, u, _, w = this.context, I = (0, p.Z)(w).getInstance(), y = i.errHandler, C = i.mediaPlayerModel, F = i.dashMetrics, Y = (0, h.Z)(w).getInstance(), H = Zi(w).getInstance(), N = i.streamInfo;
            function U() {
              return N.id;
            }
            function Z() {
              for (var ae in _) _[ae].reset();
              _ = {};
            }
            function me(ae) {
              if (ae.sender) {
                var fe = ae.request, _e = ae.response, q = fe.isInitializationRequest(), le = fe.mediaInfo.streamInfo;
                if (ae.error && (fe.mediaType === t.Z.AUDIO || fe.mediaType === t.Z.VIDEO || fe.mediaType === t.Z.TEXT && fe.mediaInfo.isFragmented) && I.trigger(l.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD, { entry: ae.request.serviceLocation }), _e && le) {
                  var K = function(de, g, L, D) {
                    var O = new Mt();
                    return O.streamId = L, O.mediaInfo = g.mediaInfo, O.segmentType = g.type, O.start = g.startTime, O.duration = g.duration, O.end = O.start + O.duration, O.bytes = de, O.index = g.index, O.quality = g.quality, O.representationId = g.representationId, O.endFragment = D, O;
                  }(_e, fe, N.id, ae.type !== l.Z.FRAGMENT_LOADING_PROGRESS);
                  H.modifyResponseAsync(K).then(function(de) {
                    I.trigger(q ? l.Z.INIT_FRAGMENT_LOADED : l.Z.MEDIA_FRAGMENT_LOADED, { chunk: de, request: fe }, { streamId: le.id, mediaType: fe.mediaType });
                  }).catch(function(de) {
                    u.error(de), I.trigger(q ? l.Z.INIT_FRAGMENT_LOADED : l.Z.MEDIA_FRAGMENT_LOADED, { chunk: K, request: fe }, { streamId: le.id, mediaType: fe.mediaType });
                  });
                } else u.warn("No " + fe.mediaType + " bytes to push or stream is inactive.");
              }
            }
            return r = { getStreamId: U, getModel: function(ae) {
              var fe = _[ae];
              return fe || (fe = W(w).create({ streamInfo: N, type: ae, dashMetrics: F, fragmentLoader: fi(w).create({ dashMetrics: F, mediaPlayerModel: C, errHandler: y, requestModifier: (0, De.Z)(w).getInstance(), settings: i.settings, boxParser: i.boxParser, eventBus: I, events: l.Z, errors: $, dashConstants: i.dashConstants, urlUtils: i.urlUtils, streamId: U() }), debug: Y, eventBus: I, events: l.Z }), _[ae] = fe), fe;
            }, reset: function() {
              I.off(n.Z.FRAGMENT_LOADING_COMPLETED, me, this), I.off(n.Z.FRAGMENT_LOADING_PROGRESS, me, this), Z();
            } }, u = Y.getLogger(r), Z(), I.on(n.Z.FRAGMENT_LOADING_COMPLETED, me, r), I.on(n.Z.FRAGMENT_LOADING_PROGRESS, me, r), r;
          }
          Bi.__dashjs_factory_name = "FragmentController";
          var Oa = v.Z.getClassFactory(Bi), Ma = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = null, this.width = null, this.height = null, this.x = null, this.y = null;
          }, Ui = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.mediaType = null, this.bitrate = null, this.width = null, this.height = null, this.scanType = null, this.qualityIndex = NaN;
          };
          function Gi(i) {
            var r, u, _ = this.context, w = i.streamInfo;
            function I(C) {
              u.setTrackByIndex(C);
            }
            function y() {
              u && u.reset();
            }
            return r = { getStreamId: function() {
              return w.id;
            }, initialize: function() {
              u.addTracks();
              var C = u.getTracks();
              C && C.length > 0 && I(0);
            }, provide: function(C, F) {
              if (typeof F == "function") {
                var Y, H, N = u.getCurrentTrack();
                if (!N || N.segmentDuration <= 0 || C == null) F(null);
                else {
                  (H = u.getThumbnailRequestForTime(C)) && (N.segmentDuration = H.duration), Y = C % N.segmentDuration;
                  var U = Math.floor(Y * N.tilesHor * N.tilesVert / N.segmentDuration), Z = new Ma();
                  if (Z.width = Math.floor(N.widthPerTile), Z.height = Math.floor(N.heightPerTile), Z.x = Math.floor(U % N.tilesHor) * N.widthPerTile, Z.y = Math.floor(U / N.tilesHor) * N.heightPerTile, "readThumbnail" in N) return N.readThumbnail(C, function(ae) {
                    Z.url = ae, F(Z);
                  });
                  if (H) Z.url = H.url, N.segmentDuration = NaN;
                  else {
                    var me = Math.floor(C / N.segmentDuration);
                    Z.url = function(ae, fe) {
                      var _e = fe + ae.startNumber, q = (0, o.vi)(ae.templateUrl, "Number", _e);
                      return q = (0, o.vi)(q, "Time", (_e - 1) * ae.segmentDuration * ae.timescale), q = (0, o.vi)(q, "Bandwidth", ae.bandwidth), (0, o.eR)(q);
                    }(N, me);
                  }
                  F(Z);
                }
              }
            }, setTrackByIndex: I, getCurrentTrackIndex: function() {
              return u.getCurrentTrackIndex();
            }, getBitrateList: function() {
              var C = u.getTracks(), F = 0;
              return C.map(function(Y) {
                var H = new Ui();
                return H.mediaType = t.Z.IMAGE, H.qualityIndex = F++, H.bitrate = Y.bitrate, H.width = Y.width, H.height = Y.height, H;
              });
            }, reset: y }, y(), u = (0, Gt.Z)(_).create({ streamInfo: w, adapter: i.adapter, baseURLController: i.baseURLController, timelineConverter: i.timelineConverter, debug: i.debug, eventBus: i.eventBus, events: i.events, dashConstants: i.dashConstants, dashMetrics: i.dashMetrics, segmentBaseController: i.segmentBaseController }), r;
          }
          Gi.__dashjs_factory_name = "ThumbnailController";
          var La = v.Z.getClassFactory(Gi), Ii = R(7417);
          function Hi(i) {
            var r;
            i = i || {};
            var u = [], _ = (0, p.Z)(this.context).getInstance(), w = i.updateEventName, I = i.addBlacklistEventName;
            function y(C) {
              u.indexOf(C) === -1 && (u.push(C), _.trigger(w, { entry: C }));
            }
            return r = { add: y, contains: function(C) {
              return !!(u.length && C && C.length) && u.indexOf(C) !== -1;
            }, reset: function() {
              u = [];
            } }, I && _.on(I, function(C) {
              y(C.entry);
            }, r), r;
          }
          Hi.__dashjs_factory_name = "BlackListController";
          var gi = v.Z.getClassFactory(Hi), Pa = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT, t.Z.MUXED, t.Z.IMAGE];
          function Bn(i) {
            i = i || {};
            var r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q, le = this.context, K = (0, p.Z)(le).getInstance(), de = (0, tt.Z)(le).getInstance(), g = i.manifestModel, L = i.mediaPlayerModel, D = i.dashMetrics, O = i.manifestUpdater, A = i.adapter, oe = i.timelineConverter, Q = i.capabilities, ue = i.errHandler, ee = i.abrController, k = i.playbackController, ne = i.eventController, ve = i.mediaController, xe = i.protectionController, Ne = i.textController, Fe = i.videoModel, Le = i.streamInfo, ut = i.settings;
            function ct(mt, kt) {
              return new Promise(function(qt, Vt) {
                vt(), H = !0, Wt();
                var Xt = Fe.getElement(), ze = [];
                Pa.forEach(function(Pe) {
                  (Pe !== t.Z.TEXT || mt) && (Pe !== t.Z.VIDEO || !Xt || Xt && /^VIDEO$/i.test(Xt.nodeName)) && ze.push(nt(Pe, mt));
                }), Promise.all(ze).then(function() {
                  return Pe = kt, new Promise(function(ft) {
                    var pe = {}, be = _.map(function(Je) {
                      return Je.createBufferSinks(Pe);
                    });
                    Promise.all(be).then(function(Je) {
                      Je.forEach(function(Nt) {
                        Nt && (pe[Nt.getType()] = Nt);
                      }), ft(pe);
                    }).catch(function() {
                      ft(pe);
                    });
                  });
                  var Pe;
                }).then(function(Pe) {
                  if (H = !1, _.length === 0) {
                    var ft = "No streams to play.";
                    ue.error(new se.Z($.MANIFEST_ERROR_ID_NOSTREAMS_CODE, ft, g.getValue())), u.fatal(ft);
                  } else zt();
                  mt && Ne.createTracks(Le), qt(Pe);
                }).catch(function(Pe) {
                  Vt(Pe);
                });
              });
            }
            function nt(mt, kt) {
              var qt, Vt = A.getAllMediaInfoForType(Le, mt), Xt = [], ze = null;
              if (!Vt || Vt.length === 0) return u.info("No " + mt + " data."), Promise.resolve();
              mt === t.Z.VIDEO && (C = !0), mt === t.Z.AUDIO && (F = !0);
              for (var Pe = 0, ft = Vt.length; Pe < ft; Pe++) ze = Vt[Pe], mt === t.Z.TEXT && ze.isEmbedded && (Ne.addEmbeddedTrack(Le, ze), Xt.push(ze)), rt(ze) && ve.addTrack(ze);
              if (Xt.length > 0 && (ve.setInitialMediaSettingsForType(mt, Le), Ne.addMediaInfosToBuffer(Le, mt, Xt)), Vt = Vt.filter(function(be) {
                return !be.isEmbedded;
              }), Vt.length === 0) return Promise.resolve();
              if (mt === t.Z.IMAGE) return (U = La(le).create({ streamInfo: Le, adapter: A, baseURLController: i.baseURLController, timelineConverter: i.timelineConverter, debug: fe, eventBus: K, events: l.Z, dashConstants: e.Z, dashMetrics: i.dashMetrics, segmentBaseController: i.segmentBaseController })).initialize(), Promise.resolve();
              K.trigger(l.Z.STREAM_INITIALIZING, { streamInfo: Le, mediaInfo: ze }), ve.setInitialMediaSettingsForType(mt, Le);
              var pe = function(be, Je) {
                var Nt = be && be.length > 0 ? be[0] : null, xt = N.getModel(Nt ? Nt.type : null), yn = Nt ? Nt.type : null, Ln = Nt ? Nt.mimeType : null, Qn = Nt ? Nt.isFragmented : null, Dn = Yt(le).create({ streamInfo: Le, type: yn, mimeType: Ln, timelineConverter: oe, adapter: A, manifestModel: g, mediaPlayerModel: L, fragmentModel: xt, dashMetrics: i.dashMetrics, baseURLController: i.baseURLController, segmentBaseController: i.segmentBaseController, abrController: ee, playbackController: k, mediaController: ve, textController: Ne, errHandler: ue, settings: ut, boxParser: ae, segmentBlacklistController: Z });
                Dn.initialize(Je, C, Qn), _.push(Dn);
                for (var mr = 0; mr < be.length; mr++) Dn.addMediaInfo(be[mr]);
                return yn === t.Z.TEXT && Ne.addMediaInfosToBuffer(Le, yn, be, xt), Dn;
              }(Vt, kt);
              return (qt = ve.getCurrentTrackFor(mt, Le.id)) ? (ee.updateTopQualityIndex(qt), pe.selectMediaInfo(mt === t.Z.TEXT && qt.isEmbedded ? Vt[0] : qt)) : Promise.resolve();
            }
            function rt(mt) {
              var kt, qt = mt ? mt.type : null;
              return qt === t.Z.MUXED ? (kt = "Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines", u.fatal(kt), ue.error(new se.Z($.MANIFEST_ERROR_ID_MULTIPLEXED_CODE, kt, g.getValue())), !1) : !(qt !== t.Z.TEXT && qt !== t.Z.IMAGE && mt.contentProtection && !Q.supportsEncryptedMedia() && (ue.error(new se.Z($.CAPABILITY_MEDIAKEYS_ERROR_CODE, $.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE)), 1));
            }
            function Bt(mt) {
              for (var kt = _ ? _.length : 0, qt = 0; qt < kt; qt++) {
                var Vt = _[qt].getFragmentModel();
                Vt.abortRequests(), Vt.resetInitialSettings(), _[qt].reset(!1, mt);
              }
              Ne && Ne.deactivateStream(Le), _ = [], I = !1, y = !1, en(!1), He(!1), K.trigger(l.Z.STREAM_DEACTIVATED, { streamInfo: Le });
            }
            function we(mt) {
              Bt(mt), w = !1, C = !1, F = !1, Y = {}, H = !1, _e = !1, q = [];
            }
            function He(mt) {
              _e = mt;
            }
            function pt() {
              return Le ? Le.start : NaN;
            }
            function We() {
              return Le ? Le.id : null;
            }
            function Tt() {
              return Le;
            }
            function vt() {
              if (!Fe || !ee) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            function ht(mt) {
              mt.error && (ue.error(mt.error), u.fatal(mt.error.message));
            }
            function Wt() {
              if (ne) {
                var mt = A.getEventsFor(Le);
                mt && mt.length > 0 && ne.addInlineEvents(mt, Le.id);
              }
            }
            function zt() {
              for (var mt = _.length, kt = Y.audio || Y.video ? new se.Z($.DATA_UPDATE_FAILED_ERROR_CODE, $.DATA_UPDATE_FAILED_ERROR_MESSAGE) : null, qt = 0; qt < mt; qt++) if (_[qt].isUpdating() || H) return;
              if (xe) {
                xe.clearMediaInfoArray();
                for (var Vt = 0; Vt < mt && _[Vt]; Vt++) {
                  var Xt = _[Vt].getType(), ze = _[Vt].getMediaInfo();
                  if (Xt === t.Z.AUDIO || Xt === t.Z.VIDEO || Xt === t.Z.TEXT && ze.isFragmented) {
                    var Pe = _[Vt].getMediaInfo();
                    Pe && xe.initializeForMedia(Pe);
                  }
                }
                xe.handleKeySystemFromManifest();
              }
              kt ? ue.error(kt) : w || (w = !0, Fe.waitForReadyState(t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                K.trigger(l.Z.STREAM_INITIALIZED, { streamInfo: Le });
              }));
            }
            function gn() {
              var mt = Rt(), kt = mt.length;
              if (kt !== 0) {
                for (var qt = 0; qt < kt; qt++) if (!mt[qt].isBufferingCompleted() && (mt[qt].getType() === t.Z.AUDIO || mt[qt].getType() === t.Z.VIDEO)) return void u.debug("onBufferingCompleted - One streamProcessor has finished but", mt[qt].getType(), "one is not buffering completed");
                u.debug("onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED"), y = !0, K.trigger(l.Z.STREAM_BUFFERING_COMPLETED, { streamInfo: Le }, { streamInfo: Le });
              } else u.warn("onBufferingCompleted - can't trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined");
            }
            function pn(mt) {
              Y[mt.mediaType] = mt.error, zt();
            }
            function Ke(mt) {
              ne && ne.addInbandEvents(mt.events, Le.id);
            }
            function Et(mt) {
              return mt && mt.type ? lt(mt.type) : null;
            }
            function lt(mt) {
              return mt ? Rt().filter(function(kt) {
                return kt.getType() === mt;
              })[0] : null;
            }
            function Rt() {
              for (var mt, kt, qt = [], Vt = 0; Vt < _.length; Vt++) (mt = (kt = _[Vt]).getType()) !== t.Z.AUDIO && mt !== t.Z.VIDEO && mt !== t.Z.TEXT || qt.push(kt);
              return qt;
            }
            function Pt(mt, kt) {
              var qt = Tt(), Vt = kt.getStreamInfo();
              if (!Vt || !qt) return !0;
              var Xt = A.getAdaptationForType(Vt.index, mt, Vt), ze = A.getAdaptationForType(qt.index, mt, qt);
              return Xt && ze ? !(!$t(ze) && $t(Xt)) : !Xt && !ze;
            }
            function $t(mt) {
              return !!mt && !!(mt.ContentProtection || mt.Representation_asArray && mt.Representation_asArray.length > 0 && mt.Representation_asArray[0].ContentProtection);
            }
            function Qt(mt, kt) {
              var qt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              if (!mt || !mt.hasOwnProperty("getStreamInfo")) return !1;
              var Vt = mt.getStreamInfo(), Xt = qt ? qt.getStreamInfo() : Tt();
              if (!Vt || !Xt) return !1;
              var ze = A.getAdaptationForType(Vt.index, kt, Vt), Pe = A.getAdaptationForType(Xt.index, kt, Xt);
              if (!ze || !Pe) return !ze && !Pe;
              var ft = ze && Pe && ze.mimeType === Pe.mimeType, pe = Pe.Representation_asArray.map(function(xt) {
                return xt.codecs;
              }), be = ze.Representation_asArray.map(function(xt) {
                return xt.codecs;
              }), Je = be.some(function(xt) {
                return pe.indexOf(xt) > -1;
              }), Nt = be.some(function(xt) {
                return pe.some(function(yn) {
                  return Q.codecRootCompatibleWithCodec(yn, xt);
                });
              });
              return Je || Nt && ft;
            }
            function en(mt) {
              me = mt;
            }
            function sn() {
              return me;
            }
            return r = { initialize: function() {
              K.on(l.Z.BUFFERING_COMPLETED, gn, r), K.on(l.Z.DATA_UPDATE_COMPLETED, pn, r), K.on(l.Z.INBAND_EVENTS, Ke, r), xe && (K.on(l.Z.KEY_ERROR, ht, r), K.on(l.Z.SERVER_CERTIFICATE_UPDATED, ht, r), K.on(l.Z.LICENSE_REQUEST_COMPLETE, ht, r), K.on(l.Z.KEY_SYSTEM_SELECTED, ht, r), K.on(l.Z.KEY_SESSION_CREATED, ht, r), K.on(l.Z.KEY_STATUSES_CHANGED, ht, r)), Ne.initializeForStream(Le), K.trigger(l.Z.STREAM_UPDATED, { streamInfo: Le });
            }, getStreamId: function() {
              return Le ? Le.id : null;
            }, activate: function(mt, kt) {
              return new Promise(function(qt, Vt) {
                if (!I) return sn() ? (I = !0, K.trigger(l.Z.STREAM_ACTIVATED, { streamInfo: Le }), void qt(kt)) : void function(Xt, ze) {
                  return ct(Xt, ze);
                }(mt, kt).then(function(Xt) {
                  I = !0, K.trigger(l.Z.STREAM_ACTIVATED, { streamInfo: Le }), qt(Xt);
                }).catch(function(Xt) {
                  Vt(Xt);
                });
                qt(kt);
              });
            }, deactivate: Bt, getIsActive: function() {
              return I;
            }, getDuration: function() {
              return Le ? Le.duration : NaN;
            }, getStartTime: pt, getId: We, getStreamInfo: Tt, getHasAudioTrack: function() {
              return F;
            }, getHasVideoTrack: function() {
              return C;
            }, startPreloading: function(mt, kt) {
              return new Promise(function(qt, Vt) {
                sn() ? Vt() : (u.info("[startPreloading] Preloading next stream with id ".concat(We())), en(!0), ct(mt, kt).then(function() {
                  for (var Xt = 0; Xt < _.length && _[Xt]; Xt++) _[Xt].setExplicitBufferingTime(pt()), _[Xt].getScheduleController().startScheduleTimer();
                  qt();
                }).catch(function() {
                  en(!1), Vt();
                }));
              });
            }, initializeForTextWithMediaSource: function(mt) {
              return new Promise(function(kt, qt) {
                nt(t.Z.TEXT, mt).then(function() {
                  return (Vt = lt(t.Z.TEXT)) ? Vt.createBufferSinks() : Promise.resolve();
                  var Vt;
                }).then(function() {
                  Ne.createTracks(Le), kt();
                }).catch(function(Vt) {
                  qt(Vt);
                });
              });
            }, getThumbnailController: function() {
              return U;
            }, getBitrateListFor: function(mt) {
              if (vt(), mt === t.Z.IMAGE) return U ? U.getBitrateList() : [];
              var kt = function(qt) {
                for (var Vt = null, Xt = 0; Xt < _.length; Xt++) if ((Vt = _[Xt]).getType() === qt) return Vt.getMediaInfo();
                return null;
              }(mt);
              return ee.getBitrateList(kt);
            }, updateData: function(mt) {
              return new Promise(function(kt) {
                H = !0, Le = mt, ne && Wt();
                for (var qt = [], Vt = 0, Xt = _.length; Vt < Xt; Vt++) {
                  var ze = _[Vt], Pe = ze.getMediaInfo();
                  qt.push(ze.updateStreamInfo(Le));
                  var ft = A.getAllMediaInfoForType(Le, ze.getType());
                  if (ft = ft.filter(function(Je) {
                    return !Je.isEmbedded;
                  })) {
                    ze.clearMediaInfoArray();
                    for (var pe = 0; pe < ft.length; pe++) {
                      var be = ft[pe];
                      ze.addMediaInfo(ft[pe]), A.areMediaInfosEqual(Pe, be) && (ee.updateTopQualityIndex(be), qt.push(ze.selectMediaInfo(be)));
                    }
                  }
                }
                Promise.all(qt).then(function() {
                  for (qt = []; q.length > 0; ) {
                    var Je = q.pop(), Nt = Je.newMediaInfo, xt = Et(Je.oldMediaInfo);
                    if (!xt) return;
                    qt.push(xt.prepareTrackSwitch()), qt.push(xt.selectMediaInfo(Nt));
                  }
                  return Promise.all(qt);
                }).then(function() {
                  H = !1, zt(), K.trigger(l.Z.STREAM_UPDATED, { streamInfo: Le }), kt();
                });
              });
            }, reset: function(mt) {
              N && (N.reset(), N = null), ee && Le && ee.clearDataForStream(Le.id), Z && (Z.reset(), Z = null), we(mt), Le = null, K.off(l.Z.DATA_UPDATE_COMPLETED, pn, r), K.off(l.Z.BUFFERING_COMPLETED, gn, r), K.off(l.Z.INBAND_EVENTS, Ke, r), xe && (K.off(l.Z.KEY_ERROR, ht, r), K.off(l.Z.SERVER_CERTIFICATE_UPDATED, ht, r), K.off(l.Z.LICENSE_REQUEST_COMPLETE, ht, r), K.off(l.Z.KEY_SYSTEM_SELECTED, ht, r), K.off(l.Z.KEY_SESSION_CREATED, ht, r), K.off(l.Z.KEY_STATUSES_CHANGED, ht, r));
            }, getProcessors: Rt, setMediaSource: function(mt) {
              return new Promise(function(kt, qt) {
                for (var Vt = [], Xt = 0; Xt < _.length; ) rt(_[Xt].getMediaInfo()) ? (Vt.push(_[Xt].setMediaSource(mt)), Xt++) : (_[Xt].reset(), _.splice(Xt, 1));
                Promise.all(Vt).then(function() {
                  for (var ze = 0; ze < _.length; ze++) _[ze].dischargePreBuffer();
                  if (_.length === 0) {
                    var Pe = "No streams to play.";
                    ue.error(new se.Z($.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Pe + "nostreams", g.getValue())), u.fatal(Pe);
                  }
                  kt();
                }).catch(function(ze) {
                  u.error(ze), qt(ze);
                });
              });
            }, isMediaCodecCompatible: function(mt) {
              var kt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return Qt(mt, t.Z.VIDEO, kt) && Qt(mt, t.Z.AUDIO, kt);
            }, isProtectionCompatible: function(mt) {
              return !mt || Pt(t.Z.VIDEO, mt) && Pt(t.Z.AUDIO, mt);
            }, getPreloaded: sn, getIsEndedEventSignaled: function() {
              return _e;
            }, setIsEndedEventSignaled: He, getAdapter: function() {
              return A;
            }, getHasFinishedBuffering: function() {
              return y;
            }, setPreloaded: en, startScheduleControllers: function() {
              for (var mt = _.length, kt = 0; kt < mt && _[kt]; kt++) _[kt].getScheduleController().startScheduleTimer();
            }, prepareTrackChange: function(mt) {
              if (I && Le) {
                y = !1;
                var kt = mt.newMediaInfo, qt = g.getValue();
                A.setCurrentMediaInfo(Le.id, kt.type, kt);
                var Vt = Et(kt);
                if (Vt) {
                  var Xt = k.getTime();
                  u.info("Stream -  Process track changed at current time " + Xt), qt.refreshManifestOnSwitchTrack ? (q.push(mt), O.getIsUpdating() || (u.debug("Stream -  Refreshing manifest for switch track"), O.refreshManifest())) : Vt.selectMediaInfo(kt).then(function() {
                    kt.type !== t.Z.VIDEO && kt.type !== t.Z.AUDIO || ee.updateTopQualityIndex(kt), Vt.prepareTrackSwitch();
                  });
                }
              }
            }, prepareQualityChange: function(mt) {
              var kt = lt(mt.mediaType);
              kt && kt.prepareQualityChange(mt);
            } }, function() {
              try {
                fe = (0, h.Z)(le).getInstance(), u = fe.getLogger(r), we(), ae = (0, Ii.Z)(le).getInstance(), Z = gi(le).create({ updateEventName: l.Z.SEGMENT_LOCATION_BLACKLIST_CHANGED, addBlacklistEventName: l.Z.SEGMENT_LOCATION_BLACKLIST_ADD }), N = Oa(le).create({ streamInfo: Le, mediaPlayerModel: L, dashMetrics: D, errHandler: ue, settings: ut, boxParser: ae, dashConstants: e.Z, urlUtils: de });
              } catch (mt) {
                throw mt;
              }
            }(), r;
          }
          Bn.__dashjs_factory_name = "Stream";
          var $r = v.Z.getClassFactory(Bn), hi = function i(r) {
            (function(u, _) {
              if (!(u instanceof _)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || null, this.type = Ge.w.CONTENT_STEERING_TYPE, this.responseType = "json";
          }, Jr = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.version = null, this.ttl = 300, this.reloadUri = null, this.pathwayPriority = [], this.pathwayClones = [];
          };
          function qi() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae = this.context, fe = (0, tt.Z)(ae).getInstance();
            function _e(ee) {
              g(ee, "baseUrl");
            }
            function q(ee) {
              g(ee, "location");
            }
            function le(ee) {
              if (ee && ee.request && ee.request.serviceLocation && ee.request.requestStartDate && ee.request.requestEndDate && !isNaN(ee.request.bytesTotal)) {
                var k = ee.request.serviceLocation, ne = ee.request.requestEndDate.getTime() - ee.request.requestStartDate.getTime();
                de(k, parseInt(8 * ee.request.bytesTotal / ne * 1e3));
              }
            }
            function K(ee) {
              ee && ee.httpRequest && ee.httpRequest._serviceLocation && !isNaN(ee.throughput) && de(ee.httpRequest._serviceLocation, 1e3 * ee.throughput);
            }
            function de(ee, k) {
              w[ee] || (w[ee] = []), w[ee].push(k), w[ee].length > 4 && w[ee].shift();
            }
            function g(ee, k) {
              if (ee && ee.request && ee.request.serviceLocation) {
                var ne = ee.request.serviceLocation;
                _[k].all.indexOf(ne) === -1 && _[k].all.push(ne), _[k].current = ne;
              }
            }
            function L() {
              var ee = H.getValue(), k = me.getContentSteering(ee);
              return k || (k = U.getServiceDescriptionSettings().contentSteering), k;
            }
            function D() {
              return new Promise(function(ee) {
                try {
                  var k = L();
                  if (!k || !k.serverUrl) return void ee();
                  var ne = function(xe) {
                    var Ne = xe.serverUrl;
                    u && u.reloadUri && (Ne = fe.isRelative(u.reloadUri) ? fe.resolve(u.reloadUri, xe.serverUrl) : u.reloadUri);
                    var Fe = [], Le = _.baseUrl.all.concat(_.location.all);
                    if (Le.length > 0) {
                      var ut = Le.map(function(rt) {
                        var Bt = function(we) {
                          if (!we || !w[we] || w[we].length === 0) return -1;
                          var He = w[we].reduce(function(pt, We) {
                            return pt + We;
                          }) / w[we].length;
                          return parseInt(He);
                        }(rt);
                        return { serviceLocation: rt, throughput: Bt };
                      });
                      ut.sort(function(rt, Bt) {
                        return Bt.throughput - rt.throughput;
                      });
                      var ct = "", nt = "";
                      ut.forEach(function(rt, Bt) {
                        Bt !== 0 && (ct = "".concat(ct, ","), rt.throughput > -1 && (nt = "".concat(nt, ","))), ct = "".concat(ct).concat(rt.serviceLocation), rt.throughput > -1 && (nt = "".concat(nt).concat(rt.throughput));
                      }), Fe.push({ key: "_DASH_pathway", value: '"'.concat(ct, '"') }), Fe.push({ key: "_DASH_throughput", value: nt });
                    }
                    return Ne = St.Z.addAditionalQueryParameterToUrl(Ne, Fe);
                  }(k), ve = new hi(ne);
                  y.load({ request: ve, success: function(xe) {
                    (function(Ne) {
                      Ne && Ne[e.Z.CONTENT_STEERING_RESPONSE.VERSION] && parseInt(Ne[e.Z.CONTENT_STEERING_RESPONSE.VERSION]) === 1 && ((u = new Jr()).version = Ne[e.Z.CONTENT_STEERING_RESPONSE.VERSION], Ne[e.Z.CONTENT_STEERING_RESPONSE.TTL] && !isNaN(Ne[e.Z.CONTENT_STEERING_RESPONSE.TTL]) && (u.ttl = Ne[e.Z.CONTENT_STEERING_RESPONSE.TTL]), Ne[e.Z.CONTENT_STEERING_RESPONSE.RELOAD_URI] && (u.reloadUri = Ne[e.Z.CONTENT_STEERING_RESPONSE.RELOAD_URI]), Ne[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_PRIORITY] && (u.pathwayPriority = Ne[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_PRIORITY]), Ne[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_CLONES] && (u.pathwayClones = Ne[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_CLONES], u.pathwayClones = u.pathwayClones.filter(function(Fe) {
                        return function(Le) {
                          return Le[e.Z.CONTENT_STEERING_RESPONSE.BASE_ID] && Le[e.Z.CONTENT_STEERING_RESPONSE.ID] && Le[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT] && Le[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.HOST];
                        }(Fe);
                      })), oe());
                    })(xe), Z.trigger(n.Z.CONTENT_STEERING_REQUEST_COMPLETED, { currentSteeringResponseData: u, url: ne }), ee();
                  }, error: function(xe, Ne, Fe, Le) {
                    (function(ut, ct) {
                      try {
                        switch (r.warn("Error fetching data from content steering server", ut), ct.status) {
                          case 410:
                            break;
                          case 429:
                            var nt = ct && ct.getResponseHeader ? ct.getResponseHeader("retry-after") : null;
                            nt !== null && (u || (u = {}), u.ttl = parseInt(nt)), oe();
                            break;
                          default:
                            oe();
                        }
                      } catch (rt) {
                        r.error(rt);
                      }
                    })(xe, Le), ee(xe);
                  }, complete: function() {
                    _.baseUrl.all = O(_.baseUrl), _.location.all = O(_.location);
                  } });
                } catch (xe) {
                  ee(xe);
                }
              });
            }
            function O(ee) {
              return ee.all && ee.all.length !== 0 && ee.current ? ee.all.filter(function(k) {
                return k === ee.current;
              }) : [];
            }
            function A(ee) {
              try {
                var k = [];
                return ee && ee.length !== 0 && u && u.pathwayClones && u.pathwayClones.length !== 0 && u.pathwayClones.forEach(function(ne) {
                  var ve = ee.filter(function(ut) {
                    return ne[e.Z.CONTENT_STEERING_RESPONSE.BASE_ID] === ut.serviceLocation;
                  }), xe = null;
                  if (ve && ve.length > 0 && (xe = ve[0]), xe) {
                    var Ne = new URL(xe.url), Fe = ne[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.HOST];
                    Fe = St.Z.stringHasProtocol(Fe) ? Fe : "".concat(Ne.protocol, "//").concat(Fe);
                    var Le = { synthesizedUrl: "".concat(Fe).concat(Ne.pathname), serviceLocation: ne[e.Z.CONTENT_STEERING_RESPONSE.ID], queryParams: ne[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.PARAMS], reference: xe };
                    k.push(Le);
                  }
                }), k;
              } catch (ne) {
                return r.error(ne), [];
              }
            }
            function oe() {
              u && u.ttl && !isNaN(u.ttl) && (I && clearTimeout(I), I = setTimeout(function() {
                D();
              }, 1e3 * u.ttl));
            }
            function Q() {
              I && clearTimeout(I), I = null;
            }
            function ue() {
              u = null, w = {}, _ = { baseUrl: { current: null, all: [] }, location: { current: null, all: [] } }, Q();
            }
            return i = { reset: function() {
              ue(), Z.off(n.Z.FRAGMENT_LOADING_STARTED, _e, i), Z.off(n.Z.MANIFEST_LOADING_STARTED, q, i), Z.off(n.Z.MANIFEST_LOADING_FINISHED, le, i), Z.off(n.Z.THROUGHPUT_MEASUREMENT_STORED, K, i);
            }, setConfig: function(ee) {
              ee && (ee.adapter && (me = ee.adapter), ee.errHandler && (C = ee.errHandler), ee.dashMetrics && (F = ee.dashMetrics), ee.mediaPlayerModel && (Y = ee.mediaPlayerModel), ee.requestModifier && (N = ee.requestModifier), ee.manifestModel && (H = ee.manifestModel), ee.serviceDescriptionController && (U = ee.serviceDescriptionController), ee.eventBus && (Z = ee.eventBus));
            }, loadSteeringData: D, getCurrentSteeringResponseData: function() {
              return u;
            }, shouldQueryBeforeStart: function() {
              var ee = L();
              return !!ee && ee.queryBeforeStart;
            }, getSteeringDataFromManifest: L, stopSteeringRequestTimer: Q, getSynthesizedBaseUrlElements: function(ee) {
              try {
                return A(ee).map(function(k) {
                  var ne = new Ir(k.synthesizedUrl, k.serviceLocation);
                  return ne.queryParams = k.queryParams, ne.dvbPriority = k.reference.dvbPriority, ne.dvbWeight = k.reference.dvbWeight, ne.availabilityTimeOffset = k.reference.availabilityTimeOffset, ne.availabilityTimeComplete = k.reference.availabilityTimeComplete, ne;
                });
              } catch (k) {
                return r.error(k), [];
              }
            }, getSynthesizedLocationElements: function(ee) {
              try {
                return A(ee).map(function(k) {
                  var ne = new nn(k.synthesizedUrl, k.serviceLocation);
                  return ne.queryParams = k.queryParams, ne;
                });
              } catch (k) {
                return r.error(k), [];
              }
            }, initialize: function() {
              y = cr(ae).create({ errHandler: C, dashMetrics: F, mediaPlayerModel: Y, requestModifier: N, errors: $ }), Z.on(n.Z.FRAGMENT_LOADING_STARTED, _e, i), Z.on(n.Z.MANIFEST_LOADING_STARTED, q, i), Z.on(n.Z.MANIFEST_LOADING_FINISHED, le, i), Z.on(n.Z.THROUGHPUT_MEASUREMENT_STORED, K, i);
            } }, r = (0, h.Z)(ae).getInstance().getLogger(i), ue(), i;
          }
          qi.__dashjs_factory_name = "ContentSteeringController";
          var Cr = v.Z.getSingletonFactory(qi);
          function Vi() {
            var i, r, u, _ = this.context, w = (0, Me.Z)(_).getInstance();
            return i = { select: function(I) {
              if (!I || I.length === 0) return null;
              var y = null;
              return w.get().streaming.applyContentSteering && (y = function(C) {
                var F = u.getCurrentSteeringResponseData();
                return F && F.pathwayPriority && F.pathwayPriority.length > 0 ? function() {
                  for (var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], N = 0, U = null, Z = function() {
                    var me = Y[N], ae = H.findIndex(function(fe) {
                      return fe.serviceLocation && fe.serviceLocation === me;
                    });
                    if (ae !== -1 && !r.contains(H[ae].serviceLocation)) return U = H[ae], "break";
                    N += 1;
                  }; N < Y.length && Z() !== "break"; ) ;
                  return U;
                }(F.pathwayPriority, C) : null;
              }(I)), y || (y = function(C) {
                return C[0];
              }(I)), y;
            }, setConfig: function(I) {
              I.blacklistController && (r = I.blacklistController), I.contentSteeringController && (u = I.contentSteeringController);
            }, reset: function() {
              r.reset();
            } }, r = gi(_).create({ updateEventName: l.Z.SERVICE_LOCATION_LOCATION_BLACKLIST_CHANGED, addBlacklistEventName: l.Z.SERVICE_LOCATION_LOCATION_BLACKLIST_ADD }), u = Cr(_).getInstance(), i;
          }
          Vi.__dashjs_factory_name = "LocationSelector";
          var Vr = v.Z.getClassFactory(Vi);
          function ji() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z, me = this.context, ae = (0, p.Z)(me).getInstance(), fe = (0, tt.Z)(me).getInstance();
            function _e() {
              u = NaN, y = !1, w = !0, I = !1, q();
            }
            function q() {
              _ !== null && (clearTimeout(_), _ = null);
            }
            function le(Q) {
              q(), I || (isNaN(Q) && !isNaN(u) && (Q = 1e3 * u), isNaN(Q) || (r.debug("Refresh manifest in " + Q + " milliseconds."), _ = setTimeout(L, Q)));
            }
            function K() {
              var Q = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              y = !0;
              var ue = F.getValue(), ee = ue.url, k = null, ne = H.getPatchLocation(ue), ve = Y.select(ne), xe = null;
              if (ve && !Q) ee = ve.url, k = ve.serviceLocation, xe = ve.queryParams;
              else {
                var Ne = de(ue), Fe = Y.select(Ne);
                Fe && (ee = Fe.url, k = Fe.serviceLocation, xe = Fe.queryParams);
              }
              fe.isRelative(ee) && (ee = fe.resolve(ee, ue.url)), C.load(ee, k, xe);
            }
            function de(Q) {
              var ue = H.getLocation(Q), ee = U.getSynthesizedLocationElements(ue);
              return ue.concat(ee);
            }
            function g(Q) {
              if (Q) {
                if (H.getIsPatch(Q)) {
                  var ue = Q;
                  Q = F.getValue();
                  var ee = H.isPatchValid(Q, ue), k = ee;
                  if (ee) {
                    var ne = H.getPublishTime(Q);
                    k = H.applyPatchToManifest(Q, ue);
                    var ve = H.getPublishTime(Q);
                    k = ne.getTime() != ve.getTime();
                  }
                  if (!k) return r.debug("Patch provided is invalid, performing full manifest refresh"), void K(!0);
                  Q.loadedTime = /* @__PURE__ */ new Date();
                }
              } else (Q = F.getValue()).loadedTime = /* @__PURE__ */ new Date();
              if (F.getValue() && F.getValue().type === e.Z.DYNAMIC && Q.type === e.Z.STATIC) return ae.trigger(l.Z.DYNAMIC_TO_STATIC), y = !1, void (I = !0);
              F.setValue(Q);
              var xe = /* @__PURE__ */ new Date(), Ne = (xe.getTime() - Q.loadedTime.getTime()) / 1e3;
              1e3 * (u = H.getManifestUpdatePeriod(Q, Ne)) > 2147483647 && (u = 2147483647e-3), ae.trigger(l.Z.MANIFEST_UPDATED, { manifest: Q }), r.info("Manifest has been refreshed at " + xe + "[" + xe.getTime() / 1e3 + "] "), w || le();
            }
            function L() {
              w || (y ? le(Z.get().streaming.manifestUpdateRetryInterval) : K());
            }
            function D(Q) {
              Q.error ? Q.error.code === $.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE && N.error(Q.error) : g(Q.manifest);
            }
            function O() {
              w = !1, le();
            }
            function A() {
              (w = !Z.get().streaming.scheduling.scheduleWhilePaused) && q();
            }
            function oe() {
              y = !1;
            }
            return i = { initialize: function() {
              _e(), ae.on(l.Z.STREAMS_COMPOSED, oe, this), ae.on(n.Z.PLAYBACK_STARTED, O, this), ae.on(n.Z.PLAYBACK_PAUSED, A, this), ae.on(l.Z.INTERNAL_MANIFEST_LOADED, D, this);
            }, setManifest: function(Q) {
              g(Q);
            }, refreshManifest: K, getIsUpdating: function() {
              return y;
            }, setConfig: function(Q) {
              Q && (Q.manifestModel && (F = Q.manifestModel), Q.adapter && (H = Q.adapter), Q.manifestLoader && (C = Q.manifestLoader), Q.errHandler && (N = Q.errHandler), Q.locationSelector && (Y = Q.locationSelector), Q.settings && (Z = Q.settings), Q.contentSteeringController && (U = Q.contentSteeringController));
            }, reset: function() {
              ae.off(n.Z.PLAYBACK_STARTED, O, this), ae.off(n.Z.PLAYBACK_PAUSED, A, this), ae.off(l.Z.STREAMS_COMPOSED, oe, this), ae.off(l.Z.INTERNAL_MANIFEST_LOADED, D, this), _e();
            } }, r = (0, h.Z)(me).getInstance().getLogger(i), Y = Vr(me).create(), i;
          }
          ji.__dashjs_factory_name = "ManifestUpdater";
          var Oo = v.Z.getClassFactory(ji);
          function xa() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe = this.context, _e = (0, p.Z)(fe).getInstance(), q = (0, tt.Z)(fe).getInstance();
            function le() {
              C = [], F = [], Y = null, H = null, U = null, N = NaN, u = !1, _ = !1, Z = w.get().streaming.utcSynchronization.timeBetweenSyncAttempts;
            }
            function K() {
              w.get().streaming.utcSynchronization.enabled && !u && !_ && U && U.value && U.schemeIdUri && !isNaN(N) && !isNaN(w.get().streaming.utcSynchronization.backgroundAttempts) && (H && (Date.now() - H) / 1e3 < 30 || (C = [], _ = !0, de(isNaN(w.get().streaming.utcSynchronization.backgroundAttempts) ? 2 : w.get().streaming.utcSynchronization.backgroundAttempts)));
            }
            function de(Fe) {
              try {
                if (Fe <= 0) return void xe();
                var Le = Date.now();
                I[U.schemeIdUri](U.value, function(ut) {
                  var ct = Date.now(), nt = L(Le, ct, ut);
                  C.push(nt), de(Fe - 1);
                }, function() {
                  xe();
                });
              } catch {
                xe();
              }
            }
            function g() {
              var Fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Le = Fe || 0;
              if (!F || F.length === 0 || Le >= F.length) D();
              else {
                var ut = F[Le];
                if (ut) if (I.hasOwnProperty(ut.schemeIdUri)) {
                  var ct = (/* @__PURE__ */ new Date()).getTime();
                  I[ut.schemeIdUri](ut.value, function(nt) {
                    var rt = (/* @__PURE__ */ new Date()).getTime(), Bt = L(ct, rt, nt);
                    U = ut, D(Bt);
                  }, function() {
                    g(Le + 1);
                  });
                } else g(Le + 1);
                else D();
              }
            }
            function L(Fe, Le, ut) {
              return ut - (Le - (Le - Fe) / 2);
            }
            function D() {
              var Fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN, Le = isNaN(Fe);
              Le && w.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource ? ne() : ve(Le, Fe);
            }
            function O(Fe) {
              var Le = Date.parse(Fe);
              return isNaN(Le) && (Le = function(ut) {
                var ct, nt, rt = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/.exec(ut);
                return ct = Date.UTC(parseInt(rt[1], 10), parseInt(rt[2], 10) - 1, parseInt(rt[3], 10), parseInt(rt[4], 10), parseInt(rt[5], 10), rt[6] && (parseInt(rt[6], 10) || 0), rt[7] && 1e3 * parseFloat(rt[7]) || 0), rt[9] && rt[10] && (nt = 60 * parseInt(rt[9], 10) + parseInt(rt[10], 10), ct += (rt[8] === "+" ? -1 : 1) * nt * 60 * 1e3), new Date(ct).getTime();
              }(Fe)), Le;
            }
            function A(Fe) {
              return Date.parse(Fe);
            }
            function oe(Fe) {
              return Date.parse(Fe);
            }
            function Q(Fe, Le, ut) {
              ut();
            }
            function ue(Fe, Le, ut) {
              var ct = O(Fe);
              isNaN(ct) ? ut() : Le(ct);
            }
            function ee(Fe, Le, ut, ct, nt) {
              var rt, Bt, we = !1, He = new XMLHttpRequest(), pt = nt ? Ge.w.HEAD : Ge.w.GET, We = Le.match(/\S+/g);
              if (Le = We.shift(), rt = function() {
                we || (we = !0, We.length ? ee(Fe, We.join(" "), ut, ct, nt) : ct());
              }, Bt = function() {
                var vt, ht;
                He.status === 200 && (vt = nt ? He.getResponseHeader("Date") : He.response, ht = Fe(vt), isNaN(ht) || (ut(ht), we = !0));
              }, q.isRelative(Le)) {
                var Tt = ae.resolve();
                Tt && (Le = q.resolve(Le, Tt.url));
              }
              He.open(pt, Le), He.timeout = 5e3, He.onload = Bt, He.onloadend = rt, He.send();
            }
            function k(Fe, Le, ut) {
              ee(oe, Fe, Le, ut, !0);
            }
            function ne() {
              var Fe = y.getLatestMPDRequestHeaderValueByID("Date"), Le = Fe !== null ? new Date(Fe).getTime() : Number.NaN;
              isNaN(Le) ? ve(!0) : ve(!1, Le - Date.now());
            }
            function ve(Fe, Le) {
              if (isNaN(N) || isNaN(Le) || Fe || function(ct) {
                try {
                  var nt, rt = Ne(ct), Bt = isNaN(Z) ? 30 : Z, we = isNaN(w.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor) ? 2 : w.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor, He = isNaN(w.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts) ? 600 : w.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts, pt = isNaN(w.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts) ? 2 : w.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts;
                  rt ? (nt = Math.min(Bt * we, He), r.debug("Increasing timeBetweenSyncAttempts to ".concat(nt))) : (nt = Math.max(Bt / we, pt), r.debug("Decreasing timeBetweenSyncAttempts to ".concat(nt))), Z = nt;
                } catch {
                }
              }(Le), !Fe && !isNaN(Le)) {
                Y = Date.now(), u = !1;
                var ut = isNaN(N);
                N = Le, ut && K(), r.debug("Completed UTC sync. Setting client - server offset to ".concat(Le));
              }
              Fe && (U = null, u = !1, me.error(new se.Z($.TIME_SYNC_FAILED_ERROR_CODE, $.TIME_SYNC_FAILED_ERROR_MESSAGE))), _e.trigger(l.Z.UPDATE_TIME_SYNC_OFFSET, { offset: Le }), _e.trigger(l.Z.TIME_SYNCHRONIZATION_COMPLETED);
            }
            function xe() {
              if (C && C.length !== 0) {
                var Fe = C.reduce(function(Le, ut) {
                  return Le + ut;
                }, 0) / C.length;
                Ne(Fe) ? r.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted.") : (r.debug("Completed background UTC sync. Setting client - server offset to ".concat(Fe)), N = Fe, _e.trigger(l.Z.UPDATE_TIME_SYNC_OFFSET, { offset: N })), _ = !1, H = Date.now();
              }
            }
            function Ne(Fe) {
              try {
                if (isNaN(N)) return !0;
                var Le = w.get().streaming.utcSynchronization.maximumAllowedDrift && !isNaN(w.get().streaming.utcSynchronization.maximumAllowedDrift) ? w.get().streaming.utcSynchronization.maximumAllowedDrift : 100;
                return Fe >= N - Le && Fe <= N + Le;
              } catch {
                return !0;
              }
            }
            return i = { initialize: function() {
              le(), I = { "urn:mpeg:dash:utc:http-head:2014": k, "urn:mpeg:dash:utc:http-xsdate:2014": ee.bind(null, O), "urn:mpeg:dash:utc:http-iso:2014": ee.bind(null, A), "urn:mpeg:dash:utc:direct:2014": ue, "urn:mpeg:dash:utc:http-head:2012": k, "urn:mpeg:dash:utc:http-xsdate:2012": ee.bind(null, O), "urn:mpeg:dash:utc:http-iso:2012": ee.bind(null, A), "urn:mpeg:dash:utc:direct:2012": ue, "urn:mpeg:dash:utc:http-ntp:2014": Q, "urn:mpeg:dash:utc:ntp:2014": Q, "urn:mpeg:dash:utc:sntp:2014": Q };
            }, attemptSync: function(Fe, Le) {
              F = Fe, u || (function(ut) {
                try {
                  if (!ut || !w.get().streaming.utcSynchronization.enabled) return !1;
                  var ct = isNaN(Z) ? 30 : Z;
                  return !(Y && ct && !isNaN(ct)) || (Date.now() - Y) / 1e3 >= ct;
                } catch {
                  return !0;
                }
              }(Le) ? (u = !0, g()) : _e.trigger(l.Z.TIME_SYNCHRONIZATION_COMPLETED));
            }, setConfig: function(Fe) {
              Fe && (Fe.dashMetrics && (y = Fe.dashMetrics), Fe.baseURLController && (ae = Fe.baseURLController), Fe.errHandler && (me = Fe.errHandler), Fe.settings && (w = Fe.settings));
            }, reset: function() {
              le(), _e.off(l.Z.ATTEMPT_BACKGROUND_SYNC, K, i);
            } }, r = (0, h.Z)(fe).getInstance().getLogger(i), _e.on(l.Z.ATTEMPT_BACKGROUND_SYNC, K, i), i;
          }
          xa.__dashjs_factory_name = "TimeSyncController";
          var Fa = v.Z.getSingletonFactory(xa);
          Fa.HTTP_TIMEOUT_MS = 5e3, v.Z.updateSingletonFactory(xa.__dashjs_factory_name, Fa);
          var Zl = Fa;
          function Mo() {
            var i, r, u, _, w, I = this.context, y = (0, p.Z)(I).getInstance();
            return i = { attachMediaSource: function(C) {
              var F = window.URL.createObjectURL(r);
              return C.setSource(F), _ === "managedMediaSource" && (C.setDisableRemotePlayback(!0), r.addEventListener("startstreaming", function() {
                y.trigger(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING);
              }), r.addEventListener("endstreaming", function() {
                y.trigger(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING);
              })), F;
            }, createMediaSource: function() {
              var C = "WebKitMediaSource" in window, F = "MediaSource" in window;
              return "ManagedMediaSource" in window ? (r = new ManagedMediaSource(), _ = "managedMediaSource", w.info("Created ManagedMediaSource")) : F ? (r = new MediaSource(), _ = "mediaSource", w.info("Created MediaSource")) : C && (r = new WebKitMediaSource(), w.info("Created WebkitMediaSource")), r;
            }, detachMediaSource: function(C) {
              C.setSource(null);
            }, setConfig: function(C) {
              C && C.settings && (u = C.settings);
            }, setDuration: function C(F) {
              r && r.readyState === "open" && (F === null && isNaN(F) || r.duration !== F && (F !== 1 / 0 || u.get().streaming.buffer.mediaSourceDurationInfinity || (F = Math.pow(2, 32)), function(Y) {
                for (var H = Y.sourceBuffers, N = 0; N < H.length; N++) if (H[N].updating) return !0;
                return !1;
              }(r) ? setTimeout(C.bind(null, F), 50) : (w.info("Set MediaSource duration:" + F), r.duration = F)));
            }, setSeekable: function(C, F) {
              r && typeof r.setLiveSeekableRange == "function" && typeof r.clearLiveSeekableRange == "function" && r.readyState === "open" && C >= 0 && C < F && (r.clearLiveSeekableRange(), r.setLiveSeekableRange(C, F));
            }, signalEndOfStream: function(C) {
              if (C && C.readyState === "open") {
                for (var F = C.sourceBuffers, Y = 0; Y < F.length; Y++)
                  if (F[Y].updating || F[Y].buffered.length === 0) return;
                w.info("call to mediaSource endOfStream"), C.endOfStream();
              }
            } }, w = (0, h.Z)(I).getInstance().getLogger(i), i;
          }
          Mo.__dashjs_factory_name = "MediaSourceController";
          var Bl = v.Z.getSingletonFactory(Mo);
          function Lo() {
            var i, r, u, _, w, I, y, C, F, Y, H, N = "urn:mpeg:dash:event:2012", U = "discarded", Z = "updated", me = "added", ae = this.context, fe = (0, p.Z)(ae).getInstance();
            function _e() {
              if (!y || !C) throw new Error("setConfig function has to be called previously");
            }
            function q() {
              H = !1, u = {}, _ = {}, w = null, Y = !1, I = Date.now() / 1e3;
            }
            function le() {
              try {
                if (!Y) {
                  Y = !0;
                  var Q = C.getTime(), ue = Q - I;
                  ue = I > 0 ? Math.max(0, ue) : 0, K(_, ue, Q), K(u, ue, Q), de(_), de(u), I = Q, Y = !1;
                }
              } catch (ee) {
                Y = !1, r.error(ee);
              }
            }
            function K(Q, ue, ee) {
              try {
                O(Q, function(k) {
                  if (k !== void 0) {
                    var ne = isNaN(k.duration) ? 0 : k.duration;
                    k.calculatedPresentationTime <= ee && k.calculatedPresentationTime + ue + ne >= ee ? oe(k, n.Z.EVENT_MODE_ON_START) : (A(ee, ne + ue, k.calculatedPresentationTime) || function(ve) {
                      try {
                        var xe = ve.eventStream.period.start + ve.eventStream.period.duration;
                        return ve.calculatedPresentationTime > xe;
                      } catch (Ne) {
                        return r.error(Ne), !1;
                      }
                    }(k)) && (r.debug("Removing event ".concat(k.id, " from period ").concat(k.eventStream.period.id, " as it is expired or invalid")), function(ve, xe) {
                      try {
                        var Ne = xe.eventStream.schemeIdUri, Fe = xe.eventStream.period.id, Le = xe.eventStream.value, ut = xe.id;
                        ve[Fe][Ne] = ve[Fe][Ne].filter(function(ct) {
                          return Le && ct.eventStream.value && ct.eventStream.value !== Le || ct.id !== ut;
                        }), ve[Fe][Ne].length === 0 && delete ve[Fe][Ne];
                      } catch (ct) {
                        r.error(ct);
                      }
                    }(Q, k));
                  }
                });
              } catch (k) {
                r.error(k);
              }
            }
            function de(Q) {
              try {
                for (var ue in Q) Q.hasOwnProperty(ue) && Object.keys(Q[ue]).length === 0 && delete Q[ue];
              } catch (ee) {
                r.error(ee);
              }
            }
            function g(Q, ue) {
              var ee = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], k = Q.eventStream.schemeIdUri, ne = Q.eventStream.value, ve = Q.id, xe = U;
              ue[k] || (ue[k] = []);
              var Ne = ue[k].findIndex(function(Le) {
                return (!ne || Le.eventStream.value && Le.eventStream.value === ne) && Le.id === ve;
              });
              if (Ne === -1) ue[k].push(Q), Q.triggeredReceivedEvent = !1, Q.triggeredStartEvent = !1, xe = me;
              else if (ee) {
                var Fe = ue[k][Ne];
                Q.triggeredReceivedEvent = Fe.triggeredReceivedEvent, Q.triggeredStartEvent = Fe.triggeredStartEvent, ue[k][Ne] = Q, xe = Z;
              }
              return xe;
            }
            function L(Q) {
              try {
                if (Q.eventStream.value == 1) {
                  var ue, ee = Q.calculatedPresentationTime;
                  ue = Q.calculatedPresentationTime == 4294967295 ? NaN : Q.calculatedPresentationTime + Q.duration, fe.trigger(n.Z.MANIFEST_VALIDITY_CHANGED, { id: Q.id, validUntil: ee, newDuration: ue, newManifestValidAfter: NaN }, { mode: n.Z.EVENT_MODE_ON_START });
                }
              } catch (k) {
                r.error(k);
              }
            }
            function D(Q) {
              try {
                var ue = C.getTime();
                O(Q, function(ee) {
                  var k = ee.eventStream && ee.eventStream.period && !isNaN(ee.eventStream.period.duration) ? ee.eventStream.period.duration : NaN, ne = ee.eventStream && ee.eventStream.period && !isNaN(ee.eventStream.period.start) ? ee.eventStream.period.start : NaN;
                  if (!isNaN(k) && !isNaN(ne)) {
                    var ve = ee.calculatedPresentationTime;
                    Math.abs(ve - ue) < 300 && oe(ee, n.Z.EVENT_MODE_ON_START);
                  }
                });
              } catch (ee) {
                r.error(ee);
              }
            }
            function O(Q, ue) {
              try {
                if (Q) for (var ee = Object.keys(Q), k = 0; k < ee.length; k++) for (var ne = Q[ee[k]], ve = Object.keys(ne), xe = 0; xe < ve.length; xe++) ne[ve[xe]].forEach(function(Ne) {
                  Ne !== void 0 && ue(Ne);
                });
              } catch (Ne) {
                r.error(Ne);
              }
            }
            function A(Q, ue, ee) {
              try {
                return Q - ue > ee;
              } catch (k) {
                return r.error(k), !1;
              }
            }
            function oe(Q, ue) {
              try {
                var ee = C.getTime(), k = Q.id;
                if (ue === n.Z.EVENT_MODE_ON_RECEIVE && !Q.triggeredReceivedEvent) return r.debug("Received event ".concat(k)), Q.triggeredReceivedEvent = !0, void fe.trigger(Q.eventStream.schemeIdUri, { event: Q }, { mode: ue });
                Q.triggeredStartEvent || (Q.eventStream.schemeIdUri === N && Q.eventStream.value == 1 ? Q.duration === 0 && Q.presentationTimeDelta === 0 || (r.debug("Starting manifest refresh event ".concat(k, " at ").concat(ee)), function() {
                  try {
                    _e(), y.refreshManifest();
                  } catch (ne) {
                    r.error(ne);
                  }
                }()) : Q.eventStream.schemeIdUri === "urn:mpeg:dash:event:callback:2015" && Q.eventStream.value == 1 ? (r.debug("Starting callback event ".concat(k, " at ").concat(ee)), function(ne) {
                  try {
                    (0, Ht.Z)(ae).create({}).load({ method: "get", url: ne, request: { responseType: "arraybuffer" } });
                  } catch (ve) {
                    r.error(ve);
                  }
                }(Q.messageData)) : (r.debug("Starting event ".concat(k, " from period ").concat(Q.eventStream.period.id, " at ").concat(ee)), fe.trigger(Q.eventStream.schemeIdUri, { event: Q }, { mode: ue })), Q.triggeredStartEvent = !0);
              } catch (ne) {
                r.error(ne);
              }
            }
            return i = { addInlineEvents: function(Q, ue) {
              try {
                if (_e(), u[ue] || (u[ue] = {}), Q) for (var ee = 0; ee < Q.length; ee++) {
                  var k = Q[ee];
                  if (!A(C.getTime(), isNaN(k.duration) ? 0 : k.duration, k.calculatedPresentationTime)) {
                    var ne = g(k, u[ue], !0);
                    ne === me ? (r.debug("Added inline event with id ".concat(k.id, " from period ").concat(ue)), oe(k, n.Z.EVENT_MODE_ON_RECEIVE)) : ne === Z && r.debug("Updated inline event with id ".concat(k.id, " from period ").concat(ue));
                  }
                }
              } catch (ve) {
                throw ve;
              }
            }, addInbandEvents: function(Q, ue) {
              try {
                _e(), _[ue] || (_[ue] = {});
                for (var ee = 0; ee < Q.length; ee++) {
                  var k = Q[ee];
                  A(C.getTime(), isNaN(k.duration) ? 0 : k.duration, k.calculatedPresentationTime) || (g(k, _[ue], !1) === me ? (k.eventStream.schemeIdUri === N && L(k), r.debug("Added inband event with id ".concat(k.id, " from period ").concat(ue)), oe(k, n.Z.EVENT_MODE_ON_RECEIVE)) : r.debug("Inband event with scheme_id_uri ".concat(k.eventStream.schemeIdUri, ", value ").concat(k.eventStream.value, ", period id ").concat(ue, " and event id ").concat(k.id, " was ignored because it has been added before.")));
                }
                le();
              } catch (ne) {
                throw ne;
              }
            }, getInbandEvents: function() {
              return _;
            }, getInlineEvents: function() {
              return u;
            }, start: function() {
              try {
                _e(), r.debug("Start Event Controller");
                var Q = F.get().streaming.eventControllerRefreshDelay;
                H || isNaN(Q) || (H = !0, w = setInterval(le, Q));
              } catch (ue) {
                throw ue;
              }
            }, setConfig: function(Q) {
              try {
                if (!Q) return;
                Q.manifestUpdater && (y = Q.manifestUpdater), Q.playbackController && (C = Q.playbackController), Q.settings && (F = Q.settings);
              } catch (ue) {
                throw ue;
              }
            }, reset: function() {
              (function() {
                try {
                  w !== null && H && (clearInterval(w), w = null, H = !1, function() {
                    try {
                      D(_), D(u);
                    } catch (Q) {
                      r.error(Q);
                    }
                  }());
                } catch (Q) {
                  throw Q;
                }
              })(), q();
            } }, r = (0, h.Z)(ae).getInstance().getLogger(i), q(), i;
          }
          Lo.__dashjs_factory_name = "EventController";
          var Ul = v.Z.getSingletonFactory(Lo), mi = { LEVELS: { SUGGESTION: "Suggestion", WARNING: "Warning", ERROR: "Error" }, EVENTS: { NO_UTC_TIMING_ELEMENT: { key: "NO_UTC_TIMING_ELEMENT", message: "No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/" }, NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE: { key: "NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE", message: 'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"' }, INVALID_DVR_WINDOW: { key: "INVALID_DVR_WINDOW", message: "No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback." } } };
          function ka(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function Po() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q, le, K, de, g, L, D, O, A, oe, Q, ue, ee, k, ne, ve, xe, Ne, Fe, Le, ut, ct, nt, rt, Bt, we, He, pt, We, Tt, vt = this.context, ht = (0, p.Z)(vt).getInstance();
            function Wt() {
              if (!(I && I.hasOwnProperty("load") && K && K.hasOwnProperty("initialize") && K.hasOwnProperty("reset") && K.hasOwnProperty("getClientTimeOffset") && y && le && F && ne)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            function zt() {
              if (!w || !w.hasOwnProperty("setManifest")) throw new Error("initialize function has to be called previously");
            }
            function gn() {
              (function() {
                try {
                  var et = C.getStreamsInfo();
                  if (!g && et.length === 0) throw new Error("There are no periods in the MPD");
                  g && et.length > 0 && F.updateManifestUpdateInfo({ currentTime: ne.getTime(), buffered: k.getBufferRange(), presentationStartTime: et[0].start, clientTimeOffset: K.getClientTimeOffset() }), de.length > 0 && function(An) {
                    An.length !== 0 ? de = de.filter(function(En) {
                      var Vn = An.filter(function(Fn) {
                        return Fn.id === En.getId();
                      }).length > 0 || En.getId() === g.getId();
                      return Vn || (r.debug("Removing stream ".concat(En.getId())), En.reset(!0)), Vn;
                    }) : r.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");
                  }(et);
                  for (var Lt = [], on = 0, hn = et.length; on < hn; on++) {
                    var Sn = et[on];
                    Lt.push(Ke(Sn)), F.addManifestUpdateStreamInfo(Sn);
                  }
                  Promise.all(Lt).then(function() {
                    return new Promise(function(An, En) {
                      g ? An() : Et(et, An, En);
                    });
                  }).then(function() {
                    ht.trigger(l.Z.STREAMS_COMPOSED), xt();
                  }).catch(function(An) {
                    throw An;
                  });
                } catch (An) {
                  le.error(new se.Z($.MANIFEST_ERROR_ID_NOSTREAMS_CODE, An.message + " nostreamscomposed", y.getValue())), ue = !0, Kr();
                }
              })();
            }
            function pn() {
              He = !0;
            }
            function Ke(et) {
              var Lt = Ni(et.id);
              return Lt ? Lt.updateData(et) : (Lt = $r(vt).create({ manifestModel: y, mediaPlayerModel: xe, dashMetrics: F, manifestUpdater: w, adapter: C, timelineConverter: K, capabilities: u, capabilitiesFilter: _, errHandler: le, baseURLController: U, segmentBaseController: Z, textController: D, abrController: ae, playbackController: ne, eventController: _e, mediaController: fe, protectionController: L, videoModel: k, streamInfo: et, settings: we }), de.push(Lt), Lt.initialize(), Promise.resolve());
            }
            function Et(et, Lt, on) {
              try {
                Xt();
                var hn = F.getCurrentDVRInfo().range;
                if (hn.end < hn.start) {
                  pt && clearTimeout(pt);
                  var Sn = Math.min(1e3 * (-1 * (hn.end - hn.start) + 2), 2147483647);
                  return r.debug("Waiting for ".concat(Sn, " ms before playback can start")), ht.trigger(l.Z.AST_IN_FUTURE, { delay: Sn }), void (pt = setTimeout(function() {
                    Et(et, Lt, on);
                  }, Sn));
                }
                we.get().streaming.applyProducerReferenceTime && ve.calculateProducerReferenceTimeOffsets(et);
                var An = et[0].manifestInfo;
                if (we.get().streaming.applyServiceDescription && ve.applyServiceDescription(An), C.getIsDynamic()) {
                  var En = ei(et, An);
                  ne.computeAndSetLiveDelay(En, An);
                }
                (we.get().streaming.applyContentSteering && N.shouldQueryBeforeStart() ? N.loadSteeringData() : Promise.resolve()).then(function() {
                  var Vn = y.getValue();
                  Vn && U.update(Vn), lt(), Lt();
                }).catch(function(Vn) {
                  r.error(Vn), lt(), Lt();
                });
              } catch (Vn) {
                on(Vn);
              }
            }
            function lt() {
              var et = function() {
                var hn;
                if (C.getIsDynamic()) {
                  var Sn = F.getCurrentDVRInfo();
                  hn = (Sn && Sn.range ? Sn.range.end : 0) - ne.getOriginalLiveDelay();
                  var An = Sn ? Sn.range : null;
                  if (An) {
                    if (isNaN(We) && We.toString().indexOf("posix:") === -1) {
                      var En = mr(!0);
                      isNaN(En) || (r.info("Start time from URI parameters: ".concat(En)), hn = Math.min(hn, En));
                    } else {
                      r.info("Start time provided by the app: ".concat(We));
                      var Vn = er(!0, We);
                      isNaN(Vn) || (hn = Math.min(hn, Vn));
                    }
                    var Fn = we.get().streaming.timeShiftBuffer.calcFromSegmentTimeline ? 0.1 : 0;
                    hn = Math.max(hn, An.start + Fn);
                  }
                } else if (hn = ri()[0].getStreamInfo().start, isNaN(We)) {
                  var Ur = mr(!1);
                  isNaN(Ur) || (r.info("Start time from URI parameters: ".concat(Ur)), hn = Math.max(hn, Ur));
                } else {
                  r.info("Start time provided by the app: ".concat(We));
                  var Ei = er(!1, We);
                  isNaN(Ei) || (hn = Math.max(hn, Ei));
                }
                return hn;
              }(), Lt = Vt(et), on = Lt !== null ? Lt : de[0];
              ht.trigger(l.Z.INITIAL_STREAM_SWITCH, { startTime: et }), Rt(on, null, et), ct || (ct = setInterval(function() {
                !oe && ne.getTimeToStreamEnd() <= 0 && !ne.isSeeking() && ht.trigger(l.Z.PLAYBACK_ENDED, { isLast: Nr().isLast });
              }, 200));
            }
            function Rt(et, Lt, on) {
              try {
                if (oe || !et || Lt === et && et.getIsActive()) return;
                oe = !0, ht.trigger(l.Z.PERIOD_SWITCH_STARTED, { fromStreamInfo: Lt ? Lt.getStreamInfo() : null, toStreamInfo: et.getStreamInfo() });
                var hn = !1;
                g = et, Lt && (hn = kt(et, Lt), Lt.deactivate(hn)), on = isNaN(on) ? !hn && Lt ? et.getStreamInfo().start : NaN : on, r.info("Switch to stream ".concat(et.getId(), ". Seektime is ").concat(on, ", current playback time is ").concat(ne.getTime(), ". Seamless period switch is set to ").concat(hn)), rt = rt.filter(function(Sn) {
                  return Sn.getId() !== g.getId();
                }), ne.initialize(Nr(), !!Lt), k.getElement() ? Pt(on, hn, !1) : $t(on, hn);
              } catch {
                oe = !1;
              }
            }
            function Pt(et, Lt) {
              var on, hn = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              function Sn() {
                if (ee && ee.readyState === "open") {
                  r.debug("MediaSource is open!"), window.URL.revokeObjectURL(on), ee.removeEventListener("sourceopen", Sn), ee.removeEventListener("webkitsourceopen", Sn), Dn();
                  var En = F.getCurrentDVRInfo();
                  Y.setSeekable(En.range.start, En.range.end), hn ? (isNaN(et) || ne.seek(et, !0, !0), g.setMediaSource(ee).then(function() {
                    g.initializeForTextWithMediaSource(ee);
                  })) : $t(et, Lt);
                }
              }
              function An() {
                ee.addEventListener("sourceopen", Sn, !1), ee.addEventListener("webkitsourceopen", Sn, !1), on = Y.attachMediaSource(k), r.debug("MediaSource attached to element.  Waiting on open...");
              }
              ee ? Lt ? $t(et, Lt) : (Y.detachMediaSource(k), An()) : (ee = Y.createMediaSource(), An());
            }
            function $t(et, Lt) {
              g.activate(ee, Lt ? nt : void 0, et).then(function(on) {
                if (on) {
                  var hn = Object.keys(on);
                  hn.length > 0 && on[hn[0]].getBuffer().changeType && (Bt = !0), nt = on;
                }
                isNaN(et) || (ht.trigger(l.Z.SEEK_TARGET, { time: et }, { streamId: g.getId() }), ne.seek(et, !1, !0), g.startScheduleControllers()), oe = !1, ht.trigger(l.Z.PERIOD_SWITCH_COMPLETED, { toStreamInfo: Nr() });
              });
            }
            function Qt(et) {
              var Lt = Vt(et.seekTime);
              Lt && Lt !== g ? Lt && Lt !== g && (en(), function(on, hn) {
                var Sn = on && !isNaN(on.seekTime) ? on.seekTime : NaN, An = g.getProcessors().map(function(En) {
                  return En.prepareOuterPeriodPlaybackSeeking(on);
                });
                Promise.all(An).then(function() {
                  Rt(hn, g, Sn);
                }).catch(function(En) {
                  le.error(En);
                });
              }(et, Lt)) : (en(), function(on) {
                g.getProcessors().forEach(function(hn) {
                  return hn.prepareInnerPeriodPlaybackSeeking(on);
                }), pr(Oe.USER_REQUEST_STOP_REASON);
              }(et)), Yr(ke.SEEK_START_REASON);
            }
            function en() {
              sn();
            }
            function sn() {
              rt && rt.length > 0 && (rt.forEach(function(et) {
                et.deactivate(!0);
              }), rt = []);
            }
            function mt(et) {
              if (et.newMediaInfo.streamInfo.id === g.getId()) {
                if (sn(), we.get().streaming.buffer.resetSourceBuffersForTrackSwitch && et.oldMediaInfo && et.oldMediaInfo.codec !== et.newMediaInfo.codec) {
                  var Lt = ne.getTime();
                  return g.deactivate(!1), void Pt(Lt, !1, !1);
                }
                g.prepareTrackChange(et);
              }
            }
            function kt(et, Lt) {
              try {
                return we.get().streaming.buffer.reuseExistingSourceBuffers && (Lt.isProtectionCompatible(et) || He) && (Bt && we.get().streaming.buffer.useChangeTypeForTrackSwitch || Lt.isMediaCodecCompatible(et, Lt));
              } catch {
                return !1;
              }
            }
            function qt(et) {
              var Lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (ee && !et.getPreloaded()) {
                var on = kt(et, Lt);
                on && et.startPreloading(ee, nt).then(function() {
                  rt.push(et);
                });
              }
            }
            function Vt(et) {
              if (isNaN(et)) return null;
              for (var Lt = de.length, on = 0; on < Lt; on++) {
                var hn = de[on];
                if (et < parseFloat((hn.getStartTime() + hn.getDuration()).toFixed(5))) return hn;
              }
              return null;
            }
            function Xt() {
              try {
                var et = C.getIsDynamic(), Lt = C.getStreamsInfo()[0].manifestInfo, on = ne.getTime(), hn = K.calcTimeShiftBufferWindow(de, et), Sn = Ln();
                if (hn.start === void 0 || hn.end === void 0) return;
                Sn && Sn.length !== 0 ? Sn.forEach(function(An) {
                  F.addDVRInfo(An.getType(), on, Lt, hn);
                }) : F.addDVRInfo(t.Z.VIDEO, on, Lt, hn);
              } catch {
              }
            }
            function ze(et) {
              if (Le && A) {
                var Lt = xe.getInitialBufferLevel(), on = [t.Z.TEXT];
                (isNaN(Lt) || Lt <= ne.getBufferLevel(on) || C.getIsDynamic() && Lt > ne.getLiveDelay()) && (Le = !1, Yr(ke.INITIAL_PLAYOUT_START_REASON), ne.play());
              }
              et && et.mediaType && F.addBufferLevel(et.mediaType, /* @__PURE__ */ new Date(), 1e3 * et.bufferLevel);
            }
            function Pe(et) {
              et.streamInfo.id === g.getId() && et.reason && et.reason.forceReplace && sn(), Ni(et.streamInfo.id).prepareQualityChange(et);
            }
            function ft() {
              if (C.getIsDynamic() && ne.getOriginalLiveDelay() !== 0 && g) {
                var et = C.getStreamsInfo();
                if (et.length > 0) {
                  var Lt = et[0].manifestInfo, on = ei(et, Lt);
                  ne.computeAndSetLiveDelay(on, Lt);
                }
              }
            }
            function pe() {
              if (Pr()) {
                var et = k.getPlaybackQuality();
                et && F.addDroppedFrames(et);
              }
            }
            function be() {
              r.debug("[onPlaybackStarted]"), !Le && Fe && Yr(ke.RESUME_FROM_PAUSE_START_REASON), Le && (Le = !1), ut && (ut = !1, we.get().streaming.applyContentSteering && !N.shouldQueryBeforeStart() && N.loadSteeringData()), Fe = !1;
            }
            function Je(et) {
              r.debug("[onPlaybackPaused]"), et.ended || (Fe = !0, pr(Oe.USER_REQUEST_STOP_REASON));
            }
            function Nt(et) {
              r.debug("Stream with id ".concat(et.streamInfo.id, " finished buffering"));
              var Lt = et.streamInfo.isLast;
              ee && Lt ? (r.info("[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController."), Y.signalEndOfStream(ee)) : xt();
            }
            function xt() {
              if (g && g.getHasFinishedBuffering()) for (var et = function() {
                var Sn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                try {
                  var An = Sn || g || null;
                  if (An) {
                    var En = An.getStreamInfo();
                    return de.filter(function(Vn) {
                      var Fn = Vn.getStreamInfo();
                      return Fn.start > En.start && En.id !== Fn.id;
                    });
                  }
                } catch {
                  return [];
                }
              }(g), Lt = 0; Lt < et.length; ) {
                var on = et[Lt], hn = Lt === 0 ? g : et[Lt - 1];
                !on.getPreloaded() && hn.getHasFinishedBuffering() && ee && qt(on, hn), Lt += 1;
              }
            }
            function yn() {
              ct && (clearInterval(ct), ct = null);
            }
            function Ln() {
              return g ? g.getProcessors() : [];
            }
            function Qn(et) {
              if (g && !g.getIsEndedEventSignaled()) {
                g.setIsEndedEventSignaled(!0);
                var Lt = function() {
                  var on = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, hn = on || g || null;
                  if (!hn) return null;
                  for (var Sn = hn.getStreamInfo(), An = Sn.start, En = 0, Vn = -1, Fn = NaN; En < de.length; ) {
                    var Ur = de[En].getStreamInfo(), Ei = Ur.start - An;
                    Ei > 0 && (isNaN(Fn) || Ei < Fn) && Sn.id !== Ur.id && (Fn = Ei, Vn = En), En += 1;
                  }
                  return Vn >= 0 ? de[Vn] : null;
                }();
                Lt ? (r.debug("StreamController onEnded, found next stream with id ".concat(Lt.getStreamInfo().id, ". Switching from ").concat(g.getStreamInfo().id, " to ").concat(Lt.getStreamInfo().id)), Rt(Lt, g, NaN)) : (r.debug("StreamController no next stream found"), g.setIsEndedEventSignaled(!1)), pr(Lt ? Oe.END_OF_PERIOD_STOP_REASON : Oe.END_OF_CONTENT_STOP_REASON);
              }
              et && et.isLast && (yn(), N.stopSteeringRequestTimer());
            }
            function Dn(et) {
              var Lt = et || Nr().manifestInfo.duration;
              Y.setDuration(Lt);
            }
            function mr(et) {
              var Lt = me.getURIFragmentData();
              if (!Lt || !Lt.t) return NaN;
              var on = ri()[0].getStreamInfo().start;
              return Lt.t = Lt.t.split(",")[0], jr(et, Lt.t, on);
            }
            function er(et, Lt) {
              var on = 0;
              return et || (on = ri()[0].getStreamInfo().start), jr(et, Lt, on);
            }
            function jr(et, Lt, on) {
              var hn = C.getRegularPeriods()[0], Sn = Lt.toString(), An = Sn.indexOf("posix:") !== -1 ? Sn.substring(6) === "now" ? Date.now() / 1e3 : parseFloat(Sn.substring(6)) : NaN;
              return et && !isNaN(An) ? K.calcPresentationTimeFromWallTime(new Date(1e3 * An), hn) : parseFloat(Sn) + on;
            }
            function ei(et, Lt) {
              try {
                var on = NaN;
                if (Lt && !isNaN(Lt.maxFragmentDuration) && isFinite(Lt.maxFragmentDuration)) return Lt.maxFragmentDuration;
                if (et && et.length === 1) {
                  var hn = et[0], Sn = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT].reduce(function(En, Vn) {
                    var Fn = C.getMediaInfoForType(hn, Vn);
                    return Fn && Fn.isFragmented !== !1 && En.push(Fn), En;
                  }, []).reduce(function(En, Vn) {
                    var Fn = C.getVoRepresentations(Vn);
                    return Fn && Fn.length > 0 && Fn.forEach(function(Ur) {
                      Ur && En.push(Ur);
                    }), En;
                  }, []).reduce(function(En, Vn) {
                    var Fn = C.convertRepresentationToRepresentationInfo(Vn);
                    return Fn && Fn.fragmentDuration && !isNaN(Fn.fragmentDuration) && En.push(Fn.fragmentDuration), En;
                  }, []);
                  on = Math.max.apply(Math, function(En) {
                    if (Array.isArray(En)) return ka(En);
                  }(An = Sn) || function(En) {
                    if (typeof Symbol < "u" && Symbol.iterator in Object(En)) return Array.from(En);
                  }(An) || function(En, Vn) {
                    if (En) {
                      if (typeof En == "string") return ka(En, Vn);
                      var Fn = Object.prototype.toString.call(En).slice(8, -1);
                      return Fn === "Object" && En.constructor && (Fn = En.constructor.name), Fn === "Map" || Fn === "Set" ? Array.from(En) : Fn === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Fn) ? ka(En, Vn) : void 0;
                    }
                  }(An) || function() {
                    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                  }());
                }
                return isFinite(on) ? on : NaN;
              } catch {
                return NaN;
              }
              var An;
            }
            function ti(et) {
              if (et.error) ue = !0, Kr();
              else {
                r.info("Manifest updated... updating data system wide.");
                var Lt = et.manifest;
                C.updatePeriods(Lt);
                var on = C.getUTCTimingSources();
                !C.getIsDynamic() || on && on.length !== 0 || ht.trigger(n.Z.CONFORMANCE_VIOLATION, { level: mi.LEVELS.WARNING, event: mi.EVENTS.NO_UTC_TIMING_ELEMENT });
                var hn = C.getIsDynamic() ? on.concat(Ne.getUTCTimingSources()) : on;
                _.filterUnsupportedFeatures(Lt).then(function() {
                  U.initialize(Lt), H.attemptSync(hn, C.getIsDynamic());
                });
              }
            }
            function Pr() {
              return !!g && g.getHasVideoTrack();
            }
            function Br() {
              return !!g && g.getHasAudioTrack();
            }
            function pr(et, Lt) {
              Lt = Lt || /* @__PURE__ */ new Date(), Ln().forEach(function(on) {
                on.finalisePlayList(Lt, et);
              }), F.addPlayList();
            }
            function Yr(et) {
              F.createPlaylistMetrics(1e3 * ne.getTime(), et);
            }
            function ni(et) {
              if (et.error) {
                var Lt = "";
                switch (et.error.code) {
                  case 1:
                    Lt = "MEDIA_ERR_ABORTED";
                    break;
                  case 2:
                    Lt = "MEDIA_ERR_NETWORK";
                    break;
                  case 3:
                    Lt = "MEDIA_ERR_DECODE", Tt.counts.mediaErrorDecode += 1;
                    break;
                  case 4:
                    Lt = "MEDIA_ERR_SRC_NOT_SUPPORTED";
                    break;
                  case 5:
                    Lt = "MEDIA_ERR_ENCRYPTED";
                    break;
                  default:
                    Lt = "UNKNOWN";
                }
                Lt === "MEDIA_ERR_DECODE" && we.get().errors.recoverAttempts.mediaErrorDecode >= Tt.counts.mediaErrorDecode ? function() {
                  r.warn("A MEDIA_ERR_DECODE occured: Resetting the MediaSource");
                  var on = ne.getTime();
                  g.deactivate(!1), r.warn("MediaSource has been resetted. Resuming playback from time ".concat(on)), Pt(on, !1, !1);
                }() : (Q = !0, et.error.message && (Lt += " (" + et.error.message + ")"), et.error.msExtendedCode && (Lt += " (0x" + (et.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ")"), r.fatal("Video Element Error: " + Lt), et.error && r.fatal(et.error), le.error(new se.Z(et.error.code, Lt)), Kr());
              }
            }
            function Nr() {
              return g ? g.getStreamInfo() : null;
            }
            function Ni(et) {
              for (var Lt = 0, on = de.length; Lt < on; Lt++) if (de[Lt].getId() === et) return de[Lt];
              return null;
            }
            function oa(et) {
              isNaN(et.newDuration) || Dn(et.newDuration);
            }
            function sa() {
              de = [], We = NaN, L = null, oe = !1, g = null, Q = !1, ue = !1, Le = !0, ut = !0, Fe = !1, A = !0, ct = null, He = !1, Bt = !1, rt = [], pt = null, Tt = { counts: { mediaErrorDecode: 0 } };
            }
            function Kr() {
              Wt(), H.reset(), pr(Q || ue ? Oe.FAILURE_STOP_REASON : Oe.USER_REQUEST_STOP_REASON);
              for (var et = 0, Lt = de ? de.length : 0; et < Lt; et++) de[et].reset(Q);
              ht.off(n.Z.PLAYBACK_TIME_UPDATED, pe, i), ht.off(n.Z.PLAYBACK_SEEKING, Qt, i), ht.off(n.Z.PLAYBACK_ERROR, ni, i), ht.off(n.Z.PLAYBACK_STARTED, be, i), ht.off(n.Z.PLAYBACK_PAUSED, Je, i), ht.off(n.Z.PLAYBACK_ENDED, Qn, i), ht.off(n.Z.METRIC_ADDED, la, i), ht.off(n.Z.MANIFEST_VALIDITY_CHANGED, oa, i), ht.off(n.Z.BUFFER_LEVEL_UPDATED, ze, i), ht.off(n.Z.QUALITY_CHANGE_REQUESTED, Pe, i), l.Z.KEY_SESSION_UPDATED && ht.off(l.Z.KEY_SESSION_UPDATED, pn, i), ht.off(l.Z.MANIFEST_UPDATED, ti, i), ht.off(l.Z.STREAM_BUFFERING_COMPLETED, Nt, i), ht.off(l.Z.TIME_SYNCHRONIZATION_COMPLETED, gn, i), ht.off(l.Z.CURRENT_TRACK_CHANGED, mt, i), ht.off(l.Z.SETTING_UPDATED_LIVE_DELAY, ft, i), ht.off(l.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, ft, i), U.reset(), w.reset(), _e.reset(), F.clearAllCurrentMetrics(), y.setValue(null), I.reset(), K.reset(), q.reset(), ee && (Y.detachMediaSource(k), ee = null), k = null, L && (L = null, O = null, y.getValue() && ht.trigger(l.Z.PROTECTION_DESTROYED, { data: y.getValue().url })), yn(), ht.trigger(l.Z.STREAM_TEARDOWN_COMPLETE), sa();
            }
            function la(et) {
              if (et.metric === m.Z.DVR_INFO) {
                var Lt = Br() ? t.Z.AUDIO : t.Z.VIDEO;
                et.mediaType === Lt && Y.setSeekable(et.value.range.start, et.value.range.end);
              }
            }
            function ri() {
              return de;
            }
            return i = { initialize: function(et, Lt) {
              Wt(), A = et, O = Lt, K.initialize(), (w = Oo(vt).create()).setConfig({ manifestModel: y, adapter: C, manifestLoader: I, errHandler: le, settings: we, contentSteeringController: N }), w.initialize(), (_e = Ul(vt).getInstance()).setConfig({ manifestUpdater: w, playbackController: ne, settings: we }), _e.start(), H.setConfig({ dashMetrics: F, baseURLController: U, errHandler: le, settings: we }), H.initialize(), Y.setConfig({ settings: we }), L && (ht.trigger(l.Z.PROTECTION_CREATED, { controller: L }), L.setMediaElement(k.getElement()), O && L.setProtectionData(O)), ht.on(n.Z.PLAYBACK_TIME_UPDATED, pe, i), ht.on(n.Z.PLAYBACK_SEEKING, Qt, i), ht.on(n.Z.PLAYBACK_ERROR, ni, i), ht.on(n.Z.PLAYBACK_STARTED, be, i), ht.on(n.Z.PLAYBACK_PAUSED, Je, i), ht.on(n.Z.PLAYBACK_ENDED, Qn, i), ht.on(n.Z.METRIC_ADDED, la, i), ht.on(n.Z.MANIFEST_VALIDITY_CHANGED, oa, i), ht.on(n.Z.BUFFER_LEVEL_UPDATED, ze, i), ht.on(n.Z.QUALITY_CHANGE_REQUESTED, Pe, i), l.Z.KEY_SESSION_UPDATED && ht.on(l.Z.KEY_SESSION_UPDATED, pn, i), ht.on(l.Z.MANIFEST_UPDATED, ti, i), ht.on(l.Z.STREAM_BUFFERING_COMPLETED, Nt, i), ht.on(l.Z.TIME_SYNCHRONIZATION_COMPLETED, gn, i), ht.on(l.Z.CURRENT_TRACK_CHANGED, mt, i), ht.on(l.Z.SETTING_UPDATED_LIVE_DELAY, ft, i), ht.on(l.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, ft, i);
            }, getActiveStreamInfo: Nr, addDVRMetric: Xt, hasVideoTrack: Pr, hasAudioTrack: Br, getStreamById: Ni, getStreamForTime: Vt, getTimeRelativeToStreamId: function(et, Lt) {
              for (var on = null, hn = 0, Sn = 0, An = null, En = 0; En < de.length; En++) {
                if (Sn = (on = de[En]).getStartTime(), An = on.getDuration(), Number.isFinite(Sn) && (hn = Sn), on.getId() === Lt) return et - hn;
                Number.isFinite(An) && (hn += An);
              }
              return null;
            }, load: function(et) {
              var Lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              Wt(), We = Lt, I.load(et);
            }, loadWithManifest: function(et) {
              var Lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              zt(), We = Lt, w.setManifest(et);
            }, getActiveStreamProcessors: Ln, setConfig: function(et) {
              et && (et.capabilities && (u = et.capabilities), et.capabilitiesFilter && (_ = et.capabilitiesFilter), et.manifestLoader && (I = et.manifestLoader), et.manifestModel && (y = et.manifestModel), et.mediaPlayerModel && (xe = et.mediaPlayerModel), et.customParametersModel && (Ne = et.customParametersModel), et.protectionController && (L = et.protectionController), et.adapter && (C = et.adapter), et.dashMetrics && (F = et.dashMetrics), et.errHandler && (le = et.errHandler), et.timelineConverter && (K = et.timelineConverter), et.videoModel && (k = et.videoModel), et.playbackController && (ne = et.playbackController), et.serviceDescriptionController && (ve = et.serviceDescriptionController), et.contentSteeringController && (N = et.contentSteeringController), et.textController && (D = et.textController), et.abrController && (ae = et.abrController), et.mediaController && (fe = et.mediaController), et.settings && (we = et.settings), et.baseURLController && (U = et.baseURLController), et.uriFragmentModel && (me = et.uriFragmentModel), et.segmentBaseController && (Z = et.segmentBaseController), et.manifestUpdater && (w = et.manifestUpdater));
            }, setProtectionData: function(et) {
              O = et, L && L.setProtectionData(O);
            }, getIsStreamSwitchInProgress: function() {
              return oe;
            }, switchToVideoElement: function(et) {
              g && (ne.initialize(Nr()), Pt(et, !1, !0));
            }, getHasMediaOrInitialisationError: function() {
              return Q || ue;
            }, getStreams: ri, getActiveStream: function() {
              return g;
            }, getInitialPlayback: function() {
              return Le;
            }, getAutoPlay: function() {
              return A;
            }, refreshManifest: function() {
              w.getIsUpdating() || w.refreshManifest();
            }, reset: Kr }, r = (0, h.Z)(vt).getInstance().getLogger(i), H = Zl(vt).getInstance(), Y = Bl(vt).getInstance(), q = Ie(vt).getInstance(), sa(), i;
          }
          Po.__dashjs_factory_name = "StreamController";
          var xo = v.Z.getSingletonFactory(Po);
          function Fo() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U = this.context, Z = (0, p.Z)(U).getInstance();
            function me() {
              N.debug("Stopping the gap controller"), w && (clearInterval(w), w = null), function() {
                Z.off(l.Z.WALLCLOCK_TIME_UPDATED, le, this), Z.off(l.Z.INITIAL_STREAM_SWITCH, q, this), Z.off(l.Z.PLAYBACK_SEEKING, ae, this), Z.off(l.Z.BUFFER_REPLACEMENT_STARTED, fe, i), Z.off(l.Z.TRACK_CHANGE_RENDERED, _e, i);
              }(), w = null, I = NaN, _ = 0, Y = null, H = {};
            }
            function ae() {
              Y && (clearTimeout(Y), Y = null);
            }
            function fe(O) {
              try {
                if (O.streamId !== C.getActiveStreamInfo().id || O.mediaType !== t.Z.VIDEO && O.mediaType !== t.Z.AUDIO) return;
                O.streamId === C.getActiveStreamInfo().id && (H[O.mediaType] = !0);
              } catch (A) {
                N.error(A);
              }
            }
            function _e(O) {
              O && O.mediaType && (H[O.mediaType] = !1);
            }
            function q() {
              w || function() {
                try {
                  w || (N.debug("Starting the gap controller"), w = setInterval(function() {
                    K() && D(y.getTime());
                  }, 100));
                } catch {
                }
              }();
            }
            function le() {
              if (K(u.get().streaming.gaps.enableSeekFix) && ++_ >= 10) {
                var O = y.getTime();
                r === O ? D(O, !0) : (r = O, I = NaN), _ = 0;
              }
            }
            function K() {
              var O = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              if (!C.getActiveStream()) return !1;
              var A = Object.keys(H).some(function(Q) {
                return H[Q];
              }), oe = !!O && de();
              return !A && u.get().streaming.gaps.jumpGaps && C.getActiveStreamProcessors().length > 0 && (!y.isSeeking() || oe) && !y.isPaused() && !C.getIsStreamSwitchInProgress() && !C.getHasMediaOrInitialisationError();
            }
            function de() {
              var O = C.getActiveStream(), A = parseFloat((O.getStartTime() + O.getDuration()).toFixed(5));
              return y.getTime() + u.get().streaming.gaps.threshold >= A;
            }
            function g(O, A) {
              try {
                if (!O || O.length <= 1 && A > 0) return NaN;
                for (var oe = NaN, Q = 0; isNaN(oe) && Q < O.length; ) {
                  var ue = Q > 0 ? O.end(Q - 1) : 0;
                  A < O.start(Q) && ue - A < u.get().streaming.gaps.threshold && (oe = Q), Q += 1;
                }
                return oe;
              } catch {
                return null;
              }
            }
            function L(O, A) {
              for (var oe = 0, Q = O.length; oe < Q; oe++) if (A >= O.start(oe) && A <= O.end(oe)) return !0;
              return !1;
            }
            function D(O) {
              var A, oe = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Q = u.get().streaming.gaps.enableStallFix, ue = u.get().streaming.gaps.stallSeek, ee = u.get().streaming.gaps.smallGapLimit, k = u.get().streaming.gaps.jumpLargeGaps, ne = F.getBufferRange(), ve = NaN, xe = !1;
              if (A = g(ne, O), !isNaN(A)) {
                var Ne = ne.start(A), Fe = Ne - O;
                Fe > 0 && (Fe <= ee || k) && (ve = Ne);
              }
              var Le = y.getTimeToStreamEnd();
              if (isNaN(ve) && oe && isFinite(Le) && !isNaN(Le) && Le < ee && (ve = parseFloat(y.getStreamEndTime().toFixed(5)), xe = !0), Q && isNaN(ve) && oe && isNaN(A) && L(ne, O) && (ue === 0 ? (N.warn("Toggle play pause to break stall"), F.pause(), F.play()) : (N.warn("Jumping ".concat(ue, "s to break stall")), ve = O + ue)), ve > 0 && I !== ve && ve > O && !Y) {
                var ut = ve - O;
                if (xe) {
                  var ct = C.getStreamForTime(ve), nt = ct && !!ct.getPreloaded();
                  N.warn("Jumping to end of stream because of gap from ".concat(O, " to ").concat(ve, ". Gap duration: ").concat(ut)), y.seek(ve, !0, nt);
                } else {
                  var rt = y.getIsDynamic(), Bt = A > 0 ? ne.end(A - 1) : O, we = rt ? 1e3 * Math.max(0, ut - 0.1) : 0;
                  Y = window.setTimeout(function() {
                    y.seek(ve, !0, !0), N.warn("Jumping gap occuring in period ".concat(C.getActiveStream().getStreamId(), " starting at ").concat(Bt, " and ending at ").concat(ve, ". Jumping by: ").concat(ve - Bt)), Y = null;
                  }, we);
                }
                I = ve;
              }
            }
            return i = { reset: me, setConfig: function(O) {
              O && (O.settings && (u = O.settings), O.playbackController && (y = O.playbackController), O.streamController && (C = O.streamController), O.videoModel && (F = O.videoModel));
            }, initialize: function() {
              (function() {
                Z.on(l.Z.WALLCLOCK_TIME_UPDATED, le, this), Z.on(l.Z.INITIAL_STREAM_SWITCH, q, this), Z.on(l.Z.PLAYBACK_SEEKING, ae, this), Z.on(l.Z.BUFFER_REPLACEMENT_STARTED, fe, i), Z.on(l.Z.TRACK_CHANGE_RENDERED, _e, i);
              })();
            } }, N = (0, h.Z)(U).getInstance().getLogger(i), me(), i;
          }
          Fo.__dashjs_factory_name = "GapController";
          var Gl = v.Z.getSingletonFactory(Fo);
          function ko() {
            var i, r, u, _, w, I, y, C, F, Y, H = this.context, N = (0, p.Z)(H).getInstance();
            function U() {
              r = !1;
              var de = St.Z.parseUserAgent();
              u = de && de.browser && de.browser.name && de.browser.name.toLowerCase() === "safari";
            }
            function Z() {
              r = !1;
            }
            function me(de) {
              if (de.streamId === I.getActiveStreamInfo().id && F) {
                var g = y.getLiveDelay();
                y.getBufferLevel() > g / 2 && (F = !1);
              }
            }
            function ae(de) {
              de.streamId === I.getActiveStreamInfo().id && (F = de.state === m.Z.BUFFER_EMPTY);
            }
            function fe() {
              C.getCatchupModeEnabled() || _.setPlaybackRate(1);
            }
            function _e() {
              y.getIsDynamic() && C.getCatchupModeEnabled() && (C.getCatchupPlaybackRates().max > 0 || C.getCatchupPlaybackRates().min < 0) && !y.isPaused() && !y.isSeeking() && function() {
                try {
                  return !(!y.getTime() > 0 || r) && (le() === t.Z.LIVE_CATCHUP_MODE_LOLP ? function(de, g) {
                    try {
                      return Math.abs(q()) > 0 || de < g;
                    } catch {
                      return !1;
                    }
                  }(y.getBufferLevel(), w.get().streaming.liveCatchup.playbackBufferMin) : function() {
                    try {
                      return Math.abs(q()) > 0;
                    } catch {
                      return !1;
                    }
                  }());
                } catch {
                  return !1;
                }
              }() && function() {
                if (!r && _) {
                  var de, g = _.getPlaybackRate(), L = C.getCatchupPlaybackRates(), D = y.getBufferLevel(), O = q(), A = C.getCatchupMaxDrift();
                  if (!isNaN(A) && A > 0 && O > A) Y.info("[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point"), r = !0, y.seekToCurrentLive(!0, !1);
                  else {
                    var oe = y.getCurrentLiveLatency(), Q = y.getLiveDelay();
                    de = le() === t.Z.LIVE_CATCHUP_MODE_LOLP ? function(ee, k, ne, ve, xe) {
                      var Ne;
                      if (xe < ve) {
                        var Fe = Math.abs(ee.min), Le = 5 * (xe - ve);
                        Ne = 1 - Fe + 2 * Fe / (1 + Math.pow(Math.E, -Le)), Y.debug("[LoL+ playback control_buffer-based] bufferLevel: " + xe + ", newRate: " + Ne);
                      } else {
                        if (Math.abs(k - ne) <= 0.02 * ne) Ne = 1;
                        else {
                          var ut = k - ne, ct = ut < 0 ? Math.abs(ee.min) : ee.max, nt = 5 * ut;
                          Ne = 1 - ct + 2 * ct / (1 + Math.pow(Math.E, -nt));
                        }
                        Y.debug("[LoL+ playback control_latency-based] latency: " + k + ", newRate: " + Ne);
                      }
                      return Ne;
                    }(L, oe, Q, w.get().streaming.liveCatchup.playbackBufferMin, D) : function(ee, k, ne, ve) {
                      if (F) return 1;
                      var xe = k - ne, Ne = xe < 0 ? Math.abs(ee.min) : ee.max, Fe = 5 * xe, Le = 1 - Ne + 2 * Ne / (1 + Math.pow(Math.E, -Fe));
                      return y.getPlaybackStalled() && ve <= ne / 2 && xe > 0 && (Le = 1), Le;
                    }(L, oe, Q, D);
                    var ue = u ? 0.25 : 0.02 / (0.5 / L.max);
                    de && Math.abs(g - de) >= ue && (Y.debug("[CatchupController]: Setting playback rate to ".concat(de)), _.setPlaybackRate(de));
                  }
                }
              }();
            }
            function q() {
              return y.getCurrentLiveLatency() - y.getLiveDelay();
            }
            function le() {
              var de = w.get().streaming.liveCatchup.playbackBufferMin;
              return w.get().streaming.liveCatchup.mode !== t.Z.LIVE_CATCHUP_MODE_LOLP || de === null || isNaN(de) ? t.Z.LIVE_CATCHUP_MODE_DEFAULT : t.Z.LIVE_CATCHUP_MODE_LOLP;
            }
            function K() {
              C.getCatchupPlaybackRates(!0);
            }
            return i = { reset: function() {
              N.off(n.Z.BUFFER_LEVEL_UPDATED, me, i), N.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, ae, i), N.off(n.Z.PLAYBACK_PROGRESS, _e, i), N.off(n.Z.PLAYBACK_TIME_UPDATED, _e, i), N.off(n.Z.PLAYBACK_SEEKED, Z, i), N.off(l.Z.SETTING_UPDATED_CATCHUP_ENABLED, fe, i), N.off(l.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, K, i), N.off(l.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX, K, i), N.off(n.Z.STREAM_INITIALIZED, K, i), U(), _.setPlaybackRate(1, !0);
            }, setConfig: function(de) {
              de && (de.settings && (w = de.settings), de.videoModel && (_ = de.videoModel), de.streamController && (I = de.streamController), de.playbackController && (y = de.playbackController), de.mediaPlayerModel && (C = de.mediaPlayerModel));
            }, initialize: function() {
              N.on(n.Z.BUFFER_LEVEL_UPDATED, me, i), N.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, ae, i), N.on(n.Z.PLAYBACK_PROGRESS, _e, i), N.on(n.Z.PLAYBACK_TIME_UPDATED, _e, i), N.on(n.Z.PLAYBACK_SEEKED, Z, i), N.on(l.Z.SETTING_UPDATED_CATCHUP_ENABLED, fe, i), N.on(l.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, K, i), N.on(l.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX, K, i), N.on(n.Z.STREAM_INITIALIZED, K, i), K();
            } }, Y = (0, h.Z)(H).getInstance().getLogger(i), U(), i;
          }
          ko.__dashjs_factory_name = "CatchupController";
          var Hl = v.Z.getSingletonFactory(ko), ql = [t.Z.SERVICE_DESCRIPTION_DVB_LL_SCHEME], Zo = "video", Bo = "audio";
          function Uo() {
            var i, r, u, _, w, I = this.context;
            function y() {
              r = { liveDelay: NaN, liveCatchup: { maxDrift: NaN, playbackRate: { min: NaN, max: NaN } }, minBitrate: {}, maxBitrate: {}, initialBitrate: {}, contentSteering: null }, u = [];
            }
            function C(F, Y, H) {
              try {
                r[F][Y] = H / 1e3;
              } catch (N) {
                _.error(N);
              }
            }
            return i = { getServiceDescriptionSettings: function() {
              return r;
            }, getProducerReferenceTimeOffsets: function() {
              return u;
            }, calculateProducerReferenceTimeOffsets: function(F) {
              try {
                var Y = [];
                if (F && F.length > 0) {
                  var H = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT], N = w.getAvailabilityStartTime() / 1e3;
                  F.forEach(function(U) {
                    var Z = H.reduce(function(me, ae) {
                      return me.concat(w.getAllMediaInfoForType(U, ae));
                    }, []).reduce(function(me, ae) {
                      return w.getProducerReferenceTimes(U, ae).forEach(function(fe) {
                        var _e = w.getVoRepresentations(ae);
                        if (_e && _e.length > 0 && _e[0].adaptation && _e[0].segmentInfoType === e.Z.SEGMENT_TEMPLATE) {
                          var q = _e[0], le = new Date(fe[e.Z.WALL_CLOCK_TIME]).getTime() / 1e3 - (fe[e.Z.PRESENTATION_TIME] / q[e.Z.TIMESCALE] - q[e.Z.PRESENTATION_TIME_OFFSET] + U.start), K = N - le;
                          me.push({ id: fe[e.Z.ID], to: K });
                        }
                      }), me;
                    }, []);
                    Y = Y.concat(Z);
                  });
                }
                u = Y;
              } catch (U) {
                _.error(U), u = [];
              }
            }, applyServiceDescription: function(F) {
              if (F && F.serviceDescriptions) {
                var Y = F.serviceDescriptions.filter(function(U) {
                  return ql.includes(U.schemeIdUri);
                }), H = F.serviceDescriptions.filter(function(U) {
                  return U.schemeIdUri == null;
                }), N = Y.length > 0 ? Y[Y.length - 1] : H[H.length - 1];
                N && (N.latency && N.latency.target > 0 && function(U) {
                  var Z;
                  if (U.schemeIdUri, t.Z.SERVICE_DESCRIPTION_DVB_LL_SCHEME, Z = function(_e) {
                    return { liveDelay: _e.latency.target / 1e3, maxDrift: !isNaN(_e.latency.max) && _e.latency.max > _e.latency.target ? (_e.latency.max - _e.latency.target + 500) / 1e3 : NaN, referenceId: _e.latency.referenceId || NaN };
                  }(U), u.length > 0) {
                    var me = function(_e) {
                      var q, le = 0, K = u.filter(function(de) {
                        return de.id === _e.referenceId;
                      });
                      return K.length === 0 ? (le = u.length > 0 ? u[0].to : 0, q = u[0].id || NaN) : (le = K[0].to || 0, q = K[0].id || NaN), { to: le, id: q };
                    }(Z), ae = me.to, fe = me.id;
                    r.liveDelay = Z.liveDelay - ae, r.liveCatchup.maxDrift = Z.maxDrift, _.debug(`
                Found latency properties coming from service description. Applied time offset of `.concat(ae, " from ProducerReferenceTime element with id ").concat(fe, `.
                Live Delay: `).concat(Z.liveDelay - ae, ", Live catchup max drift: ").concat(Z.maxDrift, `
            `));
                  } else r.liveDelay = Z.liveDelay, r.liveCatchup.maxDrift = Z.maxDrift, _.debug("Found latency properties coming from service description: Live Delay: ".concat(Z.liveDelay, ", Live catchup max drift: ").concat(Z.maxDrift));
                }(N), N.playbackRate && function(U) {
                  var Z = U.playbackRate.min ? Math.round(1e3 * (U.playbackRate.min - 1)) / 1e3 : NaN, me = U.playbackRate.max ? Math.round(1e3 * (U.playbackRate.max - 1)) / 1e3 : NaN;
                  r.liveCatchup.playbackRate.min = Z, r.liveCatchup.playbackRate.max = me, _.debug("Found latency properties coming from service description: Live catchup min playback rate: ".concat(Z)), _.debug("Found latency properties coming from service description: Live catchup max playback rate: ".concat(me));
                }(N), N.operatingQuality, N.operatingBandwidth && function(U) {
                  if (U && U.operatingBandwidth && U.operatingBandwidth.mediaType && U.operatingBandwidth.mediaType !== "all") {
                    var Z = {};
                    Z.minBandwidth = U.operatingBandwidth.min, Z.maxBandwidth = U.operatingBandwidth.max, Z.targetBandwidth = U.operatingBandwidth.target;
                    var me = [];
                    U.operatingBandwidth.mediaType === Zo || U.operatingBandwidth.mediaType === Bo ? me.push(U.operatingBandwidth.mediaType) : U.operatingBandwidth.mediaType === "any" && (me.push(Bo), me.push(Zo)), me.forEach(function(ae) {
                      isNaN(Z.minBandwidth) || C("minBitrate", ae, Z.minBandwidth), isNaN(Z.maxBandwidth) || C("maxBitrate", ae, Z.maxBandwidth), isNaN(Z.targetBandwidth) || C("initialBitrate", ae, Z.targetBandwidth);
                    });
                  }
                }(N), N.contentSteering && function(U) {
                  r.contentSteering = U.contentSteering;
                }(N));
              }
            }, reset: function() {
              y();
            }, setConfig: function(F) {
              F && F.adapter && (w = F.adapter);
            } }, _ = (0, h.Z)(I).getInstance().getLogger(i), y(), i;
          }
          Uo.__dashjs_factory_name = "ServiceDescriptionController";
          var Vl = v.Z.getSingletonFactory(Uo), jl = R(3973), Yi = R.n(jl), Go = R(3039);
          function Za() {
            var i, r, u, _, w, I, y, C, F = this.context, Y = (0, p.Z)(F).getInstance();
            function H(k, ne) {
              return k && u[ne] && u[ne][k] ? u[ne][k].list : [];
            }
            function N(k, ne) {
              return k && u[ne] && u[ne][k] ? u[ne][k].current : null;
            }
            function U(k) {
              var ne = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              if (k && k.streamInfo) {
                var ve = k.type, xe = k.streamInfo, Ne = xe.id, Fe = N(ve, Ne);
                if (u[Ne] && u[Ne][ve] && (u[Ne][ve].current = k, u[Ne][ve].current && (ve !== t.Z.TEXT && !ae(k, Fe) || ve === t.Z.TEXT && k.isFragmented) && Y.trigger(l.Z.CURRENT_TRACK_CHANGED, { oldMediaInfo: Fe, newMediaInfo: k, switchMode: _.get().streaming.trackSwitchMode[ve] }, { streamId: Ne }), !ne)) {
                  var Le = _e(k);
                  if (!Le || !u[Ne][ve].storeLastSettings) return;
                  Le.roles && (Le.role = Le.roles[0], delete Le.roles), Le.accessibility && (Le.accessibility = Le.accessibility[0]), Le.audioChannelConfiguration && (Le.audioChannelConfiguration = Le.audioChannelConfiguration[0]), I[ve] = Le, C.setSavedMediaSettings(ve, Le);
                }
              }
            }
            function Z(k, ne) {
              k && ne && (w[k] = ne);
            }
            function me(k) {
              return k ? w[k] : null;
            }
            function ae(k, ne) {
              if (!k && !ne) return !0;
              if (!k || !ne) return !1;
              var ve = k.id === ne.id, xe = k.viewpoint === ne.viewpoint, Ne = JSON.stringify(k.viewpointsWithSchemeIdUri) === JSON.stringify(ne.viewpointsWithSchemeIdUri), Fe = k.lang === ne.lang, Le = k.codec === ne.codec, ut = k.roles.toString() === ne.roles.toString(), ct = JSON.stringify(k.rolesWithSchemeIdUri) === JSON.stringify(ne.rolesWithSchemeIdUri), nt = k.accessibility.toString() === ne.accessibility.toString(), rt = JSON.stringify(k.accessibilitiesWithSchemeIdUri) === JSON.stringify(ne.accessibilitiesWithSchemeIdUri), Bt = k.audioChannelConfiguration.toString() === ne.audioChannelConfiguration.toString(), we = JSON.stringify(k.audioChannelConfigurationsWithSchemeIdUri) === JSON.stringify(ne.audioChannelConfigurationsWithSchemeIdUri);
              return ve && Le && xe && Ne && Fe && ut && ct && nt && rt && Bt && we;
            }
            function fe() {
              u = {}, I = {}, w = { audio: null, video: null, text: null };
            }
            function _e(k) {
              var ne = { lang: k.lang, viewpoint: k.viewpoint, roles: k.roles, accessibility: k.accessibility, audioChannelConfiguration: k.audioChannelConfiguration, codec: k.codec };
              return ne.lang || ne.viewpoint || ne.role && ne.role.length > 0 || ne.accessibility && ne.accessibility.length > 0 || ne.audioChannelConfiguration && ne.audioChannelConfiguration.length > 0 ? ne : null;
            }
            function q(k, ne, ve) {
              var xe = [];
              return k.forEach(function(Ne) {
                ne(ve, Ne) && xe.push(Ne);
              }), xe.length !== 0 ? xe : k;
            }
            function le(k, ne) {
              try {
                return !k.lang || k.lang instanceof RegExp ? ne.lang.match(k.lang) : ne.lang !== "" && (0, Go.extendedFilter)(ne.lang, Yi()(k.lang)).length > 0;
              } catch {
                return !1;
              }
            }
            function K(k, ne) {
              return k.index === void 0 || k.index === null || ne.index === k.index;
            }
            function de(k, ne) {
              return !k.viewpoint || k.viewpoint === ne.viewpoint;
            }
            function g(k, ne) {
              var ve = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xe = !k.role || !!ne.roles.filter(function(Ne) {
                return Ne === k.role;
              })[0];
              return xe || ne.type === t.Z.AUDIO && ve;
            }
            function L(k, ne) {
              return k.accessibility ? !!ne.accessibility.filter(function(ve) {
                return ve === k.accessibility;
              })[0] : !ne.accessibility.length;
            }
            function D(k, ne) {
              return !k.audioChannelConfiguration || !!ne.audioChannelConfiguration.filter(function(ve) {
                return ve === k.audioChannelConfiguration;
              })[0];
            }
            function O(k, ne) {
              return !k.codec || k.codec === ne.codec;
            }
            function A(k) {
              var ne, ve = 0, xe = [];
              return k.forEach(function(Ne) {
                (ne = Math.max.apply(Math, Ne.bitrateList.map(function(Fe) {
                  return Fe.bandwidth;
                }))) > ve ? (ve = ne, xe = [Ne]) : ne === ve && xe.push(Ne);
              }), xe;
            }
            function oe(k) {
              var ne, ve = 1 / 0, xe = [];
              return k.forEach(function(Ne) {
                var Fe = Ne.bitrateList.reduce(function(Le, ut) {
                  var ct = Math.max(1, ut.width * ut.height);
                  return Le + ut.bandwidth / ct;
                }, 0);
                (ne = Fe / Ne.bitrateList.length) < ve ? (ve = ne, xe = [Ne]) : ne === ve && xe.push(Ne);
              }), xe;
            }
            function Q(k) {
              var ne, ve = 0, xe = [];
              return k.forEach(function(Ne) {
                (ne = Ne.representationCount) > ve ? (ve = ne, xe = [Ne]) : ne === ve && xe.push(Ne);
              }), xe;
            }
            function ue(k, ne) {
              if (k === t.Z.TEXT) return ne[0];
              var ve, xe = _.get().streaming.selectionModeForInitialTrack, Ne = y.getCustomInitialTrackSelectionFunction();
              if (Ne && typeof Ne == "function") ve = Ne(ne);
              else switch (xe) {
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:
                  ve = function(Fe) {
                    var Le, ut, ct = (Le = 0, ut = [], Fe.forEach(function(nt) {
                      isNaN(nt.selectionPriority) || (nt.selectionPriority > Le ? (Le = nt.selectionPriority, ut = [nt]) : nt.selectionPriority === Le && ut.push(nt));
                    }), ut);
                    return ct.length > 1 && (ct = A(ct)), ct.length > 1 && (ct = Q(ct)), ct;
                  }(ne);
                  break;
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_BITRATE:
                  ve = function(Fe) {
                    var Le = A(Fe);
                    return Le.length > 1 && (Le = Q(Le)), Le;
                  }(ne);
                  break;
                case t.Z.TRACK_SELECTION_MODE_FIRST_TRACK:
                  ve = ee(ne);
                  break;
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:
                  ve = function(Fe) {
                    var Le = oe(Fe);
                    return Le.length > 1 && (Le = A(Le)), Le;
                  }(ne);
                  break;
                case t.Z.TRACK_SELECTION_MODE_WIDEST_RANGE:
                  ve = function(Fe) {
                    var Le = Q(Fe);
                    return Le.length > 1 && (Le = A(Fe)), Le;
                  }(ne);
                  break;
                default:
                  r.warn("Track selection mode ".concat(xe, " is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK")), ve = ee(ne);
              }
              return ve.length > 0 ? ve[0] : ne[0];
            }
            function ee(k) {
              return k[0];
            }
            return i = { setInitialMediaSettingsForType: function(k, ne) {
              var ve = I[k] || me(k), xe = H(k, ne.id), Ne = [];
              ve || ((ve = C.getSavedMediaSettings(k)) && delete ve.codec, Z(k, ve)), xe && xe.length !== 0 && (ve && (Ne = q(Ne = Array.from(xe), le, ve), Ne = q(Ne, K, ve), Ne = q(Ne, de, ve), k === t.Z.AUDIO && I[k] || (Ne = q(Ne, g, ve)), Ne = q(Ne, L, ve), Ne = q(Ne, D, ve), Ne = q(Ne, O, ve)), Ne.length === 0 ? U(ue(k, xe), !0) : Ne.length > 1 ? U(ue(k, Ne)) : U(Ne[0]));
            }, addTrack: function(k) {
              if (k) {
                var ne = k.type;
                if ((ve = ne) === t.Z.AUDIO || ve === t.Z.VIDEO || ve === t.Z.TEXT || ve === t.Z.IMAGE) {
                  var ve, xe, Ne = k.streamInfo.id;
                  u[Ne] || (u[Ne] = { audio: { list: [], storeLastSettings: xe = _.get().streaming.saveLastMediaSettingsForCurrentStreamingSession, current: null }, video: { list: [], storeLastSettings: xe, current: null }, text: { list: [], storeLastSettings: xe, current: null }, image: { list: [], storeLastSettings: xe, current: null } });
                  for (var Fe = u[Ne][ne].list, Le = 0, ut = Fe.length; Le < ut; ++Le) if (ae(Fe[Le], k)) return;
                  Fe.push(k);
                }
              }
            }, getTracksFor: H, getCurrentTrackFor: N, isCurrentTrack: function(k) {
              if (!k) return !1;
              var ne = k.type, ve = k.streamInfo.id;
              return u[ve] && u[ve][ne] && ae(u[ve][ne].current, k);
            }, setTrack: U, selectInitialTrack: ue, setInitialSettings: Z, getInitialSettings: me, getTracksWithHighestBitrate: A, getTracksWithHighestEfficiency: oe, getTracksWithWidestRange: Q, isTracksEqual: ae, matchSettings: function(k, ne) {
              var ve = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              try {
                var xe = !1;
                if (k.lang) {
                  if (k.lang instanceof RegExp) xe = ne.lang.match(k.lang);
                  else if (ne.lang !== "") {
                    var Ne = Yi()(k.lang);
                    Ne && (xe = (0, Go.extendedFilter)(ne.lang, Ne).length > 0);
                  }
                } else xe = !0;
                var Fe = k.index === void 0 || k.index === null || ne.index === k.index, Le = !k.viewpoint || k.viewpoint === ne.viewpoint, ut = !k.role || !!ne.roles.filter(function(rt) {
                  return rt === k.role;
                })[0], ct = !k.accessibility || !!ne.accessibility.filter(function(rt) {
                  return rt === k.accessibility;
                })[0], nt = !k.audioChannelConfiguration || !!ne.audioChannelConfiguration.filter(function(rt) {
                  return rt === k.audioChannelConfiguration;
                })[0];
                return xe && Fe && Le && (ut || ne.type === t.Z.AUDIO && ve) && ct && nt;
              } catch {
                return !1;
              }
            }, matchSettingsLang: le, matchSettingsIndex: K, matchSettingsViewPoint: de, matchSettingsRole: g, matchSettingsAccessibility: L, matchSettingsAudioChannelConfig: D, saveTextSettingsDisabled: function() {
              C.setSavedMediaSettings(t.Z.TEXT, null);
            }, setConfig: function(k) {
              k && (k.domStorage && (C = k.domStorage), k.settings && (_ = k.settings), k.customParametersModel && (y = k.customParametersModel));
            }, reset: fe }, r = (0, h.Z)(F).getInstance().getLogger(i), fe(), i;
          }
          Za.__dashjs_factory_name = "MediaController";
          var Ho = v.Z.getSingletonFactory(Za);
          v.Z.updateSingletonFactory(Za.__dashjs_factory_name, Ho);
          var Yl = Ho, Ki = NaN, qo = function i(r, u) {
            (function(_, w) {
              if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.data = { baseUrls: r || null, selectedIdx: u || Ki }, this.children = [];
          };
          function Vo() {
            var i, r, u, _, w = this.context, I = Zt(w).getInstance();
            function y(H, N, U) {
              var Z = C(U);
              H[N] ? I.areEqual(Z, H[N].data.baseUrls) || (H[N].data.baseUrls = Z, H[N].data.selectedIdx = Ki) : H[N] = new qo(Z);
            }
            function C(H) {
              var N = u.getBaseURLsFromElement(H), U = _.getSynthesizedBaseUrlElements(N);
              return U && U.length > 0 && (N = N.concat(U)), N;
            }
            function F(H, N) {
              var U = N || r;
              H(U.data), U.children && U.children.forEach(function(Z) {
                return F(H, Z);
              });
            }
            function Y() {
              r = new qo();
            }
            return i = { reset: Y, update: function(H) {
              (function(N) {
                (function() {
                  if (!u || !u.hasOwnProperty("getBaseURLsFromElement") || !u.hasOwnProperty("getRepresentationSortFunction")) throw new Error("setConfig function has to be called previously");
                })();
                var U = C(N);
                I.areEqual(U, r.data.baseUrls) || (r.data.baseUrls = U, r.data.selectedIdx = Ki), N && N.Period_asArray && N.Period_asArray.forEach(function(Z, me) {
                  y(r.children, me, Z), Z.AdaptationSet_asArray && Z.AdaptationSet_asArray.forEach(function(ae, fe) {
                    y(r.children[me].children, fe, ae), ae.Representation_asArray && ae.Representation_asArray.sort(u.getRepresentationSortFunction()).forEach(function(_e, q) {
                      y(r.children[me].children[fe].children, q, _e);
                    });
                  });
                });
              })(H);
            }, getForPath: function(H) {
              var N = r, U = [N.data];
              return H && H.forEach(function(Z) {
                (N = N.children[Z]) && U.push(N.data);
              }), U.filter(function(Z) {
                return Z.baseUrls.length;
              });
            }, invalidateSelectedIndexes: function(H) {
              F(function(N) {
                isNaN(N.selectedIdx) || H === N.baseUrls[N.selectedIdx].serviceLocation && (N.selectedIdx = Ki);
              });
            }, setConfig: function(H) {
              H.adapter && (u = H.adapter), H.contentSteeringController && (_ = H.contentSteeringController);
            }, getBaseUrls: function(H) {
              return C(H);
            } }, Y(), i;
          }
          Vo.__dashjs_factory_name = "BaseURLTreeModel";
          var Kl = v.Z.getClassFactory(Vo);
          function jo(i) {
            var r = (i = i || {}).blacklistController;
            return { select: function(u) {
              return u && function(w) {
                var I, y, C = 0, F = [], Y = 0;
                if ((y = w.sort(function(H, N) {
                  var U = H.dvbPriority - N.dvbPriority;
                  return isNaN(U) ? 0 : U;
                }).filter(function(H, N, U) {
                  return !N || U[0].dvbPriority && H.dvbPriority && U[0].dvbPriority === H.dvbPriority;
                })).length) return y.length > 1 && (y.forEach(function(H) {
                  C += H.dvbWeight, F.push(C);
                }), I = Math.floor(Math.random() * (C - 1)), F.every(function(H, N) {
                  return Y = N, !(I < H);
                })), y[Y];
              }((_ = [], u.filter(function(w) {
                return !r.contains(w.serviceLocation) || (w.dvbPriority && _.push(w.dvbPriority), !1);
              }).filter(function(w) {
                return !_.length || !w.dvbPriority || _.indexOf(w.dvbPriority) === -1;
              })));
              var _;
            } };
          }
          jo.__dashjs_factory_name = "DVBSelector";
          var zl = v.Z.getClassFactory(jo);
          function Yo(i) {
            var r = (i = i || {}).blacklistController;
            return { select: function(u) {
              var _, w = 0;
              return u && u.some(function(I, y) {
                return w = y, !r.contains(I.serviceLocation);
              }) && (_ = u[w]), _;
            } };
          }
          Yo.__dashjs_factory_name = "BasicSelector";
          var Wl = v.Z.getClassFactory(Yo);
          function Ko() {
            var i, r, u, _ = this.context;
            function w() {
              for (var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], C = 0, F = NaN, Y = function() {
                var N = I[C], U = y.findIndex(function(Z) {
                  return Z.serviceLocation && Z.serviceLocation === N;
                });
                if (U !== -1 && !u.contains(y[U].serviceLocation)) return F = U, "break";
                C += 1;
              }; C < I.length; ) {
                var H = Y();
                if (H === "break") break;
              }
              return F;
            }
            return i = { selectBaseUrlIndex: function(I) {
              var y = NaN;
              if (isNaN(I.selectedIdx)) {
                var C = r.getSteeringDataFromManifest();
                C && C.defaultServiceLocationArray.length > 0 && (y = w(C.defaultServiceLocationArray, I.baseUrls));
              }
              var F = r.getCurrentSteeringResponseData();
              return I.baseUrls && I.baseUrls.length && F && F.pathwayPriority && F.pathwayPriority.length && (y = w(F.pathwayPriority, I.baseUrls)), y;
            }, setConfig: function(I) {
              I.blacklistController && (u = I.blacklistController), I.contentSteeringController && (r = I.contentSteeringController);
            } }, r = Cr(_).getInstance(), i;
          }
          Ko.__dashjs_factory_name = "ContentSteeringSelector";
          var Ql = v.Z.getClassFactory(Ko);
          function zo() {
            var i, r, u, _, w, I, y = this.context, C = (0, p.Z)(y).getInstance(), F = (0, Me.Z)(y).getInstance();
            function Y() {
              r.reset();
            }
            return i = { chooseSelector: function(H) {
              (0, X.PS)(H, "boolean"), I = H ? _ : u;
            }, select: function(H) {
              if (H) {
                if (F.get().streaming.applyContentSteering) {
                  var N = w.selectBaseUrlIndex(H);
                  isNaN(N) || N === -1 || (H.selectedIdx = N);
                }
                if (!isNaN(H.selectedIdx)) return H.baseUrls[H.selectedIdx];
                var U = I.select(H.baseUrls);
                return U ? (H.selectedIdx = H.baseUrls.indexOf(U), U) : (C.trigger(l.Z.URL_RESOLUTION_FAILED, { error: new se.Z($.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, $.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE) }), void (I === u && Y()));
              }
            }, reset: Y, setConfig: function(H) {
              H.selector && (I = H.selector), H.contentSteeringSelector && (w = H.contentSteeringSelector);
            } }, r = gi(y).create({ updateEventName: l.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, addBlacklistEventName: l.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD }), u = Wl(y).create({ blacklistController: r }), _ = zl(y).create({ blacklistController: r }), (w = Ql(y).create()).setConfig({ blacklistController: r }), I = u, i;
          }
          zo.__dashjs_factory_name = "BaseURLSelector";
          var Xl = v.Z.getClassFactory(zo);
          function Wo() {
            var i, r, u, _, w, I = this.context, y = (0, p.Z)(I).getInstance(), C = (0, tt.Z)(I).getInstance();
            function F(H) {
              u.update(H), _.chooseSelector(r.getIsDVB(H)), y.trigger(n.Z.BASE_URLS_UPDATED, { baseUrls: Y(H) });
            }
            function Y(H) {
              return u.getBaseUrls(H);
            }
            return i = { reset: function() {
              u.reset(), _.reset();
            }, initialize: function(H) {
              u.setConfig({ adapter: r, contentSteeringController: w }), F(H);
            }, resolve: function(H) {
              var N = u.getForPath(H).reduce(function(U, Z) {
                var me = _.select(Z);
                return me ? (C.isRelative(me.url) ? U.url = C.resolve(me.url, U.url) : (U.url = me.url, U.serviceLocation = me.serviceLocation), U.availabilityTimeOffset = me.availabilityTimeOffset, U.availabilityTimeComplete = me.availabilityTimeComplete, U.queryParams = me.queryParams, U) : new Ir();
              }, new Ir());
              if (!C.isRelative(N.url)) return N;
            }, setConfig: function(H) {
              H.baseURLTreeModel && (u = H.baseURLTreeModel), H.baseURLSelector && (_ = H.baseURLSelector), H.adapter && (r = H.adapter), H.contentSteeringController && (w = H.contentSteeringController);
            }, getBaseUrls: Y, update: F }, u = Kl(I).create(), _ = Xl(I).create(), y.on(l.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, function(H) {
              u.invalidateSelectedIndexes(H.entry);
            }, i), i;
          }
          Wo.__dashjs_factory_name = "BaseURLController";
          var $l = v.Z.getClassFactory(Wo);
          function Ba(i) {
            return Ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ba(i);
          }
          function Ua(i, r) {
            return Ua = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Ua(i, r);
          }
          function Jl(i, r) {
            return !r || Ba(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function zi(i) {
            return zi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, zi(i);
          }
          var Qo = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && Ua(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = zi(r);
              if (u) {
                var C = zi(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return Jl(this, I);
            });
            function w(I, y) {
              var C;
              return function(F, Y) {
                if (!(F instanceof Y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (C = _.call(this)).url = I || null, C.type = y || null, C.mediaType = t.Z.STREAM, C.responseType = "", C;
            }
            return w;
          }(S.Z);
          function Xo(i) {
            i = i || {};
            var r = this.context, u = (0, p.Z)(r).getInstance(), _ = cr(r).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, errors: $ });
            return { load: function(w, I, y) {
              var C = function(Y, H) {
                I.resolved = !0, I.resolvedContent = Y || null, u.trigger(l.Z.XLINK_ELEMENT_LOADED, { element: I, resolveObject: y, error: Y || H ? null : new se.Z($.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE, $.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE + w) });
              };
              if (w === "urn:mpeg:dash:resolve-to-zero:2013") C(null, !0);
              else {
                var F = new Qo(w, Ge.w.XLINK_EXPANSION_TYPE);
                _.load({ request: F, success: function(Y) {
                  C(Y);
                }, error: function() {
                  C(null);
                } });
              }
            }, reset: function() {
              _ && (_.abort(), _ = null);
            } };
          }
          Xo.__dashjs_factory_name = "XlinkLoader";
          var eu = v.Z.getClassFactory(Xo), $o = function(i) {
            (i = i || {}).escapeMode === void 0 && (i.escapeMode = !0), i.attributePrefix === void 0 && (i.attributePrefix = "_"), i.arrayAccessForm = i.arrayAccessForm || "none", i.emptyNodeForm = i.emptyNodeForm || "text", i.enableToStringFunc === void 0 && (i.enableToStringFunc = !0), i.arrayAccessFormPaths = i.arrayAccessFormPaths || [], i.skipEmptyTextNodesForObj === void 0 && (i.skipEmptyTextNodesForObj = !0), i.stripWhitespaces === void 0 && (i.stripWhitespaces = !0), i.datetimeAccessFormPaths = i.datetimeAccessFormPaths || [], i.useDoubleQuotes === void 0 && (i.useDoubleQuotes = !1), i.xmlElementsFilter = i.xmlElementsFilter || [], i.jsonPropertiesFilter = i.jsonPropertiesFilter || [], i.keepCData === void 0 && (i.keepCData = !1), i.ignoreRoot === void 0 && (i.ignoreRoot = !1);
            function r(q) {
              var le = q.localName;
              return le == null && (le = q.baseName), le != null && le != "" || (le = q.nodeName), le;
            }
            function u(q) {
              return typeof q == "string" ? q.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") : q;
            }
            function _(q, le, K, de) {
              for (var g = 0; g < q.length; g++) {
                var L = q[g];
                if (typeof L == "string") {
                  if (L == de) break;
                } else if (L instanceof RegExp) {
                  if (L.test(de)) break;
                } else if (typeof L == "function" && L(le, K, de)) break;
              }
              return g != q.length;
            }
            function w(q, le, K) {
              i.arrayAccessForm === "property" && (q[le] instanceof Array ? q[le + "_asArray"] = q[le] : q[le + "_asArray"] = [q[le]]), !(q[le] instanceof Array) && i.arrayAccessFormPaths.length > 0 && _(i.arrayAccessFormPaths, q, le, K) && (q[le] = [q[le]]);
            }
            function I(q) {
              var le = q.split(/[-T:+Z]/g), K = new Date(le[0], le[1] - 1, le[2]), de = le[5].split(".");
              if (K.setHours(le[3], le[4], de[0]), de.length > 1 && K.setMilliseconds(de[1]), le[6] && le[7]) {
                var g = 60 * le[6] + Number(le[7]);
                g = 0 + ((/\d\d-\d\d:\d\d$/.test(q) ? "-" : "+") == "-" ? -1 * g : g), K.setMinutes(K.getMinutes() - g - K.getTimezoneOffset());
              } else q.indexOf("Z", q.length - 1) !== -1 && (K = new Date(Date.UTC(K.getFullYear(), K.getMonth(), K.getDate(), K.getHours(), K.getMinutes(), K.getSeconds(), K.getMilliseconds())));
              return K;
            }
            function y(q, le, K, de) {
              return !(le == 1 && i.xmlElementsFilter.length > 0) || _(i.xmlElementsFilter, q, K, de);
            }
            function C(q, le) {
              if (q.nodeType == 9) {
                for (var K = new Object(), de = q.childNodes, g = 0; g < de.length; g++) (D = de[g]).nodeType == 1 && (i.ignoreRoot ? K = C(D) : (K = {})[O = r(D)] = C(D));
                return K;
              }
              if (q.nodeType == 1) {
                (K = new Object()).__cnt = 0;
                var L = [];
                for (de = q.childNodes, g = 0; g < de.length; g++) {
                  var D, O = r(D = de[g]);
                  if (D.nodeType != 8) {
                    var A = le + "." + O;
                    if (y(K, D.nodeType, O, A)) if (K.__cnt++, K[O] == null) {
                      var oe = C(D, A);
                      (O != "#text" || /[^\s]/.test(oe)) && ((Q = {})[O] = oe, L.push(Q)), K[O] = oe, w(K, O, A);
                    } else {
                      var Q;
                      K[O] != null && (K[O] instanceof Array || (K[O] = [K[O]], w(K, O, A))), oe = C(D, A), (O != "#text" || /[^\s]/.test(oe)) && ((Q = {})[O] = oe, L.push(Q)), K[O][K[O].length] = oe;
                    }
                  }
                }
                K.__children = L;
                for (var ue = r(q), ee = 0; ee < q.attributes.length; ee++) {
                  var k = q.attributes[ee];
                  K.__cnt++;
                  for (var ne = k.value, ve = 0, xe = i.matchers.length; ve < xe; ve++) {
                    var Ne = i.matchers[ve];
                    Ne.test(k, ue) && (ne = Ne.converter(k.value));
                  }
                  K[i.attributePrefix + k.name] = ne;
                }
                var Fe = function(Le) {
                  return Le.prefix;
                }(q);
                return Fe != null && Fe != "" && (K.__cnt++, K.__prefix = Fe), K["#text"] != null && (K.__text = K["#text"], K.__text instanceof Array && (K.__text = K.__text.join(`
`)), i.stripWhitespaces && (K.__text = K.__text.trim()), delete K["#text"], i.arrayAccessForm == "property" && delete K["#text_asArray"], K.__text = function(Le, ut, ct) {
                  if (i.datetimeAccessFormPaths.length > 0) {
                    var nt = ct.split(".#")[0];
                    return _(i.datetimeAccessFormPaths, Le, ut, nt) ? I(Le) : Le;
                  }
                  return Le;
                }(K.__text, O, le + "." + O)), K["#cdata-section"] != null && (K.__cdata = K["#cdata-section"], delete K["#cdata-section"], i.arrayAccessForm == "property" && delete K["#cdata-section_asArray"]), K.__cnt == 0 && i.emptyNodeForm == "text" ? K = "" : K.__cnt == 1 && K.__text != null ? K = K.__text : K.__cnt != 1 || K.__cdata == null || i.keepCData ? K.__cnt > 1 && K.__text != null && i.skipEmptyTextNodesForObj && (i.stripWhitespaces && K.__text == "" || K.__text.trim() == "") && delete K.__text : K = K.__cdata, delete K.__cnt, !i.enableToStringFunc || K.__text == null && K.__cdata == null || (K.toString = function() {
                  return (this.__text != null ? this.__text : "") + (this.__cdata != null ? this.__cdata : "");
                }), K;
              }
              if (q.nodeType == 3 || q.nodeType == 4) return q.nodeValue;
            }
            function F(q, le, K, de) {
              var g = "<" + (q != null && q.__prefix != null ? q.__prefix + ":" : "") + le;
              if (K != null) for (var L = 0; L < K.length; L++) {
                var D = K[L], O = q[D];
                i.escapeMode && (O = u(O)), g += " " + D.substr(i.attributePrefix.length) + "=", i.useDoubleQuotes ? g += '"' + O + '"' : g += "'" + O + "'";
              }
              return g + (de ? "/>" : ">");
            }
            function Y(q, le) {
              return "</" + (q.__prefix != null ? q.__prefix + ":" : "") + le + ">";
            }
            function H(q, le) {
              return i.arrayAccessForm == "property" && (de = "_asArray", (K = le.toString()).indexOf(de, K.length - de.length) !== -1) || le.toString().indexOf(i.attributePrefix) == 0 || le.toString().indexOf("__") == 0 || q[le] instanceof Function;
              var K, de;
            }
            function N(q) {
              var le = 0;
              if (q instanceof Object) for (var K in q) H(q, K) || le++;
              return le;
            }
            function U(q, le, K) {
              return i.jsonPropertiesFilter.length == 0 || K == "" || _(i.jsonPropertiesFilter, q, le, K);
            }
            function Z(q) {
              var le = [];
              if (q instanceof Object) for (var K in q) K.toString().indexOf("__") == -1 && K.toString().indexOf(i.attributePrefix) == 0 && le.push(K);
              return le;
            }
            function me(q) {
              var le = "";
              return q instanceof Object ? le += function(K) {
                var de = "";
                return K.__cdata != null && (de += "<![CDATA[" + K.__cdata + "]]>"), K.__text != null && (i.escapeMode ? de += u(K.__text) : de += K.__text), de;
              }(q) : q != null && (i.escapeMode ? le += u(q) : le += q), le;
            }
            function ae(q, le) {
              return q === "" ? le : q + "." + le;
            }
            function fe(q, le, K, de) {
              var g = "";
              if (q.length == 0) g += F(q, le, K, !0);
              else for (var L = 0; L < q.length; L++) g += F(q[L], le, Z(q[L]), !1), g += _e(q[L], ae(de, le)), g += Y(q[L], le);
              return g;
            }
            function _e(q, le) {
              var K = "";
              if (N(q) > 0) {
                for (var de in q) if (!H(q, de) && (le == "" || U(q, de, ae(le, de)))) {
                  var g = q[de], L = Z(g);
                  g == null || g == null ? K += F(g, de, L, !0) : g instanceof Object ? g instanceof Array ? K += fe(g, de, L, le) : g instanceof Date ? (K += F(g, de, L, !1), K += g.toISOString(), K += Y(g, de)) : N(g) > 0 || g.__text != null || g.__cdata != null ? (K += F(g, de, L, !1), K += _e(g, ae(le, de)), K += Y(g, de)) : K += F(g, de, L, !0) : (K += F(g, de, L, !1), K += me(g), K += Y(g, de));
                }
              }
              return K + me(q);
            }
            this.parseXmlString = function(q) {
              var le;
              if (q === void 0) return null;
              if (window.DOMParser) {
                var K = new window.DOMParser();
                try {
                  (le = K.parseFromString(q, "text/xml")).getElementsByTagNameNS("*", "parsererror").length > 0 && (le = null);
                } catch {
                  le = null;
                }
              } else q.indexOf("<?") == 0 && (q = q.substr(q.indexOf("?>") + 2)), (le = new ActiveXObject("Microsoft.XMLDOM")).async = "false", le.loadXML(q);
              return le;
            }, this.asArray = function(q) {
              return q === void 0 || q == null ? [] : q instanceof Array ? q : [q];
            }, this.toXmlDateTime = function(q) {
              return q instanceof Date ? q.toISOString() : typeof q == "number" ? new Date(q).toISOString() : null;
            }, this.asDateTime = function(q) {
              return typeof q == "string" ? I(q) : q;
            }, this.xml2json = function(q) {
              return C(q);
            }, this.xml_str2json = function(q) {
              var le = this.parseXmlString(q);
              return le != null ? this.xml2json(le) : null;
            }, this.json2xml_str = function(q) {
              return _e(q, "");
            }, this.json2xml = function(q) {
              var le = this.json2xml_str(q);
              return this.parseXmlString(le);
            }, this.getVersion = function() {
              return "1.2.0";
            };
          }, pi = "onLoad";
          function Jo(i) {
            i = i || {};
            var r, u, _, w, I, y, C = this.context, F = (0, p.Z)(C).getInstance(), Y = (0, tt.Z)(C).getInstance();
            function H(ae, fe, _e) {
              var q, le, K = {};
              K.elements = ae, K.type = fe, K.resolveType = _e, K.elements.length === 0 && U(K);
              for (var de = 0; de < K.elements.length; de++) q = K.elements[de], le = Y.isHTTPURL(q.url) ? q.url : q.originalContent.BaseURL + q.url, y.load(le, q, K);
            }
            function N(ae) {
              var fe, _e, q = "";
              if (fe = ae.element, _e = ae.resolveObject, fe.resolvedContent) {
                var le = 0;
                fe.resolvedContent.indexOf("<?xml") === 0 && (le = fe.resolvedContent.indexOf("?>") + 2), q = fe.resolvedContent.substr(0, le) + "<response>" + fe.resolvedContent.substr(le) + "</response>", fe.resolvedContent = I.xml_str2json(q);
              }
              (function(K) {
                var de;
                for (de = 0; de < K.elements.length; de++) if (K.elements[de].resolved === !1) return !1;
                return !0;
              })(_e) && U(_e);
            }
            function U(ae) {
              var fe, _e, q = [];
              if (function(le) {
                var K, de, g, L, D, O, A = [];
                for (L = le.elements.length - 1; L >= 0; L--) {
                  if (de = (K = le.elements[L]).type + "_asArray", K.resolvedContent) {
                    if (K.resolvedContent) for (D = 0; D < K.resolvedContent[de].length; D++) g = K.resolvedContent[de][D], A.push(g);
                  } else delete K.originalContent["xlink:actuate"], delete K.originalContent["xlink:href"], A.push(K.originalContent);
                  for (K.parentElement[de].splice(K.index, 1), O = 0; O < A.length; O++) K.parentElement[de].splice(K.index + O, 0, A[O]);
                  A = [];
                }
                le.elements.length > 0 && _.run(w);
              }(ae), ae.resolveType === "onActuate" && F.trigger(l.Z.XLINK_READY, { manifest: w }), ae.resolveType === pi) switch (ae.type) {
                case e.Z.PERIOD:
                  for (fe = 0; fe < w[e.Z.PERIOD + "_asArray"].length; fe++) (_e = w[e.Z.PERIOD + "_asArray"][fe]).hasOwnProperty(e.Z.ADAPTATION_SET + "_asArray") && (q = q.concat(Z(_e[e.Z.ADAPTATION_SET + "_asArray"], _e, e.Z.ADAPTATION_SET, pi))), _e.hasOwnProperty(e.Z.EVENT_STREAM + "_asArray") && (q = q.concat(Z(_e[e.Z.EVENT_STREAM + "_asArray"], _e, e.Z.EVENT_STREAM, pi)));
                  H(q, e.Z.ADAPTATION_SET, pi);
                  break;
                case e.Z.ADAPTATION_SET:
                  F.trigger(l.Z.XLINK_READY, { manifest: w });
              }
            }
            function Z(ae, fe, _e, q) {
              var le, K, de, g = [];
              for (K = ae.length - 1; K >= 0; K--) (le = ae[K]).hasOwnProperty("xlink:href") && le["xlink:href"] === "urn:mpeg:dash:resolve-to-zero:2013" && ae.splice(K, 1);
              for (K = 0; K < ae.length; K++) (le = ae[K]).hasOwnProperty("xlink:href") && le.hasOwnProperty("xlink:actuate") && le["xlink:actuate"] === q && (de = me(le["xlink:href"], fe, _e, K, q, le), g.push(de));
              return g;
            }
            function me(ae, fe, _e, q, le, K) {
              return { url: ae, parentElement: fe, type: _e, index: q, resolveType: le, originalContent: K, resolvedContent: null, resolved: !1 };
            }
            return r = { resolveManifestOnLoad: function(ae) {
              I = new $o({ escapeMode: !1, attributePrefix: "", arrayAccessForm: "property", emptyNodeForm: "object", stripWhitespaces: !1, enableToStringFunc: !1, ignoreRoot: !0, matchers: u }), (w = ae).Period_asArray ? H(Z(w.Period_asArray, w, e.Z.PERIOD, pi), e.Z.PERIOD, pi) : F.trigger(l.Z.XLINK_READY, { manifest: w });
            }, setMatchers: function(ae) {
              ae && (u = ae);
            }, setIron: function(ae) {
              ae && (_ = ae);
            }, reset: function() {
              F.off(l.Z.XLINK_ELEMENT_LOADED, N, r), y && (y.reset(), y = null);
            } }, F.on(l.Z.XLINK_ELEMENT_LOADED, N, r), y = eu(C).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, settings: i.settings }), r;
          }
          Jo.__dashjs_factory_name = "XlinkController";
          var tu = v.Z.getClassFactory(Jo);
          function wi(i) {
            return wi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, wi(i);
          }
          function es(i) {
            function r(w, I) {
              for (var y in w) I.hasOwnProperty(y) || (I[y] = w[y]);
            }
            function u(w, I, y) {
              for (var C = 0, F = w.length; C < F; ++C) {
                var Y = w[C];
                if (I[Y.name]) if (y[Y.name]) {
                  if (Y.merge) {
                    var H = I[Y.name], N = y[Y.name];
                    wi(H) === "object" && wi(N) === "object" ? r(H, N) : y[Y.name] = H + N;
                  }
                } else y[Y.name] = I[Y.name];
              }
            }
            function _(w, I) {
              for (var y = 0, C = w.children.length; y < C; ++y) {
                var F = w.children[y], Y = I[F.name + "_asArray"];
                if (Y) for (var H = 0, N = Y.length; H < N; ++H) {
                  var U = Y[H];
                  u(w.properties, I, U), _(F, U);
                }
              }
            }
            return { run: function(w) {
              if (w === null || wi(w) !== "object") return w;
              if (w.Period_asArray && "period" in i) for (var I = i.period, y = w.Period_asArray, C = 0, F = y.length; C < F; ++C) {
                var Y = y[C];
                if (_(I, Y), "adaptationset" in i) {
                  var H = Y.AdaptationSet_asArray;
                  if (H) for (var N = i.adaptationset, U = 0, Z = H.length; U < Z; ++U) _(N, H[U]);
                }
              }
              return w;
            } };
          }
          es.__dashjs_factory_name = "ObjectIron";
          var nu = v.Z.getClassFactory(es);
          function ru(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Ri = function() {
            function i(_, w) {
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._test = _, this._converter = w;
            }
            var r, u;
            return r = i, (u = [{ key: "test", get: function() {
              return this._test;
            } }, { key: "converter", get: function() {
              return this._converter;
            } }]) && ru(r.prototype, u), i;
          }();
          function Ga(i) {
            return Ga = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ga(i);
          }
          function qn(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Ha(i, r) {
            return Ha = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Ha(i, r);
          }
          function iu(i, r) {
            return !r || Ga(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Wi(i) {
            return Wi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Wi(i);
          }
          var au = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Ha(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Wi(r);
              if (u) {
                var C = Wi(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return iu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I, y) {
                var C, F = (qn(C = {}, e.Z.MPD, [e.Z.ID, e.Z.PROFILES]), qn(C, e.Z.PERIOD, [e.Z.ID]), qn(C, e.Z.BASE_URL, [e.Z.SERVICE_LOCATION, e.Z.BYTE_RANGE]), qn(C, e.Z.SEGMENT_BASE, [e.Z.INDEX_RANGE]), qn(C, e.Z.INITIALIZATION, [e.Z.RANGE]), qn(C, e.Z.REPRESENTATION_INDEX, [e.Z.RANGE]), qn(C, e.Z.SEGMENT_LIST, [e.Z.INDEX_RANGE]), qn(C, e.Z.BITSTREAM_SWITCHING, [e.Z.RANGE]), qn(C, e.Z.SEGMENT_URL, [e.Z.MEDIA_RANGE, e.Z.INDEX_RANGE]), qn(C, e.Z.SEGMENT_TEMPLATE, [e.Z.INDEX_RANGE, e.Z.MEDIA, e.Z.INDEX, e.Z.INITIALIZATION_MINUS, e.Z.BITSTREAM_SWITCHING_MINUS]), qn(C, e.Z.ASSET_IDENTIFIER, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.EVENT_STREAM, [e.Z.VALUE]), qn(C, e.Z.ADAPTATION_SET, [e.Z.PROFILES, e.Z.MIME_TYPE, e.Z.SEGMENT_PROFILES, e.Z.CODECS, e.Z.CONTENT_TYPE]), qn(C, e.Z.FRAME_PACKING, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.AUDIO_CHANNEL_CONFIGURATION, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.CONTENT_PROTECTION, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.ESSENTIAL_PROPERTY, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.SUPPLEMENTAL_PROPERTY, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.INBAND_EVENT_STREAM, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.ACCESSIBILITY, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.ROLE, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.RATING, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.VIEWPOINT, [e.Z.VALUE, e.Z.ID]), qn(C, e.Z.CONTENT_COMPONENT, [e.Z.CONTENT_TYPE]), qn(C, e.Z.REPRESENTATION, [e.Z.ID, e.Z.DEPENDENCY_ID, e.Z.MEDIA_STREAM_STRUCTURE_ID]), qn(C, e.Z.SUBSET, [e.Z.ID]), qn(C, e.Z.METRICS, [e.Z.METRICS_MINUS]), qn(C, e.Z.REPORTING, [e.Z.VALUE, e.Z.ID]), C);
                if (F.hasOwnProperty(y)) {
                  var Y = F[y];
                  return Y !== void 0 && Y.indexOf(I.name) >= 0;
                }
                return !1;
              }, function(I) {
                return String(I);
              });
            }
            return w;
          }(Ri);
          function qa(i) {
            return qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, qa(i);
          }
          function Va(i, r) {
            return Va = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Va(i, r);
          }
          function ou(i, r) {
            return !r || qa(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Qi(i) {
            return Qi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Qi(i);
          }
          var ts = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/, su = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Va(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Qi(r);
              if (u) {
                var C = Qi(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return ou(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I) {
                for (var y = [e.Z.MIN_BUFFER_TIME, e.Z.MEDIA_PRESENTATION_DURATION, e.Z.MINIMUM_UPDATE_PERIOD, e.Z.TIMESHIFT_BUFFER_DEPTH, e.Z.MAX_SEGMENT_DURATION, e.Z.MAX_SUBSEGMENT_DURATION, e.Z.SUGGESTED_PRESENTATION_DELAY, e.Z.START, t.Z.START_TIME, e.Z.DURATION], C = y.length, F = 0; F < C; F++) if (I.nodeName === y[F]) return ts.test(I.value);
                return !1;
              }, function(I) {
                var y = ts.exec(I), C = 31536e3 * parseFloat(y[3] || 0) + 2592e3 * parseFloat(y[5] || 0) + 86400 * parseFloat(y[7] || 0) + 3600 * parseFloat(y[9] || 0) + 60 * parseFloat(y[11] || 0) + parseFloat(y[13] || 0);
                return y[1] !== void 0 && (C = -C), C;
              });
            }
            return w;
          }(Ri);
          function ja(i) {
            return ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, ja(i);
          }
          function Ya(i, r) {
            return Ya = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Ya(i, r);
          }
          function lu(i, r) {
            return !r || ja(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Xi(i) {
            return Xi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Xi(i);
          }
          var ns = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/, uu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Ya(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Xi(r);
              if (u) {
                var C = Xi(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return lu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I) {
                return ns.test(I.value);
              }, function(I) {
                var y, C = ns.exec(I);
                if (y = Date.UTC(parseInt(C[1], 10), parseInt(C[2], 10) - 1, parseInt(C[3], 10), parseInt(C[4], 10), parseInt(C[5], 10), C[6] && parseInt(C[6], 10) || 0, C[7] && 1e3 * parseFloat(C[7]) || 0), C[9] && C[10]) {
                  var F = 60 * parseInt(C[9], 10) + parseInt(C[10], 10);
                  y += (C[8] === "+" ? -1 : 1) * F * 60 * 1e3;
                }
                return new Date(y);
              });
            }
            return w;
          }(Ri);
          function Ka(i) {
            return Ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ka(i);
          }
          function za(i, r) {
            return za = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, za(i, r);
          }
          function cu(i, r) {
            return !r || Ka(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function $i(i) {
            return $i = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, $i(i);
          }
          var fu = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/, du = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), za(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = $i(r);
              if (u) {
                var C = $i(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return cu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I) {
                return fu.test(I.value);
              }, function(I) {
                return parseFloat(I);
              });
            }
            return w;
          }(Ri);
          function Wa(i) {
            return Wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Wa(i);
          }
          function Ci(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Qa(i, r) {
            return Qa = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Qa(i, r);
          }
          function gu(i, r) {
            return !r || Wa(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Ji(i) {
            return Ji = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Ji(i);
          }
          var hu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Qa(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Ji(r);
              if (u) {
                var C = Ji(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return gu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I, y) {
                var C, F = (Ci(C = {}, e.Z.ADAPTATION_SET, [e.Z.LANG]), Ci(C, e.Z.REPRESENTATION, [e.Z.LANG]), Ci(C, e.Z.CONTENT_COMPONENT, [e.Z.LANG]), Ci(C, e.Z.LABEL, [e.Z.LANG]), Ci(C, e.Z.GROUP_LABEL, [e.Z.LANG]), C);
                if (F.hasOwnProperty(y)) {
                  var Y = F[y];
                  return Y !== void 0 && Y.indexOf(I.name) >= 0;
                }
                return !1;
              }, function(I) {
                return Yi()(I) || String(I);
              });
            }
            return w;
          }(Ri);
          function mu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var pu = function() {
            function i(_) {
              var w;
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._name = _, this._merge = (w = _) && w.length && w.charAt(0) === w.charAt(0).toUpperCase();
            }
            var r, u;
            return r = i, (u = [{ key: "name", get: function() {
              return this._name;
            } }, { key: "merge", get: function() {
              return this._merge;
            } }]) && mu(r.prototype, u), i;
          }();
          function yu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var yi = function() {
            function i(_, w, I) {
              var y = this;
              (function(C, F) {
                if (!(C instanceof F)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._name = _ || "", this._properties = [], this._children = I || [], Array.isArray(w) && w.forEach(function(C) {
                y._properties.push(new pu(C));
              });
            }
            var r, u;
            return r = i, (u = [{ key: "name", get: function() {
              return this._name;
            } }, { key: "children", get: function() {
              return this._children;
            } }, { key: "properties", get: function() {
              return this._properties;
            } }]) && yu(r.prototype, u), i;
          }();
          function Xa(i) {
            return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Xa(i);
          }
          function $a(i, r) {
            return $a = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, $a(i, r);
          }
          function _u(i, r) {
            return !r || Xa(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function ea(i) {
            return ea = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ea(i);
          }
          var Eu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), $a(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ea(r);
              if (u) {
                var C = ea(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return _u(this, I);
            });
            function w() {
              (function(y, C) {
                if (!(y instanceof C)) throw new TypeError("Cannot call a class as a function");
              })(this, w);
              var I = [e.Z.PROFILES, e.Z.WIDTH, e.Z.HEIGHT, e.Z.SAR, e.Z.FRAMERATE, e.Z.AUDIO_SAMPLING_RATE, e.Z.MIME_TYPE, e.Z.SEGMENT_PROFILES, e.Z.CODECS, e.Z.MAXIMUM_SAP_PERIOD, e.Z.START_WITH_SAP, e.Z.MAX_PLAYOUT_RATE, e.Z.CODING_DEPENDENCY, e.Z.SCAN_TYPE, e.Z.FRAME_PACKING, e.Z.AUDIO_CHANNEL_CONFIGURATION, e.Z.CONTENT_PROTECTION, e.Z.ESSENTIAL_PROPERTY, e.Z.ESSENTIAL_PROPERTY + "_asArray", e.Z.SUPPLEMENTAL_PROPERTY, e.Z.INBAND_EVENT_STREAM];
              return _.call(this, e.Z.ADAPTATION_SET, I, [new yi(e.Z.REPRESENTATION, I, [new yi(e.Z.SUB_REPRESENTATION, I)])]);
            }
            return w;
          }(yi);
          function Ja(i) {
            return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ja(i);
          }
          function eo(i, r) {
            return eo = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, eo(i, r);
          }
          function vu(i, r) {
            return !r || Ja(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function ta(i) {
            return ta = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ta(i);
          }
          var Tu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), eo(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ta(r);
              if (u) {
                var C = ta(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return vu(this, I);
            });
            function w() {
              (function(y, C) {
                if (!(y instanceof C)) throw new TypeError("Cannot call a class as a function");
              })(this, w);
              var I = [e.Z.SEGMENT_BASE, e.Z.SEGMENT_TEMPLATE, e.Z.SEGMENT_LIST];
              return _.call(this, e.Z.PERIOD, I, [new yi(e.Z.ADAPTATION_SET, I, [new yi(e.Z.REPRESENTATION, I)])]);
            }
            return w;
          }(yi);
          function rs(i) {
            i = i || {};
            var r, u, _, w, I, y = this.context, C = i.debug;
            return r = { parse: function(F) {
              var Y, H = window.performance.now();
              if (!(Y = w.xml_str2json(F))) throw new Error("parsing the manifest failed");
              var N = window.performance.now();
              Y.Patch ? ((Y = Y.Patch).add_asArray && Y.add_asArray.forEach(function(Z) {
                return I.run(Z);
              }), Y.replace_asArray && Y.replace_asArray.forEach(function(Z) {
                return I.run(Z);
              })) : (Y = Y.MPD, I.run(Y));
              var U = window.performance.now();
              return u.info("Parsing complete: ( xml2json: " + (N - H).toPrecision(3) + "ms, objectiron: " + (U - N).toPrecision(3) + "ms, total: " + ((U - H) / 1e3).toPrecision(3) + "s)"), Y.protocol = "DASH", Y;
            }, getMatchers: function() {
              return _;
            }, getIron: function() {
              return I;
            } }, u = C.getLogger(r), _ = [new su(), new uu(), new du(), new hu(), new au()], w = new $o({ escapeMode: !1, attributePrefix: "", arrayAccessForm: "property", emptyNodeForm: "object", stripWhitespaces: !1, enableToStringFunc: !0, ignoreRoot: !1, matchers: _ }), I = nu(y).create({ adaptationset: new Eu(), period: new Tu() }), r;
          }
          rs.__dashjs_factory_name = "DashParser";
          var bu = v.Z.getClassFactory(rs);
          function is(i) {
            i = i || {};
            var r, u, _, w, I, y = this.context, C = i.debug, F = i.settings, Y = (0, p.Z)(y).getInstance(), H = (0, tt.Z)(y).getInstance(), N = i.mssHandler, U = i.errHandler;
            function Z(ae) {
              Y.trigger(l.Z.INTERNAL_MANIFEST_LOADED, { manifest: ae.manifest });
            }
            function me(ae) {
              var fe = null;
              return ae.indexOf("SmoothStreamingMedia") > -1 ? (N && (fe = N.createMssParser(), N.createMssFragmentProcessor(), N.registerEvents()), fe) : ae.indexOf("MPD") > -1 || ae.indexOf("Patch") > -1 ? bu(y).create({ debug: C }) : fe;
            }
            return r = { load: function(ae) {
              var fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, _e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, q = /* @__PURE__ */ new Date(), le = new Qo(ae, Ge.w.MPD_TYPE);
              fe && (le.serviceLocation = fe), _e && (le.queryParams = _e), le.requestStartDate || (le.requestStartDate = q), Y.trigger(l.Z.MANIFEST_LOADING_STARTED, { request: le }), _.load({ request: le, success: function(K, de, g) {
                var L, D, O;
                if (w) if (g && g !== ae ? (D = H.parseBaseUrl(g), L = g) : (H.isRelative(ae) && (ae = H.resolve(ae, window.location.href)), D = H.parseBaseUrl(ae)), de != "No Content") if (I === null && (I = me(K)), I !== null) {
                  w.setMatchers(I.getMatchers()), w.setIron(I.getIron());
                  try {
                    O = I.parse(K);
                  } catch {
                    return void Y.trigger(l.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z($.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, $.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae)) });
                  }
                  if (O) {
                    if (O.url = L || ae, O.originalUrl || (O.originalUrl = O.url), F && F.get().streaming.enableManifestDurationMismatchFix && O.mediaPresentationDuration && O.Period_asArray.length > 1) {
                      var A = O.Period_asArray.reduce(function(oe, Q) {
                        return oe + Q.duration;
                      }, 0);
                      !isNaN(A) && O.mediaPresentationDuration > A && (u.warn("Media presentation duration greater than duration of all periods. Setting duration to total period duration"), O.mediaPresentationDuration = A);
                    }
                    O.baseUri = D, O.loadedTime = /* @__PURE__ */ new Date(), w.resolveManifestOnLoad(O), Y.trigger(l.Z.ORIGINAL_MANIFEST_LOADED, { originalManifest: K });
                  } else Y.trigger(l.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z($.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, $.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae)) });
                } else Y.trigger(l.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z($.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, $.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae)) });
                else Y.trigger(l.Z.INTERNAL_MANIFEST_LOADED, { manifest: null });
              }, error: function(K, de, g) {
                Y.trigger(l.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z($.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE, $.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE + "".concat(ae, ", ").concat(g)) });
              } });
            }, reset: function() {
              Y.off(l.Z.XLINK_READY, Z, r), N && N.reset(), w && (w.reset(), w = null), _ && (_.abort(), _ = null);
            } }, u = C.getLogger(r), Y.on(l.Z.XLINK_READY, Z, r), _ = cr(y).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, urlUtils: H, constants: t.Z, dashConstants: e.Z, errors: $, requestTimeout: i.settings.get().streaming.manifestRequestTimeout }), w = tu(y).create({ errHandler: U, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, settings: i.settings }), I = null, r;
          }
          is.__dashjs_factory_name = "ManifestLoader";
          var Su = v.Z.getClassFactory(is);
          function as() {
            var i = this.context, r = (0, p.Z)(i).getInstance();
            return { error: function(u) {
              r.trigger(l.Z.ERROR, { error: u });
            } };
          }
          as.__dashjs_factory_name = "ErrorHandler";
          var Au = v.Z.getSingletonFactory(as), os = R(1715);
          function ss() {
            var i, r, u, _, w, I, y = this.context, C = (0, p.Z)(y).getInstance();
            function F(Y, H) {
              if (!H || !H.Period_asArray || H.Period_asArray.length === 0) return Promise.resolve();
              var N = [];
              return H.Period_asArray.forEach(function(U) {
                N.push(function(Z, me) {
                  return new Promise(function(ae) {
                    if (Z && Z.AdaptationSet_asArray && Z.AdaptationSet_asArray.length !== 0) {
                      var fe = [];
                      Z.AdaptationSet_asArray.forEach(function(_e) {
                        r.getIsTypeOf(_e, me) && fe.push(function(q, le) {
                          return new Promise(function(K) {
                            if (q.Representation_asArray && q.Representation_asArray.length !== 0) {
                              var de = [], g = [];
                              q.Representation_asArray.forEach(function(L, D) {
                                var O = r.getCodec(q, D, !1), A = function(oe, Q, ue) {
                                  switch (oe) {
                                    case t.Z.VIDEO:
                                      return function(ee, k) {
                                        return { codec: k, width: ee.width || null, height: ee.height || null, framerate: ee.frameRate || null, bitrate: ee.bandwidth || null };
                                      }(Q, ue);
                                    case t.Z.AUDIO:
                                      return function(ee, k) {
                                        var ne = ee.audioSamplingRate || null;
                                        return { codec: k, bitrate: ee.bandwidth || null, samplerate: ne };
                                      }(Q, ue);
                                    default:
                                      return null;
                                  }
                                }(le, L, O);
                                g.push(A), de.push(u.supportsCodec(A, le));
                              }), Promise.all(de).then(function(L) {
                                q.Representation_asArray = q.Representation_asArray.filter(function(D, O) {
                                  return L[O] || I.debug("[Stream] Codec ".concat(g[O].codec, " not supported ")), L[O];
                                }), K();
                              }).catch(function() {
                                K();
                              });
                            } else K();
                          });
                        }(_e, me));
                      }), Promise.all(fe).then(function() {
                        Z.AdaptationSet_asArray = Z.AdaptationSet_asArray.filter(function(_e) {
                          var q = _e.Representation_asArray && _e.Representation_asArray.length > 0;
                          return q || (C.trigger(l.Z.ADAPTATION_SET_REMOVED_NO_CAPABILITIES, { adaptationSet: _e }), I.warn("AdaptationSet has been removed because of no supported Representation")), q;
                        }), ae();
                      }).catch(function() {
                        ae();
                      });
                    } else ae();
                  });
                }(U, Y));
              }), Promise.all(N);
            }
            return i = { setConfig: function(Y) {
              Y && (Y.adapter && (r = Y.adapter), Y.capabilities && (u = Y.capabilities), Y.settings && (_ = Y.settings), Y.customParametersModel && (w = Y.customParametersModel));
            }, filterUnsupportedFeatures: function(Y) {
              return new Promise(function(H) {
                var N = [];
                N.push(F(t.Z.VIDEO, Y)), N.push(F(t.Z.AUDIO, Y)), Promise.all(N).then(function() {
                  _.get().streaming.capabilities.filterUnsupportedEssentialProperties && function(U) {
                    U && U.Period_asArray && U.Period_asArray.length !== 0 && U.Period_asArray.forEach(function(Z) {
                      Z.AdaptationSet_asArray = Z.AdaptationSet_asArray.filter(function(me) {
                        return !me.Representation_asArray || me.Representation_asArray.length === 0 || (me.Representation_asArray = me.Representation_asArray.filter(function(ae) {
                          var fe = r.getEssentialPropertiesForRepresentation(ae);
                          if (fe && fe.length > 0) for (var _e = 0; _e < fe.length; ) {
                            if (!u.supportsEssentialProperty(fe[_e])) return I.debug("[Stream] EssentialProperty not supported: " + fe[_e].schemeIdUri), !1;
                            _e += 1;
                          }
                          return !0;
                        }), me.Representation_asArray && me.Representation_asArray.length > 0);
                      });
                    });
                  }(Y), function(U) {
                    var Z = w.getCustomCapabilitiesFilters();
                    Z && Z.length !== 0 && U && U.Period_asArray && U.Period_asArray.length !== 0 && U.Period_asArray.forEach(function(me) {
                      me.AdaptationSet_asArray = me.AdaptationSet_asArray.filter(function(ae) {
                        return !ae.Representation_asArray || ae.Representation_asArray.length === 0 || (ae.Representation_asArray = ae.Representation_asArray.filter(function(fe) {
                          return !Z.some(function(_e) {
                            return !_e(fe);
                          });
                        }), ae.Representation_asArray && ae.Representation_asArray.length > 0);
                      });
                    });
                  }(Y), H();
                }).catch(function() {
                  H();
                });
              });
            } }, I = (0, h.Z)(y).getInstance().getLogger(i), i;
          }
          ss.__dashjs_factory_name = "CapabilitiesFilter";
          var Iu = v.Z.getSingletonFactory(ss), wu = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.xywh = null, this.track = null, this.id = null, this.s = null, this.r = null;
          };
          function ls() {
            var i;
            return { initialize: function(r) {
              if (i = new wu(), !r) return null;
              var u = r.indexOf("#");
              if (u !== -1) for (var _ = r.substr(u + 1).split("&"), w = 0, I = _.length; w < I; ++w) {
                var y = _[w], C = y.indexOf("=");
                if (C !== -1) {
                  var F = y.substring(0, C);
                  i.hasOwnProperty(F) && (i[F] = y.substr(C + 1));
                }
              }
            }, getURIFragmentData: function() {
              return i;
            } };
          }
          ls.__dashjs_factory_name = "URIFragmentModel";
          var Ru = v.Z.getSingletonFactory(ls);
          function us() {
            var i, r = this.context, u = (0, p.Z)(r).getInstance();
            return { getValue: function() {
              return i;
            }, setValue: function(_) {
              i = _, _ && u.trigger(l.Z.MANIFEST_LOADED, { data: _ });
            } };
          }
          us.__dashjs_factory_name = "ManifestModel";
          var Cu = v.Z.getSingletonFactory(us), to = -0.5;
          function cs() {
            var i, r, u, _, w = this.context, I = (0, Me.Z)(w).getInstance();
            function y(Y, H) {
              return isNaN(Y) ? 0 : Y > 0 ? (H && r.warn("Supplied minimum playback rate is a positive value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : Y < to ? (H && r.warn("Supplied minimum playback rate is out of range and will be limited to ".concat(to, ": ").concat(-50, "% playback speed.")), to) : Y;
            }
            function C(Y, H) {
              return isNaN(Y) ? 0 : Y < 0 ? (H && r.warn("Supplied maximum playback rate is a negative value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : Y > 1 ? (H && r.warn("Supplied maximum playback rate is out of range and will be limited to ".concat(1, ": ").concat(200, "% playback speed.")), 1) : Y;
            }
            function F() {
              var Y = I.get().streaming.buffer.stableBufferTime > 0 ? I.get().streaming.buffer.stableBufferTime : I.get().streaming.buffer.fastSwitchEnabled ? 20 : 12, H = u.getLiveDelay();
              return !isNaN(H) && H > 0 ? Math.min(Y, H) : Y;
            }
            return i = { getCatchupMaxDrift: function() {
              if (!isNaN(I.get().streaming.liveCatchup.maxDrift) && I.get().streaming.liveCatchup.maxDrift > 0) return I.get().streaming.liveCatchup.maxDrift;
              var Y = _.getServiceDescriptionSettings();
              return Y && Y.liveCatchup && !isNaN(Y.liveCatchup.maxDrift) && Y.liveCatchup.maxDrift > 0 ? Y.liveCatchup.maxDrift : 12;
            }, getCatchupModeEnabled: function() {
              return I.get().streaming.liveCatchup.enabled !== null ? I.get().streaming.liveCatchup.enabled : u.getInitialCatchupModeActivated();
            }, getStableBufferTime: F, getInitialBufferLevel: function() {
              var Y = I.get().streaming.buffer.initialBufferLevel;
              return isNaN(Y) || Y < 0 ? 0 : Math.min(F(), Y);
            }, getRetryAttemptsForType: function(Y) {
              var H = isNaN(I.get().streaming.retryAttempts.lowLatencyMultiplyFactor) ? 5 : I.get().streaming.retryAttempts.lowLatencyMultiplyFactor;
              return u.getLowLatencyModeEnabled() ? I.get().streaming.retryAttempts[Y] * H : I.get().streaming.retryAttempts[Y];
            }, getRetryIntervalsForType: function(Y) {
              var H = isNaN(I.get().streaming.retryIntervals.lowLatencyReductionFactor) ? 10 : I.get().streaming.retryIntervals.lowLatencyReductionFactor;
              return u.getLowLatencyModeEnabled() ? I.get().streaming.retryIntervals[Y] / H : I.get().streaming.retryIntervals[Y];
            }, getCatchupPlaybackRates: function(Y) {
              var H = I.get().streaming.liveCatchup.playbackRate;
              if (!isNaN(H.min) || !isNaN(H.max)) return { min: y(H.min, Y), max: C(H.max, Y) };
              var N = _.getServiceDescriptionSettings();
              if (N && N.liveCatchup && (!isNaN(N.liveCatchup.playbackRate.min) || !isNaN(N.liveCatchup.playbackRate.max))) {
                var U = N.liveCatchup.playbackRate;
                return { min: y(U.min, Y), max: C(U.max, Y) };
              }
              return { min: -0.5, max: 0.5 };
            }, getAbrBitrateParameter: function(Y, H) {
              try {
                var N = I.get().streaming.abr[Y][H];
                if (!isNaN(N) && N !== -1) return N;
                var U = _.getServiceDescriptionSettings();
                return U && U[Y] && !isNaN(U[Y][H]) ? U[Y][H] : -1;
              } catch {
                return -1;
              }
            }, setConfig: function(Y) {
              Y.playbackController && (u = Y.playbackController), Y.serviceDescriptionController && (_ = Y.serviceDescriptionController);
            }, reset: function() {
            } }, r = (0, h.Z)(w).getInstance().getLogger(i), i;
          }
          cs.__dashjs_factory_name = "MediaPlayerModel";
          var Nu = v.Z.getSingletonFactory(cs), Du = R(1767);
          function fs(i) {
            var r = (i = i || {}).abrController, u = i.switchHistory, _ = i.droppedFramesHistory, w = i.currentRequest, I = i.useBufferOccupancyABR, y = i.useL2AABR, C = i.useLoLPABR, F = i.streamProcessor ? i.streamProcessor.getScheduleController() : null, Y = i.streamProcessor ? i.streamProcessor.getRepresentationInfo() : null, H = i.videoModel ? i.videoModel : null;
            function N() {
              return Y ? Y.mediaInfo : null;
            }
            return { getMediaType: function() {
              var U = N();
              return U ? U.type : null;
            }, getMediaInfo: N, getDroppedFramesHistory: function() {
              return _;
            }, getCurrentRequest: function() {
              return w;
            }, getSwitchHistory: function() {
              return u;
            }, getStreamInfo: function() {
              var U = N();
              return U ? U.streamInfo : null;
            }, getScheduleController: function() {
              return F;
            }, getAbrController: function() {
              return r;
            }, getRepresentationInfo: function() {
              return Y;
            }, useBufferOccupancyABR: function() {
              return I;
            }, useL2AABR: function() {
              return y;
            }, useLoLPABR: function() {
              return C;
            }, getVideoModel: function() {
              return H;
            } };
          }
          fs.__dashjs_factory_name = "RulesContext";
          var ds = v.Z.getClassFactory(fs), na = R(2068);
          function gs() {
            var i = [], r = [];
            return { push: function(u) {
              u.newValue === na.Z.NO_CHANGE && (u.newValue = u.oldValue), i[u.oldValue] || (i[u.oldValue] = { noDrops: 0, drops: 0, dropSize: 0 });
              var _ = u.newValue - u.oldValue, w = _ < 0 ? 1 : 0, I = w ? -_ : 0, y = w ? 0 : 1;
              if (i[u.oldValue].drops += w, i[u.oldValue].dropSize += I, i[u.oldValue].noDrops += y, r.push({ idx: u.oldValue, noDrop: y, drop: w, dropSize: I }), r.length > 8) {
                var C = r.shift();
                i[C.idx].drops -= C.drop, i[C.idx].dropSize -= C.dropSize, i[C.idx].noDrops -= C.noDrop;
              }
            }, getSwitchRequests: function() {
              return i;
            }, reset: function() {
              i = [], r = [];
            } };
          }
          gs.__dashjs_factory_name = "SwitchRequestHistory";
          var Ou = v.Z.getClassFactory(gs);
          function hs() {
            var i = {}, r = {}, u = {};
            return { push: function(_, w, I) {
              if (w) {
                i[_] || (i[_] = [], r[_] = 0, u[_] = 0);
                var y = I && I.droppedVideoFrames ? I.droppedVideoFrames : 0, C = I && I.totalVideoFrames ? I.totalVideoFrames : 0, F = y - r[_];
                r[_] = y;
                var Y = C - u[_];
                u[_] = C;
                var H = i[_];
                isNaN(w) || (H[w] ? (H[w].droppedVideoFrames += F, H[w].totalVideoFrames += Y) : H[w] = { droppedVideoFrames: F, totalVideoFrames: Y });
              }
            }, getFrameHistory: function(_) {
              return i[_];
            }, clearForStream: function(_) {
              try {
                delete i[_], delete r[_], delete u[_];
              } catch {
              }
            }, reset: function() {
              i = {}, r = {}, u = {};
            } };
          }
          hs.__dashjs_factory_name = "DroppedFramesHistory";
          var Mu = v.Z.getClassFactory(hs);
          function ms(i) {
            var r, u, _, w, I, y = this.context, C = (i = i || {}).settings, F = (0, p.Z)(y).getInstance();
            function Y(ae, fe, _e, q) {
              var le = Math.pow(0.5, _e / q.fast);
              ae.fastEstimate = (1 - le) * fe + le * ae.fastEstimate;
              var K = Math.pow(0.5, _e / q.slow);
              ae.slowEstimate = (1 - K) * fe + K * ae.slowEstimate, ae.totalWeight += _e;
            }
            function H(ae, fe, _e) {
              return C.get().streaming.abr.movingAverageMethod !== t.Z.MOVING_AVERAGE_SLIDING_WINDOW ? function(q, le) {
                var K = q ? I.throughputHalfLife : I.latencyHalfLife, de = q ? _[le] : w[le];
                if (!de || de.totalWeight <= 0) return NaN;
                var g = de.fastEstimate / (1 - Math.pow(0.5, de.totalWeight / K.fast)), L = de.slowEstimate / (1 - Math.pow(0.5, de.totalWeight / K.slow));
                return q ? Math.min(g, L) : Math.max(g, L);
              }(ae, fe) : function(q, le, K) {
                var de = function(L, D, O) {
                  var A, oe;
                  if (L ? (A = r[D], oe = O ? 3 : 4) : (A = u[D], oe = 4), A) {
                    if (oe >= A.length) oe = A.length;
                    else if (L) for (var Q = 1; Q < oe; ++Q) {
                      var ue = A[A.length - Q] / A[A.length - Q - 1];
                      if ((ue >= 1.3 || ue <= 0.7692307692307692) && (oe += 1) === A.length) break;
                    }
                  } else oe = 0;
                  return oe;
                }(q, le, K), g = (q ? r : u)[le];
                return de !== 0 && g && g.length !== 0 ? (g = g.slice(-de)).reduce(function(L, D) {
                  return L + D;
                }) / g.length : NaN;
              }(ae, fe, _e);
            }
            function N(ae, fe) {
              return H(!0, ae, fe);
            }
            function U(ae) {
              r[ae] = r[ae] || [], u[ae] = u[ae] || [], _[ae] = _[ae] || { fastEstimate: 0, slowEstimate: 0, totalWeight: 0 }, w[ae] = w[ae] || { fastEstimate: 0, slowEstimate: 0, totalWeight: 0 };
            }
            function Z() {
              r = {}, u = {}, _ = {}, w = {};
            }
            var me = { push: function(ae, fe, _e) {
              if (fe.trace && fe.trace.length) {
                var q, le = fe.tresponse.getTime() - fe.trequest.getTime() || 1, K = fe._tfinish.getTime() - fe.tresponse.getTime() || 1, de = fe.trace.reduce(function(O, A) {
                  return O + A.b[0];
                }, 0), g = 0;
                if ((q = fe._fileLoaderType && fe._fileLoaderType === t.Z.FILE_LOADER_TYPES.FETCH ? fe.trace.reduce(function(O, A) {
                  return O + A.d;
                }, 0) : _e ? K : le + K) !== 0 && (g = Math.round(8 * de / q)), fe.cmsd) {
                  var L = fe.cmsd.dynamic && fe.cmsd.dynamic.etp ? fe.cmsd.dynamic.etp : null;
                  if (L) {
                    var D = C.get().streaming.cmsd.abr.etpWeightRatio;
                    D > 0 && D <= 1 && (g = g * (1 - D) + L * D);
                  }
                }
                if (U(ae), function(O, A, oe) {
                  return O === t.Z.VIDEO ? oe < C.get().streaming.cacheLoadThresholds[t.Z.VIDEO] : O === t.Z.AUDIO ? oe < C.get().streaming.cacheLoadThresholds[t.Z.AUDIO] : void 0;
                }(ae, 0, K)) {
                  if (r[ae].length > 0 && !r[ae].hasCachedEntries) return;
                  r[ae].hasCachedEntries = !0;
                } else r[ae] && r[ae].hasCachedEntries && function(O) {
                  delete r[O], delete u[O], delete _[O], delete w[O], U(O);
                }(ae);
                r[ae].push(g), F.trigger(n.Z.THROUGHPUT_MEASUREMENT_STORED, { throughput: g, mediaType: ae, httpRequest: fe }), r[ae].length > 20 && r[ae].shift(), u[ae].push(le), u[ae].length > 20 && u[ae].shift(), Y(_[ae], g, 1e-3 * K, I.throughputHalfLife), Y(w[ae], le, 1, I.latencyHalfLife);
              }
            }, getAverageThroughput: N, getSafeAverageThroughput: function(ae, fe) {
              var _e = N(ae, fe);
              return isNaN(_e) || (_e *= C.get().streaming.abr.bandwidthSafetyFactor), _e;
            }, getAverageLatency: function(ae) {
              return H(!1, ae);
            }, reset: Z };
            return I = { throughputHalfLife: { fast: 3, slow: 8 }, latencyHalfLife: { fast: 1, slow: 2 } }, Z(), me;
          }
          ms.__dashjs_factory_name = "ThroughputHistory";
          var Lu = v.Z.getClassFactory(ms);
          function no() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q, le, K, de, g, L, D, O, A, oe = this.context, Q = (0, h.Z)(oe).getInstance(), ue = (0, p.Z)(oe).getInstance();
            function ee() {
              w = {}, I = {}, C = {}, y = {}, le = {}, g = {}, L = {}, D = {}, Y === void 0 && (Y = !1), K && K.reset(), q = void 0, K = void 0, de = void 0, clearTimeout(F), F = null;
            }
            function k(we) {
              var He = we.request.mediaType, pt = we.streamId;
              if (He && pt && y[pt] && A.get().streaming.abr.autoSwitchBitrate[He]) {
                var We = y[pt][He];
                if (We) {
                  var Tt = ds(oe).create({ abrController: i, streamProcessor: We, currentRequest: we.request, useBufferOccupancyABR: g[He], useL2AABR: L[He], useLoLPABR: D[He], videoModel: Z }), vt = u.shouldAbandonFragment(Tt, pt);
                  vt.quality > na.Z.NO_CHANGE && We.getFragmentModel().getRequests({ state: W.FRAGMENT_MODEL_LOADING, index: we.request.index })[0] && (C[pt][He].state = m.Z.ABANDON_LOAD, le[pt][He].reset(), le[pt][He].push({ oldValue: Fe(He, pt), newValue: vt.quality, confidence: 1, reason: vt.reason }), Le(He, _.getActiveStreamInfo(), vt.quality, vt.reason), clearTimeout(F), F = setTimeout(function() {
                    C[pt][He].state = m.Z.ALLOW_LOAD, F = null;
                  }, A.get().streaming.abandonLoadTimeout));
                }
              }
            }
            function ne(we) {
              we.mediaType === t.Z.VIDEO && (q !== void 0 && K.push(we.streamId, q, Z.getPlaybackQuality()), q = we.newQuality);
            }
            function ve(we) {
              var He, pt;
              we.metric !== m.Z.HTTP_REQUEST || !we.value || we.value.type !== Ge.w.MEDIA_SEGMENT_TYPE || we.mediaType !== t.Z.AUDIO && we.mediaType !== t.Z.VIDEO || de.push(we.mediaType, we.value, A.get().streaming.abr.useDeadTimeLatency), we.metric !== m.Z.BUFFER_LEVEL || we.mediaType !== t.Z.AUDIO && we.mediaType !== t.Z.VIDEO || (He = we.mediaType, pt = 1e-3 * we.value.level, A.get().streaming.abr.ABRStrategy === t.Z.ABR_STRATEGY_DYNAMIC && function(We, Tt) {
                try {
                  var vt = me.getStableBufferTime(), ht = vt, Wt = 0.5 * vt, zt = g[We], gn = Tt > (zt ? Wt : ht);
                  g[We] = gn, gn !== zt && (gn ? r.info("[" + We + "] switching from throughput to buffer occupancy ABR rule (buffer: " + Tt.toFixed(3) + ").") : r.info("[" + We + "] switching from buffer occupancy to throughput ABR rule (buffer: " + Tt.toFixed(3) + ")."));
                } catch (pn) {
                  r.error(pn);
                }
              }(He, pt));
            }
            function xe(we, He) {
              try {
                var pt;
                return w[He] = w[He] || {}, w[He].hasOwnProperty(we) || (w[He][we] = 0), pt = function(We, Tt) {
                  var vt = w[Tt][We], ht = vt;
                  if (!y[Tt] || !y[Tt][We]) return ht;
                  var Wt = Ne(We, Tt);
                  Wt !== void 0 && (ht = Math.max(vt, Wt));
                  var zt = function(gn, pn) {
                    try {
                      var Ke = me.getAbrBitrateParameter("maxBitrate", gn);
                      return Ke > -1 ? nt(y[pn][gn].getMediaInfo(), Ke, pn) : void 0;
                    } catch {
                      return;
                    }
                  }(We, Tt);
                  return zt !== void 0 && (ht = Math.min(ht, zt)), ht;
                }(we, He), pt = function(We, Tt, vt) {
                  var ht = w[vt][Tt], Wt = A.get().streaming.abr.maxRepresentationRatio[Tt];
                  return isNaN(Wt) || Wt >= 1 || Wt < 0 ? We : Math.min(We, Math.round(ht * Wt));
                }(pt, we, He), pt = function(We, Tt, vt) {
                  if (Tt !== t.Z.VIDEO || !A.get().streaming.abr.limitBitrateByPortal || !y[vt] || !y[vt][Tt]) return We;
                  Y || Bt();
                  var ht = y[vt][Tt].getStreamInfo(), Wt = U.getAdaptationForType(ht.index, Tt, ht).Representation_asArray, zt = We;
                  if (H > 0 && N > 0) {
                    for (; zt > 0 && Wt[zt] && H < Wt[zt].width && H - Wt[zt - 1].width < Wt[zt].width - H; ) zt -= 1;
                    for (; zt < Wt.length - 1 && Wt[zt].width === Wt[zt + 1].width; ) zt += 1;
                  }
                  return zt;
                }(pt, we, He), A.get().streaming.cmsd.enabled && A.get().streaming.cmsd.abr.applyMb && (pt = function(We, Tt, vt) {
                  if (Tt !== "video") return We;
                  var ht = fe.getMaxBitrate(Tt);
                  if (ht < 0) return We;
                  var Wt = ct(vt, "audio", Fe("audio", vt));
                  ht -= Wt ? Wt.bitrate / 1e3 : 0;
                  var zt = nt(y[vt][Tt].getMediaInfo(), ht, vt);
                  return r.debug("Stream ID: " + vt + " [" + Tt + "] Apply max bit rate from CMSD: " + ht), Math.min(We, zt);
                }(pt, we, He)), pt;
              } catch {
                return;
              }
            }
            function Ne(we, He) {
              try {
                return function(pt, We) {
                  try {
                    var Tt = me.getAbrBitrateParameter("minBitrate", pt);
                    if (Tt > -1) {
                      var vt = y[We][pt].getMediaInfo(), ht = rt(vt), Wt = nt(vt, Tt, We);
                      return ht[Wt] && Wt < ht.length - 1 && ht[Wt].bitrate < 1e3 * Tt && Wt++, Wt;
                    }
                    return;
                  } catch {
                    return;
                  }
                }(we, He);
              } catch {
                return;
              }
            }
            function Fe(we) {
              var He = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              try {
                return He || (He = _.getActiveStreamInfo().id), we && y[He] && y[He][we] && He ? (I[He] = I[He] || {}, I[He].hasOwnProperty(we) || (I[He][we] = 0), I[He][we]) : 0;
              } catch {
                return 0;
              }
            }
            function Le(we, He, pt) {
              var We = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
              if (He && He.id && we) {
                var Tt = He.id, vt = Fe(we, Tt);
                (0, X.SE)(pt);
                var ht = xe(we, Tt);
                pt !== vt && pt >= 0 && pt <= ht && ut(we, vt, pt, ht, We, Tt);
              }
            }
            function ut(we, He, pt, We, Tt, vt) {
              if (we && y[vt] && y[vt][we]) {
                var ht = y[vt][we].getStreamInfo(), Wt = ht && ht.manifestInfo && ht.manifestInfo.isDynamic, zt = O.getCurrentBufferLevel(we);
                r.info("Stream ID: " + vt + " [" + we + "] switch from " + He + " to " + pt + "/" + We + " (buffer: " + zt + ") " + (Tt ? JSON.stringify(Tt) : ".")), I[vt] = I[vt] || {}, I[vt][we] = pt;
                var gn = ct(vt, we, pt);
                ue.trigger(l.Z.QUALITY_CHANGE_REQUESTED, { oldQuality: He, newQuality: pt, reason: Tt, streamInfo: ht, bitrateInfo: gn, maxIdx: We, mediaType: we }, { streamId: ht.id, mediaType: we });
                var pn = de.getAverageThroughput(we, Wt);
                isNaN(pn) || _e.setSavedBitrateSettings(we, pn);
              }
            }
            function ct(we, He, pt) {
              if (He && y && y[we] && y[we][He]) {
                var We = rt(y[we][He].getMediaInfo());
                return We[pt] ? We[pt] : null;
              }
              return null;
            }
            function nt(we, He, pt) {
              var We = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, Tt = we && we.type ? y[pt][we.type].getRepresentationInfo() : null;
              if (A.get().streaming.abr.useDeadTimeLatency && We && Tt && Tt.fragmentDuration) {
                We /= 1e3;
                var vt = Tt.fragmentDuration;
                if (We > vt) return 0;
                var ht = We / vt;
                He *= 1 - ht;
              }
              for (var Wt = rt(we), zt = Wt.length - 1; zt >= 0; zt--) {
                var gn = Wt[zt];
                if (1e3 * He >= gn.bitrate) return zt;
              }
              return 0;
            }
            function rt(we) {
              var He = [];
              if (!we || !we.bitrateList) return He;
              for (var pt, We = we.bitrateList, Tt = we.type, vt = 0, ht = We.length; vt < ht; vt++) (pt = new Ui()).mediaType = Tt, pt.qualityIndex = vt, pt.bitrate = We[vt].bandwidth, pt.width = We[vt].width, pt.height = We[vt].height, pt.scanType = We[vt].scanType, He.push(pt);
              return He;
            }
            function Bt() {
              if (Z) {
                var we = A.get().streaming.abr.usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty("devicePixelRatio") ? window.devicePixelRatio : 1;
                H = Z.getClientWidth() * we, N = Z.getClientHeight() * we;
              }
            }
            return i = { initialize: function() {
              K = Mu(oe).create(), de = Lu(oe).create({ settings: A }), (u = (0, Du.Z)(oe).create({ dashMetrics: O, customParametersModel: ae, mediaPlayerModel: me, settings: A })).initialize(), ue.on(n.Z.QUALITY_CHANGE_RENDERED, ne, i), ue.on(n.Z.METRIC_ADDED, ve, i), ue.on(l.Z.LOADING_PROGRESS, k, i);
            }, isPlayingAtTopQuality: function(we) {
              var He = we ? we.id : null, pt = Fe(t.Z.AUDIO, He), We = Fe(t.Z.VIDEO, He);
              return pt === xe(t.Z.AUDIO, He) && We === xe(t.Z.VIDEO, He);
            }, updateTopQualityIndex: function(we) {
              var He = we.type, pt = we.streamInfo.id, We = we.representationCount - 1;
              return w[pt] = w[pt] || {}, w[pt][He] = We, We;
            }, clearDataForStream: function(we) {
              K && K.clearForStream(we), y[we] && delete y[we], le[we] && delete le[we], C[we] && delete C[we];
            }, getThroughputHistory: function() {
              return de;
            }, getBitrateList: rt, getQualityForBitrate: nt, getTopBitrateInfoFor: function(we) {
              var He = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (He || (He = _.getActiveStreamInfo().id), we && y && y[He] && y[He][we]) {
                var pt = xe(we, He), We = rt(y[He][we].getMediaInfo());
                return We[pt] ? We[pt] : null;
              }
              return null;
            }, getMinAllowedIndexFor: Ne, getMaxAllowedIndexFor: xe, getInitialBitrateFor: function(we, He) {
              if (function() {
                if (!_e || !_e.hasOwnProperty("getSavedBitrateSettings")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              }(), we === t.Z.TEXT) return NaN;
              var pt = _e.getSavedBitrateSettings(we), We = me.getAbrBitrateParameter("initialBitrate", we), Tt = A.get().streaming.abr.initialRepresentationRatio[we];
              if (We === -1) if (Tt > -1) {
                var vt = y[He][we].getStreamInfo(), ht = U.getAdaptationForType(vt.index, we, vt).Representation_asArray;
                We = Array.isArray(ht) ? ht[Math.max(Math.round(ht.length * Tt) - 1, 0)].bandwidth / 1e3 : 0;
              } else We = isNaN(pt) ? we === t.Z.VIDEO ? 1e3 : 100 : pt;
              return We;
            }, getQualityFor: Fe, getAbandonmentStateFor: function(we, He) {
              return C[we] && C[we][He] ? C[we][He].state : null;
            }, setPlaybackQuality: Le, checkPlaybackQuality: function(we, He) {
              try {
                if (!(we && y && y[He] && y[He][we])) return !1;
                if (K) {
                  var pt = Z.getPlaybackQuality();
                  pt && K.push(He, q, pt);
                }
                if (!A.get().streaming.abr.autoSwitchBitrate[we]) return !1;
                var We = Fe(we, He), Tt = ds(oe).create({ abrController: i, switchHistory: le[He][we], droppedFramesHistory: K, streamProcessor: y[He][we], currentValue: We, useBufferOccupancyABR: g[we], useL2AABR: L[we], useLoLPABR: D[we], videoModel: Z }), vt = Ne(we, He), ht = xe(we, He), Wt = u.getMaxQuality(Tt), zt = Wt.quality;
                return vt !== void 0 && (zt > na.Z.NO_CHANGE ? zt : We) < vt && (zt = vt), zt > ht && (zt = ht), le[He][we].push({ oldValue: We, newValue: zt }), zt > na.Z.NO_CHANGE && zt !== We && (C[He][we].state === m.Z.ALLOW_LOAD || zt < We) && (ut(we, We, zt, ht, Wt.reason, He), !0);
              } catch {
                return !1;
              }
            }, setElementSize: Bt, setWindowResizeEventCalled: function(we) {
              Y = we;
            }, registerStreamType: function(we, He) {
              var pt = He.getStreamInfo().id;
              y[pt] || (y[pt] = {}), le[pt] || (le[pt] = {}), C[pt] || (C[pt] = {}), le[pt][we] = Ou(oe).create(), y[pt][we] = He, C[pt][we] = {}, C[pt][we].state = m.Z.ALLOW_LOAD, function(We) {
                var Tt = A.get().streaming.abr.ABRStrategy;
                Tt === t.Z.ABR_STRATEGY_L2A ? (g[We] = !1, D[We] = !1, L[We] = !0) : Tt === t.Z.ABR_STRATEGY_LoLP ? (g[We] = !1, D[We] = !0, L[We] = !1) : Tt === t.Z.ABR_STRATEGY_BOLA ? (g[We] = !0, D[We] = !1, L[We] = !1) : Tt === t.Z.ABR_STRATEGY_THROUGHPUT ? (g[We] = !1, D[We] = !1, L[We] = !1) : Tt === t.Z.ABR_STRATEGY_DYNAMIC && (g[We] = !(!g || !g[We]) && g[We], D[We] = !1, L[We] = !1);
              }(we), we === t.Z.VIDEO && Bt();
            }, unRegisterStreamType: function(we, He) {
              try {
                y[we] && y[we][He] && delete y[we][He], le[we] && le[we][He] && delete le[we][He], C[we] && C[we][He] && delete C[we][He];
              } catch {
              }
            }, setConfig: function(we) {
              we && (we.streamController && (_ = we.streamController), we.domStorage && (_e = we.domStorage), we.mediaPlayerModel && (me = we.mediaPlayerModel), we.customParametersModel && (ae = we.customParametersModel), we.cmsdModel && (fe = we.cmsdModel), we.dashMetrics && (O = we.dashMetrics), we.adapter && (U = we.adapter), we.videoModel && (Z = we.videoModel), we.settings && (A = we.settings));
            }, reset: function() {
              ee(), ue.off(l.Z.LOADING_PROGRESS, k, i), ue.off(n.Z.QUALITY_CHANGE_RENDERED, ne, i), ue.off(n.Z.METRIC_ADDED, ve, i), u && u.reset();
            } }, r = Q.getLogger(i), ee(), i;
          }
          no.__dashjs_factory_name = "AbrController";
          var ro = v.Z.getSingletonFactory(no);
          ro.QUALITY_DEFAULT = 0, v.Z.updateSingletonFactory(no.__dashjs_factory_name, ro);
          var Pu = ro, xu = /* @__PURE__ */ new Map([[t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, "loadedmetadata"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA, "loadeddata"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA, "canplay"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA, "canplaythrough"]]);
          function ps() {
            var i, r, u, _, w, I, y, C, F = this.context, Y = (0, p.Z)(F).getInstance(), H = [];
            function N() {
              u && (u.playbackRate = 1, u.removeEventListener("canplay", N));
            }
            function U() {
              return H.length > 0;
            }
            function Z() {
              if (u && U() && u.playbackRate === 0) {
                var K = document.createEvent("Event");
                K.initEvent("waiting", !0, !1), u.dispatchEvent(K);
              }
            }
            function me(K, de) {
              u && u.addEventListener(K, de);
            }
            function ae(K, de) {
              u && u.removeEventListener(K, de);
            }
            function fe() {
              return u ? u.readyState : NaN;
            }
            function _e() {
              return u ? u.buffered : null;
            }
            function q(K, de, g, L, D) {
              if (u) {
                for (var O = 0; O < u.textTracks.length; O++) if (u.textTracks[O].kind === K && (!de || u.textTracks[O].label == de) && u.textTracks[O].language === g && u.textTracks[O].isTTML === L && u.textTracks[O].isEmbedded === D) return u.textTracks[O];
              }
              return null;
            }
            function le(K, de) {
              return K === t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING || fe() >= K ? (de(), null) : function(g, L) {
                var D = function O() {
                  ae(g, O), L(g);
                };
                return me(g, D), { func: D, event: g };
              }(xu.get(K), de);
            }
            return i = { addEventListener: me, addTextTrack: function(K, de, g, L, D) {
              if (!u) return null;
              var O = q(K, de, g, L, D);
              return O || ((O = u.addTextTrack(K, de, g)).isEmbedded = D, O.isTTML = L), O;
            }, appendChild: function(K) {
              u && (u.appendChild(K), K.isTTML !== void 0 && (u.textTracks[u.textTracks.length - 1].isTTML = K.isTTML, u.textTracks[u.textTracks.length - 1].isEmbedded = K.isEmbedded));
            }, getBufferRange: _e, getClientHeight: function() {
              return u ? u.clientHeight : NaN;
            }, getClientWidth: function() {
              return u ? u.clientWidth : NaN;
            }, getElement: function() {
              return u;
            }, getEnded: function() {
              return u ? u.ended : null;
            }, getPlaybackQuality: function() {
              if (!u) return null;
              var K = "webkitDroppedFrameCount" in u && "webkitDecodedFrameCount" in u, de = null;
              return "getVideoPlaybackQuality" in u ? de = u.getVideoPlaybackQuality() : K && (de = { droppedVideoFrames: u.webkitDroppedFrameCount, totalVideoFrames: u.webkitDroppedFrameCount + u.webkitDecodedFrameCount, creationTime: /* @__PURE__ */ new Date() }), de;
            }, getPlaybackRate: function() {
              return u ? u.playbackRate : null;
            }, getPlayedRanges: function() {
              return u ? u.played : null;
            }, getReadyState: fe, getSource: function() {
              return u ? u.src : null;
            }, getTTMLRenderingDiv: function() {
              return I;
            }, getTextTrack: q, getTextTracks: function() {
              return u ? u.textTracks : [];
            }, getTime: function() {
              return u ? isNaN(_) ? u.currentTime : _ : null;
            }, getVideoHeight: function() {
              return u ? u.videoHeight : NaN;
            }, getVideoRelativeOffsetLeft: function() {
              if (u) {
                var K = u.parentNode.host || u.parentNode;
                return K ? u.getBoundingClientRect().left - K.getBoundingClientRect().left : NaN;
              }
              return NaN;
            }, getVideoRelativeOffsetTop: function() {
              if (u) {
                var K = u.parentNode.host || u.parentNode;
                return K ? u.getBoundingClientRect().top - K.getBoundingClientRect().top : NaN;
              }
              return NaN;
            }, getVideoWidth: function() {
              return u ? u.videoWidth : NaN;
            }, getVttRenderingDiv: function() {
              return y;
            }, initialize: function() {
              Y.on(l.Z.PLAYBACK_PLAYING, Z, this);
            }, isPaused: function() {
              return u ? u.paused : null;
            }, isSeeking: function() {
              return u ? u.seeking || !isNaN(_) : null;
            }, isStalled: U, pause: function() {
              u && (u.pause(), u.autoplay = !1);
            }, play: function() {
              if (u) {
                u.autoplay = !0;
                var K = u.play();
                K && K.catch && typeof Promise < "u" && K.catch(function(de) {
                  de.name === "NotAllowedError" && Y.trigger(l.Z.PLAYBACK_NOT_ALLOWED), r.warn("Caught pending play exception - continuing (".concat(de, ")"));
                });
              }
            }, removeChild: function(K) {
              u && u.removeChild(K);
            }, removeEventListener: ae, reset: function() {
              clearTimeout(C), Y.off(l.Z.PLAYBACK_PLAYING, Z, this);
            }, setCurrentTime: function(K, de) {
              u && (w && w.func && w.event && ae(w.event, w.func), _ = K, w = le(t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                if (u) if (u.currentTime !== _) try {
                  _ = de ? function(g) {
                    var L = _e(), D = g, O = 9999999999;
                    if (L) for (var A = 0; A < L.length; A++) {
                      var oe = L.start(A), Q = L.end(A), ue = Math.abs(oe - g), ee = Math.abs(Q - g);
                      if (g >= oe && g <= Q) return g;
                      ue < O && (O = ue, D = oe), ee < O && (O = ee, D = Q);
                    }
                    return D;
                  }(_) : _, isNaN(_) || (u.currentTime = _), _ = NaN;
                } catch (g) {
                  u.readyState === 0 && g.code === g.INVALID_STATE_ERR && (C = setTimeout(function() {
                    u.currentTime = _, _ = NaN;
                  }, 400));
                }
                else _ = NaN;
              }));
            }, setElement: function(K) {
              if (!(K == null || K && /^(VIDEO|AUDIO)$/i.test(K.nodeName))) throw "element is not video or audio DOM type!";
              (u = K) && (u.preload = "auto");
            }, setPlaybackRate: function(K) {
              var de = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              u && (!de && u.readyState <= 2 && K > 0 ? u.addEventListener("canplay", N) : u.playbackRate = K);
            }, setSource: function(K) {
              u && (K ? u.src = K : (u.removeAttribute("src"), u.load()));
            }, setStallState: function(K, de) {
              (function(g, L) {
                L ? function(D) {
                  D !== null && u && !u.seeking && H.indexOf(D) === -1 && H.push(D);
                }(g) : function(D) {
                  var O = H.indexOf(D);
                  D !== null && O !== -1 && H.splice(O, 1);
                }(g);
              })(K, de);
            }, setTTMLRenderingDiv: function(K) {
              (I = K).style.position = "absolute", I.style.display = "flex", I.style.overflow = "hidden", I.style.pointerEvents = "none", I.style.top = 0, I.style.left = 0;
            }, setVttRenderingDiv: function(K) {
              y = K;
            }, waitForReadyState: le, setDisableRemotePlayback: function(K) {
              u && (u.disableRemotePlayback = K);
            } }, r = (0, h.Z)(F).getInstance().getLogger(i), _ = NaN, i;
          }
          ps.__dashjs_factory_name = "VideoModel";
          var Fu = v.Z.getSingletonFactory(ps), ku = [{ oldKey: "dashjs_vbitrate", newKey: "dashjs_video_bitrate" }, { oldKey: "dashjs_abitrate", newKey: "dashjs_audio_bitrate" }, { oldKey: "dashjs_vsettings", newKey: "dashjs_video_settings" }, { oldKey: "dashjs_asettings", newKey: "dashjs_audio_settings" }], ys = "dashjs_?_bitrate", _s = "dashjs_?_settings", _i = "localStorage", Es = "lastBitrate", vs = "lastMediaSettings";
          function Ts(i) {
            i = i || {};
            var r, u, _, w = this.context, I = i.settings;
            function y(H) {
              if (_ !== void 0) return _;
              var N;
              _ = !1;
              try {
                typeof window < "u" && (N = window[H]);
              } catch (U) {
                return u.warn("DOMStorage access denied: " + U.message), _;
              }
              if (!N || H !== _i) return _;
              try {
                N.setItem("1", "1"), N.removeItem("1"), _ = !0;
              } catch (U) {
                u.warn("DOMStorage is supported, but cannot be used: " + U.message);
              }
              return _;
            }
            function C() {
              var H = 6e5;
              return Math.round((/* @__PURE__ */ new Date()).getTime() / H) * H;
            }
            function F(H, N) {
              return y(H) && I.get().streaming[N + "CachingInfo"].enabled;
            }
            function Y() {
              if (!I) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            return r = { getSavedBitrateSettings: function(H) {
              if (Y(), !I.get().streaming.lastBitrateCachingInfo.enabled) return NaN;
              var N = NaN;
              if (F(_i, Es)) {
                var U = ys.replace(/\?/, H);
                try {
                  var Z = JSON.parse(localStorage.getItem(U)) || {}, me = (/* @__PURE__ */ new Date()).getTime() - parseInt(Z.timestamp, 10) >= I.get().streaming.lastBitrateCachingInfo.ttl || !1, ae = parseFloat(Z.bitrate);
                  isNaN(ae) || me ? me && localStorage.removeItem(U) : (N = ae, u.debug("Last saved bitrate for " + H + " was " + ae));
                } catch {
                  return null;
                }
              }
              return N;
            }, setSavedBitrateSettings: function(H, N) {
              if (F(_i, Es) && N) {
                var U = ys.replace(/\?/, H);
                try {
                  localStorage.setItem(U, JSON.stringify({ bitrate: N.toFixed(3), timestamp: C() }));
                } catch (Z) {
                  u.error(Z.message);
                }
              }
            }, getSavedMediaSettings: function(H) {
              if (Y(), !I.get().streaming.lastMediaSettingsCachingInfo.enabled) return null;
              var N = null;
              if (F(_i, vs)) {
                var U = _s.replace(/\?/, H);
                try {
                  var Z = JSON.parse(localStorage.getItem(U)) || {}, me = (/* @__PURE__ */ new Date()).getTime() - parseInt(Z.timestamp, 10) >= I.get().streaming.lastMediaSettingsCachingInfo.ttl || !1;
                  N = Z.settings, me && (localStorage.removeItem(U), N = null);
                } catch {
                  return null;
                }
              }
              return N;
            }, setSavedMediaSettings: function(H, N) {
              if (F(_i, vs)) {
                var U = _s.replace(/\?/, H);
                try {
                  localStorage.setItem(U, JSON.stringify({ settings: N, timestamp: C() }));
                } catch (Z) {
                  u.error(Z.message);
                }
              }
            } }, u = (0, h.Z)(w).getInstance().getLogger(r), y(_i) && ku.forEach(function(H) {
              var N = localStorage.getItem(H.oldKey);
              if (N) {
                localStorage.removeItem(H.oldKey);
                try {
                  localStorage.setItem(H.newKey, N);
                } catch (U) {
                  u.error(U.message);
                }
              }
            }), r;
          }
          Ts.__dashjs_factory_name = "DOMStorage";
          var Zu = v.Z.getSingletonFactory(Ts), Bu = R(2032), bs = R(2011);
          function Ss() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z = this.context;
            function me(q, le, K, de) {
              var g = null, L = q ? U.resolve(q.path) : null, D = de || { init: !0, url: L ? L.url : void 0, range: { start: 0, end: 1500 }, searching: !1, bytesLoaded: 0, bytesToLoad: 1500, mediaType: le };
              r.debug("Start searching for initialization.");
              var O = _e(D);
              C.load({ request: O, success: function(A) {
                if (D.bytesLoaded = D.range.end, !(g = _.findInitRange(A))) return D.range.end = D.bytesLoaded + D.bytesToLoad, me(q, le, K, D);
                q.range = g, K(q);
              }, error: function() {
                K(q);
              } }), r.debug("Perform init search: " + D.url);
            }
            function ae(q, le, K, de, g, L) {
              if (K && (K.start === void 0 || K.end === void 0)) {
                var D = K ? K.toString().split("-") : null;
                K = D ? { start: parseFloat(D[0]), end: parseFloat(D[1]) } : null;
              }
              g = g || fe;
              var O = null, A = null, oe = !!K, Q = q ? U.resolve(q.path) : null, ue = { init: !1, url: Q ? Q.url : void 0, range: oe ? K : { start: 0, end: 1500 }, searching: !oe, bytesLoaded: L ? L.bytesLoaded : 0, bytesToLoad: 1500, mediaType: le }, ee = _e(ue);
              C.load({ request: ee, success: function(k) {
                var ne = ue.bytesToLoad, ve = k.byteLength;
                if (ue.bytesLoaded = ue.range.end - ue.range.start, O = _.parse(k), (A = O.getBox("sidx")) && A.isComplete) {
                  var xe, Ne, Fe = A.references;
                  if (Fe != null && Fe.length > 0 && (xe = Fe[0].reference_type === 1), xe) {
                    var Le, ut, ct, nt;
                    r.debug("Initiate multiple SIDX load."), ue.range.end = ue.range.start + A.size;
                    var rt = [], Bt = 0, we = (A.offset || ue.range.start) + A.size, He = function(We) {
                      We ? (rt = rt.concat(We), ++Bt >= ut && (rt.sort(function(Tt, vt) {
                        return Tt.startTime - vt.startTime < 0 ? -1 : 0;
                      }), g(rt, q, de))) : g(null, q, de);
                    };
                    for (Le = 0, ut = Fe.length; Le < ut; Le++) ct = we, nt = we + Fe[Le].referenced_size - 1, we += Fe[Le].referenced_size, ae(q, le, { start: ct, end: nt }, de, He, ue);
                  } else r.debug("Parsing segments from SIDX. representation " + le + " - id: " + q.id + " for range : " + ue.range.start + " - " + ue.range.end), Ne = function(We, Tt) {
                    for (var vt, ht, Wt, zt, gn = We.references, pn = gn.length, Ke = We.timescale, Et = We.earliest_presentation_time, lt = Tt.range.start + We.offset + We.first_offset + We.size, Rt = [], Pt = 0; Pt < pn; Pt++) Wt = gn[Pt].subsegment_duration, zt = gn[Pt].referenced_size, (vt = new bs.Z()).duration = Wt, vt.startTime = Et, vt.timescale = Ke, ht = lt + zt - 1, vt.mediaRange = lt + "-" + ht, Rt.push(vt), Et += Wt, lt += zt;
                    return Rt;
                  }(A, ue), g(Ne, q, de);
                } else {
                  if (A) ue.range.start = A.offset || ue.range.start, ue.range.end = ue.range.start + (A.size || ne);
                  else {
                    if (ve < ue.bytesLoaded) return void g(null, q, de);
                    var pt = O.getLastBox();
                    pt && pt.size ? (ue.range.start = pt.offset + pt.size, ue.range.end = ue.range.start + ne) : ue.range.end += ne;
                  }
                  ae(q, le, ue.range, de, null, ue);
                }
              }, error: function() {
                g(null, q, de);
              } }), r.debug("Perform SIDX load for type ".concat(le, " : ").concat(ue.url, " with range ").concat(ue.range.start, " - ").concat(ue.range.end));
            }
            function fe(q, le, K) {
              K({ segments: q, representation: le, error: q ? void 0 : new se.Z(F.SEGMENT_BASE_LOADER_ERROR_CODE, F.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
            }
            function _e(q) {
              if (q.url) {
                var le = new S.Z();
                return le.setInfo(q), le;
              }
            }
            return i = { setConfig: function(q) {
              q.baseURLController && (U = q.baseURLController), q.dashMetrics && (I = q.dashMetrics), q.mediaPlayerModel && (y = q.mediaPlayerModel), q.errHandler && (u = q.errHandler), q.boxParser && (_ = q.boxParser), q.debug && (r = q.debug.getLogger(i)), q.requestModifier && (w = q.requestModifier), q.errors && (F = q.errors), q.urlUtils && (N = q.urlUtils), q.constants && (Y = q.constants), q.dashConstants && (H = q.dashConstants);
            }, initialize: function() {
              C = cr(Z).create({ errHandler: u, dashMetrics: I, mediaPlayerModel: y, requestModifier: w, boxParser: _, errors: F, urlUtils: N, constants: Y, dashConstants: H });
            }, loadInitialization: function(q, le) {
              return new Promise(function(K) {
                me(q, le, K);
              });
            }, loadSegments: function(q, le, K) {
              return new Promise(function(de) {
                ae(q, le, K, de);
              });
            }, reset: function() {
              C && (C.abort(), C = null);
            } };
          }
          Ss.__dashjs_factory_name = "SegmentBaseLoader";
          var Uu = v.Z.getSingletonFactory(Ss);
          function As(i) {
            var r;
            i = i || {};
            var u = new DataView(i.data), _ = 0;
            function w(y, C) {
              var F = !0, Y = 0;
              if (C === void 0 && (C = !1), y.tag > 16777215 ? (u.getUint32(_) !== y.tag && (F = !1), Y = 4) : y.tag > 65535 ? (256 * u.getUint16(_) + u.getUint8(_ + 2) !== y.tag && (F = !1), Y = 3) : y.tag > 255 ? (u.getUint16(_) !== y.tag && (F = !1), Y = 2) : (u.getUint8(_) !== y.tag && (F = !1), Y = 1), !F && y.required && !C) throw new Error("required tag not found");
              return F && (_ += Y), F;
            }
            function I(y) {
              var C = 1, F = 128, Y = -1, H = 0, N = u.getUint8(_), U = 0;
              for (U = 0; U < 8; U += 1) {
                if ((N & F) === F) {
                  H = y === void 0 ? N & ~F : N, Y = U;
                  break;
                }
                F >>= 1;
              }
              for (U = 0; U < Y; U += 1, C += 1) H = H << 8 | 255 & u.getUint8(_ + C);
              return _ += C, H;
            }
            return r = { getPos: function() {
              return _;
            }, setPos: function(y) {
              _ = y;
            }, consumeTag: w, consumeTagAndSize: function(y, C) {
              var F = w(y, C);
              return F && I(), F;
            }, parseTag: function(y) {
              var C;
              return w(y), C = I(), r[y.parse](C);
            }, skipOverElement: function(y, C) {
              var F, Y = w(y, C);
              return Y && (F = I(), _ += F), Y;
            }, getMatroskaCodedNum: I, getMatroskaFloat: function(y) {
              var C;
              switch (y) {
                case 4:
                  C = u.getFloat32(_), _ += 4;
                  break;
                case 8:
                  C = u.getFloat64(_), _ += 8;
              }
              return C;
            }, getMatroskaUint: function(y) {
              if (y > 4) return function(Y) {
                for (var H = Math.floor(Number.MAX_SAFE_INTEGER / 256), N = 0, U = 0; U < Y; U += 1) {
                  if (N > H) throw new Error("Value exceeds safe integer limit");
                  N *= 256;
                  var Z = u.getUint8(_ + U);
                  if (N > Number.MAX_SAFE_INTEGER - Z) throw new Error("Value exceeds safe integer limit");
                  N += Z;
                }
                return _ += Y, N;
              }(y);
              for (var C = 0, F = 0; F < y; F += 1) C <<= 8, C |= 255 & u.getUint8(_ + F);
              return _ += y, C >>> 0;
            }, moreData: function() {
              return _ < u.byteLength;
            } };
          }
          As.__dashjs_factory_name = "EBMLParser";
          var Is = v.Z.getClassFactory(As);
          function ws() {
            var i, r, u, _, w, I, y, C, F, Y, H = this.context;
            function N(U) {
              var Z = new S.Z();
              return Z.setInfo(U), Z;
            }
            return i = { setConfig: function(U) {
              if (!(U.baseURLController && U.dashMetrics && U.mediaPlayerModel && U.errHandler)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              Y = U.baseURLController, I = U.dashMetrics, y = U.mediaPlayerModel, _ = U.errHandler, F = U.errors, r = U.debug.getLogger(i), w = U.requestModifier;
            }, initialize: function() {
              C = cr(H).create({ errHandler: _, dashMetrics: I, mediaPlayerModel: y, requestModifier: w, errors: F });
            }, loadInitialization: function(U, Z) {
              return new Promise(function(me) {
                var ae = null, fe = U ? Y.resolve(U.path) : null, _e = U ? U.range.split("-") : null, q = { range: { start: _e ? parseFloat(_e[0]) : null, end: _e ? parseFloat(_e[1]) : null }, request: ae, url: fe ? fe.url : void 0, init: !0, mediaType: Z };
                r.info("Start loading initialization."), ae = N(q), C.load({ request: ae, success: function() {
                  me(U);
                }, error: function() {
                  me(U);
                } }), r.debug("Perform init load: " + q.url);
              });
            }, loadSegments: function(U, Z, me) {
              return new Promise(function(ae) {
                var fe = null, _e = U ? Y.resolve(U.path) : null, q = _e ? _e.url : void 0;
                fe = N({ bytesLoaded: 0, bytesToLoad: 8192, range: { start: 0, end: 8192 }, request: fe, url: q, init: !1, mediaType: Z }), r.debug("Parsing ebml header"), C.load({ request: fe, success: function(le) {
                  (function(K, de, g, L) {
                    if (K && K.byteLength !== 0) {
                      var D, O, A, oe, Q = Is(H).create({ data: K }), ue = g ? g.split("-") : null, ee = null, k = { url: de, range: { start: ue ? parseFloat(ue[0]) : null, end: ue ? parseFloat(ue[1]) : null }, request: ee };
                      for (r.debug("Parse EBML header: " + k.url), Q.skipOverElement(u.EBML), Q.consumeTag(u.Segment), A = Q.getMatroskaCodedNum(), A += Q.getPos(), oe = Q.getPos(); Q.moreData() && !Q.consumeTagAndSize(u.Segment.Info, !0); ) if (!(Q.skipOverElement(u.Segment.SeekHead, !0) || Q.skipOverElement(u.Segment.Tracks, !0) || Q.skipOverElement(u.Segment.Cues, !0) || Q.skipOverElement(u.Void, !0))) throw new Error("no valid top level element found");
                      for (; D === void 0; ) {
                        var ne = Q.getMatroskaCodedNum(!0), ve = Q.getMatroskaCodedNum();
                        ne === u.Segment.Info.Duration.tag ? D = Q[u.Segment.Info.Duration.parse](ve) : Q.setPos(Q.getPos() + ve);
                      }
                      ee = N(k), C.load({ request: ee, success: function(xe) {
                        O = function(Ne, Fe, Le, ut) {
                          var ct, nt, rt, Bt, we, He, pt, We;
                          for (rt = [], we = 0, He = (nt = function(Tt) {
                            var vt, ht, Wt = [], zt = Is(H).create({ data: Tt });
                            for (zt.consumeTagAndSize(u.Segment.Cues); zt.moreData() && zt.consumeTagAndSize(u.Segment.Cues.CuePoint, !0); ) {
                              for ((vt = {}).CueTime = zt.parseTag(u.Segment.Cues.CuePoint.CueTime), vt.CueTracks = []; zt.moreData() && zt.consumeTag(u.Segment.Cues.CuePoint.CueTrackPositions, !0); ) {
                                var gn = zt.getMatroskaCodedNum(), pn = zt.getPos();
                                if ((ht = {}).Track = zt.parseTag(u.Segment.Cues.CuePoint.CueTrackPositions.CueTrack), ht.Track === 0) throw new Error("Cue track cannot be 0");
                                ht.ClusterPosition = zt.parseTag(u.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition), vt.CueTracks.push(ht), zt.setPos(pn + gn);
                              }
                              if (vt.CueTracks.length === 0) throw new Error("Mandatory cuetrack not found");
                              Wt.push(vt);
                            }
                            if (Wt.length === 0) throw new Error("mandatory cuepoint not found");
                            return Wt;
                          }(Ne)).length; we < He; we += 1) Bt = new bs.Z(), ct = we < nt.length - 1 ? nt[we + 1].CueTime - nt[we].CueTime : ut - nt[we].CueTime, Bt.duration = ct, Bt.startTime = nt[we].CueTime, Bt.timescale = 1e3, pt = nt[we].CueTracks[0].ClusterPosition + Fe, We = we < nt.length - 1 ? nt[we + 1].CueTracks[0].ClusterPosition + Fe - 1 : Le - 1, Bt.mediaRange = pt + "-" + We, rt.push(Bt);
                          return r.debug("Parsed cues: " + rt.length + " cues."), rt;
                        }(xe, oe, A, D), L(O);
                      }, error: function() {
                        r.error("Download Error: Cues " + k.url), L(null);
                      } }), r.debug("Perform cues load: " + k.url + " bytes=" + k.range.start + "-" + k.range.end);
                    } else L(null);
                  })(le, q, me, function(K) {
                    ae({ segments: K, representation: U, error: K ? void 0 : new se.Z(F.SEGMENT_BASE_LOADER_ERROR_CODE, F.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
                  });
                }, error: function() {
                  ae({ representation: U, error: new se.Z(F.SEGMENT_BASE_LOADER_ERROR_CODE, F.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
                } });
              });
            }, reset: function() {
              C && (C.abort(), C = null);
            } }, u = { EBML: { tag: 440786851, required: !0 }, Segment: { tag: 408125543, required: !0, SeekHead: { tag: 290298740, required: !0 }, Info: { tag: 357149030, required: !0, TimecodeScale: { tag: 2807729, required: !0, parse: "getMatroskaUint" }, Duration: { tag: 17545, required: !0, parse: "getMatroskaFloat" } }, Tracks: { tag: 374648427, required: !0 }, Cues: { tag: 475249515, required: !0, CuePoint: { tag: 187, required: !0, CueTime: { tag: 179, required: !0, parse: "getMatroskaUint" }, CueTrackPositions: { tag: 183, required: !0, CueTrack: { tag: 247, required: !0, parse: "getMatroskaUint" }, CueClusterPosition: { tag: 241, required: !0, parse: "getMatroskaUint" } } } } }, Void: { tag: 236, required: !0 } }, i;
          }
          ws.__dashjs_factory_name = "WebmSegmentBaseLoader";
          var Gu = v.Z.getSingletonFactory(ws);
          function Rs(i) {
            i = i || {};
            var r, u, _, w = this.context, I = i.eventBus, y = i.events, C = i.dashMetrics, F = i.mediaPlayerModel, Y = i.errHandler, H = i.baseURLController, N = i.debug, U = i.boxParser, Z = i.requestModifier, me = i.errors;
            function ae(fe) {
              return (fe ? fe.split("/")[1] : "").toLowerCase() === "webm";
            }
            return r = { initialize: function() {
              u.initialize(), _.initialize();
            }, getSegmentBaseInitSegment: function(fe) {
              return ae(fe.representation.mimeType) ? _.loadInitialization(fe.representation, fe.mediaType) : u.loadInitialization(fe.representation, fe.mediaType);
            }, getSegmentList: function(fe) {
              return ae(fe.mimeType) ? _.loadSegments(fe.representation, fe.mediaType, fe.representation ? fe.representation.indexRange : null) : u.loadSegments(fe.representation, fe.mediaType, fe.representation ? fe.representation.indexRange : null);
            }, reset: function() {
              u.reset(), _.reset();
            } }, u = Uu(w).getInstance(), _ = Gu(w).getInstance(), u.setConfig({ baseURLController: H, dashMetrics: C, mediaPlayerModel: F, errHandler: Y, eventBus: I, events: y, errors: me, debug: N, boxParser: U, requestModifier: Z }), _.setConfig({ baseURLController: H, dashMetrics: C, mediaPlayerModel: F, errHandler: Y, eventBus: I, events: y, errors: me, debug: N, requestModifier: Z }), r;
          }
          Rs.__dashjs_factory_name = "SegmentBaseController";
          var Hu = v.Z.getSingletonFactory(Rs), Cs = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.quality = null, this.fragmentDuration = null, this.mediaInfo = null, this.MSETimeOffset = null;
          }, io = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = null, this.type = null, this.streamInfo = null, this.representationCount = 0, this.labels = null, this.lang = null, this.viewpoint = null, this.viewpointsWithSchemeIdUri = null, this.accessibility = null, this.accessibilitiesWithSchemeIdUri = null, this.audioChannelConfiguration = null, this.audioChannelConfigurationsWithSchemeIdUri = null, this.roles = null, this.rolesWithSchemeIdUri = null, this.codec = null, this.mimeType = null, this.contentProtection = null, this.isText = !1, this.KID = null, this.bitrateList = null, this.isFragmented = null, this.isEmbedded = null, this.selectionPriority = 1, this.supplementalProperties = {}, this.supplementalPropertiesAsArray = [], this.essentialProperties = {}, this.essentialPropertiesAsArray = [], this.segmentAlignment = !1, this.subSegmentAlignment = !1;
          }, Ns = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = null, this.start = NaN, this.duration = NaN, this.manifestInfo = null, this.isLast = !0;
          }, qu = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.dvrWindowSize = NaN, this.loadedTime = null, this.availableFrom = null, this.minBufferTime = NaN, this.duration = NaN, this.isDynamic = !1, this.maxFragmentDuration = null, this.serviceDescriptions = [], this.protocol = null;
          };
          function Vu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var ju = function() {
            function i(_) {
              var w = this;
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.valid = _[0] == "/", this.path = _.split("/").filter(function(I) {
                return I.length !== 0;
              }).map(function(I) {
                var y = { name: I }, C = I.indexOf("[");
                if (C != -1) {
                  y.name = I.substring(0, C);
                  var F = I.substring(C + 1, I.length - 1);
                  w.valid = w.valid && F.indexOf("[") == -1;
                  var Y = F.indexOf("=");
                  Y != -1 ? (y.attribute = { name: F.substring(1, Y), value: F.substring(Y + 1) }, ["'", '"'].indexOf(y.attribute.value[0]) != -1 && (y.attribute.value = y.attribute.value.substring(1, y.attribute.value.length - 1))) : y.position = parseInt(F, 10) - 1;
                }
                return y;
              });
            }
            var r, u;
            return r = i, (u = [{ key: "isValid", value: function() {
              return this.valid;
            } }, { key: "findsElement", value: function() {
              return !this.findsAttribute();
            } }, { key: "findsAttribute", value: function() {
              return this.path[this.path.length - 1].name.startsWith("@");
            } }, { key: "findsTextReplace", value: function() {
              return this.path[this.path.length - 1].name === "text()";
            } }, { key: "getMpdTarget", value: function(_, w) {
              for (var I = null, y = _, C = 1, F = "MPD"; C < this.path.length && y !== null; ) {
                I = y;
                var Y = this.path[C];
                if (F = Y.name, C !== this.path.length - 1 || !F.startsWith("@") && F !== "text()") {
                  var H = I[F + "_asArray"] || [];
                  H.length === 0 && I[F] && H.push(I[F]), Y.position ? y = H[Y.position] || null : Y.attribute ? function() {
                    var N = Y.attribute;
                    y = H.filter(function(U) {
                      return U[N.name] == N.value;
                    })[0] || null;
                  }() : y = H[0] || null;
                }
                C++;
              }
              return y === null ? null : F.startsWith("@") ? { name: F.substring(1), leaf: y, target: y } : F === "text()" ? { name: "__text", leaf: y, target: y } : { name: F, leaf: y, target: w ? I : y };
            } }]) && Vu(r.prototype, u), i;
          }();
          function Yu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Ku = function() {
            function i(_, w, I) {
              (function(y, C) {
                if (!(y instanceof C)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.action = _, this.xpath = w, this.value = I, this.position = null;
            }
            var r, u;
            return r = i, (u = [{ key: "getMpdTarget", value: function(_) {
              var w = this.action === "remove" || this.action === "replace" || this.position === "before" || this.position === "after";
              return this.xpath.getMpdTarget(_, w);
            } }]) && Yu(r.prototype, u), i;
          }();
          function Ds() {
            var i, r, u = this.context;
            return i = { getIsPatch: function(_) {
              return _ && _.hasOwnProperty(e.Z.ORIGINAL_MPD_ID) || !1;
            }, getPublishTime: function(_) {
              return _ && _.hasOwnProperty(e.Z.PUBLISH_TIME) ? new Date(_[e.Z.PUBLISH_TIME]) : null;
            }, getOriginalPublishTime: function(_) {
              return _ && _.hasOwnProperty(e.Z.ORIGINAL_PUBLISH_TIME) ? new Date(_[e.Z.ORIGINAL_PUBLISH_TIME]) : null;
            }, getMpdId: function(_) {
              return _ && _[e.Z.ORIGINAL_MPD_ID] || null;
            }, getPatchOperations: function(_) {
              return _ ? (_.__children || []).map(function(w) {
                var I = Object.keys(w)[0];
                if (I !== "add" && I !== "remove" && I !== "replace") return r.warn("Ignoring node of invalid action: ".concat(I)), null;
                var y = w[I], C = y.sel;
                if (I === "add" && y.type) {
                  if (!y.type.startsWith("@")) return r.warn("Ignoring add action for prefixed namespace declaration: ".concat(y.type, "=").concat(y.__text)), null;
                  C = "".concat(C, "/").concat(y.type);
                }
                var F = new ju(C);
                if (!F.isValid()) return r.warn("Ignoring action with invalid selector: ".concat(I, " - ").concat(C)), null;
                var Y = null;
                F.findsAttribute() || F.findsTextReplace() ? Y = y.__text || "" : I !== "remove" && (Y = y.__children.reduce(function(N, U) {
                  var Z = Object.keys(U)[0];
                  return Z !== "#text" && (N[Z] = N[Z] || [], N[Z].push(U[Z])), N;
                }, {}));
                var H = new Ku(I, F, Y);
                return I === "add" && (H.position = y.pos), H;
              }).filter(function(w) {
                return !!w;
              }) : [];
            } }, r = (0, h.Z)(u).getInstance().getLogger(i), i;
          }
          Ds.__dashjs_factory_name = "PatchManifestModel";
          var zu = v.Z.getSingletonFactory(Ds);
          function Os() {
            var i, r, u, _, w, I, y, C = this.context;
            function F(D, O, A) {
              var oe, Q = r.getAdaptationsForType(_[0].mpd.manifest, D, O);
              if (!Q || Q.length === 0) return null;
              if (Q.length > 1 && A) {
                var ue = N(A, O);
                if (w[A.id] && w[A.id][O]) {
                  for (var ee = 0, k = Q.length; ee < k; ee++) if (Y(w[A.id][O], ue[ee])) return Q[ee];
                }
                for (var ne = 0, ve = Q.length; ne < ve; ne++) if (oe = Q[ne], r.getRolesForAdaptation(oe).filter(function(xe) {
                  return xe.value === e.Z.MAIN;
                })[0]) return Q[ne];
              }
              return Q[0];
            }
            function Y(D, O) {
              if (!D || !O) return !1;
              var A = D.id === O.id, oe = D.codec === O.codec, Q = D.viewpoint === O.viewpoint, ue = JSON.stringify(D.viewpointsWithSchemeIdUri) === JSON.stringify(O.viewpointsWithSchemeIdUri), ee = D.lang === O.lang, k = D.roles.toString() === O.roles.toString(), ne = JSON.stringify(D.rolesWithSchemeIdUri) === JSON.stringify(O.rolesWithSchemeIdUri), ve = D.accessibility.toString() === O.accessibility.toString(), xe = JSON.stringify(D.accessibilitiesWithSchemeIdUri) === JSON.stringify(O.accessibilitiesWithSchemeIdUri), Ne = D.audioChannelConfiguration.toString() === O.audioChannelConfiguration.toString(), Fe = JSON.stringify(D.audioChannelConfigurationsWithSchemeIdUri) === JSON.stringify(O.audioChannelConfigurationsWithSchemeIdUri);
              return A && oe && Q && ue && ee && k && ne && ve && xe && Ne && Fe;
            }
            function H(D, O, A, oe, Q, ue) {
              var ee, k, ne, ve, xe, Ne, Fe = [];
              if (!oe || oe.length === 0) return [];
              var Le = r.getAdaptationsForPeriod(O);
              for (ve = 0, Ne = oe.length; ve < Ne; ve++) if (ee = oe[ve], k = q(Le[ne = r.getIndexForAdaptation(ee, D, A.index)]), ue) {
                var ut = k.accessibility.length;
                for (xe = 0; xe < ut; xe++) if (k) {
                  var ct = k.accessibility[xe];
                  if (ct.indexOf("cea-608:") === 0) {
                    var nt = ct.substring(8).split(";");
                    if (nt[0].substring(0, 2) === "CC") for (xe = 0; xe < nt.length; xe++) k || (k = q.call(this, Le[ne])), le(k, nt[xe].substring(0, 3), nt[xe].substring(4)), Fe.push(k), k = null;
                    else for (xe = 0; xe < nt.length; xe++) k || (k = q.call(this, Le[ne])), le(k, "CC" + (xe + 1), nt[xe]), Fe.push(k), k = null;
                  } else ct.indexOf("cea-608") === 0 && (le(k, I.CC1, "eng"), Fe.push(k), k = null);
                }
              } else Q === I.IMAGE ? (k.type = I.IMAGE, Fe.push(k), k = null) : k && Fe.push(k);
              return Fe;
            }
            function N(D, O, A) {
              var oe = _, Q = A, ue = [];
              if (Q) de(), oe = U(Q);
              else {
                if (!(_.length > 0)) return ue;
                Q = _[0].mpd.manifest;
              }
              var ee = _e(D, oe), k = r.getAdaptationsForType(Q, D ? D.index : null, O);
              return ue = H(Q, ee, D, k, O), O === I.TEXT && (k = r.getAdaptationsForType(Q, D ? D.index : null, I.VIDEO), ue = ue.concat(H(Q, ee, D, k, O, !0))), ue;
            }
            function U(D) {
              var O = Z(D);
              return r.getRegularPeriods(O);
            }
            function Z(D) {
              var O = ae(D);
              return r.getMpd(O);
            }
            function me() {
              _ = [], w = {};
            }
            function ae(D) {
              return D || (_.length > 0 ? _[0].mpd.manifest : null);
            }
            function fe(D) {
              try {
                var O = _e(D.streamInfo, _), A = r.getAdaptationsForPeriod(O);
                return D && D.streamInfo && D.streamInfo.id !== void 0 && A ? A[D.index] : null;
              } catch {
                return null;
              }
            }
            function _e(D, O) {
              for (var A = O.length, oe = 0; oe < A; oe++) {
                var Q = O[oe];
                if (D && D.id === Q.id) return Q;
              }
              return null;
            }
            function q(D) {
              if (!D) return null;
              var O, A, oe, Q, ue, ee = new io(), k = D.period.mpd.manifest.Period_asArray[D.period.index].AdaptationSet_asArray[D.index];
              if (ee.id = D.id, ee.index = D.index, ee.type = D.type, ee.streamInfo = K(D.period), ee.representationCount = r.getRepresentationCount(k), ee.labels = r.getLabelsForAdaptation(k), ee.lang = r.getLanguageForAdaptation(k), ee.segmentAlignment = r.getSegmentAlignment(k), ee.subSegmentAlignment = r.getSubSegmentAlignment(k), O = r.getViewpointForAdaptation(k), ee.viewpoint = O.length ? O[0].value : void 0, ee.viewpointsWithSchemeIdUri = O, ue = r.getAccessibilityForAdaptation(k), ee.accessibility = ue.map(function(Fe) {
                var Le = Fe.value, ut = Le;
                return Fe.schemeIdUri && Fe.schemeIdUri.search("cea-608") >= 0 && y !== void 0 && (ut = Le ? "cea-608:" + Le : "cea-608", ee.embeddedCaptions = !0), ut;
              }), ee.accessibilitiesWithSchemeIdUri = ue, A = r.getAudioChannelConfigurationForAdaptation(k), ee.audioChannelConfiguration = A.map(function(Fe) {
                return Fe.value;
              }), ee.audioChannelConfigurationsWithSchemeIdUri = A, ee.audioChannelConfiguration.length === 0 && Array.isArray(k.Representation_asArray) && k.Representation_asArray.length > 0 && (oe = r.getAudioChannelConfigurationForRepresentation(k.Representation_asArray[0]), ee.audioChannelConfiguration = oe.map(function(Fe) {
                return Fe.value;
              }), ee.audioChannelConfigurationsWithSchemeIdUri = oe), Q = r.getRolesForAdaptation(k), ee.roles = Q.map(function(Fe) {
                return Fe.value;
              }), ee.rolesWithSchemeIdUri = Q, ee.codec = r.getCodec(k), ee.mimeType = r.getMimeType(k), ee.contentProtection = r.getContentProtectionData(k), ee.bitrateList = r.getBitrateListForAdaptation(k), ee.selectionPriority = r.getSelectionPriority(k), ee.contentProtection) {
                var ne = ee.contentProtection.map(function(Fe) {
                  return r.getKID(Fe);
                }).filter(function(Fe) {
                  return Fe !== null;
                });
                if (ne.length) {
                  var ve = ne[0];
                  ee.contentProtection.forEach(function(Fe) {
                    Fe.keyId = ve;
                  });
                }
              }
              if (ee.isText = r.getIsText(k), ee.supplementalProperties = r.getSupplementalPropertiesForAdaptation(k), (!ee.supplementalProperties || Object.keys(ee.supplementalProperties).length === 0) && Array.isArray(k.Representation_asArray) && k.Representation_asArray.length > 0) {
                var xe = k.Representation_asArray.map(function(Fe) {
                  return r.getSupplementalPropertiesForRepresentation(Fe);
                });
                xe.every(function(Fe) {
                  return JSON.stringify(Fe) === JSON.stringify(xe[0]);
                }) && (ee.supplementalProperties = xe[0]);
              }
              if (ee.supplementalPropertiesAsArray = r.getSupplementalPropertiesAsArrayForAdaptation(k), (!ee.supplementalPropertiesAsArray || ee.supplementalPropertiesAsArray.length === 0) && Array.isArray(k.Representation_asArray) && k.Representation_asArray.length > 0) {
                var Ne = k.Representation_asArray.map(function(Fe) {
                  return r.getSupplementalPropertiesAsArrayForRepresentation(Fe);
                });
                Ne.every(function(Fe) {
                  return JSON.stringify(Fe) === JSON.stringify(Ne[0]);
                }) && (ee.supplementalPropertiesAsArray = Ne[0]);
              }
              return ee.essentialProperties = r.getEssentialPropertiesForAdaptation(k), ee.essentialPropertiesAsArray = r.getEssentialPropertiesAsArrayForAdaptation(k), ee.isFragmented = r.getIsFragmented(k), ee.isEmbedded = !1, ee;
            }
            function le(D, O, A) {
              D.id = O, D.index = 100 + parseInt(O.substring(2, 3)), D.type = I.TEXT, D.codec = "cea-608-in-SEI", D.isEmbedded = !0, D.isFragmented = !1;
              var oe = Yi()(A);
              D.lang = oe || A, D.roles = ["caption"], D.rolesWithSchemeIdUri = [{ schemeIdUri: "urn:mpeg:dash:role:2011", value: "caption" }];
            }
            function K(D) {
              var O, A, oe = new Ns();
              return oe.id = D.id, oe.index = D.index, oe.start = D.start, oe.duration = D.duration, oe.manifestInfo = (O = D.mpd, (A = new qu()).dvrWindowSize = O.timeShiftBufferDepth, A.loadedTime = O.manifest.loadedTime, A.availableFrom = O.availabilityStartTime, A.minBufferTime = O.manifest.minBufferTime, A.maxFragmentDuration = O.maxSegmentDuration, A.duration = r.getDuration(O.manifest), A.isDynamic = r.getIsDynamic(O.manifest), A.serviceDescriptions = r.getServiceDescriptions(O.manifest), A.protocol = O.manifest.protocol, A), oe.isLast = D.mpd.manifest.Period_asArray.length === 1 || Math.abs(oe.start + oe.duration - oe.manifestInfo.duration) < 1, oe;
            }
            function de() {
              if (!I) throw new Error("setConfig function has to be called previously");
            }
            function g(D) {
              return _.length > 0 ? _[0].mpd.manifest.Period_asArray[D] : null;
            }
            function L(D, O, A) {
              var oe, Q, ue, ee, k;
              if (D) {
                for (oe = D.AdaptationSet_asArray, ee = 0; ee < oe.length; ee += 1) for (ue = oe[ee].Representation_asArray, k = 0; k < ue.length; k += 1) if (O === (Q = ue[k]).id) return A ? k : Q;
              }
              return null;
            }
            return i = { getBandwidthForRepresentation: function(D, O) {
              var A;
              return (A = L(g(O), D)) ? A.bandwidth : null;
            }, getIndexForRepresentation: function(D, O) {
              return function(A, oe) {
                var Q = L(A, oe, !0);
                return Q !== null ? Q : -1;
              }(g(O), D);
            }, getMaxIndexForBufferType: function(D, O) {
              return function(A, oe) {
                var Q, ue, ee, k;
                if (!A || !oe) return -1;
                for (ue = A.AdaptationSet_asArray, k = 0; k < ue.length; k += 1) if (ee = (Q = ue[k]).Representation_asArray, r.getIsTypeOf(Q, oe)) return ee.length;
                return -1;
              }(g(O), D);
            }, convertRepresentationToRepresentationInfo: function(D) {
              if (D) {
                var O = new Cs(), A = D.adaptation.period.mpd.manifest.Period_asArray[D.adaptation.period.index].AdaptationSet_asArray[D.adaptation.index], oe = r.getRepresentationFor(D.index, A);
                return O.id = D.id, O.quality = D.index, O.bandwidth = r.getBandwidth(oe), O.fragmentDuration = D.segmentDuration || (D.segments && D.segments.length > 0 ? D.segments[0].duration : NaN), O.MSETimeOffset = D.MSETimeOffset, O.mediaInfo = q(D.adaptation), O;
              }
              return null;
            }, getStreamsInfo: function(D, O) {
              var A = [], oe = _;
              if (D && (de(), oe = U(D)), oe.length > 0) {
                (!O || O > oe.length) && (O = oe.length);
                for (var Q = 0; Q < O; Q++) A.push(K(oe[Q]));
              }
              return A;
            }, getMediaInfoForType: function(D, O) {
              if (_.length === 0 || !D) return null;
              var A = _e(D, _);
              if (!A) return null;
              var oe = r.getAdaptationsForPeriod(A), Q = F(D.index, O, D);
              return Q ? q(oe[r.getIndexForAdaptation(Q, _[0].mpd.manifest, D.index)]) : null;
            }, getAllMediaInfoForType: N, getAdaptationForType: F, getRealAdaptation: function(D, O) {
              var A, oe, Q = _e(D, _);
              return A = O ? O.id : null, _.length > 0 && Q && (oe = A ? r.getAdaptationForId(A, _[0].mpd.manifest, Q.index) : r.getAdaptationForIndex(O ? O.index : null, _[0].mpd.manifest, Q.index)), oe;
            }, getProducerReferenceTimes: function(D, O) {
              var A, oe, Q = _e(D, _);
              return A = O ? O.id : null, _.length > 0 && Q && (oe = A ? r.getAdaptationForId(A, _[0].mpd.manifest, Q.index) : r.getAdaptationForIndex(O ? O.index : null, _[0].mpd.manifest, Q.index)), oe ? r.getProducerReferenceTimesForAdaptation(oe) : [];
            }, getRealPeriodByIndex: function(D) {
              return r.getRealPeriodForIndex(D, _[0].mpd.manifest);
            }, getEssentialPropertiesForRepresentation: function(D) {
              try {
                return r.getEssentialPropertiesForRepresentation(D);
              } catch {
                return [];
              }
            }, getVoRepresentations: function(D) {
              var O = fe(D);
              return r.getRepresentationsForAdaptation(O);
            }, getEventsFor: function(D, O, A) {
              var oe = [];
              if (_.length > 0) {
                var Q = _[0].mpd.manifest;
                if (D instanceof Ns) {
                  var ue = _e(D, _);
                  oe = r.getEventsForPeriod(ue);
                } else if (D instanceof io) {
                  var ee = _e(A, _);
                  oe = r.getEventStreamForAdaptationSet(Q, fe(D), ee);
                } else if (D instanceof Cs) {
                  var k = _e(A, _);
                  oe = r.getEventStreamForRepresentation(Q, O, k);
                }
              }
              return oe;
            }, getEvent: function(D, O, A, oe) {
              try {
                if (!D || !O || isNaN(A) || !oe) return null;
                var Q = D.scheme_id_uri, ue = D.value;
                if (!O[Q + "/" + ue]) return null;
                var ee, k = new sr(), ne = D.timescale || 1, ve = oe.adaptation.period.start, xe = O[Q + "/" + ue], Ne = isNaN(oe.presentationTimeOffset) ? isNaN(xe.presentationTimeOffset) ? 0 : xe.presentationTimeOffset : oe.presentationTimeOffset, Fe = D.presentation_time_delta / ne;
                ee = D.version === 0 ? ve + A - Ne + Fe : ve - Ne + Fe;
                var Le = D.event_duration / ne, ut = D.id, ct = D.message_data;
                return k.eventStream = xe, k.eventStream.value = ue, k.eventStream.timescale = ne, k.duration = Le, k.id = ut, k.calculatedPresentationTime = ee, k.messageData = ct, k.presentationTimeDelta = Fe, k;
              } catch {
                return null;
              }
            }, getMpd: Z, setConfig: function(D) {
              D && (D.constants && (I = D.constants), D.cea608parser && (y = D.cea608parser), D.errHandler && r.setConfig({ errHandler: D.errHandler }), D.BASE64 && r.setConfig({ BASE64: D.BASE64 }));
            }, updatePeriods: function(D) {
              if (!D) return null;
              de(), _ = U(D);
            }, getIsTextTrack: function(D) {
              return r.getIsText(D);
            }, getUTCTimingSources: function() {
              var D = ae();
              return r.getUTCTimingSources(D);
            }, getSuggestedPresentationDelay: function() {
              var D = _.length > 0 ? _[0].mpd : null;
              return r.getSuggestedPresentationDelay(D);
            }, getAvailabilityStartTime: function(D) {
              var O = Z(D);
              return r.getAvailabilityStartTime(O);
            }, getIsTypeOf: function(D, O) {
              return r.getIsTypeOf(D, O);
            }, getIsDynamic: function(D) {
              var O = ae(D);
              return r.getIsDynamic(O);
            }, getDuration: function(D) {
              var O = ae(D);
              return r.getDuration(O);
            }, getRegularPeriods: U, getContentSteering: function(D) {
              return r.getContentSteering(D);
            }, getLocation: function(D) {
              return r.getLocation(D);
            }, getPatchLocation: function(D) {
              var O = r.getPatchLocation(D), A = r.getPublishTime(D);
              return O && O.length !== 0 && A ? O.filter(function(oe) {
                return isNaN(oe.ttl) || A.getTime() + oe.ttl > (/* @__PURE__ */ new Date()).getTime();
              }) : [];
            }, getManifestUpdatePeriod: function(D) {
              var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              return r.getManifestUpdatePeriod(D, O);
            }, getPublishTime: function(D) {
              return r.getPublishTime(D);
            }, getIsDVB: function(D) {
              return r.hasProfile(D, "urn:dvb:dash:profile:dvb-dash:2014");
            }, getIsPatch: function(D) {
              return u.getIsPatch(D);
            }, getBaseURLsFromElement: function(D) {
              return r.getBaseURLsFromElement(D);
            }, getRepresentationSortFunction: function() {
              return r.getRepresentationSortFunction();
            }, getCodec: function(D, O, A) {
              return r.getCodec(D, O, A);
            }, getPeriodById: function(D) {
              if (!D || _.length === 0) return null;
              var O = _.filter(function(A) {
                return A.id === D;
              });
              return O && O.length > 0 ? O[0] : null;
            }, setCurrentMediaInfo: function(D, O, A) {
              w[D] = w[D] || {}, w[D][O] = w[D][O] || {}, w[D][O] = A;
            }, isPatchValid: function(D, O) {
              var A = r.getId(D), oe = u.getMpdId(O), Q = r.getPublishTime(D), ue = u.getPublishTime(O), ee = u.getOriginalPublishTime(O);
              return !!(A && oe && A == oe && Q && ee && Q.getTime() == ee.getTime() && ue && Q.getTime() < ue.getTime());
            }, applyPatchToManifest: function(D, O) {
              u.getPatchOperations(O).forEach(function(A) {
                var oe = A.getMpdTarget(D);
                if (oe !== null) {
                  var Q = oe.name, ue = oe.target, ee = oe.leaf;
                  if (A.xpath.findsAttribute() || Q === "__text") switch (A.action) {
                    case "add":
                    case "replace":
                      ue[Q] = A.value;
                      break;
                    case "remove":
                      delete ue[Q];
                  }
                  else {
                    var k = (ue[Q + "_asArray"] || []).indexOf(ee), ne = A.position === "prepend" || A.position === "before";
                    if ((A.action === "remove" || A.action === "replace") && (delete ue[Q], k != -1)) {
                      var ve = ue[Q + "_asArray"];
                      ve.splice(k, 1), ve.length > 1 ? ue[Q] = ve : ve.length == 1 ? ue[Q] = ve[0] : delete ue[Q + "_asArray"];
                    }
                    A.action !== "add" && A.action !== "replace" || Object.keys(A.value).forEach(function(xe) {
                      var Ne = A.value[xe], Fe = ue[xe + "_asArray"] || [];
                      if (Fe.length === 0 && ue[xe] && Fe.push(ue[xe]), Fe.length === 0) Fe = Ne;
                      else {
                        var Le = Fe.length;
                        Le = xe == Q && k != -1 ? k + (ne ? 0 : 1) + (A.action == "replace" ? -1 : 0) : ne ? 0 : Fe.length, Fe.splice.apply(Fe, [Le, 0].concat(Ne));
                      }
                      ue[xe + "_asArray"] = Fe, ue[xe] = Fe.length == 1 ? Fe[0] : Fe;
                    });
                  }
                }
              });
            }, areMediaInfosEqual: Y, reset: me }, r = ln(C).getInstance(), u = zu(C).getInstance(), me(), i;
          }
          Os.__dashjs_factory_name = "DashAdapter";
          var Wu = v.Z.getSingletonFactory(Os);
          function Qu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Xu = function() {
            function i() {
              (function(_, w) {
                if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, i);
            }
            var r, u;
            return r = i, u = [{ key: "round10", value: function(_, w) {
              return function(I, y, C) {
                return C === void 0 || +C == 0 ? Math[I](y) : (C = +C, (y = +y) === null || isNaN(y) || typeof C != "number" || C % 1 != 0 ? NaN : (y = y.toString().split("e"), +((y = (y = Math[I](+(y[0] + "e" + (y[1] ? +y[1] - C : -C)))).toString().split("e"))[0] + "e" + (y[1] ? +y[1] + C : C))));
              }("round", _, w);
            } }], u && Qu(r, u), i;
          }(), $u = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.TcpList = [], this.HttpList = [], this.RepSwitchList = [], this.BufferLevel = [], this.BufferState = [], this.PlayList = [], this.DroppedFrames = [], this.SchedulingInfo = [], this.DVRInfo = [], this.ManifestUpdate = [], this.RequestsQueue = null, this.DVBErrors = [];
          }, Ju = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.mt = null, this.to = null, this.lto = null;
          }, ec = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.level = null;
          }, tc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.target = null, this.state = m.Z.BUFFER_EMPTY;
          }, nc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.time = null, this.range = null, this.manifestInfo = null;
          }, rc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.time = null, this.droppedFrames = null;
          };
          function ao(i, r) {
            if (!(i instanceof r)) throw new TypeError("Cannot call a class as a function");
          }
          var ic = function i() {
            ao(this, i), this.mediaType = null, this.type = null, this.requestTime = null, this.fetchTime = null, this.availabilityStartTime = null, this.presentationStartTime = 0, this.clientTimeOffset = 0, this.currentTime = null, this.buffered = null, this.latency = 0, this.streamInfo = [], this.representationInfo = [];
          }, ac = function i() {
            ao(this, i), this.id = null, this.index = null, this.start = null, this.duration = null;
          }, oc = function i() {
            ao(this, i), this.id = null, this.index = null, this.mediaType = null, this.streamIndex = null, this.presentationTimeOffset = null, this.startNumber = null, this.fragmentInfoType = null;
          }, sc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.mediaType = null, this.t = null, this.type = null, this.startTime = null, this.availabilityStartTime = null, this.duration = null, this.quality = null, this.range = null, this.state = null;
          }, lc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.loadingRequests = [], this.executedRequests = [];
          };
          function Ms(i) {
            var r, u, _ = (i = i || {}).settings, w = this.context, I = (0, p.Z)(w).getInstance();
            function y() {
              I.trigger(l.Z.METRICS_CHANGED);
            }
            function C(Z) {
              I.trigger(l.Z.METRIC_CHANGED, { mediaType: Z }), y();
            }
            function F(Z, me, ae) {
              I.trigger(l.Z.METRIC_UPDATED, { mediaType: Z, metric: me, value: ae }), C(Z);
            }
            function Y(Z, me, ae) {
              I.trigger(l.Z.METRIC_ADDED, { mediaType: Z, metric: me, value: ae }), C(Z);
            }
            function H(Z, me) {
              var ae = null;
              return Z && (u.hasOwnProperty(Z) ? ae = u[Z] : me || (ae = new $u(), u[Z] = ae)), ae;
            }
            function N(Z, me, ae) {
              var fe = H(Z);
              fe !== null && (fe[me].push(ae), fe[me].length > _.get().streaming.metrics.maxListDepth && fe[me].shift());
            }
            function U(Z, me, ae) {
              N(Z, me, ae), Y(Z, me, ae);
            }
            return r = { clearCurrentMetricsForType: function(Z) {
              delete u[Z], C(Z);
            }, clearAllCurrentMetrics: function() {
              u = {}, y();
            }, getMetricsFor: H, addHttpRequest: function Z(me, ae, fe, _e, q, le, K, de, g, L, D, O, A, oe, Q, ue, ee) {
              var k = new Ge.w();
              le != null && le !== _e && (Z(me, null, fe, _e, q, null, null, de, g, null, null, null, A, null, null, ue, ee), k.actualurl = le), k.tcpid = ae, k.type = fe, k.url = _e, k.range = de, k.trequest = g, k.tresponse = L, k.responsecode = O, k.cmsd = ee, k._tfinish = D, k._stream = me, k._mediaduration = A, k._quality = q, k._responseHeaders = oe, k._serviceLocation = K, k._fileLoaderType = ue, Q ? Q.forEach(function(ne) {
                (function(ve, xe, Ne, Fe) {
                  var Le = new Ge.O();
                  Le.s = xe, Le.d = Ne, Le.b = Fe, ve.trace.push(Le), ve.interval || (ve.interval = 0), ve.interval += Ne;
                })(k, ne.s, ne.d, ne.b);
              }) : (delete k.interval, delete k.trace), U(me, m.Z.HTTP_REQUEST, k);
            }, addRepresentationSwitch: function(Z, me, ae, fe, _e) {
              var q = new Ju();
              q.t = me, q.mt = ae, q.to = fe, _e ? q.lto = _e : delete q.lto, U(Z, m.Z.TRACK_SWITCH, q);
            }, addBufferLevel: function(Z, me, ae) {
              var fe = new ec();
              fe.t = me, fe.level = ae, U(Z, m.Z.BUFFER_LEVEL, fe);
            }, addBufferState: function(Z, me, ae) {
              var fe = new tc();
              fe.target = ae, fe.state = me, U(Z, m.Z.BUFFER_STATE, fe);
            }, addDVRInfo: function(Z, me, ae, fe) {
              var _e = new nc();
              _e.time = me, _e.range = fe, _e.manifestInfo = ae, U(Z, m.Z.DVR_INFO, _e);
            }, addDroppedFrames: function(Z, me) {
              var ae = new rc(), fe = H(Z).DroppedFrames;
              me && (ae.time = me.creationTime, ae.droppedFrames = me.droppedVideoFrames, fe.length > 0 && fe[fe.length - 1] == ae || U(Z, m.Z.DROPPED_FRAMES, ae));
            }, addSchedulingInfo: function(Z, me, ae, fe, _e, q, le, K, de) {
              var g = new sc();
              g.mediaType = Z, g.t = me, g.type = ae, g.startTime = fe, g.availabilityStartTime = _e, g.duration = q, g.quality = le, g.range = K, g.state = de, U(Z, m.Z.SCHEDULING_INFO, g);
            }, addRequestsQueue: function(Z, me, ae) {
              var fe = new lc();
              fe.loadingRequests = me, fe.executedRequests = ae, H(Z).RequestsQueue = fe, Y(Z, m.Z.REQUESTS_QUEUE, fe);
            }, addManifestUpdate: function(Z, me, ae, fe, _e, q, le, K, de, g) {
              var L = new ic();
              L.mediaType = Z, L.type = me, L.requestTime = ae, L.fetchTime = fe, L.availabilityStartTime = _e, L.presentationStartTime = q, L.clientTimeOffset = le, L.currentTime = K, L.buffered = de, L.latency = g, N(t.Z.STREAM, m.Z.MANIFEST_UPDATE, L), Y(Z, m.Z.MANIFEST_UPDATE, L);
            }, updateManifestUpdateInfo: function(Z, me) {
              if (Z) {
                for (var ae in me) Z[ae] = me[ae];
                F(Z.mediaType, m.Z.MANIFEST_UPDATE, Z);
              }
            }, addManifestUpdateStreamInfo: function(Z, me, ae, fe, _e) {
              if (Z) {
                var q = new ac();
                q.id = me, q.index = ae, q.start = fe, q.duration = _e, Z.streamInfo.push(q), F(Z.mediaType, m.Z.MANIFEST_UPDATE_STREAM_INFO, Z);
              }
            }, addManifestUpdateRepresentationInfo: function(Z, me, ae, fe, _e, q, le, K) {
              if (Z && Z.representationInfo) {
                var de = new oc();
                de.id = me, de.index = ae, de.streamIndex = fe, de.mediaType = _e, de.startNumber = le, de.fragmentInfoType = K, de.presentationTimeOffset = q, Z.representationInfo.push(de), F(Z.mediaType, m.Z.MANIFEST_UPDATE_TRACK_INFO, Z);
              }
            }, addPlayList: function(Z) {
              Z.trace && Array.isArray(Z.trace) ? Z.trace.forEach(function(me) {
                me.hasOwnProperty("subreplevel") && !me.subreplevel && delete me.subreplevel;
              }) : delete Z.trace, U(t.Z.STREAM, m.Z.PLAY_LIST, Z);
            }, addDVBErrors: function(Z) {
              U(t.Z.STREAM, m.Z.DVB_ERRORS, Z);
            } }, u = {}, r;
          }
          Ms.__dashjs_factory_name = "MetricsModel";
          var uc = v.Z.getSingletonFactory(Ms);
          function Ls(i) {
            i = i || {};
            var r, u, _, w, I = this.context, y = i.metricsModel;
            function C(H) {
              var N = y.getMetricsFor(H, !0);
              if (!N) return null;
              var U, Z = N.HttpList, me = null;
              if (!Z || Z.length <= 0) return null;
              for (U = Z.length - 1; U >= 0; ) {
                if (Z[U].responsecode) {
                  me = Z[U];
                  break;
                }
                U--;
              }
              return me;
            }
            function F(H) {
              var N = y.getMetricsFor(H, !0);
              return N && N.HttpList ? N.HttpList : [];
            }
            function Y(H, N) {
              if (!H) return null;
              var U = H[N];
              return U && U.length !== 0 ? U[U.length - 1] : null;
            }
            return r = { getCurrentRepresentationSwitch: function(H) {
              return Y(y.getMetricsFor(H, !0), m.Z.TRACK_SWITCH);
            }, getCurrentBufferState: function(H) {
              return Y(y.getMetricsFor(H, !0), m.Z.BUFFER_STATE);
            }, getCurrentBufferLevel: function(H) {
              var N = Y(y.getMetricsFor(H, !0), m.Z.BUFFER_LEVEL);
              return N ? Xu.round10(N.level / 1e3, -3) : 0;
            }, getCurrentHttpRequest: C, getHttpRequests: F, getCurrentDroppedFrames: function() {
              return Y(y.getMetricsFor(t.Z.VIDEO, !0), m.Z.DROPPED_FRAMES);
            }, getCurrentSchedulingInfo: function(H) {
              return Y(y.getMetricsFor(H, !0), m.Z.SCHEDULING_INFO);
            }, getCurrentDVRInfo: function(H) {
              return Y(H ? y.getMetricsFor(H, !0) : y.getMetricsFor(t.Z.VIDEO, !0) || y.getMetricsFor(t.Z.AUDIO, !0), m.Z.DVR_INFO);
            }, getCurrentManifestUpdate: function() {
              return Y(y.getMetricsFor(t.Z.STREAM), m.Z.MANIFEST_UPDATE);
            }, getLatestFragmentRequestHeaderValueByID: function(H, N) {
              if (!N) return null;
              var U = {}, Z = C(H);
              Z && (U = St.Z.parseHttpHeaders(Z._responseHeaders));
              var me = U[N.toLowerCase()];
              return me === void 0 ? null : me;
            }, getLatestMPDRequestHeaderValueByID: function(H) {
              if (!H) return null;
              var N, U, Z, me = {};
              for (Z = (N = F(t.Z.STREAM)).length - 1; Z >= 0; Z--) if ((U = N[Z]).type === Ge.w.MPD_TYPE) {
                me = St.Z.parseHttpHeaders(U._responseHeaders);
                break;
              }
              var ae = me[H.toLowerCase()];
              return ae === void 0 ? null : ae;
            }, addRepresentationSwitch: function(H, N, U, Z, me) {
              y.addRepresentationSwitch(H, N, U, Z, me);
            }, addDVRInfo: function(H, N, U, Z) {
              y.addDVRInfo(H, N, U, Z);
            }, updateManifestUpdateInfo: function(H) {
              var N = this.getCurrentManifestUpdate();
              y.updateManifestUpdateInfo(N, H);
            }, addManifestUpdateStreamInfo: function(H) {
              if (H) {
                var N = this.getCurrentManifestUpdate();
                y.addManifestUpdateStreamInfo(N, H.id, H.index, H.start, H.duration);
              }
            }, addManifestUpdateRepresentationInfo: function(H, N) {
              if (H) {
                var U = this.getCurrentManifestUpdate();
                y.addManifestUpdateRepresentationInfo(U, H.id, H.index, H.streamIndex, N, H.presentationTimeOffset, H.startNumber, H.fragmentInfoType);
              }
            }, addManifestUpdate: function(H) {
              y.addManifestUpdate(t.Z.STREAM, H.type, H.requestStartDate, H.requestEndDate);
            }, addHttpRequest: function(H, N, U, Z, me, ae) {
              y.addHttpRequest(H.mediaType, null, H.type, H.url, H.quality, N, H.serviceLocation || null, H.range || null, H.requestStartDate, H.firstByteDate, H.requestEndDate, U, H.duration, Z, me, H.fileLoaderType, ae);
            }, addSchedulingInfo: function(H, N) {
              y.addSchedulingInfo(H.mediaType, /* @__PURE__ */ new Date(), H.type, H.startTime, H.availabilityStartTime, H.duration, H.quality, H.range, N);
            }, addRequestsQueue: function(H, N, U) {
              y.addRequestsQueue(H, N, U);
            }, addBufferLevel: function(H, N, U) {
              y.addBufferLevel(H, N, U);
            }, addBufferState: function(H, N, U) {
              y.addBufferState(H, N, U);
            }, addDroppedFrames: function(H) {
              y.addDroppedFrames(t.Z.VIDEO, H);
            }, addPlayList: function() {
              w && (y.addPlayList(w), w = null);
            }, addDVBErrors: function(H) {
              y.addDVBErrors(H);
            }, createPlaylistMetrics: function(H, N) {
              (w = new ke()).start = /* @__PURE__ */ new Date(), w.mstart = H, w.starttype = N;
            }, createPlaylistTraceMetrics: function(H, N, U) {
              u === !0 && (u = !1, (_ = new Oe()).representationid = H, _.start = /* @__PURE__ */ new Date(), _.mstart = N, _.playbackspeed = U !== null ? U.toString() : null);
            }, updatePlayListTraceMetrics: function(H) {
              if (_) for (var N in _) _[N] = H[N];
            }, pushPlayListTraceMetrics: function(H, N) {
              if (u === !1 && w && _ && _.start) {
                var U = _.start, Z = H.getTime() - U.getTime();
                _.duration = Z, _.stopreason = N, w.trace.push(_), u = !0;
              }
            }, clearAllCurrentMetrics: function() {
              y.clearAllCurrentMetrics();
            } }, y = y || uc(I).getInstance({ settings: i.settings }), u = !0, _ = null, w = null, r;
          }
          Ls.__dashjs_factory_name = "DashMetrics";
          var cc = v.Z.getSingletonFactory(Ls);
          function Ps() {
            var i, r, u, _, w = this.context, I = (0, p.Z)(w).getInstance(), y = (0, Me.Z)(w).getInstance();
            function C(_e) {
              _ = _e;
            }
            function F(_e, q, le, K) {
              var de, g = q.adaptation.period.mpd, L = g.availabilityStartTime;
              if (K) de = le && g.timeShiftBufferDepth !== Number.POSITIVE_INFINITY ? new Date(L.getTime() + 1e3 * (_e + g.timeShiftBufferDepth)) : g.availabilityEndTime;
              else if (le) {
                var D = q.availabilityTimeOffset;
                de = new Date(L.getTime() + 1e3 * (_e - D));
              } else de = L;
              return de;
            }
            function Y(_e, q) {
              return (_e.getTime() - q.mpd.availabilityStartTime.getTime() + 1e3 * _) / 1e3;
            }
            function H(_e, q) {
              return _e + (q.adaptation.period.start - q.presentationTimeOffset);
            }
            function N(_e) {
              var q = { start: NaN, end: NaN }, le = _e[0].getAdapter().getRegularPeriods()[0], K = Y(/* @__PURE__ */ new Date(), le);
              if (!_e || _e.length === 0) return { range: q, now: K };
              _e.forEach(function(g) {
                var L = g.getAdapter(), D = L.getMediaInfoForType(g.getStreamInfo(), t.Z.VIDEO) || L.getMediaInfoForType(g.getStreamInfo(), t.Z.AUDIO), O = L.getVoRepresentations(D)[0], A = { start: NaN, end: NaN };
                if (O) if (O.segmentInfoType === e.Z.SEGMENT_TIMELINE) A = function(Q) {
                  var ue, ee, k, ne, ve = Q.adaptation.period.mpd.manifest.Period_asArray[Q.adaptation.period.index].AdaptationSet_asArray[Q.adaptation.index], xe = r.getRepresentationFor(Q.index, ve), Ne = xe.SegmentTemplate || xe.SegmentList, Fe = Ne.SegmentTimeline, Le = Ne.timescale, ut = Fe.S_asArray, ct = { start: 0, end: 0 }, nt = ut[0].t, rt = !isNaN(nt), Bt = rt ? nt : 0, we = 0;
                  for (rt && (ct.start = H(Bt / Le, Q)), k = 0, ne = ut.length; k < ne; k++) ee = 0, (ue = ut[k]).hasOwnProperty("r") && (ee = ue.r), we += ue.d * (1 + ee);
                  return ct.end = H((Bt + we) / Le, Q), ct;
                }(O);
                else {
                  var oe = O.adaptation.period;
                  A.start = oe.start, A.end = Math.max(K, oe.start + oe.duration);
                }
                !isNaN(A.start) && (isNaN(q.start) || q.start > A.start) && (q.start = A.start), !isNaN(A.end) && (isNaN(q.end) || q.end < A.end) && (q.end = A.end);
              }), q.end = Math.min(K, q.end);
              var de = Z(_e, q.end, !0);
              return q.end = isNaN(de) ? q.end : de, q.start = le && le.mpd && le.mpd.timeShiftBufferDepth && !isNaN(le.mpd.timeShiftBufferDepth) && !isNaN(q.end) ? Math.max(q.end - le.mpd.timeShiftBufferDepth, q.start) : q.start, q.start = Z(_e, q.start), { range: q, now: K };
            }
            function U(_e, q) {
              u = _e - q.end;
            }
            function Z(_e, q) {
              var le = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              try {
                for (var K = 0, de = !1, g = NaN; !de && K < _e.length; ) {
                  var L = _e[K].getStreamInfo();
                  L.start <= q && (!isFinite(L.duration) || L.start + L.duration >= q) ? (g = q, de = !0) : !le && L.start > q && (isNaN(g) || L.start < g) ? g = L.start : le && L.start + L.duration < q && (isNaN(g) || L.start + L.duration > g) && (g = L.start + L.duration), K += 1;
                }
                return g;
              } catch {
                return q;
              }
            }
            function me(_e) {
              _e.offset === void 0 || isNaN(_e.offset) || C(_e.offset / 1e3);
            }
            function ae() {
              _ = 0, u = 0;
            }
            function fe() {
              I.off(l.Z.UPDATE_TIME_SYNC_OFFSET, me, this), ae();
            }
            return i = { initialize: function() {
              ae(), I.on(l.Z.UPDATE_TIME_SYNC_OFFSET, me, this);
            }, getClientTimeOffset: function() {
              return _;
            }, setClientTimeOffset: C, getClientReferenceTime: function() {
              return Date.now() - 1e3 * u + 1e3 * _;
            }, calcAvailabilityStartTimeFromPresentationTime: function(_e, q, le) {
              return F(_e, q, le);
            }, calcAvailabilityEndTimeFromPresentationTime: function(_e, q, le) {
              return F(_e, q, le, !0);
            }, calcPresentationTimeFromWallTime: Y, calcPresentationTimeFromMediaTime: H, calcPeriodRelativeTimeFromMpdRelativeTime: function(_e, q) {
              return q - _e.adaptation.period.start;
            }, calcMediaTimeFromPresentationTime: function(_e, q) {
              return _e - q.adaptation.period.start + q.presentationTimeOffset;
            }, calcWallTimeForSegment: function(_e, q) {
              var le, K, de;
              return q && (le = _e.representation.adaptation.period.mpd.suggestedPresentationDelay, K = _e.presentationStartTime + le, de = new Date(_e.availabilityStartTime.getTime() + 1e3 * K)), de;
            }, calcTimeShiftBufferWindow: function(_e, q) {
              if (!q) return function(K) {
                var de = { start: NaN, end: NaN }, g = 0, L = NaN;
                return K.forEach(function(D) {
                  var O = D.getStreamInfo();
                  g += O.duration, (isNaN(L) || O.start < L) && (L = O.start);
                }), de.start = L, de.end = L + g, de;
              }(_e);
              if (y.get().streaming.timeShiftBuffer.calcFromSegmentTimeline) {
                var le = N(_e);
                return U(le.now, le.range), le.range;
              }
              return function(K) {
                var de = { start: NaN, end: NaN };
                if (!K || K.length === 0) return de;
                var g = K[0].getAdapter().getRegularPeriods()[0], L = Y(/* @__PURE__ */ new Date(), g), D = g.mpd.timeShiftBufferDepth, O = isNaN(D) ? 0 : L - D;
                if (de.start = Z(K, O), de.end = !isNaN(de.start) && L < de.start ? L : Z(K, L, !0), !isNaN(D) && de.end < L - D && (de.end = NaN), y.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline) {
                  var A = N(K);
                  if (A.range.end < de.start) return I.trigger(n.Z.CONFORMANCE_VIOLATION, { level: mi.LEVELS.WARNING, event: mi.EVENTS.INVALID_DVR_WINDOW }), U(A.now, A.range), A.range;
                }
                return de;
              }(_e);
            }, reset: fe }, r = ln(w).getInstance(), fe(), i;
          }
          Ps.__dashjs_factory_name = "TimelineConverter";
          var fc = v.Z.getSingletonFactory(Ps), oo = R(4593), ra = R(6934);
          function so(i) {
            return so = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, so(i);
          }
          function lo(i, r) {
            return lo = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, lo(i, r);
          }
          function dc(i, r) {
            return !r || so(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function ia(i) {
            return ia = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ia(i);
          }
          var gc = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), lo(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ia(r);
              if (u) {
                var C = ia(this).constructor;
                I = Reflect.construct(y, arguments, C);
              } else I = y.apply(this, arguments);
              return dc(this, I);
            });
            function w() {
              var I;
              return function(y, C) {
                if (!(y instanceof C)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (I = _.call(this)).captionData = null, I.label = null, I.defaultTrack = !1, I.kind = null, I.isFragmented = !1, I.isEmbedded = !1, I.isTTML = null, I;
            }
            return w;
          }(io), hc = R(2295);
          function xs() {
            var i = 0;
            function r(C) {
              for (var F = "", Y = 0; Y < C.length; ++Y) F += C[Y].uchar;
              return F.length - F.replace(/^\s+/, "").length;
            }
            function u(C) {
              return "left: " + 3.125 * C.x + "%; top: " + 6.66 * C.y1 + "%; width: " + (100 - 3.125 * C.x) + "%; height: " + 6.66 * Math.max(C.y2 - 1 - C.y1, 1) + "%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;";
            }
            function _(C) {
              return C === "red" ? "rgb(255, 0, 0)" : C === "green" ? "rgb(0, 255, 0)" : C === "blue" ? "rgb(0, 0, 255)" : C === "cyan" ? "rgb(0, 255, 255)" : C === "magenta" ? "rgb(255, 0, 255)" : C === "yellow" ? "rgb(255, 255, 0)" : C === "white" ? "rgb(255, 255, 255)" : C === "black" ? "rgb(0, 0, 0)" : C;
            }
            function w(C, F) {
              var Y = C.videoHeight / 15;
              return F ? "font-size: " + Y + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; color: " + (F.foreground ? _(F.foreground) : "rgb(255, 255, 255)") + "; font-style: " + (F.italics ? "italic" : "normal") + "; text-decoration: " + (F.underline ? "underline" : "none") + "; white-space: pre; background-color: " + (F.background ? _(F.background) : "transparent") + ";" : "font-size: " + Y + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;";
            }
            function I(C) {
              return C.replace(/^\s+/g, "");
            }
            function y(C) {
              return C.replace(/\s+$/g, "");
            }
            return { createHTMLCaptionsFromScreen: function(C, F, Y, H) {
              var N, U, Z = null, me = !1, ae = -1, fe = { start: F, end: Y, spans: [] }, _e = "style_cea608_white_black", q = {}, le = {}, K = [];
              for (N = 0; N < 15; ++N) {
                var de = H.rows[N], g = "", L = null;
                if (de.isEmpty() === !1) {
                  var D = r(de.chars);
                  Z === null && (Z = { x: D, y1: N, y2: N + 1, p: [] }), D !== ae && me && (Z.p.push(fe), fe = { start: F, end: Y, spans: [] }, Z.y2 = N, Z.name = "region_" + Z.x + "_" + Z.y1 + "_" + Z.y2, q.hasOwnProperty(Z.name) === !1 ? (K.push(Z), q[Z.name] = Z) : q[Z.name].p.contat(Z.p), Z = { x: D, y1: N, y2: N + 1, p: [] });
                  for (var O = 0; O < de.chars.length; ++O) {
                    var A = de.chars[O], oe = A.penState;
                    if (L === null || !oe.equals(L)) {
                      g.trim().length > 0 && (fe.spans.push({ name: _e, line: g, row: N }), g = "");
                      var Q = "style_cea608_" + oe.foreground + "_" + oe.background;
                      oe.underline && (Q += "_underline"), oe.italics && (Q += "_italics"), le.hasOwnProperty(Q) || (le[Q] = JSON.parse(JSON.stringify(oe))), L = oe, _e = Q;
                    }
                    g += A.uchar;
                  }
                  g.trim().length > 0 && fe.spans.push({ name: _e, line: g, row: N }), me = !0, ae = D;
                } else me = !1, ae = -1, Z && (Z.p.push(fe), fe = { start: F, end: Y, spans: [] }, Z.y2 = N, Z.name = "region_" + Z.x + "_" + Z.y1 + "_" + Z.y2, q.hasOwnProperty(Z.name) === !1 ? (K.push(Z), q[Z.name] = Z) : q[Z.name].p.contat(Z.p), Z = null);
              }
              Z && (Z.p.push(fe), Z.y2 = N + 1, Z.name = "region_" + Z.x + "_" + Z.y1 + "_" + Z.y2, q.hasOwnProperty(Z.name) === !1 ? (K.push(Z), q[Z.name] = Z) : q[Z.name].p.contat(Z.p), Z = null);
              var ue = [];
              for (N = 0; N < K.length; ++N) {
                var ee = K[N], k = "sub_cea608_" + i++, ne = document.createElement("div");
                ne.id = k;
                var ve = u(ee);
                ne.style.cssText = "position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;" + ve;
                var xe = document.createElement("div");
                xe.className = "paragraph bodyStyle", xe.style.cssText = w(C);
                var Ne = document.createElement("div");
                Ne.className = "cueUniWrapper", Ne.style.cssText = "unicode-bidi: normal; direction: ltr;";
                for (var Fe = 0; Fe < ee.p.length; ++Fe) {
                  var Le = ee.p[Fe], ut = 0;
                  for (U = 0; U < Le.spans.length; ++U) {
                    var ct = Le.spans[U];
                    if (ct.line.length > 0) {
                      if (U !== 0 && ut != ct.row) {
                        var nt = document.createElement("br");
                        nt.className = "lineBreak", Ne.appendChild(nt);
                      }
                      var rt = !1;
                      ut === ct.row && (rt = !0), ut = ct.row;
                      var Bt = le[ct.name], we = document.createElement("span");
                      we.className = "spanPadding " + ct.name + " customSpanColor", we.style.cssText = w(C, Bt), U !== 0 && rt ? U === Le.spans.length - 1 ? we.textContent = y(ct.line) : we.textContent = ct.line : Le.spans.length > 1 && U < Le.spans.length - 1 && ct.row === Le.spans[U + 1].row ? we.textContent = I(ct.line) : we.textContent = ct.line.trim(), Ne.appendChild(we);
                    }
                  }
                }
                xe.appendChild(Ne), ne.appendChild(xe);
                var He = { bodyStyle: ["%", 90] };
                for (var pt in le) le.hasOwnProperty(pt) && (He[pt] = ["%", 90]);
                ue.push({ type: "html", start: F, end: Y, cueHTMLElement: ne, cueID: k, cellResolution: [32, 15], isFromCEA608: !0, fontSize: He, lineHeight: {}, linePadding: {} });
              }
              return ue;
            } };
          }
          xs.__dashjs_factory_name = "EmbeddedTextHtmlRender";
          var mc = v.Z.getSingletonFactory(xs);
          function Fs(i) {
            var r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q = i.errHandler, le = i.manifestModel, K = i.mediaController, de = i.videoModel, g = i.textTracks, L = i.vttParser, D = i.vttCustomRenderingParser, O = i.ttmlParser, A = i.streamInfo, oe = i.settings, Q = this.context, ue = (0, p.Z)(Q).getInstance(), ee = !1;
            function k() {
              y = null, F = NaN, Y = [], H = null, C = !1, I = [], w = null;
            }
            function ne(nt) {
              var rt = new gc();
              for (var Bt in nt) rt[Bt] = nt[Bt];
              rt.labels = nt.labels, rt.defaultTrack = function(we) {
                var He = !1;
                return U.length > 1 && we.isEmbedded ? He = we.id && we.id === t.Z.CC1 : U.length === 1 ? we.id && typeof we.id == "string" && we.id.substring(0, 2) === "CC" && (He = !0) : U.length === 0 && (He = we.index === I[0].index), He;
              }(nt), rt.isFragmented = nt.isFragmented, rt.isEmbedded = !!nt.isEmbedded, rt.isTTML = function(we) {
                return we.codec && we.codec.search(t.Z.STPP) >= 0 || we.mimeType && we.mimeType.search(t.Z.TTML) >= 0;
              }(nt), rt.kind = function(we, He) {
                var pt = we.roles && we.roles.length > 0 ? He[we.roles[0]] : He.caption;
                return pt = pt === He.caption || pt === He.subtitle ? pt : He.caption;
              }(nt, { subtitle: "subtitles", caption: "captions" }), g.addTextTrack(rt);
            }
            function ve(nt) {
              var rt = nt.chunk;
              rt.mediaInfo.embeddedCaptions && Ne(rt.bytes, rt);
            }
            function xe(nt) {
              N = nt;
            }
            function Ne(nt, rt) {
              var Bt = rt.mediaInfo, we = Bt.type, He = Bt.mimeType, pt = Bt.codec || He;
              pt ? Bt.codec.indexOf("application/mp4") !== -1 ? function(We, Tt, vt) {
                var ht;
                if (Tt.segmentType === "InitializationSegment") C = !0, F = _.getMediaTimescaleFromMoov(We);
                else {
                  if (!C) return;
                  (ht = _.getSamplesInfo(We).sampleList).length > 0 && (H = ht[0].cts - Tt.start * F), vt.search(t.Z.STPP) >= 0 ? function(Wt, zt, gn) {
                    var pn, Ke;
                    for (w = w !== null ? w : ut(gn), pn = 0; pn < zt.length; pn++) {
                      var Et = zt[pn], lt = Et.cts, Rt = Le(), Pt = Rt + lt / F, $t = Pt + Et.duration / F;
                      r.buffered.add(Pt, $t);
                      var Qt = new DataView(Wt, Et.offset, Et.subSizes[0]), en = ra.Utils.dataViewToString(Qt, t.Z.UTF8), sn = [], mt = Et.offset + Et.subSizes[0];
                      for (Ke = 1; Ke < Et.subSizes.length; Ke++) {
                        var kt = new Uint8Array(Wt, mt, Et.subSizes[Ke]), qt = String.fromCharCode.apply(null, kt);
                        sn.push(qt), mt += Et.subSizes[Ke];
                      }
                      try {
                        var Vt = le.getValue().ttmlTimeIsRelative ? lt / F : 0, Xt = w.parse(en, Vt, lt / F, (lt + Et.duration) / F, sn);
                        g.addCaptions(N, Rt, Xt);
                      } catch (ze) {
                        y.removeExecutedRequestsBeforeTime(), this.remove(), u.error("TTML parser error: " + ze.message);
                      }
                    }
                  }(We, ht, vt) : function(Wt, zt) {
                    var gn, pn, Ke, Et = [];
                    for (gn = 0; gn < zt.length; gn++) {
                      var lt = zt[gn];
                      lt.cts -= H;
                      var Rt = Le() + lt.cts / F, Pt = Rt + lt.duration / F;
                      r.buffered.add(Rt, Pt);
                      var $t = Wt.slice(lt.offset, lt.offset + lt.size), Qt = ra.parseBuffer($t);
                      for (pn = 0; pn < Qt.boxes.length; pn++) {
                        var en = Qt.boxes[pn];
                        if (u.debug("VTT box1: " + en.type), en.type !== "vtte" && en.type === "vttc") {
                          u.debug("VTT vttc boxes.length = " + en.boxes.length);
                          var sn = { styles: {} };
                          for (Ke = 0; Ke < en.boxes.length; Ke++) {
                            var mt = en.boxes[Ke];
                            if (u.debug("VTT box2: " + mt.type), mt.type === "payl") sn.start = lt.cts / F, sn.end = (lt.cts + lt.duration) / F, sn.data = mt.cue_text;
                            else if (mt.type === "sttg" && mt.settings && mt.settings !== "") try {
                              var kt = mt.settings.split(" ");
                              sn.styles = L.getCaptionStyles(kt);
                            } catch {
                            }
                          }
                          sn && sn.data && (Et.push(sn), u.debug("VTT  ".concat(sn.start, " - ").concat(sn.end, " :  ").concat(sn.data)));
                        }
                      }
                    }
                    Et.length > 0 && g.addCaptions(N, 0, Et);
                  }(We, ht);
                }
              }(nt, rt, pt) : we === t.Z.VIDEO ? function(We, Tt) {
                var vt, ht;
                if (Tt.segmentType === Ge.w.INIT_SEGMENT_TYPE) Z === 0 && (Z = _.getMediaTimescaleFromMoov(We));
                else if (Tt.segmentType === Ge.w.MEDIA_SEGMENT_TYPE) {
                  if (Z === 0) return void u.warn("CEA-608: No timescale for embeddedTextTrack yet");
                  var Wt = (ht = _.getSamplesInfo(We)).lastSequenceNumber, zt = Math.trunc(Tt.start), gn = Math.trunc(Tt.end);
                  if (fe[0] || fe[1] || function() {
                    for (var Rt, Pt = 0; Pt < U.length; Pt++) {
                      if ((Rt = g.getTrackIdxForId(U[Pt].id)) === -1) return void u.warn("CEA-608: data before track is ready.");
                      var $t = Fe(Rt);
                      fe[Pt] = new (E()).Cea608Parser(Pt + 1, { newCue: $t }, null);
                    }
                  }(), Z) {
                    if (function(Rt, Pt, $t, Qt, en) {
                      return Rt !== null && Pt !== null && Qt !== null && en !== null && (Pt === Rt ? Qt !== en : Pt !== Rt + $t);
                    }(me, Wt, ht.numSequences, ae, zt)) for (vt = 0; vt < fe.length; vt++) fe[vt] && fe[vt].reset();
                    for (var pn = function(Rt, Pt) {
                      if (Pt.length === 0) return null;
                      for (var $t = { splits: [], fields: [[], []] }, Qt = new DataView(Rt), en = 0; en < Pt.length; en++) for (var sn = Pt[en], mt = E().findCea608Nalus(Qt, sn.offset, sn.size), kt = null, qt = 0, Vt = 0; Vt < mt.length; Vt++) for (var Xt = E().extractCea608DataFromRange(Qt, mt[Vt]), ze = 0; ze < 2; ze++) if (Xt[ze].length > 0) {
                        sn.cts !== kt ? qt = 0 : qt += 1;
                        var Pe = Le();
                        $t.fields[ze].push([sn.cts + Pe * Z, Xt[ze], qt]), kt = sn.cts;
                      }
                      return $t.fields.forEach(function(ft) {
                        ft.sort(function(pe, be) {
                          return pe[0] === be[0] ? pe[2] - be[2] : pe[0] - be[0];
                        });
                      }), $t;
                    }(We, ht.sampleList), Ke = 0; Ke < fe.length; Ke++) {
                      var Et = pn.fields[Ke], lt = fe[Ke];
                      if (lt) for (vt = 0; vt < Et.length; vt++) lt.addData(Et[vt][0] / Z, Et[vt][1]);
                    }
                    me = Wt, ae = gn;
                  }
                }
              }(nt, rt) : function(We, Tt, vt) {
                var ht, Wt, zt = new DataView(We, 0, We.byteLength);
                Wt = ra.Utils.dataViewToString(zt, t.Z.UTF8);
                try {
                  ht = ut(vt).parse(Wt, 0), g.addCaptions(g.getCurrentTrackIdx(), 0, ht), r.buffered && r.buffered.add(Tt.start, Tt.end);
                } catch (gn) {
                  q.error(new se.Z($.TIMED_TEXT_ERROR_ID_PARSE_CODE, $.TIMED_TEXT_ERROR_MESSAGE_PARSE + gn.message, Wt));
                }
              }(nt, rt, pt) : u.error("No text type defined");
            }
            function Fe(nt) {
              return function(rt, Bt, we) {
                var He;
                (He = de.getTTMLRenderingDiv() ? _e.createHTMLCaptionsFromScreen(de.getElement(), rt, Bt, we) : [{ start: rt, end: Bt, data: we.getDisplayText(), styles: {} }]) && g.addCaptions(nt, 0, He);
              };
            }
            function Le() {
              return isNaN(r.timestampOffset) ? 0 : r.timestampOffset;
            }
            function ut(nt) {
              var rt;
              return nt.search(t.Z.VTT) >= 0 ? rt = oe.get().streaming.text.webvtt.customRenderingEnabled && D ? D : L : (nt.search(t.Z.TTML) >= 0 || nt.search(t.Z.STPP) >= 0) && (rt = O), rt;
            }
            function ct(nt) {
              U.forEach(function(rt) {
                var Bt = g.getTrackIdxForId(rt.id);
                Bt >= 0 && g.deleteCuesFromTrackIdx(Bt, nt.from, nt.to);
              });
            }
            return r = { initialize: function() {
              ee || (U = [], N = null, Z = 0, fe = [], me = null, ae = null, ee = !0, _e = mc(Q).getInstance(), ue.on(l.Z.VIDEO_CHUNK_RECEIVED, ve, r), ue.on(l.Z.BUFFER_CLEARED, ct, r));
            }, addMediaInfos: function(nt, rt, Bt) {
              if (I = I.concat(rt), nt === t.Z.TEXT && rt[0].isFragmented && !rt[0].isEmbedded) {
                y = Bt, r.buffered = (0, hc.Z)(Q).create(), Y = K.getTracksFor(t.Z.TEXT, A.id).filter(function(We) {
                  return We.isFragmented;
                });
                for (var we = K.getCurrentTrackFor(t.Z.TEXT, A.id), He = 0; He < Y.length; He++) if (Y[He] === we) {
                  xe(He);
                  break;
                }
              }
              for (var pt = 0; pt < rt.length; pt++) ne(rt[pt]);
            }, resetMediaInfos: function() {
              I = [];
            }, getStreamId: function() {
              return A.id;
            }, append: Ne, abort: function() {
            }, addEmbeddedTrack: function(nt) {
              if (ee && nt) if (nt.id === t.Z.CC1 || nt.id === t.Z.CC3) {
                for (var rt = 0; rt < U.length; rt++) if (U[rt].id === nt.id) return;
                U.push(nt);
              } else u.warn("Embedded track " + nt.id + " not supported!");
            }, resetEmbedded: function() {
              ue.off(l.Z.VIDEO_CHUNK_RECEIVED, ve, r), ue.off(l.Z.BUFFER_CLEARED, ct, r), g && g.deleteAllTextTracks(), ee = !1, U = [], fe = [null, null], me = null, ae = null;
            }, getConfig: function() {
              return { fragmentModel: y, fragmentedTracks: Y, videoModel: de };
            }, setCurrentFragmentedTrackIdx: xe, remove: function(nt, rt) {
              nt === void 0 && nt === rt && (nt = r.buffered.start(0), rt = r.buffered.end(r.buffered.length - 1)), r.buffered.remove(nt, rt), g.deleteCuesFromTrackIdx(N, nt, rt);
            }, reset: function() {
              k(), I = [], _ = null;
            } }, u = (0, h.Z)(Q).getInstance().getLogger(r), _ = (0, Ii.Z)(Q).getInstance(), k(), r;
          }
          Fs.__dashjs_factory_name = "TextSourceBuffer";
          var pc = v.Z.getClassFactory(Fs), uo = R(4403);
          function ks(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          var yc = ["text", "align", "fontSize", "id", "isd", "line", "lineAlign", "lineHeight", "linePadding", "position", "positionAlign", "region", "size", "snapToLines", "vertical"];
          function Zs(i) {
            var r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q, le, K, de = this.context, g = (0, p.Z)(de).getInstance(), L = i.videoModel, D = i.streamInfo, O = i.settings;
            function A(Ke, Et, lt, Rt, Pt, $t) {
              var Qt = 0, en = 0;
              Ke / Et > lt / Rt ? Qt = (en = Et) / Rt * lt : en = (Qt = Ke) / lt * Rt;
              var sn, mt, kt = 0, qt = 0;
              return Qt / en > Pt ? (qt = en, kt = en * Pt) : (kt = Qt, qt = Qt / Pt), sn = (Ke - kt) / 2, mt = (Et - qt) / 2, $t ? { x: sn + 0.1 * kt, y: mt + 0.1 * qt, w: 0.8 * kt, h: 0.8 * qt } : { x: sn, y: mt, w: kt, h: qt };
            }
            function oe(Ke, Et) {
              var lt = L.getClientWidth(), Rt = L.getClientHeight(), Pt = L.getVideoWidth(), $t = L.getVideoHeight(), Qt = L.getVideoRelativeOffsetTop(), en = L.getVideoRelativeOffsetLeft();
              if (Pt !== 0 && $t !== 0) {
                var sn = Pt / $t, mt = !1;
                Ke.isFromCEA608 && (sn = 1.1666666666666667, mt = !0);
                var kt = A.call(this, lt, Rt, Pt, $t, sn, mt), qt = kt.w, Vt = kt.h, Xt = kt.x, ze = kt.y;
                if (qt != Y || Vt != H || Xt != C || ze != F || Et) {
                  if (C = Xt + en, F = ze + Qt, Y = qt, H = Vt, N) {
                    var Pe = N.style;
                    Pe && (Pe.left = C + "px", Pe.top = F + "px", Pe.width = Y + "px", Pe.height = H + "px", Pe.zIndex = me && document[me] || ae ? _e : null, g.trigger(n.Z.CAPTION_CONTAINER_RESIZE));
                  }
                  var ft = Ke.activeCues;
                  if (ft) for (var pe = ft.length, be = 0; be < pe; ++be) {
                    var Je = ft[be];
                    Je.scaleCue(Je);
                  }
                }
              }
            }
            function Q(Ke) {
              var Et, lt, Rt, Pt, $t, Qt = Y, en = H;
              if (Ke.cellResolution) {
                var sn = [Qt / Ke.cellResolution[0], en / Ke.cellResolution[1]];
                if (Ke.linePadding) {
                  for (Et in Ke.linePadding) if (Ke.linePadding.hasOwnProperty(Et)) {
                    lt = (Ke.linePadding[Et] * sn[0]).toString();
                    for (var mt = document.getElementsByClassName("spanPadding"), kt = 0; kt < mt.length; kt++) mt[kt].style.cssText = mt[kt].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt), mt[kt].style.cssText = mt[kt].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt);
                  }
                }
                if (Ke.fontSize) {
                  for (Et in Ke.fontSize) if (Ke.fontSize.hasOwnProperty(Et)) {
                    Ke.fontSize[Et][0] === "%" ? Rt = Ke.fontSize[Et][1] / 100 : Ke.fontSize[Et][0] === "c" && (Rt = Ke.fontSize[Et][1]), lt = (Rt * sn[1]).toString(), $t = Et !== "defaultFontSize" ? document.getElementsByClassName(Et) : document.getElementsByClassName("paragraph");
                    for (var qt = 0; qt < $t.length; qt++) $t[qt].style.cssText = $t[qt].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt);
                  }
                  if (Ke.lineHeight) {
                    for (Et in Ke.lineHeight) if (Ke.lineHeight.hasOwnProperty(Et)) {
                      Ke.lineHeight[Et][0] === "%" ? Pt = Ke.lineHeight[Et][1] / 100 : Ke.fontSize[Et][0] === "c" && (Pt = Ke.lineHeight[Et][1]), lt = (Pt * sn[1]).toString(), $t = document.getElementsByClassName(Et);
                      for (var Vt = 0; Vt < $t.length; Vt++) $t[Vt].style.cssText = $t[Vt].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt);
                    }
                  }
                }
              }
              if (Ke.isd) {
                var Xt = document.getElementById(Ke.cueID);
                Xt && N.removeChild(Xt), ee(Ke);
              }
            }
            function ue(Ke, Et) {
              var lt = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/, Rt = /^#(.*)$/;
              if (lt.test(Et)) {
                var Pt = lt.exec(Et), $t = parseInt(Pt[4], 10) - 1;
                return "data:image/png;base64," + btoa(Ke.images[$t]);
              }
              if (Rt.test(Et)) {
                var Qt = Rt.exec(Et)[1];
                return "data:image/png;base64," + Ke.embeddedImages[Qt];
              }
              return Et;
            }
            function ee(Ke) {
              if (N) {
                pn.call(this);
                var Et = document.createElement("div");
                N.appendChild(Et), fe = (0, uo.renderHTML)(Ke.isd, Et, function(lt) {
                  return ue(Ke, lt);
                }, N.clientHeight, N.clientWidth, O.get().streaming.text.imsc.displayForcedOnlyMode, function(lt) {
                  u.info("renderCaption :", lt);
                }, fe, O.get().streaming.text.imsc.enableRollUp), Et.id = Ke.cueID, g.trigger(n.Z.CAPTION_RENDERED, { captionDiv: Et, currentTrackIdx: y });
              }
            }
            function k(Ke, Et) {
              return !!Et && Et.endTime >= Ke.startTime;
            }
            function ne(Ke, Et) {
              return !!O.get().streaming.text.extendSegmentedCues && !!function(lt, Rt, Pt) {
                for (var $t = 0; $t < Pt.length; $t++) {
                  var Qt = Pt[$t];
                  if (JSON.stringify(lt[Qt]) !== JSON.stringify(Rt[Qt])) return !1;
                }
                return !0;
              }(Et, Ke, yc) && (Et.endTime = Math.max(Et.endTime, Ke.endTime), !0);
            }
            function ve(Ke, Et) {
              Et && Et.forEach(function(lt) {
                lt.kind && lt.kind === "image" && (lt.src = ue(Ke, lt.src)), ve(Ke, lt.contents);
              });
            }
            function xe(Ke, Et, lt) {
              var Rt = He(Ke), Pt = O.get().streaming.text.dispatchForManualRendering;
              if (Rt && Array.isArray(lt) && lt.length !== 0) for (var $t = 0; $t < lt.length; $t++) {
                var Qt = null, en = lt[$t];
                Rt.cellResolution = en.cellResolution, Rt.isFromCEA608 = en.isFromCEA608, isNaN(en.start) || isNaN(en.end) || (Pt ? Qt = Ne(en, Et) : nt(en) && N ? Qt = ut(en, Et, Rt) : en.data && (Qt = ct(en, Et, Rt)));
                try {
                  if (Qt) {
                    if (!Tt(Rt, Qt)) if (O.get().streaming.text.webvtt.customRenderingEnabled) Rt.manualCueList || (Rt.manualCueList = []), Rt.manualCueList.push(Qt);
                    else {
                      var sn = void 0;
                      Rt.cues && Rt.cues.length !== 0 && (sn = Rt.cues[Rt.cues.length - 1]), k(Qt, sn) ? ne(Qt, sn) || (sn.isd && (sn.onexit = function() {
                      }), Rt.mode !== t.Z.TEXT_DISABLED && Rt.addCue(Qt)) : Rt.mode !== t.Z.TEXT_DISABLED && Rt.addCue(Qt);
                    }
                    var mt = O.get().streaming.buffer.bufferToKeep;
                    ht(Rt, 0, L.getTime() - mt);
                  } else u.error("Impossible to display subtitles. You might have missed setting a TTML rendering div via player.attachTTMLRenderingDiv(TTMLRenderingDiv)");
                } catch (kt) {
                  throw Wt(Rt), Rt.addCue(Qt), kt;
                }
              }
            }
            function Ne(Ke, Et) {
              var lt = rt(Ke, Et);
              return lt.onenter = function() {
                nt(Ke) && K && K.cueID !== lt.cueID && Le(K), delete lt.type, K = lt, Fe(lt);
              }, lt.onexit = function() {
                Le(lt), K = null;
              }, lt;
            }
            function Fe(Ke) {
              g.trigger(n.Z.CUE_ENTER, Ke);
            }
            function Le(Ke) {
              g.trigger(n.Z.CUE_EXIT, { cueID: Ke.cueID });
            }
            function ut(Ke, Et, lt) {
              var Rt = this, Pt = rt(Ke, Et);
              return N.style.left = C + "px", N.style.top = F + "px", N.style.width = Y + "px", N.style.height = H + "px", Pt.onenter = function() {
                var $t = this;
                lt.mode === t.Z.TEXT_SHOWING && (this.isd ? (le ? requestAnimationFrame(function() {
                  return ee($t);
                }) : ee(this), u.debug("Cue enter id:" + this.cueID)) : (N.appendChild(this.cueHTMLElement), Q.call(Rt, this), g.trigger(n.Z.CAPTION_RENDERED, { captionDiv: this.cueHTMLElement, currentTrackIdx: y })));
              }, Pt.onexit = function() {
                if (N) for (var $t = N.childNodes, Qt = 0; Qt < $t.length; ++Qt) $t[Qt].id === this.cueID && (u.debug("Cue exit id:" + $t[Qt].id), N.removeChild($t[Qt]), --Qt);
              }, Pt;
            }
            function ct(Ke, Et, lt) {
              var Rt = rt(Ke, Et);
              if (Rt.isActive = !1, Ke.styles) try {
                Ke.styles.align !== void 0 && "align" in Rt && (Rt.align = Ke.styles.align), Ke.styles.line !== void 0 && "line" in Rt && (Rt.line = Ke.styles.line), Ke.styles.snapToLines !== void 0 && "snapToLines" in Rt && (Rt.snapToLines = Ke.styles.snapToLines), Ke.styles.position !== void 0 && "position" in Rt && (Rt.position = Ke.styles.position), Ke.styles.size !== void 0 && "size" in Rt && (Rt.size = Ke.styles.size);
              } catch (Pt) {
                u.error(Pt);
              }
              return Rt.onenter = function() {
                lt.mode === t.Z.TEXT_SHOWING && g.trigger(n.Z.CAPTION_RENDERED, { currentTrackIdx: y });
              }, Rt;
            }
            function nt(Ke) {
              return Ke.type === "html";
            }
            function rt(Ke, Et) {
              return nt(Ke) ? function(lt, Rt) {
                var Pt = new _(lt.start + Rt, lt.end + Rt, "");
                return Pt.cueHTMLElement = lt.cueHTMLElement, Pt.isd = lt.isd, Pt.images = lt.images, Pt.embeddedImages = lt.embeddedImages, Pt.cueID = lt.cueID, Pt.scaleCue = Q.bind(self), Pt.cellResolution = lt.cellResolution, Pt.lineHeight = lt.lineHeight, Pt.linePadding = lt.linePadding, Pt.fontSize = lt.fontSize, Pt.isd && ve(Pt, Pt.isd.contents), Pt;
              }(Ke, Et) : function(lt, Rt) {
                var Pt = new _(lt.start - Rt, lt.end - Rt, lt.data);
                return Pt.cueID = "".concat(Pt.startTime, "_").concat(Pt.endTime), Pt;
              }(Ke, Et);
            }
            function Bt(Ke) {
              if (U) for (var Et = U.childNodes, lt = 0; lt < Et.length; ++lt) Et[lt].id === Ke.cueID && (U.removeChild(Et[lt]), --lt);
            }
            function we() {
              var Ke, Et = [], lt = function(Pt, $t) {
                var Qt;
                if (typeof Symbol > "u" || Pt[Symbol.iterator] == null) {
                  if (Array.isArray(Pt) || (Qt = function(Vt, Xt) {
                    if (Vt) {
                      if (typeof Vt == "string") return ks(Vt, Xt);
                      var ze = Object.prototype.toString.call(Vt).slice(8, -1);
                      return ze === "Object" && Vt.constructor && (ze = Vt.constructor.name), ze === "Map" || ze === "Set" ? Array.from(Vt) : ze === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ze) ? ks(Vt, Xt) : void 0;
                    }
                  }(Pt)) || $t) {
                    Qt && (Pt = Qt);
                    var en = 0, sn = function() {
                    };
                    return { s: sn, n: function() {
                      return en >= Pt.length ? { done: !0 } : { done: !1, value: Pt[en++] };
                    }, e: function(Vt) {
                      throw Vt;
                    }, f: sn };
                  }
                  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }
                var mt, kt = !0, qt = !1;
                return { s: function() {
                  Qt = Pt[Symbol.iterator]();
                }, n: function() {
                  var Vt = Qt.next();
                  return kt = Vt.done, Vt;
                }, e: function(Vt) {
                  qt = !0, mt = Vt;
                }, f: function() {
                  try {
                    kt || Qt.return == null || Qt.return();
                  } finally {
                    if (qt) throw mt;
                  }
                } };
              }(L.getTextTracks());
              try {
                for (lt.s(); !(Ke = lt.n()).done; ) {
                  var Rt = Ke.value;
                  Rt.manualMode === t.Z.TEXT_SHOWING && Et.push(Rt);
                }
              } catch (Pt) {
                lt.e(Pt);
              } finally {
                lt.f();
              }
              return Et;
            }
            function He(Ke) {
              return Ke >= 0 && w[Ke] ? L.getTextTrack(w[Ke].kind, w[Ke].id, w[Ke].lang, w[Ke].isTTML, w[Ke].isEmbedded) : null;
            }
            function pt(Ke) {
              var Et = this;
              if (Ke !== y) {
                var lt = He(y = Ke);
                We.call(this, lt), Z && (clearInterval(Z), Z = null), lt && lt.renderingType === "html" && (oe.call(this, lt, !0), window.ResizeObserver ? (q = new window.ResizeObserver(function() {
                  oe.call(Et, lt, !0);
                })).observe(L.getElement()) : Z = setInterval(oe.bind(this, lt), 500));
              }
            }
            function We(Ke) {
              pn.call(this), Ke && Ke.renderingType === "html" ? zt.call(this) : gn.call(this);
            }
            function Tt(Ke, Et) {
              if (!Ke.cues) return !1;
              for (var lt = 0; lt < Ke.cues.length; lt++) if (Ke.cues[lt].startTime === Et.startTime && Ke.cues[lt].endTime === Et.endTime) return !0;
              return !1;
            }
            function vt(Ke, Et, lt) {
              var Rt = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
              return !!Ke && (isNaN(Et) || (Rt ? Ke.startTime : Ke.endTime) >= Et) && (isNaN(lt) || (Rt ? Ke.endTime : Ke.startTime) <= lt);
            }
            function ht(Ke, Et, lt) {
              var Rt, Pt;
              if (!(lt < Et) && Ke && (Ke.cues || Ke.manualCueList)) {
                var $t = Ke.cues && Ke.cues.length > 0 ? "native" : "custom", Qt = $t === "native" ? Ke.cues : Ke.manualCueList;
                if (!Qt || Qt.length === 0) return;
                for (var en = Qt.length - 1; en >= 0; en--) !vt(Qt[en], Et, lt, !0) || (Rt = Qt[en], Pt = L.getTime(), Rt.startTime >= Pt && Rt.endTime <= Pt) || ($t === "native" ? Ke.removeCue(Qt[en]) : (Bt(Qt[en]), delete Ke.manualCueList[en]));
              }
            }
            function Wt(Ke, Et, lt) {
              var Rt = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
              if (Ke && (Ke.cues || Ke.manualCueList)) {
                var Pt = Ke.cues && Ke.cues.length > 0 ? "native" : "custom", $t = Pt === "native" ? Ke.cues : Ke.manualCueList;
                if (!$t || $t.length === 0) return;
                for (var Qt = $t.length - 1, en = Qt; en >= 0; en--) vt($t[en], Et, lt, Rt) && (Pt === "native" ? ($t[en].onexit && $t[en].onexit(), Ke.removeCue($t[en])) : (Bt($t[en]), delete Ke.manualCueList[en]));
              }
            }
            function zt() {
              var Ke = document.getElementById("native-cue-style");
              if (!Ke) {
                (Ke = document.createElement("style")).id = "native-cue-style", document.head.appendChild(Ke);
                var Et = Ke.sheet, lt = L.getElement();
                try {
                  lt && (lt.id ? Et.insertRule("#" + lt.id + "::cue {background: transparent}", 0) : lt.classList.length !== 0 ? Et.insertRule("." + lt.className + "::cue {background: transparent}", 0) : Et.insertRule("video::cue {background: transparent}", 0));
                } catch (Rt) {
                  u.info("" + Rt.message);
                }
              }
            }
            function gn() {
              var Ke = document.getElementById("native-cue-style");
              Ke && document.head.removeChild(Ke);
            }
            function pn() {
              if (N) for (; N.firstChild; ) N.removeChild(N.firstChild);
            }
            return r = { initialize: function() {
              typeof window < "u" && typeof navigator < "u" && (_ = window.VTTCue || window.TextTrackCue, w = [], I = [], y = -1, C = 0, F = 0, Y = 0, H = 0, N = null, U = null, Z = null, ae = !1, _e = 2147483647, fe = null, le = "requestAnimationFrame" in window, document.fullscreenElement !== void 0 ? me = "fullscreenElement" : document.webkitIsFullScreen !== void 0 ? me = "webkitIsFullScreen" : document.msFullscreenElement ? me = "msFullscreenElement" : document.mozFullScreen && (me = "mozFullScreen"));
            }, getStreamId: function() {
              return D.id;
            }, addTextTrack: function(Ke) {
              w.push(Ke);
            }, addCaptions: xe, createTracks: function() {
              var Ke = O.get().streaming.text.dispatchForManualRendering;
              w.sort(function(Xt, ze) {
                return Xt.index - ze.index;
              }), N = L.getTTMLRenderingDiv(), U = L.getVttRenderingDiv();
              for (var Et, lt, Rt, Pt, $t, Qt, en = -1, sn = 0; sn < w.length; sn++) {
                var mt = (lt = (Et = w[sn]).kind, Rt = Et.id !== void 0 ? Et.id : Et.lang, Pt = Et.lang, $t = Et.isTTML, Qt = Et.isEmbedded, L.addTextTrack(lt, Rt, Pt, $t, Qt));
                I.push(mt), w[sn].defaultTrack && (mt.default = !0, en = sn);
                var kt = He(sn);
                kt && (kt.mode = t.Z.TEXT_SHOWING, N && (w[sn].isTTML || w[sn].isEmbedded) ? kt.renderingType = "html" : kt.renderingType = "default"), xe(sn, 0, w[sn].captionData), g.trigger(n.Z.TEXT_TRACK_ADDED);
              }
              if (pt.call(this, en), en >= 0) {
                g.on(n.Z.PLAYBACK_METADATA_LOADED, function Xt() {
                  var ze = He(en);
                  ze && ze.renderingType === "html" && oe.call(this, ze, !0), g.off(n.Z.PLAYBACK_METADATA_LOADED, Xt, this);
                }, this);
                for (var qt = 0; qt < w.length; qt++) {
                  var Vt = He(qt);
                  Vt && (Vt.mode = qt !== en || Ke ? t.Z.TEXT_HIDDEN : t.Z.TEXT_SHOWING, Vt.manualMode = qt === en ? t.Z.TEXT_SHOWING : t.Z.TEXT_HIDDEN);
                }
              }
              g.trigger(l.Z.TEXT_TRACKS_QUEUE_INITIALIZED, { index: y, tracks: w, streamId: D.id });
            }, getCurrentTrackIdx: function() {
              return y;
            }, setCurrentTrackIdx: pt, getTrackIdxForId: function(Ke) {
              for (var Et = -1, lt = 0; lt < w.length; lt++) if (w[lt].id === Ke) {
                Et = lt;
                break;
              }
              return Et;
            }, getCurrentTrackInfo: function() {
              return w[y];
            }, setModeForTrackIdx: function(Ke, Et) {
              var lt = He(Ke);
              lt && lt.mode !== Et && (lt.mode = Et), lt && lt.manualMode !== Et && (lt.manualMode = Et);
            }, deleteCuesFromTrackIdx: function(Ke, Et, lt) {
              var Rt = He(Ke);
              Rt && Wt(Rt, Et, lt);
            }, deleteAllTextTracks: function() {
              for (var Ke = I ? I.length : 0, Et = 0; Et < Ke; Et++) {
                var lt = He(Et);
                lt && Wt.call(this, lt, D.start, D.start + D.duration, !1);
              }
              I = [], w = [], Z && (clearInterval(Z), Z = null), q && L && (q.unobserve(L.getElement()), q = null), y = -1, pn.call(this);
            }, manualCueProcessing: function(Ke) {
              var Et = we();
              if (Et.length > 0) {
                var lt = Et[0].manualCueList;
                lt && lt.length > 0 && lt.forEach(function(Rt) {
                  Rt.startTime <= Ke && Rt.endTime >= Ke && !Rt.isActive ? (Rt.isActive = !0, O.get().streaming.text.dispatchForManualRendering ? Fe(Rt) : WebVTT.processCues(window, [Rt], U, Rt.cueID)) : Rt.isActive && (Rt.startTime > Ke || Rt.endTime < Ke) && (Rt.isActive = !1, O.get().streaming.text.dispatchForManualRendering ? Le(Rt) : Bt(Rt));
                });
              }
            }, disableManualTracks: function() {
              var Ke = we();
              if (Ke.length > 0) {
                var Et = Ke[0].manualCueList;
                Et && Et.length > 0 && Et.forEach(function(lt) {
                  if (lt.isActive) {
                    if (lt.isActive = !1, O.get().streaming.text.dispatchForManualRendering) Le(lt);
                    else if (U) for (var Rt = U.childNodes, Pt = 0; Pt < Rt.length; ++Pt) Rt[Pt].id === lt.cueID && (U.removeChild(Rt[Pt]), --Pt);
                  }
                });
              }
            } }, u = (0, h.Z)(de).getInstance().getLogger(r), r;
          }
          Zs.__dashjs_factory_name = "TextTracks";
          var _c = v.Z.getClassFactory(Zs);
          function Bs() {
            var i, r, u, _, w, I, y = this.context;
            function C(N) {
              var U = N.split(":"), Z = U.length - 1;
              return N = 60 * parseInt(U[Z - 1], 10) + parseFloat(U[Z]), Z === 2 && (N += 3600 * parseInt(U[0], 10)), N;
            }
            function F(N) {
              var U = N.split(_), Z = U[1].split(I);
              return Z.shift(), U[1] = Z[0], Z.shift(), { cuePoints: U, styles: Y(Z) };
            }
            function Y(N) {
              var U = {};
              return N.forEach(function(Z) {
                if (Z.split(/:/).length > 1) {
                  var me = Z.split(/:/)[1], ae = !1;
                  me && me.search(/%/) != -1 && (ae = !0, me = parseInt(me.replace(/%/, ""), 10)), (Z.match(/align/) || Z.match(/A/)) && (U.align = me), (Z.match(/line/) || Z.match(/L/)) && (U.line = me === "auto" ? me : parseInt(me, 10), ae && (U.snapToLines = !1)), (Z.match(/position/) || Z.match(/P/)) && (U.position = me), (Z.match(/size/) || Z.match(/S/)) && (U.size = me);
                }
              }), U;
            }
            function H(N, U) {
              for (var Z, me = U, ae = "", fe = ""; N[me] !== "" && me < N.length; ) me++;
              if ((Z = me - U) > 1) for (var _e = 0; _e < Z; _e++) {
                if ((fe = N[U + _e]).match(_)) {
                  ae = "";
                  break;
                }
                ae += fe, _e !== Z - 1 && (ae += `
`);
              }
              else (fe = N[U]).match(_) || (ae = fe);
              return ae;
            }
            return i = { parse: function(N) {
              var U, Z, me = [];
              if (!N) return me;
              U = (N = N.split(u)).length, Z = -1;
              for (var ae = 0; ae < U; ae++) {
                var fe = N[ae];
                if (fe.length > 0 && fe !== "WEBVTT" && fe.match(_)) {
                  var _e = F(fe), q = _e.cuePoints, le = _e.styles, K = H(N, ae + 1), de = C(q[0].replace(w, "")), g = C(q[1].replace(w, ""));
                  !isNaN(de) && !isNaN(g) && de >= Z && g > de ? K !== "" ? (Z = de, me.push({ start: de, end: g, data: K, styles: le })) : r.error("Skipping cue due to empty/malformed cue text") : r.error("Skipping cue due to incorrect cue timing");
                }
              }
              return me;
            }, getCaptionStyles: Y }, r = (0, h.Z)(y).getInstance().getLogger(i), u = /(?:\r\n|\r|\n)/gm, _ = /-->/, w = /(^[\s]+|[\s]+$)/g, I = /\s\b/g, i;
          }
          Bs.__dashjs_factory_name = "VTTParser";
          var Ec = v.Z.getSingletonFactory(Bs);
          function Us() {
            var i, r;
            return i = { parse: function(u) {
              var _ = [];
              return r.oncue = function(w) {
                w.start = w.startTime, w.end = w.endTime, w.data = w.text, w.styles = { align: w.align, line: w.line, position: w.position, size: w.size }, _.push(w);
              }, r.parse(u), _;
            } }, function() {
              try {
                window && window.WebVTT && window.WebVTT.Parser && (r = new window.WebVTT.Parser(window, window.vttjs, window.WebVTT.StringDecoder()));
              } catch {
              }
            }(), i;
          }
          Us.__dashjs_factory_name = "VttCustomRenderingParser";
          var vc = v.Z.getSingletonFactory(Us);
          function Gs() {
            var i, r, u = this.context, _ = (0, p.Z)(u).getInstance(), w = 0;
            return i = { parse: function(I, y, C, F, Y) {
              var H, N, U, Z = "", me = [], ae = {}, fe = {}, _e = "", q = "", le = { onOpenTag: function(D, O, A) {
                if (A[" imagetype"] && !A[" imageType"] && (_.trigger(n.Z.CONFORMANCE_VIOLATION, { level: mi.LEVELS.ERROR, event: mi.EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE }), A[" imageType"] = A[" imagetype"]), O === "image" && (D === "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt" || D === "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt")) {
                  if (!A[" imageType"] || A[" imageType"].value !== "PNG") return void r.warn("smpte-tt imageType != PNG. Discarded");
                  _e = A["http://www.w3.org/XML/1998/namespace id"].value;
                }
              }, onCloseTag: function() {
                _e && (fe[_e] = q.trim()), q = "", _e = "";
              }, onText: function(D) {
                _e && (q += D);
              } };
              if (!I) throw Z = "no ttml data to parse", new Error(Z);
              ae.data = I, _.trigger(l.Z.TTML_TO_PARSE, ae);
              var K = (0, uo.fromXML)(ae.data, function(D) {
                Z = D;
              }, le);
              _.trigger(l.Z.TTML_PARSED, { ttmlString: ae.data, ttmlDoc: K });
              var de, g = K.getMediaTimeEvents();
              for (U = 0; U < g.length; U++) {
                var L = (0, uo.generateISD)(K, g[U], function(D) {
                  Z = D;
                });
                L.contents.some(function(D) {
                  return D.contents.length;
                }) && (H = g[U] + y) < (N = g[U + 1] + y) && me.push({ start: H, end: N, type: "html", cueID: (de = "cue_TTML_" + w, w++, de), isd: L, images: Y, embeddedImages: fe });
              }
              if (Z !== "") throw r.error(Z), new Error(Z);
              return me;
            } }, r = (0, h.Z)(u).getInstance().getLogger(i), i;
          }
          Gs.__dashjs_factory_name = "TTMLParser";
          var Tc = v.Z.getSingletonFactory(Gs);
          function Hs(i, r) {
            var u = Object.keys(i);
            if (Object.getOwnPropertySymbols) {
              var _ = Object.getOwnPropertySymbols(i);
              r && (_ = _.filter(function(w) {
                return Object.getOwnPropertyDescriptor(i, w).enumerable;
              })), u.push.apply(u, _);
            }
            return u;
          }
          function qs(i) {
            for (var r = 1; r < arguments.length; r++) {
              var u = arguments[r] != null ? arguments[r] : {};
              r % 2 ? Hs(Object(u), !0).forEach(function(_) {
                bc(i, _, u[_]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(u)) : Hs(Object(u)).forEach(function(_) {
                Object.defineProperty(i, _, Object.getOwnPropertyDescriptor(u, _));
              });
            }
            return i;
          }
          function bc(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Vs(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function js(i) {
            var r, u, _, w = this.context, I = (0, p.Z)(w).getInstance(), y = (0, tt.Z)(w).getInstance(), C = i.adapter, F = i.baseURLController;
            function Y(U, Z) {
              var me, ae, fe = !1;
              if (F.resolve()) {
                var _e = C.getVoRepresentations(U);
                _e && _e.length > 0 && (me = F.resolve(_e[0].path).url);
              }
              var q = U.essentialPropertiesAsArray.filter(function(K) {
                return K.schemeIdUri && K.schemeIdUri === t.Z.FONT_DOWNLOAD_DVB_SCHEME;
              }), le = U.supplementalPropertiesAsArray.filter(function(K) {
                return K.schemeIdUri && K.schemeIdUri === t.Z.FONT_DOWNLOAD_DVB_SCHEME;
              });
              q.length > 0 ? (fe = !0, ae = q) : ae = le, ae.forEach(function(K) {
                if (function(D) {
                  return !(!(D.value && D.value === "1" && D.dvbUrl && D.dvbUrl.length > 0 && D.dvbFontFamily && D.dvbFontFamily.length > 0 && D.dvbMimeType) || D.dvbMimeType !== t.Z.OFF_MIMETYPE && D.dvbMimeType !== t.Z.WOFF_MIMETYPE);
                }(K)) {
                  var de = (g = K.dvbUrl, L = me, y.isPathAbsolute(g) ? g : y.isRelative(g) ? L ? y.resolve(g, L) : y.resolve(g) : g);
                  _.push({ fontFamily: K.dvbFontFamily, url: de, mimeType: K.dvbMimeType, trackId: U.id, streamId: Z, isEssential: fe, status: "unloaded", fontFace: new FontFace(K.dvbFontFamily, "url(".concat(de, ")"), { display: "swap" }) });
                }
                var g, L;
              });
            }
            function H(U, Z) {
              var me = _[U];
              _[U] = qs(qs({}, me), {}, { status: Z });
            }
            function N() {
              _ = [];
            }
            return r = { addFontsFromTracks: function(U, Z) {
              if (U && Array.isArray(U) && Z) for (var me = 0; me < U.length; me++) Y(U[me], Z);
            }, downloadFonts: function() {
              for (var U = function(me) {
                var ae = _[me];
                document.fonts.add(ae.fontFace), I.trigger(n.Z.DVB_FONT_DOWNLOAD_ADDED, ae), ae.fontFace.load().then(function() {
                  H(me, "loaded"), I.trigger(n.Z.DVB_FONT_DOWNLOAD_COMPLETE, ae);
                }, function(fe) {
                  H(me, "error"), u.debug("Font download error: ", fe), I.trigger(n.Z.DVB_FONT_DOWNLOAD_FAILED, ae);
                });
              }, Z = 0; Z < _.length; Z++) U(Z);
            }, getFonts: function() {
              return _;
            }, getFontsForTrackId: function(U) {
              return _.filter(function(Z) {
                return Z.trackId && Z.trackId === U;
              });
            }, reset: function() {
              (function() {
                var U, Z = function(fe, _e) {
                  var q;
                  if (typeof Symbol > "u" || fe[Symbol.iterator] == null) {
                    if (Array.isArray(fe) || (q = function(D, O) {
                      if (D) {
                        if (typeof D == "string") return Vs(D, O);
                        var A = Object.prototype.toString.call(D).slice(8, -1);
                        return A === "Object" && D.constructor && (A = D.constructor.name), A === "Map" || A === "Set" ? Array.from(D) : A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A) ? Vs(D, O) : void 0;
                      }
                    }(fe)) || _e) {
                      q && (fe = q);
                      var le = 0, K = function() {
                      };
                      return { s: K, n: function() {
                        return le >= fe.length ? { done: !0 } : { done: !1, value: fe[le++] };
                      }, e: function(D) {
                        throw D;
                      }, f: K };
                    }
                    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                  }
                  var de, g = !0, L = !1;
                  return { s: function() {
                    q = fe[Symbol.iterator]();
                  }, n: function() {
                    var D = q.next();
                    return g = D.done, D;
                  }, e: function(D) {
                    L = !0, de = D;
                  }, f: function() {
                    try {
                      g || q.return == null || q.return();
                    } finally {
                      if (L) throw de;
                    }
                  } };
                }(_);
                try {
                  for (Z.s(); !(U = Z.n()).done; ) {
                    var me = U.value, ae = document.fonts.delete(me.fontFace);
                    u.debug("Removal of fontFamily: ".concat(me.fontFamily, " was ").concat(ae ? "successful" : "unsuccessful"));
                  }
                } catch (fe) {
                  Z.e(fe);
                } finally {
                  Z.f();
                }
              })(), N();
            } }, u = (0, h.Z)(w).getInstance().getLogger(r), N(), r;
          }
          js.__dashjs_factory_name = "DVBFonts";
          var Sc = v.Z.getClassFactory(js);
          function Ys(i) {
            var r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae = this.context, fe = i.adapter, _e = i.errHandler, q = i.manifestModel, le = i.mediaController, K = i.baseURLController, de = i.videoModel, g = i.settings;
            function L(ne) {
              if (me.error("Could not download ".concat(ne.isEssential ? "an essential" : "a", " font - fontFamily: ").concat(ne.fontFamily, ", url: ").concat(ne.url)), ne.isEssential) {
                var ve = w[ne.streamId].getTrackIdxForId(ne.trackId);
                w[ne.streamId].setModeForTrackIdx(ve, t.Z.TEXT_DISABLED);
              }
            }
            function D(ne) {
              if (me.debug("Successfully downloaded ".concat(ne.isEssential ? "an essential" : "a", " font - fontFamily: ").concat(ne.fontFamily, ", url: ").concat(ne.url)), ne.isEssential) {
                var ve = w[ne.streamId].getTrackIdxForId(ne.trackId);
                ve === w[ne.streamId].getCurrentTrackIdx() ? w[ne.streamId].setModeForTrackIdx(ve, t.Z.TEXT_SHOWING) : w[ne.streamId].setModeForTrackIdx(ve, t.Z.TEXT_HIDDEN);
              }
            }
            function O(ne) {
              var ve = ne.tracks, xe = ne.index, Ne = ne.streamId;
              if (g.get().streaming.text.defaultEnabled === !1 && !Q() || U) ue(Ne, -1);
              else {
                var Fe = le.getCurrentTrackFor(t.Z.TEXT, Ne);
                if (Fe) {
                  var Le = { lang: Fe.lang, role: Fe.roles[0], index: Fe.index, codec: Fe.codec, accessibility: Fe.accessibility[0] };
                  ve.some(function(ut, ct) {
                    if (le.matchSettings(Le, ut)) return ue(Ne, ct), xe = ct, !0;
                  });
                }
                Y = !1;
              }
              u[Ne].lastEnabledIndex = xe, F.trigger(n.Z.TEXT_TRACKS_ADDED, { enabled: Q(), index: xe, tracks: ve, streamId: Ne }), N = !0, Z.addFontsFromTracks(ve, Ne), Z.getFonts().forEach(function(ut) {
                if (ut.isEssential) {
                  var ct = w[ut.streamId].getTrackIdxForId(ut.trackId);
                  w[ut.streamId].setModeForTrackIdx(ct, t.Z.TEXT_DISABLED);
                }
              }), Z.downloadFonts();
            }
            function A(ne) {
              try {
                var ve = ne.streamId;
                if (!w[ve] || isNaN(ne.time)) return;
                w[ve].manualCueProcessing(ne.time);
              } catch {
              }
            }
            function oe(ne) {
              try {
                var ve = ne.streamId;
                if (!w[ve]) return;
                w[ve].disableManualTracks();
              } catch {
              }
            }
            function Q() {
              var ne = !0;
              return Y && !H && (ne = !1), ne;
            }
            function ue(ne, ve) {
              (Y = ve === -1) && le && le.saveTextSettingsDisabled();
              var xe = ee(ne);
              if (xe !== ve && w[ne]) {
                w[ne].disableManualTracks();
                var Ne = w[ne].getCurrentTrackInfo(), Fe = Ne ? de.getTextTrack(Ne.kind, Ne.id, Ne.lang, Ne.isTTML, Ne.isEmbedded) : null;
                Fe && Fe.mode !== t.Z.TEXT_DISABLED && w[ne].setModeForTrackIdx(xe, t.Z.TEXT_HIDDEN), w[ne].setCurrentTrackIdx(ve), Ne = w[ne].getCurrentTrackInfo();
                var Le = g.get().streaming.text.dispatchForManualRendering;
                Ne && !Le && Ne.mode !== t.Z.TEXT_DISABLED && w[ne].setModeForTrackIdx(ve, t.Z.TEXT_SHOWING), Ne && Ne.isFragmented && !Ne.isEmbedded ? function(ut, ct, nt) {
                  if (_[ut]) for (var rt = _[ut].getConfig().fragmentedTracks, Bt = 0; Bt < rt.length; Bt++) {
                    var we = rt[Bt];
                    if (ct.lang === we.lang && (we.id ? ct.id === we.id : ct.index === we.index)) {
                      var He = le.getCurrentTrackFor(t.Z.TEXT, ut);
                      (we.id ? He.id !== we.id : He.index !== we.index) ? (w[ut].deleteCuesFromTrackIdx(nt), _[ut].setCurrentFragmentedTrackIdx(Bt)) : nt === -1 && F.trigger(l.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, {}, { streamId: ut, mediaType: t.Z.TEXT });
                    }
                  }
                }(ne, Ne, xe) : Ne && !Ne.isFragmented && function(ut, ct) {
                  F.trigger(l.Z.SET_NON_FRAGMENTED_TEXT, { currentTrackInfo: ct }, { streamId: ut, mediaType: t.Z.TEXT });
                }(ne, Ne), le.setTrack(Ne);
              }
            }
            function ee(ne) {
              return w[ne].getCurrentTrackIdx();
            }
            function k() {
              _ = {}, w = {}, u = {}, Y = !0, N = !1, U = !1;
            }
            return r = { deactivateStream: function(ne) {
              if (ne) {
                var ve = ne.id;
                _[ve] && _[ve].resetMediaInfos(), w[ve] && w[ve].deleteAllTextTracks();
              }
            }, initialize: function() {
              Z = Sc(ae).create({ adapter: fe, baseURLController: K }), F.on(l.Z.TEXT_TRACKS_QUEUE_INITIALIZED, O, r), F.on(l.Z.DVB_FONT_DOWNLOAD_FAILED, L, r), F.on(l.Z.DVB_FONT_DOWNLOAD_COMPLETE, D, r), g.get().streaming.text.webvtt.customRenderingEnabled && (F.on(l.Z.PLAYBACK_TIME_UPDATED, A, r), F.on(l.Z.PLAYBACK_SEEKING, oe, r));
            }, initializeForStream: function(ne) {
              var ve = ne.id, xe = _c(ae).create({ videoModel: de, settings: g, streamInfo: ne });
              xe.initialize(), w[ve] = xe;
              var Ne = pc(ae).create({ errHandler: _e, adapter: fe, dvbFonts: Z, manifestModel: q, mediaController: le, videoModel: de, textTracks: xe, vttParser: I, vttCustomRenderingParser: y, ttmlParser: C, streamInfo: ne, settings: g });
              Ne.initialize(), _[ve] = Ne, u[ve] = {}, u[ve].lastEnabledIndex = -1;
            }, createTracks: function(ne) {
              var ve = ne.id;
              w[ve] && w[ve].createTracks();
            }, getTextSourceBuffer: function(ne) {
              var ve = ne.id;
              if (_ && _[ve]) return _[ve];
            }, getAllTracksAreDisabled: function() {
              return Y;
            }, addEmbeddedTrack: function(ne, ve) {
              var xe = ne.id;
              _[xe] && _[xe].addEmbeddedTrack(ve);
            }, enableText: function(ne, ve) {
              return (0, X.PS)(ve, "boolean"), Q() !== ve && (ve && ue(ne, u[ne].lastEnabledIndex), ve || (u[ne].lastEnabledIndex = ee(ne), N ? ue(ne, -1) : U = !0)), !0;
            }, isTextEnabled: Q, setTextTrack: ue, getCurrentTrackIdx: ee, enableForcedTextStreaming: function(ne) {
              return (0, X.PS)(ne, "boolean"), H = ne, !0;
            }, addMediaInfosToBuffer: function(ne, ve, xe) {
              var Ne = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, Fe = ne.id;
              _[Fe] && _[Fe].addMediaInfos(ve, xe, Ne);
            }, reset: function() {
              Z.reset(), k(), F.off(l.Z.TEXT_TRACKS_QUEUE_INITIALIZED, O, r), F.off(l.Z.DVB_FONT_DOWNLOAD_FAILED, L, r), F.off(l.Z.DVB_FONT_DOWNLOAD_COMPLETE, D, r), g.get().streaming.text.webvtt.customRenderingEnabled && (F.off(l.Z.PLAYBACK_TIME_UPDATED, A, r), F.off(l.Z.PLAYBACK_SEEKING, oe, r)), Object.keys(_).forEach(function(ne) {
                _[ne].resetEmbedded(), _[ne].reset();
              });
            } }, H = !1, N = !1, U = !1, I = Ec(ae).getInstance(), y = vc(ae).getInstance(), C = Tc(ae).getInstance(), F = (0, p.Z)(ae).getInstance(), me = (0, h.Z)(ae).getInstance().getLogger(r), k(), r;
          }
          Ys.__dashjs_factory_name = "TextController";
          var Ac = v.Z.getClassFactory(Ys);
          function co() {
            var i, r, u, _, w, I, y, C, F, Y, H, N, U, Z, me, ae, fe, _e, q, le, K, de, g, L, D, O, A, oe, Q, ue, ee, k, ne, ve, xe, Ne, Fe, Le, ut, ct = "You must first call initialize() and set a source before calling this method", nt = "You must first call initialize() and set a valid source and view before calling this method", rt = "You must first call attachView() to set the video element before calling this method", Bt = "You must first call attachSource() with a valid source before calling this method", we = "MediaPlayer not initialized!", He = this.context, pt = (0, p.Z)(He).getInstance(), We = (0, Me.Z)(He).getInstance(), Tt = (0, h.Z)(He).getInstance({ settings: We });
            function vt() {
              sn(null), Qt(null), _ = null, Z && (Z.reset(), Z = null), me && (me.reset(), me = null), le && le.reset(), We.reset(), fe && (fe.reset(), fe = null);
            }
            function ht() {
              return !!u && !!Ne.getElement();
            }
            function Wt() {
              return (0, Bu.e)();
            }
            function zt() {
              if (!y) throw nt;
              return oe.isPaused();
            }
            function gn() {
              if (!y) throw nt;
              return oe.getIsDynamic();
            }
            function pn(pe) {
              var be = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Je = k.getCurrentDVRInfo(be);
              if (!Je) return 0;
              var Nt = oe.getOriginalLiveDelay(), xt = Je.range.start + pe;
              return xt > Je.range.end - Nt && (xt = Je.range.end - Nt), xt;
            }
            function Ke(pe) {
              if (!y) throw nt;
              var be = $t().currentTime;
              if (pe !== void 0) be = D.getTimeRelativeToStreamId(be, pe);
              else if (oe.getIsDynamic()) {
                var Je = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Nt = k.getCurrentDVRInfo(Je);
                be = Nt === null || be === 0 ? 0 : Math.max(0, be - Nt.range.start);
              }
              return be;
            }
            function Et() {
              if (!y) throw nt;
              var pe = $t().duration;
              if (oe.getIsDynamic()) {
                var be = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Je = k.getCurrentDVRInfo(be);
                pe = Je ? Je.range.end - Je.range.start : 0;
              }
              return pe;
            }
            function lt(pe) {
              (0, X.PS)(pe, "boolean"), C = pe;
            }
            function Rt() {
              le.restoreDefaultUTCTimingSources();
            }
            function Pt() {
              return k;
            }
            function $t() {
              if (!Ne.getElement()) throw rt;
              return Ne.getElement();
            }
            function Qt(pe) {
              if (!w) throw we;
              Ne.setElement(pe), pe && (Xt(), function() {
                if (!me) {
                  var be = dashjs.MetricsReporting;
                  if (typeof be == "function") {
                    var Je = be(He).create();
                    me = Je.createMetricsReporting({ debug: Tt, eventBus: pt, mediaElement: $t(), adapter: _e, dashMetrics: k, mediaPlayerModel: q, events: l.Z, constants: t.Z, metricsConstants: m.Z });
                  }
                }
              }(), function() {
                if (!ae) {
                  var be = dashjs.MssHandler;
                  typeof be == "function" && ($.extend(be.errors), ae = be(He).create({ eventBus: pt, mediaPlayerModel: q, dashMetrics: k, manifestModel: ne, playbackController: oe, streamController: D, protectionController: Z, baseURLController: de, errHandler: K, events: l.Z, constants: t.Z, debug: Tt, initSegmentType: Ge.w.INIT_SEGMENT_TYPE, BASE64: oo, ISOBoxer: ra, settings: We }));
                }
              }(), D && D.switchToVideoElement(F)), y && kt(), ft(F);
            }
            function en(pe) {
              if (!I) throw ct;
              var be = D.getActiveStreamInfo();
              return be ? U.getTracksFor(pe, be.id) : [];
            }
            function sn(pe) {
              var be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              if (!w) throw we;
              typeof pe == "string" && Fe.initialize(pe), be == null && (be = NaN), isNaN(be) || (be = Math.max(0, be)), F = be, u = pe, (I || y) && kt(), ht() && ft(F);
            }
            function mt() {
              if (!I) throw ct;
              var pe = D.getActiveStreamInfo();
              return pe ? D.getStreamById(pe.id) : null;
            }
            function kt() {
              y = !1, I = !1, _e.reset(), D.reset(), A.reset(), ee.reset(), oe.reset(), Q.reset(), ue.reset(), Y.reset(), U.reset(), ut.reset(), Z && (We.get().streaming.protection.keepProtectionMediaKeys ? Z.stop() : (Z.reset(), Z = null, Xt())), O.reset(), ve.reset(), xe.reset();
            }
            function qt() {
              var pe = Vt();
              D || (D = xo(He).getInstance()), O || (O = Ac(He).create({ errHandler: K, manifestModel: ne, adapter: _e, mediaController: U, baseURLController: de, videoModel: Ne, settings: We })), L.setConfig({ capabilities: g, customParametersModel: le, adapter: _e, settings: We, manifestModel: ne, errHandler: K }), D.setConfig({ capabilities: g, capabilitiesFilter: L, manifestLoader: pe, manifestModel: ne, mediaPlayerModel: q, customParametersModel: le, protectionController: Z, textController: O, adapter: _e, dashMetrics: k, errHandler: K, timelineConverter: N, videoModel: Ne, playbackController: oe, serviceDescriptionController: Q, contentSteeringController: ue, abrController: Y, mediaController: U, settings: We, baseURLController: de, uriFragmentModel: Fe, segmentBaseController: ut }), A.setConfig({ settings: We, playbackController: oe, streamController: D, videoModel: Ne, timelineConverter: N, adapter: _e }), oe.setConfig({ streamController: D, serviceDescriptionController: Q, dashMetrics: k, adapter: _e, videoModel: Ne, timelineConverter: N, settings: We }), ee.setConfig({ streamController: D, playbackController: oe, mediaPlayerModel: q, videoModel: Ne, settings: We }), Y.setConfig({ streamController: D, domStorage: Le, mediaPlayerModel: q, customParametersModel: le, cmsdModel: xe, dashMetrics: k, adapter: _e, videoModel: Ne, settings: We }), ve.setConfig({ abrController: Y, dashMetrics: k, playbackController: oe }), xe.setConfig({}), Y.initialize(), D.initialize(C, _), O.initialize(), A.initialize(), ee.initialize(), ve.initialize(), xe.initialize(), ue.initialize(), ut.initialize();
            }
            function Vt() {
              return Su(He).create({ debug: Tt, errHandler: K, dashMetrics: k, mediaPlayerModel: q, requestModifier: (0, De.Z)(He).getInstance(), mssHandler: ae, settings: We });
            }
            function Xt() {
              if (Z) return Z;
              var pe = dashjs.Protection;
              if (typeof pe == "function") {
                var be = pe(He).create();
                return l.Z.extend(pe.events), n.Z.extend(pe.events, { publicOnly: !0 }), $.extend(pe.errors), g || (g = (0, os.Z)(He).getInstance()), Z = be.createProtectionSystem({ debug: Tt, errHandler: K, videoModel: Ne, customParametersModel: le, capabilities: g, eventBus: pt, events: l.Z, BASE64: oo, constants: t.Z, cmcdModel: ve, settings: We });
              }
              return null;
            }
            function ze() {
              if (!w) throw we;
              if (fe) return fe;
              var pe = dashjs.OfflineController;
              if (typeof pe == "function") {
                l.Z.extend(pe.events), n.Z.extend(pe.events, { publicOnly: !0 }), $.extend(pe.errors);
                var be = Vt(), Je = Oo(He).create();
                return Je.setConfig({ manifestModel: ne, adapter: _e, manifestLoader: be, errHandler: K, contentSteeringController: ue }), fe = pe(He).create({ debug: Tt, manifestUpdater: Je, baseURLController: de, manifestLoader: be, manifestModel: ne, mediaPlayerModel: q, abrController: Y, playbackController: oe, adapter: _e, errHandler: K, dashMetrics: k, timelineConverter: N, segmentBaseController: ut, schemeLoaderFactory: H, eventBus: pt, events: l.Z, errors: $, constants: t.Z, settings: We, dashConstants: e.Z, urlUtils: (0, tt.Z)(He).getInstance() });
              }
              return null;
            }
            function Pe(pe) {
              var be = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Je = k.getCurrentDVRInfo(be);
              return Je ? pe + (Je.manifestInfo.availableFrom.getTime() / 1e3 + Je.range.start) : 0;
            }
            function ft() {
              var pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN;
              fe && fe.resetRecords(), !I && u && (I = !0, r.info("Streaming Initialized"), qt(), typeof u == "string" ? D.load(u, pe) : D.loadWithManifest(u, pe)), !y && ht() && (y = !0, r.info("Playback Initialized"));
            }
            return i = { initialize: function(pe, be, Je) {
              var Nt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : NaN;
              g || (g = (0, os.Z)(He).getInstance()).setConfig({ settings: We }), K || (K = Au(He).getInstance()), g.supportsMediaSource() ? (w || (w = !0, N = fc(He).getInstance(), Y || (Y = Pu(He).getInstance()).setConfig({ settings: We }), H || (H = Wn(He).getInstance()), oe || (oe = d(He).getInstance()), U || (U = Yl(He).getInstance()), D || (D = xo(He).getInstance()), A || (A = Gl(He).getInstance()), ee || (ee = Hl(He).getInstance()), Q || (Q = Vl(He).getInstance()), ue || (ue = Cr(He).getInstance()), L || (L = Iu(He).getInstance()), _e = Wu(He).getInstance(), ne = Cu(He).getInstance(), ve = mn(He).getInstance(), xe = Ft(He).getInstance(), k = cc(He).getInstance({ settings: We }), Le = Zu(He).getInstance({ settings: We }), _e.setConfig({ constants: t.Z, cea608parser: E(), errHandler: K, BASE64: oo }), de || (de = $l(He).create()), de.setConfig({ adapter: _e, contentSteeringController: ue }), Q.setConfig({ adapter: _e }), ut || (ut = Hu(He).getInstance({ dashMetrics: k, mediaPlayerModel: q, errHandler: K, baseURLController: de, events: l.Z, eventBus: pt, debug: Tt, boxParser: (0, Ii.Z)(He).getInstance(), requestModifier: (0, De.Z)(He).getInstance(), errors: $ })), U.setConfig({ domStorage: Le, settings: We, customParametersModel: le }), q.setConfig({ playbackController: oe, serviceDescriptionController: Q }), ue.setConfig({ adapter: _e, errHandler: K, dashMetrics: k, mediaPlayerModel: q, manifestModel: ne, serviceDescriptionController: Q, eventBus: pt, requestModifier: (0, De.Z)(He).getInstance() }), Rt(), lt(Je === void 0 || Je), ze()), pe && Qt(pe), be && sn(be, Nt), r.info("[dash.js " + Wt() + "] MediaPlayer has been initialized")) : K.error(new se.Z($.CAPABILITY_MEDIASOURCE_ERROR_CODE, $.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE));
            }, setConfig: function(pe) {
              pe && (pe.capabilities && (g = pe.capabilities), pe.capabilitiesFilter && (L = pe.capabilitiesFilter), pe.streamController && (D = pe.streamController), pe.textController && (O = pe.textController), pe.gapController && (A = pe.gapController), pe.playbackController && (oe = pe.playbackController), pe.serviceDescriptionController && (Q = pe.serviceDescriptionController), pe.contentSteeringController && (ue = pe.contentSteeringController), pe.catchupController && (ee = pe.catchupController), pe.mediaPlayerModel && (q = pe.mediaPlayerModel), pe.customParametersModel && (le = pe.customParametersModel), pe.abrController && (Y = pe.abrController), pe.schemeLoaderFactory && (H = pe.schemeLoaderFactory), pe.mediaController && (U = pe.mediaController), pe.settings && (We = pe.settings));
            }, on: function(pe, be, Je, Nt) {
              pt.on(pe, be, Je, Nt);
            }, off: function(pe, be, Je) {
              pt.off(pe, be, Je);
            }, extend: function(pe, be, Je) {
              v.Z.extend(pe, be, Je, He);
            }, attachView: Qt, attachSource: sn, refreshManifest: function(pe) {
              if (!w) throw we;
              if (!ht()) return pe(null, Bt);
              var be = this;
              typeof pe == "function" && pt.on(l.Z.INTERNAL_MANIFEST_LOADED, function Je(Nt) {
                pt.off(l.Z.INTERNAL_MANIFEST_LOADED, Je, be), Nt.error ? pe(null, Nt.error) : pe(Nt.manifest);
              }, be), D.refreshManifest();
            }, isReady: ht, preload: function() {
              if (!Ne.getElement() && !I) {
                if (!u) throw Bt;
                ft(F);
              }
            }, play: function() {
              if (!y) throw nt;
              (!C || zt() && y) && oe.play(!0);
            }, isPaused: zt, pause: function() {
              if (!y) throw nt;
              oe.pause();
            }, isSeeking: function() {
              if (!y) throw nt;
              return oe.isSeeking();
            }, isDynamic: gn, getLowLatencyModeEnabled: function() {
              if (!y) throw nt;
              return oe.getLowLatencyModeEnabled();
            }, seek: function(pe) {
              if (!y) throw nt;
              if ((0, X.PS)(pe, "number"), isNaN(pe)) throw t.Z.BAD_ARGUMENT_ERROR;
              pe < 0 && (pe = 0);
              var be = oe.getIsDynamic() ? pn(pe) : pe, Je = $t();
              !oe.getIsDynamic() && Je.duration && (be = Math.min(Je.duration, be)), oe.seek(be, !1, !1, !0);
            }, seekToOriginalLive: function() {
              y && gn() && oe.seekToOriginalLive();
            }, setPlaybackRate: function(pe) {
              $t().playbackRate = pe;
            }, getPlaybackRate: function() {
              return $t().playbackRate;
            }, setMute: function(pe) {
              (0, X.PS)(pe, "boolean"), $t().muted = pe;
            }, isMuted: function() {
              return $t().muted;
            }, setVolume: function(pe) {
              if (typeof pe != "number" || isNaN(pe) || pe < 0 || pe > 1) throw t.Z.BAD_ARGUMENT_ERROR;
              $t().volume = pe;
            }, getVolume: function() {
              return $t().volume;
            }, time: Ke, duration: Et, timeAsUTC: function() {
              if (!y) throw nt;
              return Ke() < 0 ? NaN : Pe(Ke());
            }, durationAsUTC: function() {
              if (!y) throw nt;
              return Pe(Et());
            }, getActiveStream: mt, getDVRWindowSize: function() {
              var pe = D && D.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, be = k.getCurrentDVRInfo(pe);
              return be ? be.manifestInfo.dvrWindowSize : 0;
            }, getDVRSeekOffset: pn, getAvailableBaseUrls: function() {
              var pe = ne.getValue();
              return pe ? de.getBaseUrls(pe) : [];
            }, getAvailableLocations: function() {
              var pe = ne.getValue();
              if (!pe) return [];
              var be = _e.getLocation(pe), Je = ue.getSynthesizedLocationElements(be);
              return be.concat(Je);
            }, getTargetLiveDelay: function() {
              if (!y) throw nt;
              return oe.getOriginalLiveDelay();
            }, convertToTimeCode: function(pe) {
              pe = Math.max(pe, 0);
              var be = Math.floor(pe / 3600), Je = Math.floor(pe % 3600 / 60), Nt = Math.floor(pe % 3600 % 60);
              return (be === 0 ? "" : be < 10 ? "0" + be.toString() + ":" : be.toString() + ":") + (Je < 10 ? "0" + Je.toString() : Je.toString()) + ":" + (Nt < 10 ? "0" + Nt.toString() : Nt.toString());
            }, formatUTC: function(pe, be, Je) {
              var Nt = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], xt = new Date(1e3 * pe), yn = xt.toLocaleDateString(be), Ln = xt.toLocaleTimeString(be, { hour12: Je });
              return Nt ? Ln + " " + yn : Ln;
            }, getVersion: Wt, getDebug: function() {
              return Tt;
            }, getBufferLength: function(pe) {
              var be = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT];
              if (pe) return be.indexOf(pe) !== -1 ? Pt().getCurrentBufferLevel(pe) || NaN : (r.warn("getBufferLength requested for invalid type"), NaN);
              var Je = be.map(function(Nt) {
                return en(Nt).length > 0 ? Pt().getCurrentBufferLevel(Nt) : Number.MAX_VALUE;
              }).reduce(function(Nt, xt) {
                return Math.min(Nt, xt);
              });
              return Je === Number.MAX_VALUE ? NaN : Je;
            }, getTTMLRenderingDiv: function() {
              return Ne ? Ne.getTTMLRenderingDiv() : null;
            }, getVideoElement: $t, getSource: function() {
              if (!u) throw Bt;
              return u;
            }, updateSource: function(pe) {
              u = pe, D.load(u);
            }, getCurrentLiveLatency: function() {
              if (!w) throw we;
              return y ? oe.getCurrentLiveLatency() : NaN;
            }, getTopBitrateInfoFor: function(pe) {
              if (!I) throw ct;
              return Y.getTopBitrateInfoFor(pe);
            }, setAutoPlay: lt, getAutoPlay: function() {
              return C;
            }, getDashMetrics: Pt, getQualityFor: function(pe) {
              if (!I) throw ct;
              if (pe === t.Z.IMAGE) {
                var be = mt();
                if (!be) return -1;
                var Je = be.getThumbnailController();
                return Je ? Je.getCurrentTrackIndex() : -1;
              }
              return Y.getQualityFor(pe);
            }, setQualityFor: function(pe, be) {
              var Je = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              if (!I) throw ct;
              if (pe === t.Z.IMAGE) {
                var Nt = mt();
                if (!Nt) return;
                var xt = Nt.getThumbnailController();
                xt && xt.setTrackByIndex(be);
              }
              Y.setPlaybackQuality(pe, D.getActiveStreamInfo(), be, { forceReplace: Je });
            }, updatePortalSize: function() {
              Y.setElementSize(), Y.setWindowResizeEventCalled(!0);
            }, enableText: function(pe) {
              var be = D.getActiveStreamInfo();
              return !(!be || !O) && O.enableText(be.id, pe);
            }, enableForcedTextStreaming: function(pe) {
              return !(!D.getActiveStreamInfo() || !O) && O.enableForcedTextStreaming(pe);
            }, isTextEnabled: function() {
              var pe = D.getActiveStreamInfo();
              return !(!pe || !O) && O.isTextEnabled(pe);
            }, setTextTrack: function(pe) {
              if (!y) throw nt;
              var be = D.getActiveStreamInfo();
              be && O && O.setTextTrack(be.id, pe);
            }, getBitrateInfoListFor: function(pe) {
              if (!I) throw ct;
              var be = mt();
              return be ? be.getBitrateListFor(pe) : [];
            }, getStreamsFromManifest: function(pe) {
              if (!I) throw ct;
              return _e.getStreamsInfo(pe);
            }, getTracksFor: en, getTracksForTypeFromManifest: function(pe, be, Je) {
              if (!I) throw ct;
              return (Je = Je || _e.getStreamsInfo(be, 1)[0]) ? _e.getAllMediaInfoForType(Je, pe, be) : [];
            }, getCurrentTrackFor: function(pe) {
              if (!I) throw ct;
              var be = D.getActiveStreamInfo();
              return U.getCurrentTrackFor(pe, be.id);
            }, setInitialMediaSettingsFor: function(pe, be) {
              if (!w) throw we;
              U.setInitialSettings(pe, be);
            }, getInitialMediaSettingsFor: function(pe) {
              if (!w) throw we;
              return U.getInitialSettings(pe);
            }, setCurrentTrack: function(pe) {
              var be = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              if (!I) throw ct;
              U.setTrack(pe, be);
            }, addABRCustomRule: function(pe, be, Je) {
              le.addAbrCustomRule(pe, be, Je);
            }, removeABRCustomRule: function(pe) {
              le.removeAbrCustomRule(pe);
            }, removeAllABRCustomRule: function() {
              le.removeAllAbrCustomRule();
            }, getABRCustomRules: function() {
              return le.getAbrCustomRules();
            }, getAverageThroughput: function(pe) {
              var be = Y.getThroughputHistory(), Je = oe.getIsDynamic();
              return be ? be.getAverageThroughput(pe, Je) : 0;
            }, retrieveManifest: function(pe, be) {
              var Je = Vt(), Nt = this;
              pt.on(l.Z.INTERNAL_MANIFEST_LOADED, function xt(yn) {
                yn.error ? be(null, yn.error) : be(yn.manifest), pt.off(l.Z.INTERNAL_MANIFEST_LOADED, xt, Nt), Je.reset();
              }, Nt), Fe.initialize(pe), Je.load(pe);
            }, addUTCTimingSource: function(pe, be) {
              le.addUTCTimingSource(pe, be);
            }, removeUTCTimingSource: function(pe, be) {
              le.removeUTCTimingSource(pe, be);
            }, clearDefaultUTCTimingSources: function() {
              le.clearDefaultUTCTimingSources();
            }, restoreDefaultUTCTimingSources: Rt, setXHRWithCredentialsForType: function(pe, be) {
              le.setXHRWithCredentialsForType(pe, be);
            }, getXHRWithCredentialsForType: function(pe) {
              return le.getXHRWithCredentialsForType(pe);
            }, getProtectionController: function() {
              return Xt();
            }, attachProtectionController: function(pe) {
              Z = pe;
            }, setProtectionData: function(pe) {
              _ = pe, D && D.setProtectionData(_);
            }, registerLicenseRequestFilter: function(pe) {
              le.registerLicenseRequestFilter(pe);
            }, registerLicenseResponseFilter: function(pe) {
              le.registerLicenseResponseFilter(pe);
            }, unregisterLicenseRequestFilter: function(pe) {
              le.unregisterLicenseRequestFilter(pe);
            }, unregisterLicenseResponseFilter: function(pe) {
              le.unregisterLicenseResponseFilter(pe);
            }, registerCustomCapabilitiesFilter: function(pe) {
              le.registerCustomCapabilitiesFilter(pe);
            }, unregisterCustomCapabilitiesFilter: function(pe) {
              le.unregisterCustomCapabilitiesFilter(pe);
            }, setCustomInitialTrackSelectionFunction: function(pe) {
              le.setCustomInitialTrackSelectionFunction(pe);
            }, resetCustomInitialTrackSelectionFunction: function() {
              le.resetCustomInitialTrackSelectionFunction(null);
            }, attachTTMLRenderingDiv: function(pe) {
              if (!Ne.getElement()) throw rt;
              Ne.setTTMLRenderingDiv(pe);
            }, attachVttRenderingDiv: function(pe) {
              if (!Ne.getElement()) throw rt;
              Ne.setVttRenderingDiv(pe);
            }, getCurrentTextTrackIndex: function() {
              var pe = D.getActiveStreamInfo();
              if (pe && O) return O.getCurrentTrackIdx(pe.id);
            }, provideThumbnail: function(pe, be) {
              if (typeof be == "function") if (pe < 0) be(null);
              else {
                var Je = oe.getIsDynamic() ? pn(pe) : pe, Nt = D.getStreamForTime(Je);
                if (Nt !== null) {
                  var xt = Nt.getThumbnailController();
                  if (xt) return xt.provide(Je, be);
                  be(null);
                } else be(null);
              }
            }, getDashAdapter: function() {
              return _e;
            }, getOfflineController: function() {
              return ze();
            }, triggerSteeringRequest: function() {
              if (ue) return ue.loadSteeringData();
            }, getCurrentSteeringResponseData: function() {
              if (ue) return ue.getCurrentSteeringResponseData();
            }, getSettings: function() {
              return We.get();
            }, updateSettings: function(pe) {
              We.update(pe);
            }, resetSettings: function() {
              We.reset();
            }, reset: vt, destroy: function() {
              vt(), v.Z.deleteSingletonInstances(He);
            } }, r = Tt.getLogger(i), w = !1, y = !1, I = !1, C = !0, F = NaN, Z = null, fe = null, _ = null, _e = null, ut = null, l.Z.extend(n.Z), q = Nu(He).getInstance(), le = (0, Yn.Z)(He).getInstance(), Ne = Fu(He).getInstance(), Fe = Ru(He).getInstance(), i;
          }
          co.__dashjs_factory_name = "MediaPlayer";
          var aa = v.Z.getClassFactory(co);
          aa.events = n.Z, aa.errors = $, v.Z.updateClassFactory(co.__dashjs_factory_name, aa);
          var Ic = aa;
        }, 8825: function(Se, ge, R) {
          function te(p) {
            return te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
              return typeof l;
            } : function(l) {
              return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
            }, te(p);
          }
          function E(p, l) {
            return E = Object.setPrototypeOf || function(v, h) {
              return v.__proto__ = h, v;
            }, E(p, l);
          }
          function t(p, l) {
            return !l || te(l) !== "object" && typeof l != "function" ? function(v) {
              if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }(p) : l;
          }
          function e(p) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(l) {
              return l.__proto__ || Object.getPrototypeOf(l);
            }, e(p);
          }
          var m = new (function(p) {
            (function(f, d) {
              if (typeof d != "function" && d !== null) throw new TypeError("Super expression must either be null or a function");
              f.prototype = Object.create(d && d.prototype, { constructor: { value: f, writable: !0, configurable: !0 } }), d && E(f, d);
            })(n, p);
            var l, v, h = (l = n, v = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var f, d = e(l);
              if (v) {
                var S = e(this).constructor;
                f = Reflect.construct(d, arguments, S);
              } else f = d.apply(this, arguments);
              return t(this, f);
            });
            function n() {
              var f;
              return function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (f = h.call(this)).AST_IN_FUTURE = "astInFuture", f.BASE_URLS_UPDATED = "baseUrlsUpdated", f.BUFFER_EMPTY = "bufferStalled", f.BUFFER_LOADED = "bufferLoaded", f.BUFFER_LEVEL_STATE_CHANGED = "bufferStateChanged", f.BUFFER_LEVEL_UPDATED = "bufferLevelUpdated", f.DVB_FONT_DOWNLOAD_ADDED = "dvbFontDownloadAdded", f.DVB_FONT_DOWNLOAD_COMPLETE = "dvbFontDownloadComplete", f.DVB_FONT_DOWNLOAD_FAILED = "dvbFontDownloadFailed", f.DYNAMIC_TO_STATIC = "dynamicToStatic", f.ERROR = "error", f.FRAGMENT_LOADING_COMPLETED = "fragmentLoadingCompleted", f.FRAGMENT_LOADING_PROGRESS = "fragmentLoadingProgress", f.FRAGMENT_LOADING_STARTED = "fragmentLoadingStarted", f.FRAGMENT_LOADING_ABANDONED = "fragmentLoadingAbandoned", f.LOG = "log", f.MANIFEST_LOADING_STARTED = "manifestLoadingStarted", f.MANIFEST_LOADING_FINISHED = "manifestLoadingFinished", f.MANIFEST_LOADED = "manifestLoaded", f.METRICS_CHANGED = "metricsChanged", f.METRIC_CHANGED = "metricChanged", f.METRIC_ADDED = "metricAdded", f.METRIC_UPDATED = "metricUpdated", f.PERIOD_SWITCH_STARTED = "periodSwitchStarted", f.PERIOD_SWITCH_COMPLETED = "periodSwitchCompleted", f.QUALITY_CHANGE_REQUESTED = "qualityChangeRequested", f.QUALITY_CHANGE_RENDERED = "qualityChangeRendered", f.TRACK_CHANGE_RENDERED = "trackChangeRendered", f.STREAM_INITIALIZING = "streamInitializing", f.STREAM_UPDATED = "streamUpdated", f.STREAM_ACTIVATED = "streamActivated", f.STREAM_DEACTIVATED = "streamDeactivated", f.STREAM_INITIALIZED = "streamInitialized", f.STREAM_TEARDOWN_COMPLETE = "streamTeardownComplete", f.TEXT_TRACKS_ADDED = "allTextTracksAdded", f.TEXT_TRACK_ADDED = "textTrackAdded", f.CUE_ENTER = "cueEnter", f.CUE_EXIT = "cueExit", f.THROUGHPUT_MEASUREMENT_STORED = "throughputMeasurementStored", f.TTML_PARSED = "ttmlParsed", f.TTML_TO_PARSE = "ttmlToParse", f.CAPTION_RENDERED = "captionRendered", f.CAPTION_CONTAINER_RESIZE = "captionContainerResize", f.CAN_PLAY = "canPlay", f.CAN_PLAY_THROUGH = "canPlayThrough", f.PLAYBACK_ENDED = "playbackEnded", f.PLAYBACK_ERROR = "playbackError", f.PLAYBACK_NOT_ALLOWED = "playbackNotAllowed", f.PLAYBACK_METADATA_LOADED = "playbackMetaDataLoaded", f.PLAYBACK_LOADED_DATA = "playbackLoadedData", f.PLAYBACK_PAUSED = "playbackPaused", f.PLAYBACK_PLAYING = "playbackPlaying", f.PLAYBACK_PROGRESS = "playbackProgress", f.PLAYBACK_RATE_CHANGED = "playbackRateChanged", f.PLAYBACK_SEEKED = "playbackSeeked", f.PLAYBACK_SEEKING = "playbackSeeking", f.PLAYBACK_STALLED = "playbackStalled", f.PLAYBACK_STARTED = "playbackStarted", f.PLAYBACK_TIME_UPDATED = "playbackTimeUpdated", f.PLAYBACK_VOLUME_CHANGED = "playbackVolumeChanged", f.PLAYBACK_WAITING = "playbackWaiting", f.MANIFEST_VALIDITY_CHANGED = "manifestValidityChanged", f.EVENT_MODE_ON_START = "eventModeOnStart", f.EVENT_MODE_ON_RECEIVE = "eventModeOnReceive", f.CONFORMANCE_VIOLATION = "conformanceViolation", f.REPRESENTATION_SWITCH = "representationSwitch", f.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = "adaptationSetRemovedNoCapabilities", f.CONTENT_STEERING_REQUEST_COMPLETED = "contentSteeringRequestCompleted", f.INBAND_PRFT = "inbandPrft", f.MANAGED_MEDIA_SOURCE_START_STREAMING = "managedMediaSourceStartStreaming", f.MANAGED_MEDIA_SOURCE_END_STREAMING = "managedMediaSourceEndStreaming", f;
            }
            return n;
          }(R(8342).Z))();
          ge.Z = m;
        }, 3393: function(Se, ge) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var m = t[e];
              m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(E, m.key, m);
            }
          }
          var te = new (function() {
            function E() {
              (function(m, p) {
                if (!(m instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E), this.init();
            }
            var t, e;
            return t = E, (e = [{ key: "init", value: function() {
              this.STREAM = "stream", this.VIDEO = "video", this.AUDIO = "audio", this.TEXT = "text", this.MUXED = "muxed", this.IMAGE = "image", this.STPP = "stpp", this.TTML = "ttml", this.VTT = "vtt", this.WVTT = "wvtt", this.CONTENT_STEERING = "contentSteering", this.ABR_STRATEGY_DYNAMIC = "abrDynamic", this.ABR_STRATEGY_BOLA = "abrBola", this.ABR_STRATEGY_L2A = "abrL2A", this.ABR_STRATEGY_LoLP = "abrLoLP", this.ABR_STRATEGY_THROUGHPUT = "abrThroughput", this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA = "abrFetchThroughputCalculationDownloadedData", this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING = "abrFetchThroughputCalculationMoofParsing", this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST = "abrFetchThroughputCalculationAAST", this.LIVE_CATCHUP_MODE_DEFAULT = "liveCatchupModeDefault", this.LIVE_CATCHUP_MODE_LOLP = "liveCatchupModeLoLP", this.MOVING_AVERAGE_SLIDING_WINDOW = "slidingWindow", this.MOVING_AVERAGE_EWMA = "ewma", this.BAD_ARGUMENT_ERROR = "Invalid Arguments", this.MISSING_CONFIG_ERROR = "Missing config parameter(s)", this.TRACK_SWITCH_MODE_ALWAYS_REPLACE = "alwaysReplace", this.TRACK_SWITCH_MODE_NEVER_REPLACE = "neverReplace", this.TRACK_SELECTION_MODE_FIRST_TRACK = "firstTrack", this.TRACK_SELECTION_MODE_HIGHEST_BITRATE = "highestBitrate", this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY = "highestEfficiency", this.TRACK_SELECTION_MODE_WIDEST_RANGE = "widestRange", this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY = "highestSelectionPriority", this.CMCD_MODE_QUERY = "query", this.CMCD_MODE_HEADER = "header", this.INITIALIZE = "initialize", this.TEXT_SHOWING = "showing", this.TEXT_HIDDEN = "hidden", this.TEXT_DISABLED = "disabled", this.CC1 = "CC1", this.CC3 = "CC3", this.UTF8 = "utf-8", this.SCHEME_ID_URI = "schemeIdUri", this.START_TIME = "starttime", this.SERVICE_DESCRIPTION_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:scope:2019", this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:critical:2019", this.FONT_DOWNLOAD_DVB_SCHEME = "urn:dvb:dash:fontdownload:2014", this.XML = "XML", this.ARRAY_BUFFER = "ArrayBuffer", this.DVB_REPORTING_URL = "dvb:reportingUrl", this.DVB_PROBABILITY = "dvb:probability", this.OFF_MIMETYPE = "application/font-sfnt", this.WOFF_MIMETYPE = "application/font-woff", this.VIDEO_ELEMENT_READY_STATES = { HAVE_NOTHING: 0, HAVE_METADATA: 1, HAVE_CURRENT_DATA: 2, HAVE_FUTURE_DATA: 3, HAVE_ENOUGH_DATA: 4 }, this.FILE_LOADER_TYPES = { FETCH: "fetch_loader", XHR: "xhr_loader" };
            } }]) && R(t.prototype, e), E;
          }())();
          ge.Z = te;
        }, 3860: function(Se, ge) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var m = t[e];
              m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(E, m.key, m);
            }
          }
          var te = new (function() {
            function E() {
              (function(m, p) {
                if (!(m instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E), this.init();
            }
            var t, e;
            return t = E, (e = [{ key: "init", value: function() {
              this.TCP_CONNECTION = "TcpList", this.HTTP_REQUEST = "HttpList", this.TRACK_SWITCH = "RepSwitchList", this.BUFFER_LEVEL = "BufferLevel", this.BUFFER_LOADED = "bufferLoaded", this.ABANDON_LOAD = "abandonload", this.ALLOW_LOAD = "allowload", this.BUFFER_EMPTY = "bufferStalled", this.BUFFER_STATE = "BufferState", this.DVR_INFO = "DVRInfo", this.DROPPED_FRAMES = "DroppedFrames", this.SCHEDULING_INFO = "SchedulingInfo", this.REQUESTS_QUEUE = "RequestsQueue", this.MANIFEST_UPDATE = "ManifestUpdate", this.MANIFEST_UPDATE_STREAM_INFO = "ManifestUpdatePeriodInfo", this.MANIFEST_UPDATE_TRACK_INFO = "ManifestUpdateRepresentationInfo", this.PLAY_LIST = "PlayList", this.DVB_ERRORS = "DVBErrors", this.HTTP_REQUEST_DVB_REPORTING_TYPE = "DVBReporting";
            } }]) && R(t.prototype, e), E;
          }())();
          ge.Z = te;
        }, 8080: function(Se, ge, R) {
          R.d(ge, { default: function() {
            return T;
          } });
          var te = function b() {
            (function(X, z) {
              if (!(X instanceof z)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.mpdurl = null, this.errorcode = null, this.terror = null, this.url = null, this.ipaddress = null, this.servicelocation = null;
          };
          te.SSL_CONNECTION_FAILED_PREFIX = "SSL", te.DNS_RESOLUTION_FAILED = "C00", te.HOST_UNREACHABLE = "C01", te.CONNECTION_REFUSED = "C02", te.CONNECTION_ERROR = "C03", te.CORRUPT_MEDIA_ISOBMFF = "M00", te.CORRUPT_MEDIA_OTHER = "M01", te.BASE_URL_CHANGED = "F00", te.BECAME_REPORTER = "S00";
          var E = te, t = R(1180);
          function e(b) {
            var X, z, De = (b = b || {}).eventBus, tt = b.dashMetrics, Ue = b.metricsConstants, ke = b.events;
            function Oe(Mt) {
              var Ht = new E();
              if (z) {
                for (var Ut in Mt) Mt.hasOwnProperty(Ut) && (Ht[Ut] = Mt[Ut]);
                Ht.mpdurl || (Ht.mpdurl = z.originalUrl || z.url), Ht.terror || (Ht.terror = /* @__PURE__ */ new Date()), tt.addDVBErrors(Ht);
              }
            }
            function qe(Mt) {
              Mt.error || (z = Mt.manifest);
            }
            function it(Mt) {
              Oe({ errorcode: E.BASE_URL_CHANGED, servicelocation: Mt.entry });
            }
            function bt() {
              Oe({ errorcode: E.BECAME_REPORTER });
            }
            function dt(Mt) {
              var Ht;
              Mt.metric === Ue.HTTP_REQUEST && ((Ht = Mt.value).responsecode === 0 || Ht.responsecode == null || Ht.responsecode >= 400 || Ht.responsecode < 100 || Ht.responsecode >= 600) && Oe({ errorcode: Ht.responsecode || E.CONNECTION_ERROR, url: Ht.url, terror: Ht.tresponse, servicelocation: Ht._serviceLocation });
            }
            function Yt(Mt) {
              var Ht;
              switch (Mt.error ? Mt.error.code : 0) {
                case MediaError.MEDIA_ERR_NETWORK:
                  Ht = E.CONNECTION_ERROR;
                  break;
                case MediaError.MEDIA_ERR_DECODE:
                  Ht = E.CORRUPT_MEDIA_OTHER;
                  break;
                default:
                  return;
              }
              Oe({ errorcode: Ht });
            }
            return X = { initialize: function() {
              De.on(ke.MANIFEST_UPDATED, qe, X), De.on(ke.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, it, X), De.on(ke.METRIC_ADDED, dt, X), De.on(ke.METRIC_UPDATED, dt, X), De.on(ke.PLAYBACK_ERROR, Yt, X), De.on(t.Z.BECAME_REPORTING_PLAYER, bt, X);
            }, reset: function() {
              De.off(ke.MANIFEST_UPDATED, qe, X), De.off(ke.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, it, X), De.off(ke.METRIC_ADDED, dt, X), De.off(ke.METRIC_UPDATED, dt, X), De.off(ke.PLAYBACK_ERROR, Yt, X), De.off(t.Z.BECAME_REPORTING_PLAYER, bt, X);
            } };
          }
          e.__dashjs_factory_name = "DVBErrorsTranslator";
          var m = dashjs.FactoryMaker.getSingletonFactory(e), p = R(2295);
          function l(b) {
            b = b || {};
            var X, z, De = !1, tt = this.context, Ue = b.mediaElement;
            return X = { initialize: function(ke) {
              ke && ke.length && (ke.forEach(function(Oe) {
                var qe = Oe.starttime, it = qe + Oe.duration;
                z.add(qe, it);
              }), De = !!ke[0]._useWallClockTime);
            }, reset: function() {
              z.clear();
            }, isEnabled: function() {
              var ke, Oe = z.length;
              if (!Oe) return !0;
              ke = De ? (/* @__PURE__ */ new Date()).getTime() / 1e3 : Ue.currentTime;
              for (var qe = 0; qe < Oe; qe += 1) {
                var it = z.start(qe), bt = z.end(qe);
                if (it <= ke && ke < bt) return !0;
              }
              return !1;
            } }, z = (0, p.Z)(tt).create(), X;
          }
          l.__dashjs_factory_name = "RangeController";
          var v = dashjs.FactoryMaker.getClassFactory(l);
          function h() {
            return { serialise: function b(X) {
              var z, De, tt = [], Ue = [];
              for (z in X) if (X.hasOwnProperty(z) && z.indexOf("_") !== 0) {
                if ((De = X[z]) == null && (De = ""), Array.isArray(De)) {
                  if (!De.length) continue;
                  Ue = [], De.forEach(function(ke) {
                    var Oe = Object.prototype.toString.call(ke).slice(8, -1) !== "Object";
                    Ue.push(Oe ? ke : b(ke));
                  }), De = Ue.map(encodeURIComponent).join(",");
                } else typeof De == "string" ? De = encodeURIComponent(De) : De instanceof Date ? De = De.toISOString() : typeof De == "number" && (De = Math.round(De));
                tt.push(z + "=" + De);
              }
              return tt.join("&");
            } };
          }
          h.__dashjs_factory_name = "MetricSerialiser";
          var n = dashjs.FactoryMaker.getSingletonFactory(h);
          function f() {
            var b, X, z, De = window.crypto || window.msCrypto, tt = Uint32Array, Ue = Math.pow(2, 8 * tt.BYTES_PER_ELEMENT) - 1;
            function ke() {
              De && (b || (b = new tt(10)), De.getRandomValues(b), X = 0);
            }
            return z = { random: function(Oe, qe) {
              var it;
              return Oe || (Oe = 0), qe || (qe = 1), De ? (X === b.length && ke(), it = b[X] / Ue, X += 1) : it = Math.random(), it * (qe - Oe) + Oe;
            } }, ke(), z;
          }
          f.__dashjs_factory_name = "RNG";
          var d = dashjs.FactoryMaker.getSingletonFactory(f), S = R(5717);
          function x(b) {
            var X;
            b = b || {};
            var z, De, tt, Ue, ke, Oe, qe, it = this.context, bt = [], dt = b.metricsConstants;
            function Yt() {
              Ue = !1, ke = !1, Oe = null, qe = null;
            }
            return X = { report: function(Mt, Ht) {
              Array.isArray(Ht) || (Ht = [Ht]), ke && qe.isEnabled() && Ht.forEach(function(Ut) {
                var cn = z.serialise(Ut);
                Mt !== dt.DVB_ERRORS && (cn = "metricname=".concat(Mt, "&").concat(cn)), function(Tn, xn, Mn) {
                  var kn = new XMLHttpRequest();
                  kn.withCredentials = De.getXHRWithCredentialsForType(dt.HTTP_REQUEST_DVB_REPORTING_TYPE);
                  var tr = function() {
                    var wn = bt.indexOf(kn);
                    wn !== -1 && (bt.splice(wn, 1), !(kn.status >= 200 && kn.status < 300) && Mn());
                  };
                  bt.push(kn);
                  try {
                    kn.open("GET", Tn), kn.onloadend = tr, kn.onerror = tr, kn.send();
                  } catch {
                    kn.onerror();
                  }
                }(cn = "".concat(Oe, "?").concat(cn), 0, function() {
                  ke = !1;
                });
              });
            }, initialize: function(Mt, Ht) {
              var Ut;
              if (qe = Ht, !(Oe = Mt.dvbReportingUrl)) throw new Error("required parameter missing (dvb:reportingUrl)");
              Ue || ((Ut = Mt.dvbProbability) && (Ut === 1e3 || Ut / 1e3 >= tt.random()) && (ke = !0), Ue = !0);
            }, reset: function() {
              Yt();
            } }, z = n(it).getInstance(), tt = d(it).getInstance(), De = (0, S.Z)(it).getInstance(), Yt(), X;
          }
          x.__dashjs_factory_name = "DVBReporting";
          var G = dashjs.FactoryMaker.getClassFactory(x);
          function P(b) {
            b = b || {};
            var X, z = { "urn:dvb:dash:reporting:2014": G }, De = this.context, tt = b.debug ? b.debug.getLogger(X) : {}, Ue = b.metricsConstants, ke = b.mediaPlayerModel || {};
            return { create: function(Oe, qe) {
              var it;
              try {
                (it = z[Oe.schemeIdUri](De).create({ metricsConstants: Ue, mediaPlayerModel: ke })).initialize(Oe, qe);
              } catch (bt) {
                it = null, tt.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(Oe.schemeIdUri, " (").concat(bt.message, ")"));
              }
              return it;
            }, register: function(Oe, qe) {
              z[Oe] = qe;
            }, unregister: function(Oe) {
              delete z[Oe];
            } };
          }
          P.__dashjs_factory_name = "ReportingFactory";
          var J = dashjs.FactoryMaker.getSingletonFactory(P);
          function M(b) {
            var X = [], z = J(this.context).getInstance(b);
            return { initialize: function(De, tt) {
              De.some(function(Ue) {
                var ke = z.create(Ue, tt);
                if (ke) return X.push(ke), !0;
              });
            }, reset: function() {
              X.forEach(function(De) {
                return De.reset();
              }), X = [];
            }, report: function(De, tt) {
              X.forEach(function(Ue) {
                return Ue.report(De, tt);
              });
            } };
          }
          M.__dashjs_factory_name = "ReportingController";
          var W = dashjs.FactoryMaker.getClassFactory(M);
          function se() {
            return { reconstructFullMetricName: function(b, X, z) {
              var De = b;
              return X && (De += "(" + X, z && z.length && (De += "," + z), De += ")"), De;
            }, validateN: function(b) {
              if (!b) throw new Error("missing n");
              if (isNaN(b)) throw new Error("n is NaN");
              if (b < 0) throw new Error("n must be positive");
              return b;
            } };
          }
          se.__dashjs_factory_name = "HandlerHelpers";
          var j = dashjs.FactoryMaker.getSingletonFactory(se);
          function re(b) {
            var X, z, De, tt, Ue;
            b = b || {};
            var ke = this.context, Oe = j(ke).getInstance(), qe = [], it = b.metricsConstants;
            function bt() {
              var dt = function() {
                try {
                  return Object.keys(qe).map(function(Yt) {
                    return qe[Yt];
                  }).reduce(function(Yt, Mt) {
                    return Yt.level < Mt.level ? Yt : Mt;
                  });
                } catch {
                  return;
                }
              }();
              dt && Ue !== dt.t && (Ue = dt.t, X.report(De, dt));
            }
            return { initialize: function(dt, Yt, Mt) {
              Yt && (z = Oe.validateN(Mt), X = Yt, De = Oe.reconstructFullMetricName(dt, Mt), tt = setInterval(bt, z));
            }, reset: function() {
              clearInterval(tt), tt = null, z = 0, X = null, Ue = null;
            }, handleNewMetric: function(dt, Yt, Mt) {
              dt === it.BUFFER_LEVEL && (qe[Mt] = Yt);
            } };
          }
          re.__dashjs_factory_name = "BufferLevelHandler";
          var ce = dashjs.FactoryMaker.getClassFactory(re), Re = dashjs.FactoryMaker.getClassFactory(function(b) {
            var X, z = (b = b || {}).eventBus, De = b.metricsConstants;
            function tt() {
              z.off(t.Z.METRICS_INITIALISATION_COMPLETE, tt, this), z.trigger(t.Z.BECAME_REPORTING_PLAYER);
            }
            return { initialize: function(Ue, ke) {
              ke && (X = ke, z.on(t.Z.METRICS_INITIALISATION_COMPLETE, tt, this));
            }, reset: function() {
              X = null;
            }, handleNewMetric: function(Ue, ke) {
              Ue === De.DVB_ERRORS && X && X.report(Ue, ke);
            } };
          });
          function $(b) {
            var X, z, De, tt, Ue;
            b = b || {};
            var ke = [], Oe = j(this.context).getInstance(), qe = b.metricsConstants;
            function it() {
              var bt = ke;
              bt.length && X && X.report(tt, bt), ke = [];
            }
            return { initialize: function(bt, dt, Yt, Mt) {
              dt && (z = Oe.validateN(Yt), X = dt, Mt && Mt.length && (De = Mt), tt = Oe.reconstructFullMetricName(bt, Yt, Mt), Ue = setInterval(it, z));
            }, reset: function() {
              clearInterval(Ue), Ue = null, z = null, De = null, ke = [], X = null;
            }, handleNewMetric: function(bt, dt) {
              bt === qe.HTTP_REQUEST && (De && De !== dt.type || ke.push(dt));
            } };
          }
          $.__dashjs_factory_name = "HttpListHandler";
          var Me = dashjs.FactoryMaker.getClassFactory($);
          function Ge() {
            var b, X;
            return { initialize: function(z, De) {
              b = z, X = De;
            }, reset: function() {
              X = null, b = void 0;
            }, handleNewMetric: function(z, De) {
              z === b && X && X.report(b, De);
            } };
          }
          Ge.__dashjs_factory_name = "GenericMetricHandler";
          var Qe = dashjs.FactoryMaker.getClassFactory(Ge);
          function Ae(b) {
            var X, z = (b = b || {}).debug ? b.debug.getLogger(X) : {}, De = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/, tt = this.context, Ue = { BufferLevel: ce, DVBErrors: Re, HttpList: Me, PlayList: Qe, RepSwitchList: Qe, TcpList: Qe };
            return { create: function(ke, Oe) {
              var qe, it = ke.match(De);
              if (it) {
                try {
                  (qe = Ue[it[1]](tt).create({ eventBus: b.eventBus, metricsConstants: b.metricsConstants })).initialize(it[1], Oe, it[3], it[5]);
                } catch (bt) {
                  qe = null, z.error("MetricsHandlerFactory: Could not create handler for type ".concat(it[1], " with args ").concat(it[3], ", ").concat(it[5], " (").concat(bt.message, ")"));
                }
                return qe;
              }
            }, register: function(ke, Oe) {
              Ue[ke] = Oe;
            }, unregister: function(ke) {
              delete Ue[ke];
            } };
          }
          Ae.__dashjs_factory_name = "MetricsHandlerFactory";
          var Ze = dashjs.FactoryMaker.getSingletonFactory(Ae);
          function Xe(b) {
            b = b || {};
            var X, z = [], De = this.context, tt = b.eventBus, Ue = b.events, ke = Ze(De).getInstance({ debug: b.debug, eventBus: b.eventBus, metricsConstants: b.metricsConstants });
            function Oe(qe) {
              z.forEach(function(it) {
                it.handleNewMetric(qe.metric, qe.value, qe.mediaType);
              });
            }
            return X = { initialize: function(qe, it) {
              qe.split(",").forEach(function(bt, dt, Yt) {
                var Mt;
                if (bt.indexOf("(") !== -1 && bt.indexOf(")") === -1) {
                  var Ht = Yt[dt + 1];
                  Ht && Ht.indexOf("(") === -1 && Ht.indexOf(")") !== -1 && (bt += "," + Ht, delete Yt[dt + 1]);
                }
                (Mt = ke.create(bt, it)) && z.push(Mt);
              }), tt.on(Ue.METRIC_ADDED, Oe, X), tt.on(Ue.METRIC_UPDATED, Oe, X);
            }, reset: function() {
              tt.off(Ue.METRIC_ADDED, Oe, X), tt.off(Ue.METRIC_UPDATED, Oe, X), z.forEach(function(qe) {
                return qe.reset();
              }), z = [];
            } };
          }
          Xe.__dashjs_factory_name = "MetricsHandlersController";
          var at = dashjs.FactoryMaker.getClassFactory(Xe);
          function Ie(b) {
            var X, z, De;
            b = b || {};
            var tt = this.context;
            function Ue() {
              X && X.reset(), z && z.reset(), De && De.reset();
            }
            return { initialize: function(ke) {
              try {
                (De = v(tt).create({ mediaElement: b.mediaElement })).initialize(ke.Range), (z = W(tt).create({ debug: b.debug, metricsConstants: b.metricsConstants, mediaPlayerModel: b.mediaPlayerModel })).initialize(ke.Reporting, De), (X = at(tt).create({ debug: b.debug, eventBus: b.eventBus, metricsConstants: b.metricsConstants, events: b.events })).initialize(ke.metrics, z);
              } catch (Oe) {
                throw Ue(), Oe;
              }
            }, reset: Ue };
          }
          Ie.__dashjs_factory_name = "MetricsController";
          var Be = dashjs.FactoryMaker.getClassFactory(Ie), It = function b() {
            (function(X, z) {
              if (!(X instanceof z)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.metrics = "", this.Range = [], this.Reporting = [];
          }, _t = function b() {
            (function(X, z) {
              if (!(X instanceof z)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.starttime = 0, this.duration = 1 / 0, this._useWallClockTime = !1;
          }, Ve = function b() {
            (function(X, z) {
              if (!(X instanceof z)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.schemeIdUri = "", this.value = "", this.dvbReportingUrl = "", this.dvbProbability = 1e3;
          };
          function ot(b) {
            var X = (b = b || {}).adapter, z = b.constants;
            return { getMetrics: function(De) {
              var tt = [];
              return De && De.Metrics_asArray && De.Metrics_asArray.forEach(function(Ue) {
                var ke = new It(), Oe = X.getIsDynamic(De);
                Ue.hasOwnProperty("metrics") && (ke.metrics = Ue.metrics, Ue.Range_asArray && Ue.Range_asArray.forEach(function(qe) {
                  var it = new _t();
                  it.starttime = function(bt, dt, Yt) {
                    var Mt, Ht, Ut = 0;
                    return dt ? Ut = X.getAvailabilityStartTime(bt) / 1e3 : (Mt = X.getRegularPeriods(bt)).length && (Ut = Mt[0].start), Ht = Ut, Yt && Yt.hasOwnProperty(z.START_TIME) && (Ht += Yt.starttime), Ht;
                  }(De, Oe, qe), qe.hasOwnProperty("duration") ? it.duration = qe.duration : it.duration = X.getDuration(De), it._useWallClockTime = Oe, ke.Range.push(it);
                }), Ue.Reporting_asArray && (Ue.Reporting_asArray.forEach(function(qe) {
                  var it = new Ve();
                  qe.hasOwnProperty(z.SCHEME_ID_URI) && (it.schemeIdUri = qe.schemeIdUri, qe.hasOwnProperty("value") && (it.value = qe.value), qe.hasOwnProperty(z.DVB_REPORTING_URL) && (it.dvbReportingUrl = qe[z.DVB_REPORTING_URL]), qe.hasOwnProperty(z.DVB_PROBABILITY) && (it.dvbProbability = qe[z.DVB_PROBABILITY]), ke.Reporting.push(it));
                }), tt.push(ke)));
              }), tt;
            } };
          }
          ot.__dashjs_factory_name = "ManifestParsing";
          var Ee = dashjs.FactoryMaker.getSingletonFactory(ot);
          function Te(b) {
            var X;
            b = b || {};
            var z = {}, De = this.context, tt = b.eventBus, Ue = b.events;
            function ke(qe) {
              if (!qe.error) {
                var it = Object.keys(z);
                Ee(De).getInstance({ adapter: b.adapter, constants: b.constants }).getMetrics(qe.manifest).forEach(function(bt) {
                  var dt = JSON.stringify(bt);
                  if (z.hasOwnProperty(dt)) it.splice(dt, 1);
                  else try {
                    var Yt = Be(De).create(b);
                    Yt.initialize(bt), z[dt] = Yt;
                  } catch {
                  }
                }), it.forEach(function(bt) {
                  z[bt].reset(), delete z[bt];
                }), tt.trigger(t.Z.METRICS_INITIALISATION_COMPLETE);
              }
            }
            function Oe() {
              Object.keys(z).forEach(function(qe) {
                z[qe].reset();
              }), z = {};
            }
            return X = { reset: function() {
              tt.off(Ue.MANIFEST_UPDATED, ke, X), tt.off(Ue.STREAM_TEARDOWN_COMPLETE, Oe, X);
            } }, tt.on(Ue.MANIFEST_UPDATED, ke, X), tt.on(Ue.STREAM_TEARDOWN_COMPLETE, Oe, X), X;
          }
          Te.__dashjs_factory_name = "MetricsCollectionController";
          var je = dashjs.FactoryMaker.getClassFactory(Te);
          function c() {
            var b = this.context;
            return { createMetricsReporting: function(X) {
              return m(b).getInstance({ eventBus: X.eventBus, dashMetrics: X.dashMetrics, metricsConstants: X.metricsConstants, events: X.events }).initialize(), je(b).create(X);
            }, getReportingFactory: function() {
              return J(b).getInstance();
            }, getMetricsHandlerFactory: function() {
              return Ze(b).getInstance();
            } };
          }
          c.__dashjs_factory_name = "MetricsReporting";
          var o = dashjs.FactoryMaker.getClassFactory(c);
          o.events = t.Z, dashjs.FactoryMaker.updateClassFactory(c.__dashjs_factory_name, o);
          var T = o;
        }, 1180: function(Se, ge, R) {
          function te(p) {
            return te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
              return typeof l;
            } : function(l) {
              return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
            }, te(p);
          }
          function E(p, l) {
            return E = Object.setPrototypeOf || function(v, h) {
              return v.__proto__ = h, v;
            }, E(p, l);
          }
          function t(p, l) {
            return !l || te(l) !== "object" && typeof l != "function" ? function(v) {
              if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }(p) : l;
          }
          function e(p) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(l) {
              return l.__proto__ || Object.getPrototypeOf(l);
            }, e(p);
          }
          var m = new (function(p) {
            (function(f, d) {
              if (typeof d != "function" && d !== null) throw new TypeError("Super expression must either be null or a function");
              f.prototype = Object.create(d && d.prototype, { constructor: { value: f, writable: !0, configurable: !0 } }), d && E(f, d);
            })(n, p);
            var l, v, h = (l = n, v = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var f, d = e(l);
              if (v) {
                var S = e(this).constructor;
                f = Reflect.construct(d, arguments, S);
              } else f = d.apply(this, arguments);
              return t(this, f);
            });
            function n() {
              var f;
              return function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (f = h.call(this)).METRICS_INITIALISATION_COMPLETE = "internal_metricsReportingInitialized", f.BECAME_REPORTING_PLAYER = "internal_becameReportingPlayer", f.CMCD_DATA_GENERATED = "cmcdDataGenerated", f;
            }
            return n;
          }(R(8342).Z))();
          ge.Z = m;
        }, 5717: function(Se, ge, R) {
          var te = R(2610), E = R(5448), t = R(1264), e = R(3106), m = R(1767), p = R(3393);
          function l() {
            var v, h, n, f, d, S, x, G, P = this.context, J = (0, t.Z)(P).getInstance();
            function M() {
              f = [], d = [], S = [], G = [], x = null, h = [];
            }
            function W(ce, Re) {
              var $ = -1;
              ce.some(function(Me, Ge) {
                if (Me === Re) return $ = Ge, !0;
              }), $ < 0 || ce.splice($, 1);
            }
            function se(ce) {
              var Re;
              for (Re = 0; Re < G.length; Re++) if (G[Re].rulename === ce) return Re;
              return -1;
            }
            function j(ce, Re) {
              re(ce, Re);
              var $ = new te.Z();
              $.schemeIdUri = ce, $.value = Re, h.push($);
            }
            function re(ce, Re) {
              (0, e.PS)(ce, "string"), (0, e.PS)(Re, "string"), h.forEach(function($, Me) {
                $.schemeIdUri === ce && $.value === Re && h.splice(Me, 1);
              });
            }
            return v = { getCustomInitialTrackSelectionFunction: function() {
              return x;
            }, setCustomInitialTrackSelectionFunction: function(ce) {
              x = ce;
            }, resetCustomInitialTrackSelectionFunction: function() {
              x = null;
            }, getLicenseResponseFilters: function() {
              return d;
            }, getLicenseRequestFilters: function() {
              return f;
            }, getCustomCapabilitiesFilters: function() {
              return S;
            }, registerCustomCapabilitiesFilter: function(ce) {
              S.push(ce);
            }, registerLicenseResponseFilter: function(ce) {
              d.push(ce);
            }, registerLicenseRequestFilter: function(ce) {
              f.push(ce);
            }, unregisterCustomCapabilitiesFilter: function(ce) {
              W(S, ce);
            }, unregisterLicenseResponseFilter: function(ce) {
              W(d, ce);
            }, unregisterLicenseRequestFilter: function(ce) {
              W(f, ce);
            }, addAbrCustomRule: function(ce, Re, $) {
              if (typeof ce != "string" || ce !== m.Z.ABANDON_FRAGMENT_RULES && ce !== m.Z.QUALITY_SWITCH_RULES || typeof Re != "string") throw p.Z.BAD_ARGUMENT_ERROR;
              var Me = se(Re);
              Me === -1 ? G.push({ type: ce, rulename: Re, rule: $ }) : (G[Me].type = ce, G[Me].rule = $);
            }, removeAllAbrCustomRule: function() {
              G = [];
            }, removeAbrCustomRule: function(ce) {
              if (ce) {
                var Re = se(ce);
                Re !== -1 && G.splice(Re, 1);
              } else G = [];
            }, getAbrCustomRules: function() {
              return G;
            }, addUTCTimingSource: j, removeUTCTimingSource: re, getUTCTimingSources: function() {
              return h;
            }, clearDefaultUTCTimingSources: function() {
              h = [];
            }, restoreDefaultUTCTimingSources: function() {
              var ce = J.get().streaming.utcSynchronization.defaultTimingSource;
              j(ce.scheme, ce.value);
            }, setXHRWithCredentialsForType: function ce(Re, $) {
              Re ? n[Re] = !!$ : Object.keys(n).forEach(function(Me) {
                ce(Me, $);
              });
            }, getXHRWithCredentialsForType: function(ce) {
              var Re = n[ce];
              return Re === void 0 ? n.default : Re;
            }, setConfig: function() {
            }, reset: function() {
              M();
            } }, n = { default: !1 }, M(), v;
          }
          l.__dashjs_factory_name = "CustomParametersModel", ge.Z = E.Z.getSingletonFactory(l);
        }, 9032: function(Se, ge, R) {
          var te = R(5448), E = R(7473);
          function t(m) {
            var p = (m = m || {}).requestModifier;
            function l(v) {
              var h = /* @__PURE__ */ new Date(), n = v.request, f = new XMLHttpRequest();
              if (f.open(v.method, v.url, !0), n.responseType && (f.responseType = n.responseType), n.range && f.setRequestHeader("Range", "bytes=" + n.range), n.requestStartDate || (n.requestStartDate = h), p && p.modifyRequestHeader && (f = p.modifyRequestHeader(f, { url: v.url })), v.headers) for (var d in v.headers) {
                var S = v.headers[d];
                S && f.setRequestHeader(d, S);
              }
              f.withCredentials = v.withCredentials, f.onload = v.onload, f.onloadend = v.onend, f.onerror = v.onerror, f.onprogress = v.progress, f.onabort = v.onabort, f.ontimeout = v.ontimeout, f.timeout = v.timeout, f.send(), v.response = f;
            }
            return { load: function(v) {
              p && p.modifyRequest ? (0, E.k)(v, p).then(function() {
                return l(v);
              }) : l(v);
            }, abort: function(v) {
              var h = v.response;
              h.onloadend = h.onerror = h.onprogress = void 0, h.abort();
            } };
          }
          t.__dashjs_factory_name = "XHRLoader";
          var e = te.Z.getClassFactory(t);
          ge.Z = e;
        }, 1737: function(Se, ge, R) {
          function te(Dt, wt) {
            for (var Ct = 0; Ct < wt.length; Ct++) {
              var Ye = wt[Ct];
              Ye.enumerable = Ye.enumerable || !1, Ye.configurable = !0, "value" in Ye && (Ye.writable = !0), Object.defineProperty(Dt, Ye.key, Ye);
            }
          }
          R.d(ge, { default: function() {
            return li;
          } });
          var E = { attributes: ["Laurl", "laurl"], prefixes: ["clearkey", "dashif"] }, t = function() {
            function Dt() {
              (function(Ye, yt) {
                if (!(Ye instanceof yt)) throw new TypeError("Cannot call a class as a function");
              })(this, Dt);
            }
            var wt, Ct;
            return wt = Dt, Ct = [{ key: "findCencContentProtection", value: function(Ye) {
              for (var yt = null, $e = 0; $e < Ye.length; ++$e) {
                var gt = Ye[$e];
                gt.schemeIdUri.toLowerCase() !== "urn:mpeg:dash:mp4protection:2011" || gt.value.toLowerCase() !== "cenc" && gt.value.toLowerCase() !== "cbcs" || (yt = gt);
              }
              return yt;
            } }, { key: "getPSSHData", value: function(Ye) {
              var yt = 8, $e = new DataView(Ye), gt = $e.getUint8(yt);
              return yt += 20, gt > 0 && (yt += 4 + 16 * $e.getUint32(yt)), yt += 4, Ye.slice(yt);
            } }, { key: "getPSSHForKeySystem", value: function(Ye, yt) {
              var $e = Dt.parsePSSHList(yt);
              return Ye && $e.hasOwnProperty(Ye.uuid.toLowerCase()) ? $e[Ye.uuid.toLowerCase()] : null;
            } }, { key: "parseInitDataFromContentProtection", value: function(Ye, yt) {
              return "pssh" in Ye ? (Ye.pssh.__text = Ye.pssh.__text.replace(/\r?\n|\r/g, "").replace(/\s+/g, ""), yt.decodeArray(Ye.pssh.__text).buffer) : null;
            } }, { key: "parsePSSHList", value: function(Ye) {
              if (Ye == null) return [];
              for (var yt = new DataView(Ye.buffer || Ye), $e = {}, gt = 0; ; ) {
                var Zt, Gt, nn = void 0, an = gt;
                if (gt >= yt.buffer.byteLength) break;
                if (Zt = gt + yt.getUint32(gt), gt += 4, yt.getUint32(gt) === 1886614376) if (gt += 4, (Gt = yt.getUint8(gt)) === 0 || Gt === 1) {
                  gt++, gt += 3, nn = "";
                  var Kt = void 0, At = void 0;
                  for (Kt = 0; Kt < 4; Kt++) nn += (At = yt.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + At : At;
                  for (gt += 4, nn += "-", Kt = 0; Kt < 2; Kt++) nn += (At = yt.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + At : At;
                  for (gt += 2, nn += "-", Kt = 0; Kt < 2; Kt++) nn += (At = yt.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + At : At;
                  for (gt += 2, nn += "-", Kt = 0; Kt < 2; Kt++) nn += (At = yt.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + At : At;
                  for (gt += 2, nn += "-", Kt = 0; Kt < 6; Kt++) nn += (At = yt.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + At : At;
                  gt += 6, gt += 4, $e[nn = nn.toLowerCase()] = yt.buffer.slice(an, Zt), gt = Zt;
                } else gt = Zt;
                else gt = Zt;
              }
              return $e;
            } }, { key: "getLicenseServerUrlFromMediaInfo", value: function(Ye, yt) {
              try {
                if (!Ye || Ye.length === 0) return null;
                for (var $e = 0, gt = null; $e < Ye.length && !gt; ) {
                  var Zt = Ye[$e];
                  if (Zt && Zt.contentProtection && Zt.contentProtection.length > 0) {
                    var Gt = Zt.contentProtection.filter(function(dn) {
                      return dn.schemeIdUri && dn.schemeIdUri === yt;
                    });
                    if (Gt && Gt.length > 0) for (var nn = 0; nn < Gt.length && !gt; ) {
                      for (var an = Gt[nn], Kt = 0; Kt < E.attributes.length && !gt; ) {
                        for (var At = 0, tn = E.attributes[Kt]; At < E.prefixes.length && !gt; ) {
                          var Jt = E.prefixes[At];
                          an[tn] && an[tn].__prefix && an[tn].__prefix === Jt && an[tn].__text && (gt = an[tn].__text), At += 1;
                        }
                        Kt += 1;
                      }
                      nn += 1;
                    }
                  }
                  $e += 1;
                }
                return gt;
              } catch {
                return null;
              }
            } }], Ct && te(wt, Ct), Dt;
          }(), e = function Dt(wt, Ct) {
            (function(Ye, yt) {
              if (!(Ye instanceof yt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.contentType = wt, this.robustness = Ct;
          }, m = function Dt(wt, Ct, Ye, yt, $e) {
            (function(gt, Zt) {
              if (!(gt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.initDataTypes = ["cenc"], wt && wt.length && (this.audioCapabilities = wt), Ct && Ct.length && (this.videoCapabilities = Ct), this.distinctiveIdentifier = Ye, this.persistentState = yt, this.sessionTypes = $e;
          };
          function p(Dt) {
            return p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(wt) {
              return typeof wt;
            } : function(wt) {
              return wt && typeof Symbol == "function" && wt.constructor === Symbol && wt !== Symbol.prototype ? "symbol" : typeof wt;
            }, p(Dt);
          }
          function l(Dt, wt) {
            return l = Object.setPrototypeOf || function(Ct, Ye) {
              return Ct.__proto__ = Ye, Ct;
            }, l(Dt, wt);
          }
          function v(Dt, wt) {
            return !wt || p(wt) !== "object" && typeof wt != "function" ? function(Ct) {
              if (Ct === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return Ct;
            }(Dt) : wt;
          }
          function h(Dt) {
            return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(wt) {
              return wt.__proto__ || Object.getPrototypeOf(wt);
            }, h(Dt);
          }
          var n = new (function(Dt) {
            (function($e, gt) {
              if (typeof gt != "function" && gt !== null) throw new TypeError("Super expression must either be null or a function");
              $e.prototype = Object.create(gt && gt.prototype, { constructor: { value: $e, writable: !0, configurable: !0 } }), gt && l($e, gt);
            })(yt, Dt);
            var wt, Ct, Ye = (wt = yt, Ct = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var $e, gt = h(wt);
              if (Ct) {
                var Zt = h(this).constructor;
                $e = Reflect.construct(gt, arguments, Zt);
              } else $e = gt.apply(this, arguments);
              return v(this, $e);
            });
            function yt() {
              var $e;
              return function(gt, Zt) {
                if (!(gt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
              }(this, yt), ($e = Ye.call(this)).MEDIA_KEYERR_CODE = 100, $e.MEDIA_KEYERR_UNKNOWN_CODE = 101, $e.MEDIA_KEYERR_CLIENT_CODE = 102, $e.MEDIA_KEYERR_SERVICE_CODE = 103, $e.MEDIA_KEYERR_OUTPUT_CODE = 104, $e.MEDIA_KEYERR_HARDWARECHANGE_CODE = 105, $e.MEDIA_KEYERR_DOMAIN_CODE = 106, $e.MEDIA_KEY_MESSAGE_ERROR_CODE = 107, $e.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE = 108, $e.SERVER_CERTIFICATE_UPDATED_ERROR_CODE = 109, $e.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE = 110, $e.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE = 111, $e.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE = 112, $e.KEY_SESSION_CREATED_ERROR_CODE = 113, $e.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE = 114, $e.MEDIA_KEYERR_UNKNOWN_MESSAGE = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.", $e.MEDIA_KEYERR_CLIENT_MESSAGE = "The Key System could not be installed or updated.", $e.MEDIA_KEYERR_SERVICE_MESSAGE = "The message passed into update indicated an error from the license service.", $e.MEDIA_KEYERR_OUTPUT_MESSAGE = "There is no available output device with the required characteristics for the content protection system.", $e.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE = "A hardware configuration change caused a content protection error.", $e.MEDIA_KEYERR_DOMAIN_MESSAGE = "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.", $e.MEDIA_KEY_MESSAGE_ERROR_MESSAGE = "Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!", $e.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE = "DRM: Empty key message from CDM", $e.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE = "Error updating server certificate -- ", $e.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE = "DRM: KeyStatusChange error! -- License has expired", $e.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE = "DRM: No license server URL specified!", $e.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE = "DRM: KeySystem Access Denied! -- ", $e.KEY_SESSION_CREATED_ERROR_MESSAGE = "DRM: unable to create session! --", $e.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE = "DRM: licenser error! --", $e;
            }
            return yt;
          }(R(2230).Z))(), f = R(5459), d = function Dt(wt, Ct, Ye, yt, $e, gt, Zt, Gt) {
            (function(nn, an) {
              if (!(nn instanceof an)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.url = wt, this.method = Ct, this.responseType = Ye, this.headers = yt, this.withCredentials = $e, this.messageType = gt, this.sessionId = Zt, this.data = Gt;
          }, S = function Dt(wt, Ct, Ye) {
            (function(yt, $e) {
              if (!(yt instanceof $e)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.url = wt, this.headers = Ct, this.data = Ye;
          }, x = R(7855), G = R(703), P = R(3393), J = R(5448);
          function M(Dt) {
            return M = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(wt) {
              return typeof wt;
            } : function(wt) {
              return wt && typeof Symbol == "function" && wt.constructor === Symbol && wt !== Symbol.prototype ? "symbol" : typeof wt;
            }, M(Dt);
          }
          function W(Dt) {
            var wt, Ct, Ye, yt, $e, gt, Zt, Gt, nn, an, Kt, At = (Dt = Dt || {}).protectionKeyController, tn = Dt.protectionModel, Jt = Dt.eventBus, dn = Dt.events, bn = Dt.debug, Cn = Dt.BASE64, ln = Dt.constants, St = [], Ot = Dt.cmcdModel, jt = Dt.settings, fn = Dt.customParametersModel;
            function mn() {
              if (!(Jt && Jt.hasOwnProperty("on") && At && At.hasOwnProperty("getSupportedKeySystemsFromContentProtection"))) throw new Error("Missing config parameter(s)");
            }
            function In(Ft, un) {
              Gt || nn ? Gt && Rn() : function(vn, Yn) {
                if (!nn) {
                  nn = !0;
                  var Nn, Jn = [];
                  vn = vn.sort(function(Wn, Hn) {
                    return ($e && $e[Wn.ks.systemString] && $e[Wn.ks.systemString].priority >= 0 ? $e[Wn.ks.systemString].priority : vn.length) - ($e && $e[Hn.ks.systemString] && $e[Hn.ks.systemString].priority >= 0 ? $e[Hn.ks.systemString].priority : vn.length);
                  });
                  for (var Zn = 0; Zn < vn.length; Zn++) {
                    var Tr = Hr(vn[Zn]);
                    Jn.push({ ks: vn[Zn].ks, configs: [Tr], protData: vn[Zn].protData });
                  }
                  tn.requestKeySystemAccess(Jn).then(function(Wn) {
                    var Hn = (Nn = Wn.data).mksa && Nn.mksa.selectedSystemString ? Nn.mksa.selectedSystemString : Nn.keySystem.systemString;
                    return Ct.info("DRM: KeySystem Access Granted for system string (" + Hn + ")!  Selecting key system..."), tn.selectKeySystem(Nn);
                  }).then(function(Wn) {
                    if (Gt = Wn, nn = !1, tn) {
                      Jt.trigger(dn.KEY_SYSTEM_SELECTED, { data: Nn });
                      var Hn = $n(Gt);
                      Hn && Hn.serverCertificate && Hn.serverCertificate.length > 0 && tn.setServerCertificate(Cn.decodeArray(Hn.serverCertificate).buffer), Rn();
                    }
                  }).catch(function(Wn) {
                    Gt = null, nn = !1, Yn || Jt.trigger(dn.KEY_SYSTEM_SELECTED, { data: null, error: new f.Z(n.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE, n.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE + "Error selecting key system! -- " + Wn.error) });
                  });
                }
              }(Ft, un);
            }
            function Rn() {
              for (var Ft, un = 0; un < Ye.length; un++) for (Ft = 0; Ft < Ye[un].length; Ft++) if (Gt === Ye[un][Ft].ks) {
                nr(Ye[un][Ft]);
                break;
              }
              Ye = [];
            }
            function nr(Ft) {
              if (At.isClearKey(Gt) && Ft.protData && Ft.protData.hasOwnProperty("clearkeys") && Object.keys(Ft.protData.clearkeys).length !== 0) {
                var un = { kids: Object.keys(Ft.protData.clearkeys) };
                Ft.initData = new TextEncoder().encode(JSON.stringify(un));
              }
              Ft.sessionId ? rr(Ft) : Ft.initData !== null && Gn(Ft);
            }
            function rr(Ft) {
              mn(), tn.loadKeySession(Ft);
            }
            function Gn(Ft) {
              var un = t.getPSSHForKeySystem(Gt, Ft ? Ft.initData : null);
              if (un) {
                if (function(vn) {
                  if (!vn) return !1;
                  try {
                    for (var Yn = tn.getSessions(), Nn = 0; Nn < Yn.length; Nn++) if (Yn[Nn].getKeyId() === vn) return !0;
                    return !1;
                  } catch {
                    return !1;
                  }
                }(Ft.keyId) || jn(un)) return;
                try {
                  Ft.initData = un, tn.createKeySession(Ft);
                } catch (vn) {
                  Jt.trigger(dn.KEY_SESSION_CREATED, { data: null, error: new f.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + vn.message) });
                }
              } else Ft && Ft.initData ? tn.createKeySession(Ft) : Jt.trigger(dn.KEY_SESSION_CREATED, { data: null, error: new f.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Selected key system is " + (Gt ? Gt.systemString : null) + ".  needkey/encrypted event contains no initData corresponding to that key system!") });
            }
            function $n(Ft) {
              if (Ft) {
                var un = Ft.systemString;
                if ($e) return un in $e ? $e[un] : null;
              }
              return null;
            }
            function jn(Ft) {
              if (!Ft) return !1;
              try {
                for (var un = tn.getAllInitData(), vn = 0; vn < un.length; vn++) if (At.initDataEquals(Ft, un[vn])) return Ct.debug("DRM: Ignoring initData because we have already seen it!"), !0;
                return !1;
              } catch {
                return !1;
              }
            }
            function ir(Ft) {
              mn(), Ft ? (tn.setMediaElement(Ft), Jt.on(dn.NEED_KEY, ci, wt)) : Ft === null && (tn.setMediaElement(Ft), Jt.off(dn.NEED_KEY, ci, wt));
            }
            function Hr(Ft) {
              var un = Ft.protData, vn = [], Yn = [], Nn = un && un.audioRobustness && un.audioRobustness.length > 0 ? un.audioRobustness : Zt, Jn = un && un.videoRobustness && un.videoRobustness.length > 0 ? un.videoRobustness : Zt, Zn = Ft.sessionType, Tr = un && un.distinctiveIdentifier ? un.distinctiveIdentifier : "optional", Wn = un && un.persistentState ? un.persistentState : Zn === "temporary" ? "optional" : "required";
              return yt.forEach(function(Hn) {
                Hn.type === ln.AUDIO ? vn.push(new e(Hn.codec, Nn)) : Hn.type === ln.VIDEO && Yn.push(new e(Hn.codec, Jn));
              }), new m(vn, Yn, Tr, Wn, [Zn]);
            }
            function wr(Ft) {
              Ft.error ? Jt.trigger(dn.KEY_STATUSES_CHANGED, { data: null, error: Ft.error }) : Ct.debug("DRM: key status = " + Ft.status);
            }
            function Or(Ft) {
              Ct.debug("DRM: onKeyMessage");
              var un = Ft.data;
              Jt.trigger(dn.KEY_MESSAGE, { data: un });
              var vn = un.messageType ? un.messageType : "license-request", Yn = un.message, Nn = un.sessionToken, Jn = $n(Gt), Zn = At.getLicenseServerModelInstance(Gt, Jn, vn), Tr = { sessionToken: Nn, messageType: vn };
              if (Yn && Yn.byteLength !== 0) {
                if (!Zn) return Ct.debug("DRM: License server request not required for this message (type = " + Ft.data.messageType + ").  Session ID = " + Nn.getSessionId()), void ur(Tr);
                if (At.isClearKey(Gt)) {
                  var Wn = At.processClearKeyLicenseRequest(Gt, Jn, Yn);
                  if (Wn && Wn.keyPairs && Wn.keyPairs.length > 0) return Ct.debug("DRM: ClearKey license request handled by application!"), ur(Tr), void tn.updateKeySession(Nn, Wn);
                }
                (function(Hn, cr, fr) {
                  var Mr = Hn.sessionToken, Rr = Hn.messageType ? Hn.messageType : "license-request", Lr = { sessionToken: Mr, messageType: Rr }, qr = Gt ? Gt.systemString : null, Ai = function(Bn, $r, hi, Jr, qi) {
                    var Cr = null, Vi = Jr.message;
                    if (Bn && Bn.serverURL) {
                      var Vr = Bn.serverURL;
                      typeof Vr == "string" && Vr !== "" ? Cr = Vr : M(Vr) === "object" && Vr.hasOwnProperty($r) && (Cr = Vr[$r]);
                    } else if (Bn && Bn.laURL && Bn.laURL !== "") Cr = Bn.laURL;
                    else if (!(Cr = t.getLicenseServerUrlFromMediaInfo(yt, Gt.schemeIdURI)) && !At.isClearKey(Gt)) {
                      var ji = t.getPSSHData(hi.initData);
                      (Cr = Gt.getLicenseServerURLFromInitData(ji)) || (Cr = Jr.laURL);
                    }
                    return Cr = qi.getServerURLFromMessage(Cr, Vi, $r);
                  }(fr, Rr, Mr, Hn, cr);
                  if (Ai) {
                    var fi = {}, di = !1;
                    fr && xi(fi, fr.httpRequestHeaders);
                    var Zi = Hn.message;
                    xi(fi, Gt.getRequestHeadersFromMessage(Zi)), Object.keys(fi).forEach(function(Bn) {
                      Bn.toLowerCase() === "authorization" && (di = !0);
                    }), fr && typeof fr.withCredentials == "boolean" && (di = fr.withCredentials);
                    var Bi = function(Bn) {
                      if (tn) if (Bn.status >= 200 && Bn.status <= 299) {
                        var $r = G.Z.parseHttpHeaders(Bn.getAllResponseHeaders ? Bn.getAllResponseHeaders() : null), hi = new S(Bn.responseURL, $r, Bn.response);
                        ki(fn.getLicenseResponseFilters(), hi).then(function() {
                          var Jr = cr.getLicenseMessage(hi.data, qr, Rr);
                          Jr !== null ? (ur(Lr), tn.updateKeySession(Mr, Jr)) : Fi(Bn, Lr, qr, Rr, cr);
                        });
                      } else Fi(Bn, Lr, qr, Rr, cr);
                    }, Oa = function(Bn) {
                      ur(Lr, new f.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + qr + ' update, XHR aborted. status is "' + Bn.statusText + '" (' + Bn.status + "), readyState is " + Bn.readyState));
                    }, Ma = function(Bn) {
                      ur(Lr, new f.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + qr + ' update, XHR error. status is "' + Bn.statusText + '" (' + Bn.status + "), readyState is " + Bn.readyState));
                    }, Ui = Gt.getLicenseRequestFromMessage(Zi), Gi = cr.getHTTPMethod(Rr), La = cr.getResponseType(qr, Rr), Ii = fr && !isNaN(fr.httpTimeout) ? fr.httpTimeout : 8e3, Hi = Mr.getSessionId() || null, gi = new d(Ai, Gi, La, fi, di, Rr, Hi, Ui), Pa = isNaN(jt.get().streaming.retryAttempts[x.w.LICENSE]) ? 3 : jt.get().streaming.retryAttempts[x.w.LICENSE];
                    ki(fn.getLicenseRequestFilters(), gi).then(function() {
                      Pi(gi, Pa, Ii, Bi, Oa, Ma);
                    });
                  } else ur(Lr, new f.Z(n.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE, n.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));
                })(un, Zn, Jn);
              } else ur(Tr, new f.Z(n.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE, n.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE));
            }
            function ur(Ft, un) {
              Jt.trigger(dn.LICENSE_REQUEST_COMPLETE, { data: Ft, error: un });
            }
            function Pi(Ft, un, vn, Yn, Nn, Jn) {
              var Zn = new XMLHttpRequest();
              if (jt.get().streaming.cmcd && jt.get().streaming.cmcd.enabled && jt.get().streaming.cmcd.mode === P.Z.CMCD_MODE_QUERY) {
                var Tr = Ot.getQueryParameter({ url: Ft.url, type: x.w.LICENSE });
                Tr && (Ft.url = G.Z.addAditionalQueryParameterToUrl(Ft.url, [Tr]));
              }
              for (var Wn in Zn.open(Ft.method, Ft.url, !0), Zn.responseType = Ft.responseType, Zn.withCredentials = Ft.withCredentials, vn > 0 && (Zn.timeout = vn), Ft.headers) Zn.setRequestHeader(Wn, Ft.headers[Wn]);
              if (jt.get().streaming.cmcd && jt.get().streaming.cmcd.enabled && jt.get().streaming.cmcd.mode === P.Z.CMCD_MODE_HEADER) {
                var Hn = Ot.getHeaderParameters({ url: Ft.url, type: x.w.LICENSE });
                if (Hn) for (var cr in Hn) {
                  var fr = Hn[cr];
                  fr && Zn.setRequestHeader(cr, fr);
                }
              }
              var Mr = function() {
                un--;
                var Rr = isNaN(jt.get().streaming.retryIntervals[x.w.LICENSE]) ? 1e3 : jt.get().streaming.retryIntervals[x.w.LICENSE];
                Kt = setTimeout(function() {
                  Pi(Ft, un, vn, Yn, Nn, Jn);
                }, Rr);
              };
              Zn.onload = function() {
                an = null, this.status >= 200 && this.status <= 299 || un <= 0 ? Yn(this) : (Ct.warn("License request failed (" + this.status + "). Retrying it... Pending retries: " + un), Mr());
              }, Zn.ontimeout = Zn.onerror = function() {
                an = null, un <= 0 ? Jn(this) : (Ct.warn("License request network request failed . Retrying it... Pending retries: " + un), Mr());
              }, Zn.onabort = function() {
                Nn(this);
              }, Jt.trigger(dn.LICENSE_REQUEST_SENDING, { url: Ft.url, headers: Ft.headers, payload: Ft.data, sessionId: Ft.sessionId }), an = Zn, Zn.send(Ft.data);
            }
            function ui() {
              an && (an.onloadend = an.onerror = an.onprogress = void 0, an.abort(), an = null), Kt && (clearTimeout(Kt), Kt = null);
            }
            function xi(Ft, un) {
              if (un) for (var vn in un) Ft[vn] = un[vn];
            }
            function Fi(Ft, un, vn, Yn, Nn) {
              var Jn = "NONE", Zn = null;
              Ft.response && (Jn = Nn.getErrorResponse(Ft.response, vn, Yn), Zn = { serverResponse: Ft.response || null, responseCode: Ft.status || null, responseText: Ft.statusText || null }), ur(un, new f.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + vn + ' update, XHR complete. status is "' + Ft.statusText + '" (' + Ft.status + "), readyState is " + Ft.readyState + ".  Response is " + Jn, Zn));
            }
            function ki(Ft, un) {
              return Ft ? Ft.reduce(function(vn, Yn) {
                return vn.then(function() {
                  return Yn(un);
                });
              }, Promise.resolve()) : Promise.resolve();
            }
            function ci(Ft, un) {
              if (!jt.get().streaming.protection.ignoreEmeEncryptedEvent) {
                if (Ct.debug("DRM: onNeedKey"), Ft.key.initDataType !== "cenc") return void Ct.warn("DRM:  Only 'cenc' initData is supported!  Ignoring initData of type: " + Ft.key.initDataType);
                if (yt.length === 0 && (Ct.warn("DRM: onNeedKey called before initializeForMedia, wait until initialized"), (un = un === void 0 ? 1 : un + 1) < 5)) return void St.push(setTimeout(function() {
                  ci(Ft, un);
                }, 500));
                var vn = Ft.key.initData;
                if (ArrayBuffer.isView(vn) && (vn = vn.buffer), Gt) {
                  var Yn = t.getPSSHForKeySystem(Gt, vn);
                  if (Yn && jn(Yn)) return;
                }
                Ct.debug("DRM: initData:", String.fromCharCode.apply(null, new Uint8Array(vn)));
                var Nn = At.getSupportedKeySystemsFromSegmentPssh(vn, $e, gt);
                if (Nn.length === 0) return void Ct.debug("DRM: Received needkey event with initData, but we don't support any of the key systems!");
                (function(Jn) {
                  Ye.push(Jn), In(Jn, !1);
                })(Nn);
              }
            }
            return wt = { initializeForMedia: function(Ft) {
              if (!Ft) throw new Error("mediaInfo can not be null or undefined");
              mn(), yt.push(Ft);
            }, clearMediaInfoArray: function() {
              yt = [];
            }, handleKeySystemFromManifest: function() {
              if (yt && yt.length !== 0) {
                var Ft = [];
                yt.forEach(function(un) {
                  var vn = At.getSupportedKeySystemsFromContentProtection(un.contentProtection, $e, gt);
                  vn.length > 0 && (Ft.length === 0 && (Ft = vn), Ye.push(vn));
                }), Ft && Ft.length > 0 && In(Ft, !0);
              }
            }, createKeySession: Gn, loadKeySession: rr, removeKeySession: function(Ft) {
              mn(), tn.removeKeySession(Ft);
            }, closeKeySession: function(Ft) {
              mn(), tn.closeKeySession(Ft);
            }, setServerCertificate: function(Ft) {
              mn(), tn.setServerCertificate(Ft);
            }, setMediaElement: ir, setSessionType: function(Ft) {
              gt = Ft;
            }, setRobustnessLevel: function(Ft) {
              Zt = Ft;
            }, setProtectionData: function(Ft) {
              $e = Ft, At.setProtectionData(Ft);
            }, getSupportedKeySystemsFromContentProtection: function(Ft) {
              return mn(), At.getSupportedKeySystemsFromContentProtection(Ft, $e, gt);
            }, getKeySystems: function() {
              return At ? At.getKeySystems() : [];
            }, setKeySystems: function(Ft) {
              At && At.setKeySystems(Ft);
            }, stop: function() {
              ui(), tn && tn.stop();
            }, reset: function() {
              Jt.off(dn.INTERNAL_KEY_MESSAGE, Or, wt), Jt.off(dn.INTERNAL_KEY_STATUS_CHANGED, wr, wt), mn(), ui(), ir(null), Gt = null, nn = !1, tn && (tn.reset(), tn = null), St.forEach(function(Ft) {
                return clearTimeout(Ft);
              }), St = [], yt = [], Ye = [];
            } }, Ct = bn.getLogger(wt), Ye = [], yt = [], gt = "temporary", Zt = "", an = null, Kt = null, Jt.on(dn.INTERNAL_KEY_MESSAGE, Or, wt), Jt.on(dn.INTERNAL_KEY_STATUS_CHANGED, wr, wt), wt;
          }
          W.__dashjs_factory_name = "ProtectionController";
          var se = J.Z.getClassFactory(W), j = function Dt(wt, Ct) {
            (function(Ye, yt) {
              if (!(Ye instanceof yt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.keyID = wt, this.key = Ct;
          };
          function re(Dt, wt) {
            for (var Ct = 0; Ct < wt.length; Ct++) {
              var Ye = wt[Ct];
              Ye.enumerable = Ye.enumerable || !1, Ye.configurable = !0, "value" in Ye && (Ye.writable = !0), Object.defineProperty(Dt, Ye.key, Ye);
            }
          }
          var ce = function() {
            function Dt(Ye, yt) {
              if (function($e, gt) {
                if (!($e instanceof gt)) throw new TypeError("Cannot call a class as a function");
              }(this, Dt), yt && yt !== "persistent" && yt !== "temporary") throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");
              this.keyPairs = Ye, this.type = yt;
            }
            var wt, Ct;
            return wt = Dt, (Ct = [{ key: "toJWK", value: function() {
              var Ye, yt = this.keyPairs.length, $e = { keys: [] };
              for (Ye = 0; Ye < yt; Ye++) {
                var gt = { kty: "oct", alg: "A128KW", kid: this.keyPairs[Ye].keyID, k: this.keyPairs[Ye].key };
                $e.keys.push(gt);
              }
              this.type && ($e.type = this.type);
              var Zt = JSON.stringify($e), Gt = Zt.length, nn = new ArrayBuffer(Gt), an = new Uint8Array(nn);
              for (Ye = 0; Ye < Gt; Ye++) an[Ye] = Zt.charCodeAt(Ye);
              return nn;
            } }]) && re(wt.prototype, Ct), Dt;
          }();
          function Re(Dt, wt) {
            for (var Ct = 0; Ct < wt.length; Ct++) {
              var Ye = wt[Ct];
              Ye.enumerable = Ye.enumerable || !1, Ye.configurable = !0, "value" in Ye && (Ye.writable = !0), Object.defineProperty(Dt, Ye.key, Ye);
            }
          }
          var $ = new (function() {
            function Dt() {
              (function(Ye, yt) {
                if (!(Ye instanceof yt)) throw new TypeError("Cannot call a class as a function");
              })(this, Dt), this.init();
            }
            var wt, Ct;
            return wt = Dt, (Ct = [{ key: "init", value: function() {
              this.CLEARKEY_KEYSTEM_STRING = "org.w3.clearkey", this.WIDEVINE_KEYSTEM_STRING = "com.widevine.alpha", this.PLAYREADY_KEYSTEM_STRING = "com.microsoft.playready", this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING = "com.microsoft.playready.recommendation", this.INITIALIZATION_DATA_TYPE_CENC = "cenc", this.INITIALIZATION_DATA_TYPE_KEYIDS = "keyids", this.INITIALIZATION_DATA_TYPE_WEBM = "webm";
            } }]) && Re(wt.prototype, Ct), Dt;
          }())(), Me = "e2719d58-a985-b3c9-781a-b030af78d30e", Ge = $.CLEARKEY_KEYSTEM_STRING, Qe = "urn:uuid:" + Me;
          function Ae(Dt) {
            var wt = (Dt = Dt || {}).BASE64;
            return { uuid: Me, schemeIdURI: Qe, systemString: Ge, getInitData: function(Ct, Ye) {
              try {
                var yt = t.parseInitDataFromContentProtection(Ct, wt);
                if (!yt && Ye) {
                  var $e = { kids: [function(gt) {
                    try {
                      var Zt = gt.replace(/-/g, "");
                      return (Zt = btoa(Zt.match(/\w{2}/g).map(function(Gt) {
                        return String.fromCharCode(parseInt(Gt, 16));
                      }).join(""))).replace(/=/g, "").replace(/\//g, "_").replace(/\+/g, "-");
                    } catch {
                      return null;
                    }
                  }(Ye["cenc:default_KID"])] };
                  yt = new TextEncoder().encode(JSON.stringify($e));
                }
                return yt;
              } catch {
                return null;
              }
            }, getRequestHeadersFromMessage: function() {
              return { "Content-Type": "application/json" };
            }, getLicenseRequestFromMessage: function(Ct) {
              return JSON.stringify(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(Ct))));
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            }, getClearKeysFromProtectionData: function(Ct, Ye) {
              var yt = null;
              if (Ct) {
                for (var $e = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(Ye))), gt = [], Zt = 0; Zt < $e.kids.length; Zt++) {
                  var Gt = $e.kids[Zt], nn = Ct.clearkeys && Ct.clearkeys.hasOwnProperty(Gt) ? Ct.clearkeys[Gt] : null;
                  if (!nn) throw new Error("DRM: ClearKey keyID (" + Gt + ") is not known!");
                  gt.push(new j(Gt, nn));
                }
                yt = new ce(gt);
              }
              return yt;
            } };
          }
          Ae.__dashjs_factory_name = "KeySystemClearKey";
          var Ze = dashjs.FactoryMaker.getSingletonFactory(Ae), Xe = "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b", at = $.CLEARKEY_KEYSTEM_STRING, Ie = "urn:uuid:" + Xe;
          function Be(Dt) {
            var wt, Ct = Dt.BASE64, Ye = Dt.debug.getLogger(wt);
            return { uuid: Xe, schemeIdURI: Ie, systemString: at, getInitData: function(yt) {
              return t.parseInitDataFromContentProtection(yt, Ct);
            }, getRequestHeadersFromMessage: function() {
              return null;
            }, getLicenseRequestFromMessage: function(yt) {
              return new Uint8Array(yt);
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            }, getClearKeysFromProtectionData: function(yt, $e) {
              var gt = null;
              if (yt) {
                for (var Zt = JSON.parse(String.fromCharCode.apply(null, new Uint8Array($e))), Gt = [], nn = 0; nn < Zt.kids.length; nn++) {
                  var an = Zt.kids[nn], Kt = yt.clearkeys && yt.clearkeys.hasOwnProperty(an) ? yt.clearkeys[an] : null;
                  if (!Kt) throw new Error("DRM: ClearKey keyID (" + an + ") is not known!");
                  Gt.push(new j(an, Kt));
                }
                gt = new ce(Gt), Ye.warn("ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4");
              }
              return gt;
            } };
          }
          Be.__dashjs_factory_name = "KeySystemW3CClearKey";
          var It = dashjs.FactoryMaker.getSingletonFactory(Be), _t = "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", Ve = $.WIDEVINE_KEYSTEM_STRING, ot = "urn:uuid:" + _t;
          function Ee(Dt) {
            var wt = (Dt = Dt || {}).BASE64;
            return { uuid: _t, schemeIdURI: ot, systemString: Ve, getInitData: function(Ct) {
              return t.parseInitDataFromContentProtection(Ct, wt);
            }, getRequestHeadersFromMessage: function() {
              return null;
            }, getLicenseRequestFromMessage: function(Ct) {
              return new Uint8Array(Ct);
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            } };
          }
          Ee.__dashjs_factory_name = "KeySystemWidevine";
          var Te = dashjs.FactoryMaker.getSingletonFactory(Ee), je = "9a04f079-9840-4286-ab92-e65be0885f95", c = $.PLAYREADY_KEYSTEM_STRING, o = "urn:uuid:" + je;
          function T(Dt) {
            var wt = "utf-16", Ct = (Dt = Dt || {}).BASE64, Ye = Dt.settings;
            function yt() {
              if (!Ct || !Ct.hasOwnProperty("decodeArray") || !Ct.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
            }
            return { uuid: je, schemeIdURI: o, systemString: c, getInitData: function($e) {
              var gt, Zt, Gt, nn, an, Kt = new Uint8Array([112, 115, 115, 104, 0, 0, 0, 0]), At = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]), tn = 0, Jt = null;
              if (yt(), !$e) return null;
              if ("pssh" in $e) return t.parseInitDataFromContentProtection($e, Ct);
              if ("pro" in $e) Jt = Ct.decodeArray($e.pro.__text);
              else {
                if (!("prheader" in $e)) return null;
                Jt = Ct.decodeArray($e.prheader.__text);
              }
              return gt = Jt.length, Zt = 4 + Kt.length + At.length + 4 + gt, Gt = new ArrayBuffer(Zt), nn = new Uint8Array(Gt), (an = new DataView(Gt)).setUint32(tn, Zt), tn += 4, nn.set(Kt, tn), tn += Kt.length, nn.set(At, tn), tn += At.length, an.setUint32(tn, gt), tn += 4, nn.set(Jt, tn), tn += gt, nn.buffer;
            }, getRequestHeadersFromMessage: function($e) {
              var gt, Zt, Gt = {}, nn = new DOMParser();
              if (Ye && Ye.get().streaming.protection.detectPlayreadyMessageFormat && wt === "utf-16" && $e && $e.byteLength % 2 == 1) return Gt["Content-Type"] = "text/xml; charset=utf-8", Gt;
              var an = wt === "utf-16" ? new Uint16Array($e) : new Uint8Array($e);
              gt = String.fromCharCode.apply(null, an);
              for (var Kt = (Zt = nn.parseFromString(gt, "application/xml")).getElementsByTagName("name"), At = Zt.getElementsByTagName("value"), tn = 0; tn < Kt.length; tn++) Gt[Kt[tn].childNodes[0].nodeValue] = At[tn].childNodes[0].nodeValue;
              return Gt.hasOwnProperty("Content") && (Gt["Content-Type"] = Gt.Content, delete Gt.Content), Gt.hasOwnProperty("Content-Type") || (Gt["Content-Type"] = "text/xml; charset=utf-8"), Gt;
            }, getLicenseRequestFromMessage: function($e) {
              var gt = null, Zt = new DOMParser();
              if (Ye && Ye.get().streaming.protection.detectPlayreadyMessageFormat && wt === "utf-16" && $e && $e.byteLength % 2 == 1) return $e;
              var Gt = wt === "utf-16" ? new Uint16Array($e) : new Uint8Array($e);
              yt();
              var nn = String.fromCharCode.apply(null, Gt), an = Zt.parseFromString(nn, "application/xml");
              if (!an.getElementsByTagName("PlayReadyKeyMessage")[0]) return $e;
              var Kt = an.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;
              return Kt && (gt = Ct.decode(Kt)), gt;
            }, getLicenseServerURLFromInitData: function($e) {
              if ($e) for (var gt = new DataView($e), Zt = gt.getUint16(4, !0), Gt = 6, nn = new DOMParser(), an = 0; an < Zt; an++) {
                var Kt = gt.getUint16(Gt, !0);
                Gt += 2;
                var At = gt.getUint16(Gt, !0);
                if (Gt += 2, Kt === 1) {
                  var tn = $e.slice(Gt, Gt + At), Jt = String.fromCharCode.apply(null, new Uint16Array(tn)), dn = nn.parseFromString(Jt, "application/xml");
                  if (dn.getElementsByTagName("LA_URL")[0]) {
                    var bn = dn.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;
                    if (bn) return bn;
                  }
                  if (dn.getElementsByTagName("LUI_URL")[0]) {
                    var Cn = dn.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;
                    if (Cn) return Cn;
                  }
                } else Gt += At;
              }
              return null;
            }, getCDMData: function($e) {
              var gt, Zt, Gt, nn;
              if (yt(), !$e) return null;
              for (gt = [], nn = 0; nn < $e.length; ++nn) gt.push($e.charCodeAt(nn)), gt.push(0);
              for (gt = String.fromCharCode.apply(null, gt), gt = Ct.encode(gt), Zt = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>'.replace("%CUSTOMDATA%", gt), Gt = [], nn = 0; nn < Zt.length; ++nn) Gt.push(Zt.charCodeAt(nn)), Gt.push(0);
              return new Uint8Array(Gt).buffer;
            }, setPlayReadyMessageFormat: function($e) {
              if ($e !== "utf-8" && $e !== "utf-16") throw new Error('Specified message format is not one of "utf-8" or "utf-16"');
              wt = $e;
            } };
          }
          T.__dashjs_factory_name = "KeySystemPlayReady";
          var b = dashjs.FactoryMaker.getSingletonFactory(T);
          function X(Dt) {
            var wt = (Dt = Dt || {}).BASE64, Ct = {};
            return Ct[$.WIDEVINE_KEYSTEM_STRING] = { responseType: "json", getLicenseMessage: function(Ye) {
              return wt.decodeArray(Ye.license);
            }, getErrorResponse: function(Ye) {
              return Ye;
            } }, Ct[$.PLAYREADY_KEYSTEM_STRING] = { responseType: "arraybuffer", getLicenseMessage: function(Ye) {
              return Ye;
            }, getErrorResponse: function(Ye) {
              return String.fromCharCode.apply(null, new Uint8Array(Ye));
            } }, { getServerURLFromMessage: function(Ye) {
              return Ye;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function(Ye) {
              return Ct[Ye].responseType;
            }, getLicenseMessage: function(Ye, yt) {
              return function() {
                if (!wt || !wt.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
              }(), Ct[yt].getLicenseMessage(Ye);
            }, getErrorResponse: function(Ye, yt) {
              return Ct[yt].getErrorResponse(Ye);
            } };
          }
          X.__dashjs_factory_name = "DRMToday";
          var z = dashjs.FactoryMaker.getSingletonFactory(X);
          function De() {
            var Dt = "http://schemas.xmlsoap.org/soap/envelope/";
            function wt(yt) {
              var $e = String.fromCharCode.apply(null, new Uint8Array(yt));
              return decodeURIComponent(escape($e));
            }
            function Ct(yt) {
              if (window.DOMParser) {
                var $e = wt(yt), gt = new window.DOMParser().parseFromString($e, "text/xml"), Zt = gt ? gt.getElementsByTagNameNS(Dt, "Envelope")[0] : null, Gt = Zt ? Zt.getElementsByTagNameNS(Dt, "Body")[0] : null;
                if (Gt && Gt.getElementsByTagNameNS(Dt, "Fault")[0]) return null;
              }
              return yt;
            }
            function Ye(yt) {
              var $e = "", gt = "", Zt = "", Gt = -1, nn = -1;
              if (window.DOMParser) {
                var an = wt(yt), Kt = new window.DOMParser().parseFromString(an, "text/xml"), At = Kt ? Kt.getElementsByTagNameNS(Dt, "Envelope")[0] : null, tn = At ? At.getElementsByTagNameNS(Dt, "Body")[0] : null, Jt = tn ? tn.getElementsByTagNameNS(Dt, "Fault")[0] : null, dn = Jt ? Jt.getElementsByTagName("detail")[0] : null, bn = dn ? dn.getElementsByTagName("Exception")[0] : null, Cn = null;
                if (Jt === null) return an;
                $e = (Cn = Jt.getElementsByTagName("faultstring")[0].firstChild) ? Cn.nodeValue : null, bn !== null && (gt = (Cn = bn.getElementsByTagName("StatusCode")[0]) ? Cn.firstChild.nodeValue : null, Gt = (Zt = (Cn = bn.getElementsByTagName("Message")[0]) ? Cn.firstChild.nodeValue : null) ? Zt.lastIndexOf("[") + 1 : -1, nn = Zt ? Zt.indexOf("]") : -1, Zt = Zt ? Zt.substring(Gt, nn) : "");
              }
              var ln = "code: ".concat(gt, ", name: ").concat($e);
              return Zt && (ln += ", message: ".concat(Zt)), ln;
            }
            return { getServerURLFromMessage: function(yt) {
              return yt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "arraybuffer";
            }, getLicenseMessage: function(yt) {
              return Ct.call(this, yt);
            }, getErrorResponse: function(yt) {
              return Ye.call(this, yt);
            } };
          }
          De.__dashjs_factory_name = "PlayReady";
          var tt = J.Z.getSingletonFactory(De);
          function Ue() {
            return { getServerURLFromMessage: function(Dt) {
              return Dt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "arraybuffer";
            }, getLicenseMessage: function(Dt) {
              return Dt;
            }, getErrorResponse: function(Dt) {
              return String.fromCharCode.apply(null, new Uint8Array(Dt));
            } };
          }
          Ue.__dashjs_factory_name = "Widevine";
          var ke = dashjs.FactoryMaker.getSingletonFactory(Ue);
          function Oe() {
            return { getServerURLFromMessage: function(Dt) {
              return Dt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "json";
            }, getLicenseMessage: function(Dt) {
              if (!Dt.hasOwnProperty("keys")) return null;
              for (var wt = [], Ct = 0; Ct < Dt.keys.length; Ct++) {
                var Ye = Dt.keys[Ct], yt = Ye.kid.replace(/=/g, ""), $e = Ye.k.replace(/=/g, "");
                wt.push(new j(yt, $e));
              }
              return new ce(wt);
            }, getErrorResponse: function(Dt) {
              return String.fromCharCode.apply(null, new Uint8Array(Dt));
            } };
          }
          Oe.__dashjs_factory_name = "ClearKey";
          var qe = dashjs.FactoryMaker.getSingletonFactory(Oe);
          function it() {
            var Dt, wt, Ct, Ye, yt, $e, gt, Zt, Gt = this.context;
            function nn(At, tn) {
              return tn && At in tn ? tn[At] : null;
            }
            function an(At, tn) {
              return At && At.sessionId ? At.sessionId : tn && tn.sessionId ? tn.sessionId : null;
            }
            function Kt(At, tn) {
              return At && At.sessionType ? At.sessionType : tn;
            }
            return Dt = { initialize: function() {
              var At;
              Ye = [], At = b(Gt).getInstance({ BASE64: yt, settings: $e }), Ye.push(At), At = Te(Gt).getInstance({ BASE64: yt }), Ye.push(At), At = Ze(Gt).getInstance({ BASE64: yt }), Ye.push(At), gt = At, At = It(Gt).getInstance({ BASE64: yt, debug: wt }), Ye.push(At), Zt = At;
            }, setProtectionData: function(At) {
              for (var tn, Jt, dn = 0; dn < Ye.length; dn++) {
                var bn = Ye[dn];
                bn.hasOwnProperty("init") && bn.init((tn = bn.systemString, Jt = void 0, Jt = null, At && (Jt = tn in At ? At[tn] : null), Jt));
              }
            }, isClearKey: function(At) {
              return At === gt || At === Zt;
            }, initDataEquals: function(At, tn) {
              if (At.byteLength === tn.byteLength) {
                for (var Jt = new Uint8Array(At), dn = new Uint8Array(tn), bn = 0; bn < Jt.length; bn++) if (Jt[bn] !== dn[bn]) return !1;
                return !0;
              }
              return !1;
            }, getKeySystems: function() {
              return Ye;
            }, setKeySystems: function(At) {
              Ye = At;
            }, getKeySystemBySystemString: function(At) {
              for (var tn = 0; tn < Ye.length; tn++) if (Ye[tn].systemString === At) return Ye[tn];
              return null;
            }, getSupportedKeySystemsFromContentProtection: function(At, tn, Jt) {
              var dn, bn, Cn, ln, St = [];
              if (At) {
                var Ot = t.findCencContentProtection(At);
                for (Cn = 0; Cn < Ye.length; ++Cn) {
                  var jt = nn((bn = Ye[Cn]).systemString, tn);
                  for (ln = 0; ln < At.length; ++ln) if ((dn = At[ln]).schemeIdUri.toLowerCase() === bn.schemeIdURI) {
                    var fn = bn.getInitData(dn, Ot);
                    St.push({ ks: Ye[Cn], keyId: dn.keyId, initData: fn, protData: jt, cdmData: bn.getCDMData(jt ? jt.cdmData : null), sessionId: an(jt, dn), sessionType: Kt(jt, Jt) });
                  }
                }
              }
              return St;
            }, getSupportedKeySystemsFromSegmentPssh: function(At, tn, Jt) {
              for (var dn, bn = [], Cn = t.parsePSSHList(At), ln = 0; ln < Ye.length; ++ln) {
                var St = nn((dn = Ye[ln]).systemString, tn);
                dn.uuid in Cn && bn.push({ ks: dn, initData: Cn[dn.uuid], protData: St, cdmData: dn.getCDMData(St ? St.cdmData : null), sessionId: an(St), sessionType: Kt(St, Jt) });
              }
              return bn;
            }, getLicenseServerModelInstance: function(At, tn, Jt) {
              if (Jt === "license-release" || Jt === "individualization-request") return null;
              var dn = null;
              return tn && tn.hasOwnProperty("drmtoday") ? dn = z(Gt).getInstance({ BASE64: yt }) : At.systemString === $.WIDEVINE_KEYSTEM_STRING ? dn = ke(Gt).getInstance() : At.systemString === $.PLAYREADY_KEYSTEM_STRING ? dn = tt(Gt).getInstance() : At.systemString === $.CLEARKEY_KEYSTEM_STRING && (dn = qe(Gt).getInstance()), dn;
            }, processClearKeyLicenseRequest: function(At, tn, Jt) {
              try {
                return At.getClearKeysFromProtectionData(tn, Jt);
              } catch {
                return Ct.error("Failed to retrieve clearkeys from ProtectionData"), null;
              }
            }, setConfig: function(At) {
              At && (At.debug && (wt = At.debug, Ct = wt.getLogger(Dt)), At.BASE64 && (yt = At.BASE64), At.settings && ($e = At.settings));
            } }, Dt;
          }
          it.__dashjs_factory_name = "ProtectionKeyController";
          var bt = dashjs.FactoryMaker.getSingletonFactory(it);
          function dt(Dt) {
            return dt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(wt) {
              return typeof wt;
            } : function(wt) {
              return wt && typeof Symbol == "function" && wt.constructor === Symbol && wt !== Symbol.prototype ? "symbol" : typeof wt;
            }, dt(Dt);
          }
          function Yt(Dt, wt) {
            return Yt = Object.setPrototypeOf || function(Ct, Ye) {
              return Ct.__proto__ = Ye, Ct;
            }, Yt(Dt, wt);
          }
          function Mt(Dt, wt) {
            return !wt || dt(wt) !== "object" && typeof wt != "function" ? function(Ct) {
              if (Ct === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return Ct;
            }(Dt) : wt;
          }
          function Ht(Dt) {
            return Ht = Object.setPrototypeOf ? Object.getPrototypeOf : function(wt) {
              return wt.__proto__ || Object.getPrototypeOf(wt);
            }, Ht(Dt);
          }
          var Ut = new (function(Dt) {
            (function($e, gt) {
              if (typeof gt != "function" && gt !== null) throw new TypeError("Super expression must either be null or a function");
              $e.prototype = Object.create(gt && gt.prototype, { constructor: { value: $e, writable: !0, configurable: !0 } }), gt && Yt($e, gt);
            })(yt, Dt);
            var wt, Ct, Ye = (wt = yt, Ct = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var $e, gt = Ht(wt);
              if (Ct) {
                var Zt = Ht(this).constructor;
                $e = Reflect.construct(gt, arguments, Zt);
              } else $e = gt.apply(this, arguments);
              return Mt(this, $e);
            });
            function yt() {
              var $e;
              return function(gt, Zt) {
                if (!(gt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
              }(this, yt), ($e = Ye.call(this)).INTERNAL_KEY_MESSAGE = "internalKeyMessage", $e.INTERNAL_KEY_STATUS_CHANGED = "internalkeyStatusChanged", $e.KEY_ADDED = "public_keyAdded", $e.KEY_ERROR = "public_keyError", $e.KEY_MESSAGE = "public_keyMessage", $e.KEY_SESSION_CLOSED = "public_keySessionClosed", $e.KEY_SESSION_CREATED = "public_keySessionCreated", $e.KEY_SESSION_REMOVED = "public_keySessionRemoved", $e.KEY_STATUSES_CHANGED = "public_keyStatusesChanged", $e.KEY_SYSTEM_ACCESS_COMPLETE = "public_keySystemAccessComplete", $e.KEY_SYSTEM_SELECTED = "public_keySystemSelected", $e.LICENSE_REQUEST_COMPLETE = "public_licenseRequestComplete", $e.LICENSE_REQUEST_SENDING = "public_licenseRequestSending", $e.NEED_KEY = "needkey", $e.PROTECTION_CREATED = "public_protectioncreated", $e.PROTECTION_DESTROYED = "public_protectiondestroyed", $e.SERVER_CERTIFICATE_UPDATED = "serverCertificateUpdated", $e.TEARDOWN_COMPLETE = "protectionTeardownComplete", $e.VIDEO_ELEMENT_SELECTED = "videoElementSelected", $e.KEY_SESSION_UPDATED = "public_keySessionUpdated", $e;
            }
            return yt;
          }(R(8342).Z))(), cn = function Dt(wt, Ct) {
            (function(Ye, yt) {
              if (!(Ye instanceof yt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.initData = wt, this.initDataType = Ct;
          }, Tn = function Dt(wt, Ct, Ye, yt) {
            (function($e, gt) {
              if (!($e instanceof gt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.sessionToken = wt, this.message = Ct, this.defaultURL = Ye, this.messageType = yt || "license-request";
          }, xn = function Dt(wt, Ct) {
            (function(Ye, yt) {
              if (!(Ye instanceof yt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.keySystem = wt, this.ksConfiguration = Ct;
          }, Mn = {};
          function kn(Dt) {
            Dt = Dt || {};
            var wt, Ct, Ye, yt, $e, gt, Zt, Gt, nn = this.context, an = Dt.eventBus, Kt = Dt.events, At = Dt.debug;
            function tn(St, Ot, jt, fn) {
              if (navigator.requestMediaKeySystemAccess === void 0 || typeof navigator.requestMediaKeySystemAccess != "function") {
                var mn = "Insecure origins are not allowed";
                return an.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { error: mn }), void fn({ error: mn });
              }
              var In = St[Ot].protData && St[Ot].protData.systemStringPriority ? St[Ot].protData.systemStringPriority : null, Rn = St[Ot].configs, nr = St[Ot].ks, rr = nr.systemString;
              (function(Gn, $n) {
                return new Promise(function(jn, ir) {
                  Jt(Gn, $n, 0, jn, ir);
                });
              })(In || (Mn[rr] ? Mn[rr] : [rr]), Rn).then(function(Gn) {
                var $n = typeof Gn.getConfiguration == "function" ? Gn.getConfiguration() : null, jn = new xn(nr, $n);
                jn.mksa = Gn, an.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { data: jn }), jt({ data: jn });
              }).catch(function(Gn) {
                if (Ot + 1 < St.length) tn(St, Ot + 1, jt, fn);
                else {
                  var $n = "Key system access denied! ";
                  an.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { error: $n + Gn.message }), fn({ error: $n + Gn.message });
                }
              });
            }
            function Jt(St, Ot, jt, fn, mn) {
              var In = St[jt];
              Ct.debug("Requesting key system access for system string ".concat(In)), navigator.requestMediaKeySystemAccess(In, Ot).then(function(Rn) {
                Rn.selectedSystemString = In, fn(Rn);
              }).catch(function(Rn) {
                jt + 1 < St.length ? Jt(St, Ot, jt + 1, fn, mn) : mn(Rn);
              });
            }
            function dn(St) {
              if (!St || !St.session) return Promise.resolve;
              var Ot = St.session;
              return Ot.removeEventListener("keystatuseschange", St), Ot.removeEventListener("message", St), Ot.close();
            }
            function bn(St) {
              for (var Ot = 0; Ot < gt.length; Ot++) if (gt[Ot] === St) {
                gt.splice(Ot, 1);
                break;
              }
            }
            function Cn(St) {
              var Ot, jt;
              return St && St.length > 0 && (St[0] && (typeof St[0] == "string" ? Ot = St[0] : jt = St[0]), St[1] && (typeof St[1] == "string" ? Ot = St[1] : jt = St[1])), { status: Ot, keyId: jt };
            }
            function ln(St, Ot) {
              var jt = { session: St, keyId: Ot.keyId, initData: Ot.initData, sessionId: Ot.sessionId, sessionType: Ot.sessionType, handleEvent: function(fn) {
                switch (fn.type) {
                  case "keystatuseschange":
                    an.trigger(Kt.KEY_STATUSES_CHANGED, { data: this }), fn.target.keyStatuses.forEach(function() {
                      var In = Cn(arguments);
                      In.status === "expired" ? an.trigger(Kt.INTERNAL_KEY_STATUS_CHANGED, { error: new f.Z(n.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE, n.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE) }) : an.trigger(Kt.INTERNAL_KEY_STATUS_CHANGED, In);
                    });
                    break;
                  case "message":
                    var mn = ArrayBuffer.isView(fn.message) ? fn.message.buffer : fn.message;
                    an.trigger(Kt.INTERNAL_KEY_MESSAGE, { data: new Tn(this, mn, void 0, fn.messageType) });
                }
              }, getKeyId: function() {
                return this.keyId;
              }, getSessionId: function() {
                return St.sessionId;
              }, getSessionType: function() {
                return this.sessionType;
              }, getExpirationTime: function() {
                return St.expiration;
              }, getKeyStatuses: function() {
                return St.keyStatuses;
              }, getUsable: function() {
                var fn = !1;
                return St.keyStatuses.forEach(function() {
                  var mn = Cn(arguments);
                  mn.status === "usable" && (fn = !0);
                }), fn;
              } };
              return St.addEventListener("keystatuseschange", jt), St.addEventListener("message", jt), St.closed.then(function() {
                bn(jt), Ct.debug("DRM: Session closed.  SessionID = " + jt.getSessionId()), an.trigger(Kt.KEY_SESSION_CLOSED, { data: jt.getSessionId() });
              }), gt.push(jt), jt;
            }
            return wt = { getAllInitData: function() {
              for (var St = [], Ot = 0; Ot < gt.length; Ot++) gt[Ot].initData && St.push(gt[Ot].initData);
              return St;
            }, getSessions: function() {
              return gt;
            }, requestKeySystemAccess: function(St) {
              return new Promise(function(Ot, jt) {
                tn(St, 0, Ot, jt);
              });
            }, selectKeySystem: function(St) {
              return new Promise(function(Ot, jt) {
                St.mksa.createMediaKeys().then(function(fn) {
                  return Ye = St.keySystem, $e = fn, yt ? yt.setMediaKeys($e) : Promise.resolve();
                }).then(function() {
                  Ot(Ye);
                }).catch(function() {
                  jt({ error: "Error selecting keys system (" + St.keySystem.systemString + ")! Could not create MediaKeys -- TODO" });
                });
              });
            }, setMediaElement: function(St) {
              yt !== St && (yt && (yt.removeEventListener("encrypted", Zt), yt.setMediaKeys && yt.setMediaKeys(null)), (yt = St) && (yt.addEventListener("encrypted", Zt), yt.setMediaKeys && $e && yt.setMediaKeys($e)));
            }, setServerCertificate: function(St) {
              if (!Ye || !$e) throw new Error("Can not set server certificate until you have selected a key system");
              $e.setServerCertificate(St).then(function() {
                Ct.info("DRM: License server certificate successfully updated."), an.trigger(Kt.SERVER_CERTIFICATE_UPDATED);
              }).catch(function(Ot) {
                an.trigger(Kt.SERVER_CERTIFICATE_UPDATED, { error: new f.Z(n.SERVER_CERTIFICATE_UPDATED_ERROR_CODE, n.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE + Ot.name) });
              });
            }, createKeySession: function(St) {
              if (!Ye || !$e) throw new Error("Can not create sessions until you have selected a key system");
              var Ot = $e.createSession(St.sessionType), jt = ln(Ot, St), fn = Ye.systemString === $.CLEARKEY_KEYSTEM_STRING && (St.initData || St.protData && St.protData.clearkeys) ? $.INITIALIZATION_DATA_TYPE_KEYIDS : $.INITIALIZATION_DATA_TYPE_CENC;
              Ot.generateRequest(fn, St.initData).then(function() {
                Ct.debug("DRM: Session created.  SessionID = " + jt.getSessionId()), an.trigger(Kt.KEY_SESSION_CREATED, { data: jt });
              }).catch(function(mn) {
                bn(jt), an.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new f.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Error generating key request -- " + mn.name) });
              });
            }, updateKeySession: function(St, Ot) {
              var jt = St.session;
              Gt.isClearKey(Ye) && (Ot = Ot.toJWK()), jt.update(Ot).then(function() {
                an.trigger(Kt.KEY_SESSION_UPDATED);
              }).catch(function(fn) {
                an.trigger(Kt.KEY_ERROR, { error: new f.Z(n.MEDIA_KEYERR_CODE, "Error sending update() message! " + fn.name, St) });
              });
            }, loadKeySession: function(St) {
              if (!Ye || !$e) throw new Error("Can not load sessions until you have selected a key system");
              for (var Ot = St.sessionId, jt = 0; jt < gt.length; jt++) if (Ot === gt[jt].sessionId) return void Ct.warn("DRM: Ignoring session ID because we have already seen it!");
              var fn = $e.createSession(St.sessionType), mn = ln(fn, St);
              fn.load(Ot).then(function(In) {
                In ? (Ct.debug("DRM: Session loaded.  SessionID = " + mn.getSessionId()), an.trigger(Kt.KEY_SESSION_CREATED, { data: mn })) : (bn(mn), an.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new f.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session! Invalid Session ID (" + Ot + ")") }));
              }).catch(function(In) {
                bn(mn), an.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new f.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session (" + Ot + ")! " + In.name) });
              });
            }, removeKeySession: function(St) {
              St.session.remove().then(function() {
                Ct.debug("DRM: Session removed.  SessionID = " + St.getSessionId()), an.trigger(Kt.KEY_SESSION_REMOVED, { data: St.getSessionId() });
              }, function(Ot) {
                an.trigger(Kt.KEY_SESSION_REMOVED, { data: null, error: "Error removing session (" + St.getSessionId() + "). " + Ot.name });
              });
            }, closeKeySession: function(St) {
              dn(St).catch(function(Ot) {
                bn(St), an.trigger(Kt.KEY_SESSION_CLOSED, { data: null, error: "Error closing session (" + St.getSessionId() + ") " + Ot.name });
              });
            }, stop: function() {
              for (var St, Ot = 0; Ot < gt.length; Ot++) (St = gt[Ot]).getUsable() || (dn(St), bn(St));
            }, reset: function() {
              var St, Ot = gt.length;
              Ot !== 0 ? function() {
                for (var jt = function(mn) {
                  bn(mn), gt.length === 0 && (yt ? (yt.removeEventListener("encrypted", Zt), yt.setMediaKeys(null).then(function() {
                    an.trigger(Kt.TEARDOWN_COMPLETE);
                  })) : an.trigger(Kt.TEARDOWN_COMPLETE));
                }, fn = 0; fn < Ot; fn++) (function(mn) {
                  dn(St), jt(mn);
                })(St = gt[fn]);
              }() : an.trigger(Kt.TEARDOWN_COMPLETE);
            } }, Ct = At.getLogger(wt), Ye = null, yt = null, $e = null, gt = [], Gt = bt(nn).getInstance(), Zt = { handleEvent: function(St) {
              if (St.type === "encrypted" && St.initData) {
                var Ot = ArrayBuffer.isView(St.initData) ? St.initData.buffer : St.initData;
                an.trigger(Kt.NEED_KEY, { key: new cn(Ot, St.initDataType) });
              }
            } }, wt;
          }
          Mn[$.PLAYREADY_KEYSTEM_STRING] = [$.PLAYREADY_KEYSTEM_STRING, $.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING], Mn[$.WIDEVINE_KEYSTEM_STRING] = [$.WIDEVINE_KEYSTEM_STRING], Mn[$.CLEARKEY_KEYSTEM_STRING] = [$.CLEARKEY_KEYSTEM_STRING], kn.__dashjs_factory_name = "ProtectionModel_21Jan2015";
          var tr = dashjs.FactoryMaker.getClassFactory(kn);
          function wn(Dt) {
            Dt = Dt || {};
            var wt, Ct, Ye, yt, $e, gt, Zt, Gt, nn, an = this.context, Kt = Dt.eventBus, At = Dt.events, tn = Dt.debug, Jt = Dt.api;
            function dn() {
              try {
                for (var ln = 0; ln < Zt.length; ln++) bn(Zt[ln]);
                Ye && Ye.removeEventListener(Jt.needkey, Gt), Kt.trigger(At.TEARDOWN_COMPLETE);
              } catch (St) {
                Kt.trigger(At.TEARDOWN_COMPLETE, { error: "Error tearing down key sessions and MediaKeys! -- " + St.message });
              }
            }
            function bn(ln) {
              var St = ln.session;
              St.removeEventListener(Jt.error, ln), St.removeEventListener(Jt.message, ln), St.removeEventListener(Jt.ready, ln), St.removeEventListener(Jt.close, ln);
              for (var Ot = 0; Ot < Zt.length; Ot++) if (Zt[Ot] === ln) {
                Zt.splice(Ot, 1);
                break;
              }
              St[Jt.release]();
            }
            function Cn() {
              var ln = null, St = function() {
                Ye.removeEventListener("loadedmetadata", ln), Ye[Jt.setMediaKeys]($e), Kt.trigger(At.VIDEO_ELEMENT_SELECTED);
              };
              Ye.readyState >= 1 ? St() : (ln = St.bind(this), Ye.addEventListener("loadedmetadata", ln));
            }
            return wt = { getAllInitData: function() {
              for (var ln = [], St = 0; St < Zt.length; St++) ln.push(Zt[St].initData);
              return ln;
            }, getSessions: function() {
              return Zt;
            }, requestKeySystemAccess: function(ln) {
              return new Promise(function(St, Ot) {
                for (var jt = !1, fn = 0; fn < ln.length; fn++) for (var mn = ln[fn].ks.systemString, In = ln[fn].configs, Rn = null, nr = null, rr = 0; rr < In.length; rr++) {
                  var Gn = In[rr].audioCapabilities, $n = In[rr].videoCapabilities;
                  if (Gn && Gn.length !== 0) {
                    Rn = [];
                    for (var jn = 0; jn < Gn.length; jn++) window[Jt.MediaKeys].isTypeSupported(mn, Gn[jn].contentType) && Rn.push(Gn[jn]);
                  }
                  if ($n && $n.length !== 0) {
                    nr = [];
                    for (var ir = 0; ir < $n.length; ir++) window[Jt.MediaKeys].isTypeSupported(mn, $n[ir].contentType) && nr.push($n[ir]);
                  }
                  if (!(!Rn && !nr || Rn && Rn.length === 0 || nr && nr.length === 0)) {
                    jt = !0;
                    var Hr = new m(Rn, nr), wr = nn.getKeySystemBySystemString(mn), Or = new xn(wr, Hr);
                    Kt.trigger(At.KEY_SYSTEM_ACCESS_COMPLETE, { data: Or }), St({ data: Or });
                    break;
                  }
                }
                if (!jt) {
                  var ur = "Key system access denied! -- No valid audio/video content configurations detected!";
                  Kt.trigger(At.KEY_SYSTEM_ACCESS_COMPLETE, { error: ur }), Ot({ error: ur });
                }
              });
            }, selectKeySystem: function(ln) {
              return new Promise(function(St, Ot) {
                try {
                  $e = ln.mediaKeys = new window[Jt.MediaKeys](ln.keySystem.systemString), yt = ln.keySystem, gt = ln, Ye && Cn(), St(yt);
                } catch {
                  Ot({ error: "Error selecting keys system (" + yt.systemString + ")! Could not create MediaKeys -- TODO" });
                }
              });
            }, setMediaElement: function(ln) {
              Ye !== ln && (Ye && Ye.removeEventListener(Jt.needkey, Gt), (Ye = ln) && (Ye.addEventListener(Jt.needkey, Gt), $e && Cn()));
            }, createKeySession: function(ln) {
              if (!yt || !$e || !gt) throw new Error("Can not create sessions until you have selected a key system");
              var St = null;
              if (gt.ksConfiguration.videoCapabilities && gt.ksConfiguration.videoCapabilities.length > 0 && (St = gt.ksConfiguration.videoCapabilities[0]), St === null && gt.ksConfiguration.audioCapabilities && gt.ksConfiguration.audioCapabilities.length > 0 && (St = gt.ksConfiguration.audioCapabilities[0]), St === null) throw new Error("Can not create sessions for unknown content types.");
              var Ot = St.contentType, jt = $e.createSession(Ot, new Uint8Array(ln.initData), ln.cdmData ? new Uint8Array(ln.cdmData) : null), fn = function(mn, In) {
                return { session: mn, keyId: In.keyId, initData: In.initData, getKeyId: function() {
                  return this.keyId;
                }, getSessionId: function() {
                  return this.session.sessionId;
                }, getExpirationTime: function() {
                  return NaN;
                }, getSessionType: function() {
                  return "temporary";
                }, handleEvent: function(Rn) {
                  switch (Rn.type) {
                    case Jt.error:
                      Kt.trigger(At.KEY_ERROR, { error: new f.Z(n.MEDIA_KEYERR_CODE, "KeyError", this) });
                      break;
                    case Jt.message:
                      var nr = ArrayBuffer.isView(Rn.message) ? Rn.message.buffer : Rn.message;
                      Kt.trigger(At.INTERNAL_KEY_MESSAGE, { data: new Tn(this, nr, Rn.destinationURL) });
                      break;
                    case Jt.ready:
                      Ct.debug("DRM: Key added."), Kt.trigger(At.KEY_ADDED);
                      break;
                    case Jt.close:
                      Ct.debug("DRM: Session closed.  SessionID = " + this.getSessionId()), Kt.trigger(At.KEY_SESSION_CLOSED, { data: this.getSessionId() });
                  }
                } };
              }(jt, ln);
              jt.addEventListener(Jt.error, fn), jt.addEventListener(Jt.message, fn), jt.addEventListener(Jt.ready, fn), jt.addEventListener(Jt.close, fn), Zt.push(fn), Ct.debug("DRM: Session created.  SessionID = " + fn.getSessionId()), Kt.trigger(At.KEY_SESSION_CREATED, { data: fn });
            }, updateKeySession: function(ln, St) {
              var Ot = ln.session;
              nn.isClearKey(yt) ? Ot.update(new Uint8Array(St.toJWK())) : Ot.update(new Uint8Array(St)), Kt.trigger(At.KEY_SESSION_UPDATED);
            }, closeKeySession: bn, setServerCertificate: function() {
            }, loadKeySession: function() {
            }, removeKeySession: function() {
            }, stop: dn, reset: dn }, Ct = tn.getLogger(wt), Ye = null, yt = null, $e = null, gt = null, Zt = [], nn = bt(an).getInstance(), Gt = { handleEvent: function(ln) {
              if (ln.type === Jt.needkey && ln.initData) {
                var St = ArrayBuffer.isView(ln.initData) ? ln.initData.buffer : ln.initData;
                Kt.trigger(At.NEED_KEY, { key: new cn(St, "cenc") });
              }
            } }, wt;
          }
          wn.__dashjs_factory_name = "ProtectionModel_3Feb2014";
          var hr = dashjs.FactoryMaker.getClassFactory(wn);
          function zn(Dt) {
            Dt = Dt || {};
            var wt, Ct, Ye, yt, $e, gt, Zt, Gt, nn, an = this.context, Kt = Dt.eventBus, At = Dt.events, tn = Dt.debug, Jt = Dt.api, dn = Dt.errHandler;
            function bn() {
              Ye && St();
              for (var Ot = 0; Ot < Zt.length; Ot++) Cn(Zt[Ot]);
              Kt.trigger(At.TEARDOWN_COMPLETE);
            }
            function Cn(Ot) {
              try {
                Ye[Jt.cancelKeyRequest](yt.systemString, Ot.sessionId);
              } catch (jt) {
                Kt.trigger(At.KEY_SESSION_CLOSED, { data: null, error: "Error closing session (" + Ot.sessionId + ") " + jt.message });
              }
            }
            function ln(Ot, jt) {
              if (jt && Ot) {
                for (var fn = Ot.length, mn = 0; mn < fn; mn++) if (Ot[mn].sessionId == jt) return Ot[mn];
                return null;
              }
              return null;
            }
            function St() {
              Ye.removeEventListener(Jt.keyerror, nn), Ye.removeEventListener(Jt.needkey, nn), Ye.removeEventListener(Jt.keymessage, nn), Ye.removeEventListener(Jt.keyadded, nn);
            }
            return wt = { getAllInitData: function() {
              for (var Ot = [], jt = 0; jt < gt.length; jt++) Ot.push(gt[jt].initData);
              for (var fn = 0; fn < Zt.length; fn++) Ot.push(Zt[fn].initData);
              return Ot;
            }, getSessions: function() {
              return Zt.concat(gt);
            }, requestKeySystemAccess: function(Ot) {
              return new Promise(function(jt, fn) {
                var mn = Ye;
                mn || (mn = document.createElement("video"));
                for (var In = !1, Rn = 0; Rn < Ot.length; Rn++) for (var nr = Ot[Rn].ks.systemString, rr = Ot[Rn].configs, Gn = null, $n = 0; $n < rr.length; $n++) {
                  var jn = rr[$n].videoCapabilities;
                  if (jn && jn.length !== 0) {
                    Gn = [];
                    for (var ir = 0; ir < jn.length; ir++) mn.canPlayType(jn[ir].contentType, nr) !== "" && Gn.push(jn[ir]);
                  }
                  if (Gn && (!Gn || Gn.length !== 0)) {
                    In = !0;
                    var Hr = new m(null, Gn), wr = $e.getKeySystemBySystemString(nr), Or = new xn(wr, Hr);
                    Kt.trigger(At.KEY_SYSTEM_ACCESS_COMPLETE, { data: Or }), jt({ data: Or });
                    break;
                  }
                }
                if (!In) {
                  var ur = "Key system access denied! -- No valid audio/video content configurations detected!";
                  Kt.trigger(At.KEY_SYSTEM_ACCESS_COMPLETE, { error: ur }), fn({ error: ur });
                }
              });
            }, selectKeySystem: function(Ot) {
              return yt = Ot.keySystem, Promise.resolve(yt);
            }, setMediaElement: function(Ot) {
              if (Ye !== Ot) {
                if (Ye) {
                  St();
                  for (var jt = 0; jt < Zt.length; jt++) Cn(Zt[jt]);
                  Zt = [];
                }
                (Ye = Ot) && (Ye.addEventListener(Jt.keyerror, nn), Ye.addEventListener(Jt.needkey, nn), Ye.addEventListener(Jt.keymessage, nn), Ye.addEventListener(Jt.keyadded, nn), Kt.trigger(At.VIDEO_ELEMENT_SELECTED));
              }
            }, createKeySession: function(Ot) {
              if (!yt) throw new Error("Can not create sessions until you have selected a key system");
              if (Gt || Zt.length === 0) {
                var jt = { sessionId: null, keyId: Ot.keyId, initData: Ot.initData, getKeyId: function() {
                  return this.keyId;
                }, getSessionId: function() {
                  return this.sessionId;
                }, getExpirationTime: function() {
                  return NaN;
                }, getSessionType: function() {
                  return "temporary";
                } };
                return gt.push(jt), Ye[Jt.generateKeyRequest](yt.systemString, new Uint8Array(Ot.initData)), jt;
              }
              throw new Error("Multiple sessions not allowed!");
            }, updateKeySession: function(Ot, jt) {
              var fn = Ot.sessionId;
              if ($e.isClearKey(yt)) for (var mn = 0; mn < jt.keyPairs.length; mn++) Ye[Jt.addKey](yt.systemString, jt.keyPairs[mn].key, jt.keyPairs[mn].keyID, fn);
              else Ye[Jt.addKey](yt.systemString, new Uint8Array(jt), new Uint8Array(Ot.initData), fn);
              Kt.trigger(At.KEY_SESSION_UPDATED);
            }, closeKeySession: Cn, setServerCertificate: function() {
            }, loadKeySession: function() {
            }, removeKeySession: function() {
            }, stop: bn, reset: bn }, Ct = tn.getLogger(wt), Ye = null, yt = null, gt = [], Zt = [], $e = bt(an).getInstance(), nn = { handleEvent: function(Ot) {
              var jt = null;
              switch (Ot.type) {
                case Jt.needkey:
                  var fn = ArrayBuffer.isView(Ot.initData) ? Ot.initData.buffer : Ot.initData;
                  Kt.trigger(At.NEED_KEY, { key: new cn(fn, "cenc") });
                  break;
                case Jt.keyerror:
                  if ((jt = ln(Zt, Ot.sessionId)) || (jt = ln(gt, Ot.sessionId)), jt) {
                    var mn = n.MEDIA_KEYERR_CODE, In = "";
                    switch (Ot.errorCode.code) {
                      case 1:
                        mn = n.MEDIA_KEYERR_UNKNOWN_CODE, In += "MEDIA_KEYERR_UNKNOWN - " + n.MEDIA_KEYERR_UNKNOWN_MESSAGE;
                        break;
                      case 2:
                        mn = n.MEDIA_KEYERR_CLIENT_CODE, In += "MEDIA_KEYERR_CLIENT - " + n.MEDIA_KEYERR_CLIENT_MESSAGE;
                        break;
                      case 3:
                        mn = n.MEDIA_KEYERR_SERVICE_CODE, In += "MEDIA_KEYERR_SERVICE - " + n.MEDIA_KEYERR_SERVICE_MESSAGE;
                        break;
                      case 4:
                        mn = n.MEDIA_KEYERR_OUTPUT_CODE, In += "MEDIA_KEYERR_OUTPUT - " + n.MEDIA_KEYERR_OUTPUT_MESSAGE;
                        break;
                      case 5:
                        mn = n.MEDIA_KEYERR_HARDWARECHANGE_CODE, In += "MEDIA_KEYERR_HARDWARECHANGE - " + n.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;
                        break;
                      case 6:
                        mn = n.MEDIA_KEYERR_DOMAIN_CODE, In += "MEDIA_KEYERR_DOMAIN - " + n.MEDIA_KEYERR_DOMAIN_MESSAGE;
                    }
                    In += "  System Code = " + Ot.systemCode, Kt.trigger(At.KEY_ERROR, { error: new f.Z(mn, In, jt) });
                  } else Ct.error("No session token found for key error");
                  break;
                case Jt.keyadded:
                  (jt = ln(Zt, Ot.sessionId)) || (jt = ln(gt, Ot.sessionId)), jt ? (Ct.debug("DRM: Key added."), Kt.trigger(At.KEY_ADDED, { data: jt })) : Ct.debug("No session token found for key added");
                  break;
                case Jt.keymessage:
                  if ((Gt = Ot.sessionId !== null && Ot.sessionId !== void 0) ? !(jt = ln(Zt, Ot.sessionId)) && gt.length > 0 && (jt = gt.shift(), Zt.push(jt), jt.sessionId = Ot.sessionId, Kt.trigger(At.KEY_SESSION_CREATED, { data: jt })) : gt.length > 0 && (jt = gt.shift(), Zt.push(jt), gt.length !== 0 && dn.error(new f.Z(n.MEDIA_KEY_MESSAGE_ERROR_CODE, n.MEDIA_KEY_MESSAGE_ERROR_MESSAGE))), jt) {
                    var Rn = ArrayBuffer.isView(Ot.message) ? Ot.message.buffer : Ot.message;
                    jt.keyMessage = Rn, Kt.trigger(At.INTERNAL_KEY_MESSAGE, { data: new Tn(jt, Rn, Ot.defaultURL) });
                  } else Ct.warn("No session token found for key message");
              }
            } }, wt;
          }
          zn.__dashjs_factory_name = "ProtectionModel_01b";
          var or = dashjs.FactoryMaker.getClassFactory(zn), vr = [{ generateKeyRequest: "generateKeyRequest", addKey: "addKey", cancelKeyRequest: "cancelKeyRequest", needkey: "needkey", keyerror: "keyerror", keyadded: "keyadded", keymessage: "keymessage" }, { generateKeyRequest: "webkitGenerateKeyRequest", addKey: "webkitAddKey", cancelKeyRequest: "webkitCancelKeyRequest", needkey: "webkitneedkey", keyerror: "webkitkeyerror", keyadded: "webkitkeyadded", keymessage: "webkitkeymessage" }], sr = [{ setMediaKeys: "setMediaKeys", MediaKeys: "MediaKeys", release: "close", needkey: "needkey", error: "keyerror", message: "keymessage", ready: "keyadded", close: "keyclose" }, { setMediaKeys: "msSetMediaKeys", MediaKeys: "MSMediaKeys", release: "close", needkey: "msneedkey", error: "mskeyerror", message: "mskeymessage", ready: "mskeyadded", close: "mskeyclose" }];
          function Ar() {
            var Dt, wt = this.context;
            function Ct(Ye, yt) {
              for (var $e = 0; $e < yt.length; $e++) {
                var gt = yt[$e];
                if (typeof Ye[gt[Object.keys(gt)[0]]] == "function") return gt;
              }
              return null;
            }
            return Dt = { createProtectionSystem: function(Ye) {
              var yt = null, $e = bt(wt).getInstance();
              $e.setConfig({ debug: Ye.debug, BASE64: Ye.BASE64, settings: Ye.settings }), $e.initialize();
              var gt = function(Zt) {
                var Gt = Zt.debug, nn = Gt.getLogger(Dt), an = Zt.eventBus, Kt = Zt.errHandler, At = Zt.videoModel ? Zt.videoModel.getElement() : null;
                return At && At.onencrypted === void 0 || At && At.mediaKeys === void 0 ? Ct(At, sr) ? (nn.info("EME detected on this user agent! (ProtectionModel_3Feb2014)"), hr(wt).create({ debug: Gt, eventBus: an, events: Zt.events, api: Ct(At, sr) })) : Ct(At, vr) ? (nn.info("EME detected on this user agent! (ProtectionModel_01b)"), or(wt).create({ debug: Gt, eventBus: an, errHandler: Kt, events: Zt.events, api: Ct(At, vr) })) : (nn.warn("No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!"), null) : (nn.info("EME detected on this user agent! (ProtectionModel_21Jan2015)"), tr(wt).create({ debug: Gt, eventBus: an, events: Zt.events }));
              }(Ye);
              return !yt && gt && (yt = se(wt).create({ protectionModel: gt, protectionKeyController: $e, eventBus: Ye.eventBus, debug: Ye.debug, events: Ye.events, BASE64: Ye.BASE64, constants: Ye.constants, cmcdModel: Ye.cmcdModel, customParametersModel: Ye.customParametersModel, settings: Ye.settings }), Ye.capabilities.setEncryptedMediaSupported(!0)), yt;
            } };
          }
          Ar.__dashjs_factory_name = "Protection";
          var Ir = dashjs.FactoryMaker.getClassFactory(Ar);
          Ir.events = Ut, Ir.errors = n, dashjs.FactoryMaker.updateClassFactory(Ar.__dashjs_factory_name, Ir);
          var li = Ir;
        }, 2068: function(Se, ge, R) {
          var te = R(5448), E = { DEFAULT: 0.5, STRONG: 1, WEAK: 0 };
          function t(m, p, l) {
            var v, h;
            return v = m === void 0 ? -1 : m, h = function(n) {
              var f = E.DEFAULT;
              return n !== E.DEFAULT && n !== E.STRONG && n !== E.WEAK || (f = n), f;
            }(l), { quality: v, reason: p === void 0 ? null : p, priority: h };
          }
          t.__dashjs_factory_name = "SwitchRequest";
          var e = te.Z.getClassFactory(t);
          e.NO_CHANGE = -1, e.PRIORITY = E, te.Z.updateClassFactory(t.__dashjs_factory_name, e), ge.Z = e;
        }, 1767: function(Se, ge, R) {
          var te = R(5628), E = R(6535), t = R(7423), e = R(895), m = R(6070), p = R(3112), l = R(1914), v = R(5435), h = R(5448), n = R(2068), f = R(3393), d = "qualitySwitchRules", S = "abandonFragmentRules";
          function x(P) {
            P = P || {};
            var J, M, W = this.context, se = P.mediaPlayerModel, j = P.customParametersModel, re = P.dashMetrics, ce = P.settings;
            function Re(Me) {
              return Me.filter(function(Ge) {
                return Ge.quality > n.Z.NO_CHANGE;
              });
            }
            function $(Me) {
              var Ge, Qe, Ae, Ze, Xe, at = {}, Ie = null;
              if (Me.length !== 0) {
                for (at[n.Z.PRIORITY.STRONG] = { quality: n.Z.NO_CHANGE, reason: null }, at[n.Z.PRIORITY.WEAK] = { quality: n.Z.NO_CHANGE, reason: null }, at[n.Z.PRIORITY.DEFAULT] = { quality: n.Z.NO_CHANGE, reason: null }, Ge = 0, Qe = Me.length; Ge < Qe; Ge += 1) (Ae = Me[Ge]).quality !== n.Z.NO_CHANGE && (at[Ae.priority].quality === n.Z.NO_CHANGE || at[Ae.priority].quality > Ae.quality) && (at[Ae.priority].quality = Ae.quality, at[Ae.priority].reason = Ae.reason || null);
                return at[n.Z.PRIORITY.WEAK].quality !== n.Z.NO_CHANGE && (Ie = at[n.Z.PRIORITY.WEAK]), at[n.Z.PRIORITY.DEFAULT].quality !== n.Z.NO_CHANGE && (Ie = at[n.Z.PRIORITY.DEFAULT]), at[n.Z.PRIORITY.STRONG].quality !== n.Z.NO_CHANGE && (Ie = at[n.Z.PRIORITY.STRONG]), Ie && (Ze = Ie.quality, Xe = Ie.reason), (0, n.Z)(W).create(Ze, Xe);
              }
            }
            return { initialize: function() {
              J = [], M = [], ce.get().streaming.abr.useDefaultABRRules && (ce.get().streaming.abr.ABRStrategy === f.Z.ABR_STRATEGY_L2A ? J.push((0, l.Z)(W).create({ dashMetrics: re, settings: ce })) : ce.get().streaming.abr.ABRStrategy === f.Z.ABR_STRATEGY_LoLP ? J.push((0, v.Z)(W).create({ dashMetrics: re })) : (J.push((0, p.Z)(W).create({ dashMetrics: re, mediaPlayerModel: se, settings: ce })), J.push((0, te.Z)(W).create({ dashMetrics: re })), ce.get().streaming.abr.additionalAbrRules.insufficientBufferRule && J.push((0, E.Z)(W).create({ dashMetrics: re, settings: ce })), ce.get().streaming.abr.additionalAbrRules.switchHistoryRule && J.push((0, m.Z)(W).create()), ce.get().streaming.abr.additionalAbrRules.droppedFramesRule && J.push((0, e.Z)(W).create()), ce.get().streaming.abr.additionalAbrRules.abandonRequestsRule && M.push((0, t.Z)(W).create({ dashMetrics: re, mediaPlayerModel: se, settings: ce })))), j.getAbrCustomRules().forEach(function(Me) {
                Me.type === d && J.push(Me.rule(W).create()), Me.type === S && M.push(Me.rule(W).create());
              });
            }, reset: function() {
              [J, M].forEach(function(Me) {
                Me && Me.length && Me.forEach(function(Ge) {
                  return Ge.reset && Ge.reset();
                });
              }), J = [], M = [];
            }, getMaxQuality: function(Me) {
              return $(Re(J.map(function(Ge) {
                return Ge.getMaxIndex(Me);
              }))) || (0, n.Z)(W).create();
            }, getMinSwitchRequest: $, shouldAbandonFragment: function(Me, Ge) {
              var Qe = $(Re(M.map(function(Ae) {
                return Ae.shouldAbandon(Me, Ge);
              })));
              return Qe && (Qe.reason.forceAbandon = !0), Qe || (0, n.Z)(W).create();
            }, getQualitySwitchRules: function() {
              return J;
            } };
          }
          x.__dashjs_factory_name = "ABRRulesCollection";
          var G = h.Z.getClassFactory(x);
          G.QUALITY_SWITCH_RULES = d, G.ABANDON_FRAGMENT_RULES = S, h.Z.updateSingletonFactory(x.__dashjs_factory_name, G), ge.Z = G;
        }, 7423: function(Se, ge, R) {
          var te = R(2068), E = R(5448), t = R(6398);
          function e(m) {
            m = m || {};
            var p, l, v, h, n, f = this.context, d = m.mediaPlayerModel, S = m.dashMetrics, x = m.settings;
            function G() {
              v = {}, h = {}, n = [];
            }
            return p = { shouldAbandon: function(P) {
              var J = (0, te.Z)(f).create(te.Z.NO_CHANGE, { name: e.__dashjs_factory_name });
              if (!(P && P.hasOwnProperty("getMediaInfo") && P.hasOwnProperty("getMediaType") && P.hasOwnProperty("getCurrentRequest") && P.hasOwnProperty("getRepresentationInfo") && P.hasOwnProperty("getAbrController"))) return J;
              var M, W, se = P.getMediaInfo(), j = P.getMediaType(), re = P.getStreamInfo(), ce = re ? re.id : null, Re = P.getCurrentRequest();
              if (!isNaN(Re.index)) {
                M = j, W = Re.index, v[M] = v[M] || {}, v[M][W] = v[M][W] || {};
                var $ = d.getStableBufferTime();
                if (S.getCurrentBufferLevel(j) > $) return J;
                var Me = v[j][Re.index];
                if (Me === null || Re.firstByteDate === null || h.hasOwnProperty(Me.id)) return J;
                if (Me.firstByteTime === void 0 && (n[j] = [], Me.firstByteTime = Re.firstByteDate.getTime(), Me.segmentDuration = Re.duration, Me.bytesTotal = Re.bytesTotal, Me.id = Re.index), Me.bytesLoaded = Re.bytesLoaded, Me.elapsedTime = (/* @__PURE__ */ new Date()).getTime() - Me.firstByteTime, Me.bytesLoaded > 0 && Me.elapsedTime > 0 && function(Be, It) {
                  n[Be] = n[Be] || [], n[Be].push(It);
                }(j, Math.round(8 * Me.bytesLoaded / Me.elapsedTime)), n[j].length >= x.get().streaming.abr.abrRulesParameters.abandonRequestsRule.minLengthToAverage && Me.elapsedTime > x.get().streaming.abr.abrRulesParameters.abandonRequestsRule.graceTimeThreshold && Me.bytesLoaded < Me.bytesTotal) {
                  var Ge = n[j].reduce(function(Be, It) {
                    return Be + It;
                  }, 0);
                  if (Me.measuredBandwidthInKbps = Math.round(Ge / n[j].length), Me.estimatedTimeOfDownload = +(8 * Me.bytesTotal / Me.measuredBandwidthInKbps / 1e3).toFixed(2), Me.estimatedTimeOfDownload < Me.segmentDuration * x.get().streaming.abr.abrRulesParameters.abandonRequestsRule.abandonMultiplier || P.getRepresentationInfo().quality === 0) return J;
                  if (!h.hasOwnProperty(Me.id)) {
                    var Qe = P.getAbrController(), Ae = Me.bytesTotal - Me.bytesLoaded, Ze = Qe.getBitrateList(se), Xe = Qe.getQualityForBitrate(se, Me.measuredBandwidthInKbps * x.get().streaming.abr.bandwidthSafetyFactor, ce), at = Qe.getMinAllowedIndexFor(j, ce), Ie = at !== void 0 ? Math.max(at, Xe) : Xe;
                    Ae > Me.bytesTotal * Ze[Ie].bitrate / Ze[Qe.getQualityFor(j, ce)].bitrate && (J.quality = Ie, J.reason.throughput = Me.measuredBandwidthInKbps, J.reason.fragmentID = Me.id, J.reason.rule = this.getClassName(), h[Me.id] = Me, l.debug("[" + j + "] frag id", Me.id, " is asking to abandon and switch to quality to ", Ie, " measured bandwidth was", Me.measuredBandwidthInKbps), delete v[j][Me.id]);
                  }
                } else Me.bytesLoaded === Me.bytesTotal && delete v[j][Me.id];
              }
              return J;
            }, reset: G }, l = (0, t.Z)(f).getInstance().getLogger(p), G(), p;
          }
          e.__dashjs_factory_name = "AbandonRequestsRule", ge.Z = E.Z.getClassFactory(e);
        }, 3112: function(Se, ge, R) {
          var te = R(3860), E = R(2068), t = R(5448), e = R(7855), m = R(5595), p = R(8512), l = R(6398), v = R(8825), h = R(3393), n = 10;
          function f(d) {
            d = d || {};
            var S, x, G, P = this.context, J = d.dashMetrics, M = d.mediaPlayerModel, W = (0, m.Z)(P).getInstance();
            function se(Ie, Be, It) {
              var _t = It.reduce(function(Ee, Te, je) {
                return Te > It[Ee] ? je : Ee;
              }, 0);
              if (_t === 0) return null;
              var Ve = Math.max(Ie, n + 2 * Be.length), ot = (It[_t] - 1) / (Ve / n - 1);
              return { gp: ot, Vp: n / ot };
            }
            function j(Ie) {
              Ie.placeholderBuffer = 0, Ie.mostAdvancedSegmentStart = NaN, Ie.lastSegmentWasReplacement = !1, Ie.lastSegmentStart = NaN, Ie.lastSegmentDurationS = NaN, Ie.lastSegmentRequestTimeMs = NaN, Ie.lastSegmentFinishTimeMs = NaN;
            }
            function re(Ie, Be) {
              var It = M.getStableBufferTime();
              if (Ie.stableBufferTime !== It) {
                var _t = se(It, Ie.bitrates, Ie.utilities);
                if (_t.Vp !== Ie.Vp || _t.gp !== Ie.gp) {
                  var Ve = J.getCurrentBufferLevel(Be), ot = Ve + Ie.placeholderBuffer;
                  ot -= n, ot *= _t.Vp / Ie.Vp, ot += n, Ie.stableBufferTime = It, Ie.Vp = _t.Vp, Ie.gp = _t.gp, Ie.placeholderBuffer = Math.max(0, ot - Ve);
                }
              }
            }
            function ce(Ie, Be) {
              return Ie.Vp * (Ie.utilities[Be] + Ie.gp);
            }
            function Re(Ie, Be) {
              for (var It = Ie.bitrates[Be], _t = Ie.utilities[Be], Ve = 0, ot = Be - 1; ot >= 0; --ot) if (Ie.utilities[ot] < Ie.utilities[Be]) {
                var Ee = Ie.bitrates[ot], Te = Ie.utilities[ot], je = Ie.Vp * (Ie.gp + (It * Te - Ee * _t) / (It - Ee));
                Ve = Math.max(Ve, je);
              }
              return Ve;
            }
            function $(Ie) {
              var Be = Ie.mediaType === h.Z.AUDIO ? [h.Z.AUDIO] : G;
              for (var It in Be) G.hasOwnProperty(It) && G[It].state === 2 && (G[It].placeholderBuffer = 0);
            }
            function Me() {
              for (var Ie in G) if (G.hasOwnProperty(Ie)) {
                var Be = G[Ie];
                Be.state !== 0 && (Be.state = 1, j(Be));
              }
            }
            function Ge(Ie) {
              if (Ie && Ie.chunk && Ie.chunk.mediaInfo) {
                var Be = G[Ie.chunk.mediaInfo.type];
                if (Be && Be.state !== 0) {
                  var It = Ie.chunk.start;
                  isNaN(Be.mostAdvancedSegmentStart) || It > Be.mostAdvancedSegmentStart ? (Be.mostAdvancedSegmentStart = It, Be.lastSegmentWasReplacement = !1) : Be.lastSegmentWasReplacement = !0, Be.lastSegmentStart = It, Be.lastSegmentDurationS = Ie.chunk.duration, Be.lastQuality = Ie.chunk.quality, Ae(Be, Ie.chunk.mediaInfo.type);
                }
              }
            }
            function Qe(Ie) {
              if (Ie && Ie.metric === te.Z.HTTP_REQUEST && Ie.value && Ie.value.type === e.w.MEDIA_SEGMENT_TYPE && Ie.value.trace && Ie.value.trace.length) {
                var Be = G[Ie.mediaType];
                Be && Be.state !== 0 && (Be.lastSegmentRequestTimeMs = Ie.value.trequest.getTime(), Be.lastSegmentFinishTimeMs = Ie.value._tfinish.getTime(), Ae(Be, Ie.mediaType));
              }
            }
            function Ae(Ie, Be) {
              if (!isNaN(Ie.lastSegmentStart) && !isNaN(Ie.lastSegmentRequestTimeMs) && !isNaN(Ie.placeholderBuffer)) {
                if (Ie.placeholderBuffer *= 0.99, !isNaN(Ie.lastSegmentFinishTimeMs)) {
                  var It = J.getCurrentBufferLevel(Be) + 1e-3 * (Ie.lastSegmentFinishTimeMs - Ie.lastSegmentRequestTimeMs), _t = ce(Ie, Ie.lastQuality), Ve = Math.max(0, _t - It);
                  Ie.placeholderBuffer = Math.min(Ve, Ie.placeholderBuffer);
                }
                Ie.lastSegmentWasReplacement && !isNaN(Ie.lastSegmentDurationS) && (Ie.placeholderBuffer += Ie.lastSegmentDurationS), Ie.lastSegmentStart = NaN, Ie.lastSegmentRequestTimeMs = NaN;
              }
            }
            function Ze(Ie) {
              if (Ie) {
                var Be = G[Ie.mediaType];
                Be && Be.state !== 0 && (Be.abrQuality = Ie.newQuality);
              }
            }
            function Xe(Ie) {
              if (Ie) {
                var Be = G[Ie.mediaType];
                if (Be && Be.state !== 0) {
                  var It, _t = J.getCurrentBufferLevel(Ie.mediaType);
                  It = Be.abrQuality > 0 ? Re(Be, Be.abrQuality) : n;
                  var Ve = Math.max(0, It - _t);
                  Be.placeholderBuffer = Math.min(Be.placeholderBuffer, Ve);
                }
              }
            }
            function at() {
              G = {};
            }
            return S = { getMaxIndex: function(Ie) {
              var Be = (0, E.Z)(P).create();
              if (!(Ie && Ie.hasOwnProperty("getMediaInfo") && Ie.hasOwnProperty("getMediaType") && Ie.hasOwnProperty("getScheduleController") && Ie.hasOwnProperty("getStreamInfo") && Ie.hasOwnProperty("getAbrController") && Ie.hasOwnProperty("useBufferOccupancyABR"))) return Be;
              var It = Ie.getMediaInfo(), _t = Ie.getMediaType(), Ve = Ie.getScheduleController(), ot = Ie.getStreamInfo(), Ee = Ie.getAbrController(), Te = Ee.getThroughputHistory(), je = ot ? ot.id : null, c = ot && ot.manifestInfo && ot.manifestInfo.isDynamic, o = Ie.useBufferOccupancyABR();
              if (Be.reason = Be.reason || {}, !o) return Be;
              Ve.setTimeToLoadDelay(0);
              var T = function(Oe) {
                var qe = Oe.getMediaType(), it = G[qe];
                return it ? it.state !== 0 && re(it, qe) : (it = function(bt) {
                  var dt = {}, Yt = bt.getMediaInfo().bitrateList.map(function(cn) {
                    return cn.bandwidth;
                  }), Mt = function(cn) {
                    return cn.map(function(Tn) {
                      return Math.log(Tn);
                    });
                  }(Yt);
                  Mt = Mt.map(function(cn) {
                    return cn - Mt[0] + 1;
                  });
                  var Ht = M.getStableBufferTime(), Ut = se(Ht, Yt, Mt);
                  return Ut ? (dt.state = 1, dt.bitrates = Yt, dt.utilities = Mt, dt.stableBufferTime = Ht, dt.Vp = Ut.Vp, dt.gp = Ut.gp, dt.lastQuality = 0, j(dt)) : dt.state = 0, dt;
                }(Oe), G[qe] = it), it;
              }(Ie);
              if (T.state === 0) return Be;
              var b, X = J.getCurrentBufferLevel(_t), z = Te.getAverageThroughput(_t, c), De = Te.getSafeAverageThroughput(_t, c), tt = Te.getAverageLatency(_t);
              if (Be.reason.state = T.state, Be.reason.throughput = z, Be.reason.latency = tt, isNaN(z)) return Be;
              switch (T.state) {
                case 1:
                  b = Ee.getQualityForBitrate(It, De, je, tt), Be.quality = b, Be.reason.throughput = De, T.placeholderBuffer = Math.max(0, Re(T, b) - X), T.lastQuality = b, !isNaN(T.lastSegmentDurationS) && X >= T.lastSegmentDurationS && (T.state = 2);
                  break;
                case 2:
                  (function(Oe, qe) {
                    var it = Date.now();
                    if (isNaN(Oe.lastSegmentFinishTimeMs)) {
                      if (!isNaN(Oe.lastCallTimeMs)) {
                        var bt = 1e-3 * (it - Oe.lastCallTimeMs);
                        Oe.placeholderBuffer += Math.max(0, bt);
                      }
                    } else {
                      var dt = 1e-3 * (it - Oe.lastSegmentFinishTimeMs);
                      Oe.placeholderBuffer += Math.max(0, dt);
                    }
                    Oe.lastCallTimeMs = it, Oe.lastSegmentStart = NaN, Oe.lastSegmentRequestTimeMs = NaN, Oe.lastSegmentFinishTimeMs = NaN, re(Oe, qe);
                  })(T, _t), b = function(Oe, qe) {
                    for (var it = Oe.bitrates.length, bt = NaN, dt = NaN, Yt = 0; Yt < it; ++Yt) {
                      var Mt = (Oe.Vp * (Oe.utilities[Yt] + Oe.gp) - qe) / Oe.bitrates[Yt];
                      (isNaN(dt) || Mt >= dt) && (dt = Mt, bt = Yt);
                    }
                    return bt;
                  }(T, X + T.placeholderBuffer);
                  var Ue = Ee.getQualityForBitrate(It, De, je, tt);
                  b > T.lastQuality && b > Ue && (b = Math.max(Ue, T.lastQuality));
                  var ke = Math.max(0, X + T.placeholderBuffer - ce(T, b));
                  ke <= T.placeholderBuffer ? (T.placeholderBuffer -= ke, ke = 0) : (ke -= T.placeholderBuffer, T.placeholderBuffer = 0, b < Ee.getMaxAllowedIndexFor(_t, je) ? Ve.setTimeToLoadDelay(1e3 * ke) : ke = 0), Be.quality = b, Be.reason.throughput = z, Be.reason.latency = tt, Be.reason.bufferLevel = X, Be.reason.placeholderBuffer = T.placeholderBuffer, Be.reason.delay = ke, T.lastQuality = b;
                  break;
                default:
                  x.debug("BOLA ABR rule invoked in bad state."), Be.quality = Ee.getQualityForBitrate(It, De, je, tt), Be.reason.state = T.state, Be.reason.throughput = De, Be.reason.latency = tt, T.state = 1, j(T);
              }
              return Be;
            }, reset: function() {
              at(), W.off(v.Z.BUFFER_EMPTY, $, S), W.off(v.Z.PLAYBACK_SEEKING, Me, S), W.off(v.Z.METRIC_ADDED, Qe, S), W.off(v.Z.QUALITY_CHANGE_REQUESTED, Ze, S), W.off(v.Z.FRAGMENT_LOADING_ABANDONED, Xe, S), W.off(p.Z.MEDIA_FRAGMENT_LOADED, Ge, S);
            } }, x = (0, l.Z)(P).getInstance().getLogger(S), at(), W.on(v.Z.BUFFER_EMPTY, $, S), W.on(v.Z.PLAYBACK_SEEKING, Me, S), W.on(v.Z.METRIC_ADDED, Qe, S), W.on(v.Z.QUALITY_CHANGE_REQUESTED, Ze, S), W.on(v.Z.FRAGMENT_LOADING_ABANDONED, Xe, S), W.on(p.Z.MEDIA_FRAGMENT_LOADED, Ge, S), S;
          }
          f.__dashjs_factory_name = "BolaRule", ge.Z = t.Z.getClassFactory(f);
        }, 895: function(Se, ge, R) {
          var te = R(5448), E = R(2068), t = R(6398);
          function e() {
            var m, p, l = this.context;
            return m = { getMaxIndex: function(v) {
              var h = (0, E.Z)(l).create();
              if (!v || !v.hasOwnProperty("getDroppedFramesHistory")) return h;
              var n = v.getDroppedFramesHistory(), f = v.getStreamInfo().id;
              if (n) {
                var d = n.getFrameHistory(f);
                if (!d || d.length === 0) return h;
                for (var S = 0, x = 0, G = E.Z.NO_CHANGE, P = 1; P < d.length; P++) if (d[P] && (S = d[P].droppedVideoFrames, (x = d[P].totalVideoFrames) > 375 && S / x > 0.15)) {
                  G = P - 1, p.debug("index: " + G + " Dropped Frames: " + S + " Total Frames: " + x);
                  break;
                }
                return (0, E.Z)(l).create(G, { droppedFrames: S });
              }
              return h;
            } }, p = (0, t.Z)(l).getInstance().getLogger(m), m;
          }
          e.__dashjs_factory_name = "DroppedFramesRule", ge.Z = te.Z.getClassFactory(e);
        }, 6535: function(Se, ge, R) {
          var te = R(5595), E = R(8512), t = R(5448), e = R(6398), m = R(2068), p = R(3393), l = R(3860), v = R(8825);
          function h(n) {
            n = n || {};
            var f, d, S, x = this.context, G = (0, te.Z)(x).getInstance(), P = n.dashMetrics;
            function J() {
              (S = {})[p.Z.VIDEO] = { ignoreCount: 2 }, S[p.Z.AUDIO] = { ignoreCount: 2 };
            }
            function M() {
              J();
            }
            function W(se) {
              isNaN(se.startTime) || se.mediaType !== p.Z.AUDIO && se.mediaType !== p.Z.VIDEO || S[se.mediaType].ignoreCount > 0 && S[se.mediaType].ignoreCount--;
            }
            return f = { getMaxIndex: function(se) {
              var j = (0, m.Z)(x).create();
              if (!se || !se.hasOwnProperty("getMediaType")) return j;
              (function() {
                if (!P || !P.hasOwnProperty("getCurrentBufferLevel") || !P.hasOwnProperty("getCurrentBufferState")) throw new Error(p.Z.MISSING_CONFIG_ERROR);
              })();
              var re = se.getMediaType(), ce = P.getCurrentBufferState(re), Re = se.getRepresentationInfo().fragmentDuration, $ = se.getStreamInfo(), Me = $ ? $.id : null, Ge = se.getScheduleController(), Qe = $ && $.manifestInfo && $.manifestInfo.isDynamic;
              if (function(_t, Ve) {
                return !_t && S[Ve].ignoreCount > 0;
              }(Ge.getPlaybackController().getLowLatencyModeEnabled(), re) || !Re) return j;
              if (ce && ce.state === l.Z.BUFFER_EMPTY) d.debug("[" + re + "] Switch to index 0; buffer is empty."), j.quality = 0, j.reason = "InsufficientBufferRule: Buffer is empty";
              else {
                var Ae = se.getMediaInfo(), Ze = se.getAbrController(), Xe = Ze.getThroughputHistory(), at = P.getCurrentBufferLevel(re), Ie = Xe.getAverageThroughput(re, Qe), Be = Xe.getAverageLatency(re), It = Ie * (at / Re) * 0.5;
                j.quality = Ze.getQualityForBitrate(Ae, It, Me, Be), j.reason = "InsufficientBufferRule: being conservative to avoid immediate rebuffering";
              }
              return j;
            }, reset: function() {
              J(), G.off(v.Z.PLAYBACK_SEEKING, M, f), G.off(E.Z.BYTES_APPENDED_END_FRAGMENT, W, f);
            } }, d = (0, e.Z)(x).getInstance().getLogger(f), J(), G.on(v.Z.PLAYBACK_SEEKING, M, f), G.on(E.Z.BYTES_APPENDED_END_FRAGMENT, W, f), f;
          }
          h.__dashjs_factory_name = "InsufficientBufferRule", ge.Z = t.Z.getClassFactory(h);
        }, 1914: function(Se, ge, R) {
          var te = R(3860), E = R(2068), t = R(5448), e = R(7855), m = R(5595), p = R(8512), l = R(6398), v = R(3393);
          function h(n) {
            n = n || {};
            var f, d, S, x, G = this.context, P = n.dashMetrics, J = (0, m.Z)(G).getInstance();
            function M(Me) {
              Me.placeholderBuffer = 0, Me.mostAdvancedSegmentStart = NaN, Me.lastSegmentWasReplacement = !1, Me.lastSegmentStart = NaN, Me.lastSegmentDurationS = NaN, Me.lastSegmentRequestTimeMs = NaN, Me.lastSegmentFinishTimeMs = NaN, Me.lastSegmentUrl = "";
            }
            function W() {
              for (var Me in d) if (d.hasOwnProperty(Me)) {
                var Ge = d[Me];
                Ge.state !== 0 && (Ge.state = 1, M(Ge));
              }
            }
            function se(Me) {
              if (Me && Me.chunk && Me.chunk.mediaInfo) {
                var Ge = d[Me.chunk.mediaInfo.type], Qe = S[Me.chunk.mediaInfo.type];
                if (Ge && Ge.state !== 0) {
                  var Ae = Me.chunk.start;
                  isNaN(Ge.mostAdvancedSegmentStart) || Ae > Ge.mostAdvancedSegmentStart ? (Ge.mostAdvancedSegmentStart = Ae, Ge.lastSegmentWasReplacement = !1) : Ge.lastSegmentWasReplacement = !0, Ge.lastSegmentStart = Ae, Ge.lastSegmentDurationS = Me.chunk.duration, Ge.lastQuality = Me.chunk.quality, re(Ge, Qe);
                }
              }
            }
            function j(Me) {
              if (Me && Me.metric === te.Z.HTTP_REQUEST && Me.value && Me.value.type === e.w.MEDIA_SEGMENT_TYPE && Me.value.trace && Me.value.trace.length) {
                var Ge = d[Me.mediaType], Qe = S[Me.mediaType];
                Ge && Ge.state !== 0 && (Ge.lastSegmentRequestTimeMs = Me.value.trequest.getTime(), Ge.lastSegmentFinishTimeMs = Me.value._tfinish.getTime(), re(Ge, Qe));
              }
            }
            function re(Me, Ge) {
              isNaN(Me.lastSegmentStart) || isNaN(Me.lastSegmentRequestTimeMs) || (Ge.segment_request_start_s = 1e-3 * Me.lastSegmentRequestTimeMs, Ge.segment_download_finish_s = 1e-3 * Me.lastSegmentFinishTimeMs, Me.lastSegmentStart = NaN, Me.lastSegmentRequestTimeMs = NaN);
            }
            function ce(Me) {
              if (Me && Me.mediaType) {
                var Ge = d[Me.mediaType];
                Ge && Ge.state !== 0 && (Ge.abrQuality = Me.newQuality);
              }
            }
            function Re(Me, Ge) {
              if (Me.length !== Ge.length) return -1;
              for (var Qe = 0, Ae = 0; Ae < Me.length; Ae++) Qe += Me[Ae] * Ge[Ae];
              return Qe;
            }
            function $() {
              d = {}, S = {};
            }
            return f = { getMaxIndex: function(Me) {
              var Ge, Qe = (0, E.Z)(G).create(), Ae = Math.pow(4, 0.99), Ze = Math.max(Math.pow(4, 1), Ae * Math.sqrt(4)), Xe = Me.getMediaInfo(), at = Me.getMediaType(), Ie = Xe.bitrateList.map(function(Ut) {
                return Ut.bandwidth;
              }), Be = Ie.length, It = Me.getScheduleController(), _t = Me.getStreamInfo(), Ve = Me.getAbrController(), ot = Ve.getThroughputHistory(), Ee = _t && _t.manifestInfo && _t.manifestInfo.isDynamic, Te = Me.useL2AABR(), je = P.getCurrentBufferLevel(at, !0), c = ot.getSafeAverageThroughput(at, Ee), o = ot.getAverageThroughput(at, Ee), T = ot.getAverageLatency(at), b = Me.getVideoModel().getPlaybackRate();
              if (!(Me && Me.hasOwnProperty("getMediaInfo") && Me.hasOwnProperty("getMediaType") && Me.hasOwnProperty("getScheduleController") && Me.hasOwnProperty("getStreamInfo") && Me.hasOwnProperty("getAbrController") && Me.hasOwnProperty("useL2AABR")) || (Qe.reason = Qe.reason || {}, !Te || at === v.Z.AUDIO)) return Qe;
              It.setTimeToLoadDelay(0);
              var X = function(Ut) {
                var cn = Ut.getMediaType(), Tn = d[cn];
                return Tn || (Tn = function(xn) {
                  var Mn = {}, kn = xn.getMediaInfo(), tr = kn.bitrateList.map(function(wn) {
                    return wn.bandwidth / 1e3;
                  });
                  return Mn.state = 1, Mn.bitrates = tr, Mn.lastQuality = 0, function(wn) {
                    wn && wn.type && (S[wn.type] = {}, S[wn.type].w = [], S[wn.type].prev_w = [], S[wn.type].Q = 0, S[wn.type].segment_request_start_s = 0, S[wn.type].segment_download_finish_s = 0, S[wn.type].B_target = 1.5);
                  }(kn), M(Mn), Mn;
                }(Ut), d[cn] = Tn), Tn;
              }(Me);
              if (X.state === 0) return Qe;
              var z = S[at];
              if (!z || (Qe.reason.state = X.state, Qe.reason.throughput = o, Qe.reason.latency = T, isNaN(o))) return Qe;
              switch (X.state) {
                case 1:
                  if (Ge = Ve.getQualityForBitrate(Xe, c, _t.id, T), Qe.quality = Ge, Qe.reason.throughput = c, X.lastQuality = Ge, !isNaN(X.lastSegmentDurationS) && je >= z.B_target) {
                    X.state = 2, z.Q = Ae;
                    for (var De = 0; De < Be; ++De) De === X.lastQuality ? z.prev_w[De] = 1 : z.prev_w[De] = 0;
                  }
                  break;
                case 2:
                  var tt = [], Ue = P.getCurrentHttpRequest(at).trace.reduce(function(Ut, cn) {
                    return Ut + cn.d;
                  }, 0), ke = P.getCurrentHttpRequest(at).trace.reduce(function(Ut, cn) {
                    return Ut + cn.b[0];
                  }, 0), Oe = Math.round(8 * ke / Ue), qe = P.getCurrentHttpRequest(at);
                  if (Oe < 1 && (Oe = 1), qe.url === X.lastSegmentUrl || qe.type === e.w.INIT_SEGMENT_TYPE) Ge = X.lastQuality;
                  else {
                    for (var it = X.lastSegmentDurationS, bt = 1, dt = 0; dt < Be; ++dt) Ie[dt] = Ie[dt] / 1e3, b * Ie[dt] > Oe && (bt = -1), z.w[dt] = z.prev_w[dt] + bt * (it / (2 * Ze)) * ((z.Q + Ae) * (b * Ie[dt] / Oe));
                    z.w = function(Ut) {
                      for (var cn = Ut.length, Tn = !1, xn = [], Mn = 0; Mn < cn; ++Mn) xn[Mn] = Ut[Mn];
                      for (var kn = Ut.sort(function(vr, sr) {
                        return sr - vr;
                      }), tr = 0, wn = 0, hr = [], zn = 0; zn < cn - 1; ++zn) if ((wn = ((tr += kn[zn]) - 1) / (zn + 1)) >= kn[zn + 1]) {
                        Tn = !0;
                        break;
                      }
                      Tn || (wn = (tr + kn[cn - 1] - 1) / cn);
                      for (var or = 0; or < cn; ++or) hr[or] = Math.max(xn[or] - wn, 0);
                      return hr;
                    }(z.w);
                    for (var Yt = 0; Yt < Be; ++Yt) tt[Yt] = z.w[Yt] - z.prev_w[Yt], z.prev_w[Yt] = z.w[Yt];
                    z.Q = Math.max(0, z.Q - it + it * b * ((Re(Ie, z.prev_w) + Re(Ie, tt)) / Oe));
                    for (var Mt = [], Ht = 0; Ht < Be; ++Ht) Mt[Ht] = Math.abs(Ie[Ht] - Re(z.w, Ie));
                    (Ge = Mt.indexOf(Math.min.apply(Math, Mt))) > X.lastQuality && Ie[X.lastQuality + 1] <= Oe && (Ge = X.lastQuality + 1), Ie[Ge] >= Oe && (z.Q = 2 * Math.max(Ae, z.Q)), X.lastSegmentUrl = qe.url;
                  }
                  Qe.quality = Ge, Qe.reason.throughput = o, Qe.reason.latency = T, Qe.reason.bufferLevel = je, X.lastQuality = Qe.quality;
                  break;
                default:
                  x.debug("L2A ABR rule invoked in bad state."), Qe.quality = Ve.getQualityForBitrate(Xe, c, _t.id, T), Qe.reason.state = X.state, Qe.reason.throughput = c, Qe.reason.latency = T, X.state = 1, M(X);
              }
              return Qe;
            }, reset: function() {
              $(), J.off(p.Z.PLAYBACK_SEEKING, W, f), J.off(p.Z.MEDIA_FRAGMENT_LOADED, se, f), J.off(p.Z.METRIC_ADDED, j, f), J.off(p.Z.QUALITY_CHANGE_REQUESTED, ce, f);
            } }, x = (0, l.Z)(G).getInstance().getLogger(f), $(), J.on(p.Z.PLAYBACK_SEEKING, W, f), J.on(p.Z.MEDIA_FRAGMENT_LOADED, se, f), J.on(p.Z.METRIC_ADDED, j, f), J.on(p.Z.QUALITY_CHANGE_REQUESTED, ce, f), f;
          }
          h.__dashjs_factory_name = "L2ARule", ge.Z = t.Z.getClassFactory(h);
        }, 6070: function(Se, ge, R) {
          var te = R(5448), E = R(6398), t = R(2068);
          function e() {
            var m, p, l = this.context;
            return m = { getMaxIndex: function(v) {
              for (var h = v ? v.getSwitchHistory() : null, n = h ? h.getSwitchRequests() : [], f = 0, d = 0, S = 0, x = (0, t.Z)(l).create(), G = 0; G < n.length; G++) if (n[G] !== void 0 && (f += n[G].drops, d += n[G].noDrops, S += n[G].dropSize, f + d >= 6 && f / d > 0.075)) {
                x.quality = G > 0 && n[G].drops > 0 ? G - 1 : G, x.reason = { index: x.quality, drops: f, noDrops: d, dropSize: S }, p.debug("Switch history rule index: " + x.quality + " samples: " + (f + d) + " drops: " + f);
                break;
              }
              return x;
            } }, p = (0, E.Z)(l).getInstance().getLogger(m), m;
          }
          e.__dashjs_factory_name = "SwitchHistoryRule", ge.Z = te.Z.getClassFactory(e);
        }, 5628: function(Se, ge, R) {
          var te = R(5448), E = R(2068), t = R(3393), e = R(3860);
          function m(p) {
            p = p || {};
            var l = this.context, v = p.dashMetrics;
            return { getMaxIndex: function(h) {
              var n = (0, E.Z)(l).create();
              if (!(h && h.hasOwnProperty("getMediaInfo") && h.hasOwnProperty("getMediaType") && h.hasOwnProperty("useBufferOccupancyABR") && h.hasOwnProperty("getAbrController") && h.hasOwnProperty("getScheduleController"))) return n;
              (function() {
                if (!v || !v.hasOwnProperty("getCurrentBufferState")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              })();
              var f = h.getMediaInfo(), d = h.getMediaType(), S = v.getCurrentBufferState(d), x = h.getScheduleController(), G = h.getAbrController(), P = h.getStreamInfo(), J = P ? P.id : null, M = P && P.manifestInfo ? P.manifestInfo.isDynamic : null, W = G.getThroughputHistory(), se = W.getSafeAverageThroughput(d, M), j = W.getAverageLatency(d), re = h.useBufferOccupancyABR();
              return isNaN(se) || !S || re || G.getAbandonmentStateFor(J, d) !== e.Z.ABANDON_LOAD && (S.state === e.Z.BUFFER_LOADED || M) && (n.quality = G.getQualityForBitrate(f, se, J, j), x.setTimeToLoadDelay(0), n.reason = { throughput: se, latency: j }), n;
            }, reset: function() {
            } };
          }
          m.__dashjs_factory_name = "ThroughputRule", ge.Z = te.Z.getClassFactory(m);
        }, 4722: function(Se, ge, R) {
          var te = R(5448), E = R(6398);
          function t() {
            var e, m, p, l, v, h, n, f, d, S = this.context;
            function x() {
              p = null, l = 1, v = 100, h = 0, n = null, f = null, d = "dynamic_weight_selection";
            }
            function G() {
              var se = 0;
              if (p) for (var j = 0; j < p.length; j++) {
                var re = p[j];
                re.state.throughput > se && (se = re.state.throughput);
              }
              return se;
            }
            function P(se, j, re) {
              var ce = se.map(function(Re, $) {
                return re[$] * Math.pow(Re - j[$], 2);
              }).reduce(function(Re, $) {
                return Re + $;
              });
              return (ce < 0 ? -1 : 1) * Math.sqrt(Math.abs(ce));
            }
            function J(se, j) {
              return P([se.state.throughput, se.state.latency, se.state.rebuffer, se.state.switch], [j.state.throughput, j.state.latency, j.state.rebuffer, j.state.switch], [1, 1, 1, 1]);
            }
            function M(se, j, re) {
              for (var ce = 0; ce < j.length; ce++) {
                var Re = j[ce], $ = J(Re, se);
                W(Re, re, Math.exp(-1 * Math.pow($, 2) / (2 * Math.pow(0.1, 2))));
              }
            }
            function W(se, j, re) {
              var ce = se.state, Re = [0.01, 0.01, 0.01, 0.01];
              ce.throughput = ce.throughput + (j[0] - ce.throughput) * Re[0] * re, ce.latency = ce.latency + (j[1] - ce.latency) * Re[1] * re, ce.rebuffer = ce.rebuffer + (j[2] - ce.rebuffer) * Re[2] * re, ce.switch = ce.switch + (j[3] - ce.switch) * Re[3] * re;
            }
            return e = { getNextQuality: function(se, j, re, ce, Re, $, Me) {
              var Ge = re, Qe = ce, Ae = j, Ze = function(z) {
                if (!p) {
                  p = [];
                  var De = z.bitrateList, tt = [];
                  h = De[0].bandwidth, De.forEach(function(qe) {
                    tt.push(qe.bandwidth), qe.bandwidth < h && (h = qe.bandwidth);
                  }), Oe = tt.map(function(qe) {
                    return Math.pow(qe, 2);
                  }).reduce(function(qe, it) {
                    return qe + it;
                  }), l = Math.sqrt(Oe);
                  for (var Ue = 0; Ue < De.length; Ue++) {
                    var ke = { qualityIndex: Ue, bitrate: De[Ue].bandwidth, state: { throughput: De[Ue].bandwidth / l, latency: 0, rebuffer: 0, switch: 0 } };
                    p.push(ke);
                  }
                  f = function(qe) {
                    var it = [], bt = function(li) {
                      for (var Dt = [], wt = 0; wt < li; wt++) {
                        var Ct = [Math.random() * G(), Math.random(), Math.random(), Math.random()];
                        Dt.push(Ct);
                      }
                      return Dt;
                    }(Math.pow(qe.length, 2));
                    it.push(bt[0]);
                    for (var dt = [1, 1, 1, 1], Yt = 1; Yt < qe.length; Yt++) {
                      for (var Mt = null, Ht = null, Ut = 0; Ut < bt.length; Ut++) {
                        for (var cn = bt[Ut], Tn = null, xn = 0; xn < it.length; xn++) {
                          var Mn = P(cn, it[xn], dt);
                          (Tn === null || Mn < Tn) && (Tn = Mn);
                        }
                        (Ht === null || Tn > Ht) && (Mt = cn, Ht = Tn);
                      }
                      it.push(Mt);
                    }
                    for (var kn = null, tr = null, wn = 0; wn < it.length; wn++) {
                      for (var hr = 0, zn = 0; zn < it.length; zn++) wn !== zn && (hr += P(it[wn], it[zn], dt));
                      (kn === null || hr > kn) && (kn = hr, tr = wn);
                    }
                    var or = [];
                    for (or.push(it[tr]), it.splice(tr, 1); it.length > 0; ) {
                      for (var vr = null, sr = null, Ar = 0; Ar < it.length; Ar++) {
                        var Ir = P(or[0], it[Ar], dt);
                        (vr === null || Ir < vr) && (vr = Ir, sr = Ar);
                      }
                      or.push(it[sr]), it.splice(sr, 1);
                    }
                    return or;
                  }(p);
                }
                var Oe;
                return p;
              }(se), Xe = j / l;
              Xe > 1 && (Xe = G()), re /= v, m.debug("getNextQuality called throughput:".concat(Xe, " latency:").concat(re, " bufferSize:").concat(ce, " currentQualityIndex:").concat($, " playbackRate:").concat(Re));
              var at = Ze[$], Ie = at.bitrate * Me.getSegmentDuration() / Ae, Be = Math.max(0, Ie - Qe);
              if (Qe - Ie < Me.getMinBuffer()) return m.debug("Buffer is low for bitrate= ".concat(at.bitrate, " downloadTime=").concat(Ie, " currentBuffer=").concat(Qe, " rebuffer=").concat(Be)), function(z, De) {
                var tt = 0, Ue = z;
                if (p) for (var ke = 0; ke < p.length; ke++) {
                  var Oe = p[ke];
                  Oe.bitrate < z.bitrate && Oe.bitrate > tt && De > Oe.bitrate && (tt = Oe.bitrate, Ue = Oe);
                }
                return Ue;
              }(at, Ae).qualityIndex;
              switch (d) {
                case "manual_weight_selection":
                  n = [0.4, 0.4, 0.4, 0.4];
                  break;
                case "random_weight_selection":
                  (function(z) {
                    n = function(De, tt) {
                      for (var Ue = [], ke = Math.sqrt(2 / De), Oe = 0; Oe < 4; Oe++) Ue.push(Math.random() * ke);
                      return n = Ue;
                    }(z.length);
                  })(Ze);
                  break;
                default:
                  (function(z, De, tt, Ue, ke, Oe, qe) {
                    n || (n = f[f.length - 1]);
                    var it = z.findWeightVector(De, tt, Ue, ke, Oe, qe);
                    it !== null && it !== -1 && (n = it);
                  })(Me, Ze, Ge, Qe, Be, Ae, Re);
              }
              for (var It = null, _t = null, Ve = null, ot = 0; ot < Ze.length; ot++) {
                var Ee = Ze[ot], Te = Ee.state, je = [Te.throughput, Te.latency, Te.rebuffer, Te.switch], c = n.slice(), o = Me.getNextBufferWithBitrate(Ee.bitrate, Qe, Ae), T = o < Me.getMinBuffer();
                T && m.debug("Buffer is low for bitrate=".concat(Ee.bitrate, " downloadTime=").concat(Ie, " currentBuffer=").concat(Qe, " nextBuffer=").concat(o)), (Ee.bitrate > j - 1e4 || T) && Ee.bitrate !== h && (c[0] = 100);
                var b = P(je, [Xe, 0, 0, 0], c);
                (It === null || b < It) && (It = b, _t = Ee.qualityIndex, Ve = Ee);
              }
              var X = Math.abs(at.bitrate - Ve.bitrate) / l;
              return M(at, Ze, [Xe, re, Be, X]), M(Ve, Ze, [Xe, 0, 0, X]), _t;
            }, reset: function() {
              x();
            } }, m = (0, E.Z)(S).getInstance().getLogger(e), x(), e;
          }
          t.__dashjs_factory_name = "LearningAbrController", ge.Z = te.Z.getClassFactory(t);
        }, 5317: function(Se, ge, R) {
          var te = R(5448), E = R(2298);
          function t() {
            var e, m, p, l, v;
            function h() {
              m = null, p = null, l = null, v = null;
            }
            function n(d, S, x, G) {
              var P = new E.Z();
              return P.type = d, P.weights.bitrateReward = S || 1, P.weights.bitrateSwitchPenalty = 1, P.weights.rebufferPenalty = x || 1e3, P.weights.latencyPenalty = [], P.weights.latencyPenalty.push({ threshold: 1.1, penalty: 0.05 * G }), P.weights.latencyPenalty.push({ threshold: 1e8, penalty: 0.1 * x }), P.weights.playbackSpeedPenalty = G || 200, P;
            }
            function f(d, S, x, G, P) {
              P.bitrateWSum += P.weights.bitrateReward * d, P.lastBitrate && (P.bitrateSwitchWSum += P.weights.bitrateSwitchPenalty * Math.abs(d - P.lastBitrate)), P.lastBitrate = d, P.rebufferWSum += P.weights.rebufferPenalty * S;
              for (var J = 0; J < P.weights.latencyPenalty.length; J++) {
                var M = P.weights.latencyPenalty[J];
                if (x <= M.threshold) {
                  P.latencyWSum += M.penalty * x;
                  break;
                }
              }
              P.playbackSpeedWSum += P.weights.playbackSpeedPenalty * Math.abs(1 - G), P.totalQoe = P.bitrateWSum - P.bitrateSwitchWSum - P.rebufferWSum - P.latencyWSum - P.playbackSpeedWSum;
            }
            return e = { setupPerSegmentQoe: function(d, S, x) {
              m = n("segment", d, S, x), p = d, l = S, v = x;
            }, logSegmentMetrics: function(d, S, x, G) {
              m && f(d, S, x, G, m);
            }, getPerSegmentQoe: function() {
              return m;
            }, calculateSingleUseQoe: function(d, S, x, G) {
              var P = null;
              return p && l && v && (P = n("segment", p, l, v)), P ? (f(d, S, x, G, P), P.totalQoe) : 0;
            }, reset: function() {
              h();
            } }, h(), e;
          }
          t.__dashjs_factory_name = "LoLpQoeEvaluator", ge.Z = te.Z.getClassFactory(t);
        }, 5435: function(Se, ge, R) {
          var te = R(6398), E = R(5448), t = R(4722), e = R(5317), m = R(2068), p = R(3860), l = R(6523), v = R(3393);
          function h(n) {
            var f, d, S, x, G = (n = n || {}).dashMetrics, P = this.context;
            return d = { getMaxIndex: function(J) {
              try {
                var M = (0, m.Z)(P).create(), W = J.getMediaInfo().type, se = J.getAbrController(), j = J.getStreamInfo(), re = se.getQualityFor(W, j.id), ce = J.getMediaInfo(), Re = G.getCurrentBufferState(W), $ = J.getScheduleController(), Me = G.getCurrentBufferLevel(W, !0), Ge = j && j.manifestInfo ? j.manifestInfo.isDynamic : null, Qe = $.getPlaybackController(), Ae = Qe.getCurrentLiveLatency();
                if (!J.useLoLPABR() || W === v.Z.AUDIO) return M;
                Ae || (Ae = 0);
                var Ze = Qe.getPlaybackRate(), Xe = se.getThroughputHistory().getSafeAverageThroughput(W, Ge);
                if (f.debug("Throughput ".concat(Math.round(Xe), " kbps")), isNaN(Xe) || !Re || se.getAbandonmentStateFor(j.id, W) === p.Z.ABANDON_LOAD) return M;
                for (var at = ce.bitrateList, Ie = J.getRepresentationInfo().fragmentDuration, Be = at[0].bandwidth / 1e3, It = at[at.length - 1].bandwidth / 1e3, _t = 0; _t < at.length; _t++) {
                  var Ve = at[_t].bandwidth / 1e3;
                  Ve > It ? It = Ve : Ve < Be && (Be = Ve);
                }
                var ot = at[re].bandwidth / 1e3, Ee = G.getCurrentHttpRequest(W, !0), Te = (Ee.tresponse.getTime() - Ee.trequest.getTime()) / 1e3, je = Te > Ie ? Te - Ie : 0;
                x.setupPerSegmentQoe(Ie, It, Be), x.logSegmentMetrics(ot, je, Ae, Ze);
                var c = (0, l.Z)(P).create({ targetLatency: 1.5, bufferMin: 0.3, segmentDuration: Ie, qoeEvaluator: x });
                return M.quality = S.getNextQuality(ce, 1e3 * Xe, Ae, Me, Ze, re, c), M.reason = { throughput: Xe, latency: Ae }, M.priority = m.Z.PRIORITY.STRONG, $.setTimeToLoadDelay(0), M.quality !== re && f.debug("[TgcLearningRule][" + W + "] requesting switch to index: ", M.quality, "Average throughput", Math.round(Xe), "kbps"), M;
              } catch (o) {
                throw o;
              }
            }, reset: function() {
              S.reset(), x.reset();
            } }, f = (0, te.Z)(P).getInstance().getLogger(d), S = (0, t.Z)(P).create(), x = (0, e.Z)(P).create(), d;
          }
          h.__dashjs_factory_name = "LoLPRule", ge.Z = E.Z.getClassFactory(h);
        }, 6523: function(Se, ge, R) {
          var te = R(5448);
          function E(t) {
            var e, m, p, l, v = t.targetLatency, h = t.bufferMin, n = t.segmentDuration, f = t.qoeEvaluator;
            function d() {
              return n;
            }
            function S(x, G) {
              var P = d();
              return G > P ? x - P : x + P - G;
            }
            return e = { getMinBuffer: function() {
              return h;
            }, getSegmentDuration: d, getNextBufferWithBitrate: function(x, G, P) {
              return S(G, x * n / P);
            }, getNextBuffer: S, findWeightVector: function(x, G, P, J, M, W) {
              var se = null, j = null, re = null, ce = Math.abs(G - p);
              return x.forEach(function(Re) {
                m.forEach(function($) {
                  $[0];
                  var Me = $[1], Ge = $[2], Qe = ($[3], Re.bitrate * n / M), Ae = S(P, Qe), Ze = (Ge === 0 ? 10 : 1 / Ge) * Math.max(1e-5, Qe - Ae), Xe = (Me === 0 ? 10 : 1 / Me) * Re.state.latency, at = f.calculateSingleUseQoe(Re.bitrate, Ze, Xe, W);
                  (se === null || at > se) && function(Ie, Be, It) {
                    return !(Ie > v + It) && Be >= h;
                  }(G, Ae, ce) && (se = at, j = $, re = Re.bitrate);
                });
              }), j === null && re === null && (j = -1), p = G, j;
            } }, m = function x(G, P, J) {
              if (J === P) return G;
              for (var M = G.length, W = 0; W < M; W++) for (var se = G.shift(), j = 0; j < l.length; j++) G.push(se.concat(l[j]));
              return x(G, P, J + 1);
            }((l = [0.2, 0.4, 0.6, 0.8, 1]).map(function(x) {
              return [x];
            }), 4, 1), p = 0, e;
          }
          E.__dashjs_factory_name = "LoLpWeightSelector", ge.Z = te.Z.getClassFactory(E);
        }, 2298: function(Se, ge) {
          ge.Z = function R() {
            (function(te, E) {
              if (!(te instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.type = null, this.lastBitrate = null, this.weights = {}, this.weights.bitrateReward = null, this.weights.bitrateSwitchPenalty = null, this.weights.rebufferPenalty = null, this.weights.latencyPenalty = null, this.weights.playbackSpeedPenalty = null, this.bitrateWSum = 0, this.bitrateSwitchWSum = 0, this.rebufferWSum = 0, this.latencyWSum = 0, this.playbackSpeedWSum = 0, this.totalQoe = 0;
          };
        }, 7803: function(Se, ge, R) {
          R.d(ge, { Y: function() {
            return f;
          } });
          var te = R(3393), E = R(1553), t = R(5448), e = R(2128), m = R(2594), p = R(7387), l = R(7417), v = R(9032), h = R(9326), n = R(7802), f = ["http://dashif.org/thumbnail_tile", "http://dashif.org/guidelines/thumbnail_tile"];
          function d(S) {
            var x, G, P, J, M, W, se, j, re = this.context, ce = S.adapter, Re = S.baseURLController, $ = S.streamInfo, Me = S.timelineConverter, Ge = S.debug, Qe = S.eventBus, Ae = S.events, Ze = S.dashConstants, Xe = (0, m.Z)(re).getInstance();
            function at(Be, It) {
              var _t = new e.Z();
              _t.id = Be.id, _t.bitrate = Be.bandwidth, _t.width = Be.width, _t.height = Be.height, _t.tilesHor = 1, _t.tilesVert = 1, Be.essentialProperties && Be.essentialProperties.forEach(function(Ve) {
                if (f.indexOf(Ve.schemeIdUri) >= 0 && Ve.value) {
                  var ot = Ve.value.split("x");
                  ot.length !== 2 || isNaN(ot[0]) || isNaN(ot[1]) || (_t.tilesHor = parseInt(ot[0], 10), _t.tilesVert = parseInt(ot[1], 10));
                }
              }), It ? W.updateSegmentData(Be).then(function(Ve) {
                (function(ot, Ee, Te) {
                  var je = [], c = function(o, T) {
                    var b, X, z, De, tt = [], Ue = 0;
                    for (b = 0, X = o.segments.length; b < X; b++) z = o.segments[b], (De = (0, p.TJ)(Me, ce.getIsDynamic(), T, z.startTime, z.duration, z.timescale, z.media, z.mediaRange, Ue)) && (tt.push(De), De = null, Ue++);
                    return tt;
                  }(Te, Ee);
                  Ee.segments = c, ot.segmentDuration = Ee.segments[0].duration, ot.readThumbnail = function(o, T) {
                    var b = null;
                    je.some(function(X) {
                      if (X.start <= o && X.end > o) return b = X.url, !0;
                    }), b ? T(b) : Ee.segments.some(function(X) {
                      if (X.mediaStartTime <= o && X.mediaStartTime + X.duration > o) {
                        var z = Re.resolve(Ee.path);
                        return se.load({ method: "get", url: z.url, request: { range: X.mediaRange, responseType: "arraybuffer" }, onload: function(De) {
                          var tt = j.getSamplesInfo(De.target.response), Ue = new Blob([De.target.response.slice(tt.sampleList[0].offset, tt.sampleList[0].offset + tt.sampleList[0].size)], { type: "image/jpeg" }), ke = window.URL.createObjectURL(Ue);
                          je.push({ start: X.mediaStartTime, end: X.mediaStartTime + X.duration, url: ke }), T && T(ke);
                        } }), !0;
                      }
                    });
                  };
                })(_t, Be, Ve);
              }) : (_t.startNumber = Be.startNumber, _t.segmentDuration = Be.segmentDuration, _t.timescale = Be.timescale, _t.templateUrl = function(Ve) {
                var ot = Xe.isRelative(Ve.media) ? Xe.resolve(Ve.media, Re.resolve(Ve.path).url) : Ve.media;
                return ot ? (0, p.Aj)(ot, Ve.id) : "";
              }(Be)), _t.tilesHor > 0 && _t.tilesVert > 0 && (_t.widthPerTile = _t.width / _t.tilesHor, _t.heightPerTile = _t.height / _t.tilesVert, G.push(_t));
            }
            function Ie() {
              G = [], J = -1, M = null;
            }
            return x = { getTracks: function() {
              return G;
            }, addTracks: function() {
              if ($ && ce && (M = ce.getMediaInfoForType($, te.Z.IMAGE))) {
                var Be = ce.getVoRepresentations(M);
                Be && Be.length > 0 && Be.forEach(function(It) {
                  (It.segmentInfoType === E.Z.SEGMENT_TEMPLATE && It.segmentDuration > 0 && It.media || It.segmentInfoType === E.Z.SEGMENT_TIMELINE) && at(It), It.segmentInfoType === E.Z.SEGMENT_BASE && at(It, !0);
                }), G.length > 0 && G.sort(function(It, _t) {
                  return It.bitrate - _t.bitrate;
                });
              }
            }, reset: Ie, setTrackByIndex: function(Be) {
              G && G.length !== 0 && (Be >= G.length && (Be = G.length - 1), J = Be);
            }, getCurrentTrack: function() {
              return J < 0 ? null : G[J];
            }, getCurrentTrackIndex: function() {
              return J;
            }, getThumbnailRequestForTime: function(Be) {
              for (var It, _t = ce.getVoRepresentations(M), Ve = 0; Ve < _t.length; Ve++) if (G[J].id === _t[Ve].id) {
                It = _t[Ve];
                break;
              }
              return P.getSegmentRequestForTime(M, It, Be);
            } }, Ie(), se = (0, v.Z)(re).create({}), j = (0, l.Z)(re).getInstance(), W = (0, n.Z)(re).create({ events: Ae, eventBus: Qe, streamInfo: $, timelineConverter: Me, dashConstants: Ze, dashMetrics: S.dashMetrics, segmentBaseController: S.segmentBaseController, type: te.Z.IMAGE }), (P = (0, h.Z)(re).create({ streamInfo: $, type: te.Z.IMAGE, timelineConverter: Me, segmentsController: W, baseURLController: Re, debug: Ge, eventBus: Qe, events: Ae, dashConstants: Ze, urlUtils: Xe })).initialize(!!ce && ce.getIsDynamic()), x;
          }
          d.__dashjs_factory_name = "ThumbnailTracks", ge.Z = t.Z.getClassFactory(d);
        }, 7417: function(Se, ge, R) {
          var te = R(6398), E = R(8260), t = R(5448), e = R(6934), m = R(9597);
          function p() {
            var l, v, h = this.context;
            function n(S) {
              if (!S) return null;
              S.fileStart === void 0 && (S.fileStart = 0);
              var x = e.parseBuffer(S), G = (0, E.Z)(h).create();
              return G.setData(x), G;
            }
            function f(S, x) {
              return S[x + 3] >>> 0 | S[x + 2] << 8 >>> 0 | S[x + 1] << 16 >>> 0 | S[x] << 24 >>> 0;
            }
            function d(S, x) {
              return String.fromCharCode(S[x++]) + String.fromCharCode(S[x++]) + String.fromCharCode(S[x++]) + String.fromCharCode(S[x]);
            }
            return v = { parse: n, findLastTopIsoBoxCompleted: function(S, x, G) {
              if (G === void 0 && (G = 0), !x || G + 8 >= x.byteLength) return new m.Z(0, !1);
              for (var P, J = x instanceof ArrayBuffer ? new Uint8Array(x) : x, M = 0; G < J.byteLength; ) {
                var W = f(J, G), se = d(J, G + 4);
                if (W === 0) break;
                G + W <= J.byteLength && (S.indexOf(se) >= 0 ? P = new m.Z(G, !0, W) : M = G + W), G += W;
              }
              return P || new m.Z(M, !1);
            }, getMediaTimescaleFromMoov: function(S) {
              var x = n(S), G = x ? x.getBox("mdhd") : void 0;
              return G ? G.timescale : NaN;
            }, getSamplesInfo: function(S) {
              if (!S || S.byteLength === 0) return { sampleList: [], lastSequenceNumber: NaN, totalDuration: NaN, numSequences: NaN };
              var x, G, P, J, M, W, se, j, re, ce, Re, $, Me, Ge, Qe, Ae, Ze = n(S), Xe = Ze.getBoxes("moof"), at = Ze.getBoxes("mfhd");
              Qe = Ze.getBoxes("moof").length, Ge = at[at.length - 1].sequence_number, G = 0, M = [];
              var Ie = -1, Be = -1;
              for (ce = 0; ce < Xe.length; ce++) {
                var It = Xe[ce], _t = It.getChildBoxes("traf");
                for (j = 0; j < _t.length; j++) {
                  var Ve = _t[j], ot = Ve.getChildBox("tfhd"), Ee = Ve.getChildBox("tfdt");
                  J = Ee.baseMediaDecodeTime;
                  var Te = Ve.getChildBoxes("trun"), je = Ve.getChildBoxes("subs");
                  for (re = 0; re < Te.length; re++) {
                    var c = Te[re];
                    for (G = c.sample_count, Me = (ot.base_data_offset || 0) + (c.data_offset || 0), se = 0; se < G; se++) {
                      x = (W = c.samples[se]).sample_duration !== void 0 ? W.sample_duration : ot.default_sample_duration, P = W.sample_size !== void 0 ? W.sample_size : ot.default_sample_size;
                      var o = { dts: J, cts: J + (W.sample_composition_time_offset !== void 0 ? W.sample_composition_time_offset : 0), duration: x, offset: It.offset + Me, size: P, subSizes: [P] };
                      if (je) for (Re = 0; Re < je.length; Re++) {
                        var T = je[Re];
                        if (Ie < T.entry_count - 1 && se > Be && (Ie++, Be += T.entries[Ie].sample_delta), se == Be) {
                          o.subSizes = [];
                          var b = T.entries[Ie];
                          for ($ = 0; $ < b.subsample_count; $++) o.subSizes.push(b.subsamples[$].subsample_size);
                        }
                      }
                      M.push(o), Me += P, J += x;
                    }
                  }
                  Ae = J - Ee.baseMediaDecodeTime;
                }
              }
              return { sampleList: M, lastSequenceNumber: Ge, totalDuration: Ae, numSequences: Qe };
            }, findInitRange: function(S) {
              var x = null, G = n(S);
              if (!G) return x;
              var P = G.getBox("ftyp"), J = G.getBox("moov");
              return l.debug("Searching for initialization."), J && J.isComplete && (x = (P ? P.offset : J.offset) + "-" + (J.offset + J.size - 1), l.debug("Found the initialization.  Range: " + x)), x;
            }, parsePayload: function(S, x, G) {
              if (G === void 0 && (G = 0), !x || G + 8 >= x.byteLength) return new m.Z(0, !1);
              for (var P, J = x instanceof ArrayBuffer ? new Uint8Array(x) : x, M = 0; G < J.byteLength; ) {
                var W = f(J, G), se = d(J, G + 4);
                if (W === 0) break;
                G + W <= J.byteLength && (S.indexOf(se) >= 0 ? P = new m.Z(G, !0, W, se) : M = G + W), G += W;
              }
              return P || new m.Z(M, !1);
            } }, l = (0, te.Z)(h).getInstance().getLogger(v), v;
          }
          p.__dashjs_factory_name = "BoxParser", ge.Z = t.Z.getSingletonFactory(p);
        }, 1715: function(Se, ge, R) {
          R.d(ge, { B: function() {
            return m;
          } });
          var te = R(5448), E = R(7803), t = R(3393), e = [{ codec: "avc1", compatibleCodecs: ["avc3"] }, { codec: "avc3", compatibleCodecs: ["avc1"] }];
          function m() {
            var l = "ManagedMediaSource" in window, v = "WebKitMediaSource" in window, h = "MediaSource" in window;
            return l || v || h;
          }
          function p() {
            var l, v, h;
            return l = { setConfig: function(n) {
              n && n.settings && (v = n.settings);
            }, supportsMediaSource: m, supportsEncryptedMedia: function() {
              return h;
            }, supportsCodec: function(n, f) {
              return f !== t.Z.AUDIO && f !== t.Z.VIDEO ? Promise.resolve(!0) : function(d, S) {
                return v.get().streaming.capabilities.useMediaCapabilitiesApi && navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo && (d.codec && S === t.Z.AUDIO || S === t.Z.VIDEO && d.codec && d.width && d.height && d.bitrate && d.framerate);
              }(n, f) ? function(d, S) {
                return new Promise(function(x) {
                  if (d && d.codec) {
                    var G = { type: "media-source" };
                    G[S] = {}, G[S].contentType = d.codec, G[S].width = d.width, G[S].height = d.height, G[S].bitrate = parseInt(d.bitrate), G[S].framerate = parseFloat(d.framerate), navigator.mediaCapabilities.decodingInfo(G).then(function(P) {
                      x(P.supported);
                    }).catch(function() {
                      x(!1);
                    });
                  } else x(!1);
                });
              }(n, f) : function(d) {
                return new Promise(function(S) {
                  if (d && d.codec) {
                    var x = d.codec;
                    d.width && d.height && (x += ';width="' + d.width + '";height="' + d.height + '"'), "ManagedMediaSource" in window && ManagedMediaSource.isTypeSupported(x) || "MediaSource" in window && MediaSource.isTypeSupported(x) || "WebKitMediaSource" in window && WebKitMediaSource.isTypeSupported(x) ? S(!0) : S(!1);
                  } else S(!1);
                });
              }(n);
            }, setEncryptedMediaSupported: function(n) {
              h = n;
            }, supportsEssentialProperty: function(n) {
              try {
                return E.Y.indexOf(n.schemeIdUri) !== -1 || t.Z.FONT_DOWNLOAD_DVB_SCHEME === n.schemeIdUri;
              } catch {
                return !0;
              }
            }, codecRootCompatibleWithCodec: function(n, f) {
              for (var d, S = n.split(".")[0], x = f.indexOf(S) === 0, G = 0; G < e.length; G++) if (e[G].codec === S) {
                d = e[G];
                break;
              }
              return d ? x || d.compatibleCodecs.some(function(P) {
                return f.indexOf(P) === 0;
              }) : x;
            } }, h = !1, l;
          }
          p.__dashjs_factory_name = "Capabilities", ge.Z = te.Z.getSingletonFactory(p);
        }, 2295: function(Se, ge, R) {
          var te = R(5448), E = R(3106);
          function t() {
            return { customTimeRangeArray: [], length: 0, add: function(e, m) {
              var p;
              for (p = 0; p < this.customTimeRangeArray.length && e > this.customTimeRangeArray[p].start; p++) ;
              for (this.customTimeRangeArray.splice(p, 0, { start: e, end: m }), p = 0; p < this.customTimeRangeArray.length - 1; p++) this.mergeRanges(p, p + 1) && p--;
              this.length = this.customTimeRangeArray.length;
            }, clear: function() {
              this.customTimeRangeArray = [], this.length = 0;
            }, remove: function(e, m) {
              for (var p = 0; p < this.customTimeRangeArray.length; p++) if (e <= this.customTimeRangeArray[p].start && m >= this.customTimeRangeArray[p].end) this.customTimeRangeArray.splice(p, 1), p--;
              else {
                if (e > this.customTimeRangeArray[p].start && m < this.customTimeRangeArray[p].end) {
                  this.customTimeRangeArray.splice(p + 1, 0, { start: m, end: this.customTimeRangeArray[p].end }), this.customTimeRangeArray[p].end = e;
                  break;
                }
                e > this.customTimeRangeArray[p].start && e < this.customTimeRangeArray[p].end ? this.customTimeRangeArray[p].end = e : m > this.customTimeRangeArray[p].start && m < this.customTimeRangeArray[p].end && (this.customTimeRangeArray[p].start = m);
              }
              this.length = this.customTimeRangeArray.length;
            }, mergeRanges: function(e, m) {
              var p = this.customTimeRangeArray[e], l = this.customTimeRangeArray[m];
              return p.start <= l.start && l.start <= p.end && p.end <= l.end ? (p.end = l.end, this.customTimeRangeArray.splice(m, 1), !0) : l.start <= p.start && p.start <= l.end && l.end <= p.end ? (p.start = l.start, this.customTimeRangeArray.splice(m, 1), !0) : l.start <= p.start && p.start <= l.end && p.end <= l.end ? (this.customTimeRangeArray.splice(e, 1), !0) : p.start <= l.start && l.start <= p.end && l.end <= p.end && (this.customTimeRangeArray.splice(m, 1), !0);
            }, start: function(e) {
              return (0, E.SE)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].start;
            }, end: function(e) {
              return (0, E.SE)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].end;
            } };
          }
          t.__dashjs_factory_name = "CustomTimeRanges", ge.Z = te.Z.getClassFactory(t);
        }, 5: function(Se, ge, R) {
          var te = R(5448);
          function E() {
            var t, e = /^[a-z][a-z0-9+\-_.]*:/i, m = /^https?:\/\//i, p = /^https:\/\//i, l = /^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i, v = function(P, J) {
              try {
                return new window.URL(P, J).toString();
              } catch {
                return P;
              }
            }, h = function(P, J) {
              var M = n;
              if (!J || !S(P)) return P;
              x(P) && (M = f), G(P) && (M = d);
              var W = M(J), se = W.charAt(W.length - 1) !== "/" && P.charAt(0) !== "/" ? "/" : "";
              return [W, P].join(se);
            };
            function n(P) {
              var J = P.indexOf("/"), M = P.lastIndexOf("/");
              return J !== -1 ? M === J + 1 ? P : (P.indexOf("?") !== -1 && (P = P.substring(0, P.indexOf("?"))), P.substring(0, M + 1)) : "";
            }
            function f(P) {
              var J = P.match(l);
              return J ? J[1] : "";
            }
            function d(P) {
              var J = P.match(e);
              return J ? J[0] : "";
            }
            function S(P) {
              return !e.test(P);
            }
            function x(P) {
              return S(P) && P.charAt(0) === "/";
            }
            function G(P) {
              return P.indexOf("//") === 0;
            }
            return function() {
              try {
                new window.URL("x", "http://y"), t = v;
              } catch {
              } finally {
                t = t || h;
              }
            }(), { parseBaseUrl: n, parseOrigin: f, parseScheme: d, isRelative: S, isPathAbsolute: x, isSchemeRelative: G, isHTTPURL: function(P) {
              return m.test(P);
            }, isHTTPS: function(P) {
              return p.test(P);
            }, removeHostname: function(P) {
              return /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(P)[2].substring(1);
            }, resolve: function(P, J) {
              return t(P, J);
            } };
          }
          E.__dashjs_factory_name = "DefaultURLUtils", ge.Z = te.Z.getSingletonFactory(E);
        }, 8260: function(Se, ge, R) {
          var te = R(2839), E = R(5448);
          function t() {
            var e;
            function m(l) {
              var v = [];
              if (!l || !e || typeof e.fetchAll != "function") return v;
              for (var h, n = e.fetchAll(l), f = 0, d = n.length; f < d; f++) (h = p(n[f])) && v.push(h);
              return v;
            }
            function p(l) {
              if (!l) return null;
              var v = new te.Z(l);
              return l.hasOwnProperty("_incomplete") && (v.isComplete = !l._incomplete), v;
            }
            return { getBox: function(l) {
              return l && e && e.boxes && e.boxes.length !== 0 && typeof e.fetch == "function" ? p(e.fetch(l)) : null;
            }, getBoxes: m, setData: function(l) {
              e = l;
            }, getLastBox: function() {
              if (!e || !e.boxes || !e.boxes.length) return null;
              var l = m(e.boxes[e.boxes.length - 1].type);
              return l.length > 0 ? l[l.length - 1] : null;
            } };
          }
          t.__dashjs_factory_name = "IsoFile", ge.Z = E.Z.getClassFactory(t);
        }, 7473: function(Se, ge, R) {
          R.d(ge, { k: function() {
            return E;
          } });
          var te = R(5448);
          function E(e, m) {
            var p = { url: e.url, method: e.method, headers: Object.assign({}, e.headers), credentials: e.withCredentials ? "include" : void 0, range: e.request.range };
            return Promise.resolve(m.modifyRequest(p)).then(function() {
              return Object.assign(e, p, { withCredentials: p.credentials === "include" });
            });
          }
          function t() {
            return { modifyRequest: null, modifyRequestURL: function(e) {
              return e;
            }, modifyRequestHeader: function(e, m) {
              return m.url, e;
            } };
          }
          t.__dashjs_factory_name = "RequestModifier", ge.Z = te.Z.getSingletonFactory(t);
        }, 3106: function(Se, ge, R) {
          R.d(ge, { PS: function() {
            return t;
          }, SE: function() {
            return e;
          } });
          var te = R(3393);
          function E(m) {
            return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
              return typeof p;
            } : function(p) {
              return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
            }, E(m);
          }
          function t(m, p) {
            if (E(m) !== p) throw te.Z.BAD_ARGUMENT_ERROR;
          }
          function e(m) {
            if (m === null || isNaN(m) || m % 1 != 0) throw te.Z.BAD_ARGUMENT_ERROR + " : argument is not an integer";
          }
        }, 2594: function(Se, ge, R) {
          var te = R(5448), E = R(5);
          function t() {
            var m, p = [], l = this.context;
            function v(h, n, f) {
              var d = function(S) {
                var x;
                for (x = 0; x < p.length; x++) if (p[x].regex.test(S)) return p[x].utils;
                return m;
              }(f || n);
              return d && typeof d[h] == "function" ? d[h](n, f) : m[h](n, f);
            }
            return m = (0, E.Z)(l).getInstance(), { registerUrlRegex: function(h, n) {
              p.push({ regex: h, utils: n });
            }, parseBaseUrl: function(h) {
              return v("parseBaseUrl", h);
            }, parseOrigin: function(h) {
              return v("parseOrigin", h);
            }, parseScheme: function(h) {
              return v("parseScheme", h);
            }, isRelative: function(h) {
              return v("isRelative", h);
            }, isPathAbsolute: function(h) {
              return v("isPathAbsolute", h);
            }, isSchemeRelative: function(h) {
              return v("isSchemeRelative", h);
            }, isHTTPURL: function(h) {
              return v("isHTTPURL", h);
            }, isHTTPS: function(h) {
              return v("isHTTPS", h);
            }, removeHostname: function(h) {
              return v("removeHostname", h);
            }, resolve: function(h, n) {
              return v("resolve", h, n);
            } };
          }
          t.__dashjs_factory_name = "URLUtils";
          var e = te.Z.getSingletonFactory(t);
          ge.Z = e;
        }, 5459: function(Se, ge) {
          ge.Z = function R(te, E, t) {
            (function(e, m) {
              if (!(e instanceof m)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.code = te || null, this.message = E || null, this.data = t || null;
          };
        }, 3186: function(Se, ge, R) {
          var te = R(7855);
          function E(e, m) {
            for (var p = 0; p < m.length; p++) {
              var l = m[p];
              l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(e, l.key, l);
            }
          }
          var t = function() {
            function e(l) {
              (function(v, h) {
                if (!(v instanceof h)) throw new TypeError("Cannot call a class as a function");
              })(this, e), this.action = e.ACTION_DOWNLOAD, this.startTime = NaN, this.mediaStartTime = NaN, this.mediaType = null, this.mediaInfo = null, this.type = null, this.duration = NaN, this.timescale = NaN, this.range = null, this.url = l || null, this.serviceLocation = null, this.requestStartDate = null, this.firstByteDate = null, this.requestEndDate = null, this.quality = NaN, this.index = NaN, this.availabilityStartTime = null, this.availabilityEndTime = null, this.wallStartTime = null, this.bytesLoaded = NaN, this.bytesTotal = NaN, this.delayLoadingTime = NaN, this.responseType = "arraybuffer", this.representationId = null;
            }
            var m, p;
            return m = e, (p = [{ key: "isInitializationRequest", value: function() {
              return this.type && this.type === te.w.INIT_SEGMENT_TYPE;
            } }, { key: "setInfo", value: function(l) {
              this.type = l && l.init ? te.w.INIT_SEGMENT_TYPE : te.w.MEDIA_SEGMENT_TYPE, this.url = l && l.url ? l.url : null, this.range = l && l.range ? l.range.start + "-" + l.range.end : null, this.mediaType = l && l.mediaType ? l.mediaType : null;
            } }]) && E(m.prototype, p), e;
          }();
          t.ACTION_DOWNLOAD = "download", t.ACTION_COMPLETE = "complete", ge.Z = t;
        }, 2839: function(Se, ge) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var m = t[e];
              m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(E, m.key, m);
            }
          }
          var te = function() {
            function E(m) {
              if (function(d, S) {
                if (!(d instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, E), this.offset = m._offset, this.type = m.type, this.size = m.size, this.boxes = [], m.boxes) for (var p = 0; p < m.boxes.length; p++) this.boxes.push(new E(m.boxes[p]));
              switch (this.isComplete = !0, m.type) {
                case "sidx":
                  if (this.timescale = m.timescale, this.earliest_presentation_time = m.earliest_presentation_time, this.first_offset = m.first_offset, this.references = m.references, m.references) {
                    this.references = [];
                    for (var l = 0; l < m.references.length; l++) {
                      var v = { reference_type: m.references[l].reference_type, referenced_size: m.references[l].referenced_size, subsegment_duration: m.references[l].subsegment_duration };
                      this.references.push(v);
                    }
                  }
                  break;
                case "emsg":
                  this.id = m.id, this.version = m.version === 1 ? 1 : 0, this.value = m.value, this.timescale = m.timescale, this.scheme_id_uri = m.scheme_id_uri, this.presentation_time_delta = m.version === 1 ? m.presentation_time : m.presentation_time_delta, this.event_duration = m.event_duration, this.message_data = m.message_data;
                  break;
                case "mdhd":
                  this.timescale = m.timescale;
                  break;
                case "mfhd":
                  this.sequence_number = m.sequence_number;
                  break;
                case "subs":
                  this.entry_count = m.entry_count, this.entries = m.entries;
                  break;
                case "tfhd":
                  this.base_data_offset = m.base_data_offset, this.sample_description_index = m.sample_description_index, this.default_sample_duration = m.default_sample_duration, this.default_sample_size = m.default_sample_size, this.default_sample_flags = m.default_sample_flags, this.flags = m.flags;
                  break;
                case "tfdt":
                  this.version = m.version, this.baseMediaDecodeTime = m.baseMediaDecodeTime, this.flags = m.flags;
                  break;
                case "trun":
                  if (this.sample_count = m.sample_count, this.first_sample_flags = m.first_sample_flags, this.data_offset = m.data_offset, this.flags = m.flags, this.samples = m.samples, m.samples) {
                    this.samples = [];
                    for (var h = 0, n = m.samples.length; h < n; h++) {
                      var f = { sample_size: m.samples[h].sample_size, sample_duration: m.samples[h].sample_duration, sample_composition_time_offset: m.samples[h].sample_composition_time_offset };
                      this.samples.push(f);
                    }
                  }
                  break;
                case "prft":
                  this.version = m.version, this.reference_track_ID = m.reference_track_ID, this.ntp_timestamp_sec = m.ntp_timestamp_sec, this.ntp_timestamp_frac = m.ntp_timestamp_frac, this.media_time = m.media_time, this.flags = m.flags;
              }
            }
            var t, e;
            return t = E, (e = [{ key: "getChildBox", value: function(m) {
              for (var p = 0; p < this.boxes.length; p++) if (this.boxes[p].type === m) return this.boxes[p];
            } }, { key: "getChildBoxes", value: function(m) {
              for (var p = [], l = 0; l < this.boxes.length; l++) this.boxes[l].type === m && p.push(this.boxes[l]);
              return p;
            } }]) && R(t.prototype, e), E;
          }();
          ge.Z = te;
        }, 9597: function(Se, ge) {
          ge.Z = function R(te, E, t) {
            (function(e, m) {
              if (!(e instanceof m)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.lastCompletedOffset = te, this.found = E, this.size = t;
          };
        }, 2128: function(Se, ge) {
          ge.Z = function R() {
            (function(te, E) {
              if (!(te instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.bitrate = 0, this.width = 0, this.height = 0, this.tilesHor = 0, this.tilesVert = 0, this.widthPerTile = 0, this.heightPerTile = 0, this.startNumber = 0, this.segmentDuration = 0, this.timescale = 0, this.templateUrl = "", this.id = "";
          };
        }, 7855: function(Se, ge, R) {
          function te(e, m) {
            if (!(e instanceof m)) throw new TypeError("Cannot call a class as a function");
          }
          R.d(ge, { O: function() {
            return t;
          }, w: function() {
            return E;
          } });
          var E = function e() {
            te(this, e), this.tcpid = null, this.type = null, this.url = null, this.actualurl = null, this.range = null, this.trequest = null, this.tresponse = null, this.responsecode = null, this.interval = null, this.trace = [], this.cmsd = null, this._stream = null, this._tfinish = null, this._mediaduration = null, this._quality = null, this._responseHeaders = null, this._serviceLocation = null, this._fileLoaderType = null;
          }, t = function e() {
            te(this, e), this.s = null, this.d = null, this.b = [];
          };
          E.GET = "GET", E.HEAD = "HEAD", E.MPD_TYPE = "MPD", E.XLINK_EXPANSION_TYPE = "XLinkExpansion", E.INIT_SEGMENT_TYPE = "InitializationSegment", E.INDEX_SEGMENT_TYPE = "IndexSegment", E.MEDIA_SEGMENT_TYPE = "MediaSegment", E.BITSTREAM_SWITCHING_SEGMENT_TYPE = "BitstreamSwitchingSegment", E.MSS_FRAGMENT_INFO_SEGMENT_TYPE = "FragmentInfoSegment", E.DVB_REPORTING_TYPE = "DVBReporting", E.LICENSE = "license", E.CONTENT_STEERING_TYPE = "ContentSteering", E.OTHER_TYPE = "other";
        }, 3039: function(Se, ge) {
          function R(E, t) {
            return function(e, m) {
              for (var p, l, v, h = te(e, "tag"), n = te(m ?? "*", "range"), f = [], d = -1; ++d < n.length; ) if (p = n[d].toLowerCase(), t || p !== "*") {
                for (l = -1, v = []; ++l < h.length; ) if (E(h[l].toLowerCase(), p)) {
                  if (!t) return h[l];
                  f.push(h[l]);
                } else v.push(h[l]);
                h = v;
              }
              return t ? f : void 0;
            };
          }
          function te(E, t) {
            var e = E && typeof E == "string" ? [E] : E;
            if (!e || typeof e != "object" || !("length" in e)) throw new Error("Invalid " + t + " `" + e + "`, expected non-empty string");
            return e;
          }
          ge.basicFilter = R(function(E, t) {
            return t === "*" || E === t || E.indexOf(t + "-") > -1;
          }, !0), ge.extendedFilter = R(function(E, t) {
            var e = E.split("-"), m = t.split("-"), p = 0, l = 0;
            if (m[l] !== "*" && e[p] !== m[l]) return !1;
            for (p++, l++; l < m.length; ) if (m[l] !== "*") {
              if (!e[p]) return !1;
              if (e[p] !== m[l]) {
                if (e[p].length === 1) return !1;
                p++;
              } else p++, l++;
            } else l++;
            return !0;
          }, !0), ge.lookup = R(function(E, t) {
            for (var e, m = t; ; ) {
              if (m === "*" || E === m) return !0;
              if ((e = m.lastIndexOf("-")) < 0) return !1;
              m.charAt(e - 2) === "-" && (e -= 2), m = m.slice(0, e);
            }
          });
        }, 3973: function(Se, ge, R) {
          Se.exports = R(3854);
        }, 3854: function(Se, ge, R) {
          var te = R(2415), E = R(3039), t = R(7778), e = R(5813), m = R(3165), p = R(9460);
          Se.exports = function(x, G) {
            var P, J = G || {}, M = te.parse(String(x || "").toLowerCase(), J), W = te.stringify(M), se = -1;
            if (!W) return W;
            for (; ++se < t.length; ) E.extendedFilter(W, t[se].from).length && (n(M, t[se].from, t[se].to), W = te.stringify(M));
            for (se = -1; ++se < e.length; ) f(M, e[se].from.field, e[se].from.value) && d(M, e[se].to.field, e[se].to.value);
            for (W = te.stringify(Object.assign({}, M, h)), se = -1; ++se < m.length; ) W === m[se] && (n(M, m[se], m[se].split("-").slice(0, -1).join("-")), W = te.stringify(Object.assign({}, M, h)));
            if (M.extensions.sort(S), J.warning) for (P in p) l.call(p[P], M[P]) && J.warning("Deprecated " + P + " `" + M[P] + "`, expected one of `" + p[P][M[P]].join("`, `") + "`", null, 7);
            return M.script && (M.script = M.script.charAt(0).toUpperCase() + M.script.slice(1)), M.region && (M.region = M.region.toUpperCase()), te.stringify(M);
          };
          var l = {}.hasOwnProperty, v = new Intl.Collator(), h = { variants: [], extensions: [], privateuse: [], irregular: null, regular: null };
          function n(x, G, P) {
            var J, M = te.parse(G), W = te.parse(P), se = [];
            for (J in M) M[J] && M[J].length && f(x, J, M[J]) && se.push(J);
            for (J in W) W[J] && W[J].length && (se.indexOf(J) > -1 || !x[J] || !x[J].length) && d(x, J, W[J]);
          }
          function f(x, G, P) {
            var J, M, W, se, j = !1;
            if (P) {
              if (M = J = x[G], J && typeof J == "object") for (M = [], W = -1; ++W < J.length; ) se = J[W], P.indexOf(se) < 0 ? M.push(se) : j = !0;
              else J === P && (M = null, j = !0);
              x[G] = M;
            }
            return j;
          }
          function d(x, G, P) {
            var J, M, W, se = x[G];
            if (se && typeof se == "object") for (J = [].concat(P), M = -1; ++M < J.length; ) W = J[M], se.indexOf(W) < 0 && se.push(W);
            else x[G] = P;
          }
          function S(x, G) {
            return v.compare(x.singleton, G.singleton);
          }
        }, 2415: function(Se, ge, R) {
          ge.parse = R(6903), ge.stringify = R(6713);
        }, 6903: function(Se, ge, R) {
          var te = R(2219), E = R(3516), t = R(395), e = R(858), m = R(8589);
          Se.exports = function l(v, h) {
            var n, f, d, S = h || {}, x = { language: null, extendedLanguageSubtags: [], script: null, region: null, variants: [], extensions: [], privateuse: [], irregular: null, regular: null }, G = String(v), P = G.toLowerCase(), J = 0;
            if (v == null) throw new Error("Expected string, got `" + v + "`");
            if (p.call(m, P)) return (S.normalize == null || S.normalize) && m[P] ? l(m[P]) : (x[e.indexOf(P) === -1 ? "irregular" : "regular"] = G, x);
            for (; E(P.charCodeAt(J)) && J < 9; ) J++;
            if (J > 1 && J < 9) {
              if (x.language = G.slice(0, J), J < 4) for (f = 0; P.charCodeAt(J) === 45 && E(P.charCodeAt(J + 1)) && E(P.charCodeAt(J + 2)) && E(P.charCodeAt(J + 3)) && !E(P.charCodeAt(J + 4)); ) {
                if (f > 2) return M(J, 3, "Too many extended language subtags, expected at most 3 subtags");
                x.extendedLanguageSubtags.push(G.slice(J + 1, J + 4)), J += 4, f++;
              }
              for (P.charCodeAt(J) === 45 && E(P.charCodeAt(J + 1)) && E(P.charCodeAt(J + 2)) && E(P.charCodeAt(J + 3)) && E(P.charCodeAt(J + 4)) && !E(P.charCodeAt(J + 5)) && (x.script = G.slice(J + 1, J + 5), J += 5), P.charCodeAt(J) === 45 && (E(P.charCodeAt(J + 1)) && E(P.charCodeAt(J + 2)) && !E(P.charCodeAt(J + 3)) ? (x.region = G.slice(J + 1, J + 3), J += 3) : t(P.charCodeAt(J + 1)) && t(P.charCodeAt(J + 2)) && t(P.charCodeAt(J + 3)) && !t(P.charCodeAt(J + 4)) && (x.region = G.slice(J + 1, J + 4), J += 4)); P.charCodeAt(J) === 45; ) {
                for (d = n = J + 1; te(P.charCodeAt(d)); ) {
                  if (d - n > 7) return M(d, 1, "Too long variant, expected at most 8 characters");
                  d++;
                }
                if (!(d - n > 4 || d - n > 3 && t(P.charCodeAt(n)))) break;
                x.variants.push(G.slice(n, d)), J = d;
              }
              for (; P.charCodeAt(J) === 45 && P.charCodeAt(J + 1) !== 120 && te(P.charCodeAt(J + 1)) && P.charCodeAt(J + 2) === 45 && te(P.charCodeAt(J + 3)); ) {
                for (d = J + 2, f = 0; P.charCodeAt(d) === 45 && te(P.charCodeAt(d + 1)) && te(P.charCodeAt(d + 2)); ) for (d = (n = d + 1) + 2, f++; te(P.charCodeAt(d)); ) {
                  if (d - n > 7) return M(d, 2, "Too long extension, expected at most 8 characters");
                  d++;
                }
                if (!f) return M(d, 4, "Empty extension, extensions must have at least 2 characters of content");
                x.extensions.push({ singleton: G.charAt(J + 1), extensions: G.slice(J + 3, d).split("-") }), J = d;
              }
            } else J = 0;
            if (J === 0 && P.charCodeAt(J) === 120 || P.charCodeAt(J) === 45 && P.charCodeAt(J + 1) === 120) for (d = J = J ? J + 2 : 1; P.charCodeAt(d) === 45 && te(P.charCodeAt(d + 1)); ) {
              for (d = n = J + 1; te(P.charCodeAt(d)); ) {
                if (d - n > 7) return M(d, 5, "Too long private-use area, expected at most 8 characters");
                d++;
              }
              x.privateuse.push(G.slice(J + 1, d)), J = d;
            }
            return J !== G.length ? M(J, 6, "Found superfluous content after tag") : x;
            function M(W, se, j) {
              return S.warning && S.warning(j, se, W), S.forgiving ? x : { language: null, extendedLanguageSubtags: [], script: null, region: null, variants: [], extensions: [], privateuse: [], irregular: null, regular: null };
            }
          };
          var p = {}.hasOwnProperty;
        }, 6713: function(Se) {
          Se.exports = function(ge) {
            var R, te, E, t = ge || {}, e = [];
            if (t.irregular || t.regular) return t.irregular || t.regular;
            if (t.language) for (e = e.concat(t.language, t.extendedLanguageSubtags || [], t.script || [], t.region || [], t.variants || []), R = t.extensions || [], te = -1; ++te < R.length; ) (E = R[te]).singleton && E.extensions && E.extensions.length && (e = e.concat(E.singleton, E.extensions));
            return t.privateuse && t.privateuse.length && (e = e.concat("x", t.privateuse)), e.join("-");
          };
        }, 1549: function(Se, ge, R) {
          var te = R(6693), E = R(2165), t = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
          ge.Buffer = p, ge.SlowBuffer = function(c) {
            return +c != c && (c = 0), p.alloc(+c);
          }, ge.INSPECT_MAX_BYTES = 50;
          var e = 2147483647;
          function m(c) {
            if (c > e) throw new RangeError('The value "' + c + '" is invalid for option "size"');
            var o = new Uint8Array(c);
            return Object.setPrototypeOf(o, p.prototype), o;
          }
          function p(c, o, T) {
            if (typeof c == "number") {
              if (typeof o == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
              return h(c);
            }
            return l(c, o, T);
          }
          function l(c, o, T) {
            if (typeof c == "string") return function(z, De) {
              if (typeof De == "string" && De !== "" || (De = "utf8"), !p.isEncoding(De)) throw new TypeError("Unknown encoding: " + De);
              var tt = 0 | S(z, De), Ue = m(tt), ke = Ue.write(z, De);
              return ke !== tt && (Ue = Ue.slice(0, ke)), Ue;
            }(c, o);
            if (ArrayBuffer.isView(c)) return function(z) {
              if (Ee(z, Uint8Array)) {
                var De = new Uint8Array(z);
                return f(De.buffer, De.byteOffset, De.byteLength);
              }
              return n(z);
            }(c);
            if (c == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof c);
            if (Ee(c, ArrayBuffer) || c && Ee(c.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Ee(c, SharedArrayBuffer) || c && Ee(c.buffer, SharedArrayBuffer))) return f(c, o, T);
            if (typeof c == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
            var b = c.valueOf && c.valueOf();
            if (b != null && b !== c) return p.from(b, o, T);
            var X = function(z) {
              if (p.isBuffer(z)) {
                var De = 0 | d(z.length), tt = m(De);
                return tt.length === 0 || z.copy(tt, 0, 0, De), tt;
              }
              return z.length !== void 0 ? typeof z.length != "number" || Te(z.length) ? m(0) : n(z) : z.type === "Buffer" && Array.isArray(z.data) ? n(z.data) : void 0;
            }(c);
            if (X) return X;
            if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof c[Symbol.toPrimitive] == "function") return p.from(c[Symbol.toPrimitive]("string"), o, T);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof c);
          }
          function v(c) {
            if (typeof c != "number") throw new TypeError('"size" argument must be of type number');
            if (c < 0) throw new RangeError('The value "' + c + '" is invalid for option "size"');
          }
          function h(c) {
            return v(c), m(c < 0 ? 0 : 0 | d(c));
          }
          function n(c) {
            for (var o = c.length < 0 ? 0 : 0 | d(c.length), T = m(o), b = 0; b < o; b += 1) T[b] = 255 & c[b];
            return T;
          }
          function f(c, o, T) {
            if (o < 0 || c.byteLength < o) throw new RangeError('"offset" is outside of buffer bounds');
            if (c.byteLength < o + (T || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var b;
            return b = o === void 0 && T === void 0 ? new Uint8Array(c) : T === void 0 ? new Uint8Array(c, o) : new Uint8Array(c, o, T), Object.setPrototypeOf(b, p.prototype), b;
          }
          function d(c) {
            if (c >= e) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + e.toString(16) + " bytes");
            return 0 | c;
          }
          function S(c, o) {
            if (p.isBuffer(c)) return c.length;
            if (ArrayBuffer.isView(c) || Ee(c, ArrayBuffer)) return c.byteLength;
            if (typeof c != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof c);
            var T = c.length, b = arguments.length > 2 && arguments[2] === !0;
            if (!b && T === 0) return 0;
            for (var X = !1; ; ) switch (o) {
              case "ascii":
              case "latin1":
              case "binary":
                return T;
              case "utf8":
              case "utf-8":
                return _t(c).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * T;
              case "hex":
                return T >>> 1;
              case "base64":
                return Ve(c).length;
              default:
                if (X) return b ? -1 : _t(c).length;
                o = ("" + o).toLowerCase(), X = !0;
            }
          }
          function x(c, o, T) {
            var b = !1;
            if ((o === void 0 || o < 0) && (o = 0), o > this.length || ((T === void 0 || T > this.length) && (T = this.length), T <= 0) || (T >>>= 0) <= (o >>>= 0)) return "";
            for (c || (c = "utf8"); ; ) switch (c) {
              case "hex":
                return Qe(this, o, T);
              case "utf8":
              case "utf-8":
                return Re(this, o, T);
              case "ascii":
                return Me(this, o, T);
              case "latin1":
              case "binary":
                return Ge(this, o, T);
              case "base64":
                return ce(this, o, T);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return Ae(this, o, T);
              default:
                if (b) throw new TypeError("Unknown encoding: " + c);
                c = (c + "").toLowerCase(), b = !0;
            }
          }
          function G(c, o, T) {
            var b = c[o];
            c[o] = c[T], c[T] = b;
          }
          function P(c, o, T, b, X) {
            if (c.length === 0) return -1;
            if (typeof T == "string" ? (b = T, T = 0) : T > 2147483647 ? T = 2147483647 : T < -2147483648 && (T = -2147483648), Te(T = +T) && (T = X ? 0 : c.length - 1), T < 0 && (T = c.length + T), T >= c.length) {
              if (X) return -1;
              T = c.length - 1;
            } else if (T < 0) {
              if (!X) return -1;
              T = 0;
            }
            if (typeof o == "string" && (o = p.from(o, b)), p.isBuffer(o)) return o.length === 0 ? -1 : J(c, o, T, b, X);
            if (typeof o == "number") return o &= 255, typeof Uint8Array.prototype.indexOf == "function" ? X ? Uint8Array.prototype.indexOf.call(c, o, T) : Uint8Array.prototype.lastIndexOf.call(c, o, T) : J(c, [o], T, b, X);
            throw new TypeError("val must be string, number or Buffer");
          }
          function J(c, o, T, b, X) {
            var z, De = 1, tt = c.length, Ue = o.length;
            if (b !== void 0 && ((b = String(b).toLowerCase()) === "ucs2" || b === "ucs-2" || b === "utf16le" || b === "utf-16le")) {
              if (c.length < 2 || o.length < 2) return -1;
              De = 2, tt /= 2, Ue /= 2, T /= 2;
            }
            function ke(bt, dt) {
              return De === 1 ? bt[dt] : bt.readUInt16BE(dt * De);
            }
            if (X) {
              var Oe = -1;
              for (z = T; z < tt; z++) if (ke(c, z) === ke(o, Oe === -1 ? 0 : z - Oe)) {
                if (Oe === -1 && (Oe = z), z - Oe + 1 === Ue) return Oe * De;
              } else Oe !== -1 && (z -= z - Oe), Oe = -1;
            } else for (T + Ue > tt && (T = tt - Ue), z = T; z >= 0; z--) {
              for (var qe = !0, it = 0; it < Ue; it++) if (ke(c, z + it) !== ke(o, it)) {
                qe = !1;
                break;
              }
              if (qe) return z;
            }
            return -1;
          }
          function M(c, o, T, b) {
            T = Number(T) || 0;
            var X = c.length - T;
            b ? (b = Number(b)) > X && (b = X) : b = X;
            var z = o.length;
            b > z / 2 && (b = z / 2);
            for (var De = 0; De < b; ++De) {
              var tt = parseInt(o.substr(2 * De, 2), 16);
              if (Te(tt)) return De;
              c[T + De] = tt;
            }
            return De;
          }
          function W(c, o, T, b) {
            return ot(_t(o, c.length - T), c, T, b);
          }
          function se(c, o, T, b) {
            return ot(function(X) {
              for (var z = [], De = 0; De < X.length; ++De) z.push(255 & X.charCodeAt(De));
              return z;
            }(o), c, T, b);
          }
          function j(c, o, T, b) {
            return ot(Ve(o), c, T, b);
          }
          function re(c, o, T, b) {
            return ot(function(X, z) {
              for (var De, tt, Ue, ke = [], Oe = 0; Oe < X.length && !((z -= 2) < 0); ++Oe) tt = (De = X.charCodeAt(Oe)) >> 8, Ue = De % 256, ke.push(Ue), ke.push(tt);
              return ke;
            }(o, c.length - T), c, T, b);
          }
          function ce(c, o, T) {
            return o === 0 && T === c.length ? te.fromByteArray(c) : te.fromByteArray(c.slice(o, T));
          }
          function Re(c, o, T) {
            T = Math.min(c.length, T);
            for (var b = [], X = o; X < T; ) {
              var z, De, tt, Ue, ke = c[X], Oe = null, qe = ke > 239 ? 4 : ke > 223 ? 3 : ke > 191 ? 2 : 1;
              if (X + qe <= T) switch (qe) {
                case 1:
                  ke < 128 && (Oe = ke);
                  break;
                case 2:
                  (192 & (z = c[X + 1])) == 128 && (Ue = (31 & ke) << 6 | 63 & z) > 127 && (Oe = Ue);
                  break;
                case 3:
                  z = c[X + 1], De = c[X + 2], (192 & z) == 128 && (192 & De) == 128 && (Ue = (15 & ke) << 12 | (63 & z) << 6 | 63 & De) > 2047 && (Ue < 55296 || Ue > 57343) && (Oe = Ue);
                  break;
                case 4:
                  z = c[X + 1], De = c[X + 2], tt = c[X + 3], (192 & z) == 128 && (192 & De) == 128 && (192 & tt) == 128 && (Ue = (15 & ke) << 18 | (63 & z) << 12 | (63 & De) << 6 | 63 & tt) > 65535 && Ue < 1114112 && (Oe = Ue);
              }
              Oe === null ? (Oe = 65533, qe = 1) : Oe > 65535 && (Oe -= 65536, b.push(Oe >>> 10 & 1023 | 55296), Oe = 56320 | 1023 & Oe), b.push(Oe), X += qe;
            }
            return function(it) {
              var bt = it.length;
              if (bt <= $) return String.fromCharCode.apply(String, it);
              for (var dt = "", Yt = 0; Yt < bt; ) dt += String.fromCharCode.apply(String, it.slice(Yt, Yt += $));
              return dt;
            }(b);
          }
          ge.kMaxLength = e, p.TYPED_ARRAY_SUPPORT = function() {
            try {
              var c = new Uint8Array(1), o = { foo: function() {
                return 42;
              } };
              return Object.setPrototypeOf(o, Uint8Array.prototype), Object.setPrototypeOf(c, o), c.foo() === 42;
            } catch {
              return !1;
            }
          }(), p.TYPED_ARRAY_SUPPORT || typeof console > "u" || typeof console.error != "function" || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(p.prototype, "parent", { enumerable: !0, get: function() {
            if (p.isBuffer(this)) return this.buffer;
          } }), Object.defineProperty(p.prototype, "offset", { enumerable: !0, get: function() {
            if (p.isBuffer(this)) return this.byteOffset;
          } }), p.poolSize = 8192, p.from = function(c, o, T) {
            return l(c, o, T);
          }, Object.setPrototypeOf(p.prototype, Uint8Array.prototype), Object.setPrototypeOf(p, Uint8Array), p.alloc = function(c, o, T) {
            return function(b, X, z) {
              return v(b), b <= 0 ? m(b) : X !== void 0 ? typeof z == "string" ? m(b).fill(X, z) : m(b).fill(X) : m(b);
            }(c, o, T);
          }, p.allocUnsafe = function(c) {
            return h(c);
          }, p.allocUnsafeSlow = function(c) {
            return h(c);
          }, p.isBuffer = function(c) {
            return c != null && c._isBuffer === !0 && c !== p.prototype;
          }, p.compare = function(c, o) {
            if (Ee(c, Uint8Array) && (c = p.from(c, c.offset, c.byteLength)), Ee(o, Uint8Array) && (o = p.from(o, o.offset, o.byteLength)), !p.isBuffer(c) || !p.isBuffer(o)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (c === o) return 0;
            for (var T = c.length, b = o.length, X = 0, z = Math.min(T, b); X < z; ++X) if (c[X] !== o[X]) {
              T = c[X], b = o[X];
              break;
            }
            return T < b ? -1 : b < T ? 1 : 0;
          }, p.isEncoding = function(c) {
            switch (String(c).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, p.concat = function(c, o) {
            if (!Array.isArray(c)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (c.length === 0) return p.alloc(0);
            var T;
            if (o === void 0) for (o = 0, T = 0; T < c.length; ++T) o += c[T].length;
            var b = p.allocUnsafe(o), X = 0;
            for (T = 0; T < c.length; ++T) {
              var z = c[T];
              if (Ee(z, Uint8Array)) X + z.length > b.length ? p.from(z).copy(b, X) : Uint8Array.prototype.set.call(b, z, X);
              else {
                if (!p.isBuffer(z)) throw new TypeError('"list" argument must be an Array of Buffers');
                z.copy(b, X);
              }
              X += z.length;
            }
            return b;
          }, p.byteLength = S, p.prototype._isBuffer = !0, p.prototype.swap16 = function() {
            var c = this.length;
            if (c % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var o = 0; o < c; o += 2) G(this, o, o + 1);
            return this;
          }, p.prototype.swap32 = function() {
            var c = this.length;
            if (c % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var o = 0; o < c; o += 4) G(this, o, o + 3), G(this, o + 1, o + 2);
            return this;
          }, p.prototype.swap64 = function() {
            var c = this.length;
            if (c % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var o = 0; o < c; o += 8) G(this, o, o + 7), G(this, o + 1, o + 6), G(this, o + 2, o + 5), G(this, o + 3, o + 4);
            return this;
          }, p.prototype.toString = function() {
            var c = this.length;
            return c === 0 ? "" : arguments.length === 0 ? Re(this, 0, c) : x.apply(this, arguments);
          }, p.prototype.toLocaleString = p.prototype.toString, p.prototype.equals = function(c) {
            if (!p.isBuffer(c)) throw new TypeError("Argument must be a Buffer");
            return this === c || p.compare(this, c) === 0;
          }, p.prototype.inspect = function() {
            var c = "", o = ge.INSPECT_MAX_BYTES;
            return c = this.toString("hex", 0, o).replace(/(.{2})/g, "$1 ").trim(), this.length > o && (c += " ... "), "<Buffer " + c + ">";
          }, t && (p.prototype[t] = p.prototype.inspect), p.prototype.compare = function(c, o, T, b, X) {
            if (Ee(c, Uint8Array) && (c = p.from(c, c.offset, c.byteLength)), !p.isBuffer(c)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof c);
            if (o === void 0 && (o = 0), T === void 0 && (T = c ? c.length : 0), b === void 0 && (b = 0), X === void 0 && (X = this.length), o < 0 || T > c.length || b < 0 || X > this.length) throw new RangeError("out of range index");
            if (b >= X && o >= T) return 0;
            if (b >= X) return -1;
            if (o >= T) return 1;
            if (this === c) return 0;
            for (var z = (X >>>= 0) - (b >>>= 0), De = (T >>>= 0) - (o >>>= 0), tt = Math.min(z, De), Ue = this.slice(b, X), ke = c.slice(o, T), Oe = 0; Oe < tt; ++Oe) if (Ue[Oe] !== ke[Oe]) {
              z = Ue[Oe], De = ke[Oe];
              break;
            }
            return z < De ? -1 : De < z ? 1 : 0;
          }, p.prototype.includes = function(c, o, T) {
            return this.indexOf(c, o, T) !== -1;
          }, p.prototype.indexOf = function(c, o, T) {
            return P(this, c, o, T, !0);
          }, p.prototype.lastIndexOf = function(c, o, T) {
            return P(this, c, o, T, !1);
          }, p.prototype.write = function(c, o, T, b) {
            if (o === void 0) b = "utf8", T = this.length, o = 0;
            else if (T === void 0 && typeof o == "string") b = o, T = this.length, o = 0;
            else {
              if (!isFinite(o)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              o >>>= 0, isFinite(T) ? (T >>>= 0, b === void 0 && (b = "utf8")) : (b = T, T = void 0);
            }
            var X = this.length - o;
            if ((T === void 0 || T > X) && (T = X), c.length > 0 && (T < 0 || o < 0) || o > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            b || (b = "utf8");
            for (var z = !1; ; ) switch (b) {
              case "hex":
                return M(this, c, o, T);
              case "utf8":
              case "utf-8":
                return W(this, c, o, T);
              case "ascii":
              case "latin1":
              case "binary":
                return se(this, c, o, T);
              case "base64":
                return j(this, c, o, T);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return re(this, c, o, T);
              default:
                if (z) throw new TypeError("Unknown encoding: " + b);
                b = ("" + b).toLowerCase(), z = !0;
            }
          }, p.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          };
          var $ = 4096;
          function Me(c, o, T) {
            var b = "";
            T = Math.min(c.length, T);
            for (var X = o; X < T; ++X) b += String.fromCharCode(127 & c[X]);
            return b;
          }
          function Ge(c, o, T) {
            var b = "";
            T = Math.min(c.length, T);
            for (var X = o; X < T; ++X) b += String.fromCharCode(c[X]);
            return b;
          }
          function Qe(c, o, T) {
            var b = c.length;
            (!o || o < 0) && (o = 0), (!T || T < 0 || T > b) && (T = b);
            for (var X = "", z = o; z < T; ++z) X += je[c[z]];
            return X;
          }
          function Ae(c, o, T) {
            for (var b = c.slice(o, T), X = "", z = 0; z < b.length - 1; z += 2) X += String.fromCharCode(b[z] + 256 * b[z + 1]);
            return X;
          }
          function Ze(c, o, T) {
            if (c % 1 != 0 || c < 0) throw new RangeError("offset is not uint");
            if (c + o > T) throw new RangeError("Trying to access beyond buffer length");
          }
          function Xe(c, o, T, b, X, z) {
            if (!p.isBuffer(c)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (o > X || o < z) throw new RangeError('"value" argument is out of bounds');
            if (T + b > c.length) throw new RangeError("Index out of range");
          }
          function at(c, o, T, b, X, z) {
            if (T + b > c.length) throw new RangeError("Index out of range");
            if (T < 0) throw new RangeError("Index out of range");
          }
          function Ie(c, o, T, b, X) {
            return o = +o, T >>>= 0, X || at(c, 0, T, 4), E.write(c, o, T, b, 23, 4), T + 4;
          }
          function Be(c, o, T, b, X) {
            return o = +o, T >>>= 0, X || at(c, 0, T, 8), E.write(c, o, T, b, 52, 8), T + 8;
          }
          p.prototype.slice = function(c, o) {
            var T = this.length;
            (c = ~~c) < 0 ? (c += T) < 0 && (c = 0) : c > T && (c = T), (o = o === void 0 ? T : ~~o) < 0 ? (o += T) < 0 && (o = 0) : o > T && (o = T), o < c && (o = c);
            var b = this.subarray(c, o);
            return Object.setPrototypeOf(b, p.prototype), b;
          }, p.prototype.readUintLE = p.prototype.readUIntLE = function(c, o, T) {
            c >>>= 0, o >>>= 0, T || Ze(c, o, this.length);
            for (var b = this[c], X = 1, z = 0; ++z < o && (X *= 256); ) b += this[c + z] * X;
            return b;
          }, p.prototype.readUintBE = p.prototype.readUIntBE = function(c, o, T) {
            c >>>= 0, o >>>= 0, T || Ze(c, o, this.length);
            for (var b = this[c + --o], X = 1; o > 0 && (X *= 256); ) b += this[c + --o] * X;
            return b;
          }, p.prototype.readUint8 = p.prototype.readUInt8 = function(c, o) {
            return c >>>= 0, o || Ze(c, 1, this.length), this[c];
          }, p.prototype.readUint16LE = p.prototype.readUInt16LE = function(c, o) {
            return c >>>= 0, o || Ze(c, 2, this.length), this[c] | this[c + 1] << 8;
          }, p.prototype.readUint16BE = p.prototype.readUInt16BE = function(c, o) {
            return c >>>= 0, o || Ze(c, 2, this.length), this[c] << 8 | this[c + 1];
          }, p.prototype.readUint32LE = p.prototype.readUInt32LE = function(c, o) {
            return c >>>= 0, o || Ze(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + 16777216 * this[c + 3];
          }, p.prototype.readUint32BE = p.prototype.readUInt32BE = function(c, o) {
            return c >>>= 0, o || Ze(c, 4, this.length), 16777216 * this[c] + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
          }, p.prototype.readIntLE = function(c, o, T) {
            c >>>= 0, o >>>= 0, T || Ze(c, o, this.length);
            for (var b = this[c], X = 1, z = 0; ++z < o && (X *= 256); ) b += this[c + z] * X;
            return b >= (X *= 128) && (b -= Math.pow(2, 8 * o)), b;
          }, p.prototype.readIntBE = function(c, o, T) {
            c >>>= 0, o >>>= 0, T || Ze(c, o, this.length);
            for (var b = o, X = 1, z = this[c + --b]; b > 0 && (X *= 256); ) z += this[c + --b] * X;
            return z >= (X *= 128) && (z -= Math.pow(2, 8 * o)), z;
          }, p.prototype.readInt8 = function(c, o) {
            return c >>>= 0, o || Ze(c, 1, this.length), 128 & this[c] ? -1 * (255 - this[c] + 1) : this[c];
          }, p.prototype.readInt16LE = function(c, o) {
            c >>>= 0, o || Ze(c, 2, this.length);
            var T = this[c] | this[c + 1] << 8;
            return 32768 & T ? 4294901760 | T : T;
          }, p.prototype.readInt16BE = function(c, o) {
            c >>>= 0, o || Ze(c, 2, this.length);
            var T = this[c + 1] | this[c] << 8;
            return 32768 & T ? 4294901760 | T : T;
          }, p.prototype.readInt32LE = function(c, o) {
            return c >>>= 0, o || Ze(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
          }, p.prototype.readInt32BE = function(c, o) {
            return c >>>= 0, o || Ze(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
          }, p.prototype.readFloatLE = function(c, o) {
            return c >>>= 0, o || Ze(c, 4, this.length), E.read(this, c, !0, 23, 4);
          }, p.prototype.readFloatBE = function(c, o) {
            return c >>>= 0, o || Ze(c, 4, this.length), E.read(this, c, !1, 23, 4);
          }, p.prototype.readDoubleLE = function(c, o) {
            return c >>>= 0, o || Ze(c, 8, this.length), E.read(this, c, !0, 52, 8);
          }, p.prototype.readDoubleBE = function(c, o) {
            return c >>>= 0, o || Ze(c, 8, this.length), E.read(this, c, !1, 52, 8);
          }, p.prototype.writeUintLE = p.prototype.writeUIntLE = function(c, o, T, b) {
            c = +c, o >>>= 0, T >>>= 0, b || Xe(this, c, o, T, Math.pow(2, 8 * T) - 1, 0);
            var X = 1, z = 0;
            for (this[o] = 255 & c; ++z < T && (X *= 256); ) this[o + z] = c / X & 255;
            return o + T;
          }, p.prototype.writeUintBE = p.prototype.writeUIntBE = function(c, o, T, b) {
            c = +c, o >>>= 0, T >>>= 0, b || Xe(this, c, o, T, Math.pow(2, 8 * T) - 1, 0);
            var X = T - 1, z = 1;
            for (this[o + X] = 255 & c; --X >= 0 && (z *= 256); ) this[o + X] = c / z & 255;
            return o + T;
          }, p.prototype.writeUint8 = p.prototype.writeUInt8 = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 1, 255, 0), this[o] = 255 & c, o + 1;
          }, p.prototype.writeUint16LE = p.prototype.writeUInt16LE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 2, 65535, 0), this[o] = 255 & c, this[o + 1] = c >>> 8, o + 2;
          }, p.prototype.writeUint16BE = p.prototype.writeUInt16BE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 2, 65535, 0), this[o] = c >>> 8, this[o + 1] = 255 & c, o + 2;
          }, p.prototype.writeUint32LE = p.prototype.writeUInt32LE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 4, 4294967295, 0), this[o + 3] = c >>> 24, this[o + 2] = c >>> 16, this[o + 1] = c >>> 8, this[o] = 255 & c, o + 4;
          }, p.prototype.writeUint32BE = p.prototype.writeUInt32BE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 4, 4294967295, 0), this[o] = c >>> 24, this[o + 1] = c >>> 16, this[o + 2] = c >>> 8, this[o + 3] = 255 & c, o + 4;
          }, p.prototype.writeIntLE = function(c, o, T, b) {
            if (c = +c, o >>>= 0, !b) {
              var X = Math.pow(2, 8 * T - 1);
              Xe(this, c, o, T, X - 1, -X);
            }
            var z = 0, De = 1, tt = 0;
            for (this[o] = 255 & c; ++z < T && (De *= 256); ) c < 0 && tt === 0 && this[o + z - 1] !== 0 && (tt = 1), this[o + z] = (c / De >> 0) - tt & 255;
            return o + T;
          }, p.prototype.writeIntBE = function(c, o, T, b) {
            if (c = +c, o >>>= 0, !b) {
              var X = Math.pow(2, 8 * T - 1);
              Xe(this, c, o, T, X - 1, -X);
            }
            var z = T - 1, De = 1, tt = 0;
            for (this[o + z] = 255 & c; --z >= 0 && (De *= 256); ) c < 0 && tt === 0 && this[o + z + 1] !== 0 && (tt = 1), this[o + z] = (c / De >> 0) - tt & 255;
            return o + T;
          }, p.prototype.writeInt8 = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 1, 127, -128), c < 0 && (c = 255 + c + 1), this[o] = 255 & c, o + 1;
          }, p.prototype.writeInt16LE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 2, 32767, -32768), this[o] = 255 & c, this[o + 1] = c >>> 8, o + 2;
          }, p.prototype.writeInt16BE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 2, 32767, -32768), this[o] = c >>> 8, this[o + 1] = 255 & c, o + 2;
          }, p.prototype.writeInt32LE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 4, 2147483647, -2147483648), this[o] = 255 & c, this[o + 1] = c >>> 8, this[o + 2] = c >>> 16, this[o + 3] = c >>> 24, o + 4;
          }, p.prototype.writeInt32BE = function(c, o, T) {
            return c = +c, o >>>= 0, T || Xe(this, c, o, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), this[o] = c >>> 24, this[o + 1] = c >>> 16, this[o + 2] = c >>> 8, this[o + 3] = 255 & c, o + 4;
          }, p.prototype.writeFloatLE = function(c, o, T) {
            return Ie(this, c, o, !0, T);
          }, p.prototype.writeFloatBE = function(c, o, T) {
            return Ie(this, c, o, !1, T);
          }, p.prototype.writeDoubleLE = function(c, o, T) {
            return Be(this, c, o, !0, T);
          }, p.prototype.writeDoubleBE = function(c, o, T) {
            return Be(this, c, o, !1, T);
          }, p.prototype.copy = function(c, o, T, b) {
            if (!p.isBuffer(c)) throw new TypeError("argument should be a Buffer");
            if (T || (T = 0), b || b === 0 || (b = this.length), o >= c.length && (o = c.length), o || (o = 0), b > 0 && b < T && (b = T), b === T || c.length === 0 || this.length === 0) return 0;
            if (o < 0) throw new RangeError("targetStart out of bounds");
            if (T < 0 || T >= this.length) throw new RangeError("Index out of range");
            if (b < 0) throw new RangeError("sourceEnd out of bounds");
            b > this.length && (b = this.length), c.length - o < b - T && (b = c.length - o + T);
            var X = b - T;
            return this === c && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(o, T, b) : Uint8Array.prototype.set.call(c, this.subarray(T, b), o), X;
          }, p.prototype.fill = function(c, o, T, b) {
            if (typeof c == "string") {
              if (typeof o == "string" ? (b = o, o = 0, T = this.length) : typeof T == "string" && (b = T, T = this.length), b !== void 0 && typeof b != "string") throw new TypeError("encoding must be a string");
              if (typeof b == "string" && !p.isEncoding(b)) throw new TypeError("Unknown encoding: " + b);
              if (c.length === 1) {
                var X = c.charCodeAt(0);
                (b === "utf8" && X < 128 || b === "latin1") && (c = X);
              }
            } else typeof c == "number" ? c &= 255 : typeof c == "boolean" && (c = Number(c));
            if (o < 0 || this.length < o || this.length < T) throw new RangeError("Out of range index");
            if (T <= o) return this;
            var z;
            if (o >>>= 0, T = T === void 0 ? this.length : T >>> 0, c || (c = 0), typeof c == "number") for (z = o; z < T; ++z) this[z] = c;
            else {
              var De = p.isBuffer(c) ? c : p.from(c, b), tt = De.length;
              if (tt === 0) throw new TypeError('The value "' + c + '" is invalid for argument "value"');
              for (z = 0; z < T - o; ++z) this[z + o] = De[z % tt];
            }
            return this;
          };
          var It = /[^+/0-9A-Za-z-_]/g;
          function _t(c, o) {
            var T;
            o = o || 1 / 0;
            for (var b = c.length, X = null, z = [], De = 0; De < b; ++De) {
              if ((T = c.charCodeAt(De)) > 55295 && T < 57344) {
                if (!X) {
                  if (T > 56319) {
                    (o -= 3) > -1 && z.push(239, 191, 189);
                    continue;
                  }
                  if (De + 1 === b) {
                    (o -= 3) > -1 && z.push(239, 191, 189);
                    continue;
                  }
                  X = T;
                  continue;
                }
                if (T < 56320) {
                  (o -= 3) > -1 && z.push(239, 191, 189), X = T;
                  continue;
                }
                T = 65536 + (X - 55296 << 10 | T - 56320);
              } else X && (o -= 3) > -1 && z.push(239, 191, 189);
              if (X = null, T < 128) {
                if ((o -= 1) < 0) break;
                z.push(T);
              } else if (T < 2048) {
                if ((o -= 2) < 0) break;
                z.push(T >> 6 | 192, 63 & T | 128);
              } else if (T < 65536) {
                if ((o -= 3) < 0) break;
                z.push(T >> 12 | 224, T >> 6 & 63 | 128, 63 & T | 128);
              } else {
                if (!(T < 1114112)) throw new Error("Invalid code point");
                if ((o -= 4) < 0) break;
                z.push(T >> 18 | 240, T >> 12 & 63 | 128, T >> 6 & 63 | 128, 63 & T | 128);
              }
            }
            return z;
          }
          function Ve(c) {
            return te.toByteArray(function(o) {
              if ((o = (o = o.split("=")[0]).trim().replace(It, "")).length < 2) return "";
              for (; o.length % 4 != 0; ) o += "=";
              return o;
            }(c));
          }
          function ot(c, o, T, b) {
            for (var X = 0; X < b && !(X + T >= o.length || X >= c.length); ++X) o[X + T] = c[X];
            return X;
          }
          function Ee(c, o) {
            return c instanceof o || c != null && c.constructor != null && c.constructor.name != null && c.constructor.name === o.name;
          }
          function Te(c) {
            return c != c;
          }
          var je = function() {
            for (var c = "0123456789abcdef", o = new Array(256), T = 0; T < 16; ++T) for (var b = 16 * T, X = 0; X < 16; ++X) o[b + X] = c[T] + c[X];
            return o;
          }();
        }, 6693: function(Se, ge) {
          ge.byteLength = function(v) {
            var h = p(v), n = h[0], f = h[1];
            return 3 * (n + f) / 4 - f;
          }, ge.toByteArray = function(v) {
            var h, n, f = p(v), d = f[0], S = f[1], x = new E(function(J, M, W) {
              return 3 * (M + W) / 4 - W;
            }(0, d, S)), G = 0, P = S > 0 ? d - 4 : d;
            for (n = 0; n < P; n += 4) h = te[v.charCodeAt(n)] << 18 | te[v.charCodeAt(n + 1)] << 12 | te[v.charCodeAt(n + 2)] << 6 | te[v.charCodeAt(n + 3)], x[G++] = h >> 16 & 255, x[G++] = h >> 8 & 255, x[G++] = 255 & h;
            return S === 2 && (h = te[v.charCodeAt(n)] << 2 | te[v.charCodeAt(n + 1)] >> 4, x[G++] = 255 & h), S === 1 && (h = te[v.charCodeAt(n)] << 10 | te[v.charCodeAt(n + 1)] << 4 | te[v.charCodeAt(n + 2)] >> 2, x[G++] = h >> 8 & 255, x[G++] = 255 & h), x;
          }, ge.fromByteArray = function(v) {
            for (var h, n = v.length, f = n % 3, d = [], S = 16383, x = 0, G = n - f; x < G; x += S) d.push(l(v, x, x + S > G ? G : x + S));
            return f === 1 ? (h = v[n - 1], d.push(R[h >> 2] + R[h << 4 & 63] + "==")) : f === 2 && (h = (v[n - 2] << 8) + v[n - 1], d.push(R[h >> 10] + R[h >> 4 & 63] + R[h << 2 & 63] + "=")), d.join("");
          };
          for (var R = [], te = [], E = typeof Uint8Array < "u" ? Uint8Array : Array, t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, m = t.length; e < m; ++e) R[e] = t[e], te[t.charCodeAt(e)] = e;
          function p(v) {
            var h = v.length;
            if (h % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var n = v.indexOf("=");
            return n === -1 && (n = h), [n, n === h ? 0 : 4 - n % 4];
          }
          function l(v, h, n) {
            for (var f, d, S = [], x = h; x < n; x += 3) f = (v[x] << 16 & 16711680) + (v[x + 1] << 8 & 65280) + (255 & v[x + 2]), S.push(R[(d = f) >> 18 & 63] + R[d >> 12 & 63] + R[d >> 6 & 63] + R[63 & d]);
            return S.join("");
          }
          te[45] = 62, te[95] = 63;
        }, 2165: function(Se, ge) {
          ge.read = function(R, te, E, t, e) {
            var m, p, l = 8 * e - t - 1, v = (1 << l) - 1, h = v >> 1, n = -7, f = E ? e - 1 : 0, d = E ? -1 : 1, S = R[te + f];
            for (f += d, m = S & (1 << -n) - 1, S >>= -n, n += l; n > 0; m = 256 * m + R[te + f], f += d, n -= 8) ;
            for (p = m & (1 << -n) - 1, m >>= -n, n += t; n > 0; p = 256 * p + R[te + f], f += d, n -= 8) ;
            if (m === 0) m = 1 - h;
            else {
              if (m === v) return p ? NaN : 1 / 0 * (S ? -1 : 1);
              p += Math.pow(2, t), m -= h;
            }
            return (S ? -1 : 1) * p * Math.pow(2, m - t);
          }, ge.write = function(R, te, E, t, e, m) {
            var p, l, v, h = 8 * m - e - 1, n = (1 << h) - 1, f = n >> 1, d = e === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, S = t ? 0 : m - 1, x = t ? 1 : -1, G = te < 0 || te === 0 && 1 / te < 0 ? 1 : 0;
            for (te = Math.abs(te), isNaN(te) || te === 1 / 0 ? (l = isNaN(te) ? 1 : 0, p = n) : (p = Math.floor(Math.log(te) / Math.LN2), te * (v = Math.pow(2, -p)) < 1 && (p--, v *= 2), (te += p + f >= 1 ? d / v : d * Math.pow(2, 1 - f)) * v >= 2 && (p++, v /= 2), p + f >= n ? (l = 0, p = n) : p + f >= 1 ? (l = (te * v - 1) * Math.pow(2, e), p += f) : (l = te * Math.pow(2, f - 1) * Math.pow(2, e), p = 0)); e >= 8; R[E + S] = 255 & l, S += x, l /= 256, e -= 8) ;
            for (p = p << e | l, h += e; h > 0; R[E + S] = 255 & p, S += x, p /= 256, h -= 8) ;
            R[E + S - x] |= 128 * G;
          };
        }, 6934: function(Se, ge) {
          var R = { parseBuffer: function(t) {
            return new te(t).parse();
          }, addBoxProcessor: function(t, e) {
            typeof t == "string" && typeof e == "function" && (E.prototype._boxProcessors[t] = e);
          }, createFile: function() {
            return new te();
          }, createBox: function(t, e, m) {
            var p = E.create(t);
            return e && e.append(p, m), p;
          }, createFullBox: function(t, e, m) {
            var p = R.createBox(t, e, m);
            return p.version = 0, p.flags = 0, p;
          }, Utils: {} };
          R.Utils.dataViewToString = function(t, e) {
            var m = e || "utf-8";
            if (typeof TextDecoder < "u") return new TextDecoder(m).decode(t);
            var p = [], l = 0;
            if (m === "utf-8") for (; l < t.byteLength; ) {
              var v = t.getUint8(l++);
              v < 128 || (v < 224 ? (v = (31 & v) << 6, v |= 63 & t.getUint8(l++)) : v < 240 ? (v = (15 & v) << 12, v |= (63 & t.getUint8(l++)) << 6, v |= 63 & t.getUint8(l++)) : (v = (7 & v) << 18, v |= (63 & t.getUint8(l++)) << 12, v |= (63 & t.getUint8(l++)) << 6, v |= 63 & t.getUint8(l++))), p.push(String.fromCharCode(v));
            }
            else for (; l < t.byteLength; ) p.push(String.fromCharCode(t.getUint8(l++)));
            return p.join("");
          }, R.Utils.utf8ToByteArray = function(t) {
            var e, m;
            if (typeof TextEncoder < "u") e = new TextEncoder().encode(t);
            else for (e = [], m = 0; m < t.length; ++m) {
              var p = t.charCodeAt(m);
              p < 128 ? e.push(p) : p < 2048 ? (e.push(192 | p >> 6), e.push(128 | 63 & p)) : p < 65536 ? (e.push(224 | p >> 12), e.push(128 | 63 & p >> 6), e.push(128 | 63 & p)) : (e.push(240 | p >> 18), e.push(128 | 63 & p >> 12), e.push(128 | 63 & p >> 6), e.push(128 | 63 & p));
            }
            return e;
          }, R.Utils.appendBox = function(t, e, m) {
            if (e._offset = t._cursor.offset, e._root = t._root ? t._root : t, e._raw = t._raw, e._parent = t, m !== -1) if (m != null) {
              var p, l = -1;
              if (typeof m == "number") l = m;
              else {
                if (typeof m == "string") p = m;
                else {
                  if (typeof m != "object" || !m.type) return void t.boxes.push(e);
                  p = m.type;
                }
                for (var v = 0; v < t.boxes.length; v++) if (p === t.boxes[v].type) {
                  l = v + 1;
                  break;
                }
              }
              t.boxes.splice(l, 0, e);
            } else t.boxes.push(e);
          }, ge.parseBuffer = R.parseBuffer, ge.addBoxProcessor = R.addBoxProcessor, ge.createFile = R.createFile, ge.createBox = R.createBox, ge.createFullBox = R.createFullBox, ge.Utils = R.Utils, R.Cursor = function(t) {
            this.offset = t === void 0 ? 0 : t;
          };
          var te = function(t) {
            this._cursor = new R.Cursor(), this.boxes = [], t && (this._raw = new DataView(t));
          };
          te.prototype.fetch = function(t) {
            var e = this.fetchAll(t, !0);
            return e.length ? e[0] : null;
          }, te.prototype.fetchAll = function(t, e) {
            var m = [];
            return te._sweep.call(this, t, m, e), m;
          }, te.prototype.parse = function() {
            for (this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength; ) {
              var t = E.parse(this);
              if (t.type === void 0) break;
              this.boxes.push(t);
            }
            return this;
          }, te._sweep = function(t, e, m) {
            for (var p in this.type && this.type == t && e.push(this), this.boxes) {
              if (e.length && m) return;
              te._sweep.call(this.boxes[p], t, e, m);
            }
          }, te.prototype.write = function() {
            var t, e = 0;
            for (t = 0; t < this.boxes.length; t++) e += this.boxes[t].getLength(!1);
            var m = new Uint8Array(e);
            for (this._rawo = new DataView(m.buffer), this.bytes = m, this._cursor.offset = 0, t = 0; t < this.boxes.length; t++) this.boxes[t].write();
            return m.buffer;
          }, te.prototype.append = function(t, e) {
            R.Utils.appendBox(this, t, e);
          };
          var E = function() {
            this._cursor = new R.Cursor();
          };
          E.parse = function(t) {
            var e = new E();
            return e._offset = t._cursor.offset, e._root = t._root ? t._root : t, e._raw = t._raw, e._parent = t, e._parseBox(), t._cursor.offset = e._raw.byteOffset + e._raw.byteLength, e;
          }, E.create = function(t) {
            var e = new E();
            return e.type = t, e.boxes = [], e;
          }, E.prototype._boxContainers = ["dinf", "edts", "mdia", "meco", "mfra", "minf", "moof", "moov", "mvex", "stbl", "strk", "traf", "trak", "tref", "udta", "vttc", "sinf", "schi", "encv", "enca"], E.prototype._boxProcessors = {}, E.prototype._procField = function(t, e, m) {
            this._parsing ? this[t] = this._readField(e, m) : this._writeField(e, m, this[t]);
          }, E.prototype._procFieldArray = function(t, e, m, p) {
            var l;
            if (this._parsing) for (this[t] = [], l = 0; l < e; l++) this[t][l] = this._readField(m, p);
            else for (l = 0; l < this[t].length; l++) this._writeField(m, p, this[t][l]);
          }, E.prototype._procFullBox = function() {
            this._procField("version", "uint", 8), this._procField("flags", "uint", 24);
          }, E.prototype._procEntries = function(t, e, m) {
            var p;
            if (this._parsing) for (this[t] = [], p = 0; p < e; p++) this[t].push({}), m.call(this, this[t][p]);
            else for (p = 0; p < e; p++) m.call(this, this[t][p]);
          }, E.prototype._procSubEntries = function(t, e, m, p) {
            var l;
            if (this._parsing) for (t[e] = [], l = 0; l < m; l++) t[e].push({}), p.call(this, t[e][l]);
            else for (l = 0; l < m; l++) p.call(this, t[e][l]);
          }, E.prototype._procEntryField = function(t, e, m, p) {
            this._parsing ? t[e] = this._readField(m, p) : this._writeField(m, p, t[e]);
          }, E.prototype._procSubBoxes = function(t, e) {
            var m;
            if (this._parsing) for (this[t] = [], m = 0; m < e; m++) this[t].push(E.parse(this));
            else for (m = 0; m < e; m++) this._rawo ? this[t][m].write() : this.size += this[t][m].getLength();
          }, E.prototype._readField = function(t, e) {
            switch (t) {
              case "uint":
                return this._readUint(e);
              case "int":
                return this._readInt(e);
              case "template":
                return this._readTemplate(e);
              case "string":
                return e === -1 ? this._readTerminatedString() : this._readString(e);
              case "data":
                return this._readData(e);
              case "utf8":
                return this._readUTF8String();
              default:
                return -1;
            }
          }, E.prototype._readInt = function(t) {
            var e = null, m = this._cursor.offset - this._raw.byteOffset;
            switch (t) {
              case 8:
                e = this._raw.getInt8(m);
                break;
              case 16:
                e = this._raw.getInt16(m);
                break;
              case 32:
                e = this._raw.getInt32(m);
                break;
              case 64:
                var p = this._raw.getInt32(m), l = this._raw.getInt32(m + 4);
                e = p * Math.pow(2, 32) + l;
            }
            return this._cursor.offset += t >> 3, e;
          }, E.prototype._readUint = function(t) {
            var e, m, p = null, l = this._cursor.offset - this._raw.byteOffset;
            switch (t) {
              case 8:
                p = this._raw.getUint8(l);
                break;
              case 16:
                p = this._raw.getUint16(l);
                break;
              case 24:
                p = ((e = this._raw.getUint16(l)) << 8) + (m = this._raw.getUint8(l + 2));
                break;
              case 32:
                p = this._raw.getUint32(l);
                break;
              case 64:
                e = this._raw.getUint32(l), m = this._raw.getUint32(l + 4), p = e * Math.pow(2, 32) + m;
            }
            return this._cursor.offset += t >> 3, p;
          }, E.prototype._readString = function(t) {
            for (var e = "", m = 0; m < t; m++) {
              var p = this._readUint(8);
              e += String.fromCharCode(p);
            }
            return e;
          }, E.prototype._readTemplate = function(t) {
            return this._readUint(t / 2) + this._readUint(t / 2) / Math.pow(2, t / 2);
          }, E.prototype._readTerminatedString = function() {
            for (var t = ""; this._cursor.offset - this._offset < this._raw.byteLength; ) {
              var e = this._readUint(8);
              if (e === 0) break;
              t += String.fromCharCode(e);
            }
            return t;
          }, E.prototype._readData = function(t) {
            var e = t > 0 ? t : this._raw.byteLength - (this._cursor.offset - this._offset);
            if (e > 0) {
              var m = new Uint8Array(this._raw.buffer, this._cursor.offset, e);
              return this._cursor.offset += e, m;
            }
            return null;
          }, E.prototype._readUTF8String = function() {
            var t = this._raw.byteLength - (this._cursor.offset - this._offset), e = null;
            return t > 0 && (e = new DataView(this._raw.buffer, this._cursor.offset, t), this._cursor.offset += t), e && R.Utils.dataViewToString(e);
          }, E.prototype._parseBox = function() {
            if (this._parsing = !0, this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength) this._root._incomplete = !0;
            else {
              switch (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this.size) {
                case 0:
                  this._raw = new DataView(this._raw.buffer, this._offset);
                  break;
                case 1:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                  break;
                default:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
              }
              this._incomplete || (this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1 ? this._parseContainerBox() : this._data = this._readData());
            }
          }, E.prototype._parseFullBox = function() {
            this.version = this._readUint(8), this.flags = this._readUint(24);
          }, E.prototype._parseContainerBox = function() {
            for (this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; ) this.boxes.push(E.parse(this));
          }, E.prototype.append = function(t, e) {
            R.Utils.appendBox(this, t, e);
          }, E.prototype.getLength = function() {
            if (this._parsing = !1, this._rawo = null, this.size = 0, this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1) for (var t = 0; t < this.boxes.length; t++) this.size += this.boxes[t].getLength();
            return this._data && this._writeData(this._data), this.size;
          }, E.prototype.write = function() {
            switch (this._parsing = !1, this._cursor.offset = this._parent._cursor.offset, this.size) {
              case 0:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.parent._rawo.byteLength - this._cursor.offset);
                break;
              case 1:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
                break;
              default:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
            }
            if (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1) for (var t = 0; t < this.boxes.length; t++) this.boxes[t].write();
            return this._data && this._writeData(this._data), this._parent._cursor.offset += this.size, this.size;
          }, E.prototype._writeInt = function(t, e) {
            if (this._rawo) {
              var m = this._cursor.offset - this._rawo.byteOffset;
              switch (t) {
                case 8:
                  this._rawo.setInt8(m, e);
                  break;
                case 16:
                  this._rawo.setInt16(m, e);
                  break;
                case 32:
                  this._rawo.setInt32(m, e);
                  break;
                case 64:
                  var p = Math.floor(e / Math.pow(2, 32)), l = e - p * Math.pow(2, 32);
                  this._rawo.setUint32(m, p), this._rawo.setUint32(m + 4, l);
              }
              this._cursor.offset += t >> 3;
            } else this.size += t >> 3;
          }, E.prototype._writeUint = function(t, e) {
            if (this._rawo) {
              var m, p, l = this._cursor.offset - this._rawo.byteOffset;
              switch (t) {
                case 8:
                  this._rawo.setUint8(l, e);
                  break;
                case 16:
                  this._rawo.setUint16(l, e);
                  break;
                case 24:
                  m = (16776960 & e) >> 8, p = 255 & e, this._rawo.setUint16(l, m), this._rawo.setUint8(l + 2, p);
                  break;
                case 32:
                  this._rawo.setUint32(l, e);
                  break;
                case 64:
                  p = e - (m = Math.floor(e / Math.pow(2, 32))) * Math.pow(2, 32), this._rawo.setUint32(l, m), this._rawo.setUint32(l + 4, p);
              }
              this._cursor.offset += t >> 3;
            } else this.size += t >> 3;
          }, E.prototype._writeString = function(t, e) {
            for (var m = 0; m < t; m++) this._writeUint(8, e.charCodeAt(m));
          }, E.prototype._writeTerminatedString = function(t) {
            if (t.length !== 0) {
              for (var e = 0; e < t.length; e++) this._writeUint(8, t.charCodeAt(e));
              this._writeUint(8, 0);
            }
          }, E.prototype._writeTemplate = function(t, e) {
            var m = Math.floor(e), p = (e - m) * Math.pow(2, t / 2);
            this._writeUint(t / 2, m), this._writeUint(t / 2, p);
          }, E.prototype._writeData = function(t) {
            if (t) if (this._rawo) {
              if (t instanceof Array) {
                for (var e = this._cursor.offset - this._rawo.byteOffset, m = 0; m < t.length; m++) this._rawo.setInt8(e + m, t[m]);
                this._cursor.offset += t.length;
              }
              t instanceof Uint8Array && (this._root.bytes.set(t, this._cursor.offset), this._cursor.offset += t.length);
            } else this.size += t.length;
          }, E.prototype._writeUTF8String = function(t) {
            var e = R.Utils.utf8ToByteArray(t);
            if (this._rawo) for (var m = new DataView(this._rawo.buffer, this._cursor.offset, e.length), p = 0; p < e.length; p++) m.setUint8(p, e[p]);
            else this.size += e.length;
          }, E.prototype._writeField = function(t, e, m) {
            switch (t) {
              case "uint":
                this._writeUint(e, m);
                break;
              case "int":
                this._writeInt(e, m);
                break;
              case "template":
                this._writeTemplate(e, m);
                break;
              case "string":
                e == -1 ? this._writeTerminatedString(m) : this._writeString(e, m);
                break;
              case "data":
                this._writeData(m);
                break;
              case "utf8":
                this._writeUTF8String(m);
            }
          }, E.prototype._boxProcessors.avc1 = E.prototype._boxProcessors.avc2 = E.prototype._boxProcessors.avc3 = E.prototype._boxProcessors.avc4 = E.prototype._boxProcessors.hvc1 = E.prototype._boxProcessors.hev1 = E.prototype._boxProcessors.encv = function() {
            this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procField("pre_defined1", "uint", 16), this._procField("reserved2", "uint", 16), this._procFieldArray("pre_defined2", 3, "uint", 32), this._procField("width", "uint", 16), this._procField("height", "uint", 16), this._procField("horizresolution", "template", 32), this._procField("vertresolution", "template", 32), this._procField("reserved3", "uint", 32), this._procField("frame_count", "uint", 16), this._procFieldArray("compressorname", 32, "uint", 8), this._procField("depth", "uint", 16), this._procField("pre_defined3", "int", 16), this._procField("config", "data", -1);
          }, E.prototype._boxProcessors.ctts = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_count", "uint", 32), this._procEntryField(t, "sample_offset", this.version === 1 ? "int" : "uint", 32);
            });
          }, E.prototype._boxProcessors.dref = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
          }, E.prototype._boxProcessors.elst = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "segment_duration", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "media_time", "int", this.version === 1 ? 64 : 32), this._procEntryField(t, "media_rate_integer", "int", 16), this._procEntryField(t, "media_rate_fraction", "int", 16);
            });
          }, E.prototype._boxProcessors.emsg = function() {
            this._procFullBox(), this.version == 1 ? (this._procField("timescale", "uint", 32), this._procField("presentation_time", "uint", 64), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32), this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1)) : (this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1), this._procField("timescale", "uint", 32), this._procField("presentation_time_delta", "uint", 32), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32)), this._procField("message_data", "data", -1);
          }, E.prototype._boxProcessors.free = E.prototype._boxProcessors.skip = function() {
            this._procField("data", "data", -1);
          }, E.prototype._boxProcessors.frma = function() {
            this._procField("data_format", "uint", 32);
          }, E.prototype._boxProcessors.ftyp = E.prototype._boxProcessors.styp = function() {
            this._procField("major_brand", "string", 4), this._procField("minor_version", "uint", 32);
            var t = -1;
            this._parsing && (t = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4), this._procFieldArray("compatible_brands", t, "string", 4);
          }, E.prototype._boxProcessors.hdlr = function() {
            this._procFullBox(), this._procField("pre_defined", "uint", 32), this._procField("handler_type", "string", 4), this._procFieldArray("reserved", 3, "uint", 32), this._procField("name", "string", -1);
          }, E.prototype._boxProcessors.mdat = function() {
            this._procField("data", "data", -1);
          }, E.prototype._boxProcessors.mdhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._parsing || typeof this.language != "string" || (this.language = this.language.charCodeAt(0) - 96 << 10 | this.language.charCodeAt(1) - 96 << 5 | this.language.charCodeAt(2) - 96), this._procField("language", "uint", 16), this._parsing && (this.language = String.fromCharCode(96 + (this.language >> 10 & 31), 96 + (this.language >> 5 & 31), 96 + (31 & this.language))), this._procField("pre_defined", "uint", 16);
          }, E.prototype._boxProcessors.mehd = function() {
            this._procFullBox(), this._procField("fragment_duration", "uint", this.version == 1 ? 64 : 32);
          }, E.prototype._boxProcessors.mfhd = function() {
            this._procFullBox(), this._procField("sequence_number", "uint", 32);
          }, E.prototype._boxProcessors.mfro = function() {
            this._procFullBox(), this._procField("mfra_size", "uint", 32);
          }, E.prototype._boxProcessors.mp4a = E.prototype._boxProcessors.enca = function() {
            this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("channelcount", "uint", 16), this._procField("samplesize", "uint", 16), this._procField("pre_defined", "uint", 16), this._procField("reserved3", "uint", 16), this._procField("samplerate", "template", 32), this._procField("esds", "data", -1);
          }, E.prototype._boxProcessors.mvhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procField("rate", "template", 32), this._procField("volume", "template", 16), this._procField("reserved1", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procFieldArray("matrix", 9, "template", 32), this._procFieldArray("pre_defined", 6, "uint", 32), this._procField("next_track_ID", "uint", 32);
          }, E.prototype._boxProcessors.payl = function() {
            this._procField("cue_text", "utf8");
          }, E.prototype._boxProcessors.prft = function() {
            this._procFullBox(), this._procField("reference_track_ID", "uint", 32), this._procField("ntp_timestamp_sec", "uint", 32), this._procField("ntp_timestamp_frac", "uint", 32), this._procField("media_time", "uint", this.version == 1 ? 64 : 32);
          }, E.prototype._boxProcessors.pssh = function() {
            this._procFullBox(), this._procFieldArray("SystemID", 16, "uint", 8), this._procField("DataSize", "uint", 32), this._procFieldArray("Data", this.DataSize, "uint", 8);
          }, E.prototype._boxProcessors.schm = function() {
            this._procFullBox(), this._procField("scheme_type", "uint", 32), this._procField("scheme_version", "uint", 32), 1 & this.flags && this._procField("scheme_uri", "string", -1);
          }, E.prototype._boxProcessors.sdtp = function() {
            this._procFullBox();
            var t = -1;
            this._parsing && (t = this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)), this._procFieldArray("sample_dependency_table", t, "uint", 8);
          }, E.prototype._boxProcessors.sidx = function() {
            this._procFullBox(), this._procField("reference_ID", "uint", 32), this._procField("timescale", "uint", 32), this._procField("earliest_presentation_time", "uint", this.version == 1 ? 64 : 32), this._procField("first_offset", "uint", this.version == 1 ? 64 : 32), this._procField("reserved", "uint", 16), this._procField("reference_count", "uint", 16), this._procEntries("references", this.reference_count, function(t) {
              this._parsing || (t.reference = (1 & t.reference_type) << 31, t.reference |= 2147483647 & t.referenced_size, t.sap = (1 & t.starts_with_SAP) << 31, t.sap |= (3 & t.SAP_type) << 28, t.sap |= 268435455 & t.SAP_delta_time), this._procEntryField(t, "reference", "uint", 32), this._procEntryField(t, "subsegment_duration", "uint", 32), this._procEntryField(t, "sap", "uint", 32), this._parsing && (t.reference_type = t.reference >> 31 & 1, t.referenced_size = 2147483647 & t.reference, t.starts_with_SAP = t.sap >> 31 & 1, t.SAP_type = t.sap >> 28 & 7, t.SAP_delta_time = 268435455 & t.sap);
            });
          }, E.prototype._boxProcessors.smhd = function() {
            this._procFullBox(), this._procField("balance", "uint", 16), this._procField("reserved", "uint", 16);
          }, E.prototype._boxProcessors.ssix = function() {
            this._procFullBox(), this._procField("subsegment_count", "uint", 32), this._procEntries("subsegments", this.subsegment_count, function(t) {
              this._procEntryField(t, "ranges_count", "uint", 32), this._procSubEntries(t, "ranges", t.ranges_count, function(e) {
                this._procEntryField(e, "level", "uint", 8), this._procEntryField(e, "range_size", "uint", 24);
              });
            });
          }, E.prototype._boxProcessors.stsd = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
          }, E.prototype._boxProcessors.sttg = function() {
            this._procField("settings", "utf8");
          }, E.prototype._boxProcessors.stts = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_count", "uint", 32), this._procEntryField(t, "sample_delta", "uint", 32);
            });
          }, E.prototype._boxProcessors.subs = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_delta", "uint", 32), this._procEntryField(t, "subsample_count", "uint", 16), this._procSubEntries(t, "subsamples", t.subsample_count, function(e) {
                this._procEntryField(e, "subsample_size", "uint", this.version === 1 ? 32 : 16), this._procEntryField(e, "subsample_priority", "uint", 8), this._procEntryField(e, "discardable", "uint", 8), this._procEntryField(e, "codec_specific_parameters", "uint", 32);
              });
            });
          }, E.prototype._boxProcessors.tenc = function() {
            this._procFullBox(), this._procField("default_IsEncrypted", "uint", 24), this._procField("default_IV_size", "uint", 8), this._procFieldArray("default_KID", 16, "uint", 8);
          }, E.prototype._boxProcessors.tfdt = function() {
            this._procFullBox(), this._procField("baseMediaDecodeTime", "uint", this.version == 1 ? 64 : 32);
          }, E.prototype._boxProcessors.tfhd = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), 1 & this.flags && this._procField("base_data_offset", "uint", 64), 2 & this.flags && this._procField("sample_description_offset", "uint", 32), 8 & this.flags && this._procField("default_sample_duration", "uint", 32), 16 & this.flags && this._procField("default_sample_size", "uint", 32), 32 & this.flags && this._procField("default_sample_flags", "uint", 32);
          }, E.prototype._boxProcessors.tfra = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), this._parsing || (this.reserved = 0, this.reserved |= (48 & this.length_size_of_traf_num) << 4, this.reserved |= (12 & this.length_size_of_trun_num) << 2, this.reserved |= 3 & this.length_size_of_sample_num), this._procField("reserved", "uint", 32), this._parsing && (this.length_size_of_traf_num = (48 & this.reserved) >> 4, this.length_size_of_trun_num = (12 & this.reserved) >> 2, this.length_size_of_sample_num = 3 & this.reserved), this._procField("number_of_entry", "uint", 32), this._procEntries("entries", this.number_of_entry, function(t) {
              this._procEntryField(t, "time", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "moof_offset", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "traf_number", "uint", 8 * (this.length_size_of_traf_num + 1)), this._procEntryField(t, "trun_number", "uint", 8 * (this.length_size_of_trun_num + 1)), this._procEntryField(t, "sample_number", "uint", 8 * (this.length_size_of_sample_num + 1));
            });
          }, E.prototype._boxProcessors.tkhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("track_ID", "uint", 32), this._procField("reserved1", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("layer", "uint", 16), this._procField("alternate_group", "uint", 16), this._procField("volume", "template", 16), this._procField("reserved3", "uint", 16), this._procFieldArray("matrix", 9, "template", 32), this._procField("width", "template", 32), this._procField("height", "template", 32);
          }, E.prototype._boxProcessors.trex = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), this._procField("default_sample_description_index", "uint", 32), this._procField("default_sample_duration", "uint", 32), this._procField("default_sample_size", "uint", 32), this._procField("default_sample_flags", "uint", 32);
          }, E.prototype._boxProcessors.trun = function() {
            this._procFullBox(), this._procField("sample_count", "uint", 32), 1 & this.flags && this._procField("data_offset", "int", 32), 4 & this.flags && this._procField("first_sample_flags", "uint", 32), this._procEntries("samples", this.sample_count, function(t) {
              256 & this.flags && this._procEntryField(t, "sample_duration", "uint", 32), 512 & this.flags && this._procEntryField(t, "sample_size", "uint", 32), 1024 & this.flags && this._procEntryField(t, "sample_flags", "uint", 32), 2048 & this.flags && this._procEntryField(t, "sample_composition_time_offset", this.version === 1 ? "int" : "uint", 32);
            });
          }, E.prototype._boxProcessors["url "] = E.prototype._boxProcessors["urn "] = function() {
            this._procFullBox(), this.type === "urn " && this._procField("name", "string", -1), this._procField("location", "string", -1);
          }, E.prototype._boxProcessors.vlab = function() {
            this._procField("source_label", "utf8");
          }, E.prototype._boxProcessors.vmhd = function() {
            this._procFullBox(), this._procField("graphicsmode", "uint", 16), this._procFieldArray("opcolor", 3, "uint", 16);
          }, E.prototype._boxProcessors.vttC = function() {
            this._procField("config", "utf8");
          }, E.prototype._boxProcessors.vtte = function() {
          };
        }, 5530: function(Se, ge, R) {
          Se.exports = R(6146).polyfill();
        }, 6146: function(Se, ge, R) {
          Se.exports = function() {
            function te(Ve) {
              return typeof Ve == "function";
            }
            var E = Array.isArray ? Array.isArray : function(Ve) {
              return Object.prototype.toString.call(Ve) === "[object Array]";
            }, t = 0, e = void 0, m = void 0, p = function(Ve, ot) {
              S[t] = Ve, S[t + 1] = ot, (t += 2) === 2 && (m ? m(x) : W());
            }, l = typeof window < "u" ? window : void 0, v = l || {}, h = v.MutationObserver || v.WebKitMutationObserver, n = typeof self > "u" && typeof process < "u" && {}.toString.call(process) === "[object process]", f = typeof Uint8ClampedArray < "u" && typeof importScripts < "u" && typeof MessageChannel < "u";
            function d() {
              var Ve = setTimeout;
              return function() {
                return Ve(x, 1);
              };
            }
            var S = new Array(1e3);
            function x() {
              for (var Ve = 0; Ve < t; Ve += 2) (0, S[Ve])(S[Ve + 1]), S[Ve] = void 0, S[Ve + 1] = void 0;
              t = 0;
            }
            var G, P, J, M, W = void 0;
            function se(Ve, ot) {
              var Ee = this, Te = new this.constructor(ce);
              Te[re] === void 0 && Be(Te);
              var je = Ee._state;
              if (je) {
                var c = arguments[je - 1];
                p(function() {
                  return at(je, Te, c, Ee._result);
                });
              } else Ze(Ee, Te, Ve, ot);
              return Te;
            }
            function j(Ve) {
              if (Ve && typeof Ve == "object" && Ve.constructor === this) return Ve;
              var ot = new this(ce);
              return Me(ot, Ve), ot;
            }
            W = n ? function() {
              return process.nextTick(x);
            } : h ? (P = 0, J = new h(x), M = document.createTextNode(""), J.observe(M, { characterData: !0 }), function() {
              M.data = P = ++P % 2;
            }) : f ? ((G = new MessageChannel()).port1.onmessage = x, function() {
              return G.port2.postMessage(0);
            }) : l === void 0 ? function() {
              try {
                var Ve = Function("return this")().require("vertx");
                return (e = Ve.runOnLoop || Ve.runOnContext) !== void 0 ? function() {
                  e(x);
                } : d();
              } catch {
                return d();
              }
            }() : d();
            var re = Math.random().toString(36).substring(2);
            function ce() {
            }
            var Re = void 0;
            function $(Ve, ot, Ee) {
              ot.constructor === Ve.constructor && Ee === se && ot.constructor.resolve === j ? function(Te, je) {
                je._state === 1 ? Qe(Te, je._result) : je._state === 2 ? Ae(Te, je._result) : Ze(je, void 0, function(c) {
                  return Me(Te, c);
                }, function(c) {
                  return Ae(Te, c);
                });
              }(Ve, ot) : Ee === void 0 ? Qe(Ve, ot) : te(Ee) ? function(Te, je, c) {
                p(function(o) {
                  var T = !1, b = function(X, z, De, tt) {
                    try {
                      X.call(z, De, tt);
                    } catch (Ue) {
                      return Ue;
                    }
                  }(c, je, function(X) {
                    T || (T = !0, je !== X ? Me(o, X) : Qe(o, X));
                  }, function(X) {
                    T || (T = !0, Ae(o, X));
                  }, o._label);
                  !T && b && (T = !0, Ae(o, b));
                }, Te);
              }(Ve, ot, Ee) : Qe(Ve, ot);
            }
            function Me(Ve, ot) {
              if (Ve === ot) Ae(Ve, new TypeError("You cannot resolve a promise with itself"));
              else if (je = typeof (Te = ot), Te === null || je !== "object" && je !== "function") Qe(Ve, ot);
              else {
                var Ee = void 0;
                try {
                  Ee = ot.then;
                } catch (c) {
                  return void Ae(Ve, c);
                }
                $(Ve, ot, Ee);
              }
              var Te, je;
            }
            function Ge(Ve) {
              Ve._onerror && Ve._onerror(Ve._result), Xe(Ve);
            }
            function Qe(Ve, ot) {
              Ve._state === Re && (Ve._result = ot, Ve._state = 1, Ve._subscribers.length !== 0 && p(Xe, Ve));
            }
            function Ae(Ve, ot) {
              Ve._state === Re && (Ve._state = 2, Ve._result = ot, p(Ge, Ve));
            }
            function Ze(Ve, ot, Ee, Te) {
              var je = Ve._subscribers, c = je.length;
              Ve._onerror = null, je[c] = ot, je[c + 1] = Ee, je[c + 2] = Te, c === 0 && Ve._state && p(Xe, Ve);
            }
            function Xe(Ve) {
              var ot = Ve._subscribers, Ee = Ve._state;
              if (ot.length !== 0) {
                for (var Te = void 0, je = void 0, c = Ve._result, o = 0; o < ot.length; o += 3) Te = ot[o], je = ot[o + Ee], Te ? at(Ee, Te, je, c) : je(c);
                Ve._subscribers.length = 0;
              }
            }
            function at(Ve, ot, Ee, Te) {
              var je = te(Ee), c = void 0, o = void 0, T = !0;
              if (je) {
                try {
                  c = Ee(Te);
                } catch (b) {
                  T = !1, o = b;
                }
                if (ot === c) return void Ae(ot, new TypeError("A promises callback cannot return that same promise."));
              } else c = Te;
              ot._state !== Re || (je && T ? Me(ot, c) : T === !1 ? Ae(ot, o) : Ve === 1 ? Qe(ot, c) : Ve === 2 && Ae(ot, c));
            }
            var Ie = 0;
            function Be(Ve) {
              Ve[re] = Ie++, Ve._state = void 0, Ve._result = void 0, Ve._subscribers = [];
            }
            var It = function() {
              function Ve(ot, Ee) {
                this._instanceConstructor = ot, this.promise = new ot(ce), this.promise[re] || Be(this.promise), E(Ee) ? (this.length = Ee.length, this._remaining = Ee.length, this._result = new Array(this.length), this.length === 0 ? Qe(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(Ee), this._remaining === 0 && Qe(this.promise, this._result))) : Ae(this.promise, new Error("Array Methods must be provided an Array"));
              }
              return Ve.prototype._enumerate = function(ot) {
                for (var Ee = 0; this._state === Re && Ee < ot.length; Ee++) this._eachEntry(ot[Ee], Ee);
              }, Ve.prototype._eachEntry = function(ot, Ee) {
                var Te = this._instanceConstructor, je = Te.resolve;
                if (je === j) {
                  var c = void 0, o = void 0, T = !1;
                  try {
                    c = ot.then;
                  } catch (X) {
                    T = !0, o = X;
                  }
                  if (c === se && ot._state !== Re) this._settledAt(ot._state, Ee, ot._result);
                  else if (typeof c != "function") this._remaining--, this._result[Ee] = ot;
                  else if (Te === _t) {
                    var b = new Te(ce);
                    T ? Ae(b, o) : $(b, ot, c), this._willSettleAt(b, Ee);
                  } else this._willSettleAt(new Te(function(X) {
                    return X(ot);
                  }), Ee);
                } else this._willSettleAt(je(ot), Ee);
              }, Ve.prototype._settledAt = function(ot, Ee, Te) {
                var je = this.promise;
                je._state === Re && (this._remaining--, ot === 2 ? Ae(je, Te) : this._result[Ee] = Te), this._remaining === 0 && Qe(je, this._result);
              }, Ve.prototype._willSettleAt = function(ot, Ee) {
                var Te = this;
                Ze(ot, void 0, function(je) {
                  return Te._settledAt(1, Ee, je);
                }, function(je) {
                  return Te._settledAt(2, Ee, je);
                });
              }, Ve;
            }(), _t = function() {
              function Ve(ot) {
                this[re] = Ie++, this._result = this._state = void 0, this._subscribers = [], ce !== ot && (typeof ot != "function" && function() {
                  throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }(), this instanceof Ve ? function(Ee, Te) {
                  try {
                    Te(function(je) {
                      Me(Ee, je);
                    }, function(je) {
                      Ae(Ee, je);
                    });
                  } catch (je) {
                    Ae(Ee, je);
                  }
                }(this, ot) : function() {
                  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }());
              }
              return Ve.prototype.catch = function(ot) {
                return this.then(null, ot);
              }, Ve.prototype.finally = function(ot) {
                var Ee = this, Te = Ee.constructor;
                return te(ot) ? Ee.then(function(je) {
                  return Te.resolve(ot()).then(function() {
                    return je;
                  });
                }, function(je) {
                  return Te.resolve(ot()).then(function() {
                    throw je;
                  });
                }) : Ee.then(ot, ot);
              }, Ve;
            }();
            return _t.prototype.then = se, _t.all = function(Ve) {
              return new It(this, Ve).promise;
            }, _t.race = function(Ve) {
              var ot = this;
              return E(Ve) ? new ot(function(Ee, Te) {
                for (var je = Ve.length, c = 0; c < je; c++) ot.resolve(Ve[c]).then(Ee, Te);
              }) : new ot(function(Ee, Te) {
                return Te(new TypeError("You must pass an array to race."));
              });
            }, _t.resolve = j, _t.reject = function(Ve) {
              var ot = new this(ce);
              return Ae(ot, Ve), ot;
            }, _t._setScheduler = function(Ve) {
              m = Ve;
            }, _t._setAsap = function(Ve) {
              p = Ve;
            }, _t._asap = p, _t.polyfill = function() {
              var Ve = void 0;
              if (R.g !== void 0) Ve = R.g;
              else if (typeof self < "u") Ve = self;
              else try {
                Ve = Function("return this")();
              } catch {
                throw new Error("polyfill failed because global object is unavailable in this environment");
              }
              var ot = Ve.Promise;
              if (ot) {
                var Ee = null;
                try {
                  Ee = Object.prototype.toString.call(ot.resolve());
                } catch {
                }
                if (Ee === "[object Promise]" && !ot.cast) return;
              }
              Ve.Promise = _t;
            }, _t.Promise = _t, _t;
          }();
        }, 1159: function(Se) {
          var ge, R = typeof Reflect == "object" ? Reflect : null, te = R && typeof R.apply == "function" ? R.apply : function(x, G, P) {
            return Function.prototype.apply.call(x, G, P);
          };
          ge = R && typeof R.ownKeys == "function" ? R.ownKeys : Object.getOwnPropertySymbols ? function(x) {
            return Object.getOwnPropertyNames(x).concat(Object.getOwnPropertySymbols(x));
          } : function(x) {
            return Object.getOwnPropertyNames(x);
          };
          var E = Number.isNaN || function(x) {
            return x != x;
          };
          function t() {
            t.init.call(this);
          }
          Se.exports = t, Se.exports.once = function(x, G) {
            return new Promise(function(P, J) {
              function M(se) {
                x.removeListener(G, W), J(se);
              }
              function W() {
                typeof x.removeListener == "function" && x.removeListener("error", M), P([].slice.call(arguments));
              }
              S(x, G, W, { once: !0 }), G !== "error" && function(se, j, re) {
                typeof se.on == "function" && S(se, "error", j, { once: !0 });
              }(x, M);
            });
          }, t.EventEmitter = t, t.prototype._events = void 0, t.prototype._eventsCount = 0, t.prototype._maxListeners = void 0;
          var e = 10;
          function m(x) {
            if (typeof x != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof x);
          }
          function p(x) {
            return x._maxListeners === void 0 ? t.defaultMaxListeners : x._maxListeners;
          }
          function l(x, G, P, J) {
            var M, W, se, j;
            if (m(P), (W = x._events) === void 0 ? (W = x._events = /* @__PURE__ */ Object.create(null), x._eventsCount = 0) : (W.newListener !== void 0 && (x.emit("newListener", G, P.listener ? P.listener : P), W = x._events), se = W[G]), se === void 0) se = W[G] = P, ++x._eventsCount;
            else if (typeof se == "function" ? se = W[G] = J ? [P, se] : [se, P] : J ? se.unshift(P) : se.push(P), (M = p(x)) > 0 && se.length > M && !se.warned) {
              se.warned = !0;
              var re = new Error("Possible EventEmitter memory leak detected. " + se.length + " " + String(G) + " listeners added. Use emitter.setMaxListeners() to increase limit");
              re.name = "MaxListenersExceededWarning", re.emitter = x, re.type = G, re.count = se.length, j = re, console && console.warn && console.warn(j);
            }
            return x;
          }
          function v() {
            if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
          }
          function h(x, G, P) {
            var J = { fired: !1, wrapFn: void 0, target: x, type: G, listener: P }, M = v.bind(J);
            return M.listener = P, J.wrapFn = M, M;
          }
          function n(x, G, P) {
            var J = x._events;
            if (J === void 0) return [];
            var M = J[G];
            return M === void 0 ? [] : typeof M == "function" ? P ? [M.listener || M] : [M] : P ? function(W) {
              for (var se = new Array(W.length), j = 0; j < se.length; ++j) se[j] = W[j].listener || W[j];
              return se;
            }(M) : d(M, M.length);
          }
          function f(x) {
            var G = this._events;
            if (G !== void 0) {
              var P = G[x];
              if (typeof P == "function") return 1;
              if (P !== void 0) return P.length;
            }
            return 0;
          }
          function d(x, G) {
            for (var P = new Array(G), J = 0; J < G; ++J) P[J] = x[J];
            return P;
          }
          function S(x, G, P, J) {
            if (typeof x.on == "function") J.once ? x.once(G, P) : x.on(G, P);
            else {
              if (typeof x.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof x);
              x.addEventListener(G, function M(W) {
                J.once && x.removeEventListener(G, M), P(W);
              });
            }
          }
          Object.defineProperty(t, "defaultMaxListeners", { enumerable: !0, get: function() {
            return e;
          }, set: function(x) {
            if (typeof x != "number" || x < 0 || E(x)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + x + ".");
            e = x;
          } }), t.init = function() {
            this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
          }, t.prototype.setMaxListeners = function(x) {
            if (typeof x != "number" || x < 0 || E(x)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + x + ".");
            return this._maxListeners = x, this;
          }, t.prototype.getMaxListeners = function() {
            return p(this);
          }, t.prototype.emit = function(x) {
            for (var G = [], P = 1; P < arguments.length; P++) G.push(arguments[P]);
            var J = x === "error", M = this._events;
            if (M !== void 0) J = J && M.error === void 0;
            else if (!J) return !1;
            if (J) {
              var W;
              if (G.length > 0 && (W = G[0]), W instanceof Error) throw W;
              var se = new Error("Unhandled error." + (W ? " (" + W.message + ")" : ""));
              throw se.context = W, se;
            }
            var j = M[x];
            if (j === void 0) return !1;
            if (typeof j == "function") te(j, this, G);
            else {
              var re = j.length, ce = d(j, re);
              for (P = 0; P < re; ++P) te(ce[P], this, G);
            }
            return !0;
          }, t.prototype.addListener = function(x, G) {
            return l(this, x, G, !1);
          }, t.prototype.on = t.prototype.addListener, t.prototype.prependListener = function(x, G) {
            return l(this, x, G, !0);
          }, t.prototype.once = function(x, G) {
            return m(G), this.on(x, h(this, x, G)), this;
          }, t.prototype.prependOnceListener = function(x, G) {
            return m(G), this.prependListener(x, h(this, x, G)), this;
          }, t.prototype.removeListener = function(x, G) {
            var P, J, M, W, se;
            if (m(G), (J = this._events) === void 0) return this;
            if ((P = J[x]) === void 0) return this;
            if (P === G || P.listener === G) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete J[x], J.removeListener && this.emit("removeListener", x, P.listener || G));
            else if (typeof P != "function") {
              for (M = -1, W = P.length - 1; W >= 0; W--) if (P[W] === G || P[W].listener === G) {
                se = P[W].listener, M = W;
                break;
              }
              if (M < 0) return this;
              M === 0 ? P.shift() : function(j, re) {
                for (; re + 1 < j.length; re++) j[re] = j[re + 1];
                j.pop();
              }(P, M), P.length === 1 && (J[x] = P[0]), J.removeListener !== void 0 && this.emit("removeListener", x, se || G);
            }
            return this;
          }, t.prototype.off = t.prototype.removeListener, t.prototype.removeAllListeners = function(x) {
            var G, P, J;
            if ((P = this._events) === void 0) return this;
            if (P.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : P[x] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete P[x]), this;
            if (arguments.length === 0) {
              var M, W = Object.keys(P);
              for (J = 0; J < W.length; ++J) (M = W[J]) !== "removeListener" && this.removeAllListeners(M);
              return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
            }
            if (typeof (G = P[x]) == "function") this.removeListener(x, G);
            else if (G !== void 0) for (J = G.length - 1; J >= 0; J--) this.removeListener(x, G[J]);
            return this;
          }, t.prototype.listeners = function(x) {
            return n(this, x, !0);
          }, t.prototype.rawListeners = function(x) {
            return n(this, x, !1);
          }, t.listenerCount = function(x, G) {
            return typeof x.listenerCount == "function" ? x.listenerCount(G) : f.call(x, G);
          }, t.prototype.listenerCount = f, t.prototype.eventNames = function() {
            return this._eventsCount > 0 ? ge(this._events) : [];
          };
        }, 3101: function(Se) {
          var ge = Array.isArray, R = Object.keys, te = Object.prototype.hasOwnProperty;
          Se.exports = function E(t, e) {
            if (t === e) return !0;
            if (t && e && typeof t == "object" && typeof e == "object") {
              var m, p, l, v = ge(t), h = ge(e);
              if (v && h) {
                if ((p = t.length) != e.length) return !1;
                for (m = p; m-- != 0; ) if (!E(t[m], e[m])) return !1;
                return !0;
              }
              if (v != h) return !1;
              var n = t instanceof Date, f = e instanceof Date;
              if (n != f) return !1;
              if (n && f) return t.getTime() == e.getTime();
              var d = t instanceof RegExp, S = e instanceof RegExp;
              if (d != S) return !1;
              if (d && S) return t.toString() == e.toString();
              var x = R(t);
              if ((p = x.length) !== R(e).length) return !1;
              for (m = p; m-- != 0; ) if (!te.call(e, x[m])) return !1;
              for (m = p; m-- != 0; ) if (!E(t[l = x[m]], e[l])) return !1;
              return !0;
            }
            return t != t && e != e;
          };
        }, 3362: function(Se, ge, R) {
          (function(te, E, t, e, m) {
            function p(o) {
              if ("contents" in o) for (var T = ("styleAttrs" in o) ? o.styleAttrs[e.byName.ruby.qname] : null, b = o.kind === "span" && (T === "container" || T === "textContainer" || T === "baseContainer"), X = o.contents.length - 1; X >= 0; X--) !b || "styleAttrs" in o.contents[X] && e.byName.ruby.qname in o.contents[X].styleAttrs ? p(o.contents[X]) : delete o.contents[X];
            }
            function l(o, T, b, X) {
              var z = X && X.timeContainer === "seq", De = 0;
              X && (De = z && b ? b.end : X.begin), T.begin = T.explicit_begin ? T.explicit_begin + De : De;
              var tt = T.begin, Ue = null;
              if ("sets" in T) for (var ke = 0; ke < T.sets.length; ke++) l(o, T.sets[ke], Ue, T), tt = T.timeContainer === "seq" ? T.sets[ke].end : Math.max(tt, T.sets[ke].end), Ue = T.sets[ke];
              if ("contents" in T) {
                if ("contents" in T) for (var Oe = 0; Oe < T.contents.length; Oe++) l(o, T.contents[Oe], Ue, T), tt = T.timeContainer === "seq" ? T.contents[Oe].end : Math.max(tt, T.contents[Oe].end), Ue = T.contents[Oe];
              } else tt = z ? T.begin : Number.POSITIVE_INFINITY;
              T.explicit_end !== null && T.explicit_dur !== null ? T.end = Math.min(T.begin + T.explicit_dur, De + T.explicit_end) : T.explicit_end === null && T.explicit_dur !== null ? T.end = T.begin + T.explicit_dur : T.explicit_end !== null && T.explicit_dur === null ? T.end = De + T.explicit_end : T.end = tt, delete T.explicit_begin, delete T.explicit_dur, delete T.explicit_end, o._registerEvent(T);
            }
            function v(o) {
              this.node = o;
            }
            function h() {
              this.events = [], this.head = new n(), this.body = null;
            }
            function n() {
              this.styling = new f(), this.layout = new x();
            }
            function f() {
              this.styles = {}, this.initials = {};
            }
            function d() {
              this.id = null, this.styleAttrs = null, this.styleRefs = null;
            }
            function S() {
              this.styleAttrs = null;
            }
            function x() {
              this.regions = {};
            }
            function G(o, T) {
              P.call(this, "image"), this.src = o, this.type = T;
            }
            function P(o) {
              this.kind = o;
            }
            function J(o) {
              this.id = o;
            }
            function M(o) {
              this.regionID = o;
            }
            function W(o) {
              this.styleAttrs = o;
            }
            function se(o) {
              this.sets = o;
            }
            function j(o) {
              this.contents = o;
            }
            function re(o, T, b) {
              this.explicit_begin = o, this.explicit_end = T, this.explicit_dur = b;
            }
            function ce() {
              P.call(this, "body");
            }
            function Re() {
              P.call(this, "div");
            }
            function $() {
              P.call(this, "p");
            }
            function Me() {
              P.call(this, "span");
            }
            function Ge() {
              P.call(this, "span");
            }
            function Qe() {
              P.call(this, "br");
            }
            function Ae() {
            }
            function Ze() {
            }
            function Xe(o) {
              return o && "xml:id" in o.attributes && o.attributes["xml:id"].value || null;
            }
            function at(o) {
              return o && "style" in o.attributes ? o.attributes.style.value.split(" ") : [];
            }
            function Ie(o, T) {
              var b = {};
              if (o !== null) for (var X in o.attributes) {
                var z = o.attributes[X].uri + " " + o.attributes[X].local, De = e.byQName[z];
                if (De !== void 0) {
                  var tt = De.parse(o.attributes[X].value);
                  tt !== null ? (b[z] = tt, De === e.byName.zIndex && Ee(T, "zIndex attribute present but not used by IMSC1 since regions do not overlap")) : Te(T, "Cannot parse styling attribute " + z + " --> " + o.attributes[X].value);
                }
              }
              return b;
            }
            function Be(o, T, b) {
              for (var X in o.attributes) if (o.attributes[X].uri === T && o.attributes[X].local === b) return o.attributes[X].value;
              return null;
            }
            function It(o, T, b) {
              var X, z = null;
              return (X = /^(\d+(?:\.\d+)?)f$/.exec(b)) !== null ? T !== null && (z = parseFloat(X[1]) / T) : (X = /^(\d+(?:\.\d+)?)t$/.exec(b)) !== null ? o !== null && (z = parseFloat(X[1]) / o) : (X = /^(\d+(?:\.\d+)?)ms$/.exec(b)) !== null ? z = parseFloat(X[1]) / 1e3 : (X = /^(\d+(?:\.\d+)?)s$/.exec(b)) !== null ? z = parseFloat(X[1]) : (X = /^(\d+(?:\.\d+)?)h$/.exec(b)) !== null ? z = 3600 * parseFloat(X[1]) : (X = /^(\d+(?:\.\d+)?)m$/.exec(b)) !== null ? z = 60 * parseFloat(X[1]) : (X = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/.exec(b)) !== null ? z = 3600 * parseInt(X[1]) + 60 * parseInt(X[2]) + parseFloat(X[3]) : (X = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/.exec(b)) !== null && T !== null && (z = 3600 * parseInt(X[1]) + 60 * parseInt(X[2]) + parseInt(X[3]) + (X[4] === null ? 0 : parseInt(X[4]) / T)), z;
            }
            function _t(o, T, b) {
              for (; T.styleRefs.length > 0; ) {
                var X = T.styleRefs.pop();
                X in o.styles ? (_t(o, o.styles[X], b), ot(o.styles[X].styleAttrs, T.styleAttrs)) : Te(b, "Non-existant style id referenced");
              }
            }
            function Ve(o, T, b, X) {
              for (var z = T.length - 1; z >= 0; z--) {
                var De = T[z];
                De in o.styles ? ot(o.styles[De].styleAttrs, b) : Te(X, "Non-existant style id referenced");
              }
            }
            function ot(o, T) {
              for (var b in o) o.hasOwnProperty(b) && (b in T || (T[b] = o[b]));
            }
            function Ee(o, T) {
              if (o && o.warn && o.warn(T)) throw T;
            }
            function Te(o, T) {
              if (o && o.error && o.error(T)) throw T;
            }
            function je(o, T) {
              throw o && o.fatal && o.fatal(T), T;
            }
            function c(o, T) {
              for (var b, X = 0, z = o.length - 1; X <= z; ) {
                var De = o[b = Math.floor((X + z) / 2)];
                if (De < T) X = b + 1;
                else {
                  if (!(De > T)) return { found: !0, index: b };
                  z = b - 1;
                }
              }
              return { found: !1, index: X };
            }
            te.fromXML = function(o, T, b) {
              var X = E.parser(!0, { xmlns: !0 }), z = [], De = [], tt = [], Ue = 0, ke = null;
              X.onclosetag = function(dt) {
                if (z[0] instanceof Ae) ke.head !== null && ke.head.styling !== null && Ve(ke.head.styling, z[0].styleRefs, z[0].styleAttrs, T), delete z[0].styleRefs;
                else if (z[0] instanceof f) for (var Yt in z[0].styles) z[0].styles.hasOwnProperty(Yt) && _t(z[0], z[0].styles[Yt], T);
                else if (z[0] instanceof $ || z[0] instanceof Me) {
                  if (z[0].contents.length > 1) {
                    var Mt, Ht = [z[0].contents[0]];
                    for (Mt = 1; Mt < z[0].contents.length; Mt++) z[0].contents[Mt] instanceof Ge && Ht[Ht.length - 1] instanceof Ge ? Ht[Ht.length - 1].text += z[0].contents[Mt].text : Ht.push(z[0].contents[Mt]);
                    z[0].contents = Ht;
                  }
                  z[0] instanceof Me && z[0].contents.length === 1 && z[0].contents[0] instanceof Ge && (z[0].text = z[0].contents[0].text, delete z[0].contents);
                } else z[0] instanceof v && (z[0].node.uri === t.ns_tt && z[0].node.local === "metadata" ? Ue-- : Ue > 0 && b && "onCloseTag" in b && b.onCloseTag());
                tt.shift(), De.shift(), z.shift();
              }, X.ontext = function(dt) {
                if (z[0] !== void 0) if (z[0] instanceof Me || z[0] instanceof $) {
                  if (z[0] instanceof Me) {
                    var Yt = z[0].styleAttrs[e.byName.ruby.qname];
                    if (Yt === "container" || Yt === "textContainer" || Yt === "baseContainer") return;
                  }
                  var Mt = new Ge();
                  Mt.initFromText(ke, z[0], dt, De[0], tt[0], T), z[0].contents.push(Mt);
                } else z[0] instanceof v && Ue > 0 && b && "onText" in b && b.onText(dt);
              }, X.onopentag = function(dt) {
                var Yt = dt.attributes["xml:space"];
                Yt ? tt.unshift(Yt.value) : tt.length === 0 ? tt.unshift("default") : tt.unshift(tt[0]);
                var Mt = dt.attributes["xml:lang"];
                if (Mt ? De.unshift(Mt.value) : De.length === 0 ? De.unshift("") : De.unshift(De[0]), dt.uri === t.ns_tt) if (dt.local === "tt") ke !== null && je(T, "Two <tt> elements at (" + this.line + "," + this.column + ")"), (ke = new h()).initFromNode(dt, De[0], T), z.unshift(ke);
                else if (dt.local === "head") z[0] instanceof h || je(T, "Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")"), z.unshift(ke.head);
                else if (dt.local === "styling") z[0] instanceof n || je(T, "Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")"), z.unshift(ke.head.styling);
                else if (dt.local === "style") {
                  var Ht;
                  z[0] instanceof f ? ((Ht = new d()).initFromNode(dt, T), Ht.id ? ke.head.styling.styles[Ht.id] = Ht : Te(T, "<style> element missing @id attribute"), z.unshift(Ht)) : z[0] instanceof Ae ? ((Ht = new d()).initFromNode(dt, T), ot(Ht.styleAttrs, z[0].styleAttrs), z.unshift(Ht)) : je(T, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");
                } else if (dt.local === "initial") {
                  var Ut;
                  if (z[0] instanceof f) {
                    for (var cn in (Ut = new S()).initFromNode(dt, T), Ut.styleAttrs) Ut.styleAttrs.hasOwnProperty(cn) && (ke.head.styling.initials[cn] = Ut.styleAttrs[cn]);
                    z.unshift(Ut);
                  } else je(T, "Parent of <initial> element is not <styling> at (" + this.line + "," + this.column + ")");
                } else if (dt.local === "layout") z[0] instanceof n || je(T, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")"), z.unshift(ke.head.layout);
                else if (dt.local === "region") {
                  z[0] instanceof x || je(T, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
                  var Tn = new Ae();
                  Tn.initFromNode(ke, dt, De[0], T), !Tn.id || Tn.id in ke.head.layout.regions ? Te(T, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")") : ke.head.layout.regions[Tn.id] = Tn, z.unshift(Tn);
                } else if (dt.local === "body") {
                  z[0] instanceof h || je(T, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")"), ke.body !== null && je(T, "Second <body> element at " + this.line + "," + this.column + ")");
                  var xn = new ce();
                  xn.initFromNode(ke, dt, De[0], T), ke.body = xn, z.unshift(xn);
                } else if (dt.local === "div") {
                  z[0] instanceof Re || z[0] instanceof ce || je(T, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");
                  var Mn = new Re();
                  Mn.initFromNode(ke, z[0], dt, De[0], T);
                  var kn = Mn.styleAttrs[e.byName.backgroundImage.qname];
                  kn && (Mn.contents.push(new G(kn)), delete Mn.styleAttrs[e.byName.backgroundImage.qname]), z[0].contents.push(Mn), z.unshift(Mn);
                } else if (dt.local === "image") {
                  z[0] instanceof Re || je(T, "Parent of <image> element is not <div> at " + this.line + "," + this.column + ")");
                  var tr = new G();
                  tr.initFromNode(ke, z[0], dt, De[0], T), z[0].contents.push(tr), z.unshift(tr);
                } else if (dt.local === "p") {
                  z[0] instanceof Re || je(T, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");
                  var wn = new $();
                  wn.initFromNode(ke, z[0], dt, De[0], T), z[0].contents.push(wn), z.unshift(wn);
                } else if (dt.local === "span") {
                  z[0] instanceof Me || z[0] instanceof $ || je(T, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                  var hr = new Me();
                  hr.initFromNode(ke, z[0], dt, De[0], tt[0], T), z[0].contents.push(hr), z.unshift(hr);
                } else if (dt.local === "br") {
                  z[0] instanceof Me || z[0] instanceof $ || je(T, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                  var zn = new Qe();
                  zn.initFromNode(ke, z[0], dt, De[0], T), z[0].contents.push(zn), z.unshift(zn);
                } else if (dt.local === "set") {
                  z[0] instanceof Me || z[0] instanceof $ || z[0] instanceof Re || z[0] instanceof ce || z[0] instanceof Ae || z[0] instanceof Qe || je(T, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");
                  var or = new Ze();
                  or.initFromNode(ke, z[0], dt, T), z[0].sets.push(or), z.unshift(or);
                } else z.unshift(new v(dt));
                else z.unshift(new v(dt));
                if (z[0] instanceof v) {
                  if (dt.uri === t.ns_tt && dt.local === "metadata") Ue++;
                  else if (Ue > 0 && b && "onOpenTag" in b) {
                    var vr = [];
                    for (var sr in dt.attributes) vr[dt.attributes[sr].uri + " " + dt.attributes[sr].local] = { uri: dt.attributes[sr].uri, local: dt.attributes[sr].local, value: dt.attributes[sr].value };
                    b.onOpenTag(dt.uri, dt.local, vr);
                  }
                }
              }, X.write(o).close(), delete ke.head.styling.styles;
              var Oe = !1;
              for (var qe in ke.head.layout.regions) if (ke.head.layout.regions.hasOwnProperty(qe)) {
                Oe = !0;
                break;
              }
              if (!Oe) {
                var it = Ae.prototype.createDefaultRegion(ke.lang);
                ke.head.layout.regions[it.id] = it;
              }
              for (var bt in ke.head.layout.regions) ke.head.layout.regions.hasOwnProperty(bt) && l(ke, ke.head.layout.regions[bt], null, null);
              return ke.body && l(ke, ke.body, null, null), ke.body && p(ke.body), ke;
            }, h.prototype.initFromNode = function(o, T, b) {
              var X = function(Ue, ke) {
                var Oe = Be(Ue, t.ns_ttp, "cellResolution"), qe = 15, it = 32;
                if (Oe !== null) {
                  var bt = /(\d+) (\d+)/.exec(Oe);
                  bt !== null ? (it = parseInt(bt[1]), qe = parseInt(bt[2])) : Ee(ke, "Malformed cellResolution value (using initial value instead)");
                }
                return { w: it, h: qe };
              }(o, b);
              this.cellLength = { h: new m.ComputedLength(0, 1 / X.h), w: new m.ComputedLength(1 / X.w, 0) };
              var z = function(Ue, ke) {
                var Oe, qe = Be(Ue, t.ns_ttp, "frameRate"), it = 30;
                qe !== null && ((Oe = /(\d+)/.exec(qe)) !== null ? it = parseInt(Oe[1]) : Ee(ke, "Malformed frame rate attribute (using initial value instead)"));
                var bt = Be(Ue, t.ns_ttp, "frameRateMultiplier"), dt = 1;
                bt !== null && ((Oe = /(\d+) (\d+)/.exec(bt)) !== null ? dt = parseInt(Oe[1]) / parseInt(Oe[2]) : Ee(ke, "Malformed frame rate multiplier attribute (using initial value instead)"));
                var Yt = dt * it, Mt = 1, Ht = Be(Ue, t.ns_ttp, "tickRate");
                return Ht === null ? qe !== null && (Mt = Yt) : (Oe = /(\d+)/.exec(Ht)) !== null ? Mt = parseInt(Oe[1]) : Ee(ke, "Malformed tick rate attribute (using initial value instead)"), { effectiveFrameRate: Yt, tickRate: Mt };
              }(o, b);
              this.effectiveFrameRate = z.effectiveFrameRate, this.tickRate = z.tickRate, this.aspectRatio = function(Ue, ke) {
                var Oe = Be(Ue, t.ns_ittp, "aspectRatio");
                Oe === null && (Oe = Be(Ue, t.ns_ttp, "displayAspectRatio"));
                var qe = null;
                if (Oe !== null) {
                  var it = /(\d+)\s+(\d+)/.exec(Oe);
                  if (it !== null) {
                    var bt = parseInt(it[1]), dt = parseInt(it[2]);
                    bt !== 0 && dt !== 0 ? qe = bt / dt : Te(ke, "Illegal aspectRatio values (ignoring)");
                  } else Te(ke, "Malformed aspectRatio attribute (ignoring)");
                }
                return qe;
              }(o, b);
              var De = Be(o, t.ns_ttp, "timeBase");
              De !== null && De !== "media" && je(b, "Unsupported time base");
              var tt = function(Ue, ke) {
                var Oe = Be(Ue, t.ns_tts, "extent");
                if (Oe === null) return null;
                var qe = Oe.split(" ");
                if (qe.length !== 2) return Ee(ke, "Malformed extent (ignoring)"), null;
                var it = m.parseLength(qe[0]), bt = m.parseLength(qe[1]);
                return bt && it ? { h: bt, w: it } : (Ee(ke, "Malformed extent values (ignoring)"), null);
              }(o, b);
              tt === null ? this.pxLength = { h: null, w: null } : (tt.h.unit === "px" && tt.w.unit === "px" || je(b, "Extent on TT must be in px or absent"), this.pxLength = { h: new m.ComputedLength(0, 1 / tt.h.value), w: new m.ComputedLength(1 / tt.w.value, 0) }), this.dimensions = { h: new m.ComputedLength(0, 1), w: new m.ComputedLength(1, 0) }, this.lang = T;
            }, h.prototype._registerEvent = function(o) {
              if (!(o.end <= o.begin)) {
                var T = c(this.events, o.begin);
                if (T.found || this.events.splice(T.index, 0, o.begin), o.end !== Number.POSITIVE_INFINITY) {
                  var b = c(this.events, o.end);
                  b.found || this.events.splice(b.index, 0, o.end);
                }
              }
            }, h.prototype.getMediaTimeRange = function() {
              return [this.events[0], this.events[this.events.length - 1]];
            }, h.prototype.getMediaTimeEvents = function() {
              return this.events;
            }, d.prototype.initFromNode = function(o, T) {
              this.id = Xe(o), this.styleAttrs = Ie(o, T), this.styleRefs = at(o);
            }, S.prototype.initFromNode = function(o, T) {
              for (var b in this.styleAttrs = {}, o.attributes) if (o.attributes[b].uri === t.ns_itts || o.attributes[b].uri === t.ns_ebutts || o.attributes[b].uri === t.ns_tts) {
                var X = o.attributes[b].uri + " " + o.attributes[b].local;
                this.styleAttrs[X] = o.attributes[b].value;
              }
            }, G.prototype.initFromNode = function(o, T, b, X, z) {
              this.src = "src" in b.attributes ? b.attributes.src.value : null, this.src || Te(z, "Invalid image@src attribute"), this.type = "type" in b.attributes ? b.attributes.type.value : null, this.type || Te(z, "Invalid image@type attribute"), W.prototype.initFromNode.call(this, o, T, b, z), re.prototype.initFromNode.call(this, o, T, b, z), se.prototype.initFromNode.call(this, o, T, b, z), M.prototype.initFromNode.call(this, o, T, b, z), this.lang = X;
            }, J.prototype.initFromNode = function(o, T, b, X) {
              this.id = Xe(b);
            }, M.prototype.initFromNode = function(o, T, b, X) {
              this.regionID = function(z) {
                return z && "region" in z.attributes ? z.attributes.region.value : "";
              }(b);
            }, W.prototype.initFromNode = function(o, T, b, X) {
              this.styleAttrs = Ie(b, X), o.head !== null && o.head.styling !== null && Ve(o.head.styling, at(b), this.styleAttrs, X);
            }, se.prototype.initFromNode = function(o, T, b, X) {
              this.sets = [];
            }, j.prototype.initFromNode = function(o, T, b, X) {
              this.contents = [];
            }, re.prototype.initFromNode = function(o, T, b, X) {
              var z = function(De, tt, Ue, ke) {
                var Oe = null;
                Ue && "begin" in Ue.attributes && (Oe = It(De.tickRate, De.effectiveFrameRate, Ue.attributes.begin.value)) === null && Ee(ke, "Malformed begin value " + Ue.attributes.begin.value + " (using 0)");
                var qe = null;
                Ue && "dur" in Ue.attributes && (qe = It(De.tickRate, De.effectiveFrameRate, Ue.attributes.dur.value)) === null && Ee(ke, "Malformed dur value " + Ue.attributes.dur.value + " (ignoring)");
                var it = null;
                return Ue && "end" in Ue.attributes && (it = It(De.tickRate, De.effectiveFrameRate, Ue.attributes.end.value)) === null && Ee(ke, "Malformed end value (ignoring)"), { explicit_begin: Oe, explicit_end: it, explicit_dur: qe };
              }(o, 0, b, X);
              this.explicit_begin = z.explicit_begin, this.explicit_end = z.explicit_end, this.explicit_dur = z.explicit_dur, this.timeContainer = function(De, tt) {
                var Ue = De && "timeContainer" in De.attributes ? De.attributes.timeContainer.value : null;
                return Ue && Ue !== "par" ? Ue === "seq" ? "seq" : (Te(tt, "Illegal value of timeContainer (assuming 'par')"), "par") : "par";
              }(b, X);
            }, ce.prototype.initFromNode = function(o, T, b, X) {
              W.prototype.initFromNode.call(this, o, null, T, X), re.prototype.initFromNode.call(this, o, null, T, X), se.prototype.initFromNode.call(this, o, null, T, X), M.prototype.initFromNode.call(this, o, null, T, X), j.prototype.initFromNode.call(this, o, null, T, X), this.lang = b;
            }, Re.prototype.initFromNode = function(o, T, b, X, z) {
              W.prototype.initFromNode.call(this, o, T, b, z), re.prototype.initFromNode.call(this, o, T, b, z), se.prototype.initFromNode.call(this, o, T, b, z), M.prototype.initFromNode.call(this, o, T, b, z), j.prototype.initFromNode.call(this, o, T, b, z), this.lang = X;
            }, $.prototype.initFromNode = function(o, T, b, X, z) {
              W.prototype.initFromNode.call(this, o, T, b, z), re.prototype.initFromNode.call(this, o, T, b, z), se.prototype.initFromNode.call(this, o, T, b, z), M.prototype.initFromNode.call(this, o, T, b, z), j.prototype.initFromNode.call(this, o, T, b, z), this.lang = X;
            }, Me.prototype.initFromNode = function(o, T, b, X, z, De) {
              W.prototype.initFromNode.call(this, o, T, b, De), re.prototype.initFromNode.call(this, o, T, b, De), se.prototype.initFromNode.call(this, o, T, b, De), M.prototype.initFromNode.call(this, o, T, b, De), j.prototype.initFromNode.call(this, o, T, b, De), this.space = z, this.lang = X;
            }, Ge.prototype.initFromText = function(o, T, b, X, z, De) {
              re.prototype.initFromNode.call(this, o, T, null, De), this.text = b, this.space = z, this.lang = X;
            }, Qe.prototype.initFromNode = function(o, T, b, X, z) {
              M.prototype.initFromNode.call(this, o, T, b, z), re.prototype.initFromNode.call(this, o, T, b, z), this.lang = X;
            }, Ae.prototype.createDefaultRegion = function(o) {
              var T = new Ae();
              return J.call(T, ""), W.call(T, {}), se.call(T, []), re.call(T, 0, Number.POSITIVE_INFINITY, null), this.lang = o, T;
            }, Ae.prototype.initFromNode = function(o, T, b, X) {
              J.prototype.initFromNode.call(this, o, null, T, X), re.prototype.initFromNode.call(this, o, null, T, X), se.prototype.initFromNode.call(this, o, null, T, X), this.styleAttrs = Ie(T, X), this.styleRefs = at(T), this.lang = b;
            }, Ze.prototype.initFromNode = function(o, T, b, X) {
              re.prototype.initFromNode.call(this, o, T, b, X);
              var z = Ie(b, X);
              for (var De in this.qname = null, this.value = null, z) if (z.hasOwnProperty(De)) {
                if (this.qname) {
                  Te(X, "More than one style specified on set");
                  break;
                }
                this.qname = De, this.value = z[De];
              }
            };
          })(ge, typeof sax > "u" ? R(5378) : sax, typeof imscNames > "u" ? R(210) : imscNames, typeof imscStyles > "u" ? R(6811) : imscStyles, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 506: function(Se, ge, R) {
          var te = /firefox/i.test(navigator.userAgent);
          (function(E, t, e) {
            function m(j, re, ce, Re) {
              var $;
              if (ce.kind === "region") ($ = document.createElement("div")).style.position = "absolute";
              else if (ce.kind === "body") $ = document.createElement("div");
              else if (ce.kind === "div") $ = document.createElement("div");
              else if (ce.kind === "image") {
                if ($ = document.createElement("img"), j.imgResolver !== null && ce.src !== null) {
                  var Me = j.imgResolver(ce.src, $);
                  Me && ($.src = Me), $.height = j.regionH, $.width = j.regionW;
                }
              } else if (ce.kind === "p") $ = document.createElement("p");
              else if (ce.kind === "span") if (ce.styleAttrs[e.byName.ruby.qname] === "container") $ = document.createElement("ruby"), j.ruby = !0;
              else if (ce.styleAttrs[e.byName.ruby.qname] === "base") $ = document.createElement("span");
              else if (ce.styleAttrs[e.byName.ruby.qname] === "text") $ = document.createElement("rt");
              else if (ce.styleAttrs[e.byName.ruby.qname] === "baseContainer") $ = document.createElement("rbc");
              else if (ce.styleAttrs[e.byName.ruby.qname] === "textContainer") $ = document.createElement("rtc");
              else {
                if (ce.styleAttrs[e.byName.ruby.qname] === "delimiter") return;
                $ = document.createElement("span");
              }
              else ce.kind === "br" && ($ = document.createElement("br"));
              if ($) {
                if (ce.lang && (ce.kind !== "region" && ce.lang === Re.lang || ($.lang = ce.lang)), re.appendChild($), $.style.margin = "0", ce.kind === "region") {
                  var Ge = ce.styleAttrs[e.byName.writingMode.qname];
                  Ge === "lrtb" || Ge === "lr" ? (j.ipd = "lr", j.bpd = "tb") : Ge === "rltb" || Ge === "rl" ? (j.ipd = "rl", j.bpd = "tb") : Ge === "tblr" ? (j.ipd = "tb", j.bpd = "lr") : Ge !== "tbrl" && Ge !== "tb" || (j.ipd = "tb", j.bpd = "rl");
                } else if (ce.kind === "p" && j.bpd === "tb") {
                  var Qe = ce.styleAttrs[e.byName.direction.qname];
                  j.ipd = Qe === "ltr" ? "lr" : "rl";
                }
                for (var Ae = 0; Ae < S.length; Ae++) {
                  var Ze = S[Ae], Xe = ce.styleAttrs[Ze.qname];
                  Xe !== void 0 && Ze.map !== null && Ze.map(j, $, ce, Xe);
                }
                var at = $, Ie = ce.styleAttrs[e.byName.linePadding.qname];
                if (Ie && !Ie.isZero()) {
                  var Be = Ie.toUsedLength(j.w, j.h);
                  if (Be > 0) {
                    var It = Math.ceil(Be) + "px";
                    j.bpd === "tb" ? (at.style.paddingLeft = It, at.style.paddingRight = It) : (at.style.paddingTop = It, at.style.paddingBottom = It), j.lp = Ie;
                  }
                }
                var _t = ce.styleAttrs[e.byName.multiRowAlign.qname];
                if (_t && _t !== "auto") {
                  var Ve = document.createElement("span");
                  Ve.style.display = "inline-block", Ve.style.textAlign = _t, $.appendChild(Ve), at = Ve, j.mra = _t;
                }
                var ot = ce.styleAttrs[e.byName.rubyReserve.qname];
                if (ot && ot[0] !== "none" && (j.rubyReserve = ot), ce.styleAttrs[e.byName.fillLineGap.qname] && (j.flg = !0), ce.kind === "span" && ce.text) {
                  var Ee = ce.styleAttrs[e.byName.textEmphasis.qname];
                  if (Ee && Ee.style !== "none" && (j.textEmphasis = !0), e.byName.textCombine.qname in ce.styleAttrs && ce.styleAttrs[e.byName.textCombine.qname] === "all") $.textContent = ce.text, $._isd_element = ce, Ee && f(j, $, 0, Ee);
                  else for (var Te = "", je = 0; je < ce.text.length; je++) {
                    Te += ce.text.charAt(je);
                    var c = ce.text.charCodeAt(je);
                    if (c < 55296 || c > 56319 || je === ce.text.length - 1) {
                      var o = document.createElement("span");
                      o.textContent = Te, Ee && f(j, o, 0, Ee), $.appendChild(o), Te = "", o._isd_element = ce;
                    }
                  }
                }
                if ("contents" in ce) for (var T = 0; T < ce.contents.length; T++) m(j, at, ce.contents[T], ce);
                var b = [];
                if (ce.kind === "p" && (n(j, at, b, null), j.rubyReserve && (function(Ue, ke) {
                  for (var Oe = 0; Oe < Ue.length; Oe++) {
                    var qe, it, bt = document.createElement("ruby"), dt = document.createElement("span");
                    dt.textContent = "​", bt.appendChild(dt);
                    var Yt, Mt = ke.rubyReserve[1].toUsedLength(ke.w, ke.h) + "px";
                    ke.rubyReserve[0] === "both" || ke.rubyReserve[0] === "outside" && Ue.length == 1 ? ((qe = document.createElement("rtc")).style[J] = P ? "after" : "under", qe.textContent = "​", qe.style.fontSize = Mt, (it = document.createElement("rtc")).style[J] = P ? "before" : "over", it.textContent = "​", it.style.fontSize = Mt, bt.appendChild(qe), bt.appendChild(it)) : ((qe = document.createElement("rtc")).textContent = "​", qe.style.fontSize = Mt, Yt = ke.rubyReserve[0] === "after" || ke.rubyReserve[0] === "outside" && Oe > 0 ? P ? "after" : ke.bpd === "tb" || ke.bpd === "rl" ? "under" : "over" : P ? "before" : ke.bpd === "tb" || ke.bpd === "rl" ? "over" : "under", qe.style[J] = Yt, bt.appendChild(qe));
                    for (var Ht = null, Ut = 0; Ut < Ue[Oe].rbc.length; Ut++) if (Ue[Oe].rbc[Ut].localName === "ruby") {
                      Ht = Ue[Oe].rbc[Ut];
                      for (var cn = 0; cn < Ht.style.length; cn++) bt.style.setProperty(Ht.style.item(cn), Ht.style.getPropertyValue(Ht.style.item(cn)));
                      break;
                    }
                    (Ht = Ht || Ue[Oe].elements[0].node).parentElement.insertBefore(bt, Ht);
                  }
                }(b, j), j.rubyReserve = null), (j.ruby || j.rubyReserve) && (function(Ue, ke) {
                  for (var Oe = 0; Oe < Ue.length; Oe++) for (var qe = 0; qe < Ue[Oe].rbc.length; qe++) {
                    var it;
                    Ue[Oe].rbc[qe].style[J] || (it = P ? Oe === 0 ? "before" : "after" : ke.bpd === "tb" || ke.bpd === "rl" ? Oe === 0 ? "over" : "under" : Oe === 0 ? "under" : "over", Ue[Oe].rbc[qe].style[J] = it);
                  }
                }(b, j), j.ruby = null), j.textEmphasis && (function(Ue, ke) {
                  for (var Oe = 0; Oe < Ue.length; Oe++) for (var qe = 0; qe < Ue[Oe].te.length; qe++) {
                    var it;
                    Ue[Oe].te[qe].style[W] && Ue[Oe].te[qe].style[W] !== "none" || (it = ke.bpd === "tb" ? Oe === 0 ? "left over" : "left under" : ke.bpd === "rl" ? Oe === 0 ? "right under" : "left under" : Oe === 0 ? "left under" : "right under", Ue[Oe].te[qe].style[W] = it);
                  }
                }(b, j), j.textEmphasis = null), j.mra && (function(Ue) {
                  for (var ke = 0; ke < Ue.length - 1; ke++) {
                    var Oe = Ue[ke].elements.length;
                    if (Oe !== 0 && Ue[ke].br === !1) {
                      var qe = document.createElement("br"), it = Ue[ke].elements[Oe - 1].node;
                      it.parentElement.insertBefore(qe, it.nextSibling);
                    }
                  }
                }(b), j.mra = null), j.lp && (function(Ue, ke, Oe) {
                  if (Ue !== null) for (var qe = 0; qe < Ue.length; qe++) {
                    var it = Ue[qe].elements.length, bt = Math.ceil(ke) + "px", dt = "-" + Math.ceil(ke) + "px";
                    if (it !== 0) {
                      var Yt = Ue[qe].elements[Ue[qe].start_elem], Mt = Ue[qe].elements[Ue[qe].end_elem];
                      if (Yt === Mt) {
                        var Ht = Yt.node.getBoundingClientRect();
                        if (Ht.width == 0 || Ht.height == 0) continue;
                      }
                      Oe.ipd === "lr" ? (Yt.node.style.marginLeft = dt, Yt.node.style.paddingLeft = bt) : Oe.ipd === "rl" ? (Yt.node.style.paddingRight = bt, Yt.node.style.marginRight = dt) : Oe.ipd === "tb" && (Yt.node.style.paddingTop = bt, Yt.node.style.marginTop = dt), Oe.ipd === "lr" ? (te || (Mt.node.style.marginRight = dt), Mt.node.style.paddingRight = bt) : Oe.ipd === "rl" ? (Mt.node.style.paddingLeft = bt, te || (Mt.node.style.marginLeft = dt)) : Oe.ipd === "tb" && (Mt.node.style.paddingBottom = bt, Mt.node.style.marginBottom = dt);
                    }
                  }
                }(b, j.lp.toUsedLength(j.w, j.h), j), j.lp = null), function(Ue, ke) {
                  for (var Oe = 0; Oe < Ue.length; Oe++) for (var qe = Ue[Oe], it = 1; it < qe.elements.length; ) {
                    var bt = qe.elements[it - 1], dt = qe.elements[it];
                    l(bt.node, dt.node, ke) ? qe.elements.splice(it, 1) : it++;
                  }
                  for (var Yt, Mt, Ht = [], Ut = 0; Ut < Ue.length; Ut++) for (var cn = 0; cn < Ue[Ut].elements.length; cn++) (Mt = p(Yt = Ue[Ut].elements[cn].node, Ht, !1)) && (Yt.style.backgroundColor = Mt);
                  for (var Tn = 0; Tn < Ht.length; Tn++) Ht[Tn].style.backgroundColor = "";
                }(b, j), j.flg)) {
                  var X = h(at.getBoundingClientRect(), j);
                  (function(Ue, ke, Oe, qe, it) {
                    for (var bt = Math.sign(Oe - ke), dt = 0; dt <= Ue.length; dt++) {
                      var Yt, Mt, Ht, Ut;
                      if (Yt = dt === 0 ? Math.round(ke) : dt === Ue.length ? Math.round(Oe) : Math.round((Ue[dt - 1].after + Ue[dt].before) / 2), dt > 0 && Ue[dt - 1]) for (Ht = 0; Ht < Ue[dt - 1].elements.length; Ht++) Mt = bt * (Yt - (Ut = Ue[dt - 1].elements[Ht]).after) + "px", qe.bpd === "lr" ? Ut.node.style.paddingRight = Mt : qe.bpd === "rl" ? Ut.node.style.paddingLeft = Mt : qe.bpd === "tb" && (Ut.node.style.paddingBottom = Mt);
                      if (dt < Ue.length) for (Ht = 0; Ht < Ue[dt].elements.length; Ht++) Mt = bt * ((Ut = Ue[dt].elements[Ht]).before - Yt) + "px", qe.bpd === "lr" ? Ut.node.style.paddingLeft = Mt : qe.bpd === "rl" ? Ut.node.style.paddingRight = Mt : qe.bpd === "tb" && (Ut.node.style.paddingTop = Mt);
                    }
                  })(b, X.before, X.after, j), j.flg = null;
                }
                if (ce.kind === "region" && j.bpd === "tb" && j.enableRollUp && ce.contents.length > 0 && ce.styleAttrs[e.byName.displayAlign.qname] === "after") {
                  n(j, at, b, null);
                  var z = new v(ce.id === "" ? "_" : ce.id, b);
                  if (j.currentISDState[z.id] = z, j.previousISDState && z.id in j.previousISDState && j.previousISDState[z.id].plist.length > 0 && z.plist.length > 1 && z.plist[z.plist.length - 2].text === j.previousISDState[z.id].plist[j.previousISDState[z.id].plist.length - 1].text) {
                    var De = $.firstElementChild, tt = z.plist[z.plist.length - 1].after - z.plist[z.plist.length - 1].before;
                    De.style.bottom = "-" + tt + "px", De.style.transition = "transform 0.4s", De.style.position = "relative", De.style.transform = "translateY(-" + tt + "px)";
                  }
                }
              } else se(j.errorHandler, "Error processing ISD element kind: " + ce.kind);
            }
            function p(j, re, ce) {
              return j.style.backgroundColor ? (ce && !re.includes(j) && re.push(j), j.style.backgroundColor) : j.parentElement.nodeName === "SPAN" || j.parentElement.nodeName === "RUBY" || j.parentElement.nodeName === "RBC" || j.parentElement.nodeName === "RTC" || j.parentElement.nodeName === "RT" ? p(j.parentElement, re, !0) : void 0;
            }
            function l(j, re, ce) {
              if (j.tagName === "SPAN" && re.tagName === "SPAN" && j._isd_element === re._isd_element) {
                if (!j._isd_element) return se(ce.errorHandler, "Internal error: HTML span is not linked to a source element; cannot merge spans."), !1;
                j.textContent += re.textContent;
                for (var Re = 0; Re < re.style.length; Re++) {
                  var $ = re.style[Re];
                  ($.indexOf("border") >= 0 || $.indexOf("padding") >= 0 || $.indexOf("margin") >= 0) && (j.style[$] = re.style[$]);
                }
                return re.parentElement.removeChild(re), !0;
              }
              return !1;
            }
            function v(j, re) {
              this.id = j, this.plist = re;
            }
            function h(j, re) {
              var ce = { before: null, after: null, start: null, end: null };
              return re.bpd === "tb" ? (ce.before = j.top, ce.after = j.bottom, re.ipd === "lr" ? (ce.start = j.left, ce.end = j.right) : (ce.start = j.right, ce.end = j.left)) : re.bpd === "lr" ? (ce.before = j.left, ce.after = j.right, ce.start = j.top, ce.end = j.bottom) : re.bpd === "rl" && (ce.before = j.right, ce.after = j.left, ce.start = j.top, ce.end = j.bottom), ce;
            }
            function n(j, re, ce, Re) {
              if (re.localName !== "rt" && re.localName !== "rtc") {
                var $, Me, Ge, Qe, Ae = re.style.backgroundColor || Re;
                if (re.childElementCount === 0) if (re.localName === "span" || re.localName === "rb") {
                  var Ze = h(re.getBoundingClientRect(), j);
                  if (ce.length !== 0 && ($ = Ze.before, Me = Ze.after, Ge = ce[ce.length - 1].before, Me < (Qe = ce[ce.length - 1].after) && $ > Ge || Qe <= Me && Ge >= $)) {
                    var Xe = Math.sign(Ze.after - Ze.before), at = Math.sign(Ze.end - Ze.start);
                    Xe * (Ze.before - ce[ce.length - 1].before) < 0 && (ce[ce.length - 1].before = Ze.before), Xe * (Ze.after - ce[ce.length - 1].after) > 0 && (ce[ce.length - 1].after = Ze.after), at * (Ze.start - ce[ce.length - 1].start) < 0 && (ce[ce.length - 1].start = Ze.start, ce[ce.length - 1].start_elem = ce[ce.length - 1].elements.length), at * (Ze.end - ce[ce.length - 1].end) > 0 && (ce[ce.length - 1].end = Ze.end, ce[ce.length - 1].end_elem = ce[ce.length - 1].elements.length);
                  } else ce.push({ before: Ze.before, after: Ze.after, start: Ze.start, end: Ze.end, start_elem: 0, end_elem: 0, elements: [], rbc: [], te: [], text: "", br: !1 });
                  ce[ce.length - 1].text += re.textContent, ce[ce.length - 1].elements.push({ node: re, bgcolor: Ae, before: Ze.before, after: Ze.after });
                } else re.localName === "br" && ce.length !== 0 && (ce[ce.length - 1].br = !0);
                else for (var Ie = re.firstChild; Ie; ) Ie.nodeType === Node.ELEMENT_NODE && (n(j, Ie, ce, Ae), Ie.localName === "ruby" || Ie.localName === "rtc" ? ce.length > 0 && ce[ce.length - 1].rbc.push(Ie) : Ie.localName === "span" && Ie.style[M] && Ie.style[M] !== "none" && ce.length > 0 && ce[ce.length - 1].te.push(Ie)), Ie = Ie.nextSibling;
              }
            }
            function f(j, re, ce, Re) {
              var $;
              Re.style !== "none" && (Re.style === "auto" ? re.style[M] = "filled" : re.style[M] = Re.style + " " + Re.symbol, (Re.position === "before" || Re.position === "after") && ($ = j.bpd === "tb" ? Re.position === "before" ? "left over" : "left under" : j.bpd === "rl" ? Re.position === "before" ? "right under" : "left under" : Re.position === "before" ? "left under" : "right under", re.style[W] = $));
            }
            function d(j, re) {
              this.qname = j, this.map = re;
            }
            E.render = function(j, re, ce, Re, $, Me, Ge, Qe, Ae) {
              var Ze = Re || re.clientHeight, Xe = $ || re.clientWidth;
              if (j.aspectRatio !== null) {
                var at = Ze * j.aspectRatio;
                at > Xe ? Ze = Math.round(Xe / j.aspectRatio) : Xe = at;
              }
              var Ie = document.createElement("div");
              Ie.style.position = "relative", Ie.style.width = Xe + "px", Ie.style.height = Ze + "px", Ie.style.margin = "auto", Ie.style.top = 0, Ie.style.bottom = 0, Ie.style.left = 0, Ie.style.right = 0, Ie.style.zIndex = 0;
              var Be = { h: Ze, w: Xe, regionH: null, regionW: null, imgResolver: ce, displayForcedOnlyMode: Me || !1, isd: j, errorHandler: Ge, previousISDState: Qe, enableRollUp: Ae || !1, currentISDState: {}, flg: null, lp: null, mra: null, ipd: null, bpd: null, ruby: null, textEmphasis: null, rubyReserve: null };
              if (re.appendChild(Ie), "contents" in j) for (var It = 0; It < j.contents.length; It++) m(Be, Ie, j.contents[It], j);
              return Be.currentISDState;
            };
            for (var S = [new d("http://www.w3.org/ns/ttml#styling backgroundColor", function(j, re, ce, Re) {
              Re[3] !== 0 && (re.style.backgroundColor = "rgba(" + Re[0].toString() + "," + Re[1].toString() + "," + Re[2].toString() + "," + (Re[3] / 255).toString() + ")");
            }), new d("http://www.w3.org/ns/ttml#styling color", function(j, re, ce, Re) {
              re.style.color = "rgba(" + Re[0].toString() + "," + Re[1].toString() + "," + Re[2].toString() + "," + (Re[3] / 255).toString() + ")";
            }), new d("http://www.w3.org/ns/ttml#styling direction", function(j, re, ce, Re) {
              re.style.direction = Re;
            }), new d("http://www.w3.org/ns/ttml#styling display", function(j, re, ce, Re) {
            }), new d("http://www.w3.org/ns/ttml#styling displayAlign", function(j, re, ce, Re) {
              re.style.display = "flex", re.style.flexDirection = "column", Re === "before" ? re.style.justifyContent = "flex-start" : Re === "center" ? re.style.justifyContent = "center" : Re === "after" && (re.style.justifyContent = "flex-end");
            }), new d("http://www.w3.org/ns/ttml#styling extent", function(j, re, ce, Re) {
              j.regionH = Re.h.toUsedLength(j.w, j.h), j.regionW = Re.w.toUsedLength(j.w, j.h);
              var $ = 0, Me = 0, Ge = ce.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];
              Ge && ($ = Ge[0].toUsedLength(j.w, j.h) + Ge[2].toUsedLength(j.w, j.h), Me = Ge[1].toUsedLength(j.w, j.h) + Ge[3].toUsedLength(j.w, j.h)), re.style.height = j.regionH - $ + "px", re.style.width = j.regionW - Me + "px";
            }), new d("http://www.w3.org/ns/ttml#styling fontFamily", function(j, re, ce, Re) {
              for (var $ = [], Me = 0; Me < Re.length; Me++) Re[Me] = Re[Me].trim(), Re[Me] === "monospaceSerif" ? ($.push("Courier New"), $.push('"Liberation Mono"'), $.push("Courier"), $.push("monospace")) : Re[Me] === "proportionalSansSerif" ? ($.push("Arial"), $.push("Helvetica"), $.push('"Liberation Sans"'), $.push("sans-serif")) : Re[Me] === "monospace" ? $.push("monospace") : Re[Me] === "sansSerif" ? $.push("sans-serif") : Re[Me] === "serif" ? $.push("serif") : Re[Me] === "monospaceSansSerif" ? ($.push("Consolas"), $.push("monospace")) : Re[Me] === "proportionalSerif" ? $.push("serif") : $.push(Re[Me]);
              if ($.length > 0) {
                for (var Ge = [$[0]], Qe = 1; Qe < $.length; Qe++) Ge.indexOf($[Qe]) == -1 && Ge.push($[Qe]);
                $ = Ge;
              }
              re.style.fontFamily = $.join(",");
            }), new d("http://www.w3.org/ns/ttml#styling shear", function(j, re, ce, Re) {
              if (Re !== 0) {
                var $ = -0.9 * Re;
                j.bpd === "tb" ? re.style.transform = "skewX(" + $ + "deg)" : re.style.transform = "skewY(" + $ + "deg)";
              }
            }), new d("http://www.w3.org/ns/ttml#styling fontSize", function(j, re, ce, Re) {
              re.style.fontSize = Re.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling fontStyle", function(j, re, ce, Re) {
              re.style.fontStyle = Re;
            }), new d("http://www.w3.org/ns/ttml#styling fontWeight", function(j, re, ce, Re) {
              re.style.fontWeight = Re;
            }), new d("http://www.w3.org/ns/ttml#styling lineHeight", function(j, re, ce, Re) {
              re.style.lineHeight = Re === "normal" ? "normal" : Re.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling opacity", function(j, re, ce, Re) {
              re.style.opacity = Re;
            }), new d("http://www.w3.org/ns/ttml#styling origin", function(j, re, ce, Re) {
              re.style.top = Re.h.toUsedLength(j.w, j.h) + "px", re.style.left = Re.w.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling overflow", function(j, re, ce, Re) {
              re.style.overflow = Re;
            }), new d("http://www.w3.org/ns/ttml#styling padding", function(j, re, ce, Re) {
              var $ = [];
              $[0] = Re[0].toUsedLength(j.w, j.h) + "px", $[1] = Re[3].toUsedLength(j.w, j.h) + "px", $[2] = Re[2].toUsedLength(j.w, j.h) + "px", $[3] = Re[1].toUsedLength(j.w, j.h) + "px", re.style.padding = $.join(" ");
            }), new d("http://www.w3.org/ns/ttml#styling position", function(j, re, ce, Re) {
              re.style.top = Re.h.toUsedLength(j.w, j.h) + "px", re.style.left = Re.w.toUsedLength(j.w, j.h) + "px";
            }), new d("http://www.w3.org/ns/ttml#styling rubyAlign", function(j, re, ce, Re) {
              re.style.rubyAlign = Re === "spaceAround" ? "space-around" : "center";
            }), new d("http://www.w3.org/ns/ttml#styling rubyPosition", function(j, re, ce, Re) {
              var $;
              Re !== "before" && Re !== "after" || ($ = P ? Re : j.bpd === "tb" || j.bpd === "rl" ? Re === "before" ? "over" : "under" : Re === "before" ? "under" : "over", re.parentElement.style[J] = $);
            }), new d("http://www.w3.org/ns/ttml#styling showBackground", null), new d("http://www.w3.org/ns/ttml#styling textAlign", function(j, re, ce, Re) {
              var $;
              $ = Re === "start" ? j.ipd === "rl" ? "right" : "left" : Re === "end" ? j.ipd === "rl" ? "left" : "right" : Re, re.style.textAlign = $;
            }), new d("http://www.w3.org/ns/ttml#styling textDecoration", function(j, re, ce, Re) {
              re.style.textDecoration = Re.join(" ").replace("lineThrough", "line-through");
            }), new d("http://www.w3.org/ns/ttml#styling textOutline", function(j, re, ce, Re) {
            }), new d("http://www.w3.org/ns/ttml#styling textShadow", function(j, re, ce, Re) {
              var $ = ce.styleAttrs[e.byName.textOutline.qname];
              if (Re === "none" && $ === "none") re.style.textShadow = "";
              else {
                var Me = [];
                if ($ !== "none") {
                  var Ge = "rgba(" + $.color[0].toString() + "," + $.color[1].toString() + "," + $.color[2].toString() + "," + ($.color[3] / 255).toString() + ")";
                  Me.push("1px 1px 1px " + Ge), Me.push("-1px 1px 1px " + Ge), Me.push("1px -1px 1px " + Ge), Me.push("-1px -1px 1px " + Ge);
                }
                if (Re !== "none") for (var Qe = 0; Qe < Re.length; Qe++) Me.push(Re[Qe].x_off.toUsedLength(j.w, j.h) + "px " + Re[Qe].y_off.toUsedLength(j.w, j.h) + "px " + Re[Qe].b_radius.toUsedLength(j.w, j.h) + "px rgba(" + Re[Qe].color[0].toString() + "," + Re[Qe].color[1].toString() + "," + Re[Qe].color[2].toString() + "," + (Re[Qe].color[3] / 255).toString() + ")");
                re.style.textShadow = Me.join(",");
              }
            }), new d("http://www.w3.org/ns/ttml#styling textCombine", function(j, re, ce, Re) {
              re.style.textCombineUpright = Re;
            }), new d("http://www.w3.org/ns/ttml#styling textEmphasis", function(j, re, ce, Re) {
            }), new d("http://www.w3.org/ns/ttml#styling unicodeBidi", function(j, re, ce, Re) {
              var $;
              $ = Re === "bidiOverride" ? "bidi-override" : Re, re.style.unicodeBidi = $;
            }), new d("http://www.w3.org/ns/ttml#styling visibility", function(j, re, ce, Re) {
              re.style.visibility = Re;
            }), new d("http://www.w3.org/ns/ttml#styling wrapOption", function(j, re, ce, Re) {
              Re === "wrap" ? ce.space === "preserve" ? re.style.whiteSpace = "pre-wrap" : re.style.whiteSpace = "normal" : ce.space === "preserve" ? re.style.whiteSpace = "pre" : re.style.whiteSpace = "noWrap";
            }), new d("http://www.w3.org/ns/ttml#styling writingMode", function(j, re, ce, Re) {
              Re === "lrtb" || Re === "lr" || Re === "rltb" || Re === "rl" ? re.style.writingMode = "horizontal-tb" : Re === "tblr" ? re.style.writingMode = "vertical-lr" : Re !== "tbrl" && Re !== "tb" || (re.style.writingMode = "vertical-rl");
            }), new d("http://www.w3.org/ns/ttml#styling zIndex", function(j, re, ce, Re) {
              re.style.zIndex = Re;
            }), new d("http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay", function(j, re, ce, Re) {
              j.displayForcedOnlyMode && Re === !1 && (re.style.visibility = "hidden");
            })], x = {}, G = 0; G < S.length; G++) x[S[G].qname] = S[G];
            var P = "webkitRubyPosition" in window.getComputedStyle(document.documentElement), J = P ? "webkitRubyPosition" : "rubyPosition", M = "webkitTextEmphasisStyle" in window.getComputedStyle(document.documentElement) ? "webkitTextEmphasisStyle" : "textEmphasisStyle", W = "webkitTextEmphasisPosition" in window.getComputedStyle(document.documentElement) ? "webkitTextEmphasisPosition" : "textEmphasisPosition";
            function se(j, re) {
              if (j && j.error && j.error(re)) throw re;
            }
          })(ge, typeof imscNames > "u" ? R(210) : imscNames, typeof imscStyles > "u" ? R(6811) : imscStyles, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 4080: function(Se, ge, R) {
          (function(te, E, t, e) {
            te.generateISD = function(d, S, x) {
              var G, P = new h(d), J = {}, M = {}, W = d.head.styling.initials[t.byName.showBackground.qname], se = d.head.styling.initials[t.byName.backgroundColor.qname];
              for (var j in d.head.layout.regions) if (d.head.layout.regions.hasOwnProperty(j)) {
                var re = d.head.layout.regions[j], ce = re.styleAttrs[t.byName.showBackground.qname] || W, Re = re.styleAttrs[t.byName.backgroundColor.qname] || se;
                M[re.id] = (ce === "always" || ce === void 0) && Re !== void 0 && !(S < re.begin || S >= re.end);
              }
              for (var $ in d.body && d.body.regionID && (M[d.body.regionID] = !0), G = d.body !== null ? function Ge(Qe, Ae) {
                if (Ae.contents) {
                  var Ze = {};
                  for (var Xe in Ae) Ae.hasOwnProperty(Xe) && (Ze[Xe] = Ae[Xe]);
                  return Ze.contents = [], Ae.contents.filter(function(at) {
                    return !(Qe < at.begin || Qe >= at.end);
                  }).forEach(function(at) {
                    var Ie = Ge(Qe, at);
                    Ie.regionID && (M[Ie.regionID] = !0), Ie !== null && Ze.contents.push(Ie);
                  }), Ze;
                }
                return Ae;
              }(S, d.body) : null, M[""] !== void 0 && (M[""] = !0), M) if (M[$]) {
                var Me = p(d, S, d.head.layout.regions[$], G, null, "", d.head.layout.regions[$], x, J);
                Me !== null && P.contents.push(Me.element);
              }
              return P;
            };
            var m = [t.byName.color.qname, t.byName.textCombine.qname, t.byName.textDecoration.qname, t.byName.textEmphasis.qname, t.byName.textOutline.qname, t.byName.textShadow.qname];
            function p(d, S, x, G, P, J, M, W, se) {
              if (S < M.begin || S >= M.end) return null;
              var j = "regionID" in M && M.regionID !== "" ? M.regionID : J;
              if (P !== null && j !== x.id && (!("contents" in M) || "contents" in M && M.contents.length === 0 || j !== "")) return null;
              var re = new n(M);
              if ("sets" in M) for (var ce = 0; ce < M.sets.length; ce++) S < M.sets[ce].begin || S >= M.sets[ce].end || (re.styleAttrs[M.sets[ce].qname] = M.sets[ce].value);
              var Re = {};
              for (var $ in re.styleAttrs) if (re.styleAttrs.hasOwnProperty($) && (Re[$] = !0, re.kind === "region" && $ === t.byName.writingMode.qname && !(t.byName.direction.qname in re.styleAttrs))) {
                var Me = re.styleAttrs[$];
                Me === "lrtb" || Me === "lr" ? re.styleAttrs[t.byName.direction.qname] = "ltr" : Me !== "rltb" && Me !== "rl" || (re.styleAttrs[t.byName.direction.qname] = "rtl");
              }
              if (P !== null) for (var Ge = 0; Ge < t.all.length; Ge++) {
                var Qe = t.all[Ge];
                if (Qe.qname === t.byName.textDecoration.qname) {
                  var Ae = P.styleAttrs[Qe.qname], Ze = re.styleAttrs[Qe.qname], Xe = [];
                  Ze === void 0 ? Xe = Ae : Ze.indexOf("none") === -1 ? ((Ze.indexOf("noUnderline") === -1 && Ae.indexOf("underline") !== -1 || Ze.indexOf("underline") !== -1) && Xe.push("underline"), (Ze.indexOf("noLineThrough") === -1 && Ae.indexOf("lineThrough") !== -1 || Ze.indexOf("lineThrough") !== -1) && Xe.push("lineThrough"), (Ze.indexOf("noOverline") === -1 && Ae.indexOf("overline") !== -1 || Ze.indexOf("overline") !== -1) && Xe.push("overline")) : Xe.push("none"), re.styleAttrs[Qe.qname] = Xe;
                } else if (Qe.qname !== t.byName.fontSize.qname || Qe.qname in re.styleAttrs || re.kind !== "span" || re.styleAttrs[t.byName.ruby.qname] !== "textContainer") if (Qe.qname !== t.byName.fontSize.qname || Qe.qname in re.styleAttrs || re.kind !== "span" || re.styleAttrs[t.byName.ruby.qname] !== "text") Qe.inherit && Qe.qname in P.styleAttrs && !(Qe.qname in re.styleAttrs) && (re.styleAttrs[Qe.qname] = P.styleAttrs[Qe.qname]);
                else {
                  var at = P.styleAttrs[t.byName.fontSize.qname];
                  P.styleAttrs[t.byName.ruby.qname] === "textContainer" ? re.styleAttrs[Qe.qname] = at : re.styleAttrs[Qe.qname] = new e.ComputedLength(0.5 * at.rw, 0.5 * at.rh);
                }
                else {
                  var Ie = P.styleAttrs[t.byName.fontSize.qname];
                  re.styleAttrs[Qe.qname] = new e.ComputedLength(0.5 * Ie.rw, 0.5 * Ie.rh);
                }
              }
              for (var Be = 0; Be < t.all.length; Be++) {
                var It = t.all[Be];
                if (!(It.qname in re.styleAttrs) && !(It.qname === t.byName.position.qname && t.byName.origin.qname in re.styleAttrs || It.qname === t.byName.origin.qname && t.byName.position.qname in re.styleAttrs)) {
                  var _t = d.head.styling.initials[It.qname] || It.initial;
                  if (_t !== null && (re.kind === "region" || It.inherit === !1 && _t !== null)) {
                    var Ve = It.parse(_t);
                    Ve !== null ? (re.styleAttrs[It.qname] = Ve, Re[It.qname] = !0) : f(W, "Invalid initial value for '" + It.qname + "' on element '" + re.kind);
                  }
                }
              }
              for (var ot = 0; ot < t.all.length; ot++) {
                var Ee = t.all[ot];
                if (Ee.qname in Re && Ee.compute !== null) {
                  var Te = Ee.compute(d, P, re, re.styleAttrs[Ee.qname], se);
                  Te !== null ? re.styleAttrs[Ee.qname] = Te : (re.styleAttrs[Ee.qname] = Ee.compute(d, P, re, Ee.parse(Ee.initial), se), f(W, "Style '" + Ee.qname + "' on element '" + re.kind + "' cannot be computed"));
                }
              }
              if (re.styleAttrs[t.byName.display.qname] === "none") return null;
              var je = null;
              P === null ? je = G === null ? [] : [G] : "contents" in M && (je = M.contents);
              for (var c = 0; je !== null && c < je.length; c++) {
                var o = p(d, S, x, G, re, j, je[c], W, se);
                o !== null && re.contents.push(o.element);
              }
              for (var T in re.styleAttrs) if (re.styleAttrs.hasOwnProperty(T)) {
                var b = !1;
                if (re.kind === "span") {
                  var X = re.styleAttrs[t.byName.ruby.qname];
                  (b = (X === "container" || X === "textContainer" || X === "baseContainer") && m.indexOf(T) !== -1) || (b = X !== "container" && T === t.byName.rubyAlign.qname), b || (b = !(X === "textContainer" || X === "text") && T === t.byName.rubyPosition.qname);
                }
                if (!b) {
                  var z = t.byQName[T];
                  "applies" in z && (b = z.applies.indexOf(re.kind) === -1);
                }
                b && delete re.styleAttrs[T];
              }
              var De = re.styleAttrs[t.byName.ruby.qname];
              if (re.kind === "p" || re.kind === "span" && (De === "textContainer" || De === "text")) {
                var tt = [];
                l(re, tt), function(Ue) {
                  for (var ke, Oe = 0; Oe < Ue.length; ) if ((ke = Ue[Oe]).kind !== "br" && ke.space !== "preserve") {
                    var qe = ke.text.replace(/[\t\r\n ]+/g, " ");
                    /^[ ]/.test(qe) && (Oe === 0 || (it = Ue[Oe - 1]).kind === "br" || /[\r\n\t ]$/.test(it.text)) && (qe = qe.substring(1)), ke.text = qe, qe.length === 0 ? Ue.splice(Oe, 1) : Oe++;
                  } else Oe++;
                  var it, bt;
                  for (Oe = 0; Oe < Ue.length; Oe++) (ke = Ue[Oe]).kind !== "br" && ke.space !== "preserve" ? /[ ]$/.test(ke.text) && (Oe === Ue.length - 1 || (bt = Ue[Oe + 1]).kind === "br" || bt.space === "preserve" && /^[\r\n]/.test(bt.text)) && (ke.text = ke.text.slice(0, -1)) : Oe++;
                }(tt), v(re);
              }
              return re.kind === "div" && t.byName.backgroundImage.qname in re.styleAttrs || re.kind === "br" || re.kind === "image" || "contents" in re && re.contents.length > 0 || re.kind === "span" && re.text !== null || re.kind === "region" && re.styleAttrs[t.byName.showBackground.qname] === "always" ? { region_id: j, element: re } : null;
            }
            function l(d, S) {
              if ("contents" in d) for (var x = 0; x < d.contents.length; x++) {
                var G = d.contents[x], P = G.styleAttrs[t.byName.ruby.qname];
                (G.kind !== "span" || P !== "textContainer" && P !== "text") && ("contents" in G ? l(G, S) : (G.kind === "span" && G.text.length !== 0 || G.kind === "br") && S.push(G));
              }
            }
            function v(d) {
              if (d.kind === "br") return !1;
              if ("text" in d) return d.text.length === 0;
              if ("contents" in d) {
                for (var S = d.contents.length; S--; ) v(d.contents[S]) && d.contents.splice(S, 1);
                return d.contents.length === 0;
              }
            }
            function h(d) {
              this.contents = [], this.aspectRatio = d.aspectRatio, this.lang = d.lang;
            }
            function n(d) {
              for (var S in this.kind = d.kind || "region", this.lang = d.lang, d.id && (this.id = d.id), this.styleAttrs = {}, d.styleAttrs) d.styleAttrs.hasOwnProperty(S) && (this.styleAttrs[S] = d.styleAttrs[S]);
              "src" in d && (this.src = d.src), "type" in d && (this.type = d.type), "text" in d ? this.text = d.text : (this.kind === "region" || "contents" in d) && (this.contents = []), "space" in d && (this.space = d.space);
            }
            function f(d, S) {
              if (d && d.error && d.error(S)) throw S;
            }
          })(ge, typeof imscNames > "u" ? R(210) : imscNames, typeof imscStyles > "u" ? R(6811) : imscStyles, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 4403: function(Se, ge, R) {
          ge.generateISD = R(4080).generateISD, ge.fromXML = R(3362).fromXML, ge.renderHTML = R(506).render;
        }, 210: function(Se, ge) {
          (function(R) {
            R.ns_tt = "http://www.w3.org/ns/ttml", R.ns_tts = "http://www.w3.org/ns/ttml#styling", R.ns_ttp = "http://www.w3.org/ns/ttml#parameter", R.ns_xml = "http://www.w3.org/XML/1998/namespace", R.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling", R.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter", R.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt", R.ns_ebutts = "urn:ebu:tt:style";
          })(ge);
        }, 6811: function(Se, ge, R) {
          (function(te, E, t) {
            function e(l, v, h, n, f, d, S, x) {
              this.name = v, this.ns = l, this.qname = l + " " + v, this.inherit = f, this.animatable = d, this.initial = h, this.applies = n, this.parse = S, this.compute = x;
            }
            for (var m in te.all = [new e(E.ns_tts, "backgroundColor", "transparent", ["body", "div", "p", "region", "span"], !1, !0, t.parseColor, null), new e(E.ns_tts, "color", "white", ["span"], !0, !0, t.parseColor, null), new e(E.ns_tts, "direction", "ltr", ["p", "span"], !0, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "display", "auto", ["body", "div", "p", "region", "span"], !1, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "displayAlign", "before", ["region"], !1, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "extent", "auto", ["tt", "region"], !1, !0, function(l) {
              if (l === "auto") return l;
              var v = l.split(" ");
              if (v.length !== 2) return null;
              var h = t.parseLength(v[0]), n = t.parseLength(v[1]);
              return n && h ? { h: n, w: h } : null;
            }, function(l, v, h, n, f) {
              var d, S;
              if (n === "auto") d = new t.ComputedLength(0, 1);
              else if ((d = t.toComputedLength(n.h.value, n.h.unit, null, l.dimensions.h, null, l.pxLength.h)) === null) return null;
              if (n === "auto") S = new t.ComputedLength(1, 0);
              else if ((S = t.toComputedLength(n.w.value, n.w.unit, null, l.dimensions.w, null, l.pxLength.w)) === null) return null;
              return { h: d, w: S };
            }), new e(E.ns_tts, "fontFamily", "default", ["span", "p"], !0, !0, function(l) {
              for (var v = l.split(","), h = [], n = 0; n < v.length; n++) v[n] = v[n].trim(), v[n].charAt(0) !== "'" && v[n].charAt(0) !== '"' && v[n] === "default" ? h.push("monospaceSerif") : h.push(v[n]);
              return h;
            }, null), new e(E.ns_tts, "shear", "0%", ["p"], !0, !0, t.parseLength, function(l, v, h, n) {
              return n.unit !== "%" ? null : Math.abs(n.value) > 100 ? 100 * Math.sign(n.value) : n.value;
            }), new e(E.ns_tts, "fontSize", "1c", ["span", "p"], !0, !0, t.parseLength, function(l, v, h, n, f) {
              return t.toComputedLength(n.value, n.unit, v !== null ? v.styleAttrs[te.byName.fontSize.qname] : l.cellLength.h, v !== null ? v.styleAttrs[te.byName.fontSize.qname] : l.cellLength.h, l.cellLength.h, l.pxLength.h);
            }), new e(E.ns_tts, "fontStyle", "normal", ["span", "p"], !0, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "fontWeight", "normal", ["span", "p"], !0, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "lineHeight", "normal", ["p"], !0, !0, function(l) {
              return l === "normal" ? l : t.parseLength(l);
            }, function(l, v, h, n, f) {
              var d;
              if (n === "normal") d = n;
              else if ((d = t.toComputedLength(n.value, n.unit, h.styleAttrs[te.byName.fontSize.qname], h.styleAttrs[te.byName.fontSize.qname], l.cellLength.h, l.pxLength.h)) === null) return null;
              return d;
            }), new e(E.ns_tts, "opacity", 1, ["region"], !1, !0, parseFloat, null), new e(E.ns_tts, "origin", "auto", ["region"], !1, !0, function(l) {
              if (l === "auto") return l;
              var v = l.split(" ");
              if (v.length !== 2) return null;
              var h = t.parseLength(v[0]), n = t.parseLength(v[1]);
              return n && h ? { h: n, w: h } : null;
            }, function(l, v, h, n, f) {
              var d, S;
              if (n === "auto") d = new t.ComputedLength(0, 0);
              else if ((d = t.toComputedLength(n.h.value, n.h.unit, null, l.dimensions.h, null, l.pxLength.h)) === null) return null;
              if (n === "auto") S = new t.ComputedLength(0, 0);
              else if ((S = t.toComputedLength(n.w.value, n.w.unit, null, l.dimensions.w, null, l.pxLength.w)) === null) return null;
              return { h: d, w: S };
            }), new e(E.ns_tts, "overflow", "hidden", ["region"], !1, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "padding", "0px", ["region"], !1, !0, function(l) {
              var v = l.split(" ");
              if (v.length > 4) return null;
              for (var h = [], n = 0; n < v.length; n++) {
                var f = t.parseLength(v[n]);
                if (!f) return null;
                h.push(f);
              }
              return h;
            }, function(l, v, h, n, f) {
              var d;
              if (n.length === 1) d = [n[0], n[0], n[0], n[0]];
              else if (n.length === 2) d = [n[0], n[1], n[0], n[1]];
              else if (n.length === 3) d = [n[0], n[1], n[2], n[1]];
              else {
                if (n.length !== 4) return null;
                d = [n[0], n[1], n[2], n[3]];
              }
              var S = h.styleAttrs[te.byName.writingMode.qname];
              if (S === "lrtb" || S === "lr") d = [d[0], d[3], d[2], d[1]];
              else if (S === "rltb" || S === "rl") d = [d[0], d[1], d[2], d[3]];
              else if (S === "tblr") d = [d[3], d[0], d[1], d[2]];
              else {
                if (S !== "tbrl" && S !== "tb") return null;
                d = [d[3], d[2], d[1], d[0]];
              }
              for (var x = [], G = 0; G < d.length; G++) if (d[G].value === 0) x[G] = new t.ComputedLength(0, 0);
              else if (x[G] = t.toComputedLength(d[G].value, d[G].unit, h.styleAttrs[te.byName.fontSize.qname], G === 0 || G === 2 ? h.styleAttrs[te.byName.extent.qname].h : h.styleAttrs[te.byName.extent.qname].w, G === 0 || G === 2 ? l.cellLength.h : l.cellLength.w, G === 0 || G === 2 ? l.pxLength.h : l.pxLength.w), x[G] === null) return null;
              return x;
            }), new e(E.ns_tts, "position", "top left", ["region"], !1, !0, function(l) {
              return t.parsePosition(l);
            }, function(l, v, h, n) {
              var f, d;
              return (f = t.toComputedLength(n.v.offset.value, n.v.offset.unit, null, new t.ComputedLength(-h.styleAttrs[te.byName.extent.qname].h.rw, l.dimensions.h.rh - h.styleAttrs[te.byName.extent.qname].h.rh), null, l.pxLength.h)) === null ? null : (n.v.edge === "bottom" && (f = new t.ComputedLength(-f.rw - h.styleAttrs[te.byName.extent.qname].h.rw, l.dimensions.h.rh - f.rh - h.styleAttrs[te.byName.extent.qname].h.rh)), d = t.toComputedLength(n.h.offset.value, n.h.offset.unit, null, new t.ComputedLength(l.dimensions.w.rw - h.styleAttrs[te.byName.extent.qname].w.rw, -h.styleAttrs[te.byName.extent.qname].w.rh), null, l.pxLength.w), f === null ? null : (n.h.edge === "right" && (d = new t.ComputedLength(l.dimensions.w.rw - d.rw - h.styleAttrs[te.byName.extent.qname].w.rw, -d.rh - h.styleAttrs[te.byName.extent.qname].w.rh)), { h: f, w: d }));
            }), new e(E.ns_tts, "ruby", "none", ["span"], !1, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "rubyAlign", "center", ["span"], !0, !0, function(l) {
              return l !== "center" && l !== "spaceAround" ? null : l;
            }, null), new e(E.ns_tts, "rubyPosition", "outside", ["span"], !0, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "rubyReserve", "none", ["p"], !0, !0, function(l) {
              var v = l.split(" "), h = [null, null];
              if (v.length === 0 || v.length > 2 || v[0] !== "none" && v[0] !== "both" && v[0] !== "after" && v[0] !== "before" && v[0] !== "outside") return null;
              if (h[0] = v[0], v.length === 2 && v[0] !== "none") {
                var n = t.parseLength(v[1]);
                if (!n) return null;
                h[1] = n;
              }
              return h;
            }, function(l, v, h, n, f) {
              if (n[0] === "none") return n;
              var d;
              return (d = n[1] === null ? new t.ComputedLength(0.5 * h.styleAttrs[te.byName.fontSize.qname].rw, 0.5 * h.styleAttrs[te.byName.fontSize.qname].rh) : t.toComputedLength(n[1].value, n[1].unit, h.styleAttrs[te.byName.fontSize.qname], h.styleAttrs[te.byName.fontSize.qname], l.cellLength.h, l.pxLength.h)) === null ? null : [n[0], d];
            }), new e(E.ns_tts, "showBackground", "always", ["region"], !1, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "textAlign", "start", ["p"], !0, !0, function(l) {
              return l;
            }, function(l, v, h, n, f) {
              return n === "left" ? "start" : n === "right" ? "end" : n;
            }), new e(E.ns_tts, "textCombine", "none", ["span"], !0, !0, function(l) {
              return l === "none" || l === "all" ? l : null;
            }, null), new e(E.ns_tts, "textDecoration", "none", ["span"], !0, !0, function(l) {
              return l.split(" ");
            }, null), new e(E.ns_tts, "textEmphasis", "none", ["span"], !0, !0, function(l) {
              for (var v = l.split(" "), h = { style: null, symbol: null, color: null, position: null }, n = 0; n < v.length; n++) if (v[n] === "none" || v[n] === "auto") h.style = v[n];
              else if (v[n] === "filled" || v[n] === "open") h.style = v[n];
              else if (v[n] === "circle" || v[n] === "dot" || v[n] === "sesame") h.symbol = v[n];
              else if (v[n] === "current") h.color = v[n];
              else if (v[n] === "outside" || v[n] === "before" || v[n] === "after") h.position = v[n];
              else if (h.color = t.parseColor(v[n]), h.color === null) return null;
              return h.style == null && h.symbol == null ? h.style = "auto" : (h.symbol = h.symbol || "circle", h.style = h.style || "filled"), h.position = h.position || "outside", h.color = h.color || "current", h;
            }, null), new e(E.ns_tts, "textOutline", "none", ["span"], !0, !0, function(l) {
              if (l === "none") return l;
              var v = {}, h = l.split(" ");
              if (h.length === 0 || h.length > 2) return null;
              var n = t.parseColor(h[0]);
              if (v.color = n, n !== null && h.shift(), h.length !== 1) return null;
              var f = t.parseLength(h[0]);
              return f ? (v.thickness = f, v) : null;
            }, function(l, v, h, n, f) {
              if (n === "none") return n;
              var d = {};
              return n.color === null ? d.color = h.styleAttrs[te.byName.color.qname] : d.color = n.color, d.thickness = t.toComputedLength(n.thickness.value, n.thickness.unit, h.styleAttrs[te.byName.fontSize.qname], h.styleAttrs[te.byName.fontSize.qname], l.cellLength.h, l.pxLength.h), d.thickness === null ? null : d;
            }), new e(E.ns_tts, "textShadow", "none", ["span"], !0, !0, t.parseTextShadow, function(l, v, h, n) {
              if (n === "none") return n;
              for (var f = [], d = 0; d < n.length; d++) {
                var S = {};
                if (S.x_off = t.toComputedLength(n[d][0].value, n[d][0].unit, null, h.styleAttrs[te.byName.fontSize.qname], null, l.pxLength.w), S.x_off === null || (S.y_off = t.toComputedLength(n[d][1].value, n[d][1].unit, null, h.styleAttrs[te.byName.fontSize.qname], null, l.pxLength.h), S.y_off === null)) return null;
                if (n[d][2] === null) S.b_radius = 0;
                else if (S.b_radius = t.toComputedLength(n[d][2].value, n[d][2].unit, null, h.styleAttrs[te.byName.fontSize.qname], null, l.pxLength.h), S.b_radius === null) return null;
                n[d][3] === null ? S.color = h.styleAttrs[te.byName.color.qname] : S.color = n[d][3], f.push(S);
              }
              return f;
            }), new e(E.ns_tts, "unicodeBidi", "normal", ["span", "p"], !1, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "visibility", "visible", ["body", "div", "p", "region", "span"], !0, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "wrapOption", "wrap", ["span"], !0, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "writingMode", "lrtb", ["region"], !1, !0, function(l) {
              return l;
            }, null), new e(E.ns_tts, "zIndex", "auto", ["region"], !1, !0, function(l) {
              var v;
              return l === "auto" ? v = l : (v = parseInt(l), isNaN(v) && (v = null)), v;
            }, null), new e(E.ns_ebutts, "linePadding", "0c", ["p"], !0, !1, t.parseLength, function(l, v, h, n, f) {
              return t.toComputedLength(n.value, n.unit, null, null, l.cellLength.w, null);
            }), new e(E.ns_ebutts, "multiRowAlign", "auto", ["p"], !0, !1, function(l) {
              return l;
            }, null), new e(E.ns_smpte, "backgroundImage", null, ["div"], !1, !1, function(l) {
              return l;
            }, null), new e(E.ns_itts, "forcedDisplay", "false", ["body", "div", "p", "region", "span"], !0, !0, function(l) {
              return l === "true";
            }, null), new e(E.ns_itts, "fillLineGap", "false", ["p"], !0, !0, function(l) {
              return l === "true";
            }, null)], te.byQName = {}, te.all) te.byQName[te.all[m].qname] = te.all[m];
            for (var p in te.byName = {}, te.all) te.byName[te.all[p].name] = te.all[p];
          })(ge, typeof imscNames > "u" ? R(210) : imscNames, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 5926: function(Se, ge) {
          (function(R) {
            var te = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/, E = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, t = /rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, e = { transparent: [0, 0, 0, 0], black: [0, 0, 0, 255], silver: [192, 192, 192, 255], gray: [128, 128, 128, 255], white: [255, 255, 255, 255], maroon: [128, 0, 0, 255], red: [255, 0, 0, 255], purple: [128, 0, 128, 255], fuchsia: [255, 0, 255, 255], magenta: [255, 0, 255, 255], green: [0, 128, 0, 255], lime: [0, 255, 0, 255], olive: [128, 128, 0, 255], yellow: [255, 255, 0, 255], navy: [0, 0, 128, 255], blue: [0, 0, 255, 255], teal: [0, 128, 128, 255], aqua: [0, 255, 255, 255], cyan: [0, 255, 255, 255] };
            R.parseColor = function(p) {
              var l, v = null, h = e[p.toLowerCase()];
              return h !== void 0 ? v = h : (l = te.exec(p)) !== null ? v = [parseInt(l[1], 16), parseInt(l[2], 16), parseInt(l[3], 16), l[4] !== void 0 ? parseInt(l[4], 16) : 255] : (l = E.exec(p)) !== null ? v = [parseInt(l[1]), parseInt(l[2]), parseInt(l[3]), 255] : (l = t.exec(p)) !== null && (v = [parseInt(l[1]), parseInt(l[2]), parseInt(l[3]), parseInt(l[4])]), v;
            };
            var m = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%|rh|rw)$/;
            R.parseLength = function(p) {
              var l, v = null;
              return (l = m.exec(p)) !== null && (v = { value: parseFloat(l[1]), unit: l[2] }), v;
            }, R.parseTextShadow = function(p) {
              for (var l = p.match(/([^\(,\)]|\([^\)]+\))+/g), v = [], h = 0; h < l.length; h++) {
                var n = l[h].split(" ");
                if (n.length === 1 && n[0] === "none") return "none";
                if (n.length > 1 && n.length < 5) {
                  var f = [null, null, null, null], d = R.parseLength(n.shift());
                  if (d === null || (f[0] = d, (d = R.parseLength(n.shift())) === null)) return null;
                  if (f[1] = d, n.length === 0) {
                    v.push(f);
                    continue;
                  }
                  if ((d = R.parseLength(n[0])) !== null && (f[2] = d, n.shift()), n.length === 0) {
                    v.push(f);
                    continue;
                  }
                  var S = R.parseColor(n[0]);
                  if (S === null) return null;
                  f[3] = S, v.push(f);
                }
              }
              return v;
            }, R.parsePosition = function(p) {
              var l = p.split(" "), v = function(G) {
                return G === "center" || G === "left" || G === "top" || G === "bottom" || G === "right";
              };
              if (l.length > 4) return null;
              for (var h = 0; h < l.length; h++) if (!v(l[h])) {
                var n = R.parseLength(l[h]);
                if (n === null) return null;
                l[h] = n;
              }
              for (var f = { h: { edge: "left", offset: { value: 50, unit: "%" } }, v: { edge: "top", offset: { value: 50, unit: "%" } } }, d = 0; d < l.length; ) {
                var S = l[d++];
                if (v(S)) {
                  var x = { value: 0, unit: "%" };
                  l.length !== 2 && d < l.length && !v(l[d]) && (x = l[d++]), S === "right" ? (f.h.edge = S, f.h.offset = x) : S === "bottom" ? (f.v.edge = S, f.v.offset = x) : S === "left" ? f.h.offset = x : S === "top" && (f.v.offset = x);
                } else {
                  if (l.length !== 1 && l.length !== 2) return null;
                  d === 1 ? f.h.offset = S : f.v.offset = S;
                }
              }
              return f;
            }, R.ComputedLength = function(p, l) {
              this.rw = p, this.rh = l;
            }, R.ComputedLength.prototype.toUsedLength = function(p, l) {
              return p * this.rw + l * this.rh;
            }, R.ComputedLength.prototype.isZero = function() {
              return this.rw === 0 && this.rh === 0;
            }, R.toComputedLength = function(p, l, v, h, n, f) {
              return l === "%" && h ? new R.ComputedLength(h.rw * p / 100, h.rh * p / 100) : l === "em" && v ? new R.ComputedLength(v.rw * p, v.rh * p) : l === "c" && n ? new R.ComputedLength(p * n.rw, p * n.rh) : l === "px" && f ? new R.ComputedLength(p * f.rw, p * f.rh) : l === "rh" ? new R.ComputedLength(0, p / 100) : l === "rw" ? new R.ComputedLength(p / 100, 0) : null;
            };
          })(ge);
        }, 3516: function(Se) {
          Se.exports = function(ge) {
            var R = typeof ge == "string" ? ge.charCodeAt(0) : ge;
            return R >= 97 && R <= 122 || R >= 65 && R <= 90;
          };
        }, 2219: function(Se, ge, R) {
          var te = R(3516), E = R(395);
          Se.exports = function(t) {
            return te(t) || E(t);
          };
        }, 395: function(Se) {
          Se.exports = function(ge) {
            var R = typeof ge == "string" ? ge.charCodeAt(0) : ge;
            return R >= 48 && R <= 57;
          };
        }, 3875: function(Se) {
          function ge(E) {
            if (typeof E != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(E));
          }
          function R(E, t) {
            for (var e, m = "", p = 0, l = -1, v = 0, h = 0; h <= E.length; ++h) {
              if (h < E.length) e = E.charCodeAt(h);
              else {
                if (e === 47) break;
                e = 47;
              }
              if (e === 47) {
                if (!(l === h - 1 || v === 1)) if (l !== h - 1 && v === 2) {
                  if (m.length < 2 || p !== 2 || m.charCodeAt(m.length - 1) !== 46 || m.charCodeAt(m.length - 2) !== 46) {
                    if (m.length > 2) {
                      var n = m.lastIndexOf("/");
                      if (n !== m.length - 1) {
                        n === -1 ? (m = "", p = 0) : p = (m = m.slice(0, n)).length - 1 - m.lastIndexOf("/"), l = h, v = 0;
                        continue;
                      }
                    } else if (m.length === 2 || m.length === 1) {
                      m = "", p = 0, l = h, v = 0;
                      continue;
                    }
                  }
                  t && (m.length > 0 ? m += "/.." : m = "..", p = 2);
                } else m.length > 0 ? m += "/" + E.slice(l + 1, h) : m = E.slice(l + 1, h), p = h - l - 1;
                l = h, v = 0;
              } else e === 46 && v !== -1 ? ++v : v = -1;
            }
            return m;
          }
          var te = { resolve: function() {
            for (var E, t = "", e = !1, m = arguments.length - 1; m >= -1 && !e; m--) {
              var p;
              m >= 0 ? p = arguments[m] : (E === void 0 && (E = process.cwd()), p = E), ge(p), p.length !== 0 && (t = p + "/" + t, e = p.charCodeAt(0) === 47);
            }
            return t = R(t, !e), e ? t.length > 0 ? "/" + t : "/" : t.length > 0 ? t : ".";
          }, normalize: function(E) {
            if (ge(E), E.length === 0) return ".";
            var t = E.charCodeAt(0) === 47, e = E.charCodeAt(E.length - 1) === 47;
            return (E = R(E, !t)).length !== 0 || t || (E = "."), E.length > 0 && e && (E += "/"), t ? "/" + E : E;
          }, isAbsolute: function(E) {
            return ge(E), E.length > 0 && E.charCodeAt(0) === 47;
          }, join: function() {
            if (arguments.length === 0) return ".";
            for (var E, t = 0; t < arguments.length; ++t) {
              var e = arguments[t];
              ge(e), e.length > 0 && (E === void 0 ? E = e : E += "/" + e);
            }
            return E === void 0 ? "." : te.normalize(E);
          }, relative: function(E, t) {
            if (ge(E), ge(t), E === t || (E = te.resolve(E)) === (t = te.resolve(t))) return "";
            for (var e = 1; e < E.length && E.charCodeAt(e) === 47; ++e) ;
            for (var m = E.length, p = m - e, l = 1; l < t.length && t.charCodeAt(l) === 47; ++l) ;
            for (var v = t.length - l, h = p < v ? p : v, n = -1, f = 0; f <= h; ++f) {
              if (f === h) {
                if (v > h) {
                  if (t.charCodeAt(l + f) === 47) return t.slice(l + f + 1);
                  if (f === 0) return t.slice(l + f);
                } else p > h && (E.charCodeAt(e + f) === 47 ? n = f : f === 0 && (n = 0));
                break;
              }
              var d = E.charCodeAt(e + f);
              if (d !== t.charCodeAt(l + f)) break;
              d === 47 && (n = f);
            }
            var S = "";
            for (f = e + n + 1; f <= m; ++f) f !== m && E.charCodeAt(f) !== 47 || (S.length === 0 ? S += ".." : S += "/..");
            return S.length > 0 ? S + t.slice(l + n) : (l += n, t.charCodeAt(l) === 47 && ++l, t.slice(l));
          }, _makeLong: function(E) {
            return E;
          }, dirname: function(E) {
            if (ge(E), E.length === 0) return ".";
            for (var t = E.charCodeAt(0), e = t === 47, m = -1, p = !0, l = E.length - 1; l >= 1; --l) if ((t = E.charCodeAt(l)) === 47) {
              if (!p) {
                m = l;
                break;
              }
            } else p = !1;
            return m === -1 ? e ? "/" : "." : e && m === 1 ? "//" : E.slice(0, m);
          }, basename: function(E, t) {
            if (t !== void 0 && typeof t != "string") throw new TypeError('"ext" argument must be a string');
            ge(E);
            var e, m = 0, p = -1, l = !0;
            if (t !== void 0 && t.length > 0 && t.length <= E.length) {
              if (t.length === E.length && t === E) return "";
              var v = t.length - 1, h = -1;
              for (e = E.length - 1; e >= 0; --e) {
                var n = E.charCodeAt(e);
                if (n === 47) {
                  if (!l) {
                    m = e + 1;
                    break;
                  }
                } else h === -1 && (l = !1, h = e + 1), v >= 0 && (n === t.charCodeAt(v) ? --v == -1 && (p = e) : (v = -1, p = h));
              }
              return m === p ? p = h : p === -1 && (p = E.length), E.slice(m, p);
            }
            for (e = E.length - 1; e >= 0; --e) if (E.charCodeAt(e) === 47) {
              if (!l) {
                m = e + 1;
                break;
              }
            } else p === -1 && (l = !1, p = e + 1);
            return p === -1 ? "" : E.slice(m, p);
          }, extname: function(E) {
            ge(E);
            for (var t = -1, e = 0, m = -1, p = !0, l = 0, v = E.length - 1; v >= 0; --v) {
              var h = E.charCodeAt(v);
              if (h !== 47) m === -1 && (p = !1, m = v + 1), h === 46 ? t === -1 ? t = v : l !== 1 && (l = 1) : t !== -1 && (l = -1);
              else if (!p) {
                e = v + 1;
                break;
              }
            }
            return t === -1 || m === -1 || l === 0 || l === 1 && t === m - 1 && t === e + 1 ? "" : E.slice(t, m);
          }, format: function(E) {
            if (E === null || typeof E != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof E);
            return function(t, e) {
              var m = e.dir || e.root, p = e.base || (e.name || "") + (e.ext || "");
              return m ? m === e.root ? m + p : m + "/" + p : p;
            }(0, E);
          }, parse: function(E) {
            ge(E);
            var t = { root: "", dir: "", base: "", ext: "", name: "" };
            if (E.length === 0) return t;
            var e, m = E.charCodeAt(0), p = m === 47;
            p ? (t.root = "/", e = 1) : e = 0;
            for (var l = -1, v = 0, h = -1, n = !0, f = E.length - 1, d = 0; f >= e; --f) if ((m = E.charCodeAt(f)) !== 47) h === -1 && (n = !1, h = f + 1), m === 46 ? l === -1 ? l = f : d !== 1 && (d = 1) : l !== -1 && (d = -1);
            else if (!n) {
              v = f + 1;
              break;
            }
            return l === -1 || h === -1 || d === 0 || d === 1 && l === h - 1 && l === v + 1 ? h !== -1 && (t.base = t.name = v === 0 && p ? E.slice(1, h) : E.slice(v, h)) : (v === 0 && p ? (t.name = E.slice(1, l), t.base = E.slice(1, h)) : (t.name = E.slice(v, l), t.base = E.slice(v, h)), t.ext = E.slice(l, h)), v > 0 ? t.dir = E.slice(0, v - 1) : p && (t.dir = "/"), t;
          }, sep: "/", delimiter: ":", win32: null, posix: null };
          te.posix = te, Se.exports = te;
        }, 8387: function(Se, ge, R) {
          var te = R(1549), E = te.Buffer;
          function t(m, p) {
            for (var l in m) p[l] = m[l];
          }
          function e(m, p, l) {
            return E(m, p, l);
          }
          E.from && E.alloc && E.allocUnsafe && E.allocUnsafeSlow ? Se.exports = te : (t(te, ge), ge.Buffer = e), t(E, e), e.from = function(m, p, l) {
            if (typeof m == "number") throw new TypeError("Argument must not be a number");
            return E(m, p, l);
          }, e.alloc = function(m, p, l) {
            if (typeof m != "number") throw new TypeError("Argument must be a number");
            var v = E(m);
            return p !== void 0 ? typeof l == "string" ? v.fill(p, l) : v.fill(p) : v.fill(0), v;
          }, e.allocUnsafe = function(m) {
            if (typeof m != "number") throw new TypeError("Argument must be a number");
            return E(m);
          }, e.allocUnsafeSlow = function(m) {
            if (typeof m != "number") throw new TypeError("Argument must be a number");
            return te.SlowBuffer(m);
          };
        }, 5378: function(Se, ge, R) {
          (function(te) {
            te.parser = function(c, o) {
              return new e(c, o);
            }, te.SAXParser = e, te.SAXStream = p, te.createStream = function(c, o) {
              return new p(c, o);
            }, te.MAX_BUFFER_LENGTH = 65536;
            var E, t = ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"];
            function e(c, o) {
              if (!(this instanceof e)) return new e(c, o);
              var T = this;
              (function(b) {
                for (var X = 0, z = t.length; X < z; X++) b[t[X]] = "";
              })(T), T.q = T.c = "", T.bufferCheckPosition = te.MAX_BUFFER_LENGTH, T.opt = o || {}, T.opt.lowercase = T.opt.lowercase || T.opt.lowercasetags, T.looseCase = T.opt.lowercase ? "toLowerCase" : "toUpperCase", T.tags = [], T.closed = T.closedRoot = T.sawRoot = !1, T.tag = T.error = null, T.strict = !!c, T.noscript = !(!c && !T.opt.noscript), T.state = $.BEGIN, T.strictEntities = T.opt.strictEntities, T.ENTITIES = T.strictEntities ? Object.create(te.XML_ENTITIES) : Object.create(te.ENTITIES), T.attribList = [], T.opt.xmlns && (T.ns = Object.create(x)), T.trackPosition = T.opt.position !== !1, T.trackPosition && (T.position = T.line = T.column = 0), Ge(T, "onready");
            }
            te.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function(c) {
              function o() {
              }
              return o.prototype = c, new o();
            }), Object.keys || (Object.keys = function(c) {
              var o = [];
              for (var T in c) c.hasOwnProperty(T) && o.push(T);
              return o;
            }), e.prototype = { end: function() {
              at(this);
            }, write: function(c) {
              var o = this;
              if (this.error) throw this.error;
              if (o.closed) return Xe(o, "Cannot write after close. Assign an onready handler.");
              if (c === null) return at(o);
              typeof c == "object" && (c = c.toString());
              for (var T = 0, b = ""; b = je(c, T++), o.c = b, b; ) switch (o.trackPosition && (o.position++, b === `
` ? (o.line++, o.column = 0) : o.column++), o.state) {
                case $.BEGIN:
                  if (o.state = $.BEGIN_WHITESPACE, b === "\uFEFF") continue;
                  Te(o, b);
                  continue;
                case $.BEGIN_WHITESPACE:
                  Te(o, b);
                  continue;
                case $.TEXT:
                  if (o.sawRoot && !o.closedRoot) {
                    for (var X = T - 1; b && b !== "<" && b !== "&"; ) (b = je(c, T++)) && o.trackPosition && (o.position++, b === `
` ? (o.line++, o.column = 0) : o.column++);
                    o.textNode += c.substring(X, T - 1);
                  }
                  b !== "<" || o.sawRoot && o.closedRoot && !o.strict ? (!j(l, b) || o.sawRoot && !o.closedRoot || Ie(o, "Text data outside of root node."), b === "&" ? o.state = $.TEXT_ENTITY : o.textNode += b) : (o.state = $.OPEN_WAKA, o.startTagPosition = o.position);
                  continue;
                case $.SCRIPT:
                  b === "<" ? o.state = $.SCRIPT_ENDING : o.script += b;
                  continue;
                case $.SCRIPT_ENDING:
                  b === "/" ? o.state = $.CLOSE_TAG : (o.script += "<" + b, o.state = $.SCRIPT);
                  continue;
                case $.OPEN_WAKA:
                  if (b === "!") o.state = $.SGML_DECL, o.sgmlDecl = "";
                  else if (!se(l, b)) if (se(G, b)) o.state = $.OPEN_TAG, o.tagName = b;
                  else if (b === "/") o.state = $.CLOSE_TAG, o.tagName = "";
                  else if (b === "?") o.state = $.PROC_INST, o.procInstName = o.procInstBody = "";
                  else {
                    if (Ie(o, "Unencoded <"), o.startTagPosition + 1 < o.position) {
                      var z = o.position - o.startTagPosition;
                      b = new Array(z).join(" ") + b;
                    }
                    o.textNode += "<" + b, o.state = $.TEXT;
                  }
                  continue;
                case $.SGML_DECL:
                  (o.sgmlDecl + b).toUpperCase() === "[CDATA[" ? (Qe(o, "onopencdata"), o.state = $.CDATA, o.sgmlDecl = "", o.cdata = "") : o.sgmlDecl + b === "--" ? (o.state = $.COMMENT, o.comment = "", o.sgmlDecl = "") : (o.sgmlDecl + b).toUpperCase() === "DOCTYPE" ? (o.state = $.DOCTYPE, (o.doctype || o.sawRoot) && Ie(o, "Inappropriately located doctype declaration"), o.doctype = "", o.sgmlDecl = "") : b === ">" ? (Qe(o, "onsgmldeclaration", o.sgmlDecl), o.sgmlDecl = "", o.state = $.TEXT) : (se(n, b) && (o.state = $.SGML_DECL_QUOTED), o.sgmlDecl += b);
                  continue;
                case $.SGML_DECL_QUOTED:
                  b === o.q && (o.state = $.SGML_DECL, o.q = ""), o.sgmlDecl += b;
                  continue;
                case $.DOCTYPE:
                  b === ">" ? (o.state = $.TEXT, Qe(o, "ondoctype", o.doctype), o.doctype = !0) : (o.doctype += b, b === "[" ? o.state = $.DOCTYPE_DTD : se(n, b) && (o.state = $.DOCTYPE_QUOTED, o.q = b));
                  continue;
                case $.DOCTYPE_QUOTED:
                  o.doctype += b, b === o.q && (o.q = "", o.state = $.DOCTYPE);
                  continue;
                case $.DOCTYPE_DTD:
                  o.doctype += b, b === "]" ? o.state = $.DOCTYPE : se(n, b) && (o.state = $.DOCTYPE_DTD_QUOTED, o.q = b);
                  continue;
                case $.DOCTYPE_DTD_QUOTED:
                  o.doctype += b, b === o.q && (o.state = $.DOCTYPE_DTD, o.q = "");
                  continue;
                case $.COMMENT:
                  b === "-" ? o.state = $.COMMENT_ENDING : o.comment += b;
                  continue;
                case $.COMMENT_ENDING:
                  b === "-" ? (o.state = $.COMMENT_ENDED, o.comment = Ze(o.opt, o.comment), o.comment && Qe(o, "oncomment", o.comment), o.comment = "") : (o.comment += "-" + b, o.state = $.COMMENT);
                  continue;
                case $.COMMENT_ENDED:
                  b !== ">" ? (Ie(o, "Malformed comment"), o.comment += "--" + b, o.state = $.COMMENT) : o.state = $.TEXT;
                  continue;
                case $.CDATA:
                  b === "]" ? o.state = $.CDATA_ENDING : o.cdata += b;
                  continue;
                case $.CDATA_ENDING:
                  b === "]" ? o.state = $.CDATA_ENDING_2 : (o.cdata += "]" + b, o.state = $.CDATA);
                  continue;
                case $.CDATA_ENDING_2:
                  b === ">" ? (o.cdata && Qe(o, "oncdata", o.cdata), Qe(o, "onclosecdata"), o.cdata = "", o.state = $.TEXT) : b === "]" ? o.cdata += "]" : (o.cdata += "]]" + b, o.state = $.CDATA);
                  continue;
                case $.PROC_INST:
                  b === "?" ? o.state = $.PROC_INST_ENDING : se(l, b) ? o.state = $.PROC_INST_BODY : o.procInstName += b;
                  continue;
                case $.PROC_INST_BODY:
                  if (!o.procInstBody && se(l, b)) continue;
                  b === "?" ? o.state = $.PROC_INST_ENDING : o.procInstBody += b;
                  continue;
                case $.PROC_INST_ENDING:
                  b === ">" ? (Qe(o, "onprocessinginstruction", { name: o.procInstName, body: o.procInstBody }), o.procInstName = o.procInstBody = "", o.state = $.TEXT) : (o.procInstBody += "?" + b, o.state = $.PROC_INST_BODY);
                  continue;
                case $.OPEN_TAG:
                  se(P, b) ? o.tagName += b : (Be(o), b === ">" ? Ve(o) : b === "/" ? o.state = $.OPEN_TAG_SLASH : (j(l, b) && Ie(o, "Invalid character in tag name"), o.state = $.ATTRIB));
                  continue;
                case $.OPEN_TAG_SLASH:
                  b === ">" ? (Ve(o, !0), ot(o)) : (Ie(o, "Forward-slash in opening tag not followed by >"), o.state = $.ATTRIB);
                  continue;
                case $.ATTRIB:
                  if (se(l, b)) continue;
                  b === ">" ? Ve(o) : b === "/" ? o.state = $.OPEN_TAG_SLASH : se(G, b) ? (o.attribName = b, o.attribValue = "", o.state = $.ATTRIB_NAME) : Ie(o, "Invalid attribute name");
                  continue;
                case $.ATTRIB_NAME:
                  b === "=" ? o.state = $.ATTRIB_VALUE : b === ">" ? (Ie(o, "Attribute without value"), o.attribValue = o.attribName, _t(o), Ve(o)) : se(l, b) ? o.state = $.ATTRIB_NAME_SAW_WHITE : se(P, b) ? o.attribName += b : Ie(o, "Invalid attribute name");
                  continue;
                case $.ATTRIB_NAME_SAW_WHITE:
                  if (b === "=") o.state = $.ATTRIB_VALUE;
                  else {
                    if (se(l, b)) continue;
                    Ie(o, "Attribute without value"), o.tag.attributes[o.attribName] = "", o.attribValue = "", Qe(o, "onattribute", { name: o.attribName, value: "" }), o.attribName = "", b === ">" ? Ve(o) : se(G, b) ? (o.attribName = b, o.state = $.ATTRIB_NAME) : (Ie(o, "Invalid attribute name"), o.state = $.ATTRIB);
                  }
                  continue;
                case $.ATTRIB_VALUE:
                  if (se(l, b)) continue;
                  se(n, b) ? (o.q = b, o.state = $.ATTRIB_VALUE_QUOTED) : (Ie(o, "Unquoted attribute value"), o.state = $.ATTRIB_VALUE_UNQUOTED, o.attribValue = b);
                  continue;
                case $.ATTRIB_VALUE_QUOTED:
                  if (b !== o.q) {
                    b === "&" ? o.state = $.ATTRIB_VALUE_ENTITY_Q : o.attribValue += b;
                    continue;
                  }
                  _t(o), o.q = "", o.state = $.ATTRIB_VALUE_CLOSED;
                  continue;
                case $.ATTRIB_VALUE_CLOSED:
                  se(l, b) ? o.state = $.ATTRIB : b === ">" ? Ve(o) : b === "/" ? o.state = $.OPEN_TAG_SLASH : se(G, b) ? (Ie(o, "No whitespace between attributes"), o.attribName = b, o.attribValue = "", o.state = $.ATTRIB_NAME) : Ie(o, "Invalid attribute name");
                  continue;
                case $.ATTRIB_VALUE_UNQUOTED:
                  if (j(f, b)) {
                    b === "&" ? o.state = $.ATTRIB_VALUE_ENTITY_U : o.attribValue += b;
                    continue;
                  }
                  _t(o), b === ">" ? Ve(o) : o.state = $.ATTRIB;
                  continue;
                case $.CLOSE_TAG:
                  if (o.tagName) b === ">" ? ot(o) : se(P, b) ? o.tagName += b : o.script ? (o.script += "</" + o.tagName, o.tagName = "", o.state = $.SCRIPT) : (j(l, b) && Ie(o, "Invalid tagname in closing tag"), o.state = $.CLOSE_TAG_SAW_WHITE);
                  else {
                    if (se(l, b)) continue;
                    j(G, b) ? o.script ? (o.script += "</" + b, o.state = $.SCRIPT) : Ie(o, "Invalid tagname in closing tag.") : o.tagName = b;
                  }
                  continue;
                case $.CLOSE_TAG_SAW_WHITE:
                  if (se(l, b)) continue;
                  b === ">" ? ot(o) : Ie(o, "Invalid characters in closing tag");
                  continue;
                case $.TEXT_ENTITY:
                case $.ATTRIB_VALUE_ENTITY_Q:
                case $.ATTRIB_VALUE_ENTITY_U:
                  var De, tt;
                  switch (o.state) {
                    case $.TEXT_ENTITY:
                      De = $.TEXT, tt = "textNode";
                      break;
                    case $.ATTRIB_VALUE_ENTITY_Q:
                      De = $.ATTRIB_VALUE_QUOTED, tt = "attribValue";
                      break;
                    case $.ATTRIB_VALUE_ENTITY_U:
                      De = $.ATTRIB_VALUE_UNQUOTED, tt = "attribValue";
                  }
                  b === ";" ? (o[tt] += Ee(o), o.entity = "", o.state = De) : se(o.entity.length ? M : J, b) ? o.entity += b : (Ie(o, "Invalid character in entity name"), o[tt] += "&" + o.entity + b, o.entity = "", o.state = De);
                  continue;
                default:
                  throw new Error(o, "Unknown state: " + o.state);
              }
              return o.position >= o.bufferCheckPosition && function(Ue) {
                for (var ke = Math.max(te.MAX_BUFFER_LENGTH, 10), Oe = 0, qe = 0, it = t.length; qe < it; qe++) {
                  var bt = Ue[t[qe]].length;
                  if (bt > ke) switch (t[qe]) {
                    case "textNode":
                      Ae(Ue);
                      break;
                    case "cdata":
                      Qe(Ue, "oncdata", Ue.cdata), Ue.cdata = "";
                      break;
                    case "script":
                      Qe(Ue, "onscript", Ue.script), Ue.script = "";
                      break;
                    default:
                      Xe(Ue, "Max buffer length exceeded: " + t[qe]);
                  }
                  Oe = Math.max(Oe, bt);
                }
                var dt = te.MAX_BUFFER_LENGTH - Oe;
                Ue.bufferCheckPosition = dt + Ue.position;
              }(o), o;
            }, resume: function() {
              return this.error = null, this;
            }, close: function() {
              return this.write(null);
            }, flush: function() {
              var c;
              Ae(c = this), c.cdata !== "" && (Qe(c, "oncdata", c.cdata), c.cdata = ""), c.script !== "" && (Qe(c, "onscript", c.script), c.script = "");
            } };
            try {
              E = R(182).Stream;
            } catch {
              E = function() {
              };
            }
            var m = te.EVENTS.filter(function(c) {
              return c !== "error" && c !== "end";
            });
            function p(c, o) {
              if (!(this instanceof p)) return new p(c, o);
              E.apply(this), this._parser = new e(c, o), this.writable = !0, this.readable = !0;
              var T = this;
              this._parser.onend = function() {
                T.emit("end");
              }, this._parser.onerror = function(b) {
                T.emit("error", b), T._parser.error = null;
              }, this._decoder = null, m.forEach(function(b) {
                Object.defineProperty(T, "on" + b, { get: function() {
                  return T._parser["on" + b];
                }, set: function(X) {
                  if (!X) return T.removeAllListeners(b), T._parser["on" + b] = X, X;
                  T.on(b, X);
                }, enumerable: !0, configurable: !1 });
              });
            }
            p.prototype = Object.create(E.prototype, { constructor: { value: p } }), p.prototype.write = function(c) {
              if (typeof Buffer == "function" && typeof Buffer.isBuffer == "function" && Buffer.isBuffer(c)) {
                if (!this._decoder) {
                  var o = R(7503).s;
                  this._decoder = new o("utf8");
                }
                c = this._decoder.write(c);
              }
              return this._parser.write(c.toString()), this.emit("data", c), !0;
            }, p.prototype.end = function(c) {
              return c && c.length && this.write(c), this._parser.end(), !0;
            }, p.prototype.on = function(c, o) {
              var T = this;
              return T._parser["on" + c] || m.indexOf(c) === -1 || (T._parser["on" + c] = function() {
                var b = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                b.splice(0, 0, c), T.emit.apply(T, b);
              }), E.prototype.on.call(T, c, o);
            };
            var l = `\r
	 `, v = "0124356789", h = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", n = `'"`, f = l + ">", d = "http://www.w3.org/XML/1998/namespace", S = "http://www.w3.org/2000/xmlns/", x = { xml: d, xmlns: S };
            l = W(l), v = W(v), h = W(h);
            var G = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, P = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/, J = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, M = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
            function W(c) {
              return c.split("").reduce(function(o, T) {
                return o[T] = !0, o;
              }, {});
            }
            function se(c, o) {
              return function(T) {
                return Object.prototype.toString.call(T) === "[object RegExp]";
              }(c) ? !!o.match(c) : c[o];
            }
            function j(c, o) {
              return !se(c, o);
            }
            n = W(n), f = W(f);
            var re, ce, Re, $ = 0;
            for (var Me in te.STATE = { BEGIN: $++, BEGIN_WHITESPACE: $++, TEXT: $++, TEXT_ENTITY: $++, OPEN_WAKA: $++, SGML_DECL: $++, SGML_DECL_QUOTED: $++, DOCTYPE: $++, DOCTYPE_QUOTED: $++, DOCTYPE_DTD: $++, DOCTYPE_DTD_QUOTED: $++, COMMENT_STARTING: $++, COMMENT: $++, COMMENT_ENDING: $++, COMMENT_ENDED: $++, CDATA: $++, CDATA_ENDING: $++, CDATA_ENDING_2: $++, PROC_INST: $++, PROC_INST_BODY: $++, PROC_INST_ENDING: $++, OPEN_TAG: $++, OPEN_TAG_SLASH: $++, ATTRIB: $++, ATTRIB_NAME: $++, ATTRIB_NAME_SAW_WHITE: $++, ATTRIB_VALUE: $++, ATTRIB_VALUE_QUOTED: $++, ATTRIB_VALUE_CLOSED: $++, ATTRIB_VALUE_UNQUOTED: $++, ATTRIB_VALUE_ENTITY_Q: $++, ATTRIB_VALUE_ENTITY_U: $++, CLOSE_TAG: $++, CLOSE_TAG_SAW_WHITE: $++, SCRIPT: $++, SCRIPT_ENDING: $++ }, te.XML_ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'" }, te.ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'", AElig: 198, Aacute: 193, Acirc: 194, Agrave: 192, Aring: 197, Atilde: 195, Auml: 196, Ccedil: 199, ETH: 208, Eacute: 201, Ecirc: 202, Egrave: 200, Euml: 203, Iacute: 205, Icirc: 206, Igrave: 204, Iuml: 207, Ntilde: 209, Oacute: 211, Ocirc: 212, Ograve: 210, Oslash: 216, Otilde: 213, Ouml: 214, THORN: 222, Uacute: 218, Ucirc: 219, Ugrave: 217, Uuml: 220, Yacute: 221, aacute: 225, acirc: 226, aelig: 230, agrave: 224, aring: 229, atilde: 227, auml: 228, ccedil: 231, eacute: 233, ecirc: 234, egrave: 232, eth: 240, euml: 235, iacute: 237, icirc: 238, igrave: 236, iuml: 239, ntilde: 241, oacute: 243, ocirc: 244, ograve: 242, oslash: 248, otilde: 245, ouml: 246, szlig: 223, thorn: 254, uacute: 250, ucirc: 251, ugrave: 249, uuml: 252, yacute: 253, yuml: 255, copy: 169, reg: 174, nbsp: 160, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, sect: 167, uml: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, deg: 176, plusmn: 177, sup1: 185, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, times: 215, divide: 247, OElig: 338, oelig: 339, Scaron: 352, scaron: 353, Yuml: 376, fnof: 402, circ: 710, tilde: 732, Alpha: 913, Beta: 914, Gamma: 915, Delta: 916, Epsilon: 917, Zeta: 918, Eta: 919, Theta: 920, Iota: 921, Kappa: 922, Lambda: 923, Mu: 924, Nu: 925, Xi: 926, Omicron: 927, Pi: 928, Rho: 929, Sigma: 931, Tau: 932, Upsilon: 933, Phi: 934, Chi: 935, Psi: 936, Omega: 937, alpha: 945, beta: 946, gamma: 947, delta: 948, epsilon: 949, zeta: 950, eta: 951, theta: 952, iota: 953, kappa: 954, lambda: 955, mu: 956, nu: 957, xi: 958, omicron: 959, pi: 960, rho: 961, sigmaf: 962, sigma: 963, tau: 964, upsilon: 965, phi: 966, chi: 967, psi: 968, omega: 969, thetasym: 977, upsih: 978, piv: 982, ensp: 8194, emsp: 8195, thinsp: 8201, zwnj: 8204, zwj: 8205, lrm: 8206, rlm: 8207, ndash: 8211, mdash: 8212, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, bull: 8226, hellip: 8230, permil: 8240, prime: 8242, Prime: 8243, lsaquo: 8249, rsaquo: 8250, oline: 8254, frasl: 8260, euro: 8364, image: 8465, weierp: 8472, real: 8476, trade: 8482, alefsym: 8501, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, harr: 8596, crarr: 8629, lArr: 8656, uArr: 8657, rArr: 8658, dArr: 8659, hArr: 8660, forall: 8704, part: 8706, exist: 8707, empty: 8709, nabla: 8711, isin: 8712, notin: 8713, ni: 8715, prod: 8719, sum: 8721, minus: 8722, lowast: 8727, radic: 8730, prop: 8733, infin: 8734, ang: 8736, and: 8743, or: 8744, cap: 8745, cup: 8746, int: 8747, there4: 8756, sim: 8764, cong: 8773, asymp: 8776, ne: 8800, equiv: 8801, le: 8804, ge: 8805, sub: 8834, sup: 8835, nsub: 8836, sube: 8838, supe: 8839, oplus: 8853, otimes: 8855, perp: 8869, sdot: 8901, lceil: 8968, rceil: 8969, lfloor: 8970, rfloor: 8971, lang: 9001, rang: 9002, loz: 9674, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830 }, Object.keys(te.ENTITIES).forEach(function(c) {
              var o = te.ENTITIES[c], T = typeof o == "number" ? String.fromCharCode(o) : o;
              te.ENTITIES[c] = T;
            }), te.STATE) te.STATE[te.STATE[Me]] = Me;
            function Ge(c, o, T) {
              c[o] && c[o](T);
            }
            function Qe(c, o, T) {
              c.textNode && Ae(c), Ge(c, o, T);
            }
            function Ae(c) {
              c.textNode = Ze(c.opt, c.textNode), c.textNode && Ge(c, "ontext", c.textNode), c.textNode = "";
            }
            function Ze(c, o) {
              return c.trim && (o = o.trim()), c.normalize && (o = o.replace(/\s+/g, " ")), o;
            }
            function Xe(c, o) {
              return Ae(c), c.trackPosition && (o += `
Line: ` + c.line + `
Column: ` + c.column + `
Char: ` + c.c), o = new Error(o), c.error = o, Ge(c, "onerror", o), c;
            }
            function at(c) {
              return c.sawRoot && !c.closedRoot && Ie(c, "Unclosed root tag"), c.state !== $.BEGIN && c.state !== $.BEGIN_WHITESPACE && c.state !== $.TEXT && Xe(c, "Unexpected end"), Ae(c), c.c = "", c.closed = !0, Ge(c, "onend"), e.call(c, c.strict, c.opt), c;
            }
            function Ie(c, o) {
              if (typeof c != "object" || !(c instanceof e)) throw new Error("bad call to strictFail");
              c.strict && Xe(c, o);
            }
            function Be(c) {
              c.strict || (c.tagName = c.tagName[c.looseCase]());
              var o = c.tags[c.tags.length - 1] || c, T = c.tag = { name: c.tagName, attributes: {} };
              c.opt.xmlns && (T.ns = o.ns), c.attribList.length = 0, Qe(c, "onopentagstart", T);
            }
            function It(c, o) {
              var T = c.indexOf(":") < 0 ? ["", c] : c.split(":"), b = T[0], X = T[1];
              return o && c === "xmlns" && (b = "xmlns", X = ""), { prefix: b, local: X };
            }
            function _t(c) {
              if (c.strict || (c.attribName = c.attribName[c.looseCase]()), c.attribList.indexOf(c.attribName) !== -1 || c.tag.attributes.hasOwnProperty(c.attribName)) c.attribName = c.attribValue = "";
              else {
                if (c.opt.xmlns) {
                  var o = It(c.attribName, !0), T = o.prefix, b = o.local;
                  if (T === "xmlns") if (b === "xml" && c.attribValue !== d) Ie(c, "xml: prefix must be bound to " + d + `
Actual: ` + c.attribValue);
                  else if (b === "xmlns" && c.attribValue !== S) Ie(c, "xmlns: prefix must be bound to " + S + `
Actual: ` + c.attribValue);
                  else {
                    var X = c.tag, z = c.tags[c.tags.length - 1] || c;
                    X.ns === z.ns && (X.ns = Object.create(z.ns)), X.ns[b] = c.attribValue;
                  }
                  c.attribList.push([c.attribName, c.attribValue]);
                } else c.tag.attributes[c.attribName] = c.attribValue, Qe(c, "onattribute", { name: c.attribName, value: c.attribValue });
                c.attribName = c.attribValue = "";
              }
            }
            function Ve(c, o) {
              if (c.opt.xmlns) {
                var T = c.tag, b = It(c.tagName);
                T.prefix = b.prefix, T.local = b.local, T.uri = T.ns[b.prefix] || "", T.prefix && !T.uri && (Ie(c, "Unbound namespace prefix: " + JSON.stringify(c.tagName)), T.uri = b.prefix);
                var X = c.tags[c.tags.length - 1] || c;
                T.ns && X.ns !== T.ns && Object.keys(T.ns).forEach(function(Yt) {
                  Qe(c, "onopennamespace", { prefix: Yt, uri: T.ns[Yt] });
                });
                for (var z = 0, De = c.attribList.length; z < De; z++) {
                  var tt = c.attribList[z], Ue = tt[0], ke = tt[1], Oe = It(Ue, !0), qe = Oe.prefix, it = Oe.local, bt = qe === "" ? "" : T.ns[qe] || "", dt = { name: Ue, value: ke, prefix: qe, local: it, uri: bt };
                  qe && qe !== "xmlns" && !bt && (Ie(c, "Unbound namespace prefix: " + JSON.stringify(qe)), dt.uri = qe), c.tag.attributes[Ue] = dt, Qe(c, "onattribute", dt);
                }
                c.attribList.length = 0;
              }
              c.tag.isSelfClosing = !!o, c.sawRoot = !0, c.tags.push(c.tag), Qe(c, "onopentag", c.tag), o || (c.noscript || c.tagName.toLowerCase() !== "script" ? c.state = $.TEXT : c.state = $.SCRIPT, c.tag = null, c.tagName = ""), c.attribName = c.attribValue = "", c.attribList.length = 0;
            }
            function ot(c) {
              if (!c.tagName) return Ie(c, "Weird empty close tag."), c.textNode += "</>", void (c.state = $.TEXT);
              if (c.script) {
                if (c.tagName !== "script") return c.script += "</" + c.tagName + ">", c.tagName = "", void (c.state = $.SCRIPT);
                Qe(c, "onscript", c.script), c.script = "";
              }
              var o = c.tags.length, T = c.tagName;
              c.strict || (T = T[c.looseCase]());
              for (var b = T; o-- && c.tags[o].name !== b; ) Ie(c, "Unexpected close tag");
              if (o < 0) return Ie(c, "Unmatched closing tag: " + c.tagName), c.textNode += "</" + c.tagName + ">", void (c.state = $.TEXT);
              c.tagName = T;
              for (var X = c.tags.length; X-- > o; ) {
                var z = c.tag = c.tags.pop();
                c.tagName = c.tag.name, Qe(c, "onclosetag", c.tagName);
                var De = {};
                for (var tt in z.ns) De[tt] = z.ns[tt];
                var Ue = c.tags[c.tags.length - 1] || c;
                c.opt.xmlns && z.ns !== Ue.ns && Object.keys(z.ns).forEach(function(ke) {
                  var Oe = z.ns[ke];
                  Qe(c, "onclosenamespace", { prefix: ke, uri: Oe });
                });
              }
              o === 0 && (c.closedRoot = !0), c.tagName = c.attribValue = c.attribName = "", c.attribList.length = 0, c.state = $.TEXT;
            }
            function Ee(c) {
              var o, T = c.entity, b = T.toLowerCase(), X = "";
              return c.ENTITIES[T] ? c.ENTITIES[T] : c.ENTITIES[b] ? c.ENTITIES[b] : ((T = b).charAt(0) === "#" && (T.charAt(1) === "x" ? (T = T.slice(2), X = (o = parseInt(T, 16)).toString(16)) : (T = T.slice(1), X = (o = parseInt(T, 10)).toString(10))), T = T.replace(/^0+/, ""), X.toLowerCase() !== T ? (Ie(c, "Invalid character entity"), "&" + c.entity + ";") : String.fromCodePoint(o));
            }
            function Te(c, o) {
              o === "<" ? (c.state = $.OPEN_WAKA, c.startTagPosition = c.position) : j(l, o) && (Ie(c, "Non-whitespace before first tag."), c.textNode = o, c.state = $.TEXT);
            }
            function je(c, o) {
              var T = "";
              return o < c.length && (T = c.charAt(o)), T;
            }
            $ = te.STATE, String.fromCodePoint || (re = String.fromCharCode, ce = Math.floor, Re = function() {
              var c, o, T = 16384, b = [], X = -1, z = arguments.length;
              if (!z) return "";
              for (var De = ""; ++X < z; ) {
                var tt = Number(arguments[X]);
                if (!isFinite(tt) || tt < 0 || tt > 1114111 || ce(tt) !== tt) throw RangeError("Invalid code point: " + tt);
                tt <= 65535 ? b.push(tt) : (c = 55296 + ((tt -= 65536) >> 10), o = tt % 1024 + 56320, b.push(c, o)), (X + 1 === z || b.length > T) && (De += re.apply(null, b), b.length = 0);
              }
              return De;
            }, Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", { value: Re, configurable: !0, writable: !0 }) : String.fromCodePoint = Re);
          })(ge);
        }, 182: function(Se, ge, R) {
          Se.exports = E;
          var te = R(1159).EventEmitter;
          function E() {
            te.call(this);
          }
          R(1765)(E, te), E.Readable = R(2846), E.Writable = R(8318), E.Duplex = R(6138), E.Transform = R(9798), E.PassThrough = R(5472), E.finished = R(8800), E.pipeline = R(7295), E.Stream = E, E.prototype.pipe = function(t, e) {
            var m = this;
            function p(S) {
              t.writable && t.write(S) === !1 && m.pause && m.pause();
            }
            function l() {
              m.readable && m.resume && m.resume();
            }
            m.on("data", p), t.on("drain", l), t._isStdio || e && e.end === !1 || (m.on("end", h), m.on("close", n));
            var v = !1;
            function h() {
              v || (v = !0, t.end());
            }
            function n() {
              v || (v = !0, typeof t.destroy == "function" && t.destroy());
            }
            function f(S) {
              if (d(), te.listenerCount(this, "error") === 0) throw S;
            }
            function d() {
              m.removeListener("data", p), t.removeListener("drain", l), m.removeListener("end", h), m.removeListener("close", n), m.removeListener("error", f), t.removeListener("error", f), m.removeListener("end", d), m.removeListener("close", d), t.removeListener("close", d);
            }
            return m.on("error", f), t.on("error", f), m.on("end", d), m.on("close", d), t.on("close", d), t.emit("pipe", m), t;
          };
        }, 1765: function(Se) {
          typeof Object.create == "function" ? Se.exports = function(ge, R) {
            R && (ge.super_ = R, ge.prototype = Object.create(R.prototype, { constructor: { value: ge, enumerable: !1, writable: !0, configurable: !0 } }));
          } : Se.exports = function(ge, R) {
            if (R) {
              ge.super_ = R;
              var te = function() {
              };
              te.prototype = R.prototype, ge.prototype = new te(), ge.prototype.constructor = ge;
            }
          };
        }, 3690: function(Se) {
          var ge = {};
          function R(E, t, e) {
            e || (e = Error);
            var m = function(p) {
              var l, v;
              function h(n, f, d) {
                return p.call(this, function(S, x, G) {
                  return typeof t == "string" ? t : t(S, x, G);
                }(n, f, d)) || this;
              }
              return v = p, (l = h).prototype = Object.create(v.prototype), l.prototype.constructor = l, l.__proto__ = v, h;
            }(e);
            m.prototype.name = e.name, m.prototype.code = E, ge[E] = m;
          }
          function te(E, t) {
            if (Array.isArray(E)) {
              var e = E.length;
              return E = E.map(function(m) {
                return String(m);
              }), e > 2 ? "one of ".concat(t, " ").concat(E.slice(0, e - 1).join(", "), ", or ") + E[e - 1] : e === 2 ? "one of ".concat(t, " ").concat(E[0], " or ").concat(E[1]) : "of ".concat(t, " ").concat(E[0]);
            }
            return "of ".concat(t, " ").concat(String(E));
          }
          R("ERR_INVALID_OPT_VALUE", function(E, t) {
            return 'The value "' + t + '" is invalid for option "' + E + '"';
          }, TypeError), R("ERR_INVALID_ARG_TYPE", function(E, t, e) {
            var m, p, l, v, h;
            if (typeof t == "string" && (p = "not ", t.substr(0, p.length) === p) ? (m = "must not be", t = t.replace(/^not /, "")) : m = "must be", function(f, d, S) {
              return (S === void 0 || S > f.length) && (S = f.length), f.substring(S - d.length, S) === d;
            }(E, " argument")) l = "The ".concat(E, " ").concat(m, " ").concat(te(t, "type"));
            else {
              var n = (typeof h != "number" && (h = 0), h + 1 > (v = E).length || v.indexOf(".", h) === -1 ? "argument" : "property");
              l = 'The "'.concat(E, '" ').concat(n, " ").concat(m, " ").concat(te(t, "type"));
            }
            return l + ". Received type ".concat(typeof e);
          }, TypeError), R("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), R("ERR_METHOD_NOT_IMPLEMENTED", function(E) {
            return "The " + E + " method is not implemented";
          }), R("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), R("ERR_STREAM_DESTROYED", function(E) {
            return "Cannot call " + E + " after a stream was destroyed";
          }), R("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), R("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), R("ERR_STREAM_WRITE_AFTER_END", "write after end"), R("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), R("ERR_UNKNOWN_ENCODING", function(E) {
            return "Unknown encoding: " + E;
          }, TypeError), R("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Se.exports.q = ge;
        }, 6138: function(Se, ge, R) {
          var te = Object.keys || function(n) {
            var f = [];
            for (var d in n) f.push(d);
            return f;
          };
          Se.exports = l;
          var E = R(2846), t = R(8318);
          R(1765)(l, E);
          for (var e = te(t.prototype), m = 0; m < e.length; m++) {
            var p = e[m];
            l.prototype[p] || (l.prototype[p] = t.prototype[p]);
          }
          function l(n) {
            if (!(this instanceof l)) return new l(n);
            E.call(this, n), t.call(this, n), this.allowHalfOpen = !0, n && (n.readable === !1 && (this.readable = !1), n.writable === !1 && (this.writable = !1), n.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", v)));
          }
          function v() {
            this._writableState.ended || process.nextTick(h, this);
          }
          function h(n) {
            n.end();
          }
          Object.defineProperty(l.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), Object.defineProperty(l.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(l.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(l.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
          }, set: function(n) {
            this._readableState !== void 0 && this._writableState !== void 0 && (this._readableState.destroyed = n, this._writableState.destroyed = n);
          } });
        }, 5472: function(Se, ge, R) {
          Se.exports = E;
          var te = R(9798);
          function E(t) {
            if (!(this instanceof E)) return new E(t);
            te.call(this, t);
          }
          R(1765)(E, te), E.prototype._transform = function(t, e, m) {
            m(null, t);
          };
        }, 2846: function(Se, ge, R) {
          var te;
          Se.exports = re, re.ReadableState = j, R(1159).EventEmitter;
          var E, t = function(Ee, Te) {
            return Ee.listeners(Te).length;
          }, e = R(9299), m = R(1549).Buffer, p = R.g.Uint8Array || function() {
          }, l = R(964);
          E = l && l.debuglog ? l.debuglog("stream") : function() {
          };
          var v, h, n, f = R(8393), d = R(6163), S = R(7269).getHighWaterMark, x = R(3690).q, G = x.ERR_INVALID_ARG_TYPE, P = x.ERR_STREAM_PUSH_AFTER_EOF, J = x.ERR_METHOD_NOT_IMPLEMENTED, M = x.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
          R(1765)(re, e);
          var W = d.errorOrDestroy, se = ["error", "close", "destroy", "pause", "resume"];
          function j(Ee, Te, je) {
            te = te || R(6138), Ee = Ee || {}, typeof je != "boolean" && (je = Te instanceof te), this.objectMode = !!Ee.objectMode, je && (this.objectMode = this.objectMode || !!Ee.readableObjectMode), this.highWaterMark = S(this, Ee, "readableHighWaterMark", je), this.buffer = new f(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Ee.emitClose !== !1, this.autoDestroy = !!Ee.autoDestroy, this.destroyed = !1, this.defaultEncoding = Ee.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Ee.encoding && (v || (v = R(7503).s), this.decoder = new v(Ee.encoding), this.encoding = Ee.encoding);
          }
          function re(Ee) {
            if (te = te || R(6138), !(this instanceof re)) return new re(Ee);
            var Te = this instanceof te;
            this._readableState = new j(Ee, this, Te), this.readable = !0, Ee && (typeof Ee.read == "function" && (this._read = Ee.read), typeof Ee.destroy == "function" && (this._destroy = Ee.destroy)), e.call(this);
          }
          function ce(Ee, Te, je, c, o) {
            E("readableAddChunk", Te);
            var T, b = Ee._readableState;
            if (Te === null) b.reading = !1, function(X, z) {
              if (E("onEofChunk"), !z.ended) {
                if (z.decoder) {
                  var De = z.decoder.end();
                  De && De.length && (z.buffer.push(De), z.length += z.objectMode ? 1 : De.length);
                }
                z.ended = !0, z.sync ? Ge(X) : (z.needReadable = !1, z.emittedReadable || (z.emittedReadable = !0, Qe(X)));
              }
            }(Ee, b);
            else if (o || (T = function(X, z) {
              var De, tt;
              return tt = z, m.isBuffer(tt) || tt instanceof p || typeof z == "string" || z === void 0 || X.objectMode || (De = new G("chunk", ["string", "Buffer", "Uint8Array"], z)), De;
            }(b, Te)), T) W(Ee, T);
            else if (b.objectMode || Te && Te.length > 0) if (typeof Te == "string" || b.objectMode || Object.getPrototypeOf(Te) === m.prototype || (Te = function(X) {
              return m.from(X);
            }(Te)), c) b.endEmitted ? W(Ee, new M()) : Re(Ee, b, Te, !0);
            else if (b.ended) W(Ee, new P());
            else {
              if (b.destroyed) return !1;
              b.reading = !1, b.decoder && !je ? (Te = b.decoder.write(Te), b.objectMode || Te.length !== 0 ? Re(Ee, b, Te, !1) : Ae(Ee, b)) : Re(Ee, b, Te, !1);
            }
            else c || (b.reading = !1, Ae(Ee, b));
            return !b.ended && (b.length < b.highWaterMark || b.length === 0);
          }
          function Re(Ee, Te, je, c) {
            Te.flowing && Te.length === 0 && !Te.sync ? (Te.awaitDrain = 0, Ee.emit("data", je)) : (Te.length += Te.objectMode ? 1 : je.length, c ? Te.buffer.unshift(je) : Te.buffer.push(je), Te.needReadable && Ge(Ee)), Ae(Ee, Te);
          }
          Object.defineProperty(re.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._readableState.destroyed;
          }, set: function(Ee) {
            this._readableState && (this._readableState.destroyed = Ee);
          } }), re.prototype.destroy = d.destroy, re.prototype._undestroy = d.undestroy, re.prototype._destroy = function(Ee, Te) {
            Te(Ee);
          }, re.prototype.push = function(Ee, Te) {
            var je, c = this._readableState;
            return c.objectMode ? je = !0 : typeof Ee == "string" && ((Te = Te || c.defaultEncoding) !== c.encoding && (Ee = m.from(Ee, Te), Te = ""), je = !0), ce(this, Ee, Te, !1, je);
          }, re.prototype.unshift = function(Ee) {
            return ce(this, Ee, null, !0, !1);
          }, re.prototype.isPaused = function() {
            return this._readableState.flowing === !1;
          }, re.prototype.setEncoding = function(Ee) {
            v || (v = R(7503).s);
            var Te = new v(Ee);
            this._readableState.decoder = Te, this._readableState.encoding = this._readableState.decoder.encoding;
            for (var je = this._readableState.buffer.head, c = ""; je !== null; ) c += Te.write(je.data), je = je.next;
            return this._readableState.buffer.clear(), c !== "" && this._readableState.buffer.push(c), this._readableState.length = c.length, this;
          };
          var $ = 1073741824;
          function Me(Ee, Te) {
            return Ee <= 0 || Te.length === 0 && Te.ended ? 0 : Te.objectMode ? 1 : Ee != Ee ? Te.flowing && Te.length ? Te.buffer.head.data.length : Te.length : (Ee > Te.highWaterMark && (Te.highWaterMark = function(je) {
              return je >= $ ? je = $ : (je--, je |= je >>> 1, je |= je >>> 2, je |= je >>> 4, je |= je >>> 8, je |= je >>> 16, je++), je;
            }(Ee)), Ee <= Te.length ? Ee : Te.ended ? Te.length : (Te.needReadable = !0, 0));
          }
          function Ge(Ee) {
            var Te = Ee._readableState;
            E("emitReadable", Te.needReadable, Te.emittedReadable), Te.needReadable = !1, Te.emittedReadable || (E("emitReadable", Te.flowing), Te.emittedReadable = !0, process.nextTick(Qe, Ee));
          }
          function Qe(Ee) {
            var Te = Ee._readableState;
            E("emitReadable_", Te.destroyed, Te.length, Te.ended), Te.destroyed || !Te.length && !Te.ended || (Ee.emit("readable"), Te.emittedReadable = !1), Te.needReadable = !Te.flowing && !Te.ended && Te.length <= Te.highWaterMark, Be(Ee);
          }
          function Ae(Ee, Te) {
            Te.readingMore || (Te.readingMore = !0, process.nextTick(Ze, Ee, Te));
          }
          function Ze(Ee, Te) {
            for (; !Te.reading && !Te.ended && (Te.length < Te.highWaterMark || Te.flowing && Te.length === 0); ) {
              var je = Te.length;
              if (E("maybeReadMore read 0"), Ee.read(0), je === Te.length) break;
            }
            Te.readingMore = !1;
          }
          function Xe(Ee) {
            var Te = Ee._readableState;
            Te.readableListening = Ee.listenerCount("readable") > 0, Te.resumeScheduled && !Te.paused ? Te.flowing = !0 : Ee.listenerCount("data") > 0 && Ee.resume();
          }
          function at(Ee) {
            E("readable nexttick read 0"), Ee.read(0);
          }
          function Ie(Ee, Te) {
            E("resume", Te.reading), Te.reading || Ee.read(0), Te.resumeScheduled = !1, Ee.emit("resume"), Be(Ee), Te.flowing && !Te.reading && Ee.read(0);
          }
          function Be(Ee) {
            var Te = Ee._readableState;
            for (E("flow", Te.flowing); Te.flowing && Ee.read() !== null; ) ;
          }
          function It(Ee, Te) {
            return Te.length === 0 ? null : (Te.objectMode ? je = Te.buffer.shift() : !Ee || Ee >= Te.length ? (je = Te.decoder ? Te.buffer.join("") : Te.buffer.length === 1 ? Te.buffer.first() : Te.buffer.concat(Te.length), Te.buffer.clear()) : je = Te.buffer.consume(Ee, Te.decoder), je);
            var je;
          }
          function _t(Ee) {
            var Te = Ee._readableState;
            E("endReadable", Te.endEmitted), Te.endEmitted || (Te.ended = !0, process.nextTick(Ve, Te, Ee));
          }
          function Ve(Ee, Te) {
            if (E("endReadableNT", Ee.endEmitted, Ee.length), !Ee.endEmitted && Ee.length === 0 && (Ee.endEmitted = !0, Te.readable = !1, Te.emit("end"), Ee.autoDestroy)) {
              var je = Te._writableState;
              (!je || je.autoDestroy && je.finished) && Te.destroy();
            }
          }
          function ot(Ee, Te) {
            for (var je = 0, c = Ee.length; je < c; je++) if (Ee[je] === Te) return je;
            return -1;
          }
          re.prototype.read = function(Ee) {
            E("read", Ee), Ee = parseInt(Ee, 10);
            var Te = this._readableState, je = Ee;
            if (Ee !== 0 && (Te.emittedReadable = !1), Ee === 0 && Te.needReadable && ((Te.highWaterMark !== 0 ? Te.length >= Te.highWaterMark : Te.length > 0) || Te.ended)) return E("read: emitReadable", Te.length, Te.ended), Te.length === 0 && Te.ended ? _t(this) : Ge(this), null;
            if ((Ee = Me(Ee, Te)) === 0 && Te.ended) return Te.length === 0 && _t(this), null;
            var c, o = Te.needReadable;
            return E("need readable", o), (Te.length === 0 || Te.length - Ee < Te.highWaterMark) && E("length less than watermark", o = !0), Te.ended || Te.reading ? E("reading or ended", o = !1) : o && (E("do read"), Te.reading = !0, Te.sync = !0, Te.length === 0 && (Te.needReadable = !0), this._read(Te.highWaterMark), Te.sync = !1, Te.reading || (Ee = Me(je, Te))), (c = Ee > 0 ? It(Ee, Te) : null) === null ? (Te.needReadable = Te.length <= Te.highWaterMark, Ee = 0) : (Te.length -= Ee, Te.awaitDrain = 0), Te.length === 0 && (Te.ended || (Te.needReadable = !0), je !== Ee && Te.ended && _t(this)), c !== null && this.emit("data", c), c;
          }, re.prototype._read = function(Ee) {
            W(this, new J("_read()"));
          }, re.prototype.pipe = function(Ee, Te) {
            var je = this, c = this._readableState;
            switch (c.pipesCount) {
              case 0:
                c.pipes = Ee;
                break;
              case 1:
                c.pipes = [c.pipes, Ee];
                break;
              default:
                c.pipes.push(Ee);
            }
            c.pipesCount += 1, E("pipe count=%d opts=%j", c.pipesCount, Te);
            var o = Te && Te.end === !1 || Ee === process.stdout || Ee === process.stderr ? ke : T;
            function T() {
              E("onend"), Ee.end();
            }
            c.endEmitted ? process.nextTick(o) : je.once("end", o), Ee.on("unpipe", function Oe(qe, it) {
              E("onunpipe"), qe === je && it && it.hasUnpiped === !1 && (it.hasUnpiped = !0, E("cleanup"), Ee.removeListener("close", tt), Ee.removeListener("finish", Ue), Ee.removeListener("drain", b), Ee.removeListener("error", De), Ee.removeListener("unpipe", Oe), je.removeListener("end", T), je.removeListener("end", ke), je.removeListener("data", z), X = !0, !c.awaitDrain || Ee._writableState && !Ee._writableState.needDrain || b());
            });
            var b = /* @__PURE__ */ function(Oe) {
              return function() {
                var qe = Oe._readableState;
                E("pipeOnDrain", qe.awaitDrain), qe.awaitDrain && qe.awaitDrain--, qe.awaitDrain === 0 && t(Oe, "data") && (qe.flowing = !0, Be(Oe));
              };
            }(je);
            Ee.on("drain", b);
            var X = !1;
            function z(Oe) {
              E("ondata");
              var qe = Ee.write(Oe);
              E("dest.write", qe), qe === !1 && ((c.pipesCount === 1 && c.pipes === Ee || c.pipesCount > 1 && ot(c.pipes, Ee) !== -1) && !X && (E("false write response, pause", c.awaitDrain), c.awaitDrain++), je.pause());
            }
            function De(Oe) {
              E("onerror", Oe), ke(), Ee.removeListener("error", De), t(Ee, "error") === 0 && W(Ee, Oe);
            }
            function tt() {
              Ee.removeListener("finish", Ue), ke();
            }
            function Ue() {
              E("onfinish"), Ee.removeListener("close", tt), ke();
            }
            function ke() {
              E("unpipe"), je.unpipe(Ee);
            }
            return je.on("data", z), function(Oe, qe, it) {
              if (typeof Oe.prependListener == "function") return Oe.prependListener(qe, it);
              Oe._events && Oe._events[qe] ? Array.isArray(Oe._events[qe]) ? Oe._events[qe].unshift(it) : Oe._events[qe] = [it, Oe._events[qe]] : Oe.on(qe, it);
            }(Ee, "error", De), Ee.once("close", tt), Ee.once("finish", Ue), Ee.emit("pipe", je), c.flowing || (E("pipe resume"), je.resume()), Ee;
          }, re.prototype.unpipe = function(Ee) {
            var Te = this._readableState, je = { hasUnpiped: !1 };
            if (Te.pipesCount === 0) return this;
            if (Te.pipesCount === 1) return Ee && Ee !== Te.pipes || (Ee || (Ee = Te.pipes), Te.pipes = null, Te.pipesCount = 0, Te.flowing = !1, Ee && Ee.emit("unpipe", this, je)), this;
            if (!Ee) {
              var c = Te.pipes, o = Te.pipesCount;
              Te.pipes = null, Te.pipesCount = 0, Te.flowing = !1;
              for (var T = 0; T < o; T++) c[T].emit("unpipe", this, { hasUnpiped: !1 });
              return this;
            }
            var b = ot(Te.pipes, Ee);
            return b === -1 || (Te.pipes.splice(b, 1), Te.pipesCount -= 1, Te.pipesCount === 1 && (Te.pipes = Te.pipes[0]), Ee.emit("unpipe", this, je)), this;
          }, re.prototype.on = function(Ee, Te) {
            var je = e.prototype.on.call(this, Ee, Te), c = this._readableState;
            return Ee === "data" ? (c.readableListening = this.listenerCount("readable") > 0, c.flowing !== !1 && this.resume()) : Ee === "readable" && (c.endEmitted || c.readableListening || (c.readableListening = c.needReadable = !0, c.flowing = !1, c.emittedReadable = !1, E("on readable", c.length, c.reading), c.length ? Ge(this) : c.reading || process.nextTick(at, this))), je;
          }, re.prototype.addListener = re.prototype.on, re.prototype.removeListener = function(Ee, Te) {
            var je = e.prototype.removeListener.call(this, Ee, Te);
            return Ee === "readable" && process.nextTick(Xe, this), je;
          }, re.prototype.removeAllListeners = function(Ee) {
            var Te = e.prototype.removeAllListeners.apply(this, arguments);
            return Ee !== "readable" && Ee !== void 0 || process.nextTick(Xe, this), Te;
          }, re.prototype.resume = function() {
            var Ee = this._readableState;
            return Ee.flowing || (E("resume"), Ee.flowing = !Ee.readableListening, function(Te, je) {
              je.resumeScheduled || (je.resumeScheduled = !0, process.nextTick(Ie, Te, je));
            }(this, Ee)), Ee.paused = !1, this;
          }, re.prototype.pause = function() {
            return E("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (E("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
          }, re.prototype.wrap = function(Ee) {
            var Te = this, je = this._readableState, c = !1;
            for (var o in Ee.on("end", function() {
              if (E("wrapped end"), je.decoder && !je.ended) {
                var b = je.decoder.end();
                b && b.length && Te.push(b);
              }
              Te.push(null);
            }), Ee.on("data", function(b) {
              E("wrapped data"), je.decoder && (b = je.decoder.write(b)), je.objectMode && b == null || (je.objectMode || b && b.length) && (Te.push(b) || (c = !0, Ee.pause()));
            }), Ee) this[o] === void 0 && typeof Ee[o] == "function" && (this[o] = /* @__PURE__ */ function(b) {
              return function() {
                return Ee[b].apply(Ee, arguments);
              };
            }(o));
            for (var T = 0; T < se.length; T++) Ee.on(se[T], this.emit.bind(this, se[T]));
            return this._read = function(b) {
              E("wrapped _read", b), c && (c = !1, Ee.resume());
            }, this;
          }, typeof Symbol == "function" && (re.prototype[Symbol.asyncIterator] = function() {
            return h === void 0 && (h = R(7299)), h(this);
          }), Object.defineProperty(re.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
            return this._readableState.highWaterMark;
          } }), Object.defineProperty(re.prototype, "readableBuffer", { enumerable: !1, get: function() {
            return this._readableState && this._readableState.buffer;
          } }), Object.defineProperty(re.prototype, "readableFlowing", { enumerable: !1, get: function() {
            return this._readableState.flowing;
          }, set: function(Ee) {
            this._readableState && (this._readableState.flowing = Ee);
          } }), re._fromList = It, Object.defineProperty(re.prototype, "readableLength", { enumerable: !1, get: function() {
            return this._readableState.length;
          } }), typeof Symbol == "function" && (re.from = function(Ee, Te) {
            return n === void 0 && (n = R(6233)), n(re, Ee, Te);
          });
        }, 9798: function(Se, ge, R) {
          Se.exports = v;
          var te = R(3690).q, E = te.ERR_METHOD_NOT_IMPLEMENTED, t = te.ERR_MULTIPLE_CALLBACK, e = te.ERR_TRANSFORM_ALREADY_TRANSFORMING, m = te.ERR_TRANSFORM_WITH_LENGTH_0, p = R(6138);
          function l(f, d) {
            var S = this._transformState;
            S.transforming = !1;
            var x = S.writecb;
            if (x === null) return this.emit("error", new t());
            S.writechunk = null, S.writecb = null, d != null && this.push(d), x(f);
            var G = this._readableState;
            G.reading = !1, (G.needReadable || G.length < G.highWaterMark) && this._read(G.highWaterMark);
          }
          function v(f) {
            if (!(this instanceof v)) return new v(f);
            p.call(this, f), this._transformState = { afterTransform: l.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, f && (typeof f.transform == "function" && (this._transform = f.transform), typeof f.flush == "function" && (this._flush = f.flush)), this.on("prefinish", h);
          }
          function h() {
            var f = this;
            typeof this._flush != "function" || this._readableState.destroyed ? n(this, null, null) : this._flush(function(d, S) {
              n(f, d, S);
            });
          }
          function n(f, d, S) {
            if (d) return f.emit("error", d);
            if (S != null && f.push(S), f._writableState.length) throw new m();
            if (f._transformState.transforming) throw new e();
            return f.push(null);
          }
          R(1765)(v, p), v.prototype.push = function(f, d) {
            return this._transformState.needTransform = !1, p.prototype.push.call(this, f, d);
          }, v.prototype._transform = function(f, d, S) {
            S(new E("_transform()"));
          }, v.prototype._write = function(f, d, S) {
            var x = this._transformState;
            if (x.writecb = S, x.writechunk = f, x.writeencoding = d, !x.transforming) {
              var G = this._readableState;
              (x.needTransform || G.needReadable || G.length < G.highWaterMark) && this._read(G.highWaterMark);
            }
          }, v.prototype._read = function(f) {
            var d = this._transformState;
            d.writechunk === null || d.transforming ? d.needTransform = !0 : (d.transforming = !0, this._transform(d.writechunk, d.writeencoding, d.afterTransform));
          }, v.prototype._destroy = function(f, d) {
            p.prototype._destroy.call(this, f, function(S) {
              d(S);
            });
          };
        }, 8318: function(Se, ge, R) {
          function te(Ae) {
            var Ze = this;
            this.next = null, this.entry = null, this.finish = function() {
              (function(Xe, at, Ie) {
                var Be = Xe.entry;
                for (Xe.entry = null; Be; ) {
                  var It = Be.callback;
                  at.pendingcb--, It(void 0), Be = Be.next;
                }
                at.corkedRequestsFree.next = Xe;
              })(Ze, Ae);
            };
          }
          var E;
          Se.exports = re, re.WritableState = j;
          var t, e = { deprecate: R(7839) }, m = R(9299), p = R(1549).Buffer, l = R.g.Uint8Array || function() {
          }, v = R(6163), h = R(7269).getHighWaterMark, n = R(3690).q, f = n.ERR_INVALID_ARG_TYPE, d = n.ERR_METHOD_NOT_IMPLEMENTED, S = n.ERR_MULTIPLE_CALLBACK, x = n.ERR_STREAM_CANNOT_PIPE, G = n.ERR_STREAM_DESTROYED, P = n.ERR_STREAM_NULL_VALUES, J = n.ERR_STREAM_WRITE_AFTER_END, M = n.ERR_UNKNOWN_ENCODING, W = v.errorOrDestroy;
          function se() {
          }
          function j(Ae, Ze, Xe) {
            E = E || R(6138), Ae = Ae || {}, typeof Xe != "boolean" && (Xe = Ze instanceof E), this.objectMode = !!Ae.objectMode, Xe && (this.objectMode = this.objectMode || !!Ae.writableObjectMode), this.highWaterMark = h(this, Ae, "writableHighWaterMark", Xe), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
            var at = Ae.decodeStrings === !1;
            this.decodeStrings = !at, this.defaultEncoding = Ae.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Ie) {
              (function(Be, It) {
                var _t = Be._writableState, Ve = _t.sync, ot = _t.writecb;
                if (typeof ot != "function") throw new S();
                if (function(Te) {
                  Te.writing = !1, Te.writecb = null, Te.length -= Te.writelen, Te.writelen = 0;
                }(_t), It) (function(Te, je, c, o, T) {
                  --je.pendingcb, c ? (process.nextTick(T, o), process.nextTick(Qe, Te, je), Te._writableState.errorEmitted = !0, W(Te, o)) : (T(o), Te._writableState.errorEmitted = !0, W(Te, o), Qe(Te, je));
                })(Be, _t, Ve, It, ot);
                else {
                  var Ee = Me(_t) || Be.destroyed;
                  Ee || _t.corked || _t.bufferProcessing || !_t.bufferedRequest || $(Be, _t), Ve ? process.nextTick(Re, Be, _t, Ee, ot) : Re(Be, _t, Ee, ot);
                }
              })(Ze, Ie);
            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Ae.emitClose !== !1, this.autoDestroy = !!Ae.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new te(this);
          }
          function re(Ae) {
            var Ze = this instanceof (E = E || R(6138));
            if (!Ze && !t.call(re, this)) return new re(Ae);
            this._writableState = new j(Ae, this, Ze), this.writable = !0, Ae && (typeof Ae.write == "function" && (this._write = Ae.write), typeof Ae.writev == "function" && (this._writev = Ae.writev), typeof Ae.destroy == "function" && (this._destroy = Ae.destroy), typeof Ae.final == "function" && (this._final = Ae.final)), m.call(this);
          }
          function ce(Ae, Ze, Xe, at, Ie, Be, It) {
            Ze.writelen = at, Ze.writecb = It, Ze.writing = !0, Ze.sync = !0, Ze.destroyed ? Ze.onwrite(new G("write")) : Xe ? Ae._writev(Ie, Ze.onwrite) : Ae._write(Ie, Be, Ze.onwrite), Ze.sync = !1;
          }
          function Re(Ae, Ze, Xe, at) {
            Xe || function(Ie, Be) {
              Be.length === 0 && Be.needDrain && (Be.needDrain = !1, Ie.emit("drain"));
            }(Ae, Ze), Ze.pendingcb--, at(), Qe(Ae, Ze);
          }
          function $(Ae, Ze) {
            Ze.bufferProcessing = !0;
            var Xe = Ze.bufferedRequest;
            if (Ae._writev && Xe && Xe.next) {
              var at = Ze.bufferedRequestCount, Ie = new Array(at), Be = Ze.corkedRequestsFree;
              Be.entry = Xe;
              for (var It = 0, _t = !0; Xe; ) Ie[It] = Xe, Xe.isBuf || (_t = !1), Xe = Xe.next, It += 1;
              Ie.allBuffers = _t, ce(Ae, Ze, !0, Ze.length, Ie, "", Be.finish), Ze.pendingcb++, Ze.lastBufferedRequest = null, Be.next ? (Ze.corkedRequestsFree = Be.next, Be.next = null) : Ze.corkedRequestsFree = new te(Ze), Ze.bufferedRequestCount = 0;
            } else {
              for (; Xe; ) {
                var Ve = Xe.chunk, ot = Xe.encoding, Ee = Xe.callback;
                if (ce(Ae, Ze, !1, Ze.objectMode ? 1 : Ve.length, Ve, ot, Ee), Xe = Xe.next, Ze.bufferedRequestCount--, Ze.writing) break;
              }
              Xe === null && (Ze.lastBufferedRequest = null);
            }
            Ze.bufferedRequest = Xe, Ze.bufferProcessing = !1;
          }
          function Me(Ae) {
            return Ae.ending && Ae.length === 0 && Ae.bufferedRequest === null && !Ae.finished && !Ae.writing;
          }
          function Ge(Ae, Ze) {
            Ae._final(function(Xe) {
              Ze.pendingcb--, Xe && W(Ae, Xe), Ze.prefinished = !0, Ae.emit("prefinish"), Qe(Ae, Ze);
            });
          }
          function Qe(Ae, Ze) {
            var Xe = Me(Ze);
            if (Xe && (function(Ie, Be) {
              Be.prefinished || Be.finalCalled || (typeof Ie._final != "function" || Be.destroyed ? (Be.prefinished = !0, Ie.emit("prefinish")) : (Be.pendingcb++, Be.finalCalled = !0, process.nextTick(Ge, Ie, Be)));
            }(Ae, Ze), Ze.pendingcb === 0 && (Ze.finished = !0, Ae.emit("finish"), Ze.autoDestroy))) {
              var at = Ae._readableState;
              (!at || at.autoDestroy && at.endEmitted) && Ae.destroy();
            }
            return Xe;
          }
          R(1765)(re, m), j.prototype.getBuffer = function() {
            for (var Ae = this.bufferedRequest, Ze = []; Ae; ) Ze.push(Ae), Ae = Ae.next;
            return Ze;
          }, function() {
            try {
              Object.defineProperty(j.prototype, "buffer", { get: e.deprecate(function() {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
            } catch {
            }
          }(), typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (t = Function.prototype[Symbol.hasInstance], Object.defineProperty(re, Symbol.hasInstance, { value: function(Ae) {
            return !!t.call(this, Ae) || this === re && Ae && Ae._writableState instanceof j;
          } })) : t = function(Ae) {
            return Ae instanceof this;
          }, re.prototype.pipe = function() {
            W(this, new x());
          }, re.prototype.write = function(Ae, Ze, Xe) {
            var at, Ie = this._writableState, Be = !1, It = !Ie.objectMode && (at = Ae, p.isBuffer(at) || at instanceof l);
            return It && !p.isBuffer(Ae) && (Ae = function(_t) {
              return p.from(_t);
            }(Ae)), typeof Ze == "function" && (Xe = Ze, Ze = null), It ? Ze = "buffer" : Ze || (Ze = Ie.defaultEncoding), typeof Xe != "function" && (Xe = se), Ie.ending ? function(_t, Ve) {
              var ot = new J();
              W(_t, ot), process.nextTick(Ve, ot);
            }(this, Xe) : (It || function(_t, Ve, ot, Ee) {
              var Te;
              return ot === null ? Te = new P() : typeof ot == "string" || Ve.objectMode || (Te = new f("chunk", ["string", "Buffer"], ot)), !Te || (W(_t, Te), process.nextTick(Ee, Te), !1);
            }(this, Ie, Ae, Xe)) && (Ie.pendingcb++, Be = function(_t, Ve, ot, Ee, Te, je) {
              if (!ot) {
                var c = function(X, z, De) {
                  return X.objectMode || X.decodeStrings === !1 || typeof z != "string" || (z = p.from(z, De)), z;
                }(Ve, Ee, Te);
                Ee !== c && (ot = !0, Te = "buffer", Ee = c);
              }
              var o = Ve.objectMode ? 1 : Ee.length;
              Ve.length += o;
              var T = Ve.length < Ve.highWaterMark;
              if (T || (Ve.needDrain = !0), Ve.writing || Ve.corked) {
                var b = Ve.lastBufferedRequest;
                Ve.lastBufferedRequest = { chunk: Ee, encoding: Te, isBuf: ot, callback: je, next: null }, b ? b.next = Ve.lastBufferedRequest : Ve.bufferedRequest = Ve.lastBufferedRequest, Ve.bufferedRequestCount += 1;
              } else ce(_t, Ve, !1, o, Ee, Te, je);
              return T;
            }(this, Ie, It, Ae, Ze, Xe)), Be;
          }, re.prototype.cork = function() {
            this._writableState.corked++;
          }, re.prototype.uncork = function() {
            var Ae = this._writableState;
            Ae.corked && (Ae.corked--, Ae.writing || Ae.corked || Ae.bufferProcessing || !Ae.bufferedRequest || $(this, Ae));
          }, re.prototype.setDefaultEncoding = function(Ae) {
            if (typeof Ae == "string" && (Ae = Ae.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Ae + "").toLowerCase()) > -1)) throw new M(Ae);
            return this._writableState.defaultEncoding = Ae, this;
          }, Object.defineProperty(re.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(re.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), re.prototype._write = function(Ae, Ze, Xe) {
            Xe(new d("_write()"));
          }, re.prototype._writev = null, re.prototype.end = function(Ae, Ze, Xe) {
            var at = this._writableState;
            return typeof Ae == "function" ? (Xe = Ae, Ae = null, Ze = null) : typeof Ze == "function" && (Xe = Ze, Ze = null), Ae != null && this.write(Ae, Ze), at.corked && (at.corked = 1, this.uncork()), at.ending || function(Ie, Be, It) {
              Be.ending = !0, Qe(Ie, Be), It && (Be.finished ? process.nextTick(It) : Ie.once("finish", It)), Be.ended = !0, Ie.writable = !1;
            }(this, at, Xe), this;
          }, Object.defineProperty(re.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(re.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._writableState !== void 0 && this._writableState.destroyed;
          }, set: function(Ae) {
            this._writableState && (this._writableState.destroyed = Ae);
          } }), re.prototype.destroy = v.destroy, re.prototype._undestroy = v.undestroy, re.prototype._destroy = function(Ae, Ze) {
            Ze(Ae);
          };
        }, 7299: function(Se, ge, R) {
          var te;
          function E(P, J, M) {
            return J in P ? Object.defineProperty(P, J, { value: M, enumerable: !0, configurable: !0, writable: !0 }) : P[J] = M, P;
          }
          var t = R(8800), e = Symbol("lastResolve"), m = Symbol("lastReject"), p = Symbol("error"), l = Symbol("ended"), v = Symbol("lastPromise"), h = Symbol("handlePromise"), n = Symbol("stream");
          function f(P, J) {
            return { value: P, done: J };
          }
          function d(P) {
            var J = P[e];
            if (J !== null) {
              var M = P[n].read();
              M !== null && (P[v] = null, P[e] = null, P[m] = null, J(f(M, !1)));
            }
          }
          function S(P) {
            process.nextTick(d, P);
          }
          var x = Object.getPrototypeOf(function() {
          }), G = Object.setPrototypeOf((E(te = { get stream() {
            return this[n];
          }, next: function() {
            var P = this, J = this[p];
            if (J !== null) return Promise.reject(J);
            if (this[l]) return Promise.resolve(f(void 0, !0));
            if (this[n].destroyed) return new Promise(function(j, re) {
              process.nextTick(function() {
                P[p] ? re(P[p]) : j(f(void 0, !0));
              });
            });
            var M, W = this[v];
            if (W) M = new Promise(/* @__PURE__ */ function(j, re) {
              return function(ce, Re) {
                j.then(function() {
                  re[l] ? ce(f(void 0, !0)) : re[h](ce, Re);
                }, Re);
              };
            }(W, this));
            else {
              var se = this[n].read();
              if (se !== null) return Promise.resolve(f(se, !1));
              M = new Promise(this[h]);
            }
            return this[v] = M, M;
          } }, Symbol.asyncIterator, function() {
            return this;
          }), E(te, "return", function() {
            var P = this;
            return new Promise(function(J, M) {
              P[n].destroy(null, function(W) {
                W ? M(W) : J(f(void 0, !0));
              });
            });
          }), te), x);
          Se.exports = function(P) {
            var J, M = Object.create(G, (E(J = {}, n, { value: P, writable: !0 }), E(J, e, { value: null, writable: !0 }), E(J, m, { value: null, writable: !0 }), E(J, p, { value: null, writable: !0 }), E(J, l, { value: P._readableState.endEmitted, writable: !0 }), E(J, h, { value: function(W, se) {
              var j = M[n].read();
              j ? (M[v] = null, M[e] = null, M[m] = null, W(f(j, !1))) : (M[e] = W, M[m] = se);
            }, writable: !0 }), J));
            return M[v] = null, t(P, function(W) {
              if (W && W.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var se = M[m];
                return se !== null && (M[v] = null, M[e] = null, M[m] = null, se(W)), void (M[p] = W);
              }
              var j = M[e];
              j !== null && (M[v] = null, M[e] = null, M[m] = null, j(f(void 0, !0))), M[l] = !0;
            }), P.on("readable", S.bind(null, M)), M;
          };
        }, 8393: function(Se, ge, R) {
          function te(l, v) {
            var h = Object.keys(l);
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(l);
              v && (n = n.filter(function(f) {
                return Object.getOwnPropertyDescriptor(l, f).enumerable;
              })), h.push.apply(h, n);
            }
            return h;
          }
          function E(l, v, h) {
            return v in l ? Object.defineProperty(l, v, { value: h, enumerable: !0, configurable: !0, writable: !0 }) : l[v] = h, l;
          }
          function t(l, v) {
            for (var h = 0; h < v.length; h++) {
              var n = v[h];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(l, n.key, n);
            }
          }
          var e = R(1549).Buffer, m = R(9862).inspect, p = m && m.custom || "inspect";
          Se.exports = function() {
            function l() {
              (function(n, f) {
                if (!(n instanceof f)) throw new TypeError("Cannot call a class as a function");
              })(this, l), this.head = null, this.tail = null, this.length = 0;
            }
            var v, h;
            return v = l, h = [{ key: "push", value: function(n) {
              var f = { data: n, next: null };
              this.length > 0 ? this.tail.next = f : this.head = f, this.tail = f, ++this.length;
            } }, { key: "unshift", value: function(n) {
              var f = { data: n, next: this.head };
              this.length === 0 && (this.tail = f), this.head = f, ++this.length;
            } }, { key: "shift", value: function() {
              if (this.length !== 0) {
                var n = this.head.data;
                return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, n;
              }
            } }, { key: "clear", value: function() {
              this.head = this.tail = null, this.length = 0;
            } }, { key: "join", value: function(n) {
              if (this.length === 0) return "";
              for (var f = this.head, d = "" + f.data; f = f.next; ) d += n + f.data;
              return d;
            } }, { key: "concat", value: function(n) {
              if (this.length === 0) return e.alloc(0);
              for (var f, d, S, x = e.allocUnsafe(n >>> 0), G = this.head, P = 0; G; ) f = G.data, d = x, S = P, e.prototype.copy.call(f, d, S), P += G.data.length, G = G.next;
              return x;
            } }, { key: "consume", value: function(n, f) {
              var d;
              return n < this.head.data.length ? (d = this.head.data.slice(0, n), this.head.data = this.head.data.slice(n)) : d = n === this.head.data.length ? this.shift() : f ? this._getString(n) : this._getBuffer(n), d;
            } }, { key: "first", value: function() {
              return this.head.data;
            } }, { key: "_getString", value: function(n) {
              var f = this.head, d = 1, S = f.data;
              for (n -= S.length; f = f.next; ) {
                var x = f.data, G = n > x.length ? x.length : n;
                if (G === x.length ? S += x : S += x.slice(0, n), (n -= G) == 0) {
                  G === x.length ? (++d, f.next ? this.head = f.next : this.head = this.tail = null) : (this.head = f, f.data = x.slice(G));
                  break;
                }
                ++d;
              }
              return this.length -= d, S;
            } }, { key: "_getBuffer", value: function(n) {
              var f = e.allocUnsafe(n), d = this.head, S = 1;
              for (d.data.copy(f), n -= d.data.length; d = d.next; ) {
                var x = d.data, G = n > x.length ? x.length : n;
                if (x.copy(f, f.length - n, 0, G), (n -= G) == 0) {
                  G === x.length ? (++S, d.next ? this.head = d.next : this.head = this.tail = null) : (this.head = d, d.data = x.slice(G));
                  break;
                }
                ++S;
              }
              return this.length -= S, f;
            } }, { key: p, value: function(n, f) {
              return m(this, function(d) {
                for (var S = 1; S < arguments.length; S++) {
                  var x = arguments[S] != null ? arguments[S] : {};
                  S % 2 ? te(Object(x), !0).forEach(function(G) {
                    E(d, G, x[G]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(d, Object.getOwnPropertyDescriptors(x)) : te(Object(x)).forEach(function(G) {
                    Object.defineProperty(d, G, Object.getOwnPropertyDescriptor(x, G));
                  });
                }
                return d;
              }({}, f, { depth: 0, customInspect: !1 }));
            } }], h && t(v.prototype, h), l;
          }();
        }, 6163: function(Se) {
          function ge(E, t) {
            te(E, t), R(E);
          }
          function R(E) {
            E._writableState && !E._writableState.emitClose || E._readableState && !E._readableState.emitClose || E.emit("close");
          }
          function te(E, t) {
            E.emit("error", t);
          }
          Se.exports = { destroy: function(E, t) {
            var e = this, m = this._readableState && this._readableState.destroyed, p = this._writableState && this._writableState.destroyed;
            return m || p ? (t ? t(E) : E && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(te, this, E)) : process.nextTick(te, this, E)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(E || null, function(l) {
              !t && l ? e._writableState ? e._writableState.errorEmitted ? process.nextTick(R, e) : (e._writableState.errorEmitted = !0, process.nextTick(ge, e, l)) : process.nextTick(ge, e, l) : t ? (process.nextTick(R, e), t(l)) : process.nextTick(R, e);
            }), this);
          }, undestroy: function() {
            this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
          }, errorOrDestroy: function(E, t) {
            var e = E._readableState, m = E._writableState;
            e && e.autoDestroy || m && m.autoDestroy ? E.destroy(t) : E.emit("error", t);
          } };
        }, 8800: function(Se, ge, R) {
          var te = R(3690).q.ERR_STREAM_PREMATURE_CLOSE;
          function E() {
          }
          Se.exports = function t(e, m, p) {
            if (typeof m == "function") return t(e, null, m);
            m || (m = {}), p = /* @__PURE__ */ function(J) {
              var M = !1;
              return function() {
                if (!M) {
                  M = !0;
                  for (var W = arguments.length, se = new Array(W), j = 0; j < W; j++) se[j] = arguments[j];
                  J.apply(this, se);
                }
              };
            }(p || E);
            var l = m.readable || m.readable !== !1 && e.readable, v = m.writable || m.writable !== !1 && e.writable, h = function() {
              e.writable || f();
            }, n = e._writableState && e._writableState.finished, f = function() {
              v = !1, n = !0, l || p.call(e);
            }, d = e._readableState && e._readableState.endEmitted, S = function() {
              l = !1, d = !0, v || p.call(e);
            }, x = function(J) {
              p.call(e, J);
            }, G = function() {
              var J;
              return l && !d ? (e._readableState && e._readableState.ended || (J = new te()), p.call(e, J)) : v && !n ? (e._writableState && e._writableState.ended || (J = new te()), p.call(e, J)) : void 0;
            }, P = function() {
              e.req.on("finish", f);
            };
            return function(J) {
              return J.setHeader && typeof J.abort == "function";
            }(e) ? (e.on("complete", f), e.on("abort", G), e.req ? P() : e.on("request", P)) : v && !e._writableState && (e.on("end", h), e.on("close", h)), e.on("end", S), e.on("finish", f), m.error !== !1 && e.on("error", x), e.on("close", G), function() {
              e.removeListener("complete", f), e.removeListener("abort", G), e.removeListener("request", P), e.req && e.req.removeListener("finish", f), e.removeListener("end", h), e.removeListener("close", h), e.removeListener("finish", f), e.removeListener("end", S), e.removeListener("error", x), e.removeListener("close", G);
            };
          };
        }, 6233: function(Se) {
          Se.exports = function() {
            throw new Error("Readable.from is not available in the browser");
          };
        }, 7295: function(Se, ge, R) {
          var te, E = R(3690).q, t = E.ERR_MISSING_ARGS, e = E.ERR_STREAM_DESTROYED;
          function m(n) {
            if (n) throw n;
          }
          function p(n, f, d, S) {
            S = /* @__PURE__ */ function(P) {
              var J = !1;
              return function() {
                J || (J = !0, P.apply(void 0, arguments));
              };
            }(S);
            var x = !1;
            n.on("close", function() {
              x = !0;
            }), te === void 0 && (te = R(8800)), te(n, { readable: f, writable: d }, function(P) {
              if (P) return S(P);
              x = !0, S();
            });
            var G = !1;
            return function(P) {
              if (!x && !G) return G = !0, function(J) {
                return J.setHeader && typeof J.abort == "function";
              }(n) ? n.abort() : typeof n.destroy == "function" ? n.destroy() : void S(P || new e("pipe"));
            };
          }
          function l(n) {
            n();
          }
          function v(n, f) {
            return n.pipe(f);
          }
          function h(n) {
            return n.length ? typeof n[n.length - 1] != "function" ? m : n.pop() : m;
          }
          Se.exports = function() {
            for (var n = arguments.length, f = new Array(n), d = 0; d < n; d++) f[d] = arguments[d];
            var S, x = h(f);
            if (Array.isArray(f[0]) && (f = f[0]), f.length < 2) throw new t("streams");
            var G = f.map(function(P, J) {
              var M = J < f.length - 1;
              return p(P, M, J > 0, function(W) {
                S || (S = W), W && G.forEach(l), M || (G.forEach(l), x(S));
              });
            });
            return f.reduce(v);
          };
        }, 7269: function(Se, ge, R) {
          var te = R(3690).q.ERR_INVALID_OPT_VALUE;
          Se.exports = { getHighWaterMark: function(E, t, e, m) {
            var p = function(l, v, h) {
              return l.highWaterMark != null ? l.highWaterMark : v ? l[h] : null;
            }(t, m, e);
            if (p != null) {
              if (!isFinite(p) || Math.floor(p) !== p || p < 0) throw new te(m ? e : "highWaterMark", p);
              return Math.floor(p);
            }
            return E.objectMode ? 16 : 16384;
          } };
        }, 9299: function(Se, ge, R) {
          Se.exports = R(1159).EventEmitter;
        }, 7503: function(Se, ge, R) {
          var te = R(8387).Buffer, E = te.isEncoding || function(d) {
            switch ((d = "" + d) && d.toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
              case "raw":
                return !0;
              default:
                return !1;
            }
          };
          function t(d) {
            var S;
            switch (this.encoding = function(x) {
              var G = function(P) {
                if (!P) return "utf8";
                for (var J; ; ) switch (P) {
                  case "utf8":
                  case "utf-8":
                    return "utf8";
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return "utf16le";
                  case "latin1":
                  case "binary":
                    return "latin1";
                  case "base64":
                  case "ascii":
                  case "hex":
                    return P;
                  default:
                    if (J) return;
                    P = ("" + P).toLowerCase(), J = !0;
                }
              }(x);
              if (typeof G != "string" && (te.isEncoding === E || !E(x))) throw new Error("Unknown encoding: " + x);
              return G || x;
            }(d), this.encoding) {
              case "utf16le":
                this.text = p, this.end = l, S = 4;
                break;
              case "utf8":
                this.fillLast = m, S = 4;
                break;
              case "base64":
                this.text = v, this.end = h, S = 3;
                break;
              default:
                return this.write = n, void (this.end = f);
            }
            this.lastNeed = 0, this.lastTotal = 0, this.lastChar = te.allocUnsafe(S);
          }
          function e(d) {
            return d <= 127 ? 0 : d >> 5 == 6 ? 2 : d >> 4 == 14 ? 3 : d >> 3 == 30 ? 4 : d >> 6 == 2 ? -1 : -2;
          }
          function m(d) {
            var S = this.lastTotal - this.lastNeed, x = function(G, P, J) {
              if ((192 & P[0]) != 128) return G.lastNeed = 0, "�";
              if (G.lastNeed > 1 && P.length > 1) {
                if ((192 & P[1]) != 128) return G.lastNeed = 1, "�";
                if (G.lastNeed > 2 && P.length > 2 && (192 & P[2]) != 128) return G.lastNeed = 2, "�";
              }
            }(this, d);
            return x !== void 0 ? x : this.lastNeed <= d.length ? (d.copy(this.lastChar, S, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (d.copy(this.lastChar, S, 0, d.length), void (this.lastNeed -= d.length));
          }
          function p(d, S) {
            if ((d.length - S) % 2 == 0) {
              var x = d.toString("utf16le", S);
              if (x) {
                var G = x.charCodeAt(x.length - 1);
                if (G >= 55296 && G <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = d[d.length - 2], this.lastChar[1] = d[d.length - 1], x.slice(0, -1);
              }
              return x;
            }
            return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = d[d.length - 1], d.toString("utf16le", S, d.length - 1);
          }
          function l(d) {
            var S = d && d.length ? this.write(d) : "";
            if (this.lastNeed) {
              var x = this.lastTotal - this.lastNeed;
              return S + this.lastChar.toString("utf16le", 0, x);
            }
            return S;
          }
          function v(d, S) {
            var x = (d.length - S) % 3;
            return x === 0 ? d.toString("base64", S) : (this.lastNeed = 3 - x, this.lastTotal = 3, x === 1 ? this.lastChar[0] = d[d.length - 1] : (this.lastChar[0] = d[d.length - 2], this.lastChar[1] = d[d.length - 1]), d.toString("base64", S, d.length - x));
          }
          function h(d) {
            var S = d && d.length ? this.write(d) : "";
            return this.lastNeed ? S + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : S;
          }
          function n(d) {
            return d.toString(this.encoding);
          }
          function f(d) {
            return d && d.length ? this.write(d) : "";
          }
          ge.s = t, t.prototype.write = function(d) {
            if (d.length === 0) return "";
            var S, x;
            if (this.lastNeed) {
              if ((S = this.fillLast(d)) === void 0) return "";
              x = this.lastNeed, this.lastNeed = 0;
            } else x = 0;
            return x < d.length ? S ? S + this.text(d, x) : this.text(d, x) : S || "";
          }, t.prototype.end = function(d) {
            var S = d && d.length ? this.write(d) : "";
            return this.lastNeed ? S + "�" : S;
          }, t.prototype.text = function(d, S) {
            var x = function(P, J, M) {
              var W = J.length - 1;
              if (W < M) return 0;
              var se = e(J[W]);
              return se >= 0 ? (se > 0 && (P.lastNeed = se - 1), se) : --W < M || se === -2 ? 0 : (se = e(J[W])) >= 0 ? (se > 0 && (P.lastNeed = se - 2), se) : --W < M || se === -2 ? 0 : (se = e(J[W])) >= 0 ? (se > 0 && (se === 2 ? se = 0 : P.lastNeed = se - 3), se) : 0;
            }(this, d, S);
            if (!this.lastNeed) return d.toString("utf8", S);
            this.lastTotal = x;
            var G = d.length - (x - this.lastNeed);
            return d.copy(this.lastChar, 0, G), d.toString("utf8", S, G);
          }, t.prototype.fillLast = function(d) {
            if (this.lastNeed <= d.length) return d.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
            d.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, d.length), this.lastNeed -= d.length;
          };
        }, 1067: function(Se, ge, R) {
          var te;
          (function(E, t) {
            var e = "function", m = "undefined", p = "object", l = "string", v = "major", h = "model", n = "name", f = "type", d = "vendor", S = "version", x = "architecture", G = "console", P = "mobile", J = "tablet", M = "smarttv", W = "wearable", se = "embedded", j = "Amazon", re = "Apple", ce = "ASUS", Re = "BlackBerry", $ = "Browser", Me = "Chrome", Ge = "Firefox", Qe = "Google", Ae = "Huawei", Ze = "LG", Xe = "Microsoft", at = "Motorola", Ie = "Opera", Be = "Samsung", It = "Sharp", _t = "Sony", Ve = "Xiaomi", ot = "Zebra", Ee = "Facebook", Te = "Chromium OS", je = "Mac OS", c = function(qe) {
              for (var it = {}, bt = 0; bt < qe.length; bt++) it[qe[bt].toUpperCase()] = qe[bt];
              return it;
            }, o = function(qe, it) {
              return typeof qe === l && T(it).indexOf(T(qe)) !== -1;
            }, T = function(qe) {
              return qe.toLowerCase();
            }, b = function(qe, it) {
              if (typeof qe === l) return qe = qe.replace(/^\s\s*/, ""), typeof it === m ? qe : qe.substring(0, 500);
            }, X = function(qe, it) {
              for (var bt, dt, Yt, Mt, Ht, Ut, cn = 0; cn < it.length && !Ht; ) {
                var Tn = it[cn], xn = it[cn + 1];
                for (bt = dt = 0; bt < Tn.length && !Ht && Tn[bt]; ) if (Ht = Tn[bt++].exec(qe)) for (Yt = 0; Yt < xn.length; Yt++) Ut = Ht[++dt], typeof (Mt = xn[Yt]) === p && Mt.length > 0 ? Mt.length === 2 ? typeof Mt[1] == e ? this[Mt[0]] = Mt[1].call(this, Ut) : this[Mt[0]] = Mt[1] : Mt.length === 3 ? typeof Mt[1] !== e || Mt[1].exec && Mt[1].test ? this[Mt[0]] = Ut ? Ut.replace(Mt[1], Mt[2]) : t : this[Mt[0]] = Ut ? Mt[1].call(this, Ut, Mt[2]) : t : Mt.length === 4 && (this[Mt[0]] = Ut ? Mt[3].call(this, Ut.replace(Mt[1], Mt[2])) : t) : this[Mt] = Ut || t;
                cn += 2;
              }
            }, z = function(qe, it) {
              for (var bt in it) if (typeof it[bt] === p && it[bt].length > 0) {
                for (var dt = 0; dt < it[bt].length; dt++) if (o(it[bt][dt], qe)) return bt === "?" ? t : bt;
              } else if (o(it[bt], qe)) return bt === "?" ? t : bt;
              return qe;
            }, De = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, tt = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [S, [n, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [S, [n, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [n, S], [/opios[\/ ]+([\w\.]+)/i], [S, [n, Ie + " Mini"]], [/\bopr\/([\w\.]+)/i], [S, [n, Ie]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [S, [n, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [n, S], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [S, [n, "UC" + $]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [S, [n, "WeChat"]], [/konqueror\/([\w\.]+)/i], [S, [n, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [S, [n, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [S, [n, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [S, [n, "Smart Lenovo " + $]], [/(avast|avg)\/([\w\.]+)/i], [[n, /(.+)/, "$1 Secure " + $], S], [/\bfocus\/([\w\.]+)/i], [S, [n, Ge + " Focus"]], [/\bopt\/([\w\.]+)/i], [S, [n, Ie + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [S, [n, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [S, [n, "Dolphin"]], [/coast\/([\w\.]+)/i], [S, [n, Ie + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [S, [n, "MIUI " + $]], [/fxios\/([-\w\.]+)/i], [S, [n, Ge]], [/\bqihu|(qi?ho?o?|360)browser/i], [[n, "360 " + $]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[n, /(.+)/, "$1 " + $], S], [/samsungbrowser\/([\w\.]+)/i], [S, [n, Be + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[n, /_/g, " "], S], [/metasr[\/ ]?([\d\.]+)/i], [S, [n, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[n, "Sogou Mobile"], S], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [n, S], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [n], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[n, Ee], S], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [n, S], [/\bgsa\/([\w\.]+) .*safari\//i], [S, [n, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [S, [n, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [S, [n, Me + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[n, Me + " WebView"], S], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [S, [n, "Android " + $]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [n, S], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [S, [n, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [S, n], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [n, [S, z, { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }]], [/(webkit|khtml)\/([\w\.]+)/i], [n, S], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[n, "Netscape"], S], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [S, [n, Ge + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [n, S], [/(cobalt)\/([\w\.]+)/i], [n, [S, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[x, "amd64"]], [/(ia32(?=;))/i], [[x, T]], [/((?:i[346]|x)86)[;\)]/i], [[x, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[x, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[x, "armhf"]], [/windows (ce|mobile); ppc;/i], [[x, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[x, /ower/, "", T]], [/(sun4\w)[;\)]/i], [[x, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[x, T]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [h, [d, Be], [f, J]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [h, [d, Be], [f, P]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [h, [d, re], [f, P]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [h, [d, re], [f, J]], [/(macintosh);/i], [h, [d, re]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [h, [d, It], [f, P]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [h, [d, Ae], [f, J]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [h, [d, Ae], [f, P]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[h, /_/g, " "], [d, Ve], [f, P]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[h, /_/g, " "], [d, Ve], [f, J]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [h, [d, "OPPO"], [f, P]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [h, [d, "Vivo"], [f, P]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [h, [d, "Realme"], [f, P]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [h, [d, at], [f, P]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [h, [d, at], [f, J]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [h, [d, Ze], [f, J]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [h, [d, Ze], [f, P]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [h, [d, "Lenovo"], [f, J]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[h, /_/g, " "], [d, "Nokia"], [f, P]], [/(pixel c)\b/i], [h, [d, Qe], [f, J]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [h, [d, Qe], [f, P]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [h, [d, _t], [f, P]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[h, "Xperia Tablet"], [d, _t], [f, J]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [h, [d, "OnePlus"], [f, P]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [h, [d, j], [f, J]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[h, /(.+)/g, "Fire Phone $1"], [d, j], [f, P]], [/(playbook);[-\w\),; ]+(rim)/i], [h, d, [f, J]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [h, [d, Re], [f, P]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [h, [d, ce], [f, J]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [h, [d, ce], [f, P]], [/(nexus 9)/i], [h, [d, "HTC"], [f, J]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [d, [h, /_/g, " "], [f, P]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [h, [d, "Acer"], [f, J]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [h, [d, "Meizu"], [f, P]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [h, [d, "Ulefone"], [f, P]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [d, h, [f, P]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [d, h, [f, J]], [/(surface duo)/i], [h, [d, Xe], [f, J]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [h, [d, "Fairphone"], [f, P]], [/(u304aa)/i], [h, [d, "AT&T"], [f, P]], [/\bsie-(\w*)/i], [h, [d, "Siemens"], [f, P]], [/\b(rct\w+) b/i], [h, [d, "RCA"], [f, J]], [/\b(venue[\d ]{2,7}) b/i], [h, [d, "Dell"], [f, J]], [/\b(q(?:mv|ta)\w+) b/i], [h, [d, "Verizon"], [f, J]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [h, [d, "Barnes & Noble"], [f, J]], [/\b(tm\d{3}\w+) b/i], [h, [d, "NuVision"], [f, J]], [/\b(k88) b/i], [h, [d, "ZTE"], [f, J]], [/\b(nx\d{3}j) b/i], [h, [d, "ZTE"], [f, P]], [/\b(gen\d{3}) b.+49h/i], [h, [d, "Swiss"], [f, P]], [/\b(zur\d{3}) b/i], [h, [d, "Swiss"], [f, J]], [/\b((zeki)?tb.*\b) b/i], [h, [d, "Zeki"], [f, J]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[d, "Dragon Touch"], h, [f, J]], [/\b(ns-?\w{0,9}) b/i], [h, [d, "Insignia"], [f, J]], [/\b((nxa|next)-?\w{0,9}) b/i], [h, [d, "NextBook"], [f, J]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[d, "Voice"], h, [f, P]], [/\b(lvtel\-)?(v1[12]) b/i], [[d, "LvTel"], h, [f, P]], [/\b(ph-1) /i], [h, [d, "Essential"], [f, P]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [h, [d, "Envizen"], [f, J]], [/\b(trio[-\w\. ]+) b/i], [h, [d, "MachSpeed"], [f, J]], [/\btu_(1491) b/i], [h, [d, "Rotor"], [f, J]], [/(shield[\w ]+) b/i], [h, [d, "Nvidia"], [f, J]], [/(sprint) (\w+)/i], [d, h, [f, P]], [/(kin\.[onetw]{3})/i], [[h, /\./g, " "], [d, Xe], [f, P]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [h, [d, ot], [f, J]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [h, [d, ot], [f, P]], [/smart-tv.+(samsung)/i], [d, [f, M]], [/hbbtv.+maple;(\d+)/i], [[h, /^/, "SmartTV"], [d, Be], [f, M]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[d, Ze], [f, M]], [/(apple) ?tv/i], [d, [h, re + " TV"], [f, M]], [/crkey/i], [[h, Me + "cast"], [d, Qe], [f, M]], [/droid.+aft(\w+)( bui|\))/i], [h, [d, j], [f, M]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [h, [d, It], [f, M]], [/(bravia[\w ]+)( bui|\))/i], [h, [d, _t], [f, M]], [/(mitv-\w{5}) bui/i], [h, [d, Ve], [f, M]], [/Hbbtv.*(technisat) (.*);/i], [d, h, [f, M]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[d, b], [h, b], [f, M]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[f, M]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [d, h, [f, G]], [/droid.+; (shield) bui/i], [h, [d, "Nvidia"], [f, G]], [/(playstation [345portablevi]+)/i], [h, [d, _t], [f, G]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [h, [d, Xe], [f, G]], [/((pebble))app/i], [d, h, [f, W]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [h, [d, re], [f, W]], [/droid.+; (glass) \d/i], [h, [d, Qe], [f, W]], [/droid.+; (wt63?0{2,3})\)/i], [h, [d, ot], [f, W]], [/(quest( 2| pro)?)/i], [h, [d, Ee], [f, W]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [d, [f, se]], [/(aeobc)\b/i], [h, [d, j], [f, se]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [h, [f, P]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [h, [f, J]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[f, J]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[f, P]], [/(android[-\w\. ]{0,9});.+buil/i], [h, [d, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [S, [n, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [S, [n, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [n, S], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [S, n]], os: [[/microsoft (windows) (vista|xp)/i], [n, S], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [n, [S, z, De]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[S, z, De], [n, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[S, /_/g, "."], [n, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[n, je], [S, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [S, n], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [n, S], [/\(bb(10);/i], [S, [n, Re]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [S, [n, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [S, [n, Ge + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [S, [n, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [S, [n, "watchOS"]], [/crkey\/([\d\.]+)/i], [S, [n, Me + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[n, Te], S], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [n, S], [/(sunos) ?([\w\.\d]*)/i], [[n, "Solaris"], S], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [n, S]] }, Ue = function(qe, it) {
              if (typeof qe === p && (it = qe, qe = t), !(this instanceof Ue)) return new Ue(qe, it).getResult();
              var bt = typeof E !== m && E.navigator ? E.navigator : t, dt = qe || (bt && bt.userAgent ? bt.userAgent : ""), Yt = bt && bt.userAgentData ? bt.userAgentData : t, Mt = it ? function(Ut, cn) {
                var Tn = {};
                for (var xn in Ut) cn[xn] && cn[xn].length % 2 == 0 ? Tn[xn] = cn[xn].concat(Ut[xn]) : Tn[xn] = Ut[xn];
                return Tn;
              }(tt, it) : tt, Ht = bt && bt.userAgent == dt;
              return this.getBrowser = function() {
                var Ut, cn = {};
                return cn[n] = t, cn[S] = t, X.call(cn, dt, Mt.browser), cn[v] = typeof (Ut = cn[S]) === l ? Ut.replace(/[^\d\.]/g, "").split(".")[0] : t, Ht && bt && bt.brave && typeof bt.brave.isBrave == e && (cn[n] = "Brave"), cn;
              }, this.getCPU = function() {
                var Ut = {};
                return Ut[x] = t, X.call(Ut, dt, Mt.cpu), Ut;
              }, this.getDevice = function() {
                var Ut = {};
                return Ut[d] = t, Ut[h] = t, Ut[f] = t, X.call(Ut, dt, Mt.device), Ht && !Ut[f] && Yt && Yt.mobile && (Ut[f] = P), Ht && Ut[h] == "Macintosh" && bt && typeof bt.standalone !== m && bt.maxTouchPoints && bt.maxTouchPoints > 2 && (Ut[h] = "iPad", Ut[f] = J), Ut;
              }, this.getEngine = function() {
                var Ut = {};
                return Ut[n] = t, Ut[S] = t, X.call(Ut, dt, Mt.engine), Ut;
              }, this.getOS = function() {
                var Ut = {};
                return Ut[n] = t, Ut[S] = t, X.call(Ut, dt, Mt.os), Ht && !Ut[n] && Yt && Yt.platform != "Unknown" && (Ut[n] = Yt.platform.replace(/chrome os/i, Te).replace(/macos/i, je)), Ut;
              }, this.getResult = function() {
                return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
              }, this.getUA = function() {
                return dt;
              }, this.setUA = function(Ut) {
                return dt = typeof Ut === l && Ut.length > 500 ? b(Ut, 500) : Ut, this;
              }, this.setUA(dt), this;
            };
            Ue.VERSION = "1.0.37", Ue.BROWSER = c([n, S, v]), Ue.CPU = c([x]), Ue.DEVICE = c([h, d, f, G, P, M, J, W, se]), Ue.ENGINE = Ue.OS = c([n, S]), typeof ge !== m ? (Se.exports && (ge = Se.exports = Ue), ge.UAParser = Ue) : R.amdO ? (te = (function() {
              return Ue;
            }).call(ge, R, ge, Se)) === t || (Se.exports = te) : typeof E !== m && (E.UAParser = Ue);
            var ke = typeof E !== m && (E.jQuery || E.Zepto);
            if (ke && !ke.ua) {
              var Oe = new Ue();
              ke.ua = Oe.getResult(), ke.ua.get = function() {
                return Oe.getUA();
              }, ke.ua.set = function(qe) {
                Oe.setUA(qe);
                var it = Oe.getResult();
                for (var bt in it) ke.ua[bt] = it[bt];
              };
            }
          })(typeof window == "object" ? window : this);
        }, 7839: function(Se, ge, R) {
          function te(E) {
            try {
              if (!R.g.localStorage) return !1;
            } catch {
              return !1;
            }
            var t = R.g.localStorage[E];
            return t != null && String(t).toLowerCase() === "true";
          }
          Se.exports = function(E, t) {
            if (te("noDeprecation")) return E;
            var e = !1;
            return function() {
              if (!e) {
                if (te("throwDeprecation")) throw new Error(t);
                te("traceDeprecation") ? console.trace(t) : console.warn(t), e = !0;
              }
              return E.apply(this, arguments);
            };
          };
        }, 9862: function() {
        }, 964: function() {
        }, 3165: function(Se) {
          Se.exports = JSON.parse('["mni-beng-in","mni-mtei-in","sat-deva-in","sat-olck-in","shi-latn-ma","shi-tfng-ma","vai-latn-lr","vai-vaii-lr","yue-hans-cn","yue-hant-hk","az-arab-ir","az-cyrl-az","az-latn-az","bm-nkoo-ml","bs-cyrl-ba","bs-latn-ba","en-dsrt-us","ff-adlm-gn","ff-latn-sn","ha-arab-ng","hi-latn-in","iu-latn-ca","ks-arab-in","ks-deva-in","mn-mong-cn","ms-arab-my","pa-arab-pk","pa-guru-in","sd-arab-pk","sd-deva-in","sr-cyrl-rs","sr-latn-rs","su-latn-id","uz-arab-af","uz-cyrl-uz","uz-latn-uz","zh-hans-cn","zh-hant-tw","mni-beng","sat-olck","shi-tfng","vai-vaii","yue-hant","az-latn","bs-latn","ff-latn","jbo-001","ks-arab","pa-guru","prg-001","sd-arab","sr-cyrl","su-latn","uz-latn","zh-hans","agq-cm","ar-001","arn-cl","asa-tz","ast-es","bas-cm","bem-zm","bez-tz","bgn-pk","blt-vn","brx-in","bss-cm","byn-er","cad-us","cch-ng","ccp-bd","ceb-ph","cgg-ug","chr-us","cic-us","ckb-iq","dav-ke","dje-ne","doi-in","dsb-de","dua-cm","dyo-sn","ebu-ke","eo-001","ewo-cm","fil-ph","fur-it","gaa-gh","gez-et","gsw-ch","guz-ke","haw-us","hsb-de","ia-001","ife-tg","io-001","jgo-cm","jmc-tz","kab-dz","kaj-ng","kam-ke","kcg-ng","kde-tz","kea-cv","ken-cm","khq-ml","kkj-cm","kln-ke","kok-in","kpe-lr","ksb-tz","ksf-cm","ksh-de","lag-tz","lkt-us","lrc-ir","luo-ke","luy-ke","mai-in","mas-ke","mer-ke","mfe-mu","mgh-mz","mgo-cm","moh-ca","mua-cm","mus-us","myv-ru","mzn-ir","naq-na","nds-de","nmg-cm","nnh-cm","nqo-gn","nso-za","nus-ss","nyn-ug","osa-us","pcm-ng","quc-gt","rof-tz","rwk-tz","sah-ru","saq-ke","sbp-tz","scn-it","sdh-ir","seh-mz","ses-ml","sid-et","sma-se","smj-se","smn-fi","sms-fi","ssy-er","syr-iq","szl-pl","teo-ug","tig-er","trv-tw","trw-pk","twq-ne","tzm-ma","vo-001","vun-tz","wae-ch","wal-et","wbp-au","xog-ug","yav-cm","yi-001","zgh-ma","aa-et","af-za","ak-gh","am-et","an-es","as-in","ba-ru","be-by","bg-bg","bm-ml","bn-bd","bo-cn","br-fr","ca-es","ce-ru","co-fr","cs-cz","cu-ru","cv-ru","cy-gb","da-dk","de-de","dv-mv","dz-bt","ee-gh","el-gr","en-us","es-es","et-ee","eu-es","fa-ir","fi-fi","fo-fo","fr-fr","fy-nl","ga-ie","gd-gb","gl-es","gn-py","gu-in","gv-im","ha-ng","he-il","hi-in","hr-hr","hu-hu","hy-am","id-id","ig-ng","ii-cn","is-is","it-it","iu-ca","ja-jp","jv-id","ka-ge","ki-ke","kk-kz","kl-gl","km-kh","kn-in","ko-kr","ku-tr","kw-gb","ky-kg","lb-lu","lg-ug","ln-cd","lo-la","lt-lt","lu-cd","lv-lv","mg-mg","mi-nz","mk-mk","ml-in","mn-mn","mr-in","ms-my","mt-mt","my-mm","nb-no","nd-zw","ne-np","nl-nl","nn-no","nr-za","nv-us","ny-mw","oc-fr","om-et","or-in","os-ge","pl-pl","ps-af","pt-br","qu-pe","rm-ch","rn-bi","ro-ro","ru-ru","rw-rw","sa-in","sc-it","se-no","sg-cf","si-lk","sk-sk","sl-si","sn-zw","so-so","sq-al","ss-za","st-za","sv-se","sw-tz","ta-in","te-in","tg-tj","th-th","ti-et","tk-tm","tn-za","to-to","tr-tr","ts-za","tt-ru","ug-cn","uk-ua","ur-pk","ve-za","vi-vn","wa-be","wo-sn","xh-za","yo-ng","zu-za"]');
        }, 5813: function(Se) {
          Se.exports = JSON.parse('[{"from":{"field":"script","value":"qaai"},"to":{"field":"script","value":"zinh"}},{"from":{"field":"region","value":"bu"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"ct"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"dd"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"dy"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"fx"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"hv"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"jt"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"mi"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"nh"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"nq"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"pu"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"pz"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"qu"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"rh"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"tp"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"uk"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"vd"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"wk"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"yd"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"zr"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"230"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"280"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"736"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"886"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"958"},"to":{"field":"region","value":"aa"}},{"from":{"field":"region","value":"020"},"to":{"field":"region","value":"ad"}},{"from":{"field":"region","value":"784"},"to":{"field":"region","value":"ae"}},{"from":{"field":"region","value":"004"},"to":{"field":"region","value":"af"}},{"from":{"field":"region","value":"028"},"to":{"field":"region","value":"ag"}},{"from":{"field":"region","value":"660"},"to":{"field":"region","value":"ai"}},{"from":{"field":"region","value":"008"},"to":{"field":"region","value":"al"}},{"from":{"field":"region","value":"051"},"to":{"field":"region","value":"am"}},{"from":{"field":"region","value":"024"},"to":{"field":"region","value":"ao"}},{"from":{"field":"region","value":"010"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"032"},"to":{"field":"region","value":"ar"}},{"from":{"field":"region","value":"016"},"to":{"field":"region","value":"as"}},{"from":{"field":"region","value":"040"},"to":{"field":"region","value":"at"}},{"from":{"field":"region","value":"036"},"to":{"field":"region","value":"au"}},{"from":{"field":"region","value":"533"},"to":{"field":"region","value":"aw"}},{"from":{"field":"region","value":"248"},"to":{"field":"region","value":"ax"}},{"from":{"field":"region","value":"031"},"to":{"field":"region","value":"az"}},{"from":{"field":"region","value":"070"},"to":{"field":"region","value":"ba"}},{"from":{"field":"region","value":"052"},"to":{"field":"region","value":"bb"}},{"from":{"field":"region","value":"050"},"to":{"field":"region","value":"bd"}},{"from":{"field":"region","value":"056"},"to":{"field":"region","value":"be"}},{"from":{"field":"region","value":"854"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"100"},"to":{"field":"region","value":"bg"}},{"from":{"field":"region","value":"048"},"to":{"field":"region","value":"bh"}},{"from":{"field":"region","value":"108"},"to":{"field":"region","value":"bi"}},{"from":{"field":"region","value":"204"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"652"},"to":{"field":"region","value":"bl"}},{"from":{"field":"region","value":"060"},"to":{"field":"region","value":"bm"}},{"from":{"field":"region","value":"096"},"to":{"field":"region","value":"bn"}},{"from":{"field":"region","value":"068"},"to":{"field":"region","value":"bo"}},{"from":{"field":"region","value":"535"},"to":{"field":"region","value":"bq"}},{"from":{"field":"region","value":"076"},"to":{"field":"region","value":"br"}},{"from":{"field":"region","value":"044"},"to":{"field":"region","value":"bs"}},{"from":{"field":"region","value":"064"},"to":{"field":"region","value":"bt"}},{"from":{"field":"region","value":"104"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"074"},"to":{"field":"region","value":"bv"}},{"from":{"field":"region","value":"072"},"to":{"field":"region","value":"bw"}},{"from":{"field":"region","value":"112"},"to":{"field":"region","value":"by"}},{"from":{"field":"region","value":"084"},"to":{"field":"region","value":"bz"}},{"from":{"field":"region","value":"124"},"to":{"field":"region","value":"ca"}},{"from":{"field":"region","value":"166"},"to":{"field":"region","value":"cc"}},{"from":{"field":"region","value":"180"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"140"},"to":{"field":"region","value":"cf"}},{"from":{"field":"region","value":"178"},"to":{"field":"region","value":"cg"}},{"from":{"field":"region","value":"756"},"to":{"field":"region","value":"ch"}},{"from":{"field":"region","value":"384"},"to":{"field":"region","value":"ci"}},{"from":{"field":"region","value":"184"},"to":{"field":"region","value":"ck"}},{"from":{"field":"region","value":"152"},"to":{"field":"region","value":"cl"}},{"from":{"field":"region","value":"120"},"to":{"field":"region","value":"cm"}},{"from":{"field":"region","value":"156"},"to":{"field":"region","value":"cn"}},{"from":{"field":"region","value":"170"},"to":{"field":"region","value":"co"}},{"from":{"field":"region","value":"188"},"to":{"field":"region","value":"cr"}},{"from":{"field":"region","value":"192"},"to":{"field":"region","value":"cu"}},{"from":{"field":"region","value":"132"},"to":{"field":"region","value":"cv"}},{"from":{"field":"region","value":"531"},"to":{"field":"region","value":"cw"}},{"from":{"field":"region","value":"162"},"to":{"field":"region","value":"cx"}},{"from":{"field":"region","value":"196"},"to":{"field":"region","value":"cy"}},{"from":{"field":"region","value":"203"},"to":{"field":"region","value":"cz"}},{"from":{"field":"region","value":"278"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"276"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"262"},"to":{"field":"region","value":"dj"}},{"from":{"field":"region","value":"208"},"to":{"field":"region","value":"dk"}},{"from":{"field":"region","value":"212"},"to":{"field":"region","value":"dm"}},{"from":{"field":"region","value":"214"},"to":{"field":"region","value":"do"}},{"from":{"field":"region","value":"012"},"to":{"field":"region","value":"dz"}},{"from":{"field":"region","value":"218"},"to":{"field":"region","value":"ec"}},{"from":{"field":"region","value":"233"},"to":{"field":"region","value":"ee"}},{"from":{"field":"region","value":"818"},"to":{"field":"region","value":"eg"}},{"from":{"field":"region","value":"732"},"to":{"field":"region","value":"eh"}},{"from":{"field":"region","value":"232"},"to":{"field":"region","value":"er"}},{"from":{"field":"region","value":"724"},"to":{"field":"region","value":"es"}},{"from":{"field":"region","value":"231"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"246"},"to":{"field":"region","value":"fi"}},{"from":{"field":"region","value":"242"},"to":{"field":"region","value":"fj"}},{"from":{"field":"region","value":"238"},"to":{"field":"region","value":"fk"}},{"from":{"field":"region","value":"583"},"to":{"field":"region","value":"fm"}},{"from":{"field":"region","value":"234"},"to":{"field":"region","value":"fo"}},{"from":{"field":"region","value":"250"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"249"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"266"},"to":{"field":"region","value":"ga"}},{"from":{"field":"region","value":"826"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"308"},"to":{"field":"region","value":"gd"}},{"from":{"field":"region","value":"268"},"to":{"field":"region","value":"ge"}},{"from":{"field":"region","value":"254"},"to":{"field":"region","value":"gf"}},{"from":{"field":"region","value":"831"},"to":{"field":"region","value":"gg"}},{"from":{"field":"region","value":"288"},"to":{"field":"region","value":"gh"}},{"from":{"field":"region","value":"292"},"to":{"field":"region","value":"gi"}},{"from":{"field":"region","value":"304"},"to":{"field":"region","value":"gl"}},{"from":{"field":"region","value":"270"},"to":{"field":"region","value":"gm"}},{"from":{"field":"region","value":"324"},"to":{"field":"region","value":"gn"}},{"from":{"field":"region","value":"312"},"to":{"field":"region","value":"gp"}},{"from":{"field":"region","value":"226"},"to":{"field":"region","value":"gq"}},{"from":{"field":"region","value":"300"},"to":{"field":"region","value":"gr"}},{"from":{"field":"region","value":"239"},"to":{"field":"region","value":"gs"}},{"from":{"field":"region","value":"320"},"to":{"field":"region","value":"gt"}},{"from":{"field":"region","value":"316"},"to":{"field":"region","value":"gu"}},{"from":{"field":"region","value":"624"},"to":{"field":"region","value":"gw"}},{"from":{"field":"region","value":"328"},"to":{"field":"region","value":"gy"}},{"from":{"field":"region","value":"344"},"to":{"field":"region","value":"hk"}},{"from":{"field":"region","value":"334"},"to":{"field":"region","value":"hm"}},{"from":{"field":"region","value":"340"},"to":{"field":"region","value":"hn"}},{"from":{"field":"region","value":"191"},"to":{"field":"region","value":"hr"}},{"from":{"field":"region","value":"332"},"to":{"field":"region","value":"ht"}},{"from":{"field":"region","value":"348"},"to":{"field":"region","value":"hu"}},{"from":{"field":"region","value":"360"},"to":{"field":"region","value":"id"}},{"from":{"field":"region","value":"372"},"to":{"field":"region","value":"ie"}},{"from":{"field":"region","value":"376"},"to":{"field":"region","value":"il"}},{"from":{"field":"region","value":"833"},"to":{"field":"region","value":"im"}},{"from":{"field":"region","value":"356"},"to":{"field":"region","value":"in"}},{"from":{"field":"region","value":"086"},"to":{"field":"region","value":"io"}},{"from":{"field":"region","value":"368"},"to":{"field":"region","value":"iq"}},{"from":{"field":"region","value":"364"},"to":{"field":"region","value":"ir"}},{"from":{"field":"region","value":"352"},"to":{"field":"region","value":"is"}},{"from":{"field":"region","value":"380"},"to":{"field":"region","value":"it"}},{"from":{"field":"region","value":"832"},"to":{"field":"region","value":"je"}},{"from":{"field":"region","value":"388"},"to":{"field":"region","value":"jm"}},{"from":{"field":"region","value":"400"},"to":{"field":"region","value":"jo"}},{"from":{"field":"region","value":"392"},"to":{"field":"region","value":"jp"}},{"from":{"field":"region","value":"404"},"to":{"field":"region","value":"ke"}},{"from":{"field":"region","value":"417"},"to":{"field":"region","value":"kg"}},{"from":{"field":"region","value":"116"},"to":{"field":"region","value":"kh"}},{"from":{"field":"region","value":"296"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"174"},"to":{"field":"region","value":"km"}},{"from":{"field":"region","value":"659"},"to":{"field":"region","value":"kn"}},{"from":{"field":"region","value":"408"},"to":{"field":"region","value":"kp"}},{"from":{"field":"region","value":"410"},"to":{"field":"region","value":"kr"}},{"from":{"field":"region","value":"414"},"to":{"field":"region","value":"kw"}},{"from":{"field":"region","value":"136"},"to":{"field":"region","value":"ky"}},{"from":{"field":"region","value":"398"},"to":{"field":"region","value":"kz"}},{"from":{"field":"region","value":"418"},"to":{"field":"region","value":"la"}},{"from":{"field":"region","value":"422"},"to":{"field":"region","value":"lb"}},{"from":{"field":"region","value":"662"},"to":{"field":"region","value":"lc"}},{"from":{"field":"region","value":"438"},"to":{"field":"region","value":"li"}},{"from":{"field":"region","value":"144"},"to":{"field":"region","value":"lk"}},{"from":{"field":"region","value":"430"},"to":{"field":"region","value":"lr"}},{"from":{"field":"region","value":"426"},"to":{"field":"region","value":"ls"}},{"from":{"field":"region","value":"440"},"to":{"field":"region","value":"lt"}},{"from":{"field":"region","value":"442"},"to":{"field":"region","value":"lu"}},{"from":{"field":"region","value":"428"},"to":{"field":"region","value":"lv"}},{"from":{"field":"region","value":"434"},"to":{"field":"region","value":"ly"}},{"from":{"field":"region","value":"504"},"to":{"field":"region","value":"ma"}},{"from":{"field":"region","value":"492"},"to":{"field":"region","value":"mc"}},{"from":{"field":"region","value":"498"},"to":{"field":"region","value":"md"}},{"from":{"field":"region","value":"499"},"to":{"field":"region","value":"me"}},{"from":{"field":"region","value":"663"},"to":{"field":"region","value":"mf"}},{"from":{"field":"region","value":"450"},"to":{"field":"region","value":"mg"}},{"from":{"field":"region","value":"584"},"to":{"field":"region","value":"mh"}},{"from":{"field":"region","value":"807"},"to":{"field":"region","value":"mk"}},{"from":{"field":"region","value":"466"},"to":{"field":"region","value":"ml"}},{"from":{"field":"region","value":"496"},"to":{"field":"region","value":"mn"}},{"from":{"field":"region","value":"446"},"to":{"field":"region","value":"mo"}},{"from":{"field":"region","value":"580"},"to":{"field":"region","value":"mp"}},{"from":{"field":"region","value":"474"},"to":{"field":"region","value":"mq"}},{"from":{"field":"region","value":"478"},"to":{"field":"region","value":"mr"}},{"from":{"field":"region","value":"500"},"to":{"field":"region","value":"ms"}},{"from":{"field":"region","value":"470"},"to":{"field":"region","value":"mt"}},{"from":{"field":"region","value":"480"},"to":{"field":"region","value":"mu"}},{"from":{"field":"region","value":"462"},"to":{"field":"region","value":"mv"}},{"from":{"field":"region","value":"454"},"to":{"field":"region","value":"mw"}},{"from":{"field":"region","value":"484"},"to":{"field":"region","value":"mx"}},{"from":{"field":"region","value":"458"},"to":{"field":"region","value":"my"}},{"from":{"field":"region","value":"508"},"to":{"field":"region","value":"mz"}},{"from":{"field":"region","value":"516"},"to":{"field":"region","value":"na"}},{"from":{"field":"region","value":"540"},"to":{"field":"region","value":"nc"}},{"from":{"field":"region","value":"562"},"to":{"field":"region","value":"ne"}},{"from":{"field":"region","value":"574"},"to":{"field":"region","value":"nf"}},{"from":{"field":"region","value":"566"},"to":{"field":"region","value":"ng"}},{"from":{"field":"region","value":"558"},"to":{"field":"region","value":"ni"}},{"from":{"field":"region","value":"528"},"to":{"field":"region","value":"nl"}},{"from":{"field":"region","value":"578"},"to":{"field":"region","value":"no"}},{"from":{"field":"region","value":"524"},"to":{"field":"region","value":"np"}},{"from":{"field":"region","value":"520"},"to":{"field":"region","value":"nr"}},{"from":{"field":"region","value":"570"},"to":{"field":"region","value":"nu"}},{"from":{"field":"region","value":"554"},"to":{"field":"region","value":"nz"}},{"from":{"field":"region","value":"512"},"to":{"field":"region","value":"om"}},{"from":{"field":"region","value":"591"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"604"},"to":{"field":"region","value":"pe"}},{"from":{"field":"region","value":"258"},"to":{"field":"region","value":"pf"}},{"from":{"field":"region","value":"598"},"to":{"field":"region","value":"pg"}},{"from":{"field":"region","value":"608"},"to":{"field":"region","value":"ph"}},{"from":{"field":"region","value":"586"},"to":{"field":"region","value":"pk"}},{"from":{"field":"region","value":"616"},"to":{"field":"region","value":"pl"}},{"from":{"field":"region","value":"666"},"to":{"field":"region","value":"pm"}},{"from":{"field":"region","value":"612"},"to":{"field":"region","value":"pn"}},{"from":{"field":"region","value":"630"},"to":{"field":"region","value":"pr"}},{"from":{"field":"region","value":"275"},"to":{"field":"region","value":"ps"}},{"from":{"field":"region","value":"620"},"to":{"field":"region","value":"pt"}},{"from":{"field":"region","value":"585"},"to":{"field":"region","value":"pw"}},{"from":{"field":"region","value":"600"},"to":{"field":"region","value":"py"}},{"from":{"field":"region","value":"634"},"to":{"field":"region","value":"qa"}},{"from":{"field":"region","value":"959"},"to":{"field":"region","value":"qm"}},{"from":{"field":"region","value":"960"},"to":{"field":"region","value":"qn"}},{"from":{"field":"region","value":"962"},"to":{"field":"region","value":"qp"}},{"from":{"field":"region","value":"963"},"to":{"field":"region","value":"qq"}},{"from":{"field":"region","value":"964"},"to":{"field":"region","value":"qr"}},{"from":{"field":"region","value":"965"},"to":{"field":"region","value":"qs"}},{"from":{"field":"region","value":"966"},"to":{"field":"region","value":"qt"}},{"from":{"field":"region","value":"967"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"968"},"to":{"field":"region","value":"qv"}},{"from":{"field":"region","value":"969"},"to":{"field":"region","value":"qw"}},{"from":{"field":"region","value":"970"},"to":{"field":"region","value":"qx"}},{"from":{"field":"region","value":"971"},"to":{"field":"region","value":"qy"}},{"from":{"field":"region","value":"972"},"to":{"field":"region","value":"qz"}},{"from":{"field":"region","value":"638"},"to":{"field":"region","value":"re"}},{"from":{"field":"region","value":"642"},"to":{"field":"region","value":"ro"}},{"from":{"field":"region","value":"688"},"to":{"field":"region","value":"rs"}},{"from":{"field":"region","value":"643"},"to":{"field":"region","value":"ru"}},{"from":{"field":"region","value":"646"},"to":{"field":"region","value":"rw"}},{"from":{"field":"region","value":"682"},"to":{"field":"region","value":"sa"}},{"from":{"field":"region","value":"090"},"to":{"field":"region","value":"sb"}},{"from":{"field":"region","value":"690"},"to":{"field":"region","value":"sc"}},{"from":{"field":"region","value":"729"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"752"},"to":{"field":"region","value":"se"}},{"from":{"field":"region","value":"702"},"to":{"field":"region","value":"sg"}},{"from":{"field":"region","value":"654"},"to":{"field":"region","value":"sh"}},{"from":{"field":"region","value":"705"},"to":{"field":"region","value":"si"}},{"from":{"field":"region","value":"744"},"to":{"field":"region","value":"sj"}},{"from":{"field":"region","value":"703"},"to":{"field":"region","value":"sk"}},{"from":{"field":"region","value":"694"},"to":{"field":"region","value":"sl"}},{"from":{"field":"region","value":"674"},"to":{"field":"region","value":"sm"}},{"from":{"field":"region","value":"686"},"to":{"field":"region","value":"sn"}},{"from":{"field":"region","value":"706"},"to":{"field":"region","value":"so"}},{"from":{"field":"region","value":"740"},"to":{"field":"region","value":"sr"}},{"from":{"field":"region","value":"728"},"to":{"field":"region","value":"ss"}},{"from":{"field":"region","value":"678"},"to":{"field":"region","value":"st"}},{"from":{"field":"region","value":"222"},"to":{"field":"region","value":"sv"}},{"from":{"field":"region","value":"534"},"to":{"field":"region","value":"sx"}},{"from":{"field":"region","value":"760"},"to":{"field":"region","value":"sy"}},{"from":{"field":"region","value":"748"},"to":{"field":"region","value":"sz"}},{"from":{"field":"region","value":"796"},"to":{"field":"region","value":"tc"}},{"from":{"field":"region","value":"148"},"to":{"field":"region","value":"td"}},{"from":{"field":"region","value":"260"},"to":{"field":"region","value":"tf"}},{"from":{"field":"region","value":"768"},"to":{"field":"region","value":"tg"}},{"from":{"field":"region","value":"764"},"to":{"field":"region","value":"th"}},{"from":{"field":"region","value":"762"},"to":{"field":"region","value":"tj"}},{"from":{"field":"region","value":"772"},"to":{"field":"region","value":"tk"}},{"from":{"field":"region","value":"626"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"795"},"to":{"field":"region","value":"tm"}},{"from":{"field":"region","value":"788"},"to":{"field":"region","value":"tn"}},{"from":{"field":"region","value":"776"},"to":{"field":"region","value":"to"}},{"from":{"field":"region","value":"792"},"to":{"field":"region","value":"tr"}},{"from":{"field":"region","value":"780"},"to":{"field":"region","value":"tt"}},{"from":{"field":"region","value":"798"},"to":{"field":"region","value":"tv"}},{"from":{"field":"region","value":"158"},"to":{"field":"region","value":"tw"}},{"from":{"field":"region","value":"834"},"to":{"field":"region","value":"tz"}},{"from":{"field":"region","value":"804"},"to":{"field":"region","value":"ua"}},{"from":{"field":"region","value":"800"},"to":{"field":"region","value":"ug"}},{"from":{"field":"region","value":"581"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"840"},"to":{"field":"region","value":"us"}},{"from":{"field":"region","value":"858"},"to":{"field":"region","value":"uy"}},{"from":{"field":"region","value":"860"},"to":{"field":"region","value":"uz"}},{"from":{"field":"region","value":"336"},"to":{"field":"region","value":"va"}},{"from":{"field":"region","value":"670"},"to":{"field":"region","value":"vc"}},{"from":{"field":"region","value":"862"},"to":{"field":"region","value":"ve"}},{"from":{"field":"region","value":"092"},"to":{"field":"region","value":"vg"}},{"from":{"field":"region","value":"850"},"to":{"field":"region","value":"vi"}},{"from":{"field":"region","value":"704"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"548"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"876"},"to":{"field":"region","value":"wf"}},{"from":{"field":"region","value":"882"},"to":{"field":"region","value":"ws"}},{"from":{"field":"region","value":"973"},"to":{"field":"region","value":"xa"}},{"from":{"field":"region","value":"974"},"to":{"field":"region","value":"xb"}},{"from":{"field":"region","value":"975"},"to":{"field":"region","value":"xc"}},{"from":{"field":"region","value":"976"},"to":{"field":"region","value":"xd"}},{"from":{"field":"region","value":"977"},"to":{"field":"region","value":"xe"}},{"from":{"field":"region","value":"978"},"to":{"field":"region","value":"xf"}},{"from":{"field":"region","value":"979"},"to":{"field":"region","value":"xg"}},{"from":{"field":"region","value":"980"},"to":{"field":"region","value":"xh"}},{"from":{"field":"region","value":"981"},"to":{"field":"region","value":"xi"}},{"from":{"field":"region","value":"982"},"to":{"field":"region","value":"xj"}},{"from":{"field":"region","value":"983"},"to":{"field":"region","value":"xk"}},{"from":{"field":"region","value":"984"},"to":{"field":"region","value":"xl"}},{"from":{"field":"region","value":"985"},"to":{"field":"region","value":"xm"}},{"from":{"field":"region","value":"986"},"to":{"field":"region","value":"xn"}},{"from":{"field":"region","value":"987"},"to":{"field":"region","value":"xo"}},{"from":{"field":"region","value":"988"},"to":{"field":"region","value":"xp"}},{"from":{"field":"region","value":"989"},"to":{"field":"region","value":"xq"}},{"from":{"field":"region","value":"990"},"to":{"field":"region","value":"xr"}},{"from":{"field":"region","value":"991"},"to":{"field":"region","value":"xs"}},{"from":{"field":"region","value":"992"},"to":{"field":"region","value":"xt"}},{"from":{"field":"region","value":"993"},"to":{"field":"region","value":"xu"}},{"from":{"field":"region","value":"994"},"to":{"field":"region","value":"xv"}},{"from":{"field":"region","value":"995"},"to":{"field":"region","value":"xw"}},{"from":{"field":"region","value":"996"},"to":{"field":"region","value":"xx"}},{"from":{"field":"region","value":"997"},"to":{"field":"region","value":"xy"}},{"from":{"field":"region","value":"998"},"to":{"field":"region","value":"xz"}},{"from":{"field":"region","value":"720"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"887"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"175"},"to":{"field":"region","value":"yt"}},{"from":{"field":"region","value":"710"},"to":{"field":"region","value":"za"}},{"from":{"field":"region","value":"894"},"to":{"field":"region","value":"zm"}},{"from":{"field":"region","value":"716"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"999"},"to":{"field":"region","value":"zz"}},{"from":{"field":"variants","value":"aaland"},"to":{"field":"region","value":"ax"}},{"from":{"field":"variants","value":"polytoni"},"to":{"field":"variants","value":"polyton"}},{"from":{"field":"variants","value":"heploc"},"to":{"field":"variants","value":"alalc97"}},{"from":{"field":"variants","value":"arevela"},"to":{"field":"language","value":"hy"}},{"from":{"field":"variants","value":"arevmda"},"to":{"field":"language","value":"hyw"}}]');
        }, 9460: function(Se) {
          Se.exports = JSON.parse('{"region":{"172":["ru","am","az","by","ge","kg","kz","md","tj","tm","ua","uz"],"200":["cz","sk"],"530":["cw","sx","bq"],"532":["cw","sx","bq"],"536":["sa","iq"],"582":["fm","mh","mp","pw"],"810":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"830":["je","gg"],"890":["rs","me","si","hr","mk","ba"],"891":["rs","me"],"an":["cw","sx","bq"],"cs":["rs","me"],"fq":["aq","tf"],"nt":["sa","iq"],"pc":["fm","mh","mp","pw"],"su":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yu":["rs","me"],"062":["034","143"],"ant":["cw","sx","bq"],"scg":["rs","me"],"ntz":["sa","iq"],"sun":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yug":["rs","me"]}}');
        }, 7778: function(Se) {
          Se.exports = JSON.parse('[{"from":"in","to":"id"},{"from":"iw","to":"he"},{"from":"ji","to":"yi"},{"from":"jw","to":"jv"},{"from":"mo","to":"ro"},{"from":"scc","to":"sr"},{"from":"scr","to":"hr"},{"from":"aam","to":"aas"},{"from":"adp","to":"dz"},{"from":"aue","to":"ktz"},{"from":"ayx","to":"nun"},{"from":"bgm","to":"bcg"},{"from":"bjd","to":"drl"},{"from":"ccq","to":"rki"},{"from":"cjr","to":"mom"},{"from":"cka","to":"cmr"},{"from":"cmk","to":"xch"},{"from":"coy","to":"pij"},{"from":"cqu","to":"quh"},{"from":"drh","to":"mn"},{"from":"drw","to":"fa-af"},{"from":"gav","to":"dev"},{"from":"gfx","to":"vaj"},{"from":"ggn","to":"gvr"},{"from":"gti","to":"nyc"},{"from":"guv","to":"duz"},{"from":"hrr","to":"jal"},{"from":"ibi","to":"opa"},{"from":"ilw","to":"gal"},{"from":"jeg","to":"oyb"},{"from":"kgc","to":"tdf"},{"from":"kgh","to":"kml"},{"from":"koj","to":"kwv"},{"from":"krm","to":"bmf"},{"from":"ktr","to":"dtp"},{"from":"kvs","to":"gdj"},{"from":"kwq","to":"yam"},{"from":"kxe","to":"tvd"},{"from":"kzj","to":"dtp"},{"from":"kzt","to":"dtp"},{"from":"lii","to":"raq"},{"from":"lmm","to":"rmx"},{"from":"meg","to":"cir"},{"from":"mst","to":"mry"},{"from":"mwj","to":"vaj"},{"from":"myt","to":"mry"},{"from":"nad","to":"xny"},{"from":"ncp","to":"kdz"},{"from":"nnx","to":"ngv"},{"from":"nts","to":"pij"},{"from":"oun","to":"vaj"},{"from":"pcr","to":"adx"},{"from":"pmc","to":"huw"},{"from":"pmu","to":"phr"},{"from":"ppa","to":"bfy"},{"from":"ppr","to":"lcq"},{"from":"pry","to":"prt"},{"from":"puz","to":"pub"},{"from":"sca","to":"hle"},{"from":"skk","to":"oyb"},{"from":"tdu","to":"dtp"},{"from":"thc","to":"tpo"},{"from":"thx","to":"oyb"},{"from":"tie","to":"ras"},{"from":"tkk","to":"twm"},{"from":"tlw","to":"weo"},{"from":"tmp","to":"tyj"},{"from":"tne","to":"kak"},{"from":"tnf","to":"fa-af"},{"from":"tsf","to":"taj"},{"from":"uok","to":"ema"},{"from":"xba","to":"cax"},{"from":"xia","to":"acn"},{"from":"xkh","to":"waw"},{"from":"xsj","to":"suj"},{"from":"ybd","to":"rki"},{"from":"yma","to":"lrr"},{"from":"ymt","to":"mtm"},{"from":"yos","to":"zom"},{"from":"yuu","to":"yug"},{"from":"asd","to":"snz"},{"from":"dit","to":"dif"},{"from":"llo","to":"ngt"},{"from":"myd","to":"aog"},{"from":"nns","to":"nbr"},{"from":"sgn-br","to":"bzs"},{"from":"sgn-co","to":"csn"},{"from":"sgn-de","to":"gsg"},{"from":"sgn-dk","to":"dsl"},{"from":"sgn-fr","to":"fsl"},{"from":"sgn-gb","to":"bfi"},{"from":"sgn-gr","to":"gss"},{"from":"sgn-ie","to":"isg"},{"from":"sgn-it","to":"ise"},{"from":"sgn-jp","to":"jsl"},{"from":"sgn-mx","to":"mfs"},{"from":"sgn-ni","to":"ncs"},{"from":"sgn-nl","to":"dse"},{"from":"sgn-no","to":"nsi"},{"from":"sgn-pt","to":"psr"},{"from":"sgn-se","to":"swl"},{"from":"sgn-us","to":"ase"},{"from":"sgn-za","to":"sfs"},{"from":"no-bokmal","to":"nb"},{"from":"no-nynorsk","to":"nn"},{"from":"aa-saaho","to":"ssy"},{"from":"sh","to":"sr-latn"},{"from":"cnr","to":"sr-me"},{"from":"no","to":"nb"},{"from":"tl","to":"fil"},{"from":"az-az","to":"az-latn-az"},{"from":"bs-ba","to":"bs-latn-ba"},{"from":"ha-latn-gh","to":"ha-gh"},{"from":"ha-latn-ne","to":"ha-ne"},{"from":"ha-latn-ng","to":"ha-ng"},{"from":"kk-cyrl-kz","to":"kk-kz"},{"from":"ky-cyrl-kg","to":"ky-kg"},{"from":"ks-arab-in","to":"ks-in"},{"from":"mn-cyrl-mn","to":"mn-mn"},{"from":"ms-latn-bn","to":"ms-bn"},{"from":"ms-latn-my","to":"ms-my"},{"from":"ms-latn-sg","to":"ms-sg"},{"from":"pa-in","to":"pa-guru-in"},{"from":"pa-pk","to":"pa-arab-pk"},{"from":"shi-ma","to":"shi-tfng-ma"},{"from":"sr-ba","to":"sr-cyrl-ba"},{"from":"sr-me","to":"sr-latn-me"},{"from":"sr-rs","to":"sr-cyrl-rs"},{"from":"sr-xk","to":"sr-cyrl-xk"},{"from":"tzm-latn-ma","to":"tzm-ma"},{"from":"ug-arab-cn","to":"ug-cn"},{"from":"uz-af","to":"uz-arab-af"},{"from":"uz-uz","to":"uz-latn-uz"},{"from":"vai-lr","to":"vai-vaii-lr"},{"from":"yue-cn","to":"yue-hans-cn"},{"from":"yue-hk","to":"yue-hant-hk"},{"from":"zh-cn","to":"zh-hans-cn"},{"from":"zh-hk","to":"zh-hant-hk"},{"from":"zh-mo","to":"zh-hant-mo"},{"from":"zh-sg","to":"zh-hans-sg"},{"from":"zh-tw","to":"zh-hant-tw"},{"from":"aju","to":"jrb"},{"from":"als","to":"sq"},{"from":"arb","to":"ar"},{"from":"ayr","to":"ay"},{"from":"azj","to":"az"},{"from":"bcc","to":"bal"},{"from":"bcl","to":"bik"},{"from":"bxk","to":"luy"},{"from":"bxr","to":"bua"},{"from":"cld","to":"syr"},{"from":"cmn","to":"zh"},{"from":"cwd","to":"cr"},{"from":"dgo","to":"doi"},{"from":"dhd","to":"mwr"},{"from":"dik","to":"din"},{"from":"diq","to":"zza"},{"from":"lbk","to":"bnc"},{"from":"ekk","to":"et"},{"from":"emk","to":"man"},{"from":"esk","to":"ik"},{"from":"fat","to":"ak"},{"from":"fuc","to":"ff"},{"from":"gaz","to":"om"},{"from":"gbo","to":"grb"},{"from":"gno","to":"gon"},{"from":"gug","to":"gn"},{"from":"gya","to":"gba"},{"from":"hdn","to":"hai"},{"from":"hea","to":"hmn"},{"from":"ike","to":"iu"},{"from":"kmr","to":"ku"},{"from":"knc","to":"kr"},{"from":"kng","to":"kg"},{"from":"knn","to":"kok"},{"from":"kpv","to":"kv"},{"from":"lvs","to":"lv"},{"from":"mhr","to":"chm"},{"from":"mup","to":"raj"},{"from":"khk","to":"mn"},{"from":"npi","to":"ne"},{"from":"ojg","to":"oj"},{"from":"ory","to":"or"},{"from":"pbu","to":"ps"},{"from":"pes","to":"fa"},{"from":"plt","to":"mg"},{"from":"pnb","to":"lah"},{"from":"quz","to":"qu"},{"from":"rmy","to":"rom"},{"from":"spy","to":"kln"},{"from":"src","to":"sc"},{"from":"swh","to":"sw"},{"from":"ttq","to":"tmh"},{"from":"tw","to":"ak"},{"from":"umu","to":"del"},{"from":"uzn","to":"uz"},{"from":"xpe","to":"kpe"},{"from":"xsl","to":"den"},{"from":"ydd","to":"yi"},{"from":"zai","to":"zap"},{"from":"zsm","to":"ms"},{"from":"zyb","to":"za"},{"from":"him","to":"srx"},{"from":"mnk","to":"man"},{"from":"bh","to":"bho"},{"from":"prs","to":"fa-af"},{"from":"swc","to":"sw-cd"},{"from":"aar","to":"aa"},{"from":"abk","to":"ab"},{"from":"ave","to":"ae"},{"from":"afr","to":"af"},{"from":"aka","to":"ak"},{"from":"amh","to":"am"},{"from":"arg","to":"an"},{"from":"ara","to":"ar"},{"from":"asm","to":"as"},{"from":"ava","to":"av"},{"from":"aym","to":"ay"},{"from":"aze","to":"az"},{"from":"bak","to":"ba"},{"from":"bel","to":"be"},{"from":"bul","to":"bg"},{"from":"bih","to":"bho"},{"from":"bis","to":"bi"},{"from":"bam","to":"bm"},{"from":"ben","to":"bn"},{"from":"bod","to":"bo"},{"from":"bre","to":"br"},{"from":"bos","to":"bs"},{"from":"cat","to":"ca"},{"from":"che","to":"ce"},{"from":"cha","to":"ch"},{"from":"cos","to":"co"},{"from":"cre","to":"cr"},{"from":"ces","to":"cs"},{"from":"chu","to":"cu"},{"from":"chv","to":"cv"},{"from":"cym","to":"cy"},{"from":"dan","to":"da"},{"from":"deu","to":"de"},{"from":"div","to":"dv"},{"from":"dzo","to":"dz"},{"from":"ewe","to":"ee"},{"from":"ell","to":"el"},{"from":"eng","to":"en"},{"from":"epo","to":"eo"},{"from":"spa","to":"es"},{"from":"est","to":"et"},{"from":"eus","to":"eu"},{"from":"fas","to":"fa"},{"from":"ful","to":"ff"},{"from":"fin","to":"fi"},{"from":"fij","to":"fj"},{"from":"fao","to":"fo"},{"from":"fra","to":"fr"},{"from":"fry","to":"fy"},{"from":"gle","to":"ga"},{"from":"gla","to":"gd"},{"from":"glg","to":"gl"},{"from":"grn","to":"gn"},{"from":"guj","to":"gu"},{"from":"glv","to":"gv"},{"from":"hau","to":"ha"},{"from":"heb","to":"he"},{"from":"hin","to":"hi"},{"from":"hmo","to":"ho"},{"from":"hrv","to":"hr"},{"from":"hat","to":"ht"},{"from":"hun","to":"hu"},{"from":"hye","to":"hy"},{"from":"her","to":"hz"},{"from":"ina","to":"ia"},{"from":"ind","to":"id"},{"from":"ile","to":"ie"},{"from":"ibo","to":"ig"},{"from":"iii","to":"ii"},{"from":"ipk","to":"ik"},{"from":"ido","to":"io"},{"from":"isl","to":"is"},{"from":"ita","to":"it"},{"from":"iku","to":"iu"},{"from":"jpn","to":"ja"},{"from":"jav","to":"jv"},{"from":"kat","to":"ka"},{"from":"kon","to":"kg"},{"from":"kik","to":"ki"},{"from":"kua","to":"kj"},{"from":"kaz","to":"kk"},{"from":"kal","to":"kl"},{"from":"khm","to":"km"},{"from":"kan","to":"kn"},{"from":"kor","to":"ko"},{"from":"kau","to":"kr"},{"from":"kas","to":"ks"},{"from":"kur","to":"ku"},{"from":"kom","to":"kv"},{"from":"cor","to":"kw"},{"from":"kir","to":"ky"},{"from":"lat","to":"la"},{"from":"ltz","to":"lb"},{"from":"lug","to":"lg"},{"from":"lim","to":"li"},{"from":"lin","to":"ln"},{"from":"lao","to":"lo"},{"from":"lit","to":"lt"},{"from":"lub","to":"lu"},{"from":"lav","to":"lv"},{"from":"mlg","to":"mg"},{"from":"mah","to":"mh"},{"from":"mri","to":"mi"},{"from":"mkd","to":"mk"},{"from":"mal","to":"ml"},{"from":"mon","to":"mn"},{"from":"mol","to":"ro"},{"from":"mar","to":"mr"},{"from":"msa","to":"ms"},{"from":"mlt","to":"mt"},{"from":"mya","to":"my"},{"from":"nau","to":"na"},{"from":"nob","to":"nb"},{"from":"nde","to":"nd"},{"from":"nep","to":"ne"},{"from":"ndo","to":"ng"},{"from":"nld","to":"nl"},{"from":"nno","to":"nn"},{"from":"nor","to":"nb"},{"from":"nbl","to":"nr"},{"from":"nav","to":"nv"},{"from":"nya","to":"ny"},{"from":"oci","to":"oc"},{"from":"oji","to":"oj"},{"from":"orm","to":"om"},{"from":"ori","to":"or"},{"from":"oss","to":"os"},{"from":"pan","to":"pa"},{"from":"pli","to":"pi"},{"from":"pol","to":"pl"},{"from":"pus","to":"ps"},{"from":"por","to":"pt"},{"from":"que","to":"qu"},{"from":"roh","to":"rm"},{"from":"run","to":"rn"},{"from":"ron","to":"ro"},{"from":"rus","to":"ru"},{"from":"kin","to":"rw"},{"from":"san","to":"sa"},{"from":"srd","to":"sc"},{"from":"snd","to":"sd"},{"from":"sme","to":"se"},{"from":"sag","to":"sg"},{"from":"hbs","to":"sr-latn"},{"from":"sin","to":"si"},{"from":"slk","to":"sk"},{"from":"slv","to":"sl"},{"from":"smo","to":"sm"},{"from":"sna","to":"sn"},{"from":"som","to":"so"},{"from":"sqi","to":"sq"},{"from":"srp","to":"sr"},{"from":"ssw","to":"ss"},{"from":"sot","to":"st"},{"from":"sun","to":"su"},{"from":"swe","to":"sv"},{"from":"swa","to":"sw"},{"from":"tam","to":"ta"},{"from":"tel","to":"te"},{"from":"tgk","to":"tg"},{"from":"tha","to":"th"},{"from":"tir","to":"ti"},{"from":"tuk","to":"tk"},{"from":"tgl","to":"fil"},{"from":"tsn","to":"tn"},{"from":"ton","to":"to"},{"from":"tur","to":"tr"},{"from":"tso","to":"ts"},{"from":"tat","to":"tt"},{"from":"twi","to":"ak"},{"from":"tah","to":"ty"},{"from":"uig","to":"ug"},{"from":"ukr","to":"uk"},{"from":"urd","to":"ur"},{"from":"uzb","to":"uz"},{"from":"ven","to":"ve"},{"from":"vie","to":"vi"},{"from":"vol","to":"vo"},{"from":"wln","to":"wa"},{"from":"wol","to":"wo"},{"from":"xho","to":"xh"},{"from":"yid","to":"yi"},{"from":"yor","to":"yo"},{"from":"zha","to":"za"},{"from":"zho","to":"zh"},{"from":"zul","to":"zu"},{"from":"alb","to":"sq"},{"from":"arm","to":"hy"},{"from":"baq","to":"eu"},{"from":"bur","to":"my"},{"from":"chi","to":"zh"},{"from":"cze","to":"cs"},{"from":"dut","to":"nl"},{"from":"fre","to":"fr"},{"from":"geo","to":"ka"},{"from":"ger","to":"de"},{"from":"gre","to":"el"},{"from":"ice","to":"is"},{"from":"mac","to":"mk"},{"from":"mao","to":"mi"},{"from":"may","to":"ms"},{"from":"per","to":"fa"},{"from":"rum","to":"ro"},{"from":"slo","to":"sk"},{"from":"tib","to":"bo"},{"from":"wel","to":"cy"}]');
        }, 8589: function(Se) {
          Se.exports = JSON.parse('{"en-gb-oed":"en-GB-oxendict","i-ami":"ami","i-bnn":"bnn","i-default":null,"i-enochian":null,"i-hak":"hak","i-klingon":"tlh","i-lux":"lb","i-mingo":null,"i-navajo":"nv","i-pwn":"pwn","i-tao":"tao","i-tay":"tay","i-tsu":"tsu","sgn-be-fr":"sfb","sgn-be-nl":"vgt","sgn-ch-de":"sgg","art-lojban":"jbo","cel-gaulish":null,"no-bok":"nb","no-nyn":"nn","zh-guoyu":"cmn","zh-hakka":"hak","zh-min":null,"zh-min-nan":"nan","zh-xiang":"hsn"}');
        }, 858: function(Se) {
          Se.exports = JSON.parse('["art-lojban","cel-gaulish","no-bok","no-nyn","zh-guoyu","zh-hakka","zh-min","zh-min-nan","zh-xiang"]');
        } }, ye = {};
        function Ce(Se) {
          var ge = ye[Se];
          if (ge !== void 0) return ge.exports;
          var R = ye[Se] = { exports: {} };
          return ie[Se].call(R.exports, R, R.exports, Ce), R.exports;
        }
        Ce.amdO = {}, Ce.n = function(Se) {
          var ge = Se && Se.__esModule ? function() {
            return Se.default;
          } : function() {
            return Se;
          };
          return Ce.d(ge, { a: ge }), ge;
        }, Ce.d = function(Se, ge) {
          for (var R in ge) Ce.o(ge, R) && !Ce.o(Se, R) && Object.defineProperty(Se, R, { enumerable: !0, get: ge[R] });
        }, Ce.g = function() {
          if (typeof globalThis == "object") return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object") return window;
          }
        }(), Ce.o = function(Se, ge) {
          return Object.prototype.hasOwnProperty.call(Se, ge);
        };
        var st = {};
        return function() {
          Ce.d(st, { default: function() {
            return p;
          } }), Ce(8416);
          var Se, ge = Ce(1715), R = Ce(8080), te = Ce(1737), E = Ce(1139), t = /* @__PURE__ */ function() {
            var l, v = "application/dash+xml";
            function h(f, d, S) {
              if (!f || !/^VIDEO$/i.test(f.nodeName)) return null;
              if (f._dashjs_player) return f._dashjs_player;
              var x, G = f.id || f.name || "video element";
              if (!(d = d || [].slice.call(f.querySelectorAll("source")).filter(function(P) {
                return P.type == v;
              })[0]) && f.src) (d = document.createElement("source")).src = f.src;
              else if (!d && !f.src) return null;
              return S = S || {}, (x = (0, E.Z)(S).create()).initialize(f, d.src, f.autoplay), l || (l = x.getDebug().getLogger()), l.debug("Converted " + G + " to dash.js player and added content: " + d.src), f._dashjs_player = x, x;
            }
            function n(f) {
              return /^VIDEO$/i.test(f.nodeName) ? f : n(f.parentNode);
            }
            return { create: h, createAll: function(f, d) {
              var S = [];
              f = f || "[data-dashjs-player]";
              for (var x = (d = d || document).querySelectorAll(f), G = 0; G < x.length; G++) {
                var P = h(x[G], null);
                S.push(P);
              }
              for (var J = d.querySelectorAll('source[type="' + v + '"]'), M = 0; M < J.length; M++) {
                var W = h(n(J[M]), null);
                S.push(W);
              }
              return S;
            } };
          }();
          !(typeof window < "u" && window && window.dashjs && window.dashjs.skipAutoCreate) && typeof window < "u" && window && window.addEventListener && (window.document.readyState === "complete" ? window.dashjs ? t.createAll() : Se = window.setInterval(function() {
            window.dashjs && (window.clearInterval(Se), t.createAll());
          }, 500) : window.addEventListener("load", function l() {
            window.removeEventListener("load", l), t.createAll();
          }));
          var e = t, m = Ce(6398);
          dashjs.Protection = te.default, dashjs.MetricsReporting = R.default, dashjs.MediaPlayerFactory = e, dashjs.Debug = m.Z, dashjs.supportsMediaSource = ge.B;
          var p = dashjs;
        }(), st.default;
      }();
    });
  }(ho)), ho.exports;
}
var uf = lf();
const cf = (B, V, ie) => {
  const ye = B[V];
  return ye ? typeof ye == "function" ? ye() : Promise.resolve(ye) : new Promise((Ce, st) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      st.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + V + (V.split("/").length !== ie ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
Pc.use(Lc).use(
  xc(
    (B) => cf(/* @__PURE__ */ Object.assign({ "./locales/ar.json": () => import("./ar-Z9acuZzl.js"), "./locales/ca.json": () => import("./ca-DlR1wIBB.js"), "./locales/cy.json": () => import("./cy-Bfp7KxBK.js"), "./locales/da-x-k12.json": () => import("./da-x-k12-By8rNInq.js"), "./locales/da.json": () => import("./da-qrZgDst-.js"), "./locales/de.json": () => import("./de-knn0V76L.js"), "./locales/en-AU-x-unimelb.json": () => import("./en-AU-x-unimelb-ByeXpRSQ.js"), "./locales/en-GB-x-ukhe.json": () => import("./en-GB-x-ukhe-xHRAKkin.js"), "./locales/en.json": () => import("./en-BgIIckEu.js"), "./locales/en_AU.json": () => import("./en_AU-DyOGFAXY.js"), "./locales/en_CY.json": () => import("./en_CY-BOdUgRsC.js"), "./locales/en_GB.json": () => import("./en_GB-BgDkmLv4.js"), "./locales/es.json": () => import("./es-CBqAZZdR.js"), "./locales/es_ES.json": () => import("./es_ES-DLfG4pu4.js"), "./locales/fi.json": () => import("./fi-Dq0xAMjn.js"), "./locales/fr.json": () => import("./fr-CvtcW3Dj.js"), "./locales/fr_CA.json": () => import("./fr_CA-ZpBdXMbh.js"), "./locales/ga.json": () => import("./ga-83Dv-X5Z.js"), "./locales/hi.json": () => import("./hi-xRyetvo6.js"), "./locales/ht.json": () => import("./ht-DA2-RKUH.js"), "./locales/id.json": () => import("./id-CEs1cZOo.js"), "./locales/is.json": () => import("./is-BbinArrV.js"), "./locales/it.json": () => import("./it-HslrRsSS.js"), "./locales/ja.json": () => import("./ja-D89KNqN9.js"), "./locales/kl.json": () => import("./kl-CBFEKDWH.js"), "./locales/mi.json": () => import("./mi-aU_9ve5X.js"), "./locales/ms.json": () => import("./ms-bWAzRpaY.js"), "./locales/nb-x-k12.json": () => import("./nb-x-k12-B-_bQnAo.js"), "./locales/nb.json": () => import("./nb-M_VkURkp.js"), "./locales/nl.json": () => import("./nl-DHdAiTnV.js"), "./locales/pl.json": () => import("./pl-1Qw2eZF3.js"), "./locales/pt.json": () => import("./pt-Ck4sSJ6k.js"), "./locales/pt_BR.json": () => import("./pt_BR-Cx97cXwr.js"), "./locales/ru.json": () => import("./ru-C-htuaP4.js"), "./locales/sl.json": () => import("./sl-CQCpGyzi.js"), "./locales/sv-x-k12.json": () => import("./sv-x-k12-pMVzTct2.js"), "./locales/sv.json": () => import("./sv-e5AFl9Ar.js"), "./locales/th.json": () => import("./th-D_TJAjfw.js"), "./locales/vi.json": () => import("./vi-Cm6S7qCi.js"), "./locales/zh-Hans.json": () => import("./zh-Hans-Bh10_Au7.js"), "./locales/zh-Hant.json": () => import("./zh-Hant-DvNKec8H.js"), "./locales/zh.json": () => import("./zh-DaDuLWt4.js"), "./locales/zh_HK.json": () => import("./zh_HK-CwSDZpFm.js") }), `./locales/${B}.json`, 3)
  )
).init({
  fallbackLng: "en",
  partialBundledLanguages: !0,
  ns: [],
  resources: {},
  interpolation: {
    escapeValue: !1
  }
});
const fl = Ea(null);
function ff({
  children: B,
  contextValue: V
}) {
  return /* @__PURE__ */ he(fl.Provider, { value: V, children: B });
}
function Sr() {
  const B = va(fl);
  if (!B)
    throw new Error(
      "useStudioPlayerContext must be used within a StudioPlayerContextProvider"
    );
  return B;
}
const lr = (B) => {
  const V = Sr();
  return ya(V[B]);
}, mo = window.matchMedia("(hover: none)"), po = window.matchMedia("(max-width: 720px)"), df = (B) => (mo.addEventListener("change", B), po.addEventListener("change", B), () => {
  mo.removeEventListener("change", B), po.removeEventListener("change", B);
}), dl = () => mo.matches, gf = () => po.matches, hf = () => dl() || gf(), bo = () => ol(df, hf), gl = Ea(null);
function mf(B, V, ie) {
  return B != null ? !1 : V && !ie;
}
function pf({
  title: B,
  hideFullScreen: V,
  comments: ie,
  captions: ye,
  thumbnail: Ce,
  annotations: st,
  quizMarkers: Se,
  interactive: ge,
  onAnnotationClick: R,
  onQuizMarkerClick: te,
  onInteractivePinClick: E,
  interactiveMenuElements: t,
  kebabMenuElements: e,
  darkMode: m,
  children: p,
  forceComments: l,
  disableCaptionSettings: v,
  disableStorage: h,
  captionOffsetOverride: n,
  disableInteractivePinRanges: f,
  onQuizMarkerShow: d,
  onCaptionsDelete: S,
  controlsLayout: x,
  startAt: G,
  hideQuizMarkers: P,
  enableSidebar: J,
  lockSpeed: M,
  tabs: W,
  openSidebar: se,
  emptyTranscriptsComponent: j,
  rollingTranscriptElement: re,
  transcriptMenuElements: ce
}) {
  const Re = bo(), $ = {
    title: B,
    hideFullScreen: V,
    comments: ie,
    captions: ye,
    thumbnail: Ce,
    annotations: st,
    quizMarkers: Se,
    interactive: ge,
    onAnnotationClick: R,
    onQuizMarkerClick: te,
    onInteractivePinClick: E,
    interactiveMenuElements: t,
    kebabMenuElements: e,
    darkMode: m,
    hasComments: ie.length > 0,
    hasAnnotations: st.length > 0,
    hasQuizmarkers: Se.length > 0,
    forceComments: l,
    disableCaptionSettings: v,
    disableStorage: h,
    captionOffsetOverride: n,
    disableInteractivePinRanges: f,
    onQuizMarkerShow: d,
    onCaptionsDelete: S,
    controlsLayout: x,
    startAt: G,
    hideQuizMarkers: P,
    enableSidebar: mf(
      re,
      J,
      Re
    ),
    lockSpeed: M,
    tabs: W,
    openSidebar: se,
    emptyTranscriptsComponent: j,
    rollingTranscriptElement: re,
    transcriptMenuElements: ce
  };
  return /* @__PURE__ */ he(gl.Provider, { value: $, children: p });
}
function Xn() {
  const B = va(gl);
  if (!B)
    throw new Error(
      "useStudioPlayerPropsContext must be used within a StudioPlayerPropsContextProvider"
    );
  return B;
}
const yf = "_annotation-overlay_1kxzn_1", _f = {
  "annotation-overlay": "_annotation-overlay_1kxzn_1",
  annotationOverlay: yf
}, Qs = 0.25, Ef = (B, V) => {
  let ie = !1;
  return (ye) => {
    const Ce = ye.detail.currentTime;
    Ce >= B.time && Ce < B.time + Qs && !ie && (ie = !0, V(B)), (Ce < B.time || Ce >= B.time + Qs) && ie && (ie = !1);
  };
};
function vf({ annotations: B }) {
  const V = Dr(), ie = Sr(), ye = Xn(), [Ce, st] = ar(
    null
  ), Se = Un(
    (R) => {
      V == null || V.pause(), st(R), ie.interactionsDisabled.set(!0);
    },
    [V, ie]
  ), ge = () => {
    st(null), ie.interactionsDisabled.set(!1);
    let R;
    ye.interactive ? R = () => {
      const te = document.querySelector(
        "[data-interactive-pin]"
      );
      te == null || te.focus();
    } : (V == null || V.play(), R = () => {
      const te = document.querySelector(
        "[data-play-pause-button]"
      );
      te == null || te.focus();
    }), requestAnimationFrame(R);
  };
  return Zr(() => {
    if (!V)
      return;
    const R = new AbortController();
    return requestAnimationFrame(() => {
      for (const te of B) {
        const E = Ef(te, Se);
        V.addEventListener("time-update", E, {
          signal: R.signal
        });
      }
      if (Ce) {
        const te = B.find(
          (E) => E.id === Ce.id
        );
        te ? st(te) : (st(null), ie.interactionsDisabled.set(!1));
      }
    }), () => R.abort();
  }, [V, B]), Ce ? /* @__PURE__ */ he("div", { className: _f.annotationOverlay, children: Ce.render(ge) }) : null;
}
const Tf = "_media-buffering-indicator_1fwjr_1", bf = "_media-buffering-spinner_1fwjr_17", Sf = "_media-buffering-spin_1fwjr_17", Af = "_media-buffering-track_1fwjr_22", If = "_media-buffering-track-fill_1fwjr_27", ca = {
  "media-buffering-indicator": "_media-buffering-indicator_1fwjr_1",
  mediaBufferingIndicator: Tf,
  "media-buffering-spinner": "_media-buffering-spinner_1fwjr_17",
  mediaBufferingSpinner: bf,
  "media-buffering-spin": "_media-buffering-spin_1fwjr_17",
  mediaBufferingSpin: Sf,
  "media-buffering-track": "_media-buffering-track_1fwjr_22",
  mediaBufferingTrack: Af,
  "media-buffering-track-fill": "_media-buffering-track-fill_1fwjr_27",
  mediaBufferingTrackFill: If
};
function hl() {
  return /* @__PURE__ */ he("div", { className: ca.mediaBufferingIndicator, children: /* @__PURE__ */ rn(Fc, { className: ca.mediaBufferingSpinner, size: 96, children: [
    /* @__PURE__ */ he(kc, { className: ca.mediaBufferingTrack, width: 8 }),
    /* @__PURE__ */ he(
      Zc,
      {
        className: ca.mediaBufferingTrackFill,
        width: 8
      }
    )
  ] }) });
}
const wf = "_controls-overlay_15073_1", Rf = "_keyboard-shortcuts-overlay_15073_12", Cf = "_screen-reader-content_15073_77", Nf = "_keyboard-shortcuts-button_15073_91", Df = "_kebab-menu-button_15073_101", Of = "_kebab-menu_15073_101", Mf = "_kebab-menu-item_15073_154", Lf = "_close-button_15073_212", Pf = "_arrow_15073_226", Wr = {
  "controls-overlay": "_controls-overlay_15073_1",
  controlsOverlay: wf,
  "keyboard-shortcuts-overlay": "_keyboard-shortcuts-overlay_15073_12",
  keyboardShortcutsOverlay: Rf,
  "screen-reader-content": "_screen-reader-content_15073_77",
  screenReaderContent: Cf,
  "keyboard-shortcuts-button": "_keyboard-shortcuts-button_15073_91",
  keyboardShortcutsButton: Nf,
  "kebab-menu-button": "_kebab-menu-button_15073_101",
  kebabMenuButton: Df,
  "kebab-menu": "_kebab-menu_15073_101",
  kebabMenu: Of,
  "kebab-menu-item": "_kebab-menu-item_15073_154",
  kebabMenuItem: Mf,
  "close-button": "_close-button_15073_212",
  closeButton: Lf,
  arrow: Pf
}, ml = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.8 3.6C9.79288 3.6 10.6 2.79288 10.6 1.8C10.6 0.80712 9.79288 0 8.8 0C7.80712 0 7 0.80712 7 1.8C7 2.79288 7.80712 3.6 8.8 3.6ZM10.6 8.99999C10.6 9.99287 9.79288 10.8 8.8 10.8C7.80712 10.8 7 9.99287 7 8.99999C7 8.00711 7.80712 7.19999 8.8 7.19999C9.79288 7.19999 10.6 8.00711 10.6 8.99999ZM10.6 16.2C10.6 17.1929 9.79288 18 8.8 18C7.80712 18 7 17.1929 7 16.2C7 15.2071 7.80712 14.4 8.8 14.4C9.79288 14.4 10.6 15.2071 10.6 16.2Z", fill: "currentColor" }) });
function So(B) {
  return typeof B != "string";
}
function xf(B) {
  return B.filter((V) => V.showInOverlay).sort((V, ie) => (V.order ?? 1) - (ie.order ?? 1));
}
function Ff(B, V, ie) {
  const ye = [];
  return dl() || ye.push({
    id: "keyboard-shortcuts",
    text: ie.label,
    icon: "shortcuts",
    onClick: ie.onClick,
    order: 1
  }), ye.concat(B).filter((Ce) => !V || !Ce.showInOverlay).sort((Ce, st) => (Ce.order ?? 1) - (st.order ?? 1));
}
const pl = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8234 16.4118C14.8234 16.7029 14.5852 16.9412 14.294 16.9412H3.70577C3.41459 16.9412 3.17636 16.7029 3.17636 16.4118V5.29412H2.11753V16.4118C2.11753 17.2874 2.83012 18 3.70577 18H14.294C15.1697 18 15.8822 17.2874 15.8822 16.4118V5.29412H14.8234V16.4118ZM6.35284 14.8235H7.41166V6.35294H6.35284V14.8235ZM10.5881 14.8235H11.6469V6.35294H10.5881V14.8235ZM12.5682 3.17647L11.4099 0H6.51176L5.35553 3.17647H0V4.23529H18V3.17647H12.5682ZM6.48105 3.17647L7.25293 1.05882H10.6698L11.4416 3.17647H6.48105Z", fill: "currentColor" }) }), kf = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.30365 10.9535V0H9.3637V10.9535L12.6986 7.61855L13.4491 8.368L8.83261 12.9824L4.21823 8.368L4.96875 7.61855L8.30365 10.9535ZM3.77376 16.94H13.9354L16.9607 13.9146L17.7091 14.6651L14.3742 18H3.3349L0 14.6651L0.749452 13.9146L3.77376 16.94Z", fill: "currentColor" }) }), Zf = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "m 13.7213,13.5 -0.63,-0.62022 3.2905,-3.43952 h -6.126 V 8.53855 h 6.126 L 13.1115,5.12022 13.7213,4.5 18,9 Z M 4.29881,13.5 0,9 4.27866,4.5 4.88852,5.12022 1.61817,8.53855 H 7.74419 V 9.44026 H 1.59802 l 3.2905,3.43952 z", fill: "currentColor" }) }), Bf = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9412 15.2941C16.9412 15.5853 16.704 15.8235 16.4118 15.8235H1.58823C1.296 15.8235 1.05882 15.5853 1.05882 15.2941V6.82353C1.05882 6.53235 1.296 6.29412 1.58823 6.29412H16.4118C16.704 6.29412 16.9412 6.53235 16.9412 6.82353V15.2941ZM16.4118 5.23529H9.57494C9.71471 4.42 10.1933 4.17118 10.8254 3.85565C11.6629 3.43741 12.7059 2.91541 12.7059 1H11.6471C11.6471 2.26106 11.1039 2.53212 10.3511 2.90906C9.59824 3.28494 8.68659 3.75506 8.50871 5.23529H1.58824C0.712588 5.23529 0 5.94788 0 6.82353V15.2941C0 16.1698 0.712588 16.8824 1.58824 16.8824H16.4118C17.2874 16.8824 18 16.1698 18 15.2941V6.82353C18 5.94788 17.2874 5.23529 16.4118 5.23529ZM11.1177 11.5882H6.88236C6.59013 11.5882 6.35295 11.8254 6.35295 12.1176V13.1765C6.35295 13.4687 6.59013 13.7059 6.88236 13.7059H11.1177C11.4099 13.7059 11.6471 13.4687 11.6471 13.1765V12.1176C11.6471 11.8254 11.4099 11.5882 11.1177 11.5882ZM14.2941 11.5882H13.2353C12.943 11.5882 12.7059 11.8254 12.7059 12.1176V13.1765C12.7059 13.4687 12.943 13.7059 13.2353 13.7059H14.2941C14.5863 13.7059 14.8235 13.4687 14.8235 13.1765V12.1176C14.8235 11.8254 14.5863 11.5882 14.2941 11.5882ZM4.76472 11.5882H3.7059C3.41366 11.5882 3.17649 11.8254 3.17649 12.1176V13.1765C3.17649 13.4687 3.41366 13.7059 3.7059 13.7059H4.76472C5.05696 13.7059 5.29413 13.4687 5.29413 13.1765V12.1176C5.29413 11.8254 5.05696 11.5882 4.76472 11.5882ZM4.76472 8.41176H3.7059C3.41366 8.41176 3.17649 8.64894 3.17649 8.94118V10C3.17649 10.2922 3.41366 10.5294 3.7059 10.5294H4.76472C5.05696 10.5294 5.29413 10.2922 5.29413 10V8.94118C5.29413 8.64894 5.05696 8.41176 4.76472 8.41176ZM6.88236 10.5294H7.94118C8.23342 10.5294 8.4706 10.2922 8.4706 10V8.94118C8.4706 8.64894 8.23342 8.41176 7.94118 8.41176H6.88236C6.59013 8.41176 6.35295 8.64894 6.35295 8.94118V10C6.35295 10.2922 6.59013 10.5294 6.88236 10.5294ZM11.1176 8.41176H10.0588C9.76658 8.41176 9.52941 8.64894 9.52941 8.94118V10C9.52941 10.2922 9.76658 10.5294 10.0588 10.5294H11.1176C11.4099 10.5294 11.6471 10.2922 11.6471 10V8.94118C11.6471 8.64894 11.4099 8.41176 11.1176 8.41176ZM14.2941 8.41176H13.2353C12.943 8.41176 12.7059 8.64894 12.7059 8.94118V10C12.7059 10.2922 12.943 10.5294 13.2353 10.5294H14.2941C14.5863 10.5294 14.8235 10.2922 14.8235 10V8.94118C14.8235 8.64894 14.5863 8.41176 14.2941 8.41176Z", fill: "currentColor" }) }), Uf = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1074 16.8677C12.8638 16.8677 11.8524 15.8563 11.8524 14.6127C11.8524 14.4154 11.8862 14.2271 11.9336 14.0444C12.0317 13.6701 12.22 13.3318 12.4804 13.059C12.8908 12.6294 13.467 12.3576 14.1074 12.3576C15.3511 12.3576 16.3625 13.369 16.3625 14.6127C16.3625 15.8563 15.3511 16.8677 14.1074 16.8677ZM4.38257 11.2301C3.13891 11.2301 2.12752 10.2187 2.12752 8.97507C2.12752 7.73141 3.13891 6.72002 4.38257 6.72002C5.01623 6.72002 5.58676 6.98386 5.99718 7.40556C6.25989 7.67616 6.44819 8.01329 6.54966 8.38763C6.60153 8.57592 6.63761 8.76986 6.63761 8.97507C6.63761 9.2017 6.59364 9.41818 6.53049 9.62452C6.41887 9.99435 6.22155 10.327 5.94982 10.5908C5.54391 10.9843 4.99256 11.2301 4.38257 11.2301ZM11.8524 3.38257C11.8524 2.13891 12.8638 1.12753 14.1074 1.12753C15.3511 1.12753 16.3625 2.13891 16.3625 3.38257C16.3625 4.62622 15.3511 5.63761 14.1074 5.63761C13.4749 5.63761 12.9055 5.3749 12.4962 4.95546C12.2324 4.68485 12.0429 4.34773 11.9415 3.97339C11.8896 3.78397 11.8524 3.5889 11.8524 3.38257ZM14.1074 11.2301C13.0498 11.2301 12.1151 11.7273 11.495 12.4907L7.52722 10.1996C7.67605 9.81846 7.76513 9.40804 7.76513 8.97507C7.76513 8.56465 7.68056 8.17678 7.54639 7.8126L11.5108 5.5226C12.132 6.27466 13.0588 6.76513 14.1074 6.76513C15.9724 6.76513 17.49 5.24748 17.49 3.38256C17.49 1.51764 15.9724 0 14.1074 0C12.2425 0 10.7249 1.51764 10.7249 3.38256C10.7249 3.79411 10.8094 4.18423 10.9447 4.54842L6.9815 6.83729C6.36136 6.08411 5.43341 5.59251 4.38256 5.59251C2.51764 5.59251 1 7.11015 1 8.97507C1 10.84 2.51764 12.3576 4.38256 12.3576C5.40974 12.3576 6.32077 11.8875 6.94091 11.1625L10.9368 13.4694C10.8072 13.829 10.7249 14.2102 10.7249 14.6127C10.7249 16.4776 12.2425 17.9952 14.1074 17.9952C15.9724 17.9952 17.49 16.4776 17.49 14.6127C17.49 12.7478 15.9724 11.2301 14.1074 11.2301Z", fill: "currentColor" }) }), Gf = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.7647 16.9412H2.05882V1.05883H10.5294V5.29412H14.7647V16.9412ZM11.5882 1.278L14.5455 4.2353H11.5882V1.278ZM15.3587 3.55129L12.2722 0.464824C11.9715 0.165176 11.5724 0 11.1488 0H1V18H15.8235V4.67471C15.8235 4.25118 15.6584 3.852 15.3587 3.55129ZM1 0H15.8235V18H1V0ZM1 18H15.8235V0H1V18ZM4.17649 5.29412H8.41178V4.23529H4.17649V5.29412ZM4.17649 9.52941H10.5294V8.47059H4.17649V9.52941ZM4.17649 13.7647H8.41178V12.7059H4.17649V13.7647ZM4.17649 7.41177H12.6471V6.35294H4.17649V7.41177ZM4.17649 11.6471H11.5883V10.5882H4.17649V11.6471Z", fill: "currentColor" }) }), Ao = {
  share: /* @__PURE__ */ he(Uf, {}),
  transcript: /* @__PURE__ */ he(Gf, {}),
  media: /* @__PURE__ */ he(kf, {}),
  delete: /* @__PURE__ */ he(pl, {}),
  shortcuts: /* @__PURE__ */ he(Bf, {}),
  expand: /* @__PURE__ */ he(Zf, {})
};
function Hf({ openShortcuts: B, shouldFocus: V }) {
  const [ie, ye] = ar(!1), [Ce, st] = ar(null), Se = Sr(), ge = Xn(), R = () => {
    ye(!ie), Se.globalKeysDisabled.set(!ie);
  }, te = gr(null), E = gr([]), { refs: t, floatingStyles: e, context: m } = Oi({
    open: ie,
    onOpenChange: R,
    whileElementsMounted: Mi,
    placement: "bottom-end",
    middleware: [
      ba(),
      Sa(10),
      Aa({
        element: te
      })
    ]
  }), p = (J) => {
    J !== null && V && J.focus();
  }, l = Eo([t.setReference, p]), v = vo(m, {
    listRef: E,
    activeIndex: Ce,
    onNavigate: st,
    loop: !0
  }), h = cl(m, {
    toggle: !0
  }), n = Ia(m, {
    outsidePress: !0,
    outsidePressEvent: "mousedown"
  }), { getReferenceProps: f, getFloatingProps: d, getItemProps: S } = wa(
    [h, n, v]
  ), { t: x } = On(), G = bo(), P = dr(
    () => Ff(
      ge.kebabMenuElements,
      G,
      {
        label: x("KEYBOARD_SHORTCUTS"),
        onClick: B
      }
    ),
    [ge.kebabMenuElements, x, B, G]
  );
  return P.length > 0 ? /* @__PURE__ */ rn(Gr, { children: [
    /* @__PURE__ */ he(
      "button",
      {
        id: "kebab-menu-button",
        type: "button",
        "aria-label": x("KEBAB_MENU", { title: ge.title }),
        "aria-haspopup": "true",
        "aria-expanded": ie,
        className: Wr.kebabMenuButton,
        ref: l,
        ...f({
          onClick: () => R()
        }),
        children: /* @__PURE__ */ he(ml, {})
      }
    ),
    ie && /* @__PURE__ */ he(Ra, { context: m, guards: !1, children: /* @__PURE__ */ rn(
      "div",
      {
        id: "kebab-menu",
        ref: t.setFloating,
        style: e,
        className: Wr.kebabMenu,
        role: "menu",
        "aria-labelledby": "kebab-menu-button",
        ...d(),
        children: [
          P.map(({ id: J, text: M, icon: W, onClick: se }, j) => /* @__PURE__ */ rn(
            "button",
            {
              tabIndex: Ce === j ? 0 : -1,
              type: "button",
              role: "menuitem",
              className: Wr.kebabMenuItem,
              ref: (re) => {
                E.current[j] = re;
              },
              ...S({
                onClick: () => {
                  se(J), ye(!1);
                }
              }),
              children: [
                So(W) ? W : Ao[W],
                M
              ]
            },
            J
          )),
          /* @__PURE__ */ he(
            Ca,
            {
              ref: te,
              context: m,
              className: Wr.arrow
            }
          )
        ]
      }
    ) })
  ] }) : null;
}
const qf = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Escape"
];
function Io(B, V = !1, ie = !0) {
  Zr(() => {
    if (!ie)
      return;
    const ye = new AbortController();
    return document.addEventListener(
      "keydown",
      (Ce) => {
        var st;
        return (st = B[Ce.key]) == null ? void 0 : st.call(B, Ce);
      },
      {
        passive: !0,
        signal: ye.signal
      }
    ), V && window.addEventListener(
      "keydown",
      (Ce) => {
        qf.includes(Ce.code) && Ce.preventDefault();
      },
      { signal: ye.signal }
    ), () => {
      ye.abort();
    };
  }, [B, V, ie]);
}
function Vf(B) {
  const V = dr(() => ({ Escape: B }), [B]);
  return Io(V);
}
const yl = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.94968 7.74766L3.99993 2.79791L2.79785 3.99999L7.7476 8.94974L2.79785 13.8995L3.99993 15.1016L8.94968 10.1518L13.8994 15.1016L15.1015 13.8995L10.1518 8.94974L15.1015 3.99999L13.8994 2.79791L8.94968 7.74766Z", fill: "currentColor" }) });
function jf({ onClose: B }) {
  const { t: V } = On();
  return Vf(B), /* @__PURE__ */ rn(
    "div",
    {
      className: Wr.keyboardShortcutsOverlay,
      tabIndex: 0,
      role: "dialog",
      "aria-label": V("KEYBOARD_SHORTCUTS"),
      children: [
        /* @__PURE__ */ rn("header", { children: [
          /* @__PURE__ */ he("h2", { children: V("KEYBOARD_SHORTCUTS") }),
          /* @__PURE__ */ he(
            "button",
            {
              type: "button",
              className: Wr.closeButton,
              onClick: B,
              "aria-label": V("CLOSE"),
              autoFocus: !0,
              children: /* @__PURE__ */ he(yl, {})
            }
          )
        ] }),
        /* @__PURE__ */ rn("table", { children: [
          /* @__PURE__ */ he("caption", { className: Wr.screenReaderContent, children: V("KEYBOARD_SHORTCUTS") }),
          /* @__PURE__ */ he("thead", { children: /* @__PURE__ */ rn("tr", { children: [
            /* @__PURE__ */ he("th", { children: V("ACTION") }),
            /* @__PURE__ */ he("th", { children: V("SHORTCUT") })
          ] }) }),
          /* @__PURE__ */ rn("tbody", { children: [
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("SEEK_BACKWARD", { seconds: 5 }) }),
              /* @__PURE__ */ he("td", { children: V("LEFT_ARROW") })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("SEEK_FORWARD", { seconds: 5 }) }),
              /* @__PURE__ */ he("td", { children: V("RIGHT_ARROW") })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("SEEK_BACKWARD", { seconds: 10 }) }),
              /* @__PURE__ */ he("td", { children: "J" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("SEEK_FORWARD", { seconds: 10 }) }),
              /* @__PURE__ */ he("td", { children: "L" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("INCREASE_VOLUME", { percent: 5 }) }),
              /* @__PURE__ */ he("td", { children: V("UP_ARROW") })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("DECREASE_VOLUME", { percent: 5 }) }),
              /* @__PURE__ */ he("td", { children: V("DOWN_ARROW") })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("TOGGLE_MUTED") }),
              /* @__PURE__ */ he("td", { children: "M" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("TOGGLE_PLAY_PAUSE") }),
              /* @__PURE__ */ rn("td", { children: [
                V("SPACE"),
                ", K"
              ] })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("ENTER_FULLSCREEN") }),
              /* @__PURE__ */ he("td", { children: "F" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("EXIT_FULLSCREEN") }),
              /* @__PURE__ */ he("td", { children: "Esc, F" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("TOGGLE_CAPTIONS") }),
              /* @__PURE__ */ he("td", { children: "C" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("NEXT_CAPTION_LANGUAGE") }),
              /* @__PURE__ */ he("td", { children: "V" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("PREVIOUS_CAPTION_LANGUAGE") }),
              /* @__PURE__ */ he("td", { children: "X" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("DECREASE_PLAYBACK_SPEED") }),
              /* @__PURE__ */ he("td", { children: "A" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("RESET_PLAYBACK_SPEED") }),
              /* @__PURE__ */ he("td", { children: "S" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("INCREASE_PLAYBACK_SPEED") }),
              /* @__PURE__ */ he("td", { children: "D" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("JUMP_TO_START") }),
              /* @__PURE__ */ he("td", { children: "0" })
            ] }),
            /* @__PURE__ */ rn("tr", { children: [
              /* @__PURE__ */ he("td", { children: V("JUMP_TO_PERCENTAGE") }),
              /* @__PURE__ */ he("td", { children: "1-9" })
            ] })
          ] })
        ] })
      ]
    }
  );
}
const Yf = "_container_12srz_1", Kf = "_button_12srz_8", Xs = {
  container: Yf,
  button: Kf
};
function zf() {
  const B = Kn("paused"), V = Xn(), ie = bo(), ye = dr(
    () => xf(V.kebabMenuElements),
    [V.kebabMenuElements]
  );
  return ie && B ? /* @__PURE__ */ he("div", { className: Xs.container, children: ye.map(({ id: Ce, text: st, overlayText: Se, icon: ge, onClick: R }) => /* @__PURE__ */ rn(
    "button",
    {
      type: "button",
      className: Xs.button,
      onClick: () => R(Ce),
      title: st,
      children: [
        So(ge) ? ge : Ao[ge],
        Se ?? st
      ]
    },
    Ce
  )) }) : null;
}
function Wf() {
  const B = Sr(), [V, ie] = ar(!1), ye = Ta(), Ce = gr(!1), st = gr(!1), Se = Un(() => {
    ie(!0), requestAnimationFrame(() => {
      B.interactionsDisabled.set(!0);
    });
    const R = ye.getPlayer();
    R != null && R.state.playing && (Ce.current = !0, ye.pause()), st.current = !0;
  }, [ye, B]), ge = Un(() => {
    ie(!1), B.interactionsDisabled.set(!1), Ce.current && (Ce.current = !1, ye.play());
  }, [ye, B]);
  return V ? /* @__PURE__ */ he(jf, { onClose: ge }) : /* @__PURE__ */ rn("div", { className: Wr.controlsOverlay, children: [
    /* @__PURE__ */ he(zf, {}),
    /* @__PURE__ */ he(
      Hf,
      {
        openShortcuts: Se,
        shouldFocus: st.current
      }
    )
  ] });
}
const _l = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "M21.6133 0C21.7618 0.00076969 21.9069 0.0163677 22.0479 0.0429688C22.08 0.049029 22.1118 0.0561449 22.1436 0.0634766C22.2504 0.0882055 22.3543 0.119742 22.4551 0.158203C22.5054 0.177395 22.5548 0.198283 22.6035 0.220703C22.6693 0.251023 22.7328 0.285114 22.7949 0.321289C23.5109 0.698258 24.001 1.44878 24.001 2.3125V2.37598C24.0011 2.38411 24.002 2.39224 24.002 2.40039V21.5996C24.002 21.6084 24.0011 21.6172 24.001 21.626V21.8125C24.001 23.053 22.9915 24.0625 21.751 24.0625H2.25098C1.01048 24.0625 0.000976562 23.053 0.000976562 21.8125V2.3125C0.000976562 1.45189 0.487409 0.703493 1.19922 0.325195C1.2534 0.29368 1.30843 0.263587 1.36523 0.236328C1.42453 0.207895 1.485 0.181784 1.54688 0.158203C1.63627 0.1241 1.72811 0.0956196 1.82227 0.0722656C1.87757 0.0585704 1.93349 0.0468931 1.99023 0.0371094C2.1196 0.0147491 2.25212 0.00075657 2.3877 0H21.6133ZM2.66797 21.334H21.335V2.66699H2.66797V21.334ZM9.41211 8.00391C10.1452 8.00415 10.7451 8.60471 10.7451 9.33789V10.6709H8.74512V10.0039H6.07812V14.0039H8.74512V13.3379H10.7451V14.6709C10.7451 15.4041 10.1452 16.0037 9.41211 16.0039H5.41211C4.6788 16.0039 4.07814 15.4042 4.07812 14.6709V9.33789C4.07812 8.60457 4.67878 8.00391 5.41211 8.00391H9.41211ZM18.4746 8.00391C19.2077 8.00415 19.8076 8.60471 19.8076 9.33789V10.6709H17.8076V10.0039H15.1406V14.0039H17.8076V13.3379H19.8076V14.6709C19.8076 15.4041 19.2077 16.0037 18.4746 16.0039H14.4746C13.7413 16.0039 13.1406 15.4042 13.1406 14.6709V9.33789C13.1406 8.60457 13.7413 8.00391 14.4746 8.00391H18.4746Z", fill: "currentColor" }) }), El = (B) => /* @__PURE__ */ rn("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...B, children: [
  /* @__PURE__ */ he("defs", { children: /* @__PURE__ */ he("clipPath", { id: "clip0_149_104406", children: /* @__PURE__ */ he("rect", { width: 24, height: 24, fill: "white" }) }) }),
  /* @__PURE__ */ he("g", { clipPath: "url(#clip0_149_104406)", children: /* @__PURE__ */ he("path", { d: "M21.3333 0H2.66666C1.18666 0 0 1.35 0 3V21C0 22.65 1.18666 24 2.66666 24H21.3333C22.8 24 24 22.65 24 21V3C24 1.35 22.8 0 21.3333 0ZM10.6667 10.6667H8.66666V10H6V14H8.66666V13.3333H10.6667V14.6667C10.6667 15.4 10.0667 16 9.33334 16H5.33334C4.6 16 4 15.4 4 14.6667V9.33334C4 8.6 4.6 8 5.33334 8H9.33334C10.0667 8 10.6667 8.6 10.6667 9.33334V10.6667ZM20.0042 10.6667H18.0042V10H15.3375V14H18.0042V13.3333H20.0042V14.6667C20.0042 15.4 19.4042 16 18.6708 16H14.6708C13.9375 16 13.3375 15.4 13.3375 14.6667V9.33334C13.3375 8.6 13.9375 8 14.6708 8H18.6708C19.4042 8 20.0042 8.6 20.0042 9.33334V10.6667Z", fill: "currentColor" }) })
] });
function Qf() {
  const B = Ta(), V = Kn("textTrack"), ie = Kn("hasCaptions"), ye = V && Bc(V), { t: Ce } = On(), st = Un(
    (Se) => {
      B.toggleCaptions(Se.nativeEvent);
    },
    [B]
  );
  return ie ? /* @__PURE__ */ he(
    "button",
    {
      type: "button",
      className: "controls-button",
      onClick: st,
      "aria-label": Ce(ye ? "CAPTIONS_DISABLE" : "CAPTIONS_ENABLE"),
      "aria-pressed": ye ? "true" : "false",
      children: ye ? /* @__PURE__ */ he(El, { className: "controls-button-icon" }) : /* @__PURE__ */ he(_l, { className: "controls-button-icon" })
    }
  ) : null;
}
const Xf = "_captions_1mt3b_1", $f = {
  captions: Xf
}, Jf = (B, V) => B ? V.top : V.bottom;
function vl({ captions: B }) {
  const { captionOffsetOverride: V, controlsLayout: ie } = Xn(), ye = lr("captionPositionOnTop"), Ce = lr("captionsInvertColors"), st = lr("captionsFontSizeMultiplier"), Se = Jf(
    ye,
    V ?? {}
  );
  return /* @__PURE__ */ rn(Gr, { children: [
    B.map((ge) => /* @__PURE__ */ he(
      Uc,
      {
        kind: "subtitles",
        type: ge.type,
        language: ge.language,
        label: ge.label,
        src: ge.src,
        sourceType: ge.sourceType
      },
      ge.src ? ge.src : `${ge.language}-${ge.sourceType || "standard"}`
    )),
    B.length > 0 ? /* @__PURE__ */ he(
      "div",
      {
        style: {
          display: "contents",
          ...Se ? { "--caption-offset": Se } : {},
          "--captions-font-size-multiplier": st ?? 1,
          "--captions-justify-content": ye ? "start" : "end",
          "--captions-color": Ce ? "rgba(22, 22, 22)" : "white",
          "--captions-background-color": Ce ? "rgba(255, 255, 255, 0.75)" : "rgba(22, 22, 22, 0.75)",
          "--captions-fullscreen-offset": ie === "normal" ? "5.5rem" : "4rem"
        },
        children: /* @__PURE__ */ he(Gc, { className: $f.captions })
      }
    ) : null
  ] });
}
function Tl(B) {
  var V, ie, ye = "";
  if (typeof B == "string" || typeof B == "number") ye += B;
  else if (typeof B == "object") if (Array.isArray(B)) {
    var Ce = B.length;
    for (V = 0; V < Ce; V++) B[V] && (ie = Tl(B[V])) && (ye && (ye += " "), ye += ie);
  } else for (ie in B) B[ie] && (ye && (ye += " "), ye += ie);
  return ye;
}
function _a() {
  for (var B, V, ie = 0, ye = "", Ce = arguments.length; ie < Ce; ie++) (B = arguments[ie]) && (V = Tl(B)) && (ye && (ye += " "), ye += V);
  return ye;
}
const ed = "_comments-overlay_z1669_1", td = "_comments-container_z1669_12", nd = "_comment_z1669_1", rd = "_comment-text_z1669_55", id = "_comment-author-avatar_z1669_75", ad = "_comment-author-name_z1669_99", ai = {
  "comments-overlay": "_comments-overlay_z1669_1",
  commentsOverlay: ed,
  "comments-container": "_comments-container_z1669_12",
  commentsContainer: td,
  comment: nd,
  "comment-text": "_comment-text_z1669_55",
  commentText: rd,
  "comment-author-avatar": "_comment-author-avatar_z1669_75",
  commentAuthorAvatar: id,
  "comment-author-name": "_comment-author-name_z1669_99",
  commentAuthorName: ad
};
function od({ comment: B }) {
  return B.render ? B.render(B, ai) : /* @__PURE__ */ rn("div", { className: ai.comment, onClick: () => {
    var V;
    return (V = B.onClick) == null ? void 0 : V.call(B, B);
  }, children: [
    /* @__PURE__ */ he(
      "img",
      {
        className: ai.commentAuthorAvatar,
        src: B.user.avatar,
        alt: B.user.name
      }
    ),
    /* @__PURE__ */ he("span", { className: ai.commentText, children: B.text }),
    /* @__PURE__ */ he("span", { className: ai.commentAuthorName, children: B.user.name })
  ] });
}
const sd = (B) => {
  const [, V] = ar({});
  return dr(() => {
    let ie = [];
    return {
      add(ye) {
        ie.length >= B && ie.shift(), ie.push(ye), V({});
      },
      remove(ye) {
        ie = ie.filter((Ce) => Ce !== ye), V({});
      },
      clear() {
        ie = [], V({});
      },
      map(ye) {
        return ie.map(ye);
      }
    };
  }, []);
}, ld = (B, V, ie) => {
  let ye = !1;
  return (Ce) => {
    const st = Ce.detail.currentTime;
    st >= B.timestamp && st < B.timestamp + V && !ye && (ie.add(B), ye = !0), (st < B.timestamp || st >= B.timestamp + V) && ye && (ie.remove(B), ye = !1);
  };
}, ud = (B, V = 5) => {
  const ie = Dr(), ye = sd(V);
  return Zr(() => {
    if (!ie)
      return;
    const Ce = new AbortController();
    return requestAnimationFrame(() => {
      for (const st of B) {
        const Se = ld(st, af, ye);
        ie.addEventListener("time-update", Se, {
          signal: Ce.signal
        });
      }
      ie.dispatchEvent(
        new CustomEvent("time-update", {
          detail: { currentTime: ie.currentTime }
        })
      );
    }), () => {
      Ce.abort(), ye.clear();
    };
  }, [ie, ye, B]), ye;
}, cd = 4;
function fd({ comments: B }) {
  const { controlsLayout: V } = Xn(), ie = lr("commentsEnabled"), ye = lr("captionPositionOnTop"), Ce = ud(B, cd), st = !!Kn("textTrack"), Se = Ce.map((ge) => /* @__PURE__ */ he(od, { comment: ge }, ge.id));
  return B.length > 0 && ie ? /* @__PURE__ */ he(
    "div",
    {
      className: ai.commentsOverlay,
      style: {
        flexDirection: ye && st ? "column-reverse" : "column",
        "--comments-fullscreen-offset": V === "normal" ? "5.5rem" : "4rem"
      },
      children: /* @__PURE__ */ he("div", { className: _a(ai.commentsContainer), children: st ? Se.slice(-3) : Se })
    }
  ) : null;
}
function dd({ renderOverlay: B }) {
  const V = Sr();
  return B(V);
}
const gd = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0692 12C21.0692 11.4776 21.0212 10.944 20.9238 10.4104L23.5511 8.13318L21.0579 3.87247L17.7431 4.97788C16.9059 4.28329 15.9515 3.73553 14.9449 3.37271L14.2616 0H9.28941L8.60612 3.37129C7.58823 3.73553 6.65082 4.27482 5.80659 4.97647L2.49318 3.87247L0 8.13318L2.62729 10.4104C2.52988 10.944 2.48188 11.4776 2.48188 12C2.48188 12.5224 2.52988 13.056 2.62729 13.5896L0 15.8668L2.49318 20.1275L5.808 19.0221C6.64518 19.7167 7.59953 20.2645 8.60612 20.6273L9.28941 24H14.2616L14.9449 20.6287C15.9614 20.2645 16.9002 19.7252 17.7445 19.0235L21.0579 20.1289L23.5511 15.8682L20.9238 13.5911C21.0212 13.056 21.0692 12.5224 21.0692 12ZM11.7755 16.9412C9.05082 16.9412 6.83435 14.7247 6.83435 12C6.83435 9.2753 9.05082 7.05883 11.7755 7.05883C14.5002 7.05883 16.7167 9.2753 16.7167 12C16.7167 14.7247 14.5002 16.9412 11.7755 16.9412Z", fill: "currentColor" }) }), hd = "_settings-menu_6eidn_1", md = "_menu-heading_6eidn_40", pd = "_check-icon_6eidn_51", yd = "_trash-icon_6eidn_52", _d = "_menu-item-multiline-label-wrapper_6eidn_65", Ed = "_menu-item-secondary-label_6eidn_71", vd = "_menu-item-label_6eidn_77", Td = "_menu-item_6eidn_65", bd = "_menu-back-button_6eidn_118", Sd = "_arrow_6eidn_144", Fr = {
  "settings-menu": "_settings-menu_6eidn_1",
  settingsMenu: hd,
  "menu-heading": "_menu-heading_6eidn_40",
  menuHeading: md,
  "check-icon": "_check-icon_6eidn_51",
  checkIcon: pd,
  "trash-icon": "_trash-icon_6eidn_52",
  trashIcon: yd,
  "menu-item-multiline-label-wrapper": "_menu-item-multiline-label-wrapper_6eidn_65",
  menuItemMultilineLabelWrapper: _d,
  "menu-item-secondary-label": "_menu-item-secondary-label_6eidn_71",
  menuItemSecondaryLabel: Ed,
  "menu-item-label": "_menu-item-label_6eidn_77",
  menuItemLabel: vd,
  "menu-item": "_menu-item_6eidn_65",
  menuItem: Td,
  "menu-back-button": "_menu-back-button_6eidn_118",
  menuBackButton: bd,
  arrow: Sd
}, Ad = (B) => B.map((V) => {
  const { language: ie, sourceType: ye } = V;
  return ye === "youtube" ? { ...V, language: `${ie}${To}` } : V;
}), Id = (B) => B ? B.replace(To, "") : null, wd = (B, V) => B.reduce((ie, ye) => {
  const Ce = ie.findIndex(
    (st) => st.languageCode === ye.languageCode
  );
  return Ce === -1 ? ie.push(ye) : ie[Ce].kind === "asr" && ye.kind !== "asr" && (ie[Ce] = ye), ie;
}, []).map((ie) => ({
  label: new Intl.DisplayNames([V], { type: "language" }).of(
    ie.languageCode
  ) || ie.displayName,
  language: ie.languageCode,
  sourceType: "youtube",
  type: "srt"
}));
function fa(B, V) {
  if (!(B != null && B.contentWindow)) return;
  const ie = V ? Id(V) : null, ye = {
    event: "command",
    func: "setOption",
    args: [
      "captions",
      "track",
      V ? { languageCode: ie } : {}
    ]
  };
  B.contentWindow.postMessage(JSON.stringify(ye), "*");
}
const $s = {
  0.5: -1,
  1: 0,
  2: 1,
  3: 2,
  4: 3
};
function bl(B, V) {
  var ye;
  if (!(B != null && B.contentWindow)) return;
  const ie = {
    event: "command",
    func: "setOption",
    args: [
      "captions",
      "fontSize",
      $s[V] !== void 0 ? $s[V] : 0
    ]
  };
  (ye = B.contentWindow) == null || ye.postMessage(JSON.stringify(ie), "*");
}
const Rd = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.037 3.03704L6.07407 9L12.037 14.963L11 16L4 9L11 2L12.037 3.03704Z", fill: "currentColor" }) });
function si({
  noBackButton: B,
  heading: V,
  children: ie
}) {
  const ye = Xr(), { t: Ce } = On();
  return /* @__PURE__ */ rn(Gr, { children: [
    !B && /* @__PURE__ */ rn(
      "button",
      {
        type: "button",
        role: "menuitem",
        tabIndex: -1,
        className: Fr.menuBackButton,
        onClick: ye.back,
        children: [
          /* @__PURE__ */ he(Rd, {}),
          /* @__PURE__ */ he("span", { children: Ce("BACK") })
        ]
      }
    ),
    V && /* @__PURE__ */ he(
      "strong",
      {
        role: "presentation",
        id: "menu-heading",
        className: Fr.menuHeading,
        children: V
      }
    ),
    ie
  ] });
}
const Cd = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1347 3.00061L6.55157 13.5825L0.865302 7.89624L0 8.76154L6.55157 15.3131L17.9988 3.86469L17.1347 3.00061Z", fill: "currentColor" }) });
function Na({
  selected: B,
  label: V,
  secondaryLabel: ie,
  onClick: ye
}) {
  return /* @__PURE__ */ rn(
    "button",
    {
      type: "button",
      role: "menuitemradio",
      "aria-checked": B,
      onClick: ye,
      tabIndex: -1,
      className: Fr.menuItem,
      children: [
        /* @__PURE__ */ he(Cd, { className: Fr.checkIcon }),
        /* @__PURE__ */ rn("div", { className: Fr.menuItemMultilineLabelWrapper, children: [
          /* @__PURE__ */ he("span", { className: Fr.menuItemLabel, children: V }),
          ie && /* @__PURE__ */ he("span", { className: Fr.menuItemSecondaryLabel, children: ie })
        ] })
      ]
    }
  );
}
function Nd() {
  const B = Sr(), V = lr("captionsFontSizeMultiplier"), ie = lr(
    "youtubeEducationProvider"
  ), { t: ye } = On();
  return /* @__PURE__ */ he(si, { heading: ye("CAPTION_FONT_SIZE"), children: rf.map((Ce) => /* @__PURE__ */ he(
    Na,
    {
      selected: Ce === V,
      onClick: () => {
        B.captionsFontSizeMultiplier.set(Ce), ie && bl(ie.iframe, Ce);
      },
      label: `${Ce * 100}%`
    },
    Ce
  )) });
}
function Dd() {
  const B = Hc(), { t: V } = On();
  return /* @__PURE__ */ he(si, { heading: V("CAPTIONS_LANGUAGE"), children: B.map(({ value: ie, label: ye, select: Ce, selected: st, track: Se }) => /* @__PURE__ */ he(
    Na,
    {
      selected: st,
      onClick: () => !st && Ce(),
      label: ye,
      secondaryLabel: (Se == null ? void 0 : Se.sourceType) === "youtube" ? "YouTube" : void 0
    },
    `${ie}-${(Se == null ? void 0 : Se.language) || "und"}-${(Se == null ? void 0 : Se.sourceType) || "standard"}`
  )) });
}
const Xr = () => {
  const B = va(wl);
  if (!B)
    throw new Error(
      "useCustomSettingsMenuContext must be used within a CustomSettingsMenuContext.Provider"
    );
  return B;
};
function Od() {
  const B = Xr(), V = Xn(), { t: ie } = On();
  return Zr(() => {
    V.captions.length === 0 && B.backToMain();
  }, [V.captions]), /* @__PURE__ */ he(si, { heading: ie("CAPTIONS_MANAGE"), children: V.captions.map((ye) => /* @__PURE__ */ rn(
    "button",
    {
      type: "button",
      role: "menuitem",
      onClick: () => {
        var Ce;
        (Ce = V.onCaptionsDelete) == null || Ce.call(V, ye);
      },
      tabIndex: -1,
      className: Fr.menuItem,
      children: [
        /* @__PURE__ */ he(pl, { className: Fr.trashIcon }),
        /* @__PURE__ */ he("span", { className: Fr.menuItemLabel, children: ie("CAPTION_DELETE", { language: ye.label }) })
      ]
    },
    ye.language
  )) });
}
const Md = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3.03704L7.03704 2L14.037 9L7.03704 16L6 14.963L11.963 9L6 3.03704Z", fill: "currentColor" }) }), Ld = "_menu-hint_16n6u_1", Pd = "_menu-button_16n6u_5", xd = "_menu-label_16n6u_42", Fd = "_menu-icon_16n6u_47", da = {
  "menu-hint": "_menu-hint_16n6u_1",
  menuHint: Ld,
  "menu-button": "_menu-button_16n6u_5",
  menuButton: Pd,
  "menu-label": "_menu-label_16n6u_42",
  menuLabel: xd,
  "menu-icon": "_menu-icon_16n6u_47",
  menuIcon: Fd
};
function Si({
  label: B,
  hint: V,
  onClick: ie,
  Icon: ye,
  disabled: Ce = !1
}) {
  return /* @__PURE__ */ rn(
    "button",
    {
      type: "button",
      role: "menuitem",
      "aria-haspopup": Ce ? void 0 : "true",
      disabled: Ce,
      tabIndex: -1,
      onClick: ie,
      className: da.menuButton,
      children: [
        ye && /* @__PURE__ */ he(ye, { className: da.menuIcon }),
        /* @__PURE__ */ he("span", { className: da.menuLabel, children: B }),
        V && /* @__PURE__ */ he("span", { className: da.menuHint, children: V }),
        !Ce && /* @__PURE__ */ he(Md, {})
      ]
    }
  );
}
function kd() {
  const { t: B } = On(), V = Xr(), ie = lr("captionsFontSizeMultiplier"), ye = Un(() => {
    V.setPage("captionFontSize");
  }, [V]);
  return /* @__PURE__ */ he(
    Si,
    {
      label: B("CAPTION_FONT_SIZE"),
      hint: `${ie * 100}%`,
      onClick: ye
    }
  );
}
const Zd = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "M 21.798373,3.342155 8.8843977,16.256145 2.2000774,9.571825 0,11.771895 8.8843977,20.657845 24,5.543795 Z", fill: "currentColor" }) }), Bd = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "M 9.64706,12 4,17.64706 6.35293,20 12,14.35293 17.64706,20 20,17.64706 14.35293,12 20,6.35293 17.64706,4 12,9.64706 6.35293,4 4,6.35293 Z", fill: "currentColor" }) }), Ud = "_switch-track_olfik_1", Gd = "_switch-thumb_olfik_22", Hd = "_switch-icon_olfik_36", qd = "_switch-body_olfik_42", Vd = "_switch-label_olfik_83", jd = "_menu-icon_olfik_87", ii = {
  "switch-track": "_switch-track_olfik_1",
  switchTrack: Ud,
  "switch-thumb": "_switch-thumb_olfik_22",
  switchThumb: Gd,
  "switch-icon": "_switch-icon_olfik_36",
  switchIcon: Hd,
  "switch-body": "_switch-body_olfik_42",
  switchBody: qd,
  "switch-label": "_switch-label_olfik_83",
  switchLabel: Vd,
  "menu-icon": "_menu-icon_olfik_87",
  menuIcon: jd
};
function wo({
  label: B,
  checked: V = !1,
  onClick: ie,
  Icon: ye
}) {
  return /* @__PURE__ */ rn(
    "button",
    {
      type: "button",
      className: ii.switchBody,
      role: "menuitemcheckbox",
      "aria-label": B,
      "aria-checked": V,
      onClick: ie,
      tabIndex: -1,
      children: [
        ye && /* @__PURE__ */ he(ye, { className: ii.menuIcon }),
        /* @__PURE__ */ he("span", { className: ii.switchLabel, children: B }),
        /* @__PURE__ */ he("div", { className: ii.switchTrack, children: /* @__PURE__ */ he("div", { className: ii.switchThumb, children: V ? /* @__PURE__ */ he(Zd, { className: ii.switchIcon }) : /* @__PURE__ */ he(Bd, { className: ii.switchIcon }) }) })
      ]
    }
  );
}
function Yd() {
  const { t: B } = On(), V = Sr(), ie = lr("captionsInvertColors");
  return /* @__PURE__ */ he(
    wo,
    {
      label: B("INVERT_COLORS"),
      onClick: () => V.captionsInvertColors.set(!ie),
      checked: ie
    }
  );
}
function Kd() {
  const B = Xr(), V = Kn("textTrack"), { t: ie } = On(), { disableCaptionSettings: ye } = Xn(), Ce = Un(() => {
    B.setPage("captionLanguage");
  }, [B]);
  return ye ? null : /* @__PURE__ */ he(
    Si,
    {
      label: ie("LANGUAGE"),
      hint: (V == null ? void 0 : V.label) ?? ie("OFF"),
      onClick: Ce
    }
  );
}
function zd() {
  const B = Xr(), { t: V } = On(), ie = Un(() => {
    B.setPage("captionManage");
  }, [B]);
  return /* @__PURE__ */ he(Si, { label: V("CAPTIONS_MANAGE"), onClick: ie });
}
function Wd() {
  const { t: B } = On(), V = Sr(), ie = lr("captionPositionOnTop");
  return /* @__PURE__ */ he(
    wo,
    {
      label: B("ON_TOP"),
      onClick: () => V.captionPositionOnTop.set(!ie),
      checked: ie
    }
  );
}
function Qd() {
  const B = Xn(), { t: V } = On(), ie = Kn("textTrack");
  return /* @__PURE__ */ rn(si, { heading: V("CAPTIONS"), children: [
    /* @__PURE__ */ he(Kd, {}),
    /* @__PURE__ */ he(kd, {}),
    (ie == null ? void 0 : ie.sourceType) !== "youtube" && /* @__PURE__ */ rn(Gr, { children: [
      /* @__PURE__ */ he(Wd, {}),
      /* @__PURE__ */ he(Yd, {})
    ] }),
    B.onCaptionsDelete && /* @__PURE__ */ he(zd, {})
  ] });
}
function Xd() {
  const B = Xr(), V = Kn("hasCaptions"), ie = Kn("textTrack"), { t: ye } = On(), Ce = Un(() => {
    B.setPage("captions");
  }, [B]);
  return V ? /* @__PURE__ */ he(
    Si,
    {
      label: ye("CAPTIONS"),
      hint: (ie == null ? void 0 : ie.label) ?? ye("OFF"),
      onClick: Ce,
      Icon: _l
    }
  ) : null;
}
const $d = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 0V12.7489H5.44V18L10.5007 12.7489H16.582V0H1ZM2 1H15.58V11.7339H9.98655L6.52667 15.25V11.7339H2V1ZM5.24963 5.35011H12.3323V4.24835H5.24963V5.35011ZM5.24963 8.18462H9.50067V7.08285H5.24963V8.18462Z", fill: "currentColor" }) });
function Jd() {
  const { t: B } = On(), V = Xn(), ie = Sr(), ye = lr("commentsEnabled");
  return !V.forceComments && V.hasComments ? /* @__PURE__ */ he(
    wo,
    {
      Icon: $d,
      label: B("COMMENTS"),
      onClick: () => ie.commentsEnabled.set(!ye),
      checked: ye
    }
  ) : null;
}
function Sl(B) {
  const { width: V, height: ie } = B;
  if (V >= 3800 || ie >= 2100)
    return "2160p";
  const ye = ie > V, Ce = ye ? V : ie, st = ye ? ie : V;
  return Ce >= 1400 || st >= 2500 ? "1440p" : Ce >= 1e3 || st >= 1800 ? "1080p" : Ce >= 700 || st >= 1200 ? "720p" : Ce >= 460 || st >= 800 ? "480p" : Ce >= 300 || st >= 540 ? "360p" : Ce >= 200 || st >= 360 ? "240p" : "144p";
}
const eg = (B) => /* @__PURE__ */ rn("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: [
  /* @__PURE__ */ he("defs", { children: /* @__PURE__ */ he("clipPath", { id: "clip0_412_23039", children: /* @__PURE__ */ he("rect", { width: 18, height: 18, fill: "white" }) }) }),
  /* @__PURE__ */ rn("g", { clipPath: "url(#clip0_412_23039)", children: [
    /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.46326 3.85039H0V2.65039H2.46326C2.7388 1.36449 3.88181 0.400391 5.24999 0.400391C6.61818 0.400391 7.76119 1.36449 8.03673 2.65039H18V3.85039H8.03673C7.76119 5.13629 6.61818 6.10039 5.24999 6.10039C3.88181 6.10039 2.7388 5.13629 2.46326 3.85039ZM3.59999 3.25039C3.59999 2.33912 4.33872 1.60039 5.24999 1.60039C6.16126 1.60039 6.89999 2.33912 6.89999 3.25039C6.89999 4.16166 6.16126 4.90039 5.24999 4.90039C4.33872 4.90039 3.59999 4.16166 3.59999 3.25039Z", fill: "currentColor" }),
    /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.40039H9.46326C9.7388 7.11449 10.8818 6.15039 12.25 6.15039C13.6182 6.15039 14.7612 7.11449 15.0367 8.40039H18V9.60039H15.0367C14.7612 10.8863 13.6182 11.8504 12.25 11.8504C10.8818 11.8504 9.7388 10.8863 9.46326 9.60039H0V8.40039ZM12.25 7.35039C11.3387 7.35039 10.6 8.08912 10.6 9.00039C10.6 9.91166 11.3387 10.6504 12.25 10.6504C13.1613 10.6504 13.9 9.91166 13.9 9.00039C13.9 8.08912 13.1613 7.35039 12.25 7.35039Z", fill: "currentColor" }),
    /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.24999 17.6004C6.61818 17.6004 7.76119 16.6363 8.03673 15.3504H18V14.1504H8.03673C7.76119 12.8645 6.61818 11.9004 5.24999 11.9004C3.88181 11.9004 2.7388 12.8645 2.46326 14.1504H0V15.3504H2.46326C2.7388 16.6363 3.88181 17.6004 5.24999 17.6004ZM5.24999 13.1004C4.33872 13.1004 3.59999 13.8391 3.59999 14.7504C3.59999 15.6617 4.33872 16.4004 5.24999 16.4004C6.16126 16.4004 6.89999 15.6617 6.89999 14.7504C6.89999 13.8391 6.16126 13.1004 5.24999 13.1004Z", fill: "currentColor" })
  ] })
] });
function tg(B, V, ie, ye) {
  return B ? V ? ye("AUTO_QUALITY", { quality: ie }) : ye("AUTO") : ie;
}
function ng() {
  const B = Xr(), V = Kn("autoQuality"), ie = Kn("started"), ye = Kn("quality"), { t: Ce } = On(), st = Un(() => {
    B.setPage("quality");
  }, [B]);
  if (!ye)
    return null;
  const Se = Sl(ye), ge = tg(V, ie, Se, Ce);
  return /* @__PURE__ */ he(
    Si,
    {
      label: Ce("QUALITY"),
      hint: ge,
      onClick: st,
      Icon: eg
    }
  );
}
const rg = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.42229 2.82911C4.71149 1.83006 6.23876 1.19768 7.8383 1L7.96797 2.05432C6.55867 2.22862 5.21101 2.7866 4.07273 3.66874L3.42229 2.82911ZM5.44493 6.71393L9.49745 10.7665L17.0924 3.1705L17.8438 3.92297L9.49745 12.2693L4.69352 7.46534L5.44493 6.71393ZM17.932 8.83829C17.8618 8.27074 17.7364 7.70745 17.5589 7.16222L16.5482 7.49276C16.7055 7.97209 16.816 8.46843 16.8766 8.96689C16.917 9.29742 16.9372 9.6269 16.9372 9.96594C16.9372 10.305 16.917 10.6344 16.8777 10.9639C16.7033 12.3732 16.1454 13.7209 15.2632 14.8592L16.1029 15.5096C17.1019 14.2204 17.7343 12.6931 17.932 11.0925C17.9766 10.7205 18 10.3486 18 9.96594C18 9.58332 17.9766 9.21134 17.932 8.83829ZM1.05432 8.96795L0 8.83829C0.197684 7.23874 0.830061 5.71147 1.82911 4.42228L2.66874 5.07272C1.7866 6.211 1.22862 7.55865 1.05432 8.96795ZM0 11.0936C0.197684 12.6931 0.830061 14.2204 1.82911 15.5096L2.66874 14.8591C1.7866 13.7209 1.22862 12.3732 1.05432 10.9639L0 11.0936ZM10.0939 1.00011C11.6935 1.19673 13.2207 1.83017 14.5099 2.82922L13.8595 3.66884C12.7202 2.7867 11.3736 2.22872 9.96426 2.05442L10.0939 1.00011Z", fill: "currentColor" }) });
function ig() {
  const B = Xr(), V = Xn(), ie = Kn("playbackRate"), { t: ye } = On(), Ce = Un(() => {
    B.setPage("speed");
  }, [B]);
  return /* @__PURE__ */ he(
    Si,
    {
      label: ye("PLAYBACK_SPEED"),
      hint: `${ie}x`,
      onClick: Ce,
      disabled: V.lockSpeed,
      Icon: rg
    }
  );
}
function ag() {
  return /* @__PURE__ */ rn(si, { noBackButton: !0, children: [
    /* @__PURE__ */ he(ig, {}),
    /* @__PURE__ */ he(Xd, {}),
    /* @__PURE__ */ he(Jd, {}),
    /* @__PURE__ */ he(ng, {})
  ] });
}
function og() {
  const B = Kn("autoQuality"), V = qc({ sort: "descending" }), { t: ie } = On();
  return /* @__PURE__ */ he(si, { heading: ie("QUALITY"), children: V.map(({ value: ye, select: Ce, selected: st, label: Se, quality: ge }) => /* @__PURE__ */ he(
    Na,
    {
      selected: ye === "auto" && B || st && !B,
      onClick: () => Ce(),
      label: ge ? Sl(ge) : Se
    },
    ye
  )) });
}
function sg() {
  const B = Vc({
    rates: bi,
    normalLabel: "1x"
  }), { t: V } = On();
  return /* @__PURE__ */ he(si, { heading: V("PLAYBACK_SPEED"), children: B.map(({ value: ie, label: ye, select: Ce, selected: st }) => /* @__PURE__ */ he(
    Na,
    {
      selected: st,
      onClick: () => Ce(),
      label: ye
    },
    ie
  )) });
}
function lg(B, V) {
  const ie = Array.from(B.querySelectorAll("button")).filter(
    (Ce) => !Ce.disabled
  ), ye = ie.indexOf(V);
  return ie[ye - 1] ?? null;
}
function ug(B, V) {
  const ie = Array.from(B.querySelectorAll("button")).filter(
    (Ce) => !Ce.disabled
  ), ye = ie.indexOf(V);
  return ie[ye + 1] ?? null;
}
function Js(B) {
  return B.querySelector("button");
}
function el(B) {
  const V = Array.from(B.querySelectorAll("button"));
  return V[V.length - 1] ?? null;
}
function Al(B, V) {
  var ye, Ce;
  if (!B)
    return;
  const ie = document.activeElement;
  if (ie && ie !== B && B.contains(ie)) {
    const st = lg(B, ie);
    st ? st.focus() : (ye = el(B)) == null || ye.focus();
  } else V && B.contains(V) ? V.focus() : (Ce = el(B)) == null || Ce.focus();
}
function Il(B, V) {
  var ye, Ce;
  if (!B)
    return;
  const ie = document.activeElement;
  if (ie && ie !== B && B.contains(ie)) {
    const st = ug(B, ie);
    st ? st.focus() : (ye = Js(B)) == null || ye.focus();
  } else V && B.contains(V) ? V.focus() : (Ce = Js(B)) == null || Ce.focus();
}
function cg(B, V) {
  const ie = gr(null), ye = dr(
    () => ({
      Escape: B.toggle,
      ArrowUp: () => Al(ie.current),
      ArrowDown: () => Il(ie.current),
      ArrowRight: () => {
        const Ce = document.activeElement;
        Ce && Ce.getAttribute("aria-haspopup") === "true" && ie.current && ie.current.contains(Ce) && Ce.click();
      },
      ArrowLeft: B.back
    }),
    [B]
  );
  return Io(ye, !0, V), ie;
}
const wl = Ea(null), fg = {
  main: ag,
  speed: sg,
  captions: Qd,
  captionLanguage: Dd,
  captionFontSize: Nd,
  captionManage: Od,
  quality: og
};
function dg(B) {
  return {
    name: "resizingMiddleware",
    options: B,
    async fn(V) {
      const ie = await nf(V, {
        boundary: B ?? void 0
      });
      return {
        x: V.x - ie.right - 4,
        y: V.y - 4
      };
    }
  };
}
function gg() {
  const B = Sr(), [V, ie] = ar(["main"]), [ye, Ce] = ar(!1), st = Un(() => {
    Ce(!ye), ie(["main"]), B.globalKeysDisabled.set(!ye);
  }, [ye]), Se = Un((d) => {
    ie((S) => S.concat(d));
  }, []), ge = Un(() => {
    ie((d) => d.length > 1 ? d.slice(0, -1) : d);
  }, []), R = Un(() => {
    ie(["main"]);
  }, []), te = dr(() => fg[V[V.length - 1]], [V]), { refs: E, floatingStyles: t, context: e } = Oi({
    open: ye,
    onOpenChange: st,
    placement: "top-end",
    whileElementsMounted: Mi,
    middleware: [dg(B.playerElement.current)]
  }), m = cl(e, {
    toggle: !0
  }), p = Ia(e, {
    escapeKey: !1,
    outsidePress: !0,
    outsidePressEvent: "mousedown"
  }), { getReferenceProps: l, getFloatingProps: v } = wa([
    m,
    p
  ]), h = dr(
    () => ({ setPage: Se, back: ge, backToMain: R, toggle: st }),
    [Se, ge, R, st]
  ), n = cg(h, ye), f = Eo([E.setFloating, n]);
  return {
    Page: te,
    open: ye,
    floatingRef: f,
    referenceRef: E.setReference,
    floatingStyles: t,
    context: e,
    getReferenceProps: l,
    getFloatingProps: v,
    contextValue: h
  };
}
function hg() {
  const {
    Page: B,
    context: V,
    floatingStyles: ie,
    getFloatingProps: ye,
    getReferenceProps: Ce,
    open: st,
    floatingRef: Se,
    referenceRef: ge,
    contextValue: R
  } = gg(), { t: te } = On();
  return /* @__PURE__ */ rn(Gr, { children: [
    /* @__PURE__ */ he(
      "button",
      {
        ref: ge,
        type: "button",
        className: "controls-button",
        "aria-label": te("SETTINGS"),
        "aria-expanded": st,
        "aria-haspopup": "true",
        ...Ce(),
        children: /* @__PURE__ */ he(gd, { className: "controls-button-icon icon-rotate" })
      }
    ),
    st && /* @__PURE__ */ he(
      Ra,
      {
        context: V,
        restoreFocus: !0,
        guards: !1,
        initialFocus: -1,
        children: /* @__PURE__ */ he(
          "div",
          {
            role: "menu",
            "aria-label": te("VIDEO_SETTINGS"),
            "aria-labelledby": "menu-heading",
            className: Fr.settingsMenu,
            ref: Se,
            style: ie,
            ...ye(),
            children: /* @__PURE__ */ he(wl.Provider, { value: R, children: /* @__PURE__ */ he(B, {}) })
          }
        )
      }
    )
  ] });
}
function Rl(B, V = 1e3) {
  return function() {
    const ye = Dr(), [Ce, st] = ar(null), Se = Un(() => st(null), []);
    return Zr(() => {
      if (!ye)
        return () => {
        };
      const ge = new AbortController();
      let R;
      return requestAnimationFrame(() => {
        ye.addEventListener(
          "keyboardAction",
          (te) => {
            clearTimeout(R);
            const E = te.detail;
            st(/* @__PURE__ */ he(B, { action: E })), R = setTimeout(Se, V);
          },
          { signal: ge.signal }
        );
      }), () => {
        clearTimeout(R), ge.abort();
      };
    }, [V]), Ce;
  };
}
const mg = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.309 3.99987L0 12.1331L13.309 20.2663V13.7367L23.9987 20.2596V4.00655L13.309 10.5281V3.99987Z", fill: "currentColor" }) }), pg = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.691 3.99987V10.5281L0 4.00655V20.2596L10.691 13.7367V20.2663L23.9987 12.1331L10.691 3.99987Z", fill: "currentColor" }) }), Cl = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1179 1.41211V22.589H11.2943L5.64717 16.9418V7.05928L11.2943 1.41211H14.1179ZM4.23537 7.05928V16.9418H2.11769C0.957618 16.9418 0.0189406 16.0147 0.00028305 14.8592L0 14.8241V9.17696C0 8.01689 0.927077 7.07822 2.0826 7.05956L2.11769 7.05928H4.23537ZM22.3744 7.93711L24 9.56119L21.5623 11.9988L24 14.4365L22.3744 16.0621L19.9383 13.6245L17.5006 16.0621L15.875 14.4365L18.3127 11.9988L15.875 9.56119L17.5006 7.93711L19.9383 10.3748L22.3744 7.93711Z", fill: "currentColor" }) }), Ro = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "M 11,21 H 5 V 3 h 6 z m 8,0 H 13 V 3 h 6 z", fill: "currentColor" }) }), Co = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "M 5,2 V 22 L 21,12.000665 Z", fill: "currentColor" }) }), Nl = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.64714 16.8627V6.98017L11.2943 1.33301H14.1179V22.5099H11.2943L5.64714 16.8627ZM0 14.745V9.09785C0 7.92607 0.945899 6.98017 2.11768 6.98017H4.23537V16.8627H2.11768C0.945899 16.8627 0 15.9168 0 14.745ZM16.9056 8.4209C17.8388 9.36962 18.3527 10.6134 18.3527 11.9207C18.3527 13.2295 17.8388 14.4732 16.9056 15.422L17.9094 16.4116C19.1066 15.1989 19.7645 13.6036 19.7645 11.9207C19.7645 10.2393 19.1066 8.64396 17.9094 7.43123L16.9056 8.4209ZM19.9016 5.43185L20.8997 4.43372C22.9002 6.43422 24 9.09403 24 11.9219C24 14.7497 22.9002 17.4081 20.8997 19.4086L19.9016 18.4104C21.6353 16.6782 22.5882 14.3727 22.5882 11.9219C22.5882 9.46957 21.6353 7.16553 19.9016 5.43185Z", fill: "currentColor" }) }), Dl = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.64714 6.98017V16.8627L11.2943 22.5099H14.1179V1.33301H11.2943L5.64714 6.98017ZM0 9.09785V14.745C0 15.9168 0.945899 16.8627 2.11768 16.8627H4.23537V6.98017H2.11768C0.945899 6.98017 0 7.92607 0 9.09785ZM18.3527 11.9207C18.3527 10.6134 17.8388 9.36962 16.9056 8.4209L17.9094 7.43123C19.1066 8.64396 19.7645 10.2393 19.7645 11.9207C19.7645 13.6036 19.1066 15.1989 17.9094 16.4116L16.9056 15.422C17.8388 14.4732 18.3527 13.2295 18.3527 11.9207Z", fill: "currentColor" }) }), yg = "_feedback-overlay_14jdq_1", _g = "_feedback-message_14jdq_14", Eg = "_feedback-icon_14jdq_30", vg = "_feedback-icon-animation_14jdq_1", br = {
  "feedback-overlay": "_feedback-overlay_14jdq_1",
  feedbackOverlay: yg,
  "feedback-message": "_feedback-message_14jdq_14",
  feedbackMessage: _g,
  "feedback-icon": "_feedback-icon_14jdq_30",
  feedbackIcon: Eg,
  "feedback-icon-animation": "_feedback-icon-animation_14jdq_1",
  feedbackIconAnimation: vg
};
function Tg({ action: B }) {
  const V = Dr();
  if (!V)
    return null;
  switch (B) {
    case "togglePaused":
      return /* @__PURE__ */ he("i", { className: br.feedbackIcon, children: V.paused ? /* @__PURE__ */ he(Ro, {}) : /* @__PURE__ */ he(Co, {}) });
    case "seekForward":
    case "seekForward10":
      return /* @__PURE__ */ he("i", { className: br.feedbackIcon, children: /* @__PURE__ */ he(pg, { className: "right" }) });
    case "seekBackward":
    case "seekBackward10":
      return /* @__PURE__ */ he("i", { className: br.feedbackIcon, children: /* @__PURE__ */ he(mg, { className: "left" }) });
    case "captionsChange":
      return /* @__PURE__ */ he("i", { className: br.feedbackIcon, children: /* @__PURE__ */ he(El, {}) });
    case "volumeChange":
      return /* @__PURE__ */ he("i", { className: br.feedbackIcon, children: V.muted || V.volume === 0 ? /* @__PURE__ */ he(Cl, {}) : V.volume >= 0.5 ? /* @__PURE__ */ he(Nl, {}) : /* @__PURE__ */ he(Dl, {}) });
    default:
      return null;
  }
}
function bg({ action: B }) {
  const { t: V } = On(), ie = Dr();
  if (!ie)
    return null;
  switch (B) {
    case "captionsChange":
      return /* @__PURE__ */ he("div", { className: br.feedbackMessage, children: ie.textTracks.selected ? V("CAPTION_LANGUAGE", {
        language: ie.textTracks.selected.label
      }) : `${V("CAPTIONS")}: ${V("OFF")}` });
    case "volumeChange":
      return /* @__PURE__ */ he("div", { className: br.feedbackMessage, children: ie.muted || ie.volume === 0 ? V("MUTED") : V("VOLUME_VALUE", { volume: (ie.volume * 100).toFixed(0) }) });
    case "playbackRateChange":
      return /* @__PURE__ */ he("div", { className: br.feedbackMessage, children: V("PLAYBACK_SPEED_MESSAGE", { speed: ie.playbackRate }) });
    case "seekForward":
      return /* @__PURE__ */ he("div", { className: br.feedbackMessage, children: V("SEEK_FORWARD", { seconds: 5 }) });
    case "seekForward10":
      return /* @__PURE__ */ he("div", { className: br.feedbackMessage, children: V("SEEK_FORWARD", { seconds: 10 }) });
    case "seekBackward":
      return /* @__PURE__ */ he("div", { className: br.feedbackMessage, children: V("SEEK_BACKWARD", { seconds: 5 }) });
    case "seekBackward10":
      return /* @__PURE__ */ he("div", { className: br.feedbackMessage, children: V("SEEK_BACKWARD", { seconds: 10 }) });
    default:
      return null;
  }
}
const Sg = Rl(Tg, 300), Ag = Rl(bg, 1e3);
function Ol() {
  return /* @__PURE__ */ rn("div", { className: br.feedbackOverlay, children: [
    /* @__PURE__ */ he(Sg, {}),
    /* @__PURE__ */ he(Ag, {})
  ] });
}
const Ig = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1383 0.999867V3.66268H18.4561L3.66281 18.4546V14.1382H1V23H9.86449V20.3372H5.54542L20.3387 5.54528V9.86303H23.0001V0.999867H14.1383Z", fill: "currentColor" }) }), wg = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.562 6.58944L22.1514 0L24.0005 1.84907L17.4111 8.43851H21.6506V11.0552H12.9453V2.34861H15.562V6.58944ZM2.34861 15.5615V12.9461H11.0539V21.6501H8.43982V17.4106L1.84907 24L0 22.1509L6.59075 15.5615H2.34861Z", fill: "currentColor" }) }), Rg = "_full-screen-button_1xm32_2", Cg = {
  "full-screen-button": "_full-screen-button_1xm32_2",
  fullScreenButton: Rg
};
function Ng() {
  const B = Kn("fullscreen"), V = Dr(), ie = Xn(), { t: ye } = On();
  return ie.hideFullScreen ? null : /* @__PURE__ */ he(
    "button",
    {
      type: "button",
      "aria-label": ye(B ? "EXIT_FULLSCREEN" : "ENTER_FULLSCREEN"),
      className: `controls-button ${Cg.fullScreenButton}`,
      onClick: () => {
        B ? V == null || V.exitFullscreen() : V == null || V.enterFullscreen();
      },
      children: B ? /* @__PURE__ */ he(wg, { className: "controls-button-icon" }) : /* @__PURE__ */ he(Ig, { className: "controls-button-icon" })
    }
  );
}
const Dg = "_gestures-container_1fn3b_1", Og = "_gesture_1fn3b_1", tl = {
  "gestures-container": "_gestures-container_1fn3b_1",
  gesturesContainer: Dg,
  gesture: Og
};
function Ml() {
  const B = Ta(), V = () => {
    B.togglePaused();
  };
  return /* @__PURE__ */ he("div", { className: tl.gesturesContainer, children: /* @__PURE__ */ he("div", { "aria-hidden": !0, className: tl.gesture, onClick: V }) });
}
const Mg = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0V2.66667C17.1453 2.66667 21.3333 6.85333 21.3333 12C21.3333 17.1467 17.1453 21.3333 12 21.3333C6.85467 21.3333 2.66667 17.1467 2.66667 12C2.66667 9.53733 3.64667 7.21867 5.33333 5.49067V8.66667H8V1.33333H0.666667V4H3.05467C1.108 6.176 0 9.012 0 12C0 18.616 5.38267 24 12 24C18.6173 24 24 18.616 24 12C24 5.384 18.6173 0 12 0Z", fill: "currentColor" }) }), Lg = "_play-pause-button_vj8da_1", Pg = {
  "play-pause-button": "_play-pause-button_vj8da_1",
  playPauseButton: Lg
};
function xg(B, V) {
  return V ? Mg : B ? Co : Ro;
}
function Fg(B, V) {
  return V ? "REPLAY" : B ? "PLAY" : "PAUSE";
}
function kg() {
  const B = Dr(), V = Kn("paused"), ie = Kn("ended"), { t: ye } = On(), Ce = gr(null), st = xg(V, ie);
  return B ? /* @__PURE__ */ he(
    "button",
    {
      ref: Ce,
      type: "button",
      "data-play-pause-button": "",
      className: `controls-button ${Pg.playPauseButton}`,
      "aria-label": ye(Fg(V, ie)),
      onClick: () => {
        B.paused ? B.remoteControl.play() : B.remoteControl.pause();
      },
      children: /* @__PURE__ */ he(st, { className: "controls-button-icon" })
    }
  ) : null;
}
function Zg(B, V) {
  return B.reduce((ie, ye) => (Object.keys(V).includes(ye.id) || (ie[ye.id] = !0), ie), V);
}
function Bg(B, V, ie, ye, Ce) {
  return (st) => {
    const Se = st.detail.currentTime, ge = !ie.paused, R = Math.min(ie.duration * 0.05, 2);
    Se >= B.time && Se < B.time + R && !ye[B.id] && (Ce({ ...ye, [B.id]: !0 }), V(B, ge));
  };
}
function Ug() {
  const B = Dr(), { quizMarkers: V, onQuizMarkerShow: ie } = Xn(), [ye, Ce] = ar(
    V.reduce((st, Se) => (st[Se.id] = !1, st), {})
  );
  Zr(() => {
    if (!B)
      return;
    V.length > Object.keys(ye).length && Ce(Zg(V, ye));
    const st = new AbortController(), Se = (ge) => {
      var E;
      const R = (E = ge == null ? void 0 : ge.request) == null ? void 0 : E.detail, te = V.reduce((t, e) => (t[e.id] = e.time <= R, t), {});
      Ce({ ...ye, ...te });
    };
    return requestAnimationFrame(() => {
      B.addEventListener("seeked", Se, {
        signal: st.signal
      });
      for (const ge of V) {
        const R = Bg(
          ge,
          ie,
          B,
          ye,
          Ce
        );
        B.addEventListener("time-update", R, {
          signal: st.signal
        });
      }
    }), () => {
      st.abort();
    };
  }, [V, B, ye]);
}
function Gg() {
  return Ug(), null;
}
function Ll(B) {
  const V = Ea(null), ie = () => {
    const ye = va(V);
    if (ye === null)
      throw new Error(B);
    return ye;
  };
  return [V.Provider, ie];
}
function No(B, V) {
  let ie = -1, ye = 0, Ce = V.length - 1;
  for (; ye <= Ce; ) {
    const st = Math.floor((ye + Ce) / 2), Se = V[st];
    if (Se.startTime < B)
      ie = st, ye = st + 1;
    else if (Se.startTime > B)
      Ce = st - 1;
    else {
      ie = st;
      break;
    }
  }
  return ie;
}
function yo(B, V, ie = !1) {
  const ye = B.getBoundingClientRect(), Ce = V.getBoundingClientRect(), st = Ce.top - ye.top, ge = { top: B.scrollTop + st - ye.height / 2 + Ce.height / 2 };
  ie && (ge.behavior = "instant"), B.scrollTo(ge);
}
class Hg {
  constructor(V, ie, ye) {
    _n(this, "listElement", null);
    _n(this, "initialize", (V) => (this.listElement = V, () => {
    }));
    _n(this, "handleKeyboard", (V) => {
      this.listElement && (V.key === "ArrowUp" && (V.preventDefault(), this.state.autoScroll.get() && this.state.autoScroll.set(!1), Al(this.listElement, this.getStartElement())), V.key === "ArrowDown" && (V.preventDefault(), this.state.autoScroll.get() && this.state.autoScroll.set(!1), Il(this.listElement, this.getStartElement())));
    });
    _n(this, "onFocus", () => {
      this.playerContext.globalKeysDisabled.set(!0);
    });
    _n(this, "onBlur", () => {
      this.playerContext.globalKeysDisabled.set(!1);
    });
    _n(this, "getStartElement", () => {
      var ye;
      if (!this.listElement) return null;
      const V = CSS.highlights.get("search-results-current");
      return (V ? (ye = Array.from(V)[0].startContainer.parentElement) == null ? void 0 : ye.parentElement : this.findButtonToClosestTimeStamp()) ?? this.listElement.querySelector('[aria-current="true"]');
    });
    _n(this, "findButtonToClosestTimeStamp", () => {
      if (!this.listElement) return null;
      const V = No(
        this.player.currentTime,
        this.state.cues.get()
      );
      return V === -1 ? null : this.listElement.children[V].firstElementChild;
    });
    this.state = V, this.player = ie, this.playerContext = ye;
  }
}
class qg {
  constructor(V, ie) {
    _n(this, "currentTrack", null);
    _n(this, "abortController");
    _n(this, "trackChangeAbortController", null);
    _n(this, "cleanup", () => {
      var V;
      (V = this.trackChangeAbortController) == null || V.abort(), this.abortController.abort();
    });
    _n(this, "onTrackChange", (V) => {
      var ie;
      !V || this.currentTrack === V || (this.state.status.set("ready"), this.currentTrack = V, (ie = this.trackChangeAbortController) == null || ie.abort(), this.trackChangeAbortController = new AbortController(), this.state.cues.set(V.cues), this.setClosestCueToCurrentTimestamp(), V.addEventListener(
        "cue-change",
        ({ target: ye }) => {
          this.state.activeCueIndex.set(
            ye.cues.indexOf(ye.activeCues[0])
          );
        },
        {
          signal: this.trackChangeAbortController.signal
        }
      ));
    });
    _n(this, "setClosestCueToCurrentTimestamp", () => {
      const V = this.state.cues.get(), ie = this.player.currentTime, ye = No(ie, V);
      ye > -1 && V[ye].endTime > ie && this.state.activeCueIndex.set(ye);
    });
    this.state = V, this.player = ie, this.abortController = new AbortController(), this.player.addEventListener(
      "text-track-change",
      (ye) => {
        this.onTrackChange(ye.detail);
      },
      { signal: this.abortController.signal }
    ), jc(() => {
      const ye = this.player.$state.textTrack(), Ce = this.player.$state.textTracks();
      if (ye)
        return this.onTrackChange(ye);
      if (this.currentTrack)
        return this.onTrackChange(this.currentTrack);
      if (Ce.length > 0 && Ce[0])
        return Ce[0].cues.length === 0 ? Ce[0].addEventListener(
          "load",
          (st) => {
            this.onTrackChange(st.target);
          },
          { once: !0 }
        ) : this.onTrackChange(Ce[0]);
      this.state.status.set("empty");
    });
  }
}
function Vg(B) {
  return Array.isArray(B) && typeof B[0] == "object";
}
function jg(B) {
  return Vg(B) && B.length === 1 ? B[0].src : B;
}
function _o(B) {
  return typeof B == "number" && !Number.isNaN(B);
}
function Pl(B, V = 1e3) {
  let ie = !1;
  return () => {
    ie || (B(), ie = !0, setTimeout(() => {
      ie = !1;
    }, V));
  };
}
class Yg {
  constructor(V, ie) {
    _n(this, "listElement", null);
    _n(this, "initialize", (V) => {
      this.listElement = V;
      const ie = new AbortController(), ye = Pl(() => {
        this.state.autoScroll.get() && this.state.autoScroll.set(!1);
      });
      for (const Ce of ["touchmove", "wheel"])
        this.listElement.addEventListener(Ce, ye, {
          signal: ie.signal,
          passive: !0
        });
      return ie.signal.addEventListener(
        "abort",
        this.state.activeCueIndex.subscribe(this.onCueChange)
      ), ie.signal.addEventListener(
        "abort",
        this.state.autoScroll.subscribe(this.onAutoScrollChange)
      ), () => ie.abort();
    });
    _n(this, "enableAutoScroll", () => {
      this.state.autoScroll.set(!0);
    });
    // scroll to last active cue if auto-scroll is re-enabled
    _n(this, "onAutoScrollChange", (V) => {
      if (!V || !this.listElement || !this.listElement.children.length)
        return;
      let ie = No(
        this.player.currentTime,
        this.state.cues.get()
      );
      ie === -1 && (ie = 0);
      const ye = this.listElement.children[ie];
      ye && (this.listElement.addEventListener(
        "scrollend",
        () => {
          var Ce;
          return (Ce = this.listElement) == null ? void 0 : Ce.focus({ preventScroll: !0 });
        },
        { once: !0 }
      ), yo(this.listElement, ye));
    });
    // scroll active cue into view if auto-scroll is enabled
    _n(this, "onCueChange", (V) => {
      this.state.autoScroll.get() && V > -1 && (this.listElement && this.listElement.children.length > 0 ? this.scrollToActiveCue(V) : setTimeout(() => {
        this.scrollToActiveCue(V, !0);
      }, 0));
    });
    _n(this, "scrollToActiveCue", (V, ie) => {
      if (!this.listElement) return;
      const ye = this.listElement.children[V];
      ye && yo(this.listElement, ye, ie);
    });
    this.state = V, this.player = ie;
  }
}
class Kg {
  constructor(V, ie, ye) {
    _n(this, "listElement", null);
    _n(this, "initialize", (V) => {
      this.listElement = V;
      const ie = new AbortController();
      return this.player.addEventListener("text-track-change", this.clearSearch, {
        signal: ie.signal
      }), ie.signal.addEventListener(
        "abort",
        this.state.searchTerm.subscribe(this.onSearchTermChange)
      ), () => ie.abort();
    });
    _n(this, "onSearch", (V) => {
      this.state.searchTerm.set(V.target.value);
    });
    _n(this, "clearSearch", () => {
      this.state.searchTerm.set(""), this.state.currentHit.set(-1), this.state.numHits.set(0), this.state.autoScroll.set(!0);
    });
    _n(this, "nextHit", () => {
      const V = this.state.numHits.get();
      if (V === 0) return;
      this.state.autoScroll.set(!1);
      let ie = this.state.currentHit.get() + 1;
      ie >= V && (ie = 0), this.state.currentHit.set(ie), this.highlightAndScrollToActiveHit();
    });
    _n(this, "previousHit", () => {
      const V = this.state.numHits.get();
      if (V === 0) return;
      this.state.autoScroll.set(!1);
      let ie = this.state.currentHit.get() - 1;
      ie < 0 && (ie = V - 1), this.state.currentHit.set(ie), this.highlightAndScrollToActiveHit();
    });
    _n(this, "highlightAndScrollToActiveHit", () => {
      const V = CSS.highlights.get("search-results");
      if (!V || !this.listElement) return;
      const ie = Array.from(V), ye = this.state.currentHit.get();
      if (ie.forEach((Ce) => {
        const st = Ce.startContainer.parentElement;
        st && st.removeAttribute("data-current-search-hit");
      }), ye > -1 && ye < V.size) {
        const Ce = ie[ye], st = new Highlight(Ce);
        if (CSS.highlights.set("search-results-current", st), !Ce.startContainer.parentElement) return;
        Ce.startContainer.parentElement.setAttribute(
          "data-current-search-hit",
          ""
        ), yo(
          this.listElement,
          Ce.startContainer.parentElement,
          !0
        );
      }
    });
    _n(this, "onSearchTermChange", (V) => {
      if (CSS.highlights.clear(), this.playerContext.lastSearchTerm = V, V)
        this.listElement && this.listElement.children.length > 0 ? this.highlight(V) : setTimeout(() => {
          this.highlight(V);
        }, 10);
      else return;
    });
    _n(this, "highlight", (V) => {
      if (!this.listElement)
        return;
      const ie = this.listElement.querySelectorAll("p"), ye = V.toLowerCase(), Ce = [];
      ie.forEach((Se) => {
        var E;
        const ge = (E = Se.textContent) == null ? void 0 : E.toLowerCase();
        if (!ge || !ge.includes(ye)) return;
        let R = 0;
        const te = [];
        for (; R < ge.length; ) {
          const t = ge.indexOf(ye, R);
          if (t === -1) break;
          te.push(t), R = t + ye.length;
        }
        for (const t of te) {
          const e = Se.firstChild;
          if (!e) continue;
          const m = new Range();
          m.setStart(e, t), m.setEnd(e, t + ye.length), Ce.push(m);
        }
      });
      const st = new Highlight(...Ce);
      CSS.highlights.set("search-results", st), this.state.numHits.set(st.size), this.state.currentHit.set(-1), this.nextHit();
    });
    this.state = V, this.player = ie, this.playerContext = ye;
  }
}
class zg {
  constructor(V, ie) {
    _n(this, "state");
    _n(this, "player");
    _n(this, "abortController", null);
    _n(this, "loadingManager");
    _n(this, "keyboardManager");
    _n(this, "searchManager");
    _n(this, "scrollManager");
    _n(this, "initialize", (V) => {
      var ye;
      if (!V)
        return;
      this.abortController = new AbortController();
      const ie = [];
      ie.push(this.keyboardManager.initialize(V)), ie.push(this.searchManager.initialize(V)), ie.push(this.scrollManager.initialize(V));
      for (const Ce of ie)
        (ye = this.abortController) == null || ye.signal.addEventListener("abort", Ce);
    });
    _n(this, "cleanup", () => {
      var V;
      (V = this.abortController) == null || V.abort(), this.loadingManager.cleanup();
    });
    _n(this, "onCueClick", (V) => {
      this.player.remoteControl.seek(V + 0.01);
    });
    _n(this, "enableAutoScroll", () => {
      this.scrollManager.enableAutoScroll();
    });
    _n(this, "onSearch", (V) => {
      this.searchManager.onSearch(V);
    });
    _n(this, "clearSearch", () => {
      this.searchManager.clearSearch();
    });
    _n(this, "nextHit", () => {
      this.searchManager.nextHit();
    });
    _n(this, "previousHit", () => {
      this.searchManager.previousHit();
    });
    _n(this, "handleKeyboard", (V) => {
      this.keyboardManager.handleKeyboard(V);
    });
    _n(this, "onFocus", () => {
      this.keyboardManager.onFocus();
    });
    _n(this, "onBlur", () => {
      this.keyboardManager.onBlur();
    });
    this.player = V, this.state = {
      cues: yr([]),
      activeCueIndex: yr(-1),
      autoScroll: yr(!0),
      searchTerm: yr(ie.lastSearchTerm),
      numHits: yr(0),
      currentHit: yr(-1),
      status: yr("loading")
    }, this.loadingManager = new qg(
      this.state,
      this.player
    ), this.keyboardManager = new Hg(
      this.state,
      this.player,
      ie
    ), this.searchManager = new Kg(
      this.state,
      this.player,
      ie
    ), this.scrollManager = new Yg(
      this.state,
      this.player
    );
  }
}
function Wg() {
  const B = Dr(), V = Sr(), ie = dr(
    // biome-ignore lint/style/noNonNullAssertion: player cannot be null here
    () => new zg(B, V),
    [B]
  );
  return Zr(() => () => ie.cleanup(), [ie]), ie;
}
const [Qg, Li] = Ll(
  "useRollingTranscriptContext must be used within a RollingTranscriptContextProvider"
), Qr = (B) => {
  const V = Li();
  return ya(V.state[B]);
}, Xg = "_rolling-transcript_txgzr_1", $g = "_header_txgzr_8", Jg = "_transcript-search_txgzr_16", eh = "_search-wrapper_txgzr_59", th = "_transcript-search-clear-button_txgzr_64", nh = "_transcript-search-widget_txgzr_91", rh = "_transcript-search-widget-button_txgzr_104", ih = "_transcript-list_txgzr_139", ah = "_transcript-line_txgzr_172", oh = "_auto-scroll-button_txgzr_223", kr = {
  "rolling-transcript": "_rolling-transcript_txgzr_1",
  rollingTranscript: Xg,
  header: $g,
  "transcript-search": "_transcript-search_txgzr_16",
  transcriptSearch: Jg,
  "search-wrapper": "_search-wrapper_txgzr_59",
  searchWrapper: eh,
  "transcript-search-clear-button": "_transcript-search-clear-button_txgzr_64",
  transcriptSearchClearButton: th,
  "transcript-search-widget": "_transcript-search-widget_txgzr_91",
  transcriptSearchWidget: nh,
  "transcript-search-widget-button": "_transcript-search-widget-button_txgzr_104",
  transcriptSearchWidgetButton: rh,
  "transcript-list": "_transcript-list_txgzr_139",
  transcriptList: ih,
  "transcript-line": "_transcript-line_txgzr_172",
  transcriptLine: ah,
  "auto-scroll-button": "_auto-scroll-button_txgzr_223",
  autoScrollButton: oh
}, sh = (B) => /* @__PURE__ */ rn("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: [
  /* @__PURE__ */ he("path", { d: "M12.3665 7.40676L9.56307 3.33553C9.25214 2.88398 8.74226 2.89235 8.43708 3.33553L5.63362 7.40676C5.32269 7.8583 5.51567 8.22435 6.06596 8.22435H11.9342C12.4839 8.22435 12.6717 7.84994 12.3665 7.40676Z", fill: "currentColor" }),
  /* @__PURE__ */ he("path", { d: "M5.63094 10.5932L8.4344 14.6645C8.74533 15.116 9.25522 15.1076 9.56039 14.6645L12.3638 10.5932C12.6748 10.1417 12.4818 9.77564 11.9315 9.77564L6.06328 9.77563C5.51357 9.77563 5.32577 10.15 5.63094 10.5932Z", fill: "currentColor" })
] });
function lh() {
  const B = Li(), { t: V } = On();
  return /* @__PURE__ */ he(
    "button",
    {
      tabIndex: 0,
      type: "button",
      onClick: B.enableAutoScroll,
      className: kr.autoScrollButton,
      "aria-label": V("ENABLE_AUTOSCROLL"),
      children: /* @__PURE__ */ he(sh, {})
    }
  );
}
const uh = "_rolling-transcript-kebab-menu_vp8pb_1", ch = "_rolling-transcript-kebab-menu-container_vp8pb_32", fh = "_rolling-transcript-kebab-menu-item_vp8pb_47", dh = "_rolling-transcript-kebab-arrow_vp8pb_82", ga = {
  "rolling-transcript-kebab-menu": "_rolling-transcript-kebab-menu_vp8pb_1",
  rollingTranscriptKebabMenu: uh,
  "rolling-transcript-kebab-menu-container": "_rolling-transcript-kebab-menu-container_vp8pb_32",
  rollingTranscriptKebabMenuContainer: ch,
  "rolling-transcript-kebab-menu-item": "_rolling-transcript-kebab-menu-item_vp8pb_47",
  rollingTranscriptKebabMenuItem: fh,
  "rolling-transcript-kebab-arrow": "_rolling-transcript-kebab-arrow_vp8pb_82",
  rollingTranscriptKebabArrow: dh
};
function gh({
  elements: B
}) {
  const [V, ie] = ar(!1), [ye, Ce] = ar(null), { t: st } = On(), Se = () => {
    ie(!V);
  }, ge = gr(null), R = gr([]), { refs: te, floatingStyles: E, context: t } = Oi({
    open: V,
    onOpenChange: Se,
    whileElementsMounted: Mi,
    placement: "bottom-end",
    middleware: [
      ba(),
      Sa(10),
      Aa({
        element: ge
      })
    ]
  }), e = vo(t, {
    listRef: R,
    activeIndex: ye,
    onNavigate: Ce,
    loop: !0
  }), m = Ia(t), { getReferenceProps: p, getFloatingProps: l, getItemProps: v } = wa(
    [m, e]
  ), h = dr(
    () => [...B].sort((n, f) => (n.order ?? 1) - (f.order ?? 1)),
    [B]
  );
  return /* @__PURE__ */ rn(Gr, { children: [
    /* @__PURE__ */ he(
      "button",
      {
        id: "transcript-kebab-menu-button",
        tabIndex: 0,
        type: "button",
        "aria-label": st("TRANSCRIPT_OPTIONS"),
        "aria-haspopup": "true",
        "aria-expanded": V,
        className: ga.rollingTranscriptKebabMenu,
        ref: te.setReference,
        ...p({
          onClick: Se
        }),
        children: /* @__PURE__ */ he(ml, {})
      }
    ),
    V && /* @__PURE__ */ he(Ra, { context: t, guards: !1, children: /* @__PURE__ */ rn(
      "div",
      {
        id: "transcript-kebab-menu",
        ref: te.setFloating,
        style: E,
        className: ga.rollingTranscriptKebabMenuContainer,
        role: "menu",
        "aria-labelledby": "transcript-kebab-menu-button",
        ...l(),
        children: [
          h.map(({ id: n, text: f, icon: d, onClick: S }, x) => /* @__PURE__ */ rn(
            "button",
            {
              tabIndex: ye === x ? 0 : -1,
              type: "button",
              role: "menuitem",
              className: ga.rollingTranscriptKebabMenuItem,
              ref: (G) => {
                R.current[x] = G;
              },
              ...v({
                onClick: () => {
                  S(n), ie(!1);
                }
              }),
              children: [
                So(d) ? d : Ao[d],
                f
              ]
            },
            n
          )),
          /* @__PURE__ */ he(
            Ca,
            {
              ref: ge,
              context: t,
              className: ga.rollingTranscriptKebabArrow
            }
          )
        ]
      }
    ) })
  ] });
}
const hh = (B) => /* @__PURE__ */ he("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 0C3.58871 0 0 3.58871 0 8C0 12.4113 3.58871 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58871 12.4113 0 8 0ZM8 15.0588C4.10729 15.0588 0.941174 11.8927 0.941174 8C0.941174 4.1073 4.10729 0.941177 8 0.941177C11.8927 0.941177 15.0588 4.1073 15.0588 8C15.0588 11.8927 11.8927 15.0588 8 15.0588ZM10.6622 4.67238L7.99961 7.33496L5.33796 4.67238L4.67255 5.33779L7.3342 8.00038L4.67255 10.662L5.33796 11.3274L7.99961 8.66579L10.6622 11.3274L11.3276 10.662L8.66502 8.00038L11.3276 5.33779L10.6622 4.67238Z", fill: "currentColor" }) }), mh = (B) => /* @__PURE__ */ he("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.64531 12.3413C3.50398 12.3413 0.949332 9.78664 0.949332 6.64531C0.949332 3.50398 3.50398 0.949331 6.64531 0.949331C9.78664 0.949331 12.3413 3.50398 12.3413 6.64531C12.3413 9.78664 9.78664 12.3413 6.64531 12.3413ZM11.6616 10.9904C12.6735 9.82461 13.2906 8.30663 13.2906 6.64531C13.2906 2.98184 10.3088 0 6.64531 0C2.98184 0 0 2.98184 0 6.64531C0 10.3088 2.98184 13.2906 6.64531 13.2906C8.30663 13.2906 9.82461 12.6735 10.9904 11.6616L15.3279 16L16 15.3279L11.6616 10.9904Z", fill: "currentColor" }) });
function ph() {
  const B = Li(), V = Qr("searchTerm"), { t: ie } = On(), ye = Un((st) => st.preventDefault(), []), Ce = Un(
    (st) => {
      st.key === "Escape" ? B.clearSearch() : st.key === "Enter" && !st.shiftKey && (st.preventDefault(), B.nextHit());
    },
    [B]
  );
  return /* @__PURE__ */ rn("form", { className: kr.transcriptSearch, onSubmit: ye, children: [
    /* @__PURE__ */ he(mh, { "aria-hidden": "true" }),
    /* @__PURE__ */ he(
      "input",
      {
        id: "transcript-search",
        type: "text",
        placeholder: ie("SEARCH_TRANSCRIPT_PLACEHOLDER"),
        onChange: B.onSearch,
        value: V,
        onKeyDown: Ce
      }
    ),
    V.length > 0 ? /* @__PURE__ */ he(
      "button",
      {
        type: "button",
        "aria-label": ie("CLEAR_SEARCH"),
        onClick: B.clearSearch,
        className: kr.transcriptSearchClearButton,
        children: /* @__PURE__ */ he(hh, {})
      }
    ) : null
  ] });
}
const yh = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.03704 5L9 10.963L14.963 5L16 6.03704L9 13.037L2 6.03704L3.03704 5Z", fill: "currentColor" }) }), _h = (B) => /* @__PURE__ */ he("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.03704 13.037L2 12L9 5L16 12L14.963 13.037L9 7.07407L3.03704 13.037Z", fill: "currentColor" }) });
function Eh() {
  const B = Li(), V = Qr("searchTerm"), ie = Qr("numHits"), ye = Qr("currentHit"), { t: Ce } = On();
  return V.length > 0 ? /* @__PURE__ */ rn("div", { className: kr.transcriptSearchWidget, children: [
    /* @__PURE__ */ rn("output", { children: [
      ye + 1,
      "/",
      ie
    ] }),
    /* @__PURE__ */ he(
      "button",
      {
        type: "button",
        className: kr.transcriptSearchWidgetButton,
        "aria-label": Ce("PREVIOUS_HIT"),
        onClick: B.previousHit,
        disabled: ie === 0,
        children: /* @__PURE__ */ he(_h, {})
      }
    ),
    /* @__PURE__ */ he(
      "button",
      {
        type: "button",
        className: kr.transcriptSearchWidgetButton,
        "aria-label": Ce("NEXT_HIT"),
        onClick: B.nextHit,
        disabled: ie === 0,
        children: /* @__PURE__ */ he(yh, {})
      }
    )
  ] }) : null;
}
const vh = Cc(function({
  timestamp: V,
  text: ie,
  active: ye,
  onClick: Ce
}) {
  const st = Un(() => {
    Ce(V);
  }, [Ce, V]);
  return /* @__PURE__ */ rn(
    "button",
    {
      tabIndex: -1,
      className: kr.transcriptLine,
      type: "button",
      onClick: st,
      "aria-current": ye ? "true" : void 0,
      children: [
        /* @__PURE__ */ he("span", { children: ma(V) }),
        /* @__PURE__ */ he("p", { children: ie })
      ]
    }
  );
});
function Th() {
  const B = Li(), V = Xn(), ie = Qr("cues"), ye = Qr("autoScroll"), Ce = Qr("activeCueIndex"), st = Qr("status"), Se = V.transcriptMenuElements ?? [], ge = Se.length > 0;
  return st === "loading" ? null : st === "empty" ? V.emptyTranscriptsComponent : /* @__PURE__ */ rn(Gr, { children: [
    /* @__PURE__ */ rn("header", { className: kr.header, children: [
      /* @__PURE__ */ rn("div", { className: kr.searchWrapper, children: [
        /* @__PURE__ */ he(ph, {}),
        ge && /* @__PURE__ */ he(gh, { elements: Se })
      ] }),
      /* @__PURE__ */ he(Eh, {})
    ] }),
    /* @__PURE__ */ he(
      "ul",
      {
        className: kr.transcriptList,
        ref: B.initialize,
        onKeyDown: B.handleKeyboard,
        onFocus: B.onFocus,
        onBlur: B.onBlur,
        children: ie.map((R, te) => /* @__PURE__ */ he("li", { children: /* @__PURE__ */ he(
          vh,
          {
            onClick: B.onCueClick,
            timestamp: R.startTime,
            text: R.text,
            active: Ce === te
          }
        ) }, `${R.startTime}-${R.endTime}-${te}`))
      }
    ),
    ye ? null : /* @__PURE__ */ he(lh, {})
  ] });
}
function xl() {
  const B = Wg();
  return /* @__PURE__ */ he(Qg, { value: B, children: /* @__PURE__ */ he("section", { className: kr.rollingTranscript, children: /* @__PURE__ */ he(Th, {}) }) });
}
function bh({
  element: B
}) {
  const [V, ie] = ar();
  return Nc(() => {
    const ye = typeof B == "string" ? document.getElementById(B) : B;
    ie(ye);
  }, [B]), V ? Yc.createPortal(/* @__PURE__ */ he(xl, {}), V) : null;
}
const Sh = "_studio-player-sidebar_1fcpy_1", Ah = {
  "studio-player-sidebar": "_studio-player-sidebar_1fcpy_1",
  studioPlayerSidebar: Sh
};
function Ih(B) {
  return [
    {
      id: "transcript",
      label: "Transcript",
      Component: /* @__PURE__ */ he(xl, {})
    }
  ].concat(B).sort((ie, ye) => (ie.order ?? 1) - (ye.order ?? 1));
}
function wh() {
  var Se;
  const { enableSidebar: B, tabs: V } = Xn(), ie = lr("sidebarOpen"), ye = gr(((Se = V.find((ge) => ge.default)) == null ? void 0 : Se.id) ?? "transcript"), Ce = Un((ge) => {
    ye.current = ge;
  }, []), st = dr(() => Ih(V), [V]);
  return B && ie ? /* @__PURE__ */ he("aside", { className: Ah.studioPlayerSidebar, "data-testid": "sidebar", children: /* @__PURE__ */ rn(oi, { defaultValue: ye.current, onTabChange: Ce, children: [
    /* @__PURE__ */ he(oi.List, { children: st.map((ge) => /* @__PURE__ */ he(oi.Tab, { value: ge.id, children: ge.label }, ge.id)) }),
    st.map(({ id: ge, Component: R }) => /* @__PURE__ */ he(oi.Panel, { value: ge, children: R }, ge))
  ] }) }) : null;
}
const Rh = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM17.3333 21.3333H21.3333V2.66667H17.3333V21.3333ZM14.6667 21.3333V2.66667H2.66667V21.3333H14.6667Z", fill: "currentColor" }) }), Ch = (B) => /* @__PURE__ */ he("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("path", { d: "M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM14.6667 21.3333V2.66667H2.66667V21.3333H14.6667Z", fill: "currentColor" }) });
function Nh() {
  const B = lr("sidebarOpen"), V = Sr(), { t: ie } = On();
  return /* @__PURE__ */ he(
    "button",
    {
      type: "button",
      className: "controls-button",
      onClick: () => {
        V.sidebarOpen.set(!B);
      },
      "aria-label": ie(B ? "SIDEBAR_CLOSE" : "SIDEBAR_OPEN"),
      "aria-pressed": B ? "true" : "false",
      children: B ? /* @__PURE__ */ he(Ch, { className: "controls-button-icon" }) : /* @__PURE__ */ he(Rh, { className: "controls-button-icon" })
    }
  );
}
const Dh = "_small-layout-overlay_cmaq3_1", Oh = "_small-layout-button_cmaq3_14", Mh = "_small-layout-icon-play_cmaq3_24", Lh = "_small-layout-icon-pause_cmaq3_30", Ph = "_small-layout-timestamp_cmaq3_36", xh = "_full-screen-close-icon_cmaq3_49", Fh = "_fade-out_cmaq3_1", vi = {
  "small-layout-overlay": "_small-layout-overlay_cmaq3_1",
  smallLayoutOverlay: Dh,
  "small-layout-button": "_small-layout-button_cmaq3_14",
  smallLayoutButton: Oh,
  "small-layout-icon-play": "_small-layout-icon-play_cmaq3_24",
  smallLayoutIconPlay: Mh,
  "small-layout-icon-pause": "_small-layout-icon-pause_cmaq3_30",
  smallLayoutIconPause: Lh,
  "small-layout-timestamp": "_small-layout-timestamp_cmaq3_36",
  smallLayoutTimestamp: Ph,
  "full-screen-close-icon": "_full-screen-close-icon_cmaq3_49",
  fullScreenCloseIcon: xh,
  "fade-out": "_fade-out_cmaq3_1",
  fadeOut: Fh
};
function Fl() {
  const B = Kn("paused");
  return /* @__PURE__ */ rn(
    "div",
    {
      className: vi.smallLayoutOverlay,
      "data-testid": "small-layout-overlay",
      children: [
        /* @__PURE__ */ he(Kc, { className: vi.fullScreenCloseIcon, children: /* @__PURE__ */ he(yl, {}) }),
        /* @__PURE__ */ he("i", { className: vi.smallLayoutButton, children: B ? /* @__PURE__ */ he(Co, { className: vi.smallLayoutIconPlay }) : /* @__PURE__ */ he(Ro, { className: vi.smallLayoutIconPause }) }),
        /* @__PURE__ */ rn("div", { className: vi.smallLayoutTimestamp, children: [
          /* @__PURE__ */ he(pa, { type: "current" }),
          "/",
          /* @__PURE__ */ he(pa, { type: "duration" })
        ] })
      ]
    }
  );
}
const [kh, Do] = Ll(
  "useTabsContext must be used within a TabsProvider"
), Zh = "_tabs_1tdj4_17", Bh = "_tabs-list_1tdj4_24", Uh = "_tabs-tab_1tdj4_31", Gh = "_appear_1tdj4_1", Hh = "_tabs-panel_1tdj4_80", qh = "_fade-in_1tdj4_1", Da = {
  tabs: Zh,
  "tabs-list": "_tabs-list_1tdj4_24",
  tabsList: Bh,
  "tabs-tab": "_tabs-tab_1tdj4_31",
  tabsTab: Uh,
  appear: Gh,
  "tabs-panel": "_tabs-panel_1tdj4_80",
  tabsPanel: Hh,
  "fade-in": "_fade-in_1tdj4_1",
  fadeIn: qh
};
function Vh() {
  const { setActiveTab: B } = Do(), V = gr(null);
  return Zr(() => {
    if (!V.current)
      return () => {
      };
    const ie = V.current, ye = new AbortController();
    return ie.addEventListener(
      "keydown",
      (Ce) => {
        if (Ce.key === "ArrowRight") {
          Ce.preventDefault(), Ce.stopPropagation();
          const st = Array.from(ie.children).findIndex(
            (ge) => ge.getAttribute("aria-selected") === "true"
          ), Se = st + 1 < ie.children.length ? ie.children[st + 1] : ie.children[0];
          Se != null && Se.dataset.value && (B(Se.dataset.value), Se.focus());
        } else if (Ce.key === "ArrowLeft") {
          Ce.preventDefault(), Ce.stopPropagation();
          const st = Array.from(ie.children).findIndex(
            (ge) => ge.getAttribute("aria-selected") === "true"
          ), Se = st - 1 >= 0 ? ie.children[st - 1] : ie.children[ie.children.length - 1];
          Se != null && Se.dataset.value && (B(Se.dataset.value), Se.focus());
        }
      },
      {
        signal: ye.signal
      }
    ), () => {
      ye.abort();
    };
  }, [B]), V;
}
function jh({ children: B }) {
  const V = Vh();
  return /* @__PURE__ */ he(
    "div",
    {
      ref: V,
      role: "tablist",
      "aria-orientation": "horizontal",
      className: Da.tabsList,
      children: B
    }
  );
}
function Yh({
  value: B,
  keepMounted: V = !1,
  children: ie
}) {
  const { activeTab: ye, getPanelId: Ce, getTabId: st } = Do();
  return /* @__PURE__ */ he(
    "div",
    {
      role: "tabpanel",
      id: Ce(B),
      "aria-labelledby": st(B),
      hidden: ye !== B,
      className: Da.tabsPanel,
      children: V || ye === B ? ie : null
    }
  );
}
function Kh({ value: B, children: V }) {
  const { activeTab: ie, setActiveTab: ye, getTabId: Ce, getPanelId: st } = Do(), Se = ie === B;
  return /* @__PURE__ */ he(
    "button",
    {
      type: "button",
      role: "tab",
      tabIndex: Se ? 0 : -1,
      "aria-selected": Se,
      "aria-controls": st(B),
      id: Ce(B),
      "data-value": B,
      className: Da.tabsTab,
      onClick: () => ye(B),
      children: V
    }
  );
}
function oi({
  defaultValue: B,
  onTabChange: V,
  children: ie
}) {
  const ye = Dc(), [Ce, st] = ar(B ?? null), Se = Un(
    (te) => {
      st(te), V == null || V(te);
    },
    [V]
  ), ge = Un(
    (te) => `${te}-panel-${ye}`,
    [ye]
  ), R = Un(
    (te) => `${te}-tab-${ye}`,
    [ye]
  );
  return /* @__PURE__ */ he(
    kh,
    {
      value: {
        activeTab: Ce,
        setActiveTab: Se,
        getTabId: R,
        getPanelId: ge
      },
      children: /* @__PURE__ */ he("div", { className: Da.tabs, children: ie })
    }
  );
}
oi.List = jh;
oi.Tab = Kh;
oi.Panel = Yh;
const zh = "_time-indicator_1eqqx_1", Wh = {
  "time-indicator": "_time-indicator_1eqqx_1",
  timeIndicator: zh
};
function Qh() {
  return /* @__PURE__ */ rn("div", { className: Wh.timeIndicator, children: [
    /* @__PURE__ */ he(pa, { type: "current" }),
    "/",
    /* @__PURE__ */ he(pa, { type: "duration" })
  ] });
}
const Xh = "_comment-markers_hps13_1", $h = "_comment-marker_hps13_1", Jh = "_timeline-wrapper_hps13_19", em = "_timeline-wrapper-compact_hps13_20", tm = "_track_hps13_48", nm = "_thumb_hps13_61", rm = "_root_hps13_75", im = "_track-inner_hps13_105", am = "_progress_hps13_111", om = "_track-fill_hps13_117", sm = "_pins_hps13_123", lm = "_pin-button_hps13_132", um = "_annotation-pin_hps13_158", cm = "_quiz-pin_hps13_167", fm = "_annotation-pin-child_hps13_176", dm = "_quiz-pin-child_hps13_180", gm = "_interactive-pin-container_hps13_185", hm = "_interactive-pin-wrapper_hps13_192", mm = "_interactive-pin-icon_hps13_198", pm = "_interactive-pin_hps13_185", ym = "_bg_hps13_212", _m = "_symbol_hps13_216", Em = "_interactive-pin-button_hps13_221", vm = "_interactive-pin-menu_hps13_250", Tm = "_interactive-pin-menu-item_hps13_271", bm = "_arrow_hps13_296", Sm = "_tooltip_hps13_300", Am = "_tooltip-arrow_hps13_309", Pn = {
  "comment-markers": "_comment-markers_hps13_1",
  commentMarkers: Xh,
  "comment-marker": "_comment-marker_hps13_1",
  commentMarker: $h,
  "timeline-wrapper": "_timeline-wrapper_hps13_19",
  timelineWrapper: Jh,
  "timeline-wrapper-compact": "_timeline-wrapper-compact_hps13_20",
  timelineWrapperCompact: em,
  track: tm,
  thumb: nm,
  root: rm,
  "track-inner": "_track-inner_hps13_105",
  trackInner: im,
  progress: am,
  "track-fill": "_track-fill_hps13_117",
  trackFill: om,
  pins: sm,
  "pin-button": "_pin-button_hps13_132",
  pinButton: lm,
  "annotation-pin": "_annotation-pin_hps13_158",
  annotationPin: um,
  "quiz-pin": "_quiz-pin_hps13_167",
  quizPin: cm,
  "annotation-pin-child": "_annotation-pin-child_hps13_176",
  annotationPinChild: fm,
  "quiz-pin-child": "_quiz-pin-child_hps13_180",
  quizPinChild: dm,
  "interactive-pin-container": "_interactive-pin-container_hps13_185",
  interactivePinContainer: gm,
  "interactive-pin-wrapper": "_interactive-pin-wrapper_hps13_192",
  interactivePinWrapper: hm,
  "interactive-pin-icon": "_interactive-pin-icon_hps13_198",
  interactivePinIcon: mm,
  "interactive-pin": "_interactive-pin_hps13_185",
  interactivePin: pm,
  bg: ym,
  symbol: _m,
  "interactive-pin-button": "_interactive-pin-button_hps13_221",
  interactivePinButton: Em,
  "interactive-pin-menu": "_interactive-pin-menu_hps13_250",
  interactivePinMenu: vm,
  "interactive-pin-menu-item": "_interactive-pin-menu-item_hps13_271",
  interactivePinMenuItem: Tm,
  arrow: bm,
  tooltip: Sm,
  "tooltip-arrow": "_tooltip-arrow_hps13_309",
  tooltipArrow: Am
};
function nl() {
  const B = Kn("duration"), V = Xn(), ie = lr("commentsEnabled");
  return B > 0 && V.hasComments && ie ? /* @__PURE__ */ he("div", { className: Pn.commentMarkers, children: V.comments.map((ye) => /* @__PURE__ */ he(
    "span",
    {
      className: Pn.commentMarker,
      style: {
        left: `${ye.timestamp / B * 100}%`
      }
    },
    ye.id
  )) }) : null;
}
const Im = Oc(function({ currentTime: V, position: ie }, ye) {
  const [Ce, st] = ar(!1), [Se, ge] = ar(null), R = Xn(), te = Sr(), E = Un(() => {
    R.interactiveMenuElements.length > 0 ? st((P) => (te.globalKeysDisabled.set(!P), !P)) : R.onInteractivePinClick(V);
  }, [
    R.interactiveMenuElements,
    R.onInteractivePinClick,
    V
  ]), t = gr(null), { refs: e, floatingStyles: m, context: p } = Oi({
    open: Ce,
    onOpenChange: E,
    whileElementsMounted: Mi,
    placement: "top",
    middleware: [
      ba(),
      Sa(6),
      Aa({
        element: t
      })
    ]
  }), l = gr([]), v = Ia(p), h = vo(p, {
    listRef: l,
    activeIndex: Se,
    onNavigate: ge,
    loop: !0,
    openOnArrowKeyDown: !1
  }), { getReferenceProps: n, getFloatingProps: f, getItemProps: d } = wa(
    [v, h]
  ), S = Eo([e.setReference, ye]), { t: x } = On(), G = ma(V);
  return /* @__PURE__ */ rn(Gr, { children: [
    /* @__PURE__ */ he(
      "button",
      {
        id: "interactive-pin",
        "data-interactive-pin": "",
        type: "button",
        "aria-label": R.interactiveMenuElements.length > 0 ? x("ADD_QUESTION_AT", { time: G }) : x("ADD_ANNOTATION_AT", { time: G }),
        "aria-haspopup": R.interactiveMenuElements.length > 0 ? "true" : void 0,
        className: Pn.interactivePinButton,
        ref: S,
        style: { left: `${ie}%` },
        ...n({
          onClick: E
        }),
        children: /* @__PURE__ */ rn(
          "svg",
          {
            className: Pn.interactivePin,
            width: "36",
            height: "44",
            fill: "none",
            viewBox: "0 0 36 44",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ he(
                "path",
                {
                  className: Pn.bg,
                  d: "M 33.1703,27.499961 C 34.9615,24.721661 36,21.418761 36,17.874961 36,8.0028612 27.9411,-3.8819277e-5 18,-3.8819277e-5 8.0588999,-3.8819277e-5 -1.5e-7,8.0028612 -1.5e-7,17.874961 c 0,3.5438 1.03844995,6.8467 2.82964995,9.625 4.5447501,6.8094 10.1600502,10.1014 15.2487502,16.5 5.0364,-6.3985 10.5573,-9.7259 15.0919,-16.5 z"
                }
              ),
              /* @__PURE__ */ he(
                "path",
                {
                  className: Pn.symbol,
                  d: "m 35.499961,17.877772 c 0,3.443549 -1.008198,6.652061 -2.747494,9.351891 -2.235095,3.338633 -4.71529,5.832631 -7.286584,8.306425 -0.277599,0.267143 -0.556499,0.534085 -0.836198,0.801928 -2.174595,2.082232 -4.40389,4.216673 -6.553385,6.870196 -2.158995,-2.636621 -4.40379,-4.754859 -6.591985,-6.819788 -0.2979,-0.281145 -0.594699,-0.561289 -0.890198,-0.841534 C 7.9918219,33.077896 5.4869279,30.584698 3.2477829,27.230063 1.5082968,24.530133 0.50003905,21.321521 0.50003905,17.877772 0.50003905,8.2835422 8.3317219,0.50000048 18,0.50000048 c 9.668278,0 17.499961,7.78354172 17.499961,17.37777152 z"
                }
              ),
              /* @__PURE__ */ he(
                "path",
                {
                  className: Pn.interactivePinIcon,
                  "data-open": Ce,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "m 18.75,17.388467 v -6.25 h -1.5 v 6.25 H 11 v 1.5 h 6.25 v 6.25 h 1.5 v -6.25 H 25 v -1.5 z",
                  fill: "white"
                }
              )
            ]
          }
        )
      }
    ),
    Ce && /* @__PURE__ */ he(Ra, { context: p, initialFocus: -1, modal: !0, children: /* @__PURE__ */ rn(
      "div",
      {
        ref: e.setFloating,
        style: m,
        className: Pn.interactivePinMenu,
        ...f(),
        children: [
          R.interactiveMenuElements.map(
            ({ id: P, text: J, onClick: M }, W) => /* @__PURE__ */ rn(
              "button",
              {
                type: "button",
                className: Pn.interactivePinMenuItem,
                ref: (se) => {
                  l.current[W] = se;
                },
                tabIndex: Se === W ? 0 : -1,
                ...d({
                  onClick: () => {
                    M(P, V), st(!1), te.globalKeysDisabled.set(!1);
                  }
                }),
                children: [
                  /* @__PURE__ */ he(
                    "svg",
                    {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: /* @__PURE__ */ he(
                        "path",
                        {
                          fillRule: "evenodd",
                          clipRule: "evenodd",
                          d: "M7.33339 7.33339H1.77783V8.66672H7.33339V14.2223H8.66672V8.66672H14.2223V7.33339H8.66672V1.77783H7.33339V7.33339Z",
                          fill: "currentColor"
                        }
                      )
                    }
                  ),
                  J
                ]
              },
              P
            )
          ),
          /* @__PURE__ */ he(
            Ca,
            {
              ref: t,
              context: p,
              className: Pn.arrow
            }
          )
        ]
      }
    ) })
  ] });
}), wm = () => {
  const B = gr(!1), V = gr(!1), ie = dr(
    () => ({
      ArrowLeft: () => {
        V.current = !0;
      },
      ArrowRight: () => {
        V.current = !0;
      },
      Tab: () => {
        V.current = !1;
      }
    }),
    []
  );
  return Io(ie), { focusCallback: Un((Ce) => {
    Ce && (Ce.addEventListener("focus", () => {
      B.current = !0;
    }), Ce.addEventListener("blur", () => {
      V.current || (B.current = !1);
    }), B.current && Ce.focus());
  }, []), wasPinFocused: B.current };
};
function Rm() {
  var ge;
  const B = Kn("duration"), V = Kn("currentTime"), ie = V / B * 100, { disableInteractivePinRanges: ye } = Xn(), Ce = !ye.some(
    ([R, te]) => V >= R && V <= te
  ), { wasPinFocused: st, focusCallback: Se } = wm();
  return Ce ? /* @__PURE__ */ he("div", { className: Pn.interactivePinContainer, children: /* @__PURE__ */ he("div", { className: Pn.interactivePinWrapper, children: /* @__PURE__ */ he(
    Im,
    {
      ref: Se,
      currentTime: V,
      position: ie
    }
  ) }) }) : (st && ((ge = document.querySelector("[data-media-time-slider]")) == null || ge.focus()), null);
}
function Cm() {
  const B = Kn("paused"), V = lr("interactionsDisabled");
  return B && !V ? /* @__PURE__ */ he(Rm, {}) : null;
}
const Nm = {
  annotation: Pn.annotationPin,
  quiz: Pn.quizPin
}, Dm = (B, V, ie, ye = !1) => V === "annotation" ? B("OPEN_ANNOTATION_AT", { time: ma(ie) }) : V === "quiz" ? B(ye ? "OPEN_COMPLETED_QUIZ_AT" : "OPEN_QUIZ_AT", {
  time: ma(ie)
}) : "";
function kl({
  type: B,
  position: V,
  children: ie,
  onClick: ye,
  id: Ce,
  time: st,
  completed: Se
}) {
  const { t: ge } = On();
  return /* @__PURE__ */ he(
    "button",
    {
      type: "button",
      className: Pn.pinButton,
      style: { left: `${V}%` },
      onClick: ye,
      "data-marker-id": Ce,
      "aria-label": Dm(ge, B, st, Se),
      children: /* @__PURE__ */ rn(
        "svg",
        {
          className: Nm[B],
          width: "26",
          height: "32",
          viewBox: "0 0 26 32",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ he("path", { d: "M25.5 13C25.5 15.4774 24.7798 17.785 23.5376 19.7268C21.932 22.1411 20.1501 23.9459 18.2945 25.7433C18.0942 25.9373 17.8929 26.1314 17.6908 26.3262C16.157 27.8047 14.5793 29.3256 13.0545 31.2007C11.5227 29.3377 9.93394 27.8282 8.39067 26.362C8.17552 26.1576 7.96126 25.954 7.74816 25.7505C5.87029 23.9566 4.07076 22.1526 2.46259 19.7271C1.22024 17.7852 0.5 15.4775 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5C19.9036 0.5 25.5 6.09644 25.5 13Z" }),
            ie
          ]
        }
      )
    }
  );
}
function Om(B) {
  return /* @__PURE__ */ he(kl, { type: "annotation", ...B, children: /* @__PURE__ */ he(
    "path",
    {
      className: Pn.annotationPinChild,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 8V19.25H8.875V18.875C8.875 17.8415 9.7165 17 10.75 17H19V8H7ZM10 11.75H16V11H10V11.75ZM14.5 14H10V13.25H14.5V14Z",
      fill: "currentColor",
      stroke: "none"
    }
  ) });
}
function Mm(B) {
  const V = B.completed ? /* @__PURE__ */ he(
    "path",
    {
      className: Pn.quizPinChild,
      transform: "translate(6, 6)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7156 2.33212L5.18253 9.86522L1.28337 5.96607L0 7.24944L5.18253 12.4329L13.9999 3.6164L12.7156 2.33212Z",
      fill: "currentColor",
      "data-completed": "true"
    }
  ) : /* @__PURE__ */ he(
    "text",
    {
      className: Pn.quizPinChild,
      x: "50%",
      y: "56%",
      textAnchor: "middle",
      fill: "currentColor",
      stroke: "none",
      children: B.ordinal
    }
  );
  return /* @__PURE__ */ he(kl, { type: "quiz", ...B, children: B.multiple ? /* @__PURE__ */ he("circle", { className: Pn.quizPinChild, cx: "13", cy: "13", r: "6" }) : V });
}
function Lm(B, V) {
  return B.map((ie, ye) => ({
    id: ie.id,
    time: ie.time,
    type: "annotation",
    ordinal: ye + 1,
    onClick: () => V(ie)
  }));
}
function Pm(B, V) {
  const ie = /* @__PURE__ */ new Map();
  B.forEach((st) => {
    var ge;
    const Se = st.time;
    ie.has(Se) || ie.set(Se, []), (ge = ie.get(Se)) == null || ge.push(st);
  });
  const ye = [];
  let Ce = 0;
  return ie.forEach((st, Se) => {
    ye.push({
      id: st.map((ge) => ge.id).join("-"),
      time: Se,
      type: "quiz",
      ordinal: Ce + 1,
      onClick: () => V(st),
      multiple: st.length > 1,
      completed: st.every((ge) => ge.completed)
    }), Ce++;
  }), ye;
}
function xm(B, V, ie, ye) {
  switch (B.type) {
    case "annotation": {
      const Ce = () => ye ? B.onClick() : ie.seek(B.time);
      return /* @__PURE__ */ he(
        Om,
        {
          id: B.id,
          position: B.time / V * 100,
          onClick: Ce,
          time: B.time
        },
        B.id
      );
    }
    case "quiz":
      return /* @__PURE__ */ he(
        Mm,
        {
          id: B.id,
          position: B.time / V * 100,
          ordinal: B.ordinal,
          multiple: B.multiple,
          onClick: B.onClick,
          completed: B.completed,
          time: B.time
        },
        B.id
      );
    default:
      return null;
  }
}
function Fm() {
  const B = Ta(), V = Kn("duration"), ie = Xn(), ye = dr(() => [
    ...Lm(
      ie.annotations,
      ie.onAnnotationClick
    ),
    ...ie.hideQuizMarkers ? [] : Pm(
      ie.quizMarkers,
      ie.onQuizMarkerClick
    )
  ].sort((st, Se) => st.time - Se.time).map((st) => xm(st, V, B, ie.interactive)), [ie.annotations, ie.quizMarkers, V, B]);
  return ie.interactive || ye.length > 0 ? /* @__PURE__ */ he("div", { className: Pn.pins, "data-pins": "", children: ye }) : null;
}
const km = {
  normal: Pn.timelineWrapper,
  compact: Pn.timelineWrapperCompact
};
function rl({
  layout: B,
  children: V
}) {
  const [ie, ye] = ar(!1), Ce = Un(() => ye(!0), []), st = Un(() => ye(!1), []), Se = gr(null), { refs: ge, floatingStyles: R, context: te } = Oi({
    open: ie,
    onOpenChange: ye,
    whileElementsMounted: (E, t, e) => Mi(E, t, e, {
      animationFrame: !0
    }),
    placement: "top",
    middleware: [
      ba(),
      Sa(18),
      Aa({
        element: Se
      })
    ]
  });
  return /* @__PURE__ */ rn("div", { className: km[B], children: [
    V,
    /* @__PURE__ */ rn(
      zc,
      {
        className: Pn.root,
        onDragStart: Ce,
        onDragEnd: st,
        children: [
          /* @__PURE__ */ rn(sl, { className: Pn.track, children: [
            /* @__PURE__ */ he(
              Wc,
              {
                className: _a(Pn.progress, Pn.trackInner)
              }
            ),
            /* @__PURE__ */ he(
              ll,
              {
                className: _a(Pn.trackFill, Pn.trackInner)
              }
            )
          ] }),
          /* @__PURE__ */ he(ul, { className: Pn.thumb, ref: ge.setReference }),
          ie ? /* @__PURE__ */ rn(
            "div",
            {
              role: "tooltip",
              ref: ge.setFloating,
              style: R,
              className: Pn.tooltip,
              children: [
                /* @__PURE__ */ he(Qc, {}),
                /* @__PURE__ */ he(
                  Ca,
                  {
                    ref: Se,
                    context: te,
                    className: Pn.tooltipArrow,
                    width: 20,
                    height: 10
                  }
                )
              ]
            }
          ) : null
        ]
      }
    )
  ] });
}
const Zm = "_wrapper_3m1px_1", Bm = "_track_3m1px_6", Um = "_thumb_3m1px_18", Gm = "_track-fill_3m1px_32", Hm = "_root_3m1px_39", Di = {
  wrapper: Zm,
  track: Bm,
  thumb: Um,
  "track-fill": "_track-fill_3m1px_32",
  trackFill: Gm,
  root: Hm
};
function qm() {
  const B = Dr(), V = Kn("volume"), ye = Kn("muted") || V === 0, { t: Ce } = On();
  return /* @__PURE__ */ rn("div", { className: Di.wrapper, children: [
    /* @__PURE__ */ he(
      "button",
      {
        type: "button",
        className: "controls-button",
        "aria-label": Ce(ye ? "VOLUME" : "MUTE"),
        onClick: () => {
          ye ? B == null || B.remoteControl.unmute() : B == null || B.remoteControl.mute();
        },
        children: ye ? /* @__PURE__ */ he(Cl, { className: "controls-button-icon" }) : V < 0.5 ? /* @__PURE__ */ he(Dl, { className: "controls-button-icon" }) : /* @__PURE__ */ he(Nl, { className: "controls-button-icon" })
      }
    ),
    /* @__PURE__ */ rn(Xc, { className: Di.root, children: [
      /* @__PURE__ */ he(sl, { className: Di.track, children: /* @__PURE__ */ he(ll, { className: Di.trackFill }) }),
      /* @__PURE__ */ he(ul, { className: Di.thumb })
    ] })
  ] });
}
function Vm() {
  const B = Dr(), V = Xn();
  Zr(() => {
    const ie = () => {
      const ye = V.startAt;
      B && V.disableStorage && _o(ye) && (B.remoteControl.seek(ye), B.$state.started.set(!0));
    };
    return B == null || B.addEventListener("loaded-metadata", ie), () => {
      B == null || B.removeEventListener("loaded-metadata", ie);
    };
  }, [B]);
}
const jm = "_root_wcehe_1", Ym = "_normal_wcehe_22", Km = "_compact_wcehe_33", zm = "_left-controls_wcehe_65", Wm = "_right-controls_wcehe_74", Qm = "_indicators_wcehe_83", Ti = {
  root: jm,
  normal: Ym,
  compact: Km,
  "left-controls": "_left-controls_wcehe_65",
  leftControls: zm,
  "right-controls": "_right-controls_wcehe_74",
  rightControls: Wm,
  indicators: Qm
};
function Xm({
  darkMode: B,
  playerRef: V,
  controlsLayout: ie,
  disableCaptionSettings: ye
}) {
  const Ce = Dr(), { hasAnnotations: st, hasQuizmarkers: Se, interactive: ge, enableSidebar: R } = Xn(), te = lr("interactionsDisabled");
  return Vm(), Zr(() => {
    const E = new AbortController();
    return Ce && (Ce.remoteControl.pauseControls(), Ce.addEventListener(
      "fullscreenchange",
      () => {
        requestAnimationFrame(() => {
          Ce.$state.fullscreen() ? Ce.remoteControl.resumeControls() : Ce.remoteControl.pauseControls();
        });
      },
      { signal: E.signal }
    ), V && (typeof V == "function" ? V(Ce) : V.current = Ce)), () => {
      E.abort();
    };
  }, [Ce, V]), /* @__PURE__ */ rn(
    "div",
    {
      "data-darkmode": B,
      "data-testid": "controls-layout",
      "data-controls-layout": ie,
      className: _a(Ti.root, {
        [Ti.normal]: ie === "normal",
        [Ti.compact]: ie === "compact"
      }),
      inert: te ? "true" : void 0,
      children: [
        ie === "normal" ? /* @__PURE__ */ rn(rl, { layout: "normal", children: [
          ge || st || Se ? /* @__PURE__ */ he(Fm, {}) : null,
          ge ? /* @__PURE__ */ he(Cm, {}) : null,
          /* @__PURE__ */ he(nl, {})
        ] }) : null,
        /* @__PURE__ */ rn("div", { className: Ti.leftControls, children: [
          /* @__PURE__ */ he(kg, {}),
          /* @__PURE__ */ he(qm, {})
        ] }),
        /* @__PURE__ */ he("div", { className: Ti.indicators, children: /* @__PURE__ */ he(Qh, {}) }),
        ie === "compact" ? /* @__PURE__ */ he(rl, { layout: "compact", children: /* @__PURE__ */ he(nl, {}) }) : null,
        /* @__PURE__ */ rn("div", { className: Ti.rightControls, children: [
          !ye && /* @__PURE__ */ he(Qf, {}),
          R && /* @__PURE__ */ he(Nh, {}),
          /* @__PURE__ */ he(hg, {}),
          /* @__PURE__ */ he(Ng, {})
        ] })
      ]
    }
  );
}
const $m = (B) => /* @__PURE__ */ he("svg", { width: 56, height: 72, viewBox: "0 0 28 36", xmlns: "http://www.w3.org/2000/svg", ...B, children: /* @__PURE__ */ he("g", { id: "Icons", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ rn("g", { id: "audio", children: [
  /* @__PURE__ */ rn("g", { id: "icon-file-base-2", children: [
    /* @__PURE__ */ he("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z", fill: "#FFFFFF" }),
    /* @__PURE__ */ he("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z M1.993,35 C1.445,35 1,34.552 1,34 L1,2 C1,1.448 1.445,1 1.993,1 L16.5,1 L16.5,9 C16.5,10.379 17.621,11.5 18.999,11.5 L27,11.5 L27,34 C27,34.552 26.554,35 26.006,35 L1.993,35 Z M27,10.5 L18.999,10.5 C18.173,10.5 17.5,9.827 17.5,9 L17.5,1 L17.585,1 L27,10.414 L27,10.5 L27,10.5 Z", id: "icon-file-base", fill: "#FFFFFF" }),
    /* @__PURE__ */ he("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z M1.993,35 C1.445,35 1,34.552 1,34 L1,2 C1,1.448 1.445,1 1.993,1 L16.5,1 L16.5,9 C16.5,10.379 17.621,11.5 18.999,11.5 L27,11.5 L27,34 C27,34.552 26.554,35 26.006,35 L1.993,35 Z M27,10.5 L18.999,10.5 C18.173,10.5 17.5,9.827 17.5,9 L17.5,1 L17.585,1 L27,10.414 L27,10.5 L27,10.5 Z", fill: "#384A58" })
  ] }),
  /* @__PURE__ */ he("path", { d: "M14.7142857,14.2824 L14.7142857,13 L13.2857143,13.2548 L13.2857143,23.0912 C12.8642857,22.9106 12.3785714,22.8 11.8571429,22.8 C10.2771429,22.8 9,23.7408 9,24.9 C9,26.0592 10.2771429,27 11.8571429,27 C12.3785714,27 12.8642857,26.8894 13.2857143,26.7088 C14.1371429,26.3448 14.7142857,25.6756 14.7142857,24.9 L14.7142857,17.0824 C17.5714286,17.0824 19,20 19,21.4 C19,15.8 16.1428571,14.2824 14.7142857,14.2824", id: "Fill-776", fill: "#384A58" })
] }) }) });
function Jm() {
  const B = Xn();
  return /* @__PURE__ */ rn("div", { className: "audio-layout-wrapper", children: [
    /* @__PURE__ */ he($m, {}),
    /* @__PURE__ */ he(Ol, {}),
    /* @__PURE__ */ he(hl, {}),
    /* @__PURE__ */ he(vl, { captions: B.captions }),
    /* @__PURE__ */ he(Fl, {}),
    /* @__PURE__ */ he(Ml, {})
  ] });
}
function ep() {
  const B = Xn(), V = lr(
    "youtubeEducationProvider"
  ), ie = dr(() => V ? Ad(B.captions) : B.captions, [B.captions, V]);
  return /* @__PURE__ */ rn(Gr, { children: [
    /* @__PURE__ */ he(Ol, {}),
    /* @__PURE__ */ he(hl, {}),
    /* @__PURE__ */ he(vl, { captions: ie }),
    /* @__PURE__ */ he(Fl, {}),
    /* @__PURE__ */ he(Ml, {}),
    /* @__PURE__ */ he(fd, { comments: B.comments })
  ] });
}
const tp = "_main-layout_5ur6o_175", il = {
  "main-layout": "_main-layout_5ur6o_175",
  mainLayout: tp
};
function _r(B, V) {
  B.dispatchEvent(
    new CustomEvent("keyboardAction", {
      detail: V
    })
  );
}
function Er(B, V) {
  B.preventDefault(), V();
}
const np = (B, V) => ({
  togglePaused: {
    keys: ["Space", "Enter", "k"],
    onKeyDown({ player: ie, remote: ye, event: Ce }) {
      var st;
      (st = document.activeElement) != null && st.hasAttribute("data-media-player") && Er(Ce, () => {
        ye.togglePaused(Ce), _r(ie, "togglePaused");
      });
    }
  },
  seekForward: {
    keys: ["ArrowRight"],
    onKeyDown({ player: ie, remote: ye, event: Ce }) {
      Ce.preventDefault(), Er(Ce, () => {
        ye.seek(ie.currentTime + 5, Ce), _r(ie, "seekForward");
      });
    }
  },
  seekBackward: {
    keys: ["ArrowLeft"],
    onKeyDown({ player: ie, remote: ye, event: Ce }) {
      Er(Ce, () => {
        ye.seek(ie.currentTime - 5, Ce), _r(ie, "seekBackward");
      });
    }
  },
  volumeUp: {
    keys: ["ArrowUp"],
    onKeyDown({ player: ie, remote: ye, event: Ce }) {
      Er(Ce, () => {
        ye.changeVolume(ie.volume + 0.05, Ce), _r(ie, "volumeChange");
      });
    }
  },
  volumeDown: {
    keys: ["ArrowDown"],
    onKeyDown({ player: ie, remote: ye, event: Ce }) {
      Er(Ce, () => {
        ye.changeVolume(ie.volume - 0.05, Ce), _r(ie, "volumeChange");
      });
    }
  },
  toggleFullscreen: B ? [] : ["f"],
  toggleMuted: {
    keys: ["m"],
    onKeyDown({ player: ie, remote: ye, event: Ce }) {
      Er(Ce, () => {
        ye.toggleMuted(Ce), _r(ie, "volumeChange");
      });
    }
  },
  toggleCaptions: {
    keys: ["c"],
    onKeyDown({ player: ie, remote: ye, event: Ce }) {
      Er(Ce, () => {
        ye.toggleCaptions(Ce), _r(ie, "captionsChange");
      });
    }
  },
  nextCaptionLanguage: {
    keys: ["v"],
    onKeyDown({ event: ie, player: ye, remote: Ce }) {
      Er(ie, () => {
        const st = ye.textTracks.selectedIndex, Se = st + 1;
        Ce.changeTextTrackMode(st, "hidden", ie), Ce.changeTextTrackMode(
          Se >= ye.textTracks.length ? 0 : Se,
          "showing",
          ie
        ), _r(ye, "captionsChange");
      });
    }
  },
  previousCaptionLanguage: {
    keys: ["x"],
    onKeyDown({ event: ie, player: ye, remote: Ce }) {
      Er(ie, () => {
        const st = ye.textTracks.selectedIndex, Se = st - 1;
        Ce.changeTextTrackMode(st, "hidden", ie), Ce.changeTextTrackMode(
          Se < 0 ? ye.textTracks.length - 1 : Se,
          "showing",
          ie
        ), _r(ye, "captionsChange");
      });
    }
  },
  decreasePlaybackRate: {
    keys: V ? [] : ["a"],
    onKeyDown({ event: ie, player: ye, remote: Ce }) {
      Er(ie, () => {
        const Se = bi.indexOf(ye.playbackRate) - 1;
        Se >= 0 && (Ce.changePlaybackRate(bi[Se], ie), _r(ye, "playbackRateChange"));
      });
    }
  },
  increasePlaybackRate: {
    keys: V ? [] : ["d"],
    onKeyDown({ event: ie, player: ye, remote: Ce }) {
      Er(ie, () => {
        const Se = bi.indexOf(ye.playbackRate) + 1;
        Se < bi.length && (Ce.changePlaybackRate(bi[Se], ie), _r(ye, "playbackRateChange"));
      });
    }
  },
  resetPlaybackRate: {
    keys: V ? [] : ["s"],
    onKeyDown({ event: ie, player: ye, remote: Ce }) {
      Er(ie, () => {
        Ce.changePlaybackRate(1, ie), _r(ye, "playbackRateChange");
      });
    }
  },
  seekForward10Seconds: {
    keys: ["l"],
    onKeyDown({ event: ie, player: ye, remote: Ce }) {
      Er(ie, () => {
        Ce.seek(ye.currentTime + 10, ie), _r(ye, "seekForward10");
      });
    }
  },
  seekBackward10Seconds: {
    keys: ["j"],
    onKeyDown({ event: ie, player: ye, remote: Ce }) {
      Er(ie, () => {
        Ce.seek(ye.currentTime - 10, ie), _r(ye, "seekBackward10");
      });
    }
  }
}), al = {
  volume: 1,
  muted: !1,
  lang: null,
  captions: !1,
  rate: 1,
  multiplier: 1,
  ontop: !1,
  invert: !1,
  comments: !1
};
class rp {
  constructor(V) {
    _n(this, "playerId", "studio-player");
    _n(this, "mediaId", null);
    _n(this, "data", al);
    _n(this, "time", null);
    _n(this, "overrideTime", null);
    _n(this, "lockSpeed");
    _n(this, "saveTime", () => {
      if (!this.mediaId) return;
      const V = (this.time ?? 0).toString();
      localStorage.setItem(this.mediaId, V);
    });
    _n(this, "saveTimeThrottled", Pl(this.saveTime, 1e3));
    // only used for useStudioPlayer hook's state initialization
    _n(this, "initializeState", (V) => {
      const ie = localStorage.getItem(this.playerId);
      if (_o(V) && V >= 0 && (this.overrideTime = V), ie)
        try {
          this.data = JSON.parse(ie);
        } catch {
        }
      return {
        captionsFontSizeMultiplier: this.data.multiplier || 1,
        captionPositionOnTop: this.data.ontop || !1,
        captionsInvertColors: this.data.invert || !1,
        commentsEnabled: this.data.comments || !1
      };
    });
    _n(this, "saveData", (V, ie) => {
      this.data = {
        ...this.data,
        [V]: ie
      }, this.save();
    });
    this.lockSpeed = V;
  }
  async getVideoQuality() {
    return null;
  }
  async getAudioGain() {
    return null;
  }
  async getLang() {
    return this.data.lang;
  }
  async setLang(V) {
    this.data.lang = V, this.save();
  }
  async getVolume() {
    return this.data.volume;
  }
  async setVolume(V) {
    this.data.volume = V, this.save();
  }
  async getMuted() {
    return this.data.muted;
  }
  async setMuted(V) {
    this.data.muted = V, this.save();
  }
  async getTime() {
    return this.time;
  }
  // TODO: temporarily disabled
  // async setTime(time: number, ended: boolean) {
  //   const shouldClear = time < 0;
  //
  //   this.time = !shouldClear ? time : null;
  //
  //   if (shouldClear || ended) this.saveTime();
  //   else this.saveTimeThrottled();
  // }
  async getCaptions() {
    return this.data.captions;
  }
  async setCaptions(V) {
    this.data.captions = V, this.save();
  }
  async getPlaybackRate() {
    return this.lockSpeed ? 1 : this.data.rate;
  }
  async setPlaybackRate(V) {
    this.data.rate = V, this.save();
  }
  onChange(V, ie, ye = "studio-player") {
    const Ce = ye ? localStorage.getItem(ye) : null, st = ie ? localStorage.getItem(ie) : null;
    this.playerId = ye, this.mediaId = ie;
    let Se = {};
    if (Ce)
      try {
        Se = JSON.parse(Ce);
      } catch {
      }
    this.data = {
      ...al,
      ...Se
    }, _o(this.overrideTime) && this.overrideTime >= 0 ? this.time = this.overrideTime : this.time = st ? +st : null;
  }
  save() {
    if (!this.playerId) return;
    const V = JSON.stringify(this.data);
    localStorage.setItem(this.playerId, V);
  }
}
function ip(B, V, ie, ye, Ce, st) {
  const Se = dr(
    () => new rp(ye),
    [ye]
  ), ge = dr(
    () => np(B, ye),
    [B, ye]
  );
  return {
    contextValue: dr(() => {
      const te = Se.initializeState(st), E = {
        captionsFontSizeMultiplier: yr(te.captionsFontSizeMultiplier),
        captionPositionOnTop: yr(te.captionPositionOnTop),
        captionsInvertColors: yr(te.captionsInvertColors),
        commentsEnabled: yr(V || te.commentsEnabled),
        interactionsDisabled: yr(!1),
        globalKeysDisabled: yr(!1),
        youtubeEducationProvider: yr(null),
        sidebarOpen: yr(Ce),
        playerElement: Mc(),
        lastSearchTerm: ""
      };
      return ie || (E.captionsFontSizeMultiplier.listen((t) => {
        Se.saveData("multiplier", t);
      }), E.captionPositionOnTop.listen((t) => {
        Se.saveData("ontop", t);
      }), E.captionsInvertColors.listen((t) => {
        Se.saveData("invert", t);
      }), E.commentsEnabled.listen((t) => {
        Se.saveData("comments", t);
      })), E;
    }, [ie]),
    shortcuts: ge,
    storage: Se
  };
}
const ha = () => {
};
function gp({
  title: B,
  playerRef: V,
  src: ie,
  captions: ye = [],
  thumbnail: Ce,
  hideFullScreen: st = !1,
  comments: Se = [],
  locale: ge = "en",
  annotations: R = [],
  quizMarkers: te = [],
  interactive: E = !1,
  onAnnotationClick: t = ha,
  onQuizMarkerClick: e = ha,
  onQuizMarkerShow: m = ha,
  onInteractivePinClick: p = ha,
  onCaptionsDelete: l,
  interactiveMenuElements: v = [],
  kebabMenuElements: h = [],
  darkMode: n = !1,
  autoLoadCaptionSrc: f = "",
  forceComments: d = !1,
  disableCaptionSettings: S = !1,
  disableStorage: x = !1,
  startAt: G,
  crossOrigin: P,
  captionOffsetOverride: J,
  disableInteractivePinRanges: M = [],
  customOverlay: W,
  controlsLayout: se = "compact",
  hideQuizMarkers: j = !1,
  ytPfEduEncryptedPayload: re,
  enableSidebar: ce = !1,
  lockSpeed: Re = !1,
  tabs: $ = [],
  openSidebar: Me = !1,
  emptyTranscriptsComponent: Ge = null,
  rollingTranscriptElement: Qe = null,
  transcriptMenuElements: Ae = []
}) {
  const { contextValue: Ze, shortcuts: Xe, storage: at } = ip(
    st,
    d,
    x,
    Re,
    Me,
    G
  ), { i18n: Ie } = On();
  Zr(() => {
    Ie.changeLanguage(ge);
  }, [Ie, ge]);
  const [Be, It] = ar([]), [_t, Ve] = ar("none"), ot = Un(
    (c) => {
      $c(c) ? Ve("audio") : (Ks(c) || zs(c) || Jc(c)) && Ve("video"), (Ks(c) || fo(c)) && Ce && (c.video.poster = Ce);
    },
    [Ce]
  ), Ee = Un(
    (c) => {
      fo(c) ? c.library = uf.MediaPlayer : zs(c) && (typeof re == "string" && re.length > 0 ? (c.encryptedPayload = re, c.education = !0, c.autoLoadCaptions = !0, Ze.youtubeEducationProvider.set(c)) : c.cookies = !0);
    },
    []
  ), Te = ya(Ze.interactionsDisabled), je = ya(Ze.globalKeysDisabled);
  return /* @__PURE__ */ he(
    pf,
    {
      title: B,
      hideFullScreen: st,
      comments: Se,
      captions: [...ye, ...Be],
      thumbnail: Ce,
      annotations: R,
      quizMarkers: te,
      interactive: E,
      onAnnotationClick: t,
      onQuizMarkerClick: e,
      onInteractivePinClick: p,
      interactiveMenuElements: v,
      kebabMenuElements: h,
      darkMode: n,
      forceComments: d,
      disableCaptionSettings: S,
      disableStorage: x,
      captionOffsetOverride: J,
      disableInteractivePinRanges: M,
      onQuizMarkerShow: m,
      onCaptionsDelete: l,
      controlsLayout: se,
      startAt: G,
      hideQuizMarkers: j,
      enableSidebar: ce,
      lockSpeed: Re,
      tabs: $,
      openSidebar: Me,
      emptyTranscriptsComponent: Ge,
      rollingTranscriptElement: Qe,
      transcriptMenuElements: Ae,
      children: /* @__PURE__ */ he(ff, { contextValue: Ze, children: /* @__PURE__ */ rn(
        ef,
        {
          "data-version": "1.4.2",
          "data-darkmode": n,
          crossOrigin: P,
          storage: x ? null : at,
          title: B,
          src: jg(ie),
          keyShortcuts: Xe,
          playsInline: !0,
          keyDisabled: Te || je,
          onTextTracksChange: (c) => {
            const o = c == null ? void 0 : c.findIndex(
              (T) => T.src === f
            );
            o > -1 && (c[o].mode = "showing");
          },
          onLoadedMetadata: (c) => {
            var T;
            const o = Ze.youtubeEducationProvider.get();
            if (o) {
              if (c != null && c.youtubeCaptions && c.youtubeCaptions.length > 0 && !ye.some((b) => b.sourceType === "youtube")) {
                const b = wd(
                  c.youtubeCaptions ?? [],
                  ge
                );
                It(b);
              }
              if (x)
                fa(o.iframe, null);
              else {
                const b = at.data.captions && ((T = at.data.lang) == null ? void 0 : T.endsWith(To)) && at.data.lang || null;
                fa(
                  o.iframe,
                  b
                ), bl(
                  o.iframe,
                  at.data.multiplier
                );
              }
            }
          },
          onProviderChange: Ee,
          onProviderSetup: ot,
          onTextTrackChange: (c) => {
            const o = Ze.youtubeEducationProvider.get();
            o && ((c == null ? void 0 : c.sourceType) === "youtube" ? fa(
              o.iframe,
              c == null ? void 0 : c.language
            ) : fa(o.iframe, null));
          },
          onCanPlay: ({ provider: c }) => {
            fo(c) && (c.ctx.qualities.items.length === 0 ? Ve("audio") : Ve("video"));
          },
          children: [
            /* @__PURE__ */ rn("div", { className: il.mainLayout, ref: Ze.playerElement, children: [
              /* @__PURE__ */ rn(tf, { className: il.mediaProvider, children: [
                _t === "audio" && /* @__PURE__ */ he(Jm, {}),
                _t === "video" && /* @__PURE__ */ he(ep, {})
              ] }),
              /* @__PURE__ */ he(Wf, {}),
              W && /* @__PURE__ */ he(dd, { renderOverlay: W }),
              /* @__PURE__ */ he(
                Xm,
                {
                  darkMode: n,
                  playerRef: V,
                  disableCaptionSettings: S,
                  controlsLayout: se
                }
              ),
              /* @__PURE__ */ he(vf, { annotations: R }),
              !!te.length && /* @__PURE__ */ he(Gg, {})
            ] }),
            /* @__PURE__ */ he(wh, {}),
            Qe && /* @__PURE__ */ he(bh, { element: Qe })
          ]
        }
      ) })
    }
  );
}
export {
  rf as CAPTION_FONT_SIZE_MULTIPLIERS,
  af as COMMENT_DURATION,
  bi as PLAYBACK_RATES,
  gp as StudioPlayer,
  To as YOUTUBE_CAPTION_SUFFIX,
  Kn as useMediaState,
  pp as useMediaStore
};
